webpackJsonp([9],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.API__DailyStatistic = exports.API__Position = exports.API__common = exports.API_ActivityWarn = exports.API_Integral = exports.API_Man = exports.API_Stat = exports.API_control = exports.API_userCom = exports.API_Auth = exports.API_AIPdf = exports.API_AIRilab = exports.API_Order = exports.API_Product = exports.API_Urls = exports.API_Menu = exports.API_User = exports.API_Admin = exports.API_Models = exports.API_Common = exports.API_trial = exports.API__account = exports.API__basic = exports.API__login = exports.imgURLs = exports.API__code = undefined;

var _promise = __webpack_require__(293);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _jsCookie = __webpack_require__(377);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _elementUi = __webpack_require__(422);

var _upload = __webpack_require__(953);

var _upload2 = _interopRequireDefault(_upload);

var _login = __webpack_require__(944);

var _login2 = _interopRequireDefault(_login);

var _product = __webpack_require__(950);

var _product2 = _interopRequireDefault(_product);

var _account = __webpack_require__(936);

var _account2 = _interopRequireDefault(_account);

var _trial = __webpack_require__(952);

var _trial2 = _interopRequireDefault(_trial);

var _common = __webpack_require__(941);

var _common2 = _interopRequireDefault(_common);

var _models = __webpack_require__(947);

var _models2 = _interopRequireDefault(_models);

var _admin = __webpack_require__(938);

var _admin2 = _interopRequireDefault(_admin);

var _user = __webpack_require__(955);

var _user2 = _interopRequireDefault(_user);

var _menu = __webpack_require__(946);

var _menu2 = _interopRequireDefault(_menu);

var _urls = __webpack_require__(954);

var _urls2 = _interopRequireDefault(_urls);

var _order = __webpack_require__(948);

var _order2 = _interopRequireDefault(_order);

var _AIRilab = __webpack_require__(934);

var _AIRilab2 = _interopRequireDefault(_AIRilab);

var _AIPdf = __webpack_require__(933);

var _AIPdf2 = _interopRequireDefault(_AIPdf);

var _authorize = __webpack_require__(939);

var _authorize2 = _interopRequireDefault(_authorize);

var _userCom = __webpack_require__(956);

var _userCom2 = _interopRequireDefault(_userCom);

var _Management = __webpack_require__(935);

var _Management2 = _interopRequireDefault(_Management);

var _statistics = __webpack_require__(951);

var _statistics2 = _interopRequireDefault(_statistics);

var _manage = __webpack_require__(945);

var _manage2 = _interopRequireDefault(_manage);

var _integral = __webpack_require__(943);

var _integral2 = _interopRequireDefault(_integral);

var _activityWarn = __webpack_require__(937);

var _activityWarn2 = _interopRequireDefault(_activityWarn);

var _basic = __webpack_require__(940);

var _basic2 = _interopRequireDefault(_basic);

var _positionApi = __webpack_require__(949);

var _positionApi2 = _interopRequireDefault(_positionApi);

var _dailyStatistics = __webpack_require__(942);

var _dailyStatistics2 = _interopRequireDefault(_dailyStatistics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API__code = {
  SUCCESS: "200",
  ERROR401: "401",
  LOGONEXPIRES: "403",
  ERROR500: "500",
  NOAUTH: "505" };

_axios2.default.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

_axios2.default.interceptors.request.use(function (config) {
  var meta = config.meta || {};
  var token = _jsCookie2.default.get("dnnyptadmin_token");
  var checkCode = _jsCookie2.default.get("dnnyptadmin_checkCode");
  config.params = {
    token: token,
    checkCode: checkCode
  };

  if (config.method === "post" && meta.isSerialize === true) {
    config.data = serialize(config.data);
  }
  return config;
}, function (error) {
  return _promise2.default.reject(error);
});

_axios2.default.interceptors.response.use(function (res) {
  if (res.data.code == API__code.LOGONEXPIRES) {
    location.replace("/loginAdmin");
  }

  return res;
}, function (error) {
  return _promise2.default.reject(error);
});

var imgURLs = "http://106.14.238.88:8080/dnnCloud/";
exports.API__code = API__code;
exports.imgURLs = imgURLs;
exports.API__login = _login2.default;
exports.API__basic = _upload2.default;
exports.API__account = _account2.default;
exports.API_trial = _trial2.default;
exports.API_Common = _common2.default;
exports.API_Models = _models2.default;
exports.API_Admin = _admin2.default;
exports.API_User = _user2.default;
exports.API_Menu = _menu2.default;
exports.API_Urls = _urls2.default;
exports.API_Product = _product2.default;
exports.API_Order = _order2.default;
exports.API_AIRilab = _AIRilab2.default;
exports.API_AIPdf = _AIPdf2.default;
exports.API_Auth = _authorize2.default;
exports.API_userCom = _userCom2.default;
exports.API_control = _Management2.default;
exports.API_Stat = _statistics2.default;
exports.API_Man = _manage2.default;
exports.API_Integral = _integral2.default;
exports.API_ActivityWarn = _activityWarn2.default;
exports.API__common = _basic2.default;
exports.API__Position = _positionApi2.default;
exports.API__DailyStatistic = _dailyStatistics2.default;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var baseURL, imgURL, posUrl, wsURL;
if (false) {
    exports.baseURL = baseURL = '/api';
} else if (false) {
    exports.baseURL = baseURL = 'http://58.213.48.52:7899/dnnCloud/interface';
} else {
    exports.baseURL = baseURL = 'https://dev.eicad.net/dnnCloud/interface';
}

exports.baseURL = baseURL;
exports.wsURL = wsURL;
exports.imgURL = imgURL;

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1541)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(1785),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      maxTbHeight: 100
    };
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.setTableHeight);
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.setTableHeight();
    }, 100);
    window.addEventListener('resize', this.setTableHeight);
  },


  methods: {
    setTableHeight: function setTableHeight(extraHeight) {
      var viewBdH = document.querySelector("#app .base-container").clientHeight;
      var toolH = document.querySelector("#app .base-container .base-container-bd .content-hd").clientHeight;
      var theadH = document.querySelector("#app .base-container .base-container-bd .el-table__header-wrapper").clientHeight;
      this.maxTbHeight = viewBdH - toolH - 49 - 35;
      console.log('this.maxTbHeight==', this.maxTbHeight);
    }
  }

};

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1581)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(869),
  /* template */
  __webpack_require__(1817),
  /* scopeId */
  "data-v-89d3524a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    },

    getCookie: function getCookie() {
        var loginPhone = "";
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; ');
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('=');
                if (arr2[0] == 'zsjty_phone') {
                    loginPhone = arr2[1];
                }
            }
        }
        return loginPhone;
    },

    getNowTime: function getNowTime() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth() + 1;
        var day = now.getDate();
        var hh = now.getHours();
        var mm = now.getMinutes();
        var ss = now.getSeconds();
        var clock = year + "-";

        if (month < 10) clock += "0";
        clock += month + "-";
        if (day < 10) clock += "0";
        clock += day + " ";

        return clock;
    },
    formatDateGu: function formatDateGu(cellval) {
        var dateVal = cellval + "";
        if (cellval != null) {
            var date = new Date(cellval);
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

            var returnDate = date.getFullYear() + "-" + month + "-" + currentDate;

            return returnDate;
        }
    },
    formatDateHMS: function formatDateHMS(cellval) {
        var dateVal = cellval + "";
        if (cellval != null) {
            var date = new Date(cellval);
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

            var returnDate = hours + ":" + minutes + ":" + seconds;

            return returnDate;
        }
    },

    getNear30DaysStartDateAndEndDate: function getNear30DaysStartDateAndEndDate() {
        var now = new Date();
        var thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        return {
            startDate: this.formatDate.format(thirtyDaysAgo, 'yyyy-MM-dd'),
            endDate: this.formatDate.format(now, 'yyyy-MM-dd')
        };
    },

    getParamsByCookie: function getParamsByCookie() {
        var cookieInfo = {};
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; ');
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('=');
                if (arr2[0] == 'dnnyptadmin_token') {
                    cookieInfo.token = arr2[1];
                } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                    cookieInfo.checkCode = arr2[1];
                } else if (arr2[0] == 'dnnyptadmin_id') {
                    cookieInfo.id = arr2[1];
                }
            }
        }
        return cookieInfo;
    }

};

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1553)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(1796),
  /* scopeId */
  "data-v-5683e178",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1590)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(866),
  /* template */
  __webpack_require__(1824),
  /* scopeId */
  "data-v-d6a11c58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUser = exports.editUser = exports.batchRemoveUser = exports.removeUser = exports.getUserListPage = exports.getUserList = exports.requestLogin = undefined;

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = '';

var requestLogin = exports.requestLogin = function requestLogin(params) {
  return _axios2.default.post(base + '/login', params).then(function (res) {
    return res.data;
  });
};

var getUserList = exports.getUserList = function getUserList(params) {
  return _axios2.default.get(base + '/user/list', { params: params });
};

var getUserListPage = exports.getUserListPage = function getUserListPage(params) {
  return _axios2.default.get(base + '/user/listpage', { params: params });
};

var removeUser = exports.removeUser = function removeUser(params) {
  return _axios2.default.get(base + '/user/remove', { params: params });
};

var batchRemoveUser = exports.batchRemoveUser = function batchRemoveUser(params) {
  return _axios2.default.get(base + '/user/batchremove', { params: params });
};

var editUser = exports.editUser = function editUser(params) {
  return _axios2.default.get(base + '/user/edit', { params: params });
};

var addUser = exports.addUser = function addUser(params) {
  return _axios2.default.get(base + '/user/add', { params: params });
};

/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1558)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(1800),
  /* scopeId */
  "data-v-587e6e83",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1543)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(1787),
  /* scopeId */
  "data-v-3dd2240a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1539)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(911),
  /* template */
  __webpack_require__(1783),
  /* scopeId */
  "data-v-3637fe32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1557)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(1799),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1526)
__webpack_require__(1525)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(1774),
  /* scopeId */
  "data-v-1f1c7338",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1588)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(896),
  /* template */
  __webpack_require__(1822),
  /* scopeId */
  "data-v-be38109e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1566)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(907),
  /* template */
  __webpack_require__(1805),
  /* scopeId */
  "data-v-6332eaa6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1508)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(908),
  /* template */
  __webpack_require__(1760),
  /* scopeId */
  "data-v-069e4fc7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1573)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(912),
  /* template */
  __webpack_require__(1811),
  /* scopeId */
  "data-v-77dec7e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1544)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(913),
  /* template */
  __webpack_require__(1788),
  /* scopeId */
  "data-v-3dd9763f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1560)
__webpack_require__(1561)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(914),
  /* template */
  __webpack_require__(1802),
  /* scopeId */
  "data-v-5aa957bf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1592)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(915),
  /* template */
  __webpack_require__(1826),
  /* scopeId */
  "data-v-f0e39a00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1518)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(925),
  /* template */
  __webpack_require__(1768),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slideVerify = __webpack_require__(1709);

var _slideVerify2 = _interopRequireDefault(_slideVerify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = {
    install: function install(Vue) {
        Vue.component(_slideVerify2.default.name, _slideVerify2.default);
    }
};

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(_slideVerify2.default);
}

exports.default = plugins;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(1712);

var _Login2 = _interopRequireDefault(_Login);

var _Forget = __webpack_require__(1711);

var _Forget2 = _interopRequireDefault(_Forget);

var _Register = __webpack_require__(1715);

var _Register2 = _interopRequireDefault(_Register);

var _ = __webpack_require__(1710);

var _2 = _interopRequireDefault(_);

var _Main = __webpack_require__(1714);

var _Main2 = _interopRequireDefault(_Main);

var _LoginAdmin = __webpack_require__(1713);

var _LoginAdmin2 = _interopRequireDefault(_LoginAdmin);

var _Account = __webpack_require__(1719);

var _Account2 = _interopRequireDefault(_Account);

var _Company = __webpack_require__(1720);

var _Company2 = _interopRequireDefault(_Company);

var _UserCom = __webpack_require__(1721);

var _UserCom2 = _interopRequireDefault(_UserCom);

var _userDetail = __webpack_require__(1730);

var _userDetail2 = _interopRequireDefault(_userDetail);

var _moduleDetail = __webpack_require__(1744);

var _moduleDetail2 = _interopRequireDefault(_moduleDetail);

var _moduleUserDetail = __webpack_require__(1745);

var _moduleUserDetail2 = _interopRequireDefault(_moduleUserDetail);

var _Admin = __webpack_require__(1731);

var _Admin2 = _interopRequireDefault(_Admin);

var _Module = __webpack_require__(1747);

var _Module2 = _interopRequireDefault(_Module);

var _Menu = __webpack_require__(1746);

var _Menu2 = _interopRequireDefault(_Menu);

var _Urls = __webpack_require__(1754);

var _Urls2 = _interopRequireDefault(_Urls);

var _ProductList = __webpack_require__(1753);

var _ProductList2 = _interopRequireDefault(_ProductList);

var _Management = __webpack_require__(1718);

var _Management2 = _interopRequireDefault(_Management);

var _OrderList = __webpack_require__(1752);

var _OrderList2 = _interopRequireDefault(_OrderList);

var _OrderAdd = __webpack_require__(1749);

var _OrderAdd2 = _interopRequireDefault(_OrderAdd);

var _OrderEdit = __webpack_require__(1751);

var _OrderEdit2 = _interopRequireDefault(_OrderEdit);

var _OrderDetail = __webpack_require__(1750);

var _OrderDetail2 = _interopRequireDefault(_OrderDetail);

var _AIRilab = __webpack_require__(1717);

var _AIRilab2 = _interopRequireDefault(_AIRilab);

var _AIPdf = __webpack_require__(1716);

var _AIPdf2 = _interopRequireDefault(_AIPdf);

var _exchange = __webpack_require__(1758);

var _exchange2 = _interopRequireDefault(_exchange);

var _query = __webpack_require__(1757);

var _query2 = _interopRequireDefault(_query);

var _userIntegral = __webpack_require__(1759);

var _userIntegral2 = _interopRequireDefault(_userIntegral);

var _AuthorizeList = __webpack_require__(1733);

var _AuthorizeList2 = _interopRequireDefault(_AuthorizeList);

var _ComorizeList = __webpack_require__(1734);

var _ComorizeList2 = _interopRequireDefault(_ComorizeList);

var _ApplyTrial = __webpack_require__(1732);

var _ApplyTrial2 = _interopRequireDefault(_ApplyTrial);

var _targetCustom = __webpack_require__(1729);

var _targetCustom2 = _interopRequireDefault(_targetCustom);

var _probationCustom = __webpack_require__(1726);

var _probationCustom2 = _interopRequireDefault(_probationCustom);

var _officialCustom = __webpack_require__(1725);

var _officialCustom2 = _interopRequireDefault(_officialCustom);

var _probationView = __webpack_require__(1727);

var _probationView2 = _interopRequireDefault(_probationView);

var _officalView = __webpack_require__(1724);

var _officalView2 = _interopRequireDefault(_officalView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
  path: "/loginAdmin",
  component: _LoginAdmin2.default,
  name: "",
  hidden: true
}, {
  path: "/404",
  component: _2.default,
  name: "",
  hidden: true
}, {
  path: "/",
  component: function component() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1872));
  },
  name: "我的产品",


  children: [{
    path: "dailyStatistics",
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1874));
    },
    name: "日活统计",
    meta: {
      requireAuth: true
    }
  }, {
    path: "enterLoadIndex",
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1875));
    },
    name: "企业负载率指标",
    meta: {
      requireAuth: true
    }
  }, {
    path: "activityWarn",
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1873));
    },
    name: "活跃度预警",
    meta: {
      requireAuth: true
    }
  }, {
    path: "moduleIntegral",
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1877));
    },
    name: "模块积分统计",
    meta: {
      requireAuth: true
    }
  }, {
    path: "integralStatistics",
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1876));
    },
    name: "积分统计",
    meta: {
      requireAuth: true
    }
  }, {
    path: "salesWall",
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1878));
    },
    name: "销售挂图",
    meta: {
      requireAuth: true
    }
  }, {
    path: "userStatistics",
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1879));
    },
    name: "用户统计",
    meta: {
      requireAuth: true
    }
  }, {
    path: "management",
    component: _Management2.default,
    name: "控制台",
    meta: {
      requireAuth: true
    }
  }, {
    path: "module",
    component: _Module2.default,
    name: "模块管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "productList",
    component: _ProductList2.default,
    name: "产品管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "authorizeList",
    component: _AuthorizeList2.default,
    name: "个人产品",
    meta: {
      requireAuth: true
    }
  }, {
    path: "comorizeList",
    component: _ComorizeList2.default,
    name: "企业产品",
    meta: {
      requireAuth: true
    }
  }, {
    path: "exchange",
    component: _exchange2.default,
    name: "积分兑换",
    meta: {
      requireAuth: true
    }
  }, {
    path: "credits",
    component: _query2.default,
    name: "积分查询",
    meta: {
      requireAuth: true
    }
  }, {
    path: "userIntegral",
    component: _userIntegral2.default,
    name: "用户积分明细",
    meta: {
      requireAuth: true
    }
  }, {
    path: "orderList",
    component: _OrderList2.default,
    name: "订单管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "AIRilab",
    component: _AIRilab2.default,
    name: "AI效果图管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "PdfTrans",
    component: _AIPdf2.default,
    name: "PDF转换管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "orderAdd",
    component: _OrderAdd2.default,
    name: "新增订单",
    meta: {
      requireAuth: true
    }
  }, {
    path: "orderDetail",
    component: _OrderDetail2.default,
    name: "订单详情",
    meta: {
      requireAuth: true
    }
  }, {
    path: "orderEdit",
    component: _OrderEdit2.default,
    name: "编辑订单",
    meta: {
      requireAuth: true
    }
  }, {
    path: "admin",
    component: _Admin2.default,
    name: "管理员管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "account",
    component: _Account2.default,
    name: "用户管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "targetCustom",
    component: _targetCustom2.default,
    name: "目标客户池",
    meta: {
      requireAuth: true
    }
  }, {
    path: "probationCustom",
    component: _probationCustom2.default,
    name: "试用客户管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "officialCustom",
    component: _officialCustom2.default,
    name: "正式客户管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "company",
    component: _Company2.default,
    name: "企业管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "userCom",
    component: _UserCom2.default,
    name: "客户管理",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "probationView",
    component: _probationView2.default,
    name: "客户管理",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "officalView",
    component: _officalView2.default,
    name: "客户管理",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "userDetail",
    component: _userDetail2.default,
    name: "用户详情",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "moduleDetail",
    component: _moduleDetail2.default,
    name: "模块积分统计",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "moduleUserDetail",
    component: _moduleUserDetail2.default,
    name: "模块积分统计",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "menu",
    component: _Menu2.default,
    name: "软件类型",
    meta: {
      requireAuth: true
    }
  }, {
    path: "urls",
    component: _Urls2.default,
    name: "系统管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "applyTrial",
    component: _ApplyTrial2.default,
    name: "试用申请",
    meta: {
      requireAuth: true
    }
  }]
}, { path: "*", redirect: "/" }];

exports.default = routes;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(50);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(19);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);
var userInfoStr = localStorage.getItem("dnn_dnnCloud_admin_userInfo");
exports.default = new _vuex2.default.Store({
    state: {
        token: '',
        userInfo: userInfoStr ? JSON.parse(userInfoStr) : '',
        opened: true },

    getters: {
        userInfo: function userInfo(state) {
            return state.userInfo || (localStorage.getItem("dnn_dnnCloud_admin_userInfo") ? JSON.parse(localStorage.getItem("dnn_dnnCloud_admin_userInfo")) : '');
        },
        opened: function opened(state) {
            return state.opened;
        }
    },

    mutations: {
        set__token: function set__token(state, token) {
            state.token = token;
            sessionStorage.token = token;
        },
        del__token: function del__token(state) {
            state.token = '';
            sessionStorage.removeItem('token');
        },
        set__userinfo: function set__userinfo(state, userInfo) {
            state.userInfo = userInfo;
            localStorage.setItem("dnn_dnnCloud_admin_userInfo", (0, _stringify2.default)(userInfo));
        },
        toggle__SideBar: function toggle__SideBar(state) {
            console.log('state==', state);
            state.opened = !state.opened;
            console.log('state.opened==', state.opened);
        }
    }
});

/***/ }),
/* 815 */,
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */,
/* 822 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1591)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(864),
  /* template */
  __webpack_require__(1825),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 823 */,
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNormalCoordinates = exports.drawIcon = exports.changeMapSize = exports.toLonLat_ = exports.rewritePos2 = exports.rewritePos = exports.addPoint = exports.addDrawPoint = exports.addProvinceVector = exports.addCricle = exports.Load_Map = exports.sendThis = undefined;

__webpack_require__(1507);

var _Map = __webpack_require__(704);

var _Map2 = _interopRequireDefault(_Map);

var _View = __webpack_require__(273);

var _View2 = _interopRequireDefault(_View);

var _WMTS = __webpack_require__(1681);

var _WMTS2 = _interopRequireDefault(_WMTS);

var _WMTS3 = __webpack_require__(770);

var _WMTS4 = _interopRequireDefault(_WMTS3);

var _Vector = __webpack_require__(191);

var _Vector2 = _interopRequireDefault(_Vector);

var _layer = __webpack_require__(1650);

var _coordinate = __webpack_require__(65);

var _Projection = __webpack_require__(225);

var _Projection2 = _interopRequireDefault(_Projection);

var _XYZ = __webpack_require__(759);

var _XYZ2 = _interopRequireDefault(_XYZ);

var _OSM = __webpack_require__(1677);

var _OSM2 = _interopRequireDefault(_OSM);

var _Feature = __webpack_require__(161);

var _Feature2 = _interopRequireDefault(_Feature);

var _geom = __webpack_require__(717);

var _style = __webpack_require__(762);

var _proj = __webpack_require__(16);

var _proj2 = __webpack_require__(16);

var _extent = __webpack_require__(7);

var _control = __webpack_require__(710);

var _Overlay = __webpack_require__(707);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _interaction = __webpack_require__(724);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _this = null;
var iMap = null;
var radius = 1;
var scale = 0.5;
var vectorSource = void 0,
    vectorLayer = void 0,
    element = void 0,
    popup = void 0,
    provinceSorce = void 0,
    provinLayer = void 0;
var TDU_Key_Arr = ["d64700efc1e349f99ba65c45b170e130", "f3f9c73ee666232171858d458fb320b0"];
var TDU_Key = "";

function sendThis(vm) {
  _this = vm;
}

function Load_Map(param) {
  iMap = null;
  var map = document.getElementById("map");
  map.innerHTML = "";

  var projection = (0, _proj2.get)("EPSG:3857");
  var projectionExtent = projection.getExtent();
  var size = (0, _extent.getWidth)(projectionExtent) / 256;
  var resolutions = new Array(19);
  var matrixIds = new Array(19);
  for (var z = 0; z < 19; ++z) {
    resolutions[z] = size / Math.pow(2, z);
    matrixIds[z] = z;
  }

  TDU_Key = TDU_Key_Arr[Math.floor(Math.random() * TDU_Key_Arr.length)];

  var taindiLayer_vec_w = new _layer.Tile({
    className: "taindiLayer_vec_w",
    opacity: 1,
    source: new _WMTS2.default({
      url: "https://t{0-7}.tianditu.gov.cn/vec_w/wmts?tk=" + TDU_Key,
      layer: "vec",
      matrixSet: "w",
      format: "tiles",
      style: "default",
      projection: projection,
      tileGrid: new _WMTS4.default({
        origin: (0, _extent.getTopLeft)(projectionExtent),
        resolutions: resolutions,
        matrixIds: matrixIds
      }),
      wrapX: true })
  });

  var taindiLayer_cva_w = new _layer.Tile({
    className: "taindiLayer_cva_w",
    opacity: 1,
    source: new _WMTS2.default({
      url: "https://t{0-7}.tianditu.gov.cn/cva_w/wmts?tk=" + TDU_Key,
      layer: "cva",
      matrixSet: "w",
      format: "tiles",
      style: "default",
      projection: projection,
      tileGrid: new _WMTS4.default({
        origin: (0, _extent.getTopLeft)(projectionExtent),
        resolutions: resolutions,
        matrixIds: matrixIds
      }),
      wrapX: true
    })
  });

  var taindiLayer_img_w = new _layer.Tile({
    className: "taindiLayer_img_w",
    opacity: 1,
    source: new _WMTS2.default({
      url: "https://t{0-7}.tianditu.gov.cn/img_w/wmts?tk=" + TDU_Key.value,
      layer: "img",
      matrixSet: "w",
      format: "tiles",
      style: "default",
      projection: projection,
      tileGrid: new _WMTS4.default({
        origin: (0, _extent.getTopLeft)(projectionExtent),
        resolutions: resolutions,
        matrixIds: matrixIds
      }),
      wrapX: true
    })
  });

  var taindiLayer_cia_w = new _layer.Tile({
    className: "taindiLayer_cia_w",
    opacity: 1,
    source: new _WMTS2.default({
      url: "https://t{0-7}.tianditu.gov.cn/cia_w/wmts?tk=" + TDU_Key.value,
      layer: "cia",
      matrixSet: "w",
      format: "tiles",
      style: "default",
      projection: projection,
      tileGrid: new _WMTS4.default({
        origin: (0, _extent.getTopLeft)(projectionExtent),
        resolutions: resolutions,
        matrixIds: matrixIds
      }),
      wrapX: true
    })
  });

  vectorSource = new _Vector2.default();
  vectorLayer = new _layer.Vector({
    source: vectorSource
  });
  provinceSorce = new _Vector2.default();
  provinLayer = new _layer.Vector({
    source: provinceSorce
  });

  var layers = [];
  if (param.photography) {
    layers = [taindiLayer_img_w, taindiLayer_cia_w, vectorLayer, provinLayer];
  } else {
    layers = [taindiLayer_vec_w, taindiLayer_cva_w, vectorLayer, provinLayer];
  }

  var mappParma = {
    zoom: 4.666666666666667,
    mapCenter: [109.5, 34.52]
  };

  if (param.mappParma) {
    mappParma = param.mappParma;
  }

  iMap = new _Map2.default({
    layers: layers,
    target: "map",
    view: new _View2.default({
      center: mappParma.mapCenter[0] > 200 ? mappParma.mapCenter : (0, _proj.fromLonLat)(mappParma.mapCenter),
      maxZoom: 22,
      minZoom: 3,
      zoom: mappParma.zoom
    })
  });

  if (param.popup) {
    element = document.getElementById("popup");
    element.innerHTML = "南京\r52个";
    popup = new _Overlay2.default({
      element: element,
      offset: [0, -12],
      positioning: "bottom-center"
    });
    iMap.addOverlay(popup);

    iMap.on("pointermove", MapPointerMove);
    iMap.on("moveend", mapMoved);
    iMap.on("singleclick", MapPointerClickOpen);
  }
}

function addCricle(dataJson) {
  vectorSource.clear();
  dataJson.forEach(function (el) {
    var x = parseFloat(el.longitudeAndLatitude.split(",")[0]);
    var y = parseFloat(el.longitudeAndLatitude.split(",")[1]);
    var coordinate = [x, y];

    if (isNormalCoordinates(x, y)) {
      coordinate = [(0, _proj.fromLonLat)([x, y])[0] - 724, (0, _proj.fromLonLat)([x, y])[1] - 724];
    }

    var feature = new _Feature2.default({
      geometry: new _geom.Point([coordinate[0] + (Math.floor(Math.random() * (1000 - 1) + 1) - 500) * 0.1, coordinate[1] + (Math.floor(Math.random() * (1000 - 1) + 1) - 500) * 0.1])
    });
    feature.set("radius", 10 / el.grade);
    feature.set("value", el.cou);
    feature.set("name", el.companyName);
    feature.set("_type", "vector");
    feature.set("grade", el.grade);
    feature.set("compayId", el.id);
    var custom;
    if (el.grade == 1) {
      custom = "../../../../static/img/customer1.svg";
    } else if (el.grade == 5) {
      custom = "../../../../static/img/customer3.svg";
    } else {
      custom = "../../../../static/img/customer2.svg";
    }
    feature.setStyle([new _style.Style({
      image: new _style.Icon({
        scale: 0.5,
        src: custom
      })
    })]);
    vectorSource.addFeature(feature);
  });
}

function animation() {
  if (radius >= 40) {
    radius = 0;
  }
  var opacity = (40 - radius) / 40;
  var pointStyle = new _style.Style({
    image: new _style.Circle({
      fill: new _style.Fill({
        color: "rgba(54,110,255," + opacity + ")"
      }),
      radius: radius
    })
  });
  var features = vectorSource.getFeatures();
  features.forEach(function (element) {
    if (element.get("grade") == 1) {
      element.setStyle([pointStyle, new _style.Style({
        image: new _style.Circle({
          fill: new _style.Fill({
            color: "rgba(54,110,255,0.5)"
          }),
          radius: 20
        })
      }), new _style.Style({
        image: new _style.Circle({
          fill: new _style.Fill({
            color: "#366EFF"
          }),
          stroke: new _style.Stroke({
            color: "#FFF",
            width: 2
          }),
          radius: 10
        })
      })]);
    }
  });

  radius = radius + 0.3;
  iMap.render();
}

function MapPointerMove(evt) {
  var pixel = iMap.getEventPixel(evt.originalEvent);
  var hit = iMap.hasFeatureAtPixel(pixel);
  if (hit) {
    var feature = iMap.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
      return feature;
    });
    if (feature) {
      if (feature.get("_type") == "vector") {
        element.innerHTML = feature.get("name") + "\n" + feature.get("value") + "条";
        iMap.getTargetElement().style.cursor = "pointer";
        popup.setPosition(feature.getGeometry().getCoordinates());
      } else {
        iMap.getTargetElement().style.cursor = "";
        popup.setPosition(undefined);
      }
    } else {
      iMap.getTargetElement().style.cursor = "";
    }
  } else {
    iMap.getTargetElement().style.cursor = "";
    popup.setPosition(undefined);
  }
}

function mapMoved(e) {
  var zoom = iMap.getView().getZoom();
  var features = vectorSource.getFeatures();
  if (zoom > 11) {
    if (scale != 11) {
      features.forEach(function (element) {
        var custom;
        if (element.get("grade") == 1) {
          custom = "../../../../static/img/customer1.svg";
        } else if (element.get("grade") == 5) {
          custom = "../../../../static/img/customer3.svg";
        } else {
          custom = "../../../../static/img/customer2.svg";
        }
        element.setStyle(new _style.Style({
          image: new _style.Icon({
            scale: 1,
            src: custom
          }),
          text: new _style.Text({
            font: "bold 12px sans-serif",
            text: element.get("name"),
            textAlign: "center",
            offsetY: 25,
            stroke: new _style.Stroke({
              color: "white"
            }),
            fill: new _style.Fill({
              color: "#0079e9"
            })
          })
        }));
      });
      scale = 11;
    }
  } else if (zoom < 4) {
    if (scale != 4) {
      features.forEach(function (element) {
        var custom;
        if (element.get("grade") == 1) {
          custom = "../../../../static/img/customer1.svg";
        } else if (element.get("grade") == 5) {
          custom = "../../../../static/img/customer3.svg";
        } else {
          custom = "../../../../static/img/customer2.svg";
        }
        element.setStyle(new _style.Style({
          image: new _style.Icon({
            scale: 0.2,
            src: custom
          })
        }));
      });
      scale = 4;
    }
  } else {
    if (scale != 7) {
      features.forEach(function (element) {
        var custom;
        if (element.get("grade") == 1) {
          custom = "../../../../static/img/customer1.svg";
        } else if (element.get("grade") == 5) {
          custom = "../../../../static/img/customer3.svg";
        } else {
          custom = "../../../../static/img/customer2.svg";
        }
        element.setStyle(new _style.Style({
          image: new _style.Icon({
            scale: 0.5,
            src: custom
          })
        }));
      });
      scale = 7;
    }
  }
}

function MapPointerClickOpen(evt) {
  var pixel = iMap.getEventPixel(evt.originalEvent);
  var hit = iMap.hasFeatureAtPixel(pixel);

  if (hit) {
    var feature = iMap.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
      return feature;
    });
    if (feature) {
      _this.dataList = true;
      _this.queryList(feature.get("compayId"));
    }
  } else {
    _this.pageNumber = 1;
    _this.getTubiao(_this.param);
  }
}

function addProvinceVector() {
  var data = _this.provinceData.features;
  for (var i = 0; i < data.length; i++) {
    var _loop = function _loop(j) {
      var datajson = [];
      data[i]["geometry"]["coordinates"][j][0].forEach(function (item) {
        datajson.push((0, _proj.fromLonLat)(item));
      });
      feature = new _Feature2.default({
        geometry: new _geom.Polygon([datajson])
      });

      feature.setStyle(new _style.Style({
        stroke: new _style.Stroke({
          color: "#0066FF",
          width: 1
        }),
        fill: new _style.Fill({
          color: "rgba(87, 124, 204, 0.2)"
        }),
        text: new _style.Text({
          font: "14px bold sans-serif",
          text: data[i]["properties"]["name"],
          fill: new _style.Fill({
            color: "rgba(255,255,255,0.8)"
          }),
          stroke: new _style.Stroke({
            color: "#06798a",
            width: 0.5
          }),
          overflow: false
        })
      }));
      feature.set("_type", "province");
      provinceSorce.addFeature(feature);
    };

    for (var j = 0; j < data[i]["geometry"]["coordinates"].length; j++) {
      var feature;

      _loop(j);
    }
  }
}

function addDrawPoint() {
  var _Draw = new _interaction.Draw({
    source: vectorSource,
    stopClick: true,
    type: "Point"
  });
  iMap.addInteraction(_Draw);
  _Draw.on("drawend", function (evt) {
    var coordinate = evt.feature.getGeometry().getCoordinates();

    vectorSource.clear();
    var rome = new _Feature2.default({
      geometry: new _geom.Point(coordinate)
    });
    rome.setStyle(new _style.Style({
      image: new _style.Circle({
        fill: new _style.Fill({
          color: "rgba(0,255,216,1)"
        }),
        radius: 10
      })
    }));
    vectorSource.addFeature(rome);
  });
}

function addPoint() {
  vectorSource.clear();
  if (_this.position != "") {
    if (_this.position[0] < 200) {
      _this.position = (0, _proj.fromLonLat)(_this.position);
    }
    var rome = new _Feature2.default({
      geometry: new _geom.Point(_this.position)
    });

    rome.setStyle(new _style.Style({
      image: new _style.Circle({
        fill: new _style.Fill({
          color: "rgba(0,255,216,1)"
        }),
        radius: 10
      })
    }));
    vectorSource.addFeature(rome);
  }
}

function rewritePos(position) {
  _this.position = [(0, _proj.fromLonLat)(position)[0] - 724, (0, _proj.fromLonLat)(position)[1] - 724];
  iMap.getView().animate({
    center: _this.position,
    zoom: 15,
    duration: 500
  });
  addPoint();
}

function rewritePos2(position) {
  var x = position[0];
  var y = position[1];
  if (isNormalCoordinates(x, y)) {
    _this.position = [(0, _proj.fromLonLat)(position)[0], (0, _proj.fromLonLat)(position)[1]];
  } else {
    _this.position = [x, y];
  }
  iMap.getView().animate({
    center: _this.position,
    zoom: 15,
    duration: 500
  });
  addPoint();
}

function lonLat2Mercator(lonlat) {
  var earthRad = 6378137.0;
  var x = lonlat[0] * Math.PI / 180 * earthRad;
  var a = lonlat[1] * Math.PI / 180;
  var y = earthRad / 2 * Math.log((1.0 + Math.sin(a)) / (1.0 - Math.sin(a)));
  return [x, y];
}

function toLonLat_(coordinate) {
  return (0, _proj.toLonLat)(coordinate);
}

function isNormalCoordinates(x, y) {
  return x >= -180 && x <= 180 && y >= -90 && y <= 90;
}

function changeMapSize() {
  iMap.updateSize();
}

function drawIcon(coordinate, imageSrc, text, textStyle, offsetY, fillColor) {
  var pos;
  if (coordinate[0] < 200) {
    pos = (0, _proj.fromLonLat)(coordinate);
  } else {
    pos = coordinate;
  }
  var feature = new _Feature2.default({
    geometry: new _geom.Point(pos)
  });
  feature.setStyle(new _style.Style({
    image: new _style.Icon({
      color: "#BADA55",
      scale: 1,
      src: imageSrc
    }),
    text: new _style.Text({
      text: text,
      font: textStyle,
      textAlign: "center",
      offsetY: offsetY,
      fill: new _style.Fill({
        color: fillColor
      })
    })
  }));
  provinceSorce.addFeature(feature);

  var room = new _Feature2.default({
    geometry: new _geom.Point(pos)
  });
  vectorSource.addFeature(room);
}

exports.sendThis = sendThis;
exports.Load_Map = Load_Map;
exports.addCricle = addCricle;
exports.addProvinceVector = addProvinceVector;
exports.addDrawPoint = addDrawPoint;
exports.addPoint = addPoint;
exports.rewritePos = rewritePos;
exports.rewritePos2 = rewritePos2;
exports.toLonLat_ = toLonLat_;
exports.changeMapSize = changeMapSize;
exports.drawIcon = drawIcon;
exports.isNormalCoordinates = isNormalCoordinates;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1509)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(1761),
  /* scopeId */
  "data-v-0a4ff2d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	provide: function provide() {
		return {
			reload: this.reload
		};
	},
	data: function data() {
		return {
			isRouterAlive: true
		};
	},

	methods: {
		reload: function reload() {
			this.isRouterAlive = false;
			this.$nextTick(function () {
				this.isRouterAlive = true;
			});
		}
	},

	components: {}
};

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "baseContainer",
  props: {
    isPageHd: {
      type: Boolean,
      default: false
    },
    isMainHd: {
      type: Boolean,
      default: true
    },

    isHasPageFt: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      loadingInstance: null
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo']), {
    getCurMenu: function getCurMenu() {
      return this.$route.name;
    }
  }),

  watch: {
    '$route': function $route() {}

  }

};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    backRoute: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    getName: function getName() {
      return this.name == '' ? this.$route.name : this.name;
    }
  },
  methods: {
    backRoute_: function backRoute_() {
      if (this.backRoute == '') {
        this.$router.go(-1);
      } else {
        if (this.param != {}) {
          this.$router.push({
            path: this.backRoute,
            query: this.param
          });
        } else {
          this.$router.push(this.backRoute);
        }
      }
    }
  }
};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = __webpack_require__(963);

var _set2 = _interopRequireDefault(_set);

var _regenerator = __webpack_require__(107);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(106);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _index = __webpack_require__(6);

var _iMap = __webpack_require__(824);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _provinces = __webpack_require__(1867);

var _provinces2 = _interopRequireDefault(_provinces);

var _cities = __webpack_require__(1866);

var _cities2 = _interopRequireDefault(_cities);

var _areas = __webpack_require__(1865);

var _areas2 = _interopRequireDefault(_areas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    selected: {
      type: Object,
      default: function _default() {
        return {
          province: "320000",
          city: "320100",
          area: "320115",
          town: "320115010"
        };
      }
    },
    address: {
      type: String,
      default: ""
    },
    lonLat: {
      type: String,
      default: ""
    },
    position_: {
      type: Array,
      default: function _default() {
        return [118.846567, 31.958527];
      }
    },
    title: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      position: [118.846567, 31.958527],
      innerVisible: false,
      selected_: this.selected,
      address_: this.address,
      posValue: "",
      loading: false,
      options: [],
      shangxian: 1,
      loadingx: false,
      loadings: true,
      token: "",
      checkCode: "",
      id: "",
      ischange: true,
      confirmLoading: false,

      TDU_Key_Arr: ["d64700efc1e349f99ba65c45b170e130", "f3f9c73ee666232171858d458fb320b0"],
      TDU_Key: "",
      selectedItem: null
    };
  },
  mounted: function mounted() {
    this.TDU_Key = this.TDU_Key_Arr[Math.floor(Math.random() * this.TDU_Key_Arr.length)];
    if (document.cookie.length > 0) {
      var arr = document.cookie.split("; ");
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("=");
        if (arr2[0] == "dnnyptadmin_token") {
          this.token = arr2[1];
        } else if (arr2[0] == "dnnyptadmin_checkCode") {
          this.checkCode = arr2[1];
        } else if (arr2[0] == "dnnyptadmin_id") {
          this.id = arr2[1];
        }
      }
    }
  },

  methods: {
    openMap: function openMap() {
      this.address_ = this.address_.split(" ").join("");
      this.innerVisible = true;
    },
    initMap: function initMap() {
      (0, _iMap.sendThis)(this);
      var param = {
        photography: false,
        popup: false,
        mappParma: {
          zoom: 12,
          mapCenter: this.position == "" ? [118.846567, 31.958527] : this.position
        }
      };
      (0, _iMap.Load_Map)(param);
      (0, _iMap.addDrawPoint)();
      (0, _iMap.addPoint)();
      this.posValue = "";
      if (this.lonLat != "") {
        var aa = this.lonLat.split(",");
        var bb = [parseFloat(aa[0]), parseFloat(aa[1])];
        if ((0, _iMap.isNormalCoordinates)(bb[0], bb[1])) {
          (0, _iMap.rewritePos)(bb);
        } else {
          (0, _iMap.rewritePos2)(bb);
        }
      } else {
        this.initRemote(this.address_);
      }
    },
    initRemote: function initRemote(query) {
      if (query != "") {
        this.getSearchAddress(query, true);
      }
    },
    positions: function positions(coordinate) {
      this.confirmLoading = true;
      if (coordinate) {
        this.position = coordinate;
      } else {
        this.position = this.posValue.split("_")[1];
      }

      if (this.address_ == "") {
        this.address_ = this.selectedItem.name;
      }
      var param = {
        position: this.position,
        address: this.address_,
        selected: {
          province: {
            key: "",
            value: ""
          },
          city: {
            key: "",
            value: ""
          },
          area: {
            key: "",
            value: ""
          }
        }
      };

      if (this.selectedItem) {
        var _selectedItem = this.selectedItem,
            province = _selectedItem.province,
            city = _selectedItem.city,
            county = _selectedItem.county,
            name = _selectedItem.name;

        var itemA = _provinces2.default.filter(function (item) {
          return item.name == province;
        });
        var provinceKey = itemA && itemA.length > 0 ? itemA[0].code : "";

        var itemB = _cities2.default.filter(function (item) {
          return item.name == city;
        });
        var cityKey = itemB && itemB.length > 0 ? itemB[0].code : "";

        var itemC = _areas2.default.filter(function (item) {
          return item.name == county;
        });
        var areaKey = itemC && itemC.length > 0 ? itemC[0].code : "";
        param.selected = {
          province: {
            key: provinceKey,
            value: province
          },
          city: {
            key: cityKey,
            value: city
          },
          area: {
            key: areaKey,
            value: county
          }
        };
      } else if (this.selected_) {
        var _provinceKey = this.selected_.province;
        var _cityKey = this.selected_.city;
        var _areaKey = this.selected_.area;

        var _itemA = _provinces2.default.filter(function (item) {
          return item.code == _provinceKey;
        });
        var _province = _itemA && _itemA.length > 0 ? _itemA[0].name : "";

        var _itemB = _cities2.default.filter(function (item) {
          return item.code == _cityKey;
        });
        var _city = _itemB && _itemB.length > 0 ? _itemB[0].name : "";

        var _itemC = _areas2.default.filter(function (item) {
          return item.code == _areaKey;
        });
        var _county = _itemC && _itemC.length > 0 ? _itemC[0].name : "";
        param.selected = {
          province: {
            key: _provinceKey,
            value: _province
          },
          city: {
            key: _cityKey,
            value: _city
          },
          area: {
            key: _areaKey,
            value: _county
          }
        };
      }
      console.log("param", param);

      this.$emit("backPram", param);
      this.innerVisible = false;
      this.confirmLoading = false;
    },
    remoteMethod: function remoteMethod(query) {
      if (query !== "") {
        this.getSearchAddress(query);
      }
    },
    posChange: function posChange() {
      var index = this.posValue.split("_")[0];
      var temp = this.posValue.split("_")[1];
      this.selectedItem = this.options[index];
      this.position = [Number(temp.split(",")[0]), Number(temp.split(",")[1])];
      (0, _iMap.rewritePos2)(this.position);

      console.log("posChange-position", this.position);
    },
    changItem: function changItem(param) {
      this.address_ = param;
    },
    changePro: function changePro(param) {
      this.shangxian = 2;
      this.selected_ = param;
    },
    changePos: function changePos(pos) {
      var self = this;
      this.ischange = false;
      setTimeout(function () {
        self.position = pos;
      });
    },
    changeAddres: function changeAddres() {
      this.$emit("update:address", this.address_);
      this.ischange = true;
    },
    getSearchAddress: function getSearchAddress(keyword, isInitSearch) {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self, postStr, params, url, res, resData, allResults, poiResults, errorMsg;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                postStr = {
                  keyWord: keyword,
                  level: 2,
                  mapBound: "73.4,3.8,135.0,53.5",
                  queryType: 2,
                  queryRadius: 300000,
                  start: 0,
                  count: 15,
                  show: 2 };
                params = new URLSearchParams();

                params.append("postStr", (0, _stringify2.default)(postStr));
                params.append("type", "query");
                params.append("tk", _this.TDU_Key);
                url = "https://api.tianditu.gov.cn/v2/search?" + params.toString();


                _this.loading = true;
                _context.next = 10;
                return _axios2.default.get(url);

              case 10:
                res = _context.sent;


                if (res.status === 200 && res.data.status.infocode === 1000) {
                  resData = res.data;

                  console.log("resData", resData);

                  allResults = [];

                  if (resData.prompt && resData.prompt.length > 0) {
                    resData.prompt.forEach(function (prompt) {
                      if (prompt.admins && prompt.admins.length > 0) {
                        prompt.admins.forEach(function (admin) {
                          var fullName = admin.adminName.includes(keyword) ? admin.adminName : "" + keyword + admin.adminName;

                          _this.getAdminLonLat(fullName).then(function (res) {
                            if (res) {
                              allResults.push({
                                name: fullName,
                                address: fullName + "\uFF08\u884C\u653F\u533A\u5212\uFF09",
                                lonlat: res,
                                type: "admin"
                              });

                              renderList(allResults.concat(data.pois || []));
                            }
                          });
                        });
                      }
                    });
                  }

                  if (resData.pois && resData.pois.length > 0) {
                    poiResults = resData.pois.map(function (poi) {
                      return {
                        name: poi.name,
                        address: poi.address,
                        lonlat: poi.lonlat,
                        type: "poi",
                        province: poi.province,
                        provinceCode: poi.provinceCode,
                        city: poi.city,
                        cityCode: poi.cityCode,
                        county: poi.county,
                        countyCode: poi.countyCode
                      };
                    });

                    allResults = allResults.concat(poiResults);
                    _this.renderList(allResults);
                  }
                  _this.loading = false;


                  if (isInitSearch) {
                    setTimeout(function () {
                      self.posValue = "0_" + allResults[0].lonlat.toString();
                      self.posChange();
                    }, 1000);
                  }
                } else {
                  errorMsg = res.status === 200 ? res.data.status.cndesc : res.statusText;

                  _this.$message({
                    message: "\u8BF7\u6C42\u5931\u8D25\uFF1A " + (errorMsg || "未知错误"),
                    type: "error"
                  });
                  _this.loading = false;
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getAdminLonLat: function getAdminLonLat(adminName) {
      var ds = (0, _stringify2.default)({ keyWord: adminName });
      var geocodeUrl = "https://api.tianditu.gov.cn/geocoder?ds=" + encodeURIComponent(ds) + "&tk=" + this.TDU_Key;

      return _axios2.default.get(geocodeUrl).then(function (res) {
        var data = res.data;
        if (data && data.location && data.location.length > 0) {
          var _data$location$ = data.location[0],
              lng = _data$location$.lng,
              lat = _data$location$.lat;

          return lng + "," + lat;
        }
        return null;
      }).catch(function () {
        return null;
      });
    },
    renderList: function renderList(results) {
      var uniqueResults = this.deduplicateResults(results);
      this.options = uniqueResults;
    },
    deduplicateResults: function deduplicateResults(results) {
      var nameSet = new _set2.default();
      var uniqueResults = [];
      results.forEach(function (item) {
        if (!nameSet.has(item.name)) {
          nameSet.add(item.name);
          uniqueResults.push(item);
        }
      });
      return uniqueResults;
    }
  }
};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'pdfView',
  props: {
    pictureList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    isShowFt: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {};
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  }), {
    images: function images() {
      var imgs = [];
      imgs = this.pictureList.map(function (item) {
        return item.perfix + item.path;
      });
      return imgs;
    }
  }),

  created: function created() {},


  methods: {
    inited: function inited(viewer, index) {
      this['$viewer' + index] = viewer;
    },
    show: function show(e, index) {
      this['$viewer' + index].show();
    }
  }
};

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Organization",
  inheritAttrs: false,
  props: {
    apiPath: {
      type: String
    },

    params: {
      type: Object,
      default: function _default() {}
    },

    keys: {
      type: Object,
      default: { label: 'label', value: 'value' }
    },

    defaultVal: {
      type: String,
      default: undefined
    },

    defaultValDisabled: {
      type: Boolean,
      default: false
    },

    selectFirst: {
      type: Boolean,
      default: false
    },

    method: {
      type: String,
      default: 'post'
    }

  },
  data: function data() {
    return {
      myDefaultVal: this.defaultVal ? this.defaultVal : '',

      list: [] };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  created: function created() {},
  mounted: function mounted() {
    this.getList();
  },


  methods: {
    handleChange: function handleChange(value) {
      var _this = this;

      if (typeof value == 'string') {
        value = [value];
      }
      var datas = [];
      if (value) {
        datas = this.list.filter(function (item) {
          return value.indexOf(item[_this.keys.value]) > -1;
        });
      }

      this.$emit('change', value || '', datas);
    },
    getList: function getList() {
      var _this2 = this;

      var params = {
        token: this.userInfo.phone,
        checkCode: this.userInfo.checkCode
      };

      params = (0, _extends3.default)({}, params, this.params);
      _index.API__common.getSelectCommonList(this.apiPath, params, this.method).then(function (res) {
        if (res.data.code == 200) {
          _this2.list = res.data.data.records ? res.data.data.records : res.data.data;
          if (_this2.selectFirst && !_this2.defaultVal) {
            _this2.myDefaultVal = _this2.list[0][_this2.keys.value];
            _this2.handleChange(_this2.myDefaultVal);
          }
        }
      }).catch(function (e) {});
    }
  },

  watch: {
    'defaultVal': function defaultVal() {
      this.myDefaultVal = this.defaultVal ? this.defaultVal : '';
    }

  }

};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var PI = Math.PI;

function sum(x, y) {
    return x + y;
}

function square(x) {
    return x * x;
}
exports.default = {
    name: 'SlideVerify',
    props: {
        l: {
            type: Number,
            default: 42
        },

        r: {
            type: Number,
            default: 10
        },

        w: {
            type: Number,
            default: 350
        },

        h: {
            type: Number,
            default: 155
        },
        sliderText: {
            type: String,
            default: 'Slide filled right'
        }
    },
    data: function data() {
        return {
            containerActive: false,
            containerSuccess: false,
            containerFail: false,
            canvasCtx: null,
            blockCtx: null,
            block: null,
            block_x: undefined,
            block_y: undefined,
            L: this.l + this.r * 2 + 3,
            img: undefined,
            originX: undefined,
            originY: undefined,
            isMouseDown: false,
            trail: [],
            sliderLeft: 0,
            sliderMaskWidth: 0 };
    },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        init: function init() {
            this.initDom();
            this.initImg();
            this.bindEvents();
        },
        initDom: function initDom() {
            this.block = this.$refs.block;
            this.canvasCtx = this.$refs.canvas.getContext('2d');
            this.blockCtx = this.block.getContext('2d');
        },
        initImg: function initImg() {
            var _this = this;

            var img = this.createImg(function () {
                _this.drawBlock();
                _this.canvasCtx.drawImage(img, 0, 0, _this.w, _this.h);
                _this.blockCtx.drawImage(img, 0, 0, _this.w, _this.h);
                var x = _this.block_x,
                    y = _this.block_y,
                    r = _this.r,
                    L = _this.L;

                var _y = y - r * 2 - 1;
                var ImageData = _this.blockCtx.getImageData(x, _y, L, L);
                _this.block.width = L;
                _this.blockCtx.putImageData(ImageData, 0, _y);
            });
            this.img = img;
        },
        drawBlock: function drawBlock() {
            this.block_x = this.getRandomNumberByRange(this.L + 10, this.w - (this.L + 10));
            this.block_y = this.getRandomNumberByRange(10 + this.r * 2, this.h - (this.L + 10));
            this.draw(this.canvasCtx, this.block_x, this.block_y, 'fill');
            this.draw(this.blockCtx, this.block_x, this.block_y, 'clip');
        },
        draw: function draw(ctx, x, y, operation) {
            var l = this.l,
                r = this.r;

            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.arc(x + l / 2, y - r + 2, r, 0.72 * PI, 2.26 * PI);
            ctx.lineTo(x + l, y);
            ctx.arc(x + l + r - 2, y + l / 2, r, 1.21 * PI, 2.78 * PI);
            ctx.lineTo(x + l, y + l);
            ctx.lineTo(x, y + l);
            ctx.arc(x + r - 2, y + l / 2, r + 0.4, 2.76 * PI, 1.24 * PI, true);
            ctx.lineTo(x, y);
            ctx.lineWidth = 2;
            ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
            ctx.strokeStyle = 'rgba(255, 255, 255, 0.7)';
            ctx.stroke();
            ctx[operation]();
            ctx.globalCompositeOperation = 'overlay';
        },
        createImg: function createImg(onload) {
            var _this2 = this;

            var img = document.createElement('img');
            img.crossOrigin = "Anonymous";
            img.onload = onload;
            img.onerror = function () {
                img.src = _this2.getRandomImg();
            };
            img.src = this.getRandomImg();
            return img;
        },
        getRandomImg: function getRandomImg() {
            return 'https://picsum.photos/300/150/?image=' + this.getRandomNumberByRange(0, 1084);
        },
        getRandomNumberByRange: function getRandomNumberByRange(start, end) {
            return Math.round(Math.random() * (end - start) + start);
        },
        refresh: function refresh() {
            this.reset();
            this.$emit('refresh');
        },
        sliderDown: function sliderDown(event) {
            this.originX = event.clientX;
            this.originY = event.clientY;
            this.isMouseDown = true;
        },
        touchStartEvent: function touchStartEvent(e) {
            this.originX = e.changedTouches[0].pageX;
            this.originY = e.changedTouches[0].pageY;
            this.isMouseDown = true;
        },
        bindEvents: function bindEvents() {
            var _this3 = this;

            document.addEventListener('mousemove', function (e) {
                if (!_this3.isMouseDown) return false;
                var moveX = e.clientX - _this3.originX;
                var moveY = e.clientY - _this3.originY;
                if (moveX < 0 || moveX + 38 >= _this3.w) return false;
                _this3.sliderLeft = moveX + 'px';
                var blockLeft = (_this3.w - 40 - 20) / (_this3.w - 40) * moveX;
                _this3.block.style.left = blockLeft + 'px';

                _this3.containerActive = true;
                _this3.sliderMaskWidth = moveX + 'px';
                _this3.trail.push(moveY);
            });
            document.addEventListener('mouseup', function (e) {
                if (!_this3.isMouseDown) return false;
                _this3.isMouseDown = false;
                if (e.clientX === _this3.originX) return false;
                _this3.containerActive = false;
                var _verify = _this3.verify(),
                    spliced = _verify.spliced,
                    TuringTest = _verify.TuringTest;

                if (spliced) {
                    if (TuringTest) {
                        _this3.containerSuccess = true;
                        _this3.$emit('success');
                    } else {
                        _this3.containerFail = true;
                        _this3.sliderText = 'try again';
                        _this3.reset();
                    }
                } else {
                    _this3.containerFail = true;
                    _this3.$emit('fail');
                    setTimeout(function () {
                        _this3.reset();
                    }, 1000);
                }
            });
        },
        touchMoveEvent: function touchMoveEvent(e) {
            if (!this.isMouseDown) return false;
            var moveX = e.changedTouches[0].pageX - this.originX;
            var moveY = e.changedTouches[0].pageY - this.originY;
            if (moveX < 0 || moveX + 38 >= this.w) return false;
            this.sliderLeft = moveX + 'px';
            var blockLeft = (this.w - 40 - 20) / (this.w - 40) * moveX;
            this.block.style.left = blockLeft + 'px';

            this.containerActive = true;
            this.sliderMaskWidth = moveX + 'px';
            this.trail.push(moveY);
        },
        touchEndEvent: function touchEndEvent(e) {
            var _this4 = this;

            if (!this.isMouseDown) return false;
            this.isMouseDown = false;
            if (e.changedTouches[0].pageX === this.originX) return false;
            this.containerActive = false;

            var _verify2 = this.verify(),
                spliced = _verify2.spliced,
                TuringTest = _verify2.TuringTest;

            if (spliced) {
                if (TuringTest) {
                    this.containerSuccess = true;
                    this.$emit('success');
                } else {
                    this.containerFail = true;
                    this.sliderText = 'try again';
                    this.reset();
                }
            } else {
                this.containerFail = true;
                this.$emit('fail');
                setTimeout(function () {
                    _this4.reset();
                }, 1000);
            }
        },
        verify: function verify() {
            var arr = this.trail;
            var average = arr.reduce(sum) / arr.length;
            var deviations = arr.map(function (x) {
                return x - average;
            });
            var stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length);
            var left = parseInt(this.block.style.left);
            return {
                spliced: Math.abs(left - this.block_x) < 10,
                TuringTest: average !== stddev };
        },
        reset: function reset() {
            this.containerActive = false;
            this.containerSuccess = false;
            this.containerFail = false;
            this.sliderLeft = 0;
            this.block.style.left = 0;
            this.sliderMaskWidth = 0;
            var w = this.w,
                h = this.h;

            this.canvasCtx.clearRect(0, 0, w, h);
            this.blockCtx.clearRect(0, 0, w, h);
            this.block.width = w;

            this.img.src = this.getRandomImg();
        }
    }
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _api = __webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      msg: '',
      texts: '滑动验证',
      disabled: false,
      time: 0,
      btntxt: "重新发送",
      radio: 3,
      logining: false,
      forgetForm: {
        phone: '',
        password: '',
        conpassword: '',
        smsCode: '' },
      rules2: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        conpassword: [{ required: true, message: '请确认密码', trigger: 'blur' }, { required: true, message: '密码至少8位', trigger: ['blur', 'change'], min: 8 }],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }, { required: true, message: '请输入6位验证码', trigger: ['blur', 'change'], len: 6 }]

      },
      checked: true
    };
  },
  mounted: function mounted() {},

  methods: {
    onSuccess: function onSuccess() {
      this.msg = 'success';
    },
    onFail: function onFail() {
      this.msg = '';
    },
    onRefresh: function onRefresh() {
      this.msg = '';
    },
    smsCode: function smsCode() {
      var _this = this;

      if (this.msg != "success") {
        this.$message.error('请拖到图片进行验证！');
        return;
      }

      var reg = /^1[3-9]\d{9}$/;
      if (this.forgetForm.phone == '') {
        this.$message({
          message: '手机号不能为空',
          center: true
        });
        return;
      }
      if (!reg.test(this.forgetForm.phone)) {
        this.$message({
          message: '请输入正确的手机号',
          center: true
        });
        return;
      } else {
        var para = {
          phone: this.forgetForm.phone
        };
        _index.API__login.sendSmsCode(para).then(function (res) {

          if (res.data.code == _index.API__code.SUCCESS) {
            _this.$message({
              message: '发送成功',
              type: 'success',
              center: true
            });
            _this.time = 60;
            _this.disabled = true;
            _this.timer();
          } else {
            _this.$message.error(res.data.message);
          }
        }).catch(function (err) {
          _this.$message.error('服务器异常，请您稍后再试..');
          _this.pageLoading = false;
        });
      }
    },
    timer: function timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    handleSubmit2: function handleSubmit2(formName) {
      var _this2 = this;

      this.$refs.forgetForm.validate(function (valid) {
        if (valid) {
          _this2.forget();
        } else {
          _this2.$message.error('请正确输入登录账号和密码..');
          return false;
        }
      });
    },
    forget: function forget() {
      var _this3 = this;

      this.pageLoading = true;
      var param = {
        password: this.forgetForm.password,
        phone: this.forgetForm.phone,

        smsCode: this.forgetForm.smsCode,
        conpassword: this.forgetForm.conpassword
      };

      _index.API__login.forget(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '修改成功',
            type: 'success'
          });
          _this3.$router.push({ path: 'login' });
        } else {
          _this3.$message.error(res.data.message);
        }
        _this3.pageLoading = false;
      }).catch(function (e) {
        _this3.$message.error('服务器异常，请您稍后再试..');
        _this3.pageLoading = false;
      });
    }
  }
};

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _api = __webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      radio: 3,
      logining: false,
      loginForm: {
        phone: '',
        password: ''
      },
      rules2: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },
  mounted: function mounted() {
    this.clearCookie();
    this.getCookie();
  },

  methods: {
    handleSubmit2: function handleSubmit2(formName) {
      var _this = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this.login();
        } else {
          _this.$message.error('请正确输入登录账号和密码..');
          return false;
        }
      });
    },
    login: function login() {
      var _this2 = this;

      this.pageLoading = true;
      var param = {
        password: this.loginForm.password,
        phone: this.loginForm.phone,
        userType: '0' };
      _index.API__login.login(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: '登录成功',
            type: 'success'
          });

          var token = res.data.data.phone;
          _this2.setCookie("dnnyptInfo", "dnnypt_token", token);
          var name = res.data.data.name;
          if (name) {
            sessionStorage.setItem('user', name);
          } else {
            sessionStorage.setItem('user', token);
          }
          var modules = res.data.data.module;
          if (modules) {
            sessionStorage.setItem('module', modules);
          }
          var checkCode = res.data.data.checkCode;
          _this2.setCookie("dnnyptInfo", "dnnypt_checkCode", checkCode);
          var id = res.data.data.id;
          _this2.setCookie("dnnyptInfo", "dnnypt_id", id);

          _this2.$router.push({ path: 'productList' });
        } else {
          _this2.$message.error(res.data.message);
        }
        _this2.pageLoading = false;
      }).catch(function (e) {
        _this2.$message.error('服务器异常，请您稍后再试..');
        _this2.pageLoading = false;
      });
    },
    setCookie: function setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
      if (c_name == "dnnyptInfo") {
        window.document.cookie = c_pwd + "=" + exdays + ";path=/;expires=" + exdate.toGMTString();
      } else {
        window.document.cookie = "name" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie = "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      }
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'name') {
            this.loginForm.name = arr2[1];
          } else if (arr2[0] == 'password') {
            this.loginForm.password = arr2[1];
          }
        }
      }
    },

    clearCookie: function clearCookie() {
      this.setCookie("", "", -1);
    }
  }
};

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _api = __webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      myimg: __webpack_require__(1703),
      msg: '',
      texts: '滑动验证',
      radio: 3,
      logining: false,
      loginForm: {
        phone: '',
        password: ''
      },
      rules2: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true,
      loginLoading: false
    };
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    document.querySelector(".dnnCloud-login-box").style.backgroundImage = "url(./static/img/bg_login.png)";
  },


  methods: {
    checkTencentCaptcha: function checkTencentCaptcha(ticket, randstr, appid) {
      var _this2 = this;

      var ip = returnCitySN["cip"];
      var param = {
        Ticket: ticket,
        Randstr: randstr,
        UserIP: ip
      };
      _index.API__login.CheckTencentCaptcha(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.handleSubmit2();
        }
      });
    },
    handleSubmit2: function handleSubmit2(formName) {
      var _this3 = this;

      var _this = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this.login();
        } else {
          _this3.$message.error('请正确输入登录账号和密码');
          return false;
        }
      });
    },
    login: function login() {
      var _this4 = this;

      this.loginLoading = true;
      var param = {
        password: this.loginForm.password,
        user: this.loginForm.phone
      };
      _index.API__login.loginAdmin(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          sessionStorage.removeItem('user');
          sessionStorage.clear();
          _this4.setCookie("dnnyptInfo_admin", "dnnyptadmin_checkCode", "");
          _this4.setCookie("dnnyptInfo_admin", "dnnyptadmin_id", "");
          _this4.clearCookie();

          _this4.$message({
            message: '登录成功',
            type: 'success'
          });
          var data = res.data.data;
          var id = res.data.data.id;
          sessionStorage.setItem('dnnypt_id', id);

          if (res.data.data.checkCode) {
            var checkCode = res.data.data.checkCode;
            _this4.setCookie("dnnyptInfo_admin", "dnnyptadmin_checkCode", checkCode);
          }
          if (res.data.data.id) {
            var id = res.data.data.id;
            _this4.setCookie("dnnyptInfo_admin", "dnnyptadmin_id", id);
          }
          if (res.data.data.phone) {
            var token = res.data.data.phone;
            _this4.setCookie("dnnyptInfo_admin", "dnnyptadmin_token", token);
            _this4.$store.commit('set__token', token);
          }
          if (res.data.data.name) {
            var name = res.data.data.name;
            sessionStorage.setItem('user', name);
          }
          if (res.data.data.type) {
            var type = res.data.data.type;
            sessionStorage.setItem('type', type);
          }

          _this4.$store.commit('set__userinfo', data);

          res.data.data.type == '2' || res.data.data.type == '3' || res.data.data.type == '4' ? _this4.$router.push({ path: 'authorizeList' }) : _this4.$router.push({ path: 'management' });
        } else {
          _this4.$message.error(res.data.message);
        }
        _this4.loginLoading = false;
      }).catch(function (e) {
        _this4.$message.error('服务器异常，请您稍后再试..');
        _this4.loginLoading = false;
      });
    },
    setCookie: function setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
      if (c_name == "dnnyptInfo_admin") {
        window.document.cookie = c_pwd + "=" + exdays + ";path=/;expires=" + exdate.toGMTString();
      } else {
        window.document.cookie = "name" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie = "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      }
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'name') {
            this.loginForm.name = arr2[1];
          } else if (arr2[0] == 'password') {
            this.loginForm.password = arr2[1];
          }
        }
      }
    },

    clearCookie: function clearCookie() {
      this.setCookie("", "", -1);
    }
  }
};

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _api = __webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      msg: '',
      texts: '滑动验证',
      disabled: false,
      time: 0,
      btntxt: "重新发送",
      radio: 3,
      logining: false,
      registerForm: {
        phone: '',
        password: '',
        conpassword: '',
        smsCode: '' },
      rules2: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        conpassword: [{ required: true, message: '请确认密码', trigger: 'blur' }],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }, { required: true, message: '请输入6位验证码', trigger: ['blur', 'change'], len: 6 }]

      },
      checked: true
    };
  },
  mounted: function mounted() {},

  methods: {
    onSuccess: function onSuccess() {
      this.msg = 'success';
    },
    onFail: function onFail() {
      this.msg = '';
    },
    onRefresh: function onRefresh() {
      this.msg = '';
    },
    smsCode: function smsCode() {
      var _this = this;

      if (this.msg != "success") {
        this.$message.error('请拖到图片进行验证！');
        return;
      }

      var reg = /^1[3-9]\d{9}$/;
      if (this.registerForm.phone == '') {
        this.$message({
          message: '手机号不能为空',
          center: true
        });
        return;
      }
      if (!reg.test(this.registerForm.phone)) {
        this.$message({
          message: '请输入正确的手机号',
          center: true
        });
        return;
      } else {
        var para = {
          phone: this.registerForm.phone
        };
        _index.API__login.sendSmsCode(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this.$message({
              message: '发送成功',
              type: 'success',
              center: true
            });
            _this.time = 60;
            _this.disabled = true;
            _this.timer();
          } else {
            _this.$message.error(res.data.message);
          }
        }).catch(function (err) {
          _this.$message.error('服务器异常，请您稍后再试..');
          _this.pageLoading = false;
        });
      }
    },
    timer: function timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    handleSubmit2: function handleSubmit2(formName) {
      var _this2 = this;

      this.$refs.registerForm.validate(function (valid) {
        if (valid) {
          _this2.register();
        } else {
          _this2.$message.error('请正确输入登录账号和密码..');
          return false;
        }
      });
    },
    register: function register() {
      var _this3 = this;

      this.pageLoading = true;
      var param = {
        password: this.registerForm.password,
        conpassword: this.registerForm.conpassword,
        phone: this.registerForm.phone,
        userType: '0',
        smsCode: this.registerForm.smsCode
      };
      _index.API__login.register(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '注册成功',
            type: 'success'
          });
          _this3.$router.push({ path: 'login' });
        } else {
          _this3.$message.error(res.data.message);
        }
        _this3.pageLoading = false;
      }).catch(function (e) {
        _this3.$message.error('服务器异常，请您稍后再试..');
        _this3.pageLoading = false;
      });
    }
  }
};

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(293);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(107);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(294);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(106);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

var _jszip = __webpack_require__(1605);

var _jszip2 = _interopRequireDefault(_jszip);

var _fileSaver = __webpack_require__(1597);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      disSouch: true,
      disType: false,
      disAccountType: false,
      disTime1: false,
      disTime2: false,
      token: "",
      checkCode: "",
      id: "",
      listLoading: false,
      dataList: [],
      pageNumber: this.$route.query.pageNumber ? this.$route.query.pageNumber : 1,
      pageSize: this.$route.query.pageSize ? this.$route.query.pageSize : 20,
      total: 0,
      value: "",
      userName: "",
      searchText: this.$route.query.searchText,
      loginType: sessionStorage.getItem("type")
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["userInfo"])),

  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    getList: function getList() {
      var _this = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        userName: this.userName
      };
      this.listLoading = true;
      _index.API_AIPdf.getAIPdfList(param).then(function (res) {
        console.log(res);
        _this.dataList = res.data.data.list;
        _this.total = res.data.data.totalRow;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.$message.error("数据丢失，试试重新登陆！");
        _this.listLoading = false;
      });
    },

    dateTran: function dateTran(timestamp) {
      var date = new Date(timestamp);

      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      var hours = String(date.getHours()).padStart(2, "0");
      var minutes = String(date.getMinutes()).padStart(2, "0");
      var seconds = String(date.getSeconds()).padStart(2, "0");

      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    },

    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },


    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    download: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(row) {
        var _this2 = this;

        var zip, tempFiles, filesToDownload, validFiles, downloadPromises, content;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                zip = new _jszip2.default();
                tempFiles = [].concat((0, _toConsumableArray3.default)(row.straightCurveFiles || []), (0, _toConsumableArray3.default)(row.verticalCurveFiles || []), (0, _toConsumableArray3.default)(row.alignmentDiagramFiles || []), (0, _toConsumableArray3.default)(row.jdFiles || []), (0, _toConsumableArray3.default)(row.sqxFiles || []), (0, _toConsumableArray3.default)(row.icdFiles || []));
                filesToDownload = tempFiles.map(function (file) {
                  return {
                    url: file.url,
                    name: file.fileTitle
                  };
                });
                validFiles = filesToDownload.filter(function (file) {
                  return file.url;
                });

                if (!(validFiles.length === 0)) {
                  _context2.next = 7;
                  break;
                }

                this.$message.warning("没有可下载的文件");
                return _context2.abrupt("return");

              case 7:
                _context2.prev = 7;
                downloadPromises = validFiles.map(function () {
                  var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(file) {
                    var response, blob;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return fetch(file.url);

                          case 2:
                            response = _context.sent;

                            if (response.ok) {
                              _context.next = 5;
                              break;
                            }

                            throw new Error("\u4E0B\u8F7D\u5931\u8D25: " + file.name);

                          case 5:
                            _context.next = 7;
                            return response.blob();

                          case 7:
                            blob = _context.sent;

                            zip.file(file.name, blob);
                          case 9:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());
                _context2.next = 11;
                return _promise2.default.all(downloadPromises);

              case 11:
                _context2.next = 13;
                return zip.generateAsync({ type: "blob" });

              case 13:
                content = _context2.sent;

                (0, _fileSaver.saveAs)(content, "PDF平纵提取" + this.getDate() + ".zip");

                this.$message.success("文件打包成功！");
                _context2.next = 22;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](7);

                console.error("打包失败:", _context2.t0);
                this.$message.error("打包失败，请重试");

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 18]]);
      }));

      function download(_x) {
        return _ref2.apply(this, arguments);
      }

      return download;
    }(),

    getDate: function getDate() {
      var now = new Date();
      return now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0") + "-" + String(now.getDate()).padStart(2, "0") + "_" + String(now.getHours()).padStart(2, "0") + "-" + String(now.getMinutes()).padStart(2, "0") + "-" + String(now.getSeconds()).padStart(2, "0");
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    }
  },

  created: function created() {
    this.getCookie();
    if (this.$route.query.type == 1) {
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      token: "",
      checkCode: "",
      id: "",
      listLoading: false,
      dataList: [],
      souchs: {},
      pageNumber: this.$route.query.pageNumber ? this.$route.query.pageNumber : 1,
      pageSize: this.$route.query.pageSize ? this.$route.query.pageSize : 20,
      total: 0,
      userName: "",
      dynamicTags: [],
      imageShow: false,
      dialogVisible: false,
      detail: {},

      searchText: this.$route.query.searchText,
      successCount: 0,
      totalCount: 0,
      loginType: sessionStorage.getItem("type")
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["userInfo"])),

  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    handleRowClick: function handleRowClick(row) {
      this.handleDetail(row);
    },

    getList: function getList(page) {
      var _this = this;

      this.pageNumber = page ? page : this.pageNumber;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        userName: this.userName
      };
      this.listLoading = true;
      _index.API_AIRilab.getAIRilabStatistics().then(function (res) {
        _this.successCount = res.data.data.successCount;
        _this.totalCount = res.data.data.totalCount;
      });
      _index.API_AIRilab.getAIRilabList(param).then(function (res) {
        console.log(res);
        _this.dataList = res.data.data.list;
        _this.total = res.data.data.totalRow;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.$message.error("数据丢失，试试重新登陆！");
        _this.listLoading = false;
      });
    },

    dateTran: function dateTran(timestamp) {
      if (!timestamp) return "-";
      var date = new Date(timestamp);

      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      var hours = String(date.getHours()).padStart(2, "0");
      var minutes = String(date.getMinutes()).padStart(2, "0");
      var seconds = String(date.getSeconds()).padStart(2, "0");

      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    },

    formatDuration: function formatDuration(milliseconds) {
      if (!milliseconds || milliseconds < 0) return "-";

      var totalSeconds = Math.round(milliseconds / 1000);
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;

      return minutes + "\u5206\u949F" + String(seconds).padStart(2, "0") + "\u79D2";
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },
    handleDetail: function handleDetail(value) {
      this.dialogVisible = true;
      this.detail = value;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    }
  },

  created: function created() {
    this.getCookie();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(119);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

var _leftCharts = __webpack_require__(1737);

var _leftCharts2 = _interopRequireDefault(_leftCharts);

var _rightCharts = __webpack_require__(1738);

var _rightCharts2 = _interopRequireDefault(_rightCharts);

var _census = __webpack_require__(1735);

var _census2 = _interopRequireDefault(_census);

var _censusBar = __webpack_require__(1736);

var _censusBar2 = _interopRequireDefault(_censusBar);

var _modal = __webpack_require__(1740);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      token: "",
      checkCode: "",
      value: "1",
      value2: "1",
      chartsXAxis: [],

      chartsData: [],
      requestData: "",
      loading: true,
      chartsXAxisTwo: [],

      chartsDataTwo: [],
      options: [{
        value: "1",
        label: "最近一个月"
      }, {
        value: "3",
        label: "最近三个月"
      }, {
        value: "6",
        label: "最近半年"
      }, {
        value: "12",
        label: "最近一年"
      }],
      loading4: false,
      loading5: false,
      loading6: false,
      loading7: false,
      visitByMonth_Year: String(new Date().getFullYear()),
      visitByQuarter_Year: String(new Date().getFullYear()),
      yearPickerOptions: {
        disabledDate: function disabledDate(time) {
          var currentYear = new Date().getFullYear();
          var selectedYear = new Date(time).getFullYear();
          return selectedYear > currentYear;
        }
      },
      chartsXAxisThree: [],
      chartsDataThree: [],
      chartsXAxisFour: [],
      chartsDataFour: [],

      userGuishuPie: [],
      userGuishuBar: {}
    };
  },
  created: function created() {
    this.getCookie();
    this.getData();
    this.censusFun();
  },
  mounted: function mounted() {},


  methods: {
    censusFun: function censusFun() {
      var _this = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_control.getPeiAddress(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.userGuishuPie = res.data.data.pei;
          var bar = {
            x: res.data.data.zhuAddr,
            y: res.data.data.zhuCount
          };
          _this.userGuishuBar = bar;
        } else {
          _this.$message.error(res.data.message);
        }
      }).catch(function (err) {
        _this.loading = false;
        _this.$message.error("数据丢失，试试重新登陆！");
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    getData: function getData() {
      var _this2 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_control.getData(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.requestData = res.data.data;
          _this2.pointByHour();
          _this2.dayVisit();
          _this2.MonthVisit();
          _this2.QuarterVisit();
        } else {
          _this2.$message.error(res.data.message);
        }
      }).catch(function (err) {
        _this2.loading = false;
        _this2.$message.error("数据丢失，试试重新登陆！");
      });
    },
    pointByHour: function pointByHour(val) {
      var _this3 = this;

      var param = {
        count: this.value,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading4 = true;
      _index.API_control.pointByHour(param).then(function (res) {
        if (res.data.code == 200) {
          _this3.chartsXAxis = res.data.data.x;
          _this3.chartsData = res.data.data.y;
          _this3.getCharts();
          _this3.loading4 = false;
        }
      });
    },
    dayVisit: function dayVisit(val) {
      var _this4 = this;

      var param = {
        count: this.value2,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading5 = true;
      _index.API_control.dayVisit(param).then(function (res) {
        if (res.data.code == 200) {
          _this4.chartsXAxisTwo = res.data.data.x;
          _this4.chartsDataTwo = res.data.data.y;
          _this4.getChartsTwo();
          _this4.loading5 = false;
        }
      });
    },
    MonthVisit: function MonthVisit() {
      var _this5 = this;

      var param = {
        year: this.visitByMonth_Year,
        type: "month",
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading6 = true;
      _index.API_control.yaerVisit(param).then(function (res) {
        if (res.data.code == 200) {
          _this5.chartsXAxisThree = res.data.data.x;
          _this5.chartsDataThree = res.data.data.y;
          _this5.getChartsThree();
          _this5.loading6 = false;
        }
      });
    },
    QuarterVisit: function QuarterVisit() {
      var _this6 = this;

      var param = {
        year: this.visitByQuarter_Year,
        type: "quarter",
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading7 = true;
      _index.API_control.yaerVisit(param).then(function (res) {
        if (res.data.code == 200) {
          _this6.chartsXAxisFour = res.data.data.x;
          _this6.chartsDataFour = res.data.data.y;
          _this6.getChartsFour();
          _this6.loading7 = false;
        }
      });
    },
    getCharts: function getCharts() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box"));
      charts.showLoading();
      charts.setOption({
        title: [{
          text: "时程积分曲线",
          top: "top",
          left: "left",
          textStyle: {
            color: "#596471",
            fontSize: 17,
            fontWeight: 100
          }
        }],
        tooltip: {
          trigger: "axis",
          position: function position(pt) {
            return [pt[0], "10%"];
          },
          formatter: function formatter(params) {
            return params[0].name + "<br/>" + params[0].seriesName + ": " + (params[0].value + "").replace(/\B(?=(?:\d{3})+\b)/g, ",") + "\u5206";
          }
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxis,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          },
          splitArea: {}
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        series: [{
          name: "积分",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          itemStyle: {
            normal: {
              color: "#EF5350"
            }
          },
          areaStyle: {
            normal: {
              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#FFB87D"
              }, {
                offset: 1,
                color: "#ED7D76"
              }])
            }
          },
          data: this.chartsData,
          lineStyle: {
            normal: {
              color: "#EF5350"
            }
          }
        }]
      });
      charts.hideLoading();
      this.loading = false;
      window.addEventListener("resize", function () {
        charts.resize();
      });
    },
    getChartsTwo: function getChartsTwo() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-two"));
      charts.showLoading();
      charts.setOption({
        title: [{
          text: "时程日活曲线",
          top: "top",
          left: "10px",
          textStyle: {
            color: "#596471",
            fontSize: 17,
            fontWeight: 100
          }
        }],
        tooltip: {
          trigger: "axis",
          position: function position(pt) {
            return [pt[0], "10%"];
          },
          formatter: "{b0}<br/>{a0}: {c0}人"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisTwo,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          },
          splitArea: {}
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        series: [{
          name: "人",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          itemStyle: {
            normal: {
              color: "#448AFF"
            }
          },
          areaStyle: {
            normal: {
              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#74BCFF"
              }, {
                offset: 1,
                color: "#3575D6"
              }])
            }
          },
          data: this.chartsDataTwo,
          lineStyle: {
            normal: {
              color: "#448AFF"
            }
          }
        }]
      });
      charts.hideLoading();
      this.loading = false;
      window.addEventListener("resize", function () {
        charts.resize();
      });
    },
    getChartsThree: function getChartsThree() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-Three"));
      charts.showLoading();
      charts.setOption({
        title: [{
          text: "时程月活曲线",
          top: "top",
          left: "10px",
          textStyle: {
            color: "#596471",
            fontSize: 17,
            fontWeight: 100
          }
        }],
        tooltip: {
          trigger: "axis",
          position: function position(pt) {
            return [pt[0], "10%"];
          },
          formatter: "{b0}<br/>{a0}: {c0}人"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisThree,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        series: [{
          name: "人",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          itemStyle: {
            color: "#2E7D32" },
          areaStyle: {
            normal: {
              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#A5D6A7"
              }, {
                offset: 1,
                color: "#2E7D32"
              }])
            }
          },
          data: this.chartsDataThree,
          lineStyle: {
            color: "#2E7D32",
            width: 2
          }
        }]
      });
      charts.hideLoading();
      this.loading = false;
      window.addEventListener("resize", function () {
        charts.resize();
      });
    },
    getChartsFour: function getChartsFour() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-Four"));
      charts.showLoading();
      charts.setOption({
        title: [{
          text: "时程季活曲线",
          top: "top",
          left: "10px",
          textStyle: {
            color: "#596471",
            fontSize: 17,
            fontWeight: 100
          }
        }],
        tooltip: {
          trigger: "axis",
          position: function position(pt) {
            return [pt[0], "10%"];
          },
          formatter: "{b0}<br/>{a0}: {c0}人"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisFour,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        series: [{
          name: "人",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          itemStyle: {
            color: "#546E7A" },
          areaStyle: {
            normal: {
              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#90A4AE"
              }, {
                offset: 1,
                color: "#546E7A"
              }])
            }
          },
          data: this.chartsDataFour,
          lineStyle: {
            color: "#546E7A",
            width: 2
          }
        }]
      });
      charts.hideLoading();
      this.loading = false;
      window.addEventListener("resize", function () {
        charts.resize();
      });
    }
  },

  filters: {
    numberSlice: function numberSlice(val) {
      var num = (val + "").replace(/\B(?=(?:\d{3})+\b)/g, ",");
      if (num === "undefined") {
        num = "";
      }
      return num;
    }
  },

  components: {
    LeftCharts: _leftCharts2.default,
    RightCharts: _rightCharts2.default,
    Census: _census2.default,
    CensusBar: _censusBar2.default,
    ActiveModal: _modal2.default
  }
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(107);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(106);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _SelectCommon = __webpack_require__(76);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _GisCommon = __webpack_require__(167);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cityOptions = ['模块1', '模块2', '模块3', '模块4', '模块5', '模块6'];
exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _this2 = this,
        _ref2;

    var validateAddress = function validateAddress(rule, value, callback) {
      if (_this2.editForm0.longitudeAndLatitude === '') {
        callback(new Error('请填写客户地址'));
      } else {
        if (_this2.editForm0.province == '' || _this2.editForm0.city == '' || _this2.editForm0.district == '' || _this2.editForm0.addressInfo == '') {
          _this2.$refs.editForm0.validateField('longitudeAndLatitude');
        }
        callback();
      }
    };

    var validatoPhone = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var reg, res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reg = /^1[3-9]\d{9}$/;

                if (_this2.editForm0.phone) {
                  _context.next = 5;
                  break;
                }

                callback("请输入手机号");
                _context.next = 14;
                break;

              case 5:
                if (reg.test(_this2.editForm0.phone)) {
                  _context.next = 9;
                  break;
                }

                callback(new Error("请输入正确的手机号"));
                _context.next = 14;
                break;

              case 9:
                if (!(_this2.oldPhone != _this2.editForm0.phone)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return _this2.checkPhone(_this2.editForm0.phone);

              case 12:
                res = _context.sent;

                !res ? callback('当前手机号已被注册') : callback();

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function validatoPhone(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    return _ref2 = {
      downHrefExcel: '',
      downHref: '',
      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName: "",
      searchName: this.$route.query.searchName ? this.$route.query.searchName : '',
      dynamicTags: [],
      optionsSouch: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '软件类型', label: '软件类型' }, { value: '邀请状态', label: '邀请状态' }, { value: '开始日期', label: '开始日期' }, { value: '结束日期', label: '结束日期' }],
      value: '',
      inviValues: [],
      softtypes: [],
      yhlx: [],
      zhlx: [],
      editLoading0: false,

      editForm0: {
        managerAdminuser: '',
        successfulManager: "",
        agencyManager: "",
        userType: 0,
        code: 0,

        province: '',
        city: '',
        district: '',
        longitudeAndLatitude: '',
        addressInfo: '',

        selected: { province: '320000', city: '320100', area: '320115', town: '320115010' },
        address: '',
        companyuseid: '',
        company: '',

        fileUploadName: ''
      },

      curCompanyId: '',

      editFormVisible0: false,
      rules: {
        phone: [{ required: true, validator: validatoPhone, trigger: 'change' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        code: [{ required: false, message: '请选择软件类型', trigger: 'change' }],
        userType: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        company: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        companyuseid: [{ required: true, message: '请选择企业', trigger: 'change' }],
        passwordMo: [{ required: true, message: '请输入密码', trigger: 'blur' }],

        managerAdminuser: [{ required: true, message: '请选择客户经理', trigger: 'change' }],

        longitudeAndLatitude: [{ required: true, validator: validateAddress, trigger: 'change' }]

      },
      addCode: '0',

      falseLoading: false,
      cities: [],
      citiesd: [],
      userModule: [],
      editFormVisible: false,
      editForm: {},
      editLoading: false,
      options: [{
        value: '1',
        label: '一个月'
      }, {
        value: '2',
        label: '二个月'
      }, {
        value: '3',
        label: '三个月'
      }, {
        value: '4',
        label: '四个月'
      }, {
        value: '5',
        label: '五个月'
      }, {
        value: '6',
        label: '六个月'
      }],
      id: '',
      token: '',
      checkCode: '',
      listLoading: false,
      souchs: {
        phone: '',
        name: '',
        company: '',
        fromtime: this.$route.query.fromtime ? this.$route.query.fromtime : '',
        totime: this.$route.query.totime ? this.$route.query.totime : ''
      },
      orderStr: '',
      orderType: '',
      pageNumber: 1,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 20,
      total: 0,
      users: [],

      appFormVisible: false,
      appForm: {
        checkedCities: [],
        value: ''
      },
      appLoading: false

    }, (0, _defineProperty3.default)(_ref2, 'editForm', {
      checkedCities: [],
      value: ''
    }), (0, _defineProperty3.default)(_ref2, 'asTitle', '编辑'), (0, _defineProperty3.default)(_ref2, 'modalType', 0), (0, _defineProperty3.default)(_ref2, 'fileFormData', ''), (0, _defineProperty3.default)(_ref2, 'companyList', []), (0, _defineProperty3.default)(_ref2, 'fileUploadName', ''), (0, _defineProperty3.default)(_ref2, 'oldPhone', ''), (0, _defineProperty3.default)(_ref2, 'managerAdminuser', this.$route.query.managerAdminuser ? this.$route.query.managerAdminuser : ''), (0, _defineProperty3.default)(_ref2, 'isCompanyUser', this.$route.query.isCompanyUser ? this.$route.query.isCompanyUser : ''), (0, _defineProperty3.default)(_ref2, 'successfulManager', ''), (0, _defineProperty3.default)(_ref2, 'agencyManager', ""), (0, _defineProperty3.default)(_ref2, 'distribution', [{ value: '0', label: '未分配' }, { value: '1', label: '已分配' }]), (0, _defineProperty3.default)(_ref2, 'distributionStatus', this.$route.query.distributionStatus ? this.$route.query.distributionStatus : ''), (0, _defineProperty3.default)(_ref2, 'deptId', ''), (0, _defineProperty3.default)(_ref2, 'detpList', []), _ref2;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default,
    SelectCommon: _SelectCommon2.default,
    GisCommon: _GisCommon2.default
  },

  created: function created() {
    this.getCookie();
    this.getCode1();
    this.getCode2();
    if (this.$route.query.type == 1) {
      this.dynamicTags = this.$route.query.dynamicTags ? JSON.parse(this.$route.query.dynamicTags) : '';
      this.souchs = this.$route.query.souchs ? JSON.parse(this.$route.query.souchs) : {};
      this.pageNumber = this.$route.query.pageNumber ? JSON.parse(this.$route.query.pageNumber) : 1;
    }
    this.getUser();
    this.getModels();
    this.getCode();

    this.downHref = _index.API_Admin.userExcelTemplate() + "?token=" + this.token + "&checkCode=" + this.checkCode;
  },


  methods: {
    checkPhone: function checkPhone(phone) {
      return _index.API_Admin.checkPhoneUnique({ phone: phone }).then(function (res) {
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    handerChange: function handerChange(val, key) {
      this.detpList = [];
      if (key == 'addCode') {
        this.addCode = val + '';
        this.editForm0.userType = this.addCode;

        this.curCompanyId = '';
        this.editForm0.company = '';
        this.editForm0.companyuseid = '';
        this.editForm0.managerAdminuser = this.userInfo.type == 2 ? this.userInfo.id : '';
        this.editForm0.successfulManager = this.userInfo.type == 3 ? this.userInfo.id : '';
        this.editForm0.agencyManager = this.userInfo.type == 4 ? this.userInfo.id : '';

        this.initMap({
          addressInfo: '',
          longitudeAndLatitude: '',
          province: "{\"key\":\"320000\",\"value\":\"江苏省\"}",
          city: "{\"key\":\"320100\",\"value\":\"南京市\"}",
          district: "{\"key\":\"320115\",\"value\":\"江宁区\"}"
        });
      } else {
        this[key] = val;

        if (key == 'curCompanyId') {
          var data = this.companyList.find(function (item) {
            return item.id == val;
          });
          this.initMap(data);
          this.getDeptList(val);
        }
      }
    },
    importFile: function importFile(form) {
      var _this3 = this;

      var _self = this;
      this.$refs[form].validate(function (valid) {
        if (valid) {
          var file = _this3.fileFormData;
          if (!file) {
            _self.$message.error('请选择文件');
            return;
          }

          var formData = new FormData();
          formData.append("file", file);
          var createAdminUser = _this3.userInfo.id;
          var password = _this3.editForm0.passwordMo ? _this3.editForm0.passwordMo : '123456';
          var companyuseid = '';
          var company = '';
          var addCode = _this3.addCode;
          var code = _this3.editForm0.code;
          if (_this3.addCode == 1) {
            companyuseid = _this3.editForm0.companyuseid;
            var list = (0, _assign2.default)([], _this3.companyList);
            var name = '';
            for (var p in list) {
              if (list[p].id == _this3.editForm0.companyuseid) {
                name = list[p].name;
              }
            }
            formData.append("company", name);
            company = decodeURIComponent(name);
          } else {
            formData.append("company", _this3.editForm0.company);
            companyuseid = '';
          }
          _this3.editLoading0 = true;
          var _this = _this3;

          var _editForm = _this3.editForm0,
              province = _editForm.province,
              city = _editForm.city,
              district = _editForm.district;


          formData.append("addressInfo", _this3.editForm0.addressInfo);
          formData.append("city", city);
          formData.append("province", province);
          formData.append("district", district);
          var param = 'usertype=' + addCode + '&password=' + password + '&companyuseid=' + companyuseid + '&code=' + (code + '') + '&createAdminUser=' + createAdminUser + '&longitudeAndLatitude=' + _this3.editForm0.longitudeAndLatitude + '&deptid=' + _this3.deptId + '&managerAdminuser=' + _this3.editForm0.managerAdminuser + '&successfulManager=' + _this3.editForm0.successfulManager + '&agencyManager=' + _this3.editForm0.agencyManager;

          _index.API_Admin.importUserExcelfile(param, formData).then(function (res) {
            if (res.data.code == '401') {
              _this.$message.error(res.data.message);
            } else {
              _this.$message.success('导入成功！');
              _this.getUser();
              _this.$refs.clearFileModal.value = "";
              _this.editFormVisible0 = false;
              _this.$refs[form].resetFields();
              _this.deptId = '';
            }
            _this.editLoading0 = false;
          }).catch(function (err) {
            _this.$message.error('导入失败！');
            _this.editLoading0 = false;
          });
        } else {
          return false;
        }
      });
    },
    fileInputChange: function fileInputChange(files) {
      var file = files.target.files[0];
      var type = file.type;
      if (type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || type == "application/vnd.ms-excel") {
        this.fileFormData = file;
        this.fileUploadName = file.name;
        this.$refs.clearFileModal.value = "";
      } else {
        this.$message.error('请上传xlsx/xls格式文件！');
      }
    },
    backPram: function backPram(param) {

      this.editForm0.province = (0, _stringify2.default)(param.selected.province);
      this.editForm0.city = (0, _stringify2.default)(param.selected.city);
      this.editForm0.district = (0, _stringify2.default)(param.selected.area);
      this.editForm0.longitudeAndLatitude = param.position.toString();
      this.editForm0.addressInfo = param.address;
      this.editForm0.selected = {
        area: this.editForm0.district,
        city: this.editForm0.city,
        province: this.editForm0.province,
        town: ''
      };
      this.$refs.editForm0.validateField('longitudeAndLatitude');
    },
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.editForm0[key] = value[0];
      this.$refs.editForm0.validateField(key);
    },
    addUser: function addUser(type) {
      this.asTitle = type == 1 ? '新增' : '导入';
      this.editFormVisible0 = true;
      this.modalType = type;

      this.rules.passwordMo[0].required = true;

      this.editForm0 = {
        managerAdminuser: this.userInfo.type == 2 ? this.userInfo.id : '',
        successfulManager: this.userInfo.type == 3 ? this.userInfo.id : '',
        agencyManager: this.userInfo.type == 4 ? this.userInfo.id : '',
        code: 0,

        province: '',
        city: '',
        district: '',
        longitudeAndLatitude: '',
        addressInfo: '',

        selected: { province: '320000', city: '320100', area: '320115', town: '320115010' },
        address: '',
        company: ''
      }, this.addCode = '0';
      this.editForm0.userType = '0';
      this.fileUploadName = '';
      this.$refs['editForm0'] && this.$refs['editForm0'].resetFields();
    },
    handleClose: function handleClose(tag) {
      if (tag == "账号") {
        this.souchs.phone = '';
        if (this.value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs.name = '';
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.company = '';
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "软件类型") {
        this.souchs.softtype = "";
      }
      if (tag == "邀请状态") {
        this.souchs.invitValue = "";
      }
      if (tag == "开始日期") {
        this.souchs.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs.totime = "";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },


    delTags: function delTags() {
      this.souchs = {};
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getUser();
    },

    readUser: function readUser(index, row) {
      this.$router.push({
        path: '/userDetail',
        query: {
          userId: row.id,
          name: row.name,
          dynamicTags: (0, _stringify2.default)(this.dynamicTags),
          souchs: (0, _stringify2.default)(this.souchs),
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          searchName: this.searchName,
          isCompanyUser: this.isCompanyUser,
          fromtime: this.souchs.fromtime,
          totime: this.souchs.totime,
          managerAdminuser: this.managerAdminuser,
          distributionStatus: this.distributionStatus,
          phone: row.phone
        }
      });
    },

    changeSouch: function changeSouch(val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName = this.souchs.phone;
        this.disSouch = true;
      } else if (val == "姓名") {
        this.proName = this.souchs.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs.company;
        this.disSouch = true;
      } else if (val == "软件类型") {
        this.disSofttype = true;
      } else if (val == "邀请状态") {
        this.disinvit = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "phone") {
          this.orderStr = "phoneOrder";
        } else if (val.prop == "name") {
          this.orderStr = "nameOrder";
        } else if (val.prop == "point") {
          this.orderStr = "pointOrder";
        } else if (val.prop == "userName") {
          this.orderStr = "usertypeOrder";
        } else if (val.prop == "softtype") {
          this.orderStr = "codeOrder";
        } else if (val.prop == "registertime") {
          this.orderStr = "registertimeOrder";
        } else if (val.prop == "company") {
          this.orderStr = "companyOrder";
        } else if (val.prop == "adminName") {
          this.orderStr = "managerAdminuser";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getUser();
    },

    falseSubmit: function falseSubmit() {
      var _this4 = this;

      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + 1;
      var day = nowDate.getDate();
      var hours = nowDate.getHours();
      var minutes = nowDate.getMinutes();
      var seconds = nowDate.getSeconds();
      if (seconds < 10) {
        seconds = '0' + seconds;
      }

      var itime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      var monthNum = -this.appForm.value;
      var days = new Date(year, month, 0);
      days = days.getDate();
      var year2 = year;
      var month2 = parseInt(month) - monthNum;
      if (month2 <= 0) {
        year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : parseInt(month2) / 12);
        month2 = 12 - Math.abs(month2) % 12;
      }
      var day2 = parseInt(day) + 1;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = '01';
        month2 = parseInt(month2) + 1;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2 + ' 23-59-59';

      var userModuled = {
        "status": false,
        "date": itime,
        "time": t2,
        "duration": this.appForm.value,
        "module": this.userModule
      };
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.appForm.id,

        userModule: []
      };
      this.appLoading = true;
      _index.API_Admin.setUserModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: '审批成功',
            type: 'success'
          });
          _this4.appFormVisible = false;
          _this4.getUser();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
        _this4.appLoading = false;
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
        _this4.appLoading = false;
      });
    },

    editSubmit: function editSubmit() {
      var _this5 = this;

      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + 1;
      var day = nowDate.getDate();
      var hours = nowDate.getHours();
      var minutes = nowDate.getMinutes();
      var seconds = nowDate.getSeconds();
      if (seconds < 10) {
        seconds = '0' + seconds;
      }

      var itime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      var monthNum = -this.editForm.value;
      var days = new Date(year, month, 0);
      days = days.getDate();
      var year2 = year;
      var month2 = parseInt(month) - monthNum;
      if (month2 <= 0) {
        year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : parseInt(month2) / 12);
        month2 = 12 - Math.abs(month2) % 12;
      }
      var day2 = parseInt(day) + 1;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = '01';
        month2 = parseInt(month2) + 1;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2 + ' 23-59-59';

      var userModuled = {
        "status": true,
        "date": itime,
        "time": t2,
        "duration": this.editForm.value,
        "module": this.userModule
      };
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.editForm.id,
        userModule: (0, _stringify2.default)(userModuled)
      };
      this.editLoading = true;
      _index.API_Admin.setUserModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.$message({
            message: '授权成功',
            type: 'success'
          });
          _this5.editFormVisible = false;
          _this5.getUser();
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.editLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.editLoading = false;
      });
    },

    appSubmit: function appSubmit() {
      var _this6 = this;

      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + 1;
      var day = nowDate.getDate();
      var hours = nowDate.getHours();
      var minutes = nowDate.getMinutes();
      var seconds = nowDate.getSeconds();
      if (seconds < 10) {
        seconds = '0' + seconds;
      }

      var itime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      var monthNum = -this.appForm.value;
      var days = new Date(year, month, 0);
      days = days.getDate();
      var year2 = year;
      var month2 = parseInt(month) - monthNum;
      if (month2 <= 0) {
        year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : parseInt(month2) / 12);
        month2 = 12 - Math.abs(month2) % 12;
      }
      var day2 = parseInt(day) + 1;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = '01';
        month2 = parseInt(month2) + 1;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2 + ' 23-59-59';

      var userModuled = {
        "status": true,
        "date": itime,
        "time": t2,
        "duration": this.appForm.value,
        "module": this.userModule
      };
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.appForm.id,
        userModule: (0, _stringify2.default)(userModuled),
        moduleStatus: '1',
        phone: this.token
      };
      this.appLoading = true;
      _index.API_Admin.setUserModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this6.$message({
            message: '审批成功',
            type: 'success'
          });
          _this6.appFormVisible = false;
          _this6.getUser();
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
        _this6.appLoading = false;
      }).catch(function (err) {
        _this6.$message.error('数据丢失，试试重新登陆！');
        _this6.appLoading = false;
      });
    },

    editSubmit0: function editSubmit0(form) {
      var _this7 = this;

      this.$refs[form].validate(function (valid) {
        if (valid) {
          var param = void 0;

          _this7.editLoading0 = true;
          var methods = 'modifyUser';
          if (_this7.modalType == 1) {
            methods = 'addUserSingle';
            param = {
              token: _this7.token,
              checkCode: _this7.checkCode,
              mode: 'update',
              name: _this7.editForm0.name,
              phone: _this7.editForm0.phone,
              code: _this7.editForm0.code,
              company: _this7.editForm0.company,
              id: _this7.editForm0.id,
              userType: _this7.addCode,
              password: _this7.editForm0.passwordMo ? _this7.editForm0.passwordMo : '',
              companyuseid: '',

              province: _this7.editForm0.province,
              city: _this7.editForm0.city,
              district: _this7.editForm0.district,
              longitudeAndLatitude: _this7.editForm0.longitudeAndLatitude,
              addressInfo: _this7.editForm0.addressInfo,
              managerAdminuser: _this7.editForm0.managerAdminuser,
              createAdminUser: _this7.userInfo.id,
              successfulManager: _this7.editForm0.successfulManager,
              agencyManager: _this7.editForm0.agencyManager };
            param['password'] = _this7.editForm0.passwordMo ? _this7.editForm0.passwordMo : '123456';
          } else {
            param = {
              token: _this7.token,
              checkCode: _this7.checkCode,
              mode: 'update',
              name: _this7.editForm0.name,
              phone: _this7.editForm0.phone,
              code: _this7.editForm0.code,
              company: _this7.editForm0.company,
              id: _this7.editForm0.id,
              usertype: _this7.addCode,
              password: _this7.editForm0.passwordMo ? _this7.editForm0.passwordMo : '',
              companyuseid: '',

              province: _this7.editForm0.province,
              city: _this7.editForm0.city,
              district: _this7.editForm0.district,
              longitudeAndLatitude: _this7.editForm0.longitudeAndLatitude,
              addressInfo: _this7.editForm0.addressInfo,
              managerAdminuser: _this7.editForm0.managerAdminuser,
              createAdminUser: _this7.userInfo.id,
              successfulManager: _this7.editForm0.successfulManager,
              agencyManager: _this7.editForm0.agencyManager };
            param['registertime'] = _this7.editForm0.registertimeyuan;
          }

          if (_this7.addCode == 1) {
            param['companyuseid'] = _this7.editForm0.companyuseid;
            var list = (0, _assign2.default)([], _this7.companyList);
            var name = '';
            for (var p in list) {
              if (list[p].id == _this7.editForm0.companyuseid) {
                name = list[p].name;
              }
            }
            param['company'] = name;
          }

          _index.API_Admin[methods](param).then(function (res) {
            if (res.data.code == _index.API__code.SUCCESS) {
              _this7.$message({
                message: _this7.modalType == 0 ? '修改成功' : '新增成功',
                type: 'success'
              });
              _this7.editFormVisible0 = false;
              _this7.$refs[form].resetFields();
              _this7.getUser();
            } else {
              _this7.$message.error(res.data.message);
              _this7.editForm0.passwordMo = '';
              if (res.data.code == 403) {
                _this7.$router.push({ path: 'loginAdmin' });
              }
            }
            _this7.editLoading0 = false;
          }).catch(function (err) {
            _this7.$message.error('数据丢失，试试重新登陆！');
            _this7.editLoading0 = false;
          });
        } else {
          return false;
        }
      });
    },

    initMap: function initMap(mapData) {
      var _this8 = this;

      var mapDataBack = JSON.parse((0, _stringify2.default)(mapData));
      try {
        var province = mapData.province,
            city = mapData.city,
            district = mapData.district,
            addressInfo = mapData.addressInfo,
            _mapData$longitudeAnd = mapData.longitudeAndLatitude,
            longitudeAndLatitude = _mapData$longitudeAnd === undefined ? '' : _mapData$longitudeAnd;

        province = JSON.parse(province);
        city = JSON.parse(city);
        district = JSON.parse(district);
        setTimeout(function () {
          _this8.editForm0.selecteds = { province: province.key, city: city.key, area: district.key, town: '' };
          _this8.editForm0.address = addressInfo;
          _this8.$refs.GisCommon.changePro(_this8.editForm0.selecteds);
          _this8.$refs.GisCommon.changItem(addressInfo);
          longitudeAndLatitude = longitudeAndLatitude ? longitudeAndLatitude.split(',').map(function (item) {
            return parseInt(item);
          }) : '';
          _this8.$refs.GisCommon.changePos(longitudeAndLatitude);

          _this8.editForm0.longitudeAndLatitude = typeof longitudeAndLatitude === 'string' ? longitudeAndLatitude : longitudeAndLatitude.join();
          _this8.editForm0.province = mapDataBack.province;
          _this8.editForm0.city = mapDataBack.city;
          _this8.editForm0.district = mapDataBack.district;
          _this8.editForm0.addressInfo = mapDataBack.addressInfo;

          _this8.$refs.editForm0.validateField('longitudeAndLatitude');
        }, 100);
      } catch (e) {
        this.editForm0.selecteds = { province: '320000', city: '320100', area: '320115', town: '' };
        this.editForm0.address = '';
      }
    },

    handleEdit0: function handleEdit0(index, row) {
      this.editFormVisible0 = true;
      this.asTitle = '编辑';
      this.modalType = 0;

      this.rules.passwordMo[0].required = false;
      this.editForm0 = (0, _assign2.default)({}, row);
      this.addCode = this.editForm0.companyuseid ? '1' : '0';

      this.editForm0.userType = this.addCode;
      this.oldPhone = this.editForm0.phone;
      this.initMap(row);
    },

    handledel: function handledel(index, row) {
      var _this9 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this9.token,
          checkCode: _this9.checkCode,
          id: row.id
        };
        _index.API_Admin.delUser(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this9.$message({
              message: '删除成功',
              type: 'success'
            });
            _this9.getUser();
          } else {
            _this9.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this9.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this9.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },

    handleEdit2: function handleEdit2(index, row) {
      this.userModule = [];
      this.appForm.checkedCities = [];
      this.appForm.id = row.id;
      var moduled = JSON.parse(row.module);
      this.appForm.value = moduled.duration;
      for (var i = 0; i < this.citiesd.length; i++) {
        for (var k = 0; k < moduled.module.length; k++) {
          if (moduled.module[k].id == this.citiesd[i].id) {
            this.appForm.checkedCities.push(this.citiesd[i].modulename);
            var jsoned = { "id": this.citiesd[k].id };
            this.userModule.push(jsoned);
          }
        }
      }

      this.appFormVisible = true;
    },

    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      this.userModule = [];
      for (var i = 0; i < value.length; i++) {
        for (var k = 0; k < this.citiesd.length; k++) {
          if (value[i] == this.citiesd[k].modulename) {
            var jsoned = { "id": this.citiesd[k].id };
            this.userModule.push(jsoned);
          }
        }
      }
    },

    handleEdit: function handleEdit(index, row) {
      this.editForm = {
        checkedCities: [],
        value: '',
        id: row.id
      };
      this.editFormVisible = true;
    },

    forType: function forType(row, column) {
      if (row.usertype == 1) {
        return row.userType = '企业账号';
      } else {
        return row.userType = '个人账号';
      }
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref3) {
      var row = _ref3.row,
          column = _ref3.column,
          rowIndex = _ref3.rowIndex,
          columnIndex = _ref3.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },

    getUser: function getUser(val) {
      var _this10 = this;

      if (this.value == "账号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.company = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }

      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        userType: '',

        username: this.souchs.name,
        phone: this.souchs.phone,
        company: this.souchs.company,
        registertimefrom: this.souchs.fromtime,
        registertimeto: this.souchs.totime,
        softtype: this.souchs.softtype,
        invitestatus: this.souchs.invitValue,
        fpFlg: this.distributionStatus,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        managerAdminuser: this.managerAdminuser,
        successfulManager: this.successfulManager,
        agencyManager: this.agencyManager,
        searchName: this.searchName,
        isCompanyUser: this.isCompanyUser

      };

      this.downHrefExcel = _index.API_User.allUserByExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&registertimefrom=" + (this.souchs.fromtime || '') + "&registertimeto=" + (this.souchs.totime || '') + "&softtype=" + (this.souchs.softtype || '') + "&invitestatus=" + (this.souchs.invitestatus || '') + "&phone=" + (this.souchs.phone || '') + "&company=" + (this.souchs.company || '') + "&searchName=" + this.searchName + "&isCompanyUser=" + this.isCompanyUser + "&managerAdminuser=" + this.managerAdminuser + "&fpFlg=" + this.distributionStatus + "&username=" + (this.souchs.name || '') + "";
      this.listLoading = true;
      _index.API_User.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              res.data.data.list[i].registertimeyuan = res.data.data.list[i].registertime;
              if (res.data.data.list[i].registertime) {
                res.data.data.list[i].registertime = res.data.data.list[i].registertime.substring(0, 10);
              }
            }
            _this10.total = res.data.data.totalRow;
            _this10.users = res.data.data.list;
            _this10.listLoading = false;
          }
        } else {
          _this10.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this10.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this10.$message.error('数据丢失，试试重新登陆！');
      });
    },
    getModels: function getModels() {
      var _this11 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Models.getAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this11.models = res.data.data;
          _this11.cities = [];
          _this11.citiesd = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this11.cities.push(res.data.data[i].modulename);
            var jsones = { "modulename": res.data.data[i].modulename, "id": res.data.data[i].id };
            _this11.citiesd.push(jsones);
          }
        } else {
          _this11.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this11.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this11.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },

    getCode1: function getCode1() {
      var _this12 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        role: this.userInfo.type,
        userId: this.userInfo.id
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.yhlx = [];
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.yhlx.push(jsons);
            var json = { 'value': res.data.data[i].code, 'label': res.data.data[i].name };
            _this.softtypes.push(json);
          }
        } else {
          _this12.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this12.$router.push({ path: 'loginAdmin' });
          }
        }
      });
      param.userType = this.userInfo.type;
      _index.API_Admin.tbCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this12.companyList = res.data.data;
        }
      });
    },
    getCode2: function getCode2() {
      var _this13 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.AccList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.zhlx = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.zhlx.push(jsons);
          }
        } else {
          _this13.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this13.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },

    getCode: function getCode() {
      var _this14 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "label": res.data.data[i].name };
            _this.inviValues.push(jsons);
          }
        } else {
          _this14.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this14.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    getDeptList: function getDeptList(companyid) {
      var _this15 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: companyid
      };
      _index.API_userCom.getDepartList(param).then(function (res) {
        if (res.data.code == 200) {
          _this15.detpList = res.data.data;
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    cancelHandler: function cancelHandler() {
      this.editFormVisible0 = false;
      this.deptId = '';
    },

    dialogClose: function dialogClose() {
      console.log('dialogClose');
      this.deptId = '';
    }
  }

};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(107);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(106);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _GisCommon = __webpack_require__(167);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _addAdmin = __webpack_require__(782);

var _addAdmin2 = _interopRequireDefault(_addAdmin);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _SelectCommon = __webpack_require__(76);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

var _targetCustomDialog = __webpack_require__(777);

var _targetCustomDialog2 = _interopRequireDefault(_targetCustomDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _this2 = this;

    var validatorCompany = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.addForm.name) {
                  _context.next = 4;
                  break;
                }

                callback("请输入企业名称");
                _context.next = 8;
                break;

              case 4:
                _context.next = 6;
                return _this2.checkCompany(_this2.addForm.name);

              case 6:
                res = _context.sent;

                !res ? callback("企业名称已存在") : callback();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function validatorCompany(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      beformAddImg: "",
      editImageUrl: "",
      adminVisible: false,
      imageUrl: "",
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: _index.API_Common.setCompanyPic(),
        dialogImageUrl: "",
        dialogVisible: false,
        data: {
          mode: "save",
          token: this.token,
          checkCode: this.checkCode,
          type: 1
        }
      },

      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName2: "",
      dynamicTags2: [],
      optionsSouch2: [{ value: "账号", label: "账号" }, { value: "姓名", label: "姓名" }, { value: "企业", label: "企业" }, { value: "软件类型", label: "软件类型" }, { value: "邀请状态", label: "邀请状态" }, { value: "开始日期", label: "开始日期" }, { value: "结束日期", label: "结束日期" }],
      value2: "",
      inviValues: [],
      softtypes: [],

      proName: "",
      dynamicTags: [],
      options: [{ value: "ID", label: "ID" }, { value: "企业名称", label: "企业名称" }, { value: "管理员", label: "管理员" }],
      value: "",

      rname: "",
      companyId: "",
      orderLoading: false,
      userLoading: false,
      orderVisible: false,
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      userList: [],
      souchs2: {
        name: "",
        phone: "",
        company: "",
        invitestatus: "",
        softtype: "",
        fromtime: "",
        totime: ""
      },
      flag: false,
      checkUserId: "",
      checkUserIdOld: "",
      token: this.token,
      checkCode: this.checkCode,
      id: this.id,
      souchs: {
        name: ""
      },
      total: 0,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 20,
      pageNumber: 1,
      proList: [],
      listLoading: false,
      sels: [],
      exportList: [],
      exportLoading: false,
      needClearSel: false,
      importLoading: false,

      addFormVisible: false,
      addLoading: false,
      addForm: {
        name: "",
        showname: "",
        province: "",
        city: "",
        district: "",
        longitudeAndLatitude: "",
        addressInfo: "",
        managerAdminuser: "",
        managerAdminuserName: ""
      },

      addFormRules: {
        name: [{ required: true, validator: validatorCompany, trigger: "change" }],
        showname: [{ required: true, message: "请输入地区", trigger: "blur" }]
      },

      editFormVisible: false,
      editLoading: false,
      editForm: {
        name: ""
      },
      editFormRules: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }]
      },
      orderType: "",
      orderStr: "",

      userSelection: [],
      UserSelection: [],
      searchText: this.$route.query.searchText ? this.$route.query.searchText : "",
      selected: {
        province: "320000",
        city: "320100",
        area: "320115",
        town: "320115010"
      },
      address: "",

      comLists: [],

      statusArr: [{ value: 1, label: "拜访" }, { value: 2, label: "试用 " }, { value: 3, label: "正式" }],
      gradeArr: [{ value: '1', label: "综合甲" }, { value: '2', label: "公路甲 " }, { value: '3', label: "市政甲" }, { value: '4', label: "公路市政甲" }, { value: '5', label: "公路乙" }, { value: '6', label: "市政乙" }, { value: '7', label: "公路市政乙" }, { value: '9', label: "高校" }, { value: '10', label: "施工单位" }, { value: '8', label: "其他" }],
      gradeValue: [],
      status: this.$route.query.status ? this.$route.query.status : "",
      distribution: [{ value: "0", label: "未分配" }, { value: "1", label: "已分配" }],
      distributionStatus: this.$route.query.distributionStatus ? this.$route.query.distributionStatus : "",
      managerAdminuser: this.$route.query.managerAdminuserName,
      successfulManager: '',
      agencyManager: "",
      targetTotal: 0,
      qualityTotal: 0,
      collegesTotal: 0,
      regionCodeList: [{
        value: "1",
        label: "华东大区"
      }, {
        value: "2",
        label: "华北大区"
      }, {
        value: "3",
        label: "西北大区"
      }, {
        value: "4",
        label: "华南大区"
      }, {
        value: "5",
        label: "西南大区"
      }],
      regionCode: ""
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["userInfo"])),

  components: {
    BaseContainer: _BaseContainer2.default,
    SelectCommon: _SelectCommon2.default,
    Admin: _addAdmin2.default,
    GisCommon: _GisCommon2.default,
    TargetCustomDialog: _targetCustomDialog2.default
  },
  methods: {
    batchExport: function batchExport() {
      var _this3 = this;

      if (!this.exportList.length) {
        this.$message.error("请先勾选要导出的企业");
        return;
      }
      var param = {
        ids: this.exportList.map(function (item) {
          return item.id;
        })
      };
      this.exportLoading = true;
      _index.API_User.exportCompanyExcel(param).then(function (res) {
        if (res.data.type && res.data.type.indexOf("json") > -1) {
          var reader = new FileReader();
          reader.onload = function () {
            var result = JSON.parse(reader.result);
            _this3.$message.error(result.message || "导出失败");
          };
          reader.readAsText(res.data);
        } else {
          var blob = new Blob([res.data], {
            type: "application/vnd.ms-excel"
          });
          var fileName = "目标客户池_" + Date.now() + ".xls";
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
          _this3.$message.success("导出成功");
        }
        _this3.exportLoading = false;
      }).catch(function (err) {
        _this3.$message.error("导出失败，请稍后重试！");
        _this3.exportLoading = false;
      });
    },
    batchImport: function batchImport() {
      this.$refs.clearFileModal.click();
    },
    importCompanyFile: function importCompanyFile(fileEvent) {
      var _this4 = this;

      var file = fileEvent.target.files[0];
      if (!file) {
        this.$message.error("请选择文件！");
        return;
      }
      if (!/\.(xls|xlsx)$/i.test(file.name)) {
        this.$message.error("请选择xls或xlsx格式的文件！");
        this.$refs.clearFileModal.value = "";
        return;
      }

      var esc = function esc(val) {
        return String(val == null ? "" : val).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      };
      var formData = new FormData();
      formData.append("file", file);
      this.importLoading = true;
      _index.API_User.importCompanyExcel(formData).then(function (res) {
        console.log("导入接口返回：", res.data);
        var data = res.data || {};

        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch (e) {}
        }
        if (data.code == _index.API__code.SUCCESS) {
          var detail = data.data || {};

          if (typeof detail === "string") {
            try {
              detail = JSON.parse(detail);
            } catch (e) {
              detail = {};
            }
          }

          var failList = detail.faillist || detail.failList || [];
          if (failList.length > 0 || Number(detail.fail) > 0) {
            var html = "<div>" + esc(data.message) + "</div>";
            if (!failList.length) {
              html += "<div>失败数：" + esc(detail.fail) + "</div>";
            }
            failList.forEach(function (item) {
              html += "<div>第" + esc(item.rowNum) + "行 " + esc(item.companyName) + "，" + esc(item.reason) + "</div>";
            });
            _this4.$alert(html, "部分数据导入失败", {
              customClass: "import-fail-alert",
              dangerouslyUseHTMLString: true,
              confirmButtonText: "知道了"
            });
          } else {
            _this4.$message.success(data.message || "导入成功");
          }
          _this4.getList(1);
        } else {
          _this4.$message.error(data.message || "导入失败");
        }
        _this4.importLoading = false;
        _this4.$refs.clearFileModal.value = "";
      }).catch(function (err) {
        _this4.$message.error("导入失败，请稍后重试！");
        _this4.importLoading = false;
        _this4.$refs.clearFileModal.value = "";
      });
    },
    initSearchParams: function initSearchParams() {
      var _$route$query = this.$route.query,
          regionCode = _$route$query.regionCode,
          searchText = _$route$query.searchText,
          managerAdminuser = _$route$query.managerAdminuser,
          successfulManager = _$route$query.successfulManager,
          agencyManager = _$route$query.agencyManager,
          distributionStatus = _$route$query.distributionStatus,
          gradeValue = _$route$query.gradeValue;

      this.regionCode = regionCode || '';
      this.searchText = searchText || '';
      this.managerAdminuser = managerAdminuser || '';
      this.successfulManager = successfulManager || '';
      this.agencyManager = agencyManager || '';
      this.distributionStatus = distributionStatus || '';
      gradeValue = typeof gradeValue === 'number' ? gradeValue + '' : gradeValue;
      this.gradeValue = gradeValue ? gradeValue.split(',') : [];
    },
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    },
    querySearch: function querySearch(queryString, cb) {
      var comLists = this.comLists;
      var results = queryString ? comLists.filter(this.createFilter(queryString)) : comLists;

      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    loadCompany: function loadCompany() {
      this.getCompanySearch();
    },
    handleSelect: function handleSelect(item) {
      console.log("select==", this.addForm.name, item);
    },
    getCompanySearch: function getCompanySearch() {
      var _this5 = this;

      _index.API_User.getCompanySearch().then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var data = res.data.data;
          _this5.comLists = data.map(function (item) {
            return { value: item };
          });
          sessionStorage.setItem("comLists", (0, _stringify2.default)(_this5.comLists));
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: "loginAdmin" });
          }
        }
      }).catch(function (err) {});
    },
    checkCompany: function checkCompany(name) {
      return _index.API_User.checkCompanyUnique({ name: name }).then(function (res) {
        console.log("ressss--", res);
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    closedialog: function closedialog() {
      this.selected = {
        province: "320000",
        city: "320100",
        area: "320115",
        town: "320115010"
      };
      this.addForm.longitudeAndLatitude = "";
      this.addForm.addressInfo = "";
      this.addForm.managerAdminuser = "";
      this.imageUrl = "";
      this.beformAddImg = "";
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.addForm.managerAdminuser = value[0];
    },
    addAdmin: function addAdmin() {
      this.getUser();
      this.userSelection = [];
      this.orderVisible = true;
    },
    adminVisibleClose: function adminVisibleClose(type) {
      this.adminVisible = false;
      if (type == 1) {
        this.getList();
      }
    },
    handleUserSelectionChange: function handleUserSelectionChange(rowSelect) {
      var jc = [];
      var row = [];
      for (var p in rowSelect) {
        if (jc.indexOf(rowSelect[p].id) == -1) {
          jc.push(rowSelect[p].id);
          row.push(rowSelect[p]);
        }
      }
      this.userSelection = row;
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;
        this.imageUrl = URL.createObjectURL(file.raw);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error("请选择图片文件");
      }
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "id") {
          this.orderStr = "idpx";
        } else if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "managername") {
          this.orderStr = "managernamepx";
        } else if (val.prop == "showname") {
          this.orderStr = "shownamepx";
        } else if (val.prop == "regionCode") {
          this.orderStr = "regionCodepx";
        } else if (val.prop == "grade") {
          this.orderStr = "gradepx";
        } else if (val.prop == "natrue") {
          this.orderStr = "natruepx";
        } else if (val.prop == "userScale") {
          this.orderStr = "userScalepx";
        } else if (val.prop == "level") {
          this.orderStr = "levelpx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch2: function changeSouch2(val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName2 = this.souchs2.phone;
        this.disSouch = true;
      } else if (val == "姓名") {
        this.proName2 = this.souchs2.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName2 = this.souchs2.company;
        this.disSouch = true;
      } else if (val == "软件类型") {
        this.disSofttype = true;
      } else if (val == "邀请状态") {
        this.disinvit = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },
    handleClose2: function handleClose2(tag) {
      if (tag == "账号") {
        this.souchs2.phone = "";
        if (this.value2 == "账号") {
          this.proName2 = "";
        }
      }
      if (tag == "姓名") {
        this.souchs2.name = "";
        if (this.value2 == "姓名") {
          this.proName2 = "";
        }
      }
      if (tag == "企业") {
        this.souchs2.company = "";
        if (this.value2 == "企业") {
          this.proName2 = "";
        }
      }
      if (tag == "软件类型") {
        this.souchs2.softtype = "";
      }
      if (tag == "邀请状态") {
        this.souchs2.invitValue = "";
      }
      if (tag == "开始日期") {
        this.souchs2.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs2.totime = "";
      }
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1);
    },

    delTags2: function delTags2() {
      this.souchs2 = {};
      this.proName2 = "";
      this.value2 = "";
      this.dynamicTags2 = [];
      this.pageNumber2 = 1;
      this.getUser();
    },

    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getUser();
    },
    clickUserSelection: function clickUserSelection() {
      var _this = this;
      var list = (0, _assign2.default)([], this.userSelection);
      this.UserSelection = list;
      this.orderVisible = false;
    },

    orderUserSubmit: function orderUserSubmit(rows) {
      var _this6 = this;

      console.log(rows);
      var _this = this;

      var list = (0, _assign2.default)([], rows);

      var UserIds = [];
      for (var p in list) {
        UserIds.push(list[p].id);
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyId,
        userid: UserIds.toString()
      };
      _index.API_User.setCompanyManager(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this6.$message({
            message: "保存成功",
            type: "success"
          });
          _this6.adminVisible = false;
          _this6.getList();
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: "loginAdmin" });
          }
        }
      }).catch(function (err) {
        _this.$message.error("数据丢失，试试重新登陆！");
      });
    },
    changeFun: function changeFun(e, val) {
      if (!e) {
        this.checkUserId = "";
      }
      if (e && !this.flag) {
        this.checkUserId = this.checkUserIdOld;
      }
      this.flag = false;
    },
    handleSelectionChange: function handleSelectionChange(row) {
      this.flag = true;
      this.userList.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
        }
        if (item.id == row.id) {
          item.checked = true;
        }
      });
      if (row.name == null) {
        row.name = "";
      }
      if (row.phone == null) {
        row.phone = "";
      }
      this.checkUserId = row.id;
      this.checkUserIdOld = row.id;
    },

    getUser: function getUser(val) {
      var _this = this;
      if (this.value2 == "账号") {
        this.souchs2.phone = this.proName2;
      }
      if (this.value2 == "企业") {
        this.souchs2.company = this.proName2;
      }
      if (this.value2 == "姓名") {
        this.souchs2.name = this.proName2;
      }
      var flag2 = true;
      if (val == 1) {
        this.pageNumber2 = 1;
        if (this.value2) {
          if (this.dynamicTags2.length > 0) {
            for (var i = 0; i < this.dynamicTags2.length; i++) {
              if (this.value2 == this.dynamicTags2[i]) {
                flag2 = false;
              }
            }
          }
          if (flag2) {
            this.dynamicTags2.push(this.value2);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        listType: "page",
        userType: "",

        username: this.souchs2.name,
        phone: this.souchs2.phone,
        company: this.souchs2.company,
        registertimefrom: this.souchs2.fromtime,
        registertimeto: this.souchs2.totime,
        softtype: this.souchs2.softtype,
        invitestatus: this.souchs2.invitValue
      };
      _index.API_User.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            _this.total2 = res.data.data.totalRow;
            _this.userList = res.data.data.list;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: "loginAdmin" });
          }
        }
      }).catch(function (err) {
        _this.$message.error("数据丢失，试试重新登陆！");
      });
    },
    handleUser: function handleUser(index, row) {
      this.companyId = "";
      this.companyId = row.id;
      this.rname = "";
      this.rname = row.managerid;
      this.souchs2 = {}, this.dynamicTags2 = [];
      this.proName2 = "";
      this.value2 = "";
      this.adminList = [];
      this.adminVisible = true;
    },
    editSubmit: function editSubmit() {
      var _this = this;

      if (!this.editForm.name) {
        this.$message.error("请输入企业名称!");
        return;
      }

      if (!this.editImageUrl && !this.beformAddImg) {
        this.$message.error("请上传图片!");
        return;
      }

      if (this.beformAddImg) {
        var var_this = this;
        var formData = new FormData();
        formData.append("pic", this.beformAddImg.raw);
        formData.append("token", this.token);
        formData.append("checkCode", this.checkCode);
        formData.append("showpicid", this.editForm.showpicid);
        formData.append("mode", "save");
        var config = {
          "Content-Type": "multipart/form-data"
        };
        _axios2.default.post(this.upload.postURL, formData, config).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this.editSave(res.data.data);
            _this.$refs.upload.clearFiles();
          } else {
            _this.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this.$router.push({ path: "loginAdmin" });
            }
            return;
          }
        }).catch(function (error) {
          console.log(error);
          return;
        });
      } else {
        this.editSave();
      }
    },
    editSave: function editSave(val) {
      var _this7 = this;

      var param = void 0;
      if (val) {
        var newlbtPath = val.pic;
        var newId = val.id;
        param = {
          token: this.token,
          checkCode: this.checkCode,
          mode: "",
          id: this.editForm.id,
          name: this.editForm.name,
          logoid: newlbtPath,
          showpicid: newId,
          showname: this.editForm.showname
        };
      } else {
        param = {
          token: this.token,
          checkCode: this.checkCode,
          mode: "",
          id: this.editForm.id,
          name: this.editForm.name,
          showname: this.editForm.showname
        };
      }
      this.editLoading = true;
      _index.API_User.addCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this7.$message({
            message: "保存成功",
            type: "success"
          });
          _this7.getList();
          _this7.editFormVisible = false;
        } else {
          _this7.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this7.$router.push({ path: "loginAdmin" });
          }
        }
        _this7.editLoading = false;
      }).catch(function (err) {
        _this7.$message.error("数据丢失，试试重新登陆！");
        _this7.editLoading = false;
      });
    },

    addSubmit: function addSubmit() {
      var _this8 = this;

      var _this = this;
      this.$refs["addForm"].validate(function (valid) {
        if (valid) {
          if (_this8.addLoading) {
            return;
          }
          if (!_this8.beformAddImg) {
            _this8.$message.error("请上传图片!");
            return;
          }

          if (!_this8.addForm.longitudeAndLatitude) {
            _this8.$message.error("请在GIS地图中确认位置!");
            return;
          }

          if (!_this8.addForm.managerAdminuser) {
            _this8.$message.error("请选择客户经理");
            return;
          }

          _this8.addLoading = true;
          var formData = new FormData();
          formData.append("pic", _this8.beformAddImg.raw);
          formData.append("token", _this8.token);
          formData.append("checkCode", _this8.checkCode);
          formData.append("mode", "save");
          var config = {
            "Content-Type": "multipart/form-data"
          };

          _axios2.default.post(_this8.upload.postURL, formData, config).then(function (res) {
            if (res.data.code == _index.API__code.SUCCESS) {
              _this.addSubmit2(res.data.data);
              _this.$refs.upload.clearFiles();
            } else {
              _this.$message.error(res.data.message);
              if (res.data.code == 403) {
                _this.$router.push({ path: "loginAdmin" });
              }
              return;
            }
          }).catch(function (error) {
            console.log(error);
            return;
          });
        }
      });
    },
    addSubmit2: function addSubmit2(val) {
      var _this9 = this;

      var newlbtPath = val.pic;
      var newId = val.id;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: "save",
        name: this.addForm.name,
        logoid: newlbtPath,
        showpicid: newId,
        showname: this.addForm.showname,
        createUser: this.userInfo.id,
        province: this.addForm.province,
        city: this.addForm.city,
        district: this.addForm.district,
        longitudeAndLatitude: this.addForm.longitudeAndLatitude,
        addressInfo: this.addForm.addressInfo,
        managerAdminuser: this.addForm.managerAdminuser,
        isbinding: 0
      };
      _index.API_User.addCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this9.$message({
            message: "保存成功",
            type: "success"
          });
          _this9.getList();
          _this9.addFormVisible = false;
          _this9.resetForm("addForm");
        } else {
          _this9.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this9.$router.push({ path: "loginAdmin" });
          }
        }
        _this9.addLoading = false;
      }).catch(function (err) {
        _this9.$message.error("数据丢失，试试重新登陆！");
        _this9.addLoading = false;
      });
    },
    resetForm: function resetForm(formName) {
      this.imageUrl = "";
      this.editImageUrl = "";
      this.$refs[formName].resetFields();
    },
    handerClose: function handerClose(visibleFlag, formRef) {
      this[visibleFlag] = false;
      this.resetForm(formRef);
    },


    handleDel: function handleDel(index, row) {
      var _this10 = this;

      this.$confirm("确认删除吗?", "提示", {
        type: "warning"
      }).then(function () {
        var para = {
          token: _this10.token,
          checkCode: _this10.checkCode,
          id: row.id
        };
        _index.API_User.delCompanyList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this10.$message({
              message: "删除成功",
              type: "success"
            });
            _this10.getList();
          } else {
            _this10.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this10.$router.push({ path: "loginAdmin" });
            }
          }
        }).catch(function (err) {
          _this10.$message.error("数据丢失，试试重新登陆！");
        });
      }).catch(function (err) {});
    },
    handleCom: function handleCom(index, row) {
      var _query;

      this.$router.push({
        path: "/userCom",
        query: (_query = {
          companyId: row.id,
          managerId: row.managerid,
          companyName: row.name,
          isbinding: row.isbinding,
          dynamicTags: (0, _stringify2.default)(this.dynamicTags),
          souchs: (0, _stringify2.default)(this.souchs),
          searchText: this.searchText,
          distributionStatus: this.distributionStatus,
          managerAdminuser: this.managerAdminuser,
          status: this.status,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          regionCode: this.regionCode,
          successfulManager: this.successfulManager,
          agencyManager: this.agencyManager
        }, (0, _defineProperty3.default)(_query, "distributionStatus", this.distributionStatus), (0, _defineProperty3.default)(_query, "gradeValue", this.gradeValue.length ? this.gradeValue.join(',') : ''), _query)
      });
    },
    handleEdit: function handleEdit(index, row) {
      this.beformAddImg = "";
      this.editFormVisible = true;
      this.editImageUrl = row.pic;
      this.editForm = (0, _assign2.default)({}, row);

      this.editFormVisible = true;
    },
    handleAdd: function handleAdd() {
      this.$refs.targetcustomdialogRef.init();
    },
    delTags: function delTags() {
      this.souchs = {}, this.value = "";
      this.proName = "";
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == "ID") {
        this.souchs.id = "";
        if (this.value == "ID") {
          this.proName = "";
        }
      }
      if (tag == "企业名称") {
        this.souchs.company = "";
        if (this.value == "企业名称") {
          this.proName = "";
        }
      }
      if (tag == "管理员") {
        this.souchs.managername = "";
        if (this.value == "管理员") {
          this.proName = "";
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    changeSouch: function changeSouch(val) {
      if (val == "ID") {
        this.proName = this.souchs.id;
      } else if (val == "企业名称") {
        this.proName = this.souchs.company;
      } else if (val == "管理员") {
        this.proName = this.souchs.managername;
      }
    },
    getList: function getList(val) {
      var _this11 = this;

      this.needClearSel = val == 1;
      if (this.value == "ID") {
        this.souchs.id = this.proName;
      }
      if (this.value == "企业名称") {
        this.souchs.company = this.proName;
      }
      if (this.value == "管理员") {
        this.souchs.managername = this.proName;
      }
      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        listType: "page",
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        managename: this.souchs.managename,
        id: this.souchs.id,
        company: this.souchs.company,
        fpFlg: this.distributionStatus,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        managerAdminuser: this.managerAdminuser,
        searchText: this.searchText,
        status: 1,
        regionCode: this.regionCode,
        successfulManager: this.successfulManager,
        agencyManager: this.agencyManager,
        userType: this.userInfo.type,
        grade: this.gradeValue.length ? this.gradeValue.join(',') : ''
      };
      this.listLoading = true;

      _index.API_User.companyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data) {
            _this11.total = res.data.data.totalRow;
            _this11.proList = res.data.data.list;
            _this11.targetTotal = res.data.c1;
            _this11.qualityTotal = res.data.c2;
            _this11.collegesTotal = res.data.c4;
            if (_this11.needClearSel && _this11.$refs.companyTable) {
              _this11.$refs.companyTable.clearSelection();
            }
          }
        } else {
          _this11.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this11.$router.push({ path: "loginAdmin" });
          }
        }
        _this11.listLoading = false;
      }).catch(function (err) {
        _this11.$message.error("数据丢失，试试重新登陆！");
        _this11.listLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
      this.exportList = sels;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    },
    getCode1: function getCode1() {
      var _this12 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.yhlx = [];
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = {
              value: res.data.data[i].code,
              text: res.data.data[i].name
            };
            _this.yhlx.push(jsons);
            var json = {
              value: res.data.data[i].code,
              label: res.data.data[i].name
            };
            _this.softtypes.push(json);
          }
        } else {
          _this12.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this12.$router.push({ path: "loginAdmin" });
          }
        }
      });
    },
    getCode: function getCode() {
      var _this13 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = {
              value: res.data.data[i].code,
              label: res.data.data[i].name
            };
            _this.inviValues.push(jsons);
          }
        } else {
          _this13.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this13.$router.push({ path: "loginAdmin" });
          }
        }
      });
    },
    backPram: function backPram(param) {
      this.addForm.province = (0, _stringify2.default)(param.selected.province);
      this.addForm.city = (0, _stringify2.default)(param.selected.city);
      this.addForm.district = (0, _stringify2.default)(param.selected.area);
      this.addForm.longitudeAndLatitude = param.position.toString();
      this.addForm.addressInfo = param.address;
    }
  },
  mounted: function mounted() {
    console.log(this.$route.query.distributionStatus);
  },
  created: function created() {
    this.getCookie();

    this.initSearchParams();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _CompamySetting = __webpack_require__(408);

var _CompamySetting2 = _interopRequireDefault(_CompamySetting);

var _index = __webpack_require__(410);

var _index2 = _interopRequireDefault(_index);

var _Companyed = __webpack_require__(409);

var _Companyed2 = _interopRequireDefault(_Companyed);

var _index3 = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      activeIndex: '1',
      href: '',
      options: [{
        value: '1',
        label: '最近一个月'
      }, {
        value: '3',
        label: '最近三个月'
      }, {
        value: '6',
        label: '最近半年'
      }, {
        value: '12',
        label: '最近一年'
      }],
      value: '',
      count: 1,
      token: '',
      checkCode: ''
    };
  },

  components: {
    CompamySetting: _CompamySetting2.default,
    TrackManage: _index2.default,
    company: _Companyed2.default
  },
  created: function created() {
    this.getCookie();
    this.href = _index3.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    pointByHour: function pointByHour(val) {
      this.count = val;
      this.href = _index3.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
    },


    bak: function bak() {
      var _query;

      this.$router.push({
        path: '/company',
        query: (_query = {
          dynamicTags: this.$route.query.dynamicTags,
          souchs: this.$route.query.souchs,
          type: 1,
          pageNumber: this.$route.query.pageNumber,
          pageSize: this.$route.query.pageSize,
          companyName: this.$route.query.companyName,
          searchText: this.$route.query.searchText,
          status: this.$route.query.status,
          managerAdminuserName: this.$route.query.managerAdminuser,
          managerAdminuser: this.$route.query.managerAdminuser,
          distributionStatus: this.$route.query.distributionStatus,
          regionCode: this.$route.query.regionCode,
          successfulManager: this.$route.query.successfulManager,
          agencyManager: this.$route.query.agencyManager
        }, (0, _defineProperty3.default)(_query, 'distributionStatus', this.$route.query.distributionStatus), (0, _defineProperty3.default)(_query, 'gradeValue', this.$route.query.gradeValue), _query)
      });
    },

    handleSelect: function handleSelect(key, keyPath) {
      sessionStorage.setItem('admin_menu', key);
      this.activeIndex = key;
    }
  },

  mounted: function mounted() {
    var Index = sessionStorage.getItem('admin_menu');
    if (['7', '8'].includes(Index)) {
      this.activeIndex = Index;
    } else {
      this.activeIndex = '1';
    }
    sessionStorage.setItem('admin_menu', this.activeIndex);
  }
};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  data: function data() {
    return {
      currentDay: 1,

      currentWeek: 1,

      showDayNum: 42,
      days: [],
      class: "active",
      arrWeek: [],
      selectedWeek: [],
      options: [],
      children: [{
        value: "01",
        label: "1月"
      }, {
        value: "02",
        label: "2月"
      }, {
        value: "03",
        label: "3月"
      }, {
        value: "04",
        label: "4月"
      }, {
        value: "05",
        label: "5月"
      }, {
        value: "06",
        label: "6月"
      }, {
        value: "07",
        label: "7月"
      }, {
        value: "08",
        label: "8月"
      }, {
        value: "09",
        label: "9月"
      }, {
        value: "10",
        label: "10月"
      }, {
        value: "11",
        label: "11月"
      }, {
        value: "12",
        label: "12月"
      }],
      valueYearMonth: [],
      inspectionTimeCon: [],
      currentYear: '',
      currentMonth: '',
      loginRecord: 0,
      token: '',
      checkCode: ''
    };
  },

  props: {},
  watch: {},
  created: function created() {
    this.getCookie();

    var date = new Date();

    this.currentYear = date.getFullYear();
    this.currentMonth = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    console.log('this.currentYear==', this.currentYear);
    this.valueYearMonth = [this.currentYear, this.currentMonth + ""];

    for (var i = 3; i >= 0; i--) {
      var year = this.currentYear - i;
      this.options.push({
        value: year,
        label: year + '年',
        children: this.children
      });
    }


    this.getData();
  },
  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    getData: function getData() {
      var _this = this;

      var param = {
        month: this.valueYearMonth[1],
        year: this.valueYearMonth[0],
        userid: this.$route.query.userId,

        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.loginRecord(param).then(function (res) {
        if (res.data.code == 200) {
          _this.inspectionTimeCon = res.data.data;
          _this.loginRecord = res.data.sum;
          _this.initData(null);
        }
      });
    },
    handleChange: function handleChange(val) {
      console.log('val==', val);
      this.currentYear = val[0];
      this.currentMonth = val[1];
      this.valueYearMonth = val;
      console.log(this.currentMonth);
      this.getData();
    },

    initData: function initData(cur) {
      var leftcount = 0;
      var date;
      if (cur) {
        date = new Date(cur);
      } else {
        var now = new Date();
        var d = new Date(this.formatDate(this.currentYear, this.currentMonth - 1, 1));
        d.setDate(this.showDayNum);
        date = new Date(this.formatDate(this.currentYear, this.currentMonth, 1));
      }
      this.currentDay = date.getDate();

      this.currentWeek = date.getDay();
      var str = this.formatDate(this.currentYear, this.currentMonth, this.currentDay);
      this.days.length = 0;

      for (var i = this.currentWeek; i >= 0; i--) {
        var d = new Date(str);
        d.setDate(d.getDate() - i);
        var dayobject = {};
        dayobject.day = d;
        this.days.push(dayobject);
      }

      for (var i = 1; i < this.showDayNum - this.currentWeek; i++) {
        var d = new Date(str);
        d.setDate(d.getDate() + i);
        var dayobject = {};
        dayobject.day = d;
        this.days.push(dayobject);
      }
      this.days.splice(35, 7);
      this.shwoActiveDate(this.inspectionTimeCon);
    },
    pickYear: function pickYear(year, month) {
      alert(year + "," + month);
    },

    formatDate: function formatDate(year, month, day) {
      var y = year;
      var m = month;
      if (m < 10) m = "0" + m;
      var d = day;
      if (d < 10) d = "0" + d;
      return y + "-" + m + "-" + d;
    },

    cancelActive: function cancelActive() {
      var arr = this.$refs.dayLi;
      if (arr != undefined) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].getAttribute("class") == "active") {
            arr[i].setAttribute("class", "");
          }
        }
      }
      this.selectedWeek = [];
    },
    outputHeighLight: function outputHeighLight() {
      var arr = this.$refs.dayLi;
      var activeText = [];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].getAttribute("class") == "active") {
          var HeighLightDay = new Date(this.currentYear, this.currentMonth - 1, Number(arr[i].innerText));
          activeText.push(HeighLightDay);
        }
      }
      this.$emit("childByValue", activeText);
    },
    selectDay: function selectDay(event) {
      return;
      if (event.currentTarget.getAttribute("class") == "active") {
        event.currentTarget.setAttribute("class", "");
      } else {
        event.currentTarget.setAttribute("class", "active");
      }
      this.outputHeighLight();
    },
    interVal: function interVal(startNum, endNum, intervalNum) {
      var arr = this.$refs.dayLi;
      for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (Number(arr[i].innerText) > Number(arr[j].innerText)) {
            var t = arr[i];
            arr[i] = arr[j];
            arr[j] = t;
          }
        }
      }
      if (endNum > arr.length) endNum = arr.length;
      while (Number(startNum) <= Number(endNum)) {
        arr[startNum - 1].setAttribute("class", "active");
        startNum = Number(startNum) + Number(intervalNum) + Number(1);
      }
    },
    chooseWeek: function chooseWeek(arrWeek) {
      var arr = this.$refs.dayLi;
      for (var i = 0; i < arr.length; i++) {
        var t = new Date(this.currentYear, this.currentMonth - 1, Number(arr[i].innerText));

        if (arrWeek.indexOf(t.getDay()) != -1) {
          arr[i].setAttribute("class", "active");
        }
      }
    },
    shwoActiveDate: function shwoActiveDate(inspectionTimeCon) {
      var _this2 = this;

      this.$nextTick(function () {
        var list = [];
        for (var k = 0; k < inspectionTimeCon.length; k++) {
          var dateStr = inspectionTimeCon[k];
          list.push(dateStr);
        }

        var arr = _this2.$refs.dayLi;
        for (var i = 0; i < arr.length; i++) {
          for (var j = 0; j < list.length; j++) {
            if (_this2.currentYear + "-" + _this2.currentMonth + "-" + (arr[i].innerText < 10 ? '0' + arr[i].innerText : arr[i].innerText) == list[j]) {
              arr[i].setAttribute("class", "active");
            }
          }
        }
      });
    },
    formatDateGu: function formatDateGu(cellval) {
      var dateVal = cellval + "";
      if (cellval != null) {
        var date = new Date(cellval);
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

        var returnDate = date.getFullYear() + "-" + month + "-" + currentDate;
        return returnDate;
      }
    }
  }
};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(119);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['userid'],
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      value: "1",
      loading: false,
      options: [{
        value: "1",
        label: "最近一个月"
      }, {
        value: "3",
        label: "最近三个月"
      }, {
        value: "6",
        label: "最近半年"
      }, {
        value: "12",
        label: "最近一年"
      }],
      chartPie: [],
      legend: [],
      chartsXAxisTwo: [],
      chartsDataTwo: [],
      token: '',
      checkCode: ''
    };
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    getData: function getData() {
      this.adminModulePointPie();
    },
    adminModulePointPie: function adminModulePointPie(val) {
      var _this = this;

      var param = {
        count: this.value,
        userid: this.userid,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading = true;
      _index.API_Admin.pointByPerson(param).then(function (res) {
        if (res.data.code == 200) {
          _this.chartsXAxisTwo = res.data.data.x;
          _this.chartsDataTwo = res.data.data.y;
          _this.initCharts();
          _this.loading = false;
        }
      });
    },
    initCharts: function initCharts() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box"));
      charts.showLoading();
      charts.setOption({
        title: [{
          text: "积分统计",
          top: "top",
          left: "left",
          textStyle: {
            color: "#596471",
            fontSize: 18,
            fontWeight: 400,
            fontFamily: 'SourceHanSansCN'
          }
        }],
        tooltip: {
          trigger: "axis",
          position: function position(point, params, dom, rect, size) {
            if (size.viewSize[0] / 2 >= point[0]) {
              return [point[0], '10%'];
            } else {
              return [point[0] - 80, '10%'];
            }
          },
          formatter: function formatter(params) {
            return params[0].name + "<br/>" + params[0].seriesName + ": " + (params[0].value + "").replace(/\B(?=(?:\d{3})+\b)/g, ",") + "\u5206";
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        dataZoom: [{
          type: 'inside'
        }],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisTwo,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            },
            rotate: 20
          },
          splitArea: {}
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        series: [{
          name: "积分统计",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          itemStyle: {
            normal: {
              color: "#EF5350"
            }
          },
          areaStyle: {
            normal: {
              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#FFB87D"
              }, {
                offset: 1,
                color: "#ED7D76"
              }])
            }
          },
          data: this.chartsDataTwo,
          lineStyle: {
            normal: {
              color: "#EF5350"
            }
          }
        }]
      });
      charts.hideLoading();
      this.loading = false;
      window.addEventListener("resize", function () {
        charts.resize();
      });
    }
  }
};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Companyed = __webpack_require__(409);

var _Companyed2 = _interopRequireDefault(_Companyed);

var _Device = __webpack_require__(780);

var _Device2 = _interopRequireDefault(_Device);

var _WeProduct = __webpack_require__(781);

var _WeProduct2 = _interopRequireDefault(_WeProduct);

var _static = __webpack_require__(783);

var _static2 = _interopRequireDefault(_static);

var _system = __webpack_require__(784);

var _system2 = _interopRequireDefault(_system);

var _CompamySetting = __webpack_require__(408);

var _CompamySetting2 = _interopRequireDefault(_CompamySetting);

var _index = __webpack_require__(779);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(410);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            activeIndex: '',
            showCom: true,
            showDev: false,
            showWeP: false,
            showFx: false,
            showSystem: false,
            href: '',
            options: [{
                value: '1',
                label: '最近一个月'
            }, {
                value: '3',
                label: '最近三个月'
            }, {
                value: '6',
                label: '最近半年'
            }, {
                value: '12',
                label: '最近一年'
            }],
            value: '',
            count: 1,
            token: '',
            checkCode: ''
        };
    },

    components: {
        company: _Companyed2.default,
        device: _Device2.default,
        weProduct: _WeProduct2.default,
        Static: _static2.default,
        System: _system2.default,
        CompamySetting: _CompamySetting2.default,
        DepartManage: _index2.default,
        TrackManage: _index4.default
    },
    created: function created() {
        this.getCookie();
        this.href = _index5.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
    },

    methods: {
        getCookie: function getCookie() {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; ');
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('=');
                    if (arr2[0] == 'dnnyptadmin_token') {
                        this.token = arr2[1];
                    } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                        this.checkCode = arr2[1];
                    }
                }
            }
        },

        pointByHour: function pointByHour(val) {
            this.count = val;
            this.href = _index5.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
        },


        bak: function bak() {
            this.$router.push({
                path: '/officialCustom',
                query: {
                    dynamicTags: this.$route.query.dynamicTags,
                    souchs: this.$route.query.souchs,
                    type: 1,
                    pageNumber: this.$route.query.pageNumber,
                    pageSize: this.$route.query.pageSize,
                    companyName: this.$route.query.companyName,
                    searchText: this.$route.query.searchText,
                    status: this.$route.query.status,
                    managerAdminuserName: this.$route.query.managerAdminuser,
                    managerAdminuser: this.$route.query.managerAdminuser,
                    distributionStatus: this.$route.query.distributionStatus,
                    regionCode: this.$route.query.regionCode,
                    successfulManager: this.$route.query.successfulManager,
                    agencyManager: this.$route.query.agencyManager,
                    deadTime: this.$route.query.deadTime
                }
            });
        },
        handleSelect: function handleSelect(key, keyPath) {
            this.showCom = false;
            this.showWeP = false;
            this.showDev = false;
            this.showFx = false;
            this.showSystem = false;
            if (key == '1') {
                this.showCom = true;
                sessionStorage.setItem('admin_menu', '1');
            } else if (key == '2') {
                this.showWeP = true;
                sessionStorage.setItem('admin_menu', '2');
            } else if (key == '3') {
                this.showDev = true;
                sessionStorage.setItem('admin_menu', '3');
            } else if (key == '4') {
                this.showFx = true;
                sessionStorage.setItem('admin_menu', '4');
            } else if (key == '5') {
                this.showSystem = true;
                sessionStorage.setItem('admin_menu', '5');
            }
            sessionStorage.setItem('admin_menu', key);
            this.activeIndex = key;
        }
    },

    mounted: function mounted() {
        this.activeIndex = sessionStorage.getItem('admin_menu');
        this.activeIndex = this.activeIndex ? this.activeIndex : '1';
        if (this.activeIndex == '2') {
            this.showCom = false;
            this.showDev = false;
            this.showWeP = true;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 2);
        } else if (this.activeIndex == '3') {
            this.showDev = true;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 3);
        } else if (this.activeIndex == '4') {
            this.showDev = false;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = true;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 4);
        } else if (this.activeIndex == '5') {
            this.showDev = false;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = true;
            sessionStorage.setItem('admin_menu', 5);
        } else {
            this.showCom = true;
            this.showDev = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 1);
        }
        if (['6', '7', '8'].includes(this.activeIndex)) {
            this.showCom = false;
            this.showDev = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', this.activeIndex);
        }
    }
};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(107);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(106);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _GisCommon = __webpack_require__(167);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _addAdmin = __webpack_require__(782);

var _addAdmin2 = _interopRequireDefault(_addAdmin);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _SelectCommon = __webpack_require__(76);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _this2 = this,
        _ref2;

    var validatorCompany = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.addForm.name) {
                  _context.next = 4;
                  break;
                }

                callback("请输入企业名称");
                _context.next = 8;
                break;

              case 4:
                _context.next = 6;
                return _this2.checkCompany(_this2.addForm.name);

              case 6:
                res = _context.sent;

                !res ? callback('企业名称已存在') : callback();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function validatorCompany(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    return _ref2 = {
      beformAddImg: '',
      editImageUrl: '',
      adminVisible: false,
      imageUrl: '',
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: _index.API_Common.setCompanyPic(),
        dialogImageUrl: '',
        dialogVisible: false,
        data: {
          mode: 'save',
          token: this.token,
          checkCode: this.checkCode,
          type: 1
        }
      },

      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName2: '',
      dynamicTags2: [],
      optionsSouch2: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '软件类型', label: '软件类型' }, { value: '邀请状态', label: '邀请状态' }, { value: '开始日期', label: '开始日期' }, { value: '结束日期', label: '结束日期' }],
      value2: '',
      inviValues: [],
      softtypes: [],

      proName: '',
      dynamicTags: [],
      options: [{ value: 'ID', label: 'ID' }, { value: '企业名称', label: '企业名称' }, { value: '管理员', label: '管理员' }],
      value: '',

      rname: '',
      companyId: '',
      orderLoading: false,
      userLoading: false,
      orderVisible: false,
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      userList: [],
      souchs2: {
        name: '',
        phone: '',
        company: '',
        invitestatus: '',
        softtype: '',
        fromtime: '',
        totime: ''
      },
      flag: false,
      checkUserId: '',
      checkUserIdOld: '',
      token: this.token,
      checkCode: this.checkCode,
      id: this.id,
      souchs: {
        name: ''
      },
      total: 0,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 20,
      pageNumber: 1,
      proList: [],
      listLoading: false,
      sels: [],
      exportList: [],
      exportLoading: false,
      needClearSel: false,
      importLoading: false,

      addFormVisible: false,
      addLoading: false,
      addForm: {
        name: '',
        showname: '',
        province: '',
        city: '',
        district: '',
        longitudeAndLatitude: '',
        addressInfo: '',
        managerAdminuser: '',
        managerAdminuserName: ''
      },

      addFormRules: {
        name: [{ required: true, validator: validatorCompany, trigger: 'change' }],
        showname: [{ required: true, message: '请输入地区', trigger: 'blur' }]
      },

      editFormVisible: false,
      editLoading: false,
      editForm: {
        name: ''
      },
      editFormRules: {
        name: [{ required: true, message: '请输入企业名称', trigger: 'blur' }]
      },
      orderType: '',
      orderStr: '',

      userSelection: [],
      UserSelection: [],
      searchText: this.$route.query.searchText ? this.$route.query.searchText : '',
      selected: { province: '320000', city: '320100', area: '320115', town: '320115010' },
      address: '',

      comLists: [],

      status: this.$route.query.status ? this.$route.query.status : '',

      distributionStatus: this.$route.query.distributionStatus ? this.$route.query.distributionStatus : '',
      managerAdminuser: this.$route.query.managerAdminuserName,
      successfulManager: '',
      agencyManager: ''
    }, (0, _defineProperty3.default)(_ref2, 'total', 0), (0, _defineProperty3.default)(_ref2, 'levelTotal', 0), (0, _defineProperty3.default)(_ref2, 'tryTotal', 0), (0, _defineProperty3.default)(_ref2, 'collegesTotal', 0), (0, _defineProperty3.default)(_ref2, 'instituteTotal', 0), (0, _defineProperty3.default)(_ref2, 'regionCodeList', [{
      value: '1',
      label: '华东大区'
    }, {
      value: '2',
      label: '华北大区'
    }, {
      value: '3',
      label: '西北大区'
    }, {
      value: '4',
      label: '华南大区'
    }, {
      value: '5',
      label: '西南大区'
    }]), (0, _defineProperty3.default)(_ref2, 'regionCode', ''), (0, _defineProperty3.default)(_ref2, 'deadTime', ''), _ref2;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default,
    SelectCommon: _SelectCommon2.default,
    Admin: _addAdmin2.default,
    GisCommon: _GisCommon2.default
  },
  methods: {
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    },
    batchExport: function batchExport() {
      var _this3 = this;

      if (!this.exportList.length) {
        this.$message.error('请先勾选要导出的企业');
        return;
      }
      var param = {
        ids: this.exportList.map(function (item) {
          return item.id;
        })
      };
      this.exportLoading = true;
      _index.API_User.exportCompanyExcel(param).then(function (res) {
        if (res.data.type && res.data.type.indexOf('json') > -1) {
          var reader = new FileReader();
          reader.onload = function () {
            var result = JSON.parse(reader.result);
            _this3.$message.error(result.message || '导出失败');
          };
          reader.readAsText(res.data);
        } else {
          var blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          var fileName = '正式客户管理_' + Date.now() + '.xls';
          var elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
          _this3.$message.success('导出成功');
        }
        _this3.exportLoading = false;
      }).catch(function (err) {
        _this3.$message.error('导出失败，请稍后重试！');
        _this3.exportLoading = false;
      });
    },
    batchImport: function batchImport() {
      this.$refs.clearFileModal.click();
    },
    importCompanyFile: function importCompanyFile(fileEvent) {
      var _this4 = this;

      var file = fileEvent.target.files[0];
      if (!file) {
        this.$message.error('请选择文件！');
        return;
      }
      if (!/\.(xls|xlsx)$/i.test(file.name)) {
        this.$message.error('请选择xls或xlsx格式的文件！');
        this.$refs.clearFileModal.value = '';
        return;
      }

      var esc = function esc(val) {
        return String(val == null ? '' : val).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      };
      var formData = new FormData();
      formData.append('file', file);
      this.importLoading = true;
      _index.API_User.importCompanyExcel(formData).then(function (res) {
        console.log('导入接口返回：', res.data);
        var data = res.data || {};

        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (e) {}
        }
        if (data.code == _index.API__code.SUCCESS) {
          var detail = data.data || {};

          if (typeof detail === 'string') {
            try {
              detail = JSON.parse(detail);
            } catch (e) {
              detail = {};
            }
          }

          var failList = detail.faillist || detail.failList || [];
          if (failList.length > 0 || Number(detail.fail) > 0) {
            var html = '<div>' + esc(data.message) + '</div>';
            if (!failList.length) {
              html += '<div>失败数：' + esc(detail.fail) + '</div>';
            }
            failList.forEach(function (item) {
              html += '<div>第' + esc(item.rowNum) + '行 ' + esc(item.companyName) + '，' + esc(item.reason) + '</div>';
            });
            _this4.$alert(html, '部分数据导入失败', {
              customClass: 'import-fail-alert',
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了'
            });
          } else {
            _this4.$message.success(data.message || '导入成功');
          }
          _this4.getList(1);
        } else {
          _this4.$message.error(data.message || '导入失败');
        }
        _this4.importLoading = false;
        _this4.$refs.clearFileModal.value = '';
      }).catch(function (err) {
        _this4.$message.error('导入失败，请稍后重试！');
        _this4.importLoading = false;
        _this4.$refs.clearFileModal.value = '';
      });
    },
    querySearch: function querySearch(queryString, cb) {
      var comLists = this.comLists;
      var results = queryString ? comLists.filter(this.createFilter(queryString)) : comLists;

      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    loadCompany: function loadCompany() {
      this.getCompanySearch();
    },
    handleSelect: function handleSelect(item) {
      console.log('select==', this.addForm.name, item);
    },
    getCompanySearch: function getCompanySearch() {
      var _this5 = this;

      _index.API_User.getCompanySearch().then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var data = res.data.data;
          _this5.comLists = data.map(function (item) {
            return { value: item };
          });
          sessionStorage.setItem('comLists', (0, _stringify2.default)(_this5.comLists));
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {});
    },
    checkCompany: function checkCompany(name) {
      return _index.API_User.checkCompanyUnique({ name: name }).then(function (res) {
        console.log('ressss--', res);
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    closedialog: function closedialog() {
      this.selected = { province: '320000', city: '320100', area: '320115', town: '320115010' };
      this.addForm.longitudeAndLatitude = '';
      this.addForm.addressInfo = '';
      this.addForm.managerAdminuser = '';
      this.imageUrl = '';
      this.beformAddImg = '';
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.addForm.managerAdminuser = value[0];
    },
    addAdmin: function addAdmin() {
      this.getUser();
      this.userSelection = [];
      this.orderVisible = true;
    },
    adminVisibleClose: function adminVisibleClose(type) {
      this.adminVisible = false;
      if (type == 1) {
        this.getList();
      }
    },
    handleUserSelectionChange: function handleUserSelectionChange(rowSelect) {
      var jc = [];
      var row = [];
      for (var p in rowSelect) {
        if (jc.indexOf(rowSelect[p].id) == -1) {
          jc.push(rowSelect[p].id);
          row.push(rowSelect[p]);
        }
      }
      this.userSelection = row;
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;
        this.imageUrl = URL.createObjectURL(file.raw);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error('请选择图片文件');
      }
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == 'id') {
          this.orderStr = 'idpx';
        } else if (val.prop == 'name') {
          this.orderStr = 'namepx';
        } else if (val.prop == 'managername') {
          this.orderStr = 'managernamepx';
        } else if (val.prop == 'showname') {
          this.orderStr = 'shownamepx';
        } else if (val.prop == 'regionCode') {
          this.orderStr = 'regionCodepx';
        } else if (val.prop == 'grade') {
          this.orderStr = 'gradepx';
        } else if (val.prop == 'natrue') {
          this.orderStr = 'natruepx';
        } else if (val.prop == 'userScale') {
          this.orderStr = 'userScalepx';
        }
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
      }
      this.getList();
    },
    changeSouch2: function changeSouch2(val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == '账号') {
        this.proName2 = this.souchs2.phone;
        this.disSouch = true;
      } else if (val == '姓名') {
        this.proName2 = this.souchs2.name;
        this.disSouch = true;
      } else if (val == '企业') {
        this.proName2 = this.souchs2.company;
        this.disSouch = true;
      } else if (val == '软件类型') {
        this.disSofttype = true;
      } else if (val == '邀请状态') {
        this.disinvit = true;
      } else if (val == '开始日期') {
        this.disTime1 = true;
      } else if (val == '结束日期') {
        this.disTime2 = true;
      }
    },
    handleClose2: function handleClose2(tag) {
      if (tag == '账号') {
        this.souchs2.phone = '';
        if (this.value2 == '账号') {
          this.proName2 = '';
        }
      }
      if (tag == '姓名') {
        this.souchs2.name = '';
        if (this.value2 == '姓名') {
          this.proName2 = '';
        }
      }
      if (tag == '企业') {
        this.souchs2.company = '';
        if (this.value2 == '企业') {
          this.proName2 = '';
        }
      }
      if (tag == '软件类型') {
        this.souchs2.softtype = '';
      }
      if (tag == '邀请状态') {
        this.souchs2.invitValue = '';
      }
      if (tag == '开始日期') {
        this.souchs2.fromtime = '';
      }
      if (tag == '结束日期') {
        this.souchs2.totime = '';
      }
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1);
    },

    delTags2: function delTags2() {
      this.souchs2 = {};
      this.proName2 = '';
      this.value2 = '';
      this.dynamicTags2 = [];
      this.pageNumber2 = 1;
      this.getUser();
    },

    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getUser();
    },
    clickUserSelection: function clickUserSelection() {
      var _this = this;
      var list = (0, _assign2.default)([], this.userSelection);
      this.UserSelection = list;
      this.orderVisible = false;
    },

    orderUserSubmit: function orderUserSubmit(rows) {
      var _this6 = this;

      console.log(rows);
      var _this = this;

      var list = (0, _assign2.default)([], rows);

      var UserIds = [];
      for (var p in list) {
        UserIds.push(list[p].id);
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyId,
        userid: UserIds.toString()
      };
      _index.API_User.setCompanyManager(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this6.$message({
            message: '保存成功',
            type: 'success'
          });
          _this6.adminVisible = false;
          _this6.getList();
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    changeFun: function changeFun(e, val) {
      if (!e) {
        this.checkUserId = '';
      }
      if (e && !this.flag) {
        this.checkUserId = this.checkUserIdOld;
      }
      this.flag = false;
    },
    handleSelectionChange: function handleSelectionChange(row) {
      this.flag = true;
      this.userList.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
        }
        if (item.id == row.id) {
          item.checked = true;
        }
      });
      if (row.name == null) {
        row.name = '';
      }
      if (row.phone == null) {
        row.phone = '';
      }
      this.checkUserId = row.id;
      this.checkUserIdOld = row.id;
    },

    getUser: function getUser(val) {
      var _this = this;
      if (this.value2 == '账号') {
        this.souchs2.phone = this.proName2;
      }
      if (this.value2 == '企业') {
        this.souchs2.company = this.proName2;
      }
      if (this.value2 == '姓名') {
        this.souchs2.name = this.proName2;
      }
      var flag2 = true;
      if (val == 1) {
        this.pageNumber2 = 1;
        if (this.value2) {
          if (this.dynamicTags2.length > 0) {
            for (var i = 0; i < this.dynamicTags2.length; i++) {
              if (this.value2 == this.dynamicTags2[i]) {
                flag2 = false;
              }
            }
          }
          if (flag2) {
            this.dynamicTags2.push(this.value2);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        listType: 'page',
        userType: '',

        username: this.souchs2.name,
        phone: this.souchs2.phone,
        company: this.souchs2.company,
        registertimefrom: this.souchs2.fromtime,
        registertimeto: this.souchs2.totime,
        softtype: this.souchs2.softtype,
        invitestatus: this.souchs2.invitValue
      };
      _index.API_User.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            _this.total2 = res.data.data.totalRow;
            _this.userList = res.data.data.list;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    handleUser: function handleUser(index, row) {
      this.companyId = '';
      this.companyId = row.id;
      this.rname = '';
      this.rname = row.managerid;this.souchs2 = {}, this.dynamicTags2 = [];
      this.proName2 = '';
      this.value2 = '';
      this.adminList = [];
      this.adminVisible = true;
    },
    editSubmit: function editSubmit() {
      var _this = this;

      if (!this.editForm.name) {
        this.$message.error('请输入企业名称!');
        return;
      }

      if (!this.editImageUrl && !this.beformAddImg) {
        this.$message.error('请上传图片!');
        return;
      }

      if (this.beformAddImg) {
        var var_this = this;
        var formData = new FormData();
        formData.append('pic', this.beformAddImg.raw);
        formData.append('token', this.token);
        formData.append('checkCode', this.checkCode);
        formData.append('showpicid', this.editForm.showpicid);
        formData.append('mode', 'save');
        var config = {
          'Content-Type': 'multipart/form-data'
        };
        _axios2.default.post(this.upload.postURL, formData, config).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this.editSave(res.data.data);
            _this.$refs.upload.clearFiles();
          } else {
            _this.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this.$router.push({ path: 'loginAdmin' });
            }
            return;
          }
        }).catch(function (error) {
          console.log(error);
          return;
        });
      } else {
        this.editSave();
      }
    },
    editSave: function editSave(val) {
      var _this7 = this;

      var param = void 0;
      if (val) {
        var newlbtPath = val.pic;
        var newId = val.id;
        param = {
          token: this.token,
          checkCode: this.checkCode,
          mode: '',
          id: this.editForm.id,
          name: this.editForm.name,
          logoid: newlbtPath,
          showpicid: newId,
          showname: this.editForm.showname
        };
      } else {
        param = {
          token: this.token,
          checkCode: this.checkCode,
          mode: '',
          id: this.editForm.id,
          name: this.editForm.name,
          showname: this.editForm.showname
        };
      }
      this.editLoading = true;
      _index.API_User.addCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this7.$message({
            message: '保存成功',
            type: 'success'
          });
          _this7.getList();
          _this7.editFormVisible = false;
        } else {
          _this7.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this7.$router.push({ path: 'loginAdmin' });
          }
        }
        _this7.editLoading = false;
      }).catch(function (err) {
        _this7.$message.error('数据丢失，试试重新登陆！');
        _this7.editLoading = false;
      });
    },

    addSubmit: function addSubmit() {
      var _this8 = this;

      var _this = this;
      this.$refs['addForm'].validate(function (valid) {
        if (valid) {
          if (_this8.addLoading) {
            return;
          }
          if (!_this8.beformAddImg) {
            _this8.$message.error('请上传图片!');
            return;
          }

          if (!_this8.addForm.longitudeAndLatitude) {
            _this8.$message.error('请在GIS地图中确认位置!');
            return;
          }

          if (!_this8.addForm.managerAdminuser) {
            _this8.$message.error('请选择客户经理');
            return;
          }

          _this8.addLoading = true;
          var formData = new FormData();
          formData.append('pic', _this8.beformAddImg.raw);
          formData.append('token', _this8.token);
          formData.append('checkCode', _this8.checkCode);
          formData.append('mode', 'save');
          var config = {
            'Content-Type': 'multipart/form-data'
          };

          _axios2.default.post(_this8.upload.postURL, formData, config).then(function (res) {
            if (res.data.code == _index.API__code.SUCCESS) {
              _this.addSubmit2(res.data.data);
              _this.$refs.upload.clearFiles();
            } else {
              _this.$message.error(res.data.message);
              if (res.data.code == 403) {
                _this.$router.push({ path: 'loginAdmin' });
              }
              return;
            }
          }).catch(function (error) {
            console.log(error);
            return;
          });
        }
      });
    },
    addSubmit2: function addSubmit2(val) {
      var _this9 = this;

      var newlbtPath = val.pic;
      var newId = val.id;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        name: this.addForm.name,
        logoid: newlbtPath,
        showpicid: newId,
        showname: this.addForm.showname,
        createUser: this.userInfo.id,
        province: this.addForm.province,
        city: this.addForm.city,
        district: this.addForm.district,
        longitudeAndLatitude: this.addForm.longitudeAndLatitude,
        addressInfo: this.addForm.addressInfo,
        managerAdminuser: this.addForm.managerAdminuser,
        isbinding: 0
      };
      _index.API_User.addCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this9.$message({
            message: '保存成功',
            type: 'success'
          });
          _this9.getList();
          _this9.addFormVisible = false;
          _this9.resetForm('addForm');
        } else {
          _this9.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this9.$router.push({ path: 'loginAdmin' });
          }
        }
        _this9.addLoading = false;
      }).catch(function (err) {
        _this9.$message.error('数据丢失，试试重新登陆！');
        _this9.addLoading = false;
      });
    },
    resetForm: function resetForm(formName) {
      this.imageUrl = '';
      this.editImageUrl = '';
      this.$refs[formName].resetFields();
    },
    handerClose: function handerClose(visibleFlag, formRef) {
      this[visibleFlag] = false;
      this.resetForm(formRef);
    },


    handleDel: function handleDel(index, row) {
      var _this10 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var para = {
          token: _this10.token,
          checkCode: _this10.checkCode,
          id: row.id
        };
        _index.API_User.delCompanyList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this10.$message({
              message: '删除成功',
              type: 'success'
            });
            _this10.getList();
          } else {
            _this10.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this10.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this10.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    handleCom: function handleCom(index, row) {
      this.$router.push({
        path: '/officalView',
        query: {
          companyId: row.id,
          managerId: row.managerid,
          companyName: row.name,
          isbinding: row.isbinding,
          dynamicTags: (0, _stringify2.default)(this.dynamicTags),
          souchs: (0, _stringify2.default)(this.souchs),
          searchText: this.searchText,
          distributionStatus: this.distributionStatus,
          managerAdminuser: this.managerAdminuser,
          status: this.status,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          regionCode: this.regionCode,
          successfulManager: this.successfulManager,
          agencyManager: this.agencyManager,
          deadTime: this.deadTime
        }
      });
    },
    handleEdit: function handleEdit(index, row) {
      this.beformAddImg = '';
      this.editFormVisible = true;
      this.editImageUrl = row.pic;
      this.editForm = (0, _assign2.default)({}, row);

      this.editFormVisible = true;
    },
    handleAdd: function handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
      this.addLoading = false;
    },
    delTags: function delTags() {
      ;this.souchs = {}, this.value = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == 'ID') {
        this.souchs.id = '';
        if (this.value == 'ID') {
          this.proName = '';
        }
      }
      if (tag == '企业名称') {
        this.souchs.company = '';
        if (this.value == '企业名称') {
          this.proName = '';
        }
      }
      if (tag == '管理员') {
        this.souchs.managername = '';
        if (this.value == '管理员') {
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    changeSouch: function changeSouch(val) {
      if (val == 'ID') {
        this.proName = this.souchs.id;
      } else if (val == '企业名称') {
        this.proName = this.souchs.company;
      } else if (val == '管理员') {
        this.proName = this.souchs.managername;
      }
    },
    getList: function getList(val) {
      var _this11 = this;

      this.needClearSel = val == 1;
      if (this.value == 'ID') {
        this.souchs.id = this.proName;
      }
      if (this.value == '企业名称') {
        this.souchs.company = this.proName;
      }
      if (this.value == '管理员') {
        this.souchs.managername = this.proName;
      }
      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        managename: this.souchs.managename,
        id: this.souchs.id,
        company: this.souchs.company,
        fpFlg: this.distributionStatus,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        managerAdminuser: this.managerAdminuser,
        successfulManager: this.successfulManager,
        agencyManager: this.agencyManager,
        searchText: this.searchText,
        status: 3,
        regionCode: this.regionCode,
        deadTime: this.deadTime
      };
      this.listLoading = true;
      _index.API_User.companyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data) {
            _this11.total = res.data.data.totalRow;
            _this11.levelTotal = res.data.c2;
            _this11.tryTotal = res.data.c3;
            _this11.collegesTotal = res.data.c4;
            _this11.instituteTotal = res.data.c5;
            _this11.proList = res.data.data.list;
            if (_this11.needClearSel && _this11.$refs.companyTable) {
              _this11.$refs.companyTable.clearSelection();
            }
          }
        } else {
          _this11.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this11.$router.push({ path: 'loginAdmin' });
          }
        }
        _this11.listLoading = false;
      }).catch(function (err) {
        _this11.$message.error('数据丢失，试试重新登陆！');
        _this11.listLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref3) {
      var row = _ref3.row,
          column = _ref3.column,
          rowIndex = _ref3.rowIndex,
          columnIndex = _ref3.columnIndex;

      if (rowIndex == 0) {
        return 'background:#F5F7FA';
      } else {
        return '';
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
      this.exportList = sels;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    getCode1: function getCode1() {
      var _this12 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.yhlx = [];
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = {
              value: res.data.data[i].code,
              text: res.data.data[i].name
            };
            _this.yhlx.push(jsons);
            var json = {
              value: res.data.data[i].code,
              label: res.data.data[i].name
            };
            _this.softtypes.push(json);
          }
        } else {
          _this12.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this12.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    getCode: function getCode() {
      var _this13 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = {
              value: res.data.data[i].code,
              label: res.data.data[i].name
            };
            _this.inviValues.push(jsons);
          }
        } else {
          _this13.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this13.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    backPram: function backPram(param) {
      this.addForm.province = (0, _stringify2.default)(param.selected.province);
      this.addForm.city = (0, _stringify2.default)(param.selected.city);
      this.addForm.district = (0, _stringify2.default)(param.selected.area);
      this.addForm.longitudeAndLatitude = param.position.toString();
      this.addForm.addressInfo = param.address;
    },
    initDate: function initDate() {
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var statDateStart = myDate.getFullYear().toString() + month + "01";
      var dayEnd = new Date(myDate.getFullYear(), month, 0).getDate();
      var statDateEnd = myDate.getFullYear().toString() + '-' + month + '-' + dayEnd;
      console.log(statDateStart);
      console.log('statDateEnd--', statDateEnd);
      this.deadTime = statDateEnd;
    },
    initSearchParams: function initSearchParams() {
      var _$route$query = this.$route.query,
          regionCode = _$route$query.regionCode,
          searchText = _$route$query.searchText,
          managerAdminuser = _$route$query.managerAdminuser,
          successfulManager = _$route$query.successfulManager,
          agencyManager = _$route$query.agencyManager,
          deadTime = _$route$query.deadTime;

      this.regionCode = regionCode || '';
      this.searchText = searchText || '';
      this.managerAdminuser = managerAdminuser || '';
      this.successfulManager = successfulManager || '';
      this.agencyManager = agencyManager || '';
      if (deadTime) {
        this.deadTime = deadTime;
      }
    }
  },
  mounted: function mounted() {
    console.log(this.$route.query.distributionStatus);
  },
  created: function created() {
    this.getCookie();
    this.initDate();
    this.loadCompany();
    this.initSearchParams();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
    this.getCode();
    this.getCode1();
  }
};

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _GisCommon = __webpack_require__(167);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _SelectCommon = __webpack_require__(76);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _ref;

    return _ref = {
      proName: '',
      dynamicTags: [],
      value: '',
      rname: '',
      token: this.token,
      checkCode: this.checkCode,
      id: this.id,
      souchs: {
        name: ''
      },
      total: 0,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 20,
      pageNumber: 1,
      proList: [],
      listLoading: false,
      sels: [],
      exportList: [],
      exportLoading: false,
      needClearSel: false,
      importLoading: false,
      orderType: '',
      orderStr: '',
      userSelection: [],
      searchText: this.$route.query.searchText ? this.$route.query.searchText : '',
      address: '',
      comLists: [],
      status: this.$route.query.status ? this.$route.query.status : '',
      distributionStatus: this.$route.query.distributionStatus ? this.$route.query.distributionStatus : '',
      managerAdminuser: this.$route.query.managerAdminuserName,
      successfulManager: '',
      agencyManager: ''
    }, (0, _defineProperty3.default)(_ref, 'total', 0), (0, _defineProperty3.default)(_ref, 'levelTotal', 0), (0, _defineProperty3.default)(_ref, 'tryTotal', 0), (0, _defineProperty3.default)(_ref, 'collegesTotal', 0), (0, _defineProperty3.default)(_ref, 'instituteTotal', 0), (0, _defineProperty3.default)(_ref, 'regionCodeList', [{
      value: '1',
      label: '华东大区'
    }, {
      value: '2',
      label: '华北大区'
    }, {
      value: '3',
      label: '西北大区'
    }, {
      value: '4',
      label: '华南大区'
    }, {
      value: '5',
      label: '西南大区'
    }]), (0, _defineProperty3.default)(_ref, 'regionCode', ''), (0, _defineProperty3.default)(_ref, 'deadTime', ''), _ref;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default,
    SelectCommon: _SelectCommon2.default,
    GisCommon: _GisCommon2.default
  },
  methods: {
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    },
    batchExport: function batchExport() {
      var _this = this;

      if (!this.exportList.length) {
        this.$message.error('请先勾选要导出的企业');
        return;
      }
      var param = {
        ids: this.exportList.map(function (item) {
          return item.id;
        })
      };
      this.exportLoading = true;
      _index.API_User.exportCompanyExcel(param).then(function (res) {
        if (res.data.type && res.data.type.indexOf('json') > -1) {
          var reader = new FileReader();
          reader.onload = function () {
            var result = JSON.parse(reader.result);
            _this.$message.error(result.message || '导出失败');
          };
          reader.readAsText(res.data);
        } else {
          var blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          var fileName = '试用客户管理_' + Date.now() + '.xls';
          var elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
          _this.$message.success('导出成功');
        }
        _this.exportLoading = false;
      }).catch(function (err) {
        _this.$message.error('导出失败，请稍后重试！');
        _this.exportLoading = false;
      });
    },
    batchImport: function batchImport() {
      this.$refs.clearFileModal.click();
    },
    importCompanyFile: function importCompanyFile(fileEvent) {
      var _this2 = this;

      var file = fileEvent.target.files[0];
      if (!file) {
        this.$message.error('请选择文件！');
        return;
      }
      if (!/\.(xls|xlsx)$/i.test(file.name)) {
        this.$message.error('请选择xls或xlsx格式的文件！');
        this.$refs.clearFileModal.value = '';
        return;
      }

      var esc = function esc(val) {
        return String(val == null ? '' : val).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      };
      var formData = new FormData();
      formData.append('file', file);
      this.importLoading = true;
      _index.API_User.importCompanyExcel(formData).then(function (res) {
        console.log('导入接口返回：', res.data);
        var data = res.data || {};

        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (e) {}
        }
        if (data.code == _index.API__code.SUCCESS) {
          var detail = data.data || {};

          if (typeof detail === 'string') {
            try {
              detail = JSON.parse(detail);
            } catch (e) {
              detail = {};
            }
          }

          var failList = detail.faillist || detail.failList || [];
          if (failList.length > 0 || Number(detail.fail) > 0) {
            var html = '<div>' + esc(data.message) + '</div>';
            if (!failList.length) {
              html += '<div>失败数：' + esc(detail.fail) + '</div>';
            }
            failList.forEach(function (item) {
              html += '<div>第' + esc(item.rowNum) + '行 ' + esc(item.companyName) + '，' + esc(item.reason) + '</div>';
            });
            _this2.$alert(html, '部分数据导入失败', {
              customClass: 'import-fail-alert',
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了'
            });
          } else {
            _this2.$message.success(data.message || '导入成功');
          }
          _this2.getList(1);
        } else {
          _this2.$message.error(data.message || '导入失败');
        }
        _this2.importLoading = false;
        _this2.$refs.clearFileModal.value = '';
      }).catch(function (err) {
        _this2.$message.error('导入失败，请稍后重试！');
        _this2.importLoading = false;
        _this2.$refs.clearFileModal.value = '';
      });
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == 'id') {
          this.orderStr = 'idpx';
        } else if (val.prop == 'name') {
          this.orderStr = 'namepx';
        } else if (val.prop == 'managername') {
          this.orderStr = 'managernamepx';
        } else if (val.prop == 'showname') {
          this.orderStr = 'shownamepx';
        } else if (val.prop == 'regionCode') {
          this.orderStr = 'regionCodepx';
        } else if (val.prop == 'grade') {
          this.orderStr = 'gradepx';
        } else if (val.prop == 'natrue') {
          this.orderStr = 'natruepx';
        } else if (val.prop == 'userScale') {
          this.orderStr = 'userScalepx';
        }
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
      }
      this.getList();
    },

    handleDel: function handleDel(index, row) {
      var _this3 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var para = {
          token: _this3.token,
          checkCode: _this3.checkCode,
          id: row.id
        };
        _index.API_User.delCompanyList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this3.$message({
              message: '删除成功',
              type: 'success'
            });
            _this3.getList();
          } else {
            _this3.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this3.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this3.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },

    handleCom: function handleCom(index, row) {
      this.$router.push({
        path: '/probationView',
        query: {
          companyId: row.id,
          managerId: row.managerid,
          companyName: row.name,
          isbinding: row.isbinding,
          dynamicTags: (0, _stringify2.default)(this.dynamicTags),
          souchs: (0, _stringify2.default)(this.souchs),
          searchText: this.searchText,
          distributionStatus: this.distributionStatus,
          managerAdminuser: this.managerAdminuser,
          status: this.status,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          regionCode: this.regionCode,
          successfulManager: this.successfulManager,
          agencyManager: this.agencyManager,
          deadTime: this.deadTime
        }
      });
    },

    getList: function getList(val) {
      var _this4 = this;

      this.needClearSel = val == 1;
      if (this.value == 'ID') {
        this.souchs.id = this.proName;
      }
      if (this.value == '企业名称') {
        this.souchs.company = this.proName;
      }
      if (this.value == '管理员') {
        this.souchs.managername = this.proName;
      }
      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        listType: 'page',
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        managename: this.souchs.managename,
        id: this.souchs.id,
        company: this.souchs.company,
        fpFlg: this.distributionStatus,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        managerAdminuser: this.managerAdminuser,
        successfulManager: this.successfulManager,
        agencyManager: this.agencyManager,
        searchText: this.searchText,
        status: 2,
        regionCode: this.regionCode,
        deadTime: this.deadTime
      };
      this.listLoading = true;
      _index.API_User.companyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data) {
            _this4.total = res.data.data.totalRow;
            _this4.levelTotal = res.data.c2;
            _this4.tryTotal = res.data.c3;
            _this4.collegesTotal = res.data.c4;
            _this4.instituteTotal = res.data.c5;
            _this4.proList = res.data.data.list;
            if (_this4.needClearSel && _this4.$refs.companyTable) {
              _this4.$refs.companyTable.clearSelection();
            }
          }
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
        _this4.listLoading = false;
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
        _this4.listLoading = false;
      });
    },

    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return 'background:#F5F7FA';
      } else {
        return '';
      }
    },


    selsChange: function selsChange(sels) {
      this.sels = sels;
      this.exportList = sels;
    },

    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },

    initDate: function initDate() {
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var statDateStart = myDate.getFullYear().toString() + month + "01";
      var dayEnd = new Date(myDate.getFullYear(), month, 0).getDate();
      var statDateEnd = myDate.getFullYear().toString() + '-' + month + '-' + dayEnd;
      console.log(statDateStart);
      console.log('statDateEnd--', statDateEnd);
      this.deadTime = statDateEnd;
    },
    initSearchParams: function initSearchParams() {
      var _$route$query = this.$route.query,
          regionCode = _$route$query.regionCode,
          searchText = _$route$query.searchText,
          managerAdminuser = _$route$query.managerAdminuser,
          successfulManager = _$route$query.successfulManager,
          agencyManager = _$route$query.agencyManager,
          distributionStatus = _$route$query.distributionStatus,
          gradeValue = _$route$query.gradeValue,
          deadTime = _$route$query.deadTime;

      this.regionCode = regionCode || '';
      this.searchText = searchText || '';
      this.managerAdminuser = managerAdminuser || '';
      this.successfulManager = successfulManager || '';
      this.agencyManager = agencyManager || '';
      if (deadTime) {
        this.deadTime = deadTime;
      }
    }
  },
  mounted: function mounted() {
    console.log(this.$route.query.distributionStatus);
  },
  created: function created() {
    this.getCookie();
    this.initSearchParams();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.initDate();
    this.getList();
  }
};

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Companyed = __webpack_require__(409);

var _Companyed2 = _interopRequireDefault(_Companyed);

var _Device = __webpack_require__(780);

var _Device2 = _interopRequireDefault(_Device);

var _WeProduct = __webpack_require__(781);

var _WeProduct2 = _interopRequireDefault(_WeProduct);

var _static = __webpack_require__(783);

var _static2 = _interopRequireDefault(_static);

var _system = __webpack_require__(784);

var _system2 = _interopRequireDefault(_system);

var _CompamySetting = __webpack_require__(408);

var _CompamySetting2 = _interopRequireDefault(_CompamySetting);

var _index = __webpack_require__(779);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(410);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            activeIndex: '',
            showCom: true,
            showDev: false,
            showWeP: false,
            showFx: false,
            showSystem: false,
            href: '',
            options: [{
                value: '1',
                label: '最近一个月'
            }, {
                value: '3',
                label: '最近三个月'
            }, {
                value: '6',
                label: '最近半年'
            }, {
                value: '12',
                label: '最近一年'
            }],
            value: '',
            count: 1,
            token: '',
            checkCode: ''
        };
    },

    components: {
        company: _Companyed2.default,
        device: _Device2.default,
        weProduct: _WeProduct2.default,
        Static: _static2.default,
        System: _system2.default,
        CompamySetting: _CompamySetting2.default,
        DepartManage: _index2.default,
        TrackManage: _index4.default
    },
    created: function created() {
        this.getCookie();
        this.href = _index5.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
    },

    methods: {
        getCookie: function getCookie() {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; ');
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('=');
                    if (arr2[0] == 'dnnyptadmin_token') {
                        this.token = arr2[1];
                    } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                        this.checkCode = arr2[1];
                    }
                }
            }
        },

        pointByHour: function pointByHour(val) {
            this.count = val;
            this.href = _index5.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
        },


        bak: function bak() {
            this.$router.push({
                path: '/probationCustom',
                query: {
                    dynamicTags: this.$route.query.dynamicTags,
                    souchs: this.$route.query.souchs,
                    type: 1,
                    pageNumber: this.$route.query.pageNumber,
                    pageSize: this.$route.query.pageSize,
                    companyName: this.$route.query.companyName,
                    searchText: this.$route.query.searchText,
                    status: this.$route.query.status,
                    managerAdminuserName: this.$route.query.managerAdminuser,
                    managerAdminuser: this.$route.query.managerAdminuser,
                    distributionStatus: this.$route.query.distributionStatus,
                    regionCode: this.$route.query.regionCode,
                    successfulManager: this.$route.query.successfulManager,
                    agencyManager: this.$route.query.agencyManager
                }
            });
        },
        handleSelect: function handleSelect(key, keyPath) {
            this.showCom = false;
            this.showWeP = false;
            this.showDev = false;
            this.showFx = false;
            this.showSystem = false;
            if (key == '1') {
                this.showCom = true;
                sessionStorage.setItem('admin_menu', '1');
            } else if (key == '2') {
                this.showWeP = true;
                sessionStorage.setItem('admin_menu', '2');
            } else if (key == '3') {
                this.showDev = true;
                sessionStorage.setItem('admin_menu', '3');
            } else if (key == '4') {
                this.showFx = true;
                sessionStorage.setItem('admin_menu', '4');
            } else if (key == '5') {
                this.showSystem = true;
                sessionStorage.setItem('admin_menu', '5');
            }
            sessionStorage.setItem('admin_menu', key);
            this.activeIndex = key;
        }
    },

    mounted: function mounted() {
        this.activeIndex = sessionStorage.getItem('admin_menu');
        this.activeIndex = this.activeIndex ? this.activeIndex : '1';
        if (this.activeIndex == '2') {
            this.showCom = false;
            this.showDev = false;
            this.showWeP = true;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 2);
        } else if (this.activeIndex == '3') {
            this.showDev = true;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 3);
        } else if (this.activeIndex == '4') {
            this.showDev = false;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = true;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 4);
        } else if (this.activeIndex == '5') {
            this.showDev = false;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = true;
            sessionStorage.setItem('admin_menu', 5);
        } else {
            this.showCom = true;
            this.showDev = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 1);
        }
        if (['6', '7', '8'].includes(this.activeIndex)) {
            this.showCom = false;
            this.showDev = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', this.activeIndex);
        }
    }
};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(119);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['userid'],
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      value: "1",
      loading: false,
      options: [{
        value: "1",
        label: "最近一个月"
      }, {
        value: "3",
        label: "最近三个月"
      }, {
        value: "6",
        label: "最近半年"
      }, {
        value: "12",
        label: "最近一年"
      }],
      chartPie: [],
      legend: [],
      checkCode: '',
      token: ''
    };
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    getData: function getData() {
      this.adminModulePointPieCopy();
    },
    adminModulePointPieCopy: function adminModulePointPieCopy(val) {
      var _this = this;

      var param = {
        count: this.value,
        userid: this.userid,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading = true;
      _index.API_Admin.getUserModulePointPie(param).then(function (res) {
        if (res.data.code == 200) {
          var list = [];
          var data = res.data.data;
          var legend = [];
          for (var p in data) {
            list.push({ name: data[p].modulename, value: data[p].sumpoint });
            legend.push(data[p].modulename);
          }
          _this.chartPie = list;
          _this.legend = legend;
          _this.initCharts();
          _this.loading = false;
        }
      });
    },
    initCharts: function initCharts() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-copy-lpie"));
      charts.showLoading();
      charts.setOption({
        title: {
          text: "模块使用情况分析",
          top: "top",
          left: "left",
          textStyle: {
            color: "#596471",
            fontSize: 18,
            fontWeight: 400,
            fontFamily: 'SourceHanSansCN'
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "horizontal",
          left: 10,
          data: this.legend,
          bottom: 0
        },
        series: [{
          name: "模块使用情况分析",
          type: "pie",
          radius: "55%",
          center: ["50%", "45%"],
          data: this.chartPie,
          emphasis: {

            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          },
          label: {
            show: true,
            color: 'black',
            formatter: function formatter(params) {
              return params.value;
            }
          }
        }],
        color: ['#FF6383', '#FF9F40', '#FFCB48', '#5C89FF', '#7C6AF2', '#C95FF2']
      });
      charts.hideLoading();
    }
  }
};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

var _targetCustomDialog = __webpack_require__(777);

var _targetCustomDialog2 = _interopRequireDefault(_targetCustomDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	mixins: [_fitTableHeight2.default],
	data: function data() {
		return {
			listLoading: false,
			options: [{
				value: '选项1',
				label: '黄金糕'
			}, {
				value: '选项2',
				label: '双皮奶'
			}, {
				value: '选项3',
				label: '蚵仔煎'
			}, {
				value: '选项4',
				label: '龙须面'
			}, {
				value: '选项5',
				label: '北京烤鸭'
			}],
			souchs: {
				value1: '',
				value2: '',
				value3: '',
				input: ''
			},

			tableData: [{
				date: '2016-05-02',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1518 弄'
			}, {
				date: '2016-05-04',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1517 弄'
			}, {
				date: '2016-05-01',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1519 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}],
			pageNumber: 1,
			pageSize: 10,
			total: 50
		};
	},

	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

	components: {
		BaseContainer: _BaseContainer2.default,
		TargetCustomDialog: _targetCustomDialog2.default
	},

	mounted: function mounted() {},

	methods: {
		check: function check() {
			console.log('check');
		},
		add: function add() {
			console.log('add');
			this.$refs.targetcustomdialogRef.init();
		},
		indexMethod: function indexMethod(index) {
			return index + 1;
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.pageNumber = val;
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
		},
		getRowClass: function getRowClass(_ref) {
			var row = _ref.row,
			    column = _ref.column,
			    rowIndex = _ref.rowIndex,
			    columnIndex = _ref.columnIndex;

			if (rowIndex == 0) {
				return 'background:#F5F7FA';
			} else {
				return '';
			}
		},
		handleSortChange: function handleSortChange(val) {
			console.log('handleSortChange', val);
		}
	}
};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(107);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(106);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = __webpack_require__(19);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _SelectCommon = __webpack_require__(76);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _GisCommon = __webpack_require__(167);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _this2 = this;

    var validatorCompany = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.addForm.name) {
                  _context.next = 4;
                  break;
                }

                callback("请输入企业名称");
                _context.next = 8;
                break;

              case 4:
                _context.next = 6;
                return _this2.checkCompany(_this2.addForm.name);

              case 6:
                res = _context.sent;

                !res ? callback("企业名称已存在") : callback();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function validatorCompany(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    var validatorLevel = function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(rule, value, callback) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (value === 0) {
                  callback("请选择企业分级");
                } else {
                  callback();
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function validatorLevel(_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }();
    var validatorAddress = function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(rule, value, callback) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this2.addForm.addressInfo) {
                  callback("请输入企业位置");
                } else {
                  if (!_this2.addForm.longitudeAndLatitude) {
                    callback("请在GIS地图中确认位置");
                  } else {
                    callback();
                  }
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function validatorAddress(_x7, _x8, _x9) {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      dialogVisible: false,
      addLoading: false,
      selected: {
        province: "320000",
        city: "320100",
        area: "320115",
        town: "320115010"
      },
      address: "",
      managerAdminuser: "",
      successfulManager: "",
      agencyManager: "",
      addForm: {
        name: "",
        showname: "",
        level: 0,
        natrue: "",
        userScale: "",
        province: "",
        city: "",
        district: "",
        longitudeAndLatitude: "",
        addressInfo: "",
        linker: "",
        linkerPhone: "",
        remarks: ""
      },
      regionCodeList: [{
        value: "1",
        label: "华东大区"
      }, {
        value: "2",
        label: "华北大区"
      }, {
        value: "3",
        label: "西北大区"
      }, {
        value: "4",
        label: "华南大区"
      }, {
        value: "5",
        label: "西南大区"
      }],
      gradeList: [{
        value: "1",
        label: "综合甲"
      }, {
        value: "2",
        label: "公路甲"
      }, {
        value: "3",
        label: "市政甲"
      }, {
        value: "4",
        label: "公路市政甲"
      }, {
        value: "5",
        label: "公路乙"
      }, {
        value: "6",
        label: "市政乙"
      }, {
        value: "7",
        label: "公路市政乙"
      }, {
        value: "9",
        label: "高校"
      }, {
        value: "10",
        label: "施工单位"
      }, {
        value: "8",
        label: "其他"
      }],
      natureList: [{
        value: "1",
        label: "央企"
      }, {
        value: "2",
        label: "国企"
      }, {
        value: "3",
        label: "民营上市"
      }, {
        value: "4",
        label: "民营"
      }, {
        value: "5",
        label: "高校"
      }],
      addFormRules: {
        name: [{ required: true, validator: validatorCompany, trigger: "change" }],
        showname: [{
          required: true,
          message: "请输入地区",
          trigger: ["blur", "change"]
        }],
        regionCode: [{
          required: true,
          message: "请选择大区代号",
          trigger: ["blur", "change"]
        }],
        grade: [{
          required: true,
          message: "请选择资质等级",
          trigger: ["blur", "change"]
        }],
        natrue: [{
          required: true,
          message: "请选择企业性质",
          trigger: ["blur", "change"]
        }],
        userScale: [{
          required: true,
          message: "请输入用户规模",
          trigger: ["blur", "change"]
        }],
        addressInfo: [{
          required: true,
          message: "请输入客户地址",
          trigger: ["blur", "change"]
        }],
        level: [{
          required: true,
          validator: validatorLevel,
          trigger: ["blur", "change"]
        }]
      },
      imageUrl: "",
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: _index.API_Common.setCompanyPic(),
        dialogImageUrl: "",
        dialogVisible: false,
        data: {
          mode: "save",
          token: this.token,
          checkCode: this.checkCode,
          type: 1
        }
      },
      beformAddImg: "",
      editImageUrl: ""
    };
  },

  components: {
    SelectCommon: _SelectCommon2.default,
    GisCommon: _GisCommon2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["userInfo"])),
  mounted: function mounted() {},
  created: function created() {
    this.getCookie();
  },


  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    },
    init: function init() {
      this.dialogVisible = true;
    },
    addSubmit: function addSubmit() {
      var _this3 = this;

      this.$refs["addForm"].validate(function (valid) {
        if (valid) {
          if (_this3.addLoading) return;
          _this3.addLoading = true;
          if (_this3.beformAddImg) {
            var _this = _this3;
            var formData = new FormData();
            formData.append("pic", _this3.beformAddImg.raw);
            formData.append("token", _this3.token);
            formData.append("checkCode", _this3.checkCode);
            formData.append("mode", "save");
            var config = {
              "Content-Type": "multipart/form-data"
            };

            _axios2.default.post(_this3.upload.postURL, formData, config).then(function (res) {
              if (res.data.code == _index.API__code.SUCCESS) {
                _this.addHandler(res.data.data);
                _this.$refs.upload.clearFiles();
              } else {
                _this.$message.error(res.data.message);
                if (res.data.code == 403) {
                  _this.$router.push({ path: "loginAdmin" });
                }
                return;
              }
            }).catch(function (error) {
              console.log(error);
              return;
            });
          } else {
            _this3.addHandler();
          }
        }
      });
    },
    addHandler: function addHandler(val) {
      var _this4 = this;

      if (val) {
        var newlbtPath = val.pic;
        var newId = val.id;
      }

      var param = (0, _extends3.default)({}, this.addForm, {
        logoid: newlbtPath,
        showpicid: newId,
        token: this.token,
        checkCode: this.checkCode,
        mode: "save",
        createUser: this.userInfo.id,
        addressInfo: this.addForm.addressInfo,
        managerAdminuser: this.managerAdminuser,
        successfulManager: this.successfulManager,
        agencyManager: this.agencyManager,
        isbinding: 0
      });
      _index.API_User.addCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: "保存成功",
            type: "success"
          });
          _this4.$emit("getList", 1);
          _this4.handleClose();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: "loginAdmin" });
          }
        }
        _this4.addLoading = false;
      }).catch(function (err) {
        _this4.$message.error("数据丢失，试试重新登陆！");
        _this4.addLoading = false;
      });
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs["addForm"].clearValidate();
      this.$refs["addForm"].resetFields();
    },
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    },
    backPram: function backPram(param) {
      this.addForm.province = (0, _stringify2.default)(param.selected.province);
      this.addForm.city = (0, _stringify2.default)(param.selected.city);
      this.addForm.district = (0, _stringify2.default)(param.selected.area);
      this.addForm.longitudeAndLatitude = param.position.toString();
      this.addForm.addressInfo = param.address;

      this.$refs["addForm"].validateField("addressInfo");
    },
    checkCompany: function checkCompany(name) {
      return _index.API_User.checkCompanyUnique({ name: name }).then(function (res) {
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;
        console.log("ile.raw", file.raw);
        this.imageUrl = URL.createObjectURL(file.raw);
        console.log("this.imageUrl", this.imageUrl);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error("请选择图片文件");
      }
    }
  }
};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var _charts = __webpack_require__(1723);

var _charts2 = _interopRequireDefault(_charts);

var _rightCharts = __webpack_require__(1728);

var _rightCharts2 = _interopRequireDefault(_rightCharts);

var _calender = __webpack_require__(1722);

var _calender2 = _interopRequireDefault(_calender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      textarea: "",
      listLoading: false,
      loginInfoLoading: false,
      notes: [],
      allcount: 0,
      token: "",
      checkCode: "",
      id: "",

      users: [],

      expired: 0,
      company: 0,

      sum: 0,
      showRecords: true,

      lastLogin_time: 0,
      lastLogin_location: "",
      infos: [],
      countNum: 0,
      phone: ""
    };
  },
  created: function created() {
    this.getCookie();
    this.getUserNote();
  },

  methods: {
    back: function back() {
      if (this.$route.query.shengfeng) {
        this.$router.push({
          path: "/activityWarn",
          query: {
            datanum: this.$route.query.datanum,
            zhanghao: this.$route.query.zhanghao,
            accountManager: this.$route.query.accountManager,
            pageNumber: this.$route.query.pageNumber,
            pageSize: this.$route.query.pageSize
          }
        });
      } else if (this.$route.query.jiangshi) {
        this.$router.push({
          path: "/dailyStatistics",
          query: {
            managerAdminuser: this.$route.query.managerAdminuser,
            pageNumber: this.$route.query.pageNumber,
            pageSize: this.$route.query.pageSize,
            jiangshi: 1
          }
        });
      } else {
        this.$router.push({
          path: "/account",
          query: {
            dynamicTags: this.$route.query.dynamicTags,
            souchs: this.$route.query.souchs,
            type: 1,
            pageNumber: this.$route.query.pageNumber,
            pageSize: this.$route.query.pageSize,
            searchName: this.$route.query.searchName,
            isCompanyUser: this.$route.query.isCompanyUser,
            fromtime: this.$route.query.fromtime,
            totime: this.$route.query.totime,
            managerAdminuser: this.$route.query.managerAdminuser,
            distributionStatus: this.$route.query.distributionStatus
          }
        });
      }
    },
    getData: function getData() {
      var _this2 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: 1,
        pageSize: 999,
        listType: "paged",
        userid: this.$route.query.userId
      };
      this.listLoading = true;
      _index.API_Admin.getList(param).then(function (res) {
        if (res.data.code == 200) {
          _this2.users = res.data.data;
          _this2.sum = res.data.data.length;
          _this2.expired = res.data.expired;
          _this2.company = res.data.company;
        }
        _this2.listLoading = false;
      }).catch(function (e) {
        _this2.listLoading = false;
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
          if (arr2[0] == "dnnyptadmin_token") {
            this.phone = arr2[1];
          }
        }
      }
      this.getData();

      if (this.$route.query.notShowRecords) {
        this.showRecords = false;
        return;
      }
      this.getLoginInfor();
    },
    handleDel: function handleDel(index, row) {
      var _this3 = this;

      this.$confirm("确认禁用吗?", "提示", {
        type: "warning"
      }).then(function () {
        var ids;
        ids = row.id;
        var param = {
          token: _this3.token,
          checkCode: _this3.checkCode,
          ids: ids,
          usingstatus: 3
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this3.$message({
              message: "禁用成功",
              type: "success"
            });
            _this3.getData();
          }
        }).catch(function (err) {
          _this3.$message.error("数据丢失，试试重新登陆！");
        });
      }).catch(function () {});
    },
    handleOpen: function handleOpen(index, row) {
      var _this4 = this;

      var _this = this;
      this.$confirm("确认启用吗?", "提示", {
        type: "warning"
      }).then(function () {
        var ids;
        ids = row.id;
        var param = {
          token: _this4.token,
          checkCode: _this4.checkCode,
          ids: ids,
          usingstatus: 1
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this4.$message({
              message: "启用成功",
              type: "success"
            });
            _this4.getData();
          }
        }).catch(function (err) {
          _this4.$message.error("数据丢失，试试重新登陆！");
        });
      }).catch(function () {});
    },
    addUserNote: function addUserNote() {
      var _this5 = this;

      if (this.textarea == "") {
        this.$message.error("数据不能为空");
      } else {
        var params = {
          token: this.token,
          checkCode: this.checkCode,
          note: this.textarea,
          userId: this.$route.query.userId
        };
        _index.API_Auth.addUserNote(params).then(function (res) {
          if (res.data.code == 200) {
            _this5.$message({
              message: "提交成功",
              type: "success"
            });
            _this5.textarea = "";
            _this5.getUserNote();
          }
        });
      }
    },
    getUserNote: function getUserNote() {
      var _this6 = this;

      var params = {
        token: this.token,
        checkCode: this.checkCode,
        userId: this.$route.query.userId
      };
      _index.API_Auth.getUserNote(params).then(function (res) {
        if (res.data.code == 200) {
          _this6.notes = res.data.data;
          _this6.allcount = res.data.data.length;
        }
      });
    },

    getLoginInfor: function getLoginInfor() {
      var _this7 = this;

      this.loginInfoLoading = true;
      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: this.$route.query.userId
      };
      _index.API_Man.getLoginInfor(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var arr = [];
          for (var i = 0; i < res.data.data.loginInfor.length; i++) {
            if (res.data.data.loginInfor[i].time) {
              res.data.data.loginInfor[i].date = res.data.data.loginInfor[i].time.substring(5, 10);
              res.data.data.loginInfor[i].date = res.data.data.loginInfor[i].date.replace(/-/g, "月") + "日";
              res.data.data.loginInfor[i].times = res.data.data.loginInfor[i].time.substring(11, 16);
            }
            if (arr.length > 0) {
              for (var k = 0; k < arr.length; k++) {
                if (res.data.data.loginInfor[i].date == arr[k]) {
                  res.data.data.loginInfor[i].date = "";
                }
              }
            }
            arr.push(res.data.data.loginInfor[i].date);
          }
          if (res.data.data.loginInfor.length > 0) {
            _this.lastLogin_time = res.data.data.loginInfor[0].time;
            _this.lastLogin_location = res.data.data.loginInfor[0].location;
          }
          _this.infos = res.data.data.loginInfor;
          _this.countNum = res.data.data.loginCount;
        }
        _this7.loginInfoLoading = false;
      }).catch(function (err) {
        _this7.loginInfoLoading = false;
        _this7.$message.error("数据丢失，试试重新登陆！");
      });
    }
  },
  components: {
    LeftCharts: _charts2.default,
    RightCharts: _rightCharts2.default,
    Calendar: _calender2.default
  }
};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      types: [{ value: "1", label: "系统管理员" }, { value: "2", label: "客户经理" }, { value: "3", label: "客户成功经理" }, { value: "4", label: "经销商" }],

      total: 0,
      pageNumber: 1,
      pageSize: 20,
      id: "",
      token: "",
      checkCode: "",
      users: [],
      listLoading: false,
      souchs: {},
      addFormVisible: false,
      addForm: {},
      addLoading: false,
      addFormRules: {
        user: [{ required: true, message: "请输入账号", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },

      editForm: {
        name: "",
        phone: "",
        type: "",
        password: "",
        conpassword: ""
      },
      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        user: [{ required: true, message: "请输入账号", trigger: "blur" }],
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        password: [{ required: false, message: "密码", trigger: "blur" }],
        conpassword: [{ required: false, message: "确认密码", trigger: "blur" }]
      }
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    editSubmit: function editSubmit() {
      var _this2 = this;

      this.$refs["editForm"].validate(function (valid) {
        if (valid) {
          _this2.editLoading = true;
          var param = {
            token: _this2.token,
            checkCode: _this2.checkCode,
            id: _this2.editForm.id,
            user: _this2.editForm.phone,
            name: _this2.editForm.name,
            type: _this2.editForm.type
          };
          if (_this2.editForm.password) {
            param.password = _this2.editForm.password;
            param.conpassword = _this2.editForm.conpassword;
          }
          _index.API_Admin.editAdmin(param).then(function (res) {
            if (res.data.code == _index.API__code.SUCCESS) {
              _this2.$message({
                message: "修改成功",
                type: "success"
              });
              _this2.editFormVisible = false;
              _this2.getUser();
            } else {
              _this2.$message.error(res.data.message);
              if (res.data.code == 403) {
                _this2.$router.push({ path: "loginAdmin" });
              }
            }
            _this2.editLoading = false;
          }).catch(function (err) {
            _this2.editLoading = false;
            _this2.$message.error("服务器异常，请您稍后再试..");
          });
        }
      });
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm.id = row.id;
      this.editForm.phone = row.phone;
      this.editForm.name = row.name;
      this.editForm.type = row.type;
    },

    handleDel: function handleDel(index, row) {
      var _this3 = this;

      this.$confirm("确认删除该用户吗?", "提示", {
        type: "warning"
      }).then(function () {
        var para = {
          id: row.id,
          token: _this3.token,
          checkCode: _this3.checkCode
        };
        _index.API_Admin.delAdmin(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this3.$message({
              message: "删除成功",
              type: "success"
            });
            _this3.getUser();
          } else {
            _this3.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this3.$router.push({ path: "loginAdmin" });
            }
          }
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this4 = this;

      this.$refs["addForm"].validate(function (valid) {
        if (valid) {
          var param = {
            token: _this4.token,
            checkCode: _this4.checkCode,
            user: _this4.addForm.user,
            password: _this4.addForm.password,
            name: _this4.addForm.name,
            type: _this4.addForm.type
          };
          _this4.addLoading = true;
          _index.API_Admin.setAdmin(param).then(function (res) {
            if (res.data.code == _index.API__code.SUCCESS) {
              _this4.$message({
                message: "新增成功",
                type: "success",
                center: true
              });

              _this4.addFormVisible = false;
              _this4.addForm = {};
              _this4.getUser();
            } else {
              _this4.$message.error(res.data.message);
              if (res.data.code == 403) {
                _this4.$router.push({ path: "loginAdmin" });
              }
            }
            _this4.addLoading = false;
          }).catch(function (err) {
            _this4.$message.error("服务器异常，请您稍后再试..");
            _this4.addLoading = false;
          });
        }
      });
    },
    closeAddform: function closeAddform() {
      this.$refs["addForm"].clearValidate();
    },
    closeeditForm: function closeeditForm() {
      this.$refs["editForm"].clearValidate();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },

    handleAdd: function handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "intime") {
          this.orderStr = "intimepx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getUser();
    },
    getUser: function getUser(val) {
      var _this5 = this;

      var _this = this;
      if (val == 1) {
        this.pageNumber = 1;
      }
      var param = {
        searchName: this.souchs.name,
        token: this.token,
        checkCode: this.checkCode,
        listType: "page",
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,

        orderStr: this.orderStr,
        orderType: this.orderType
      };
      this.listLoading = true;
      _index.API_Admin.getAdminList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            _this.total = res.data.data.totalRow;
          }
          _this.users = res.data.data.list;
          for (var i = 0; i < _this5.users.length; i++) {
            if (_this.users[i].phone == _this5.token) {
              _this.users[i].delShow = true;
            } else {
              _this.users[i].delShow = false;
            }

            if (_this.users[i].type == 1) {
              _this.users[i].types = "系统管理员";
            } else {
              _this.users[i].types = "普通管理员";
            }
          }
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: "loginAdmin" });
          }
        }
        _this5.listLoading = false;
      }).catch(function (err) {
        _this5.$message.error("服务器异常，请您稍后再试..");
        _this5.listLoading = false;
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getUser();
  }
};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      viewForm: {
        usename: '',
        phone: '',
        qq: '',
        company: '',
        adress: '',
        bumenzhiwei: ''
      },
      viewVisible: false,
      value: '',
      dynamicTags: [],
      options: [{ value: '姓名', label: '姓名' }, { value: '电话', label: '电话' }, { value: 'QQ', label: 'QQ' }, { value: '公司', label: '公司' }, { value: '部门职位', label: '部门职位' }, { value: '地址', label: '地址' }],
      souchs: {},
      proName: '',

      proList: [],
      token: '',
      checkCode: '',
      id: '',
      listLoading: false,
      pageNumber: 1,
      total: 0,
      pageSize: 20,
      orderType: "",
      orderStr: '',

      searchText: ''

    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },
  methods: {
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;


      if (row.status == '1') {
        return 'warning-row';
      }

      return '';
    },
    handleClose: function handleClose(tag) {
      if (tag == "姓名") {
        this.souchs.usename = '';
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "电话") {
        this.souchs.phone = '';
        if (this.value == "电话") {
          this.proName = '';
        }
      }
      if (tag == "QQ") {
        this.souchs.qq = '';
        if (this.value == "QQ") {
          this.proName = '';
        }
      }
      if (tag == "公司") {
        this.souchs.company = '';
        if (this.value == "公司") {
          this.proName = '';
        }
      }
      if (tag == "部门职位") {
        this.souchs.bumenzhiwei = '';
        if (this.value == "部门职位") {
          this.proName = '';
        }
      }
      if (tag == "地址") {
        this.souchs.adress = '';
        if (this.value == "地址") {
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    delTags: function delTags() {
      this.souchs = {}, this.value = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getProList(1);
    },
    changeSouch: function changeSouch(val) {
      if (val == "姓名") {
        this.proName = this.souchs.usename;
      } else if (val == "电话") {
        this.proName = this.souchs.phone;
      } else if (val == "QQ") {
        this.proName = this.souchs.qq;
      } else if (val == "公司") {
        this.proName = this.souchs.company;
      } else if (val == "部门职位") {
        this.proName = this.souchs.bumenzhiwei;
      } else if (val == "地址") {
        this.proName = this.souchs.adress;
      }
    },

    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "usename") {
          this.orderStr = "namepx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "qq") {
          this.orderStr = "qqpx";
        } else if (val.prop == "company") {
          this.orderStr = "companypx";
        } else if (val.prop == "bumenzhiwei") {
          this.orderStr = "bumenzhiweipx";
        } else if (val.prop == "adress") {
          this.orderStr = "adresspx";
        } else if (val.prop == "statusname") {
          this.orderStr = "statuspx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getProList();
    },
    handleEdit: function handleEdit(index, row) {
      var _this = this;

      this.$confirm('确认已处理该申请?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this.token,
          checkCode: _this.checkCode,
          id: row.id,
          status: 1,
          mode: 'update'
        };
        _index.API_trial.setList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this.$message({
              message: "已处理成功",
              type: 'success'
            });
            _this.getProList();
          } else {
            _this.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    handleView: function handleView(index, row) {
      this.viewVisible = true;
      this.viewForm = (0, _assign2.default)({}, row);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getProList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getProList();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },


    getProList: function getProList(val) {
      var _this2 = this;

      if (this.value == "姓名") {
        this.souchs.usename = this.proName;
      }
      if (this.value == "电话") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "QQ") {
        this.souchs.qq = this.proName;
      }
      if (this.value == "公司") {
        this.souchs.company = this.proName;
      }
      if (this.value == "部门职位") {
        this.souchs.bumenzhiwei = this.proName;
      }
      if (this.value == "地址") {
        this.souchs.adress = this.proName;
      }
      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,

        name: this.souchs.usename,
        phone: this.souchs.phone,
        qq: this.souchs.qq,
        company: this.souchs.company,
        bumenzhiwei: this.souchs.bumenzhiwei,
        adress: this.souchs.adress,

        orderStr: this.orderStr,
        orderType: this.orderType,
        searchText: this.searchText

      };
      this.listLoading = true;
      _index.API_trial.getList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.proList = res.data.data.list;
          _this2.total = res.data.data.totalRow;
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.listLoading = false;
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.getProList();
  },
  created: function created() {
    this.getCookie();
  }
};

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _detail = __webpack_require__(778);

var _detail2 = _interopRequireDefault(_detail);

var _SelectCommon = __webpack_require__(76);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _ref;

    return _ref = {
      adminVisible: false,
      detailOrderId: false,
      checkType: '',
      disCheckBox: false,
      checked: false,
      detailIDS: '',
      pruductJson: [],
      userid: '',
      allPrice: 0,
      orderUser: '',
      orderId: '',
      dataList2: [],
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      editlistLoading: false,
      editFormVisible: false,
      editLoading: false,
      editForm: {},
      ygPrice: 0
    }, (0, _defineProperty3.default)(_ref, 'allPrice', 0), (0, _defineProperty3.default)(_ref, 'disSouch', true), (0, _defineProperty3.default)(_ref, 'disType1', false), (0, _defineProperty3.default)(_ref, 'disType2', false), (0, _defineProperty3.default)(_ref, 'sels', []), (0, _defineProperty3.default)(_ref, 'sels1', []), (0, _defineProperty3.default)(_ref, 'sels3', []), (0, _defineProperty3.default)(_ref, 'token', ''), (0, _defineProperty3.default)(_ref, 'checkCode', ""), (0, _defineProperty3.default)(_ref, 'id', ""), (0, _defineProperty3.default)(_ref, 'listLoading', false), (0, _defineProperty3.default)(_ref, 'dataList', []), (0, _defineProperty3.default)(_ref, 'pageNumber', 1), (0, _defineProperty3.default)(_ref, 'pageSize', 20), (0, _defineProperty3.default)(_ref, 'total', 0), (0, _defineProperty3.default)(_ref, 'souchs', {
      id: '',
      phone: '',
      name: '',
      souType: '',
      status: ""
    }), (0, _defineProperty3.default)(_ref, 'proName', ''), (0, _defineProperty3.default)(_ref, 'options', [{ value: 'ID', label: 'ID' }, { value: '姓名', label: '姓名' }, { value: '手机号', label: '手机号' }, { value: '名称', label: '名称' }, { value: '企业', label: '企业' }, { value: '类型', label: '类型' }, { value: '状态', label: '状态' }]), (0, _defineProperty3.default)(_ref, 'value', ''), (0, _defineProperty3.default)(_ref, 'types', [{ value: '1', label: '试用' }, { value: '2', label: '正式' }]), (0, _defineProperty3.default)(_ref, 'types2', [{ value: '1', label: '正常使用' }, { value: '2', label: '到期' }, { value: '3', label: '禁用' }]), (0, _defineProperty3.default)(_ref, 'typeValue', ''), (0, _defineProperty3.default)(_ref, 'typeValue2', ''), (0, _defineProperty3.default)(_ref, 'dynamicTags', []), (0, _defineProperty3.default)(_ref, 'orderType', ""), (0, _defineProperty3.default)(_ref, 'orderStr', ''), (0, _defineProperty3.default)(_ref, 'searchText', ''), (0, _defineProperty3.default)(_ref, 'managerAdminuser', ''), _ref;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default,
    Detail: _detail2.default,
    SelectCommon: _SelectCommon2.default
  },

  methods: {
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.managerAdminuser = value[0];
    },


    checkboxOnclick: function checkboxOnclick() {
      if (this.checked) {
        this.disCheckBox = true;
      } else {
        this.disCheckBox = false;
      }
    },
    adminVisibleClose: function adminVisibleClose(type) {
      this.adminVisible = false;
    },
    handleAbout: function handleAbout(index, item) {
      console.log(item);
      this.detailOrderId = item.id;
      this.adminVisible = true;
    },

    priceloseF: function priceloseF() {
      if (this.allPrice) {
        if (isNaN(this.allPrice)) {
          this.allPrice = this.allPrice.replace(/[^\.\d]/g, '');
        }
        if (parseFloat(this.allPrice).toString() == "NaN") {
          this.$message.error("指标数为大于0的数, 请重新输入");
          return;
        } else if (this.allPrice < 0) {
          this.$message.error("指标数为大于0的数, 请重新输入");
          this.allPrice = 0;
          return;
        } else {
          this.allPrice = parseFloat(this.allPrice);
          this.allPrice = this.allPrice.toLocaleString();
        }
      } else {
        this.allPrice = 0;
        return;
      }
    },
    loseFcousMonth: function loseFcousMonth(index, row) {
      if (row.purchaseMonth) {
        var falg = this.isInteger(row.purchaseMonth);
        if (!falg) {
          this.$message.error('请输入月份为大于或等于0的整数!');
          return row.purchaseMonth = "";
        }
        if (row.purchaseMonth < 0) {
          this.$message.error('请输入月份为大于或等于0的整数!');
          return row.purchaseMonth = "";
        }
        this.ygPrice = 0;
        for (var i = 0; i < this.dataList2.length; i++) {
          if (this.dataList2[i].purchaseMonth && this.dataList2[i].price) {
            this.ygPrice = parseInt(this.ygPrice) + parseInt(this.dataList2[i].purchaseMonth) * parseInt(this.dataList2[i].price);
          }
        }
        if (this.ygPrice) {
          this.ygPrice = parseFloat(this.ygPrice);
          this.ygPrice = this.ygPrice.toLocaleString();
        }
      }
    },
    isInteger: function isInteger(obj) {
      obj = parseFloat(obj);
      return Math.floor(obj) === obj;
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        console.log(val);
        if (val.prop == "id") {
          this.orderStr = "idpx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "productname") {
          this.orderStr = "productnamepx";
        } else if (val.prop == "typename") {
          this.orderStr = "typepx";
        } else if (val.prop == "createtime") {
          this.orderStr = "createtimepx";
        } else if (val.prop == "duetime") {
          this.orderStr = "duetimepx";
        } else if (val.prop == "usingstatus") {
          this.orderStr = "statuspx";
        } else if (val.prop == "usercompany") {
          this.orderStr = "usercompanypx";
        } else if (val.prop == "effectivetime") {
          this.orderStr = "effectivetime";
        }

        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch: function changeSouch(val) {
      if (val == "类型") {
        this.disSouch = false;
        this.disType1 = true;
        this.disType2 = false;
        this.proName = '';
        this.typeValue = this.souchs.souType;
      } else if (val == "状态") {
        this.disSouch = false;
        this.disType1 = false;
        this.disType2 = true;
        this.proName = '';
        this.typeValue2 = this.souchs.status;
      } else if (val == "ID") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.id;
      } else if (val == "手机号") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.phone;
      } else if (val == "姓名") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.name;
      } else if (val == "名称") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.productname;
      } else if (val == "企业") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.usercompany;
      }
    },
    getList: function getList(val) {
      var _this2 = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      if (this.value == "ID") {
        this.souchs.id = this.proName;
      }
      if (this.value == "手机号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }
      if (this.value == "名称") {
        this.souchs.productname = this.proName;
      }
      if (this.value == "类型") {
        this.souchs.souType = this.typeValue;
      }
      if (this.value == "状态") {
        this.souchs.status = this.typeValue2;
      }
      if (this.value == "企业") {
        this.souchs.usercompany = this.proName;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        id: this.souchs.id,
        name: this.souchs.name,
        phone: this.souchs.phone,
        usercompany: this.souchs.usercompany,
        productname: this.souchs.productname,
        type: this.souchs.souType,
        status: this.souchs.status,
        orderType: this.orderType,
        orderStr: this.orderStr,
        accountType: 0,
        searchText: this.searchText,
        managerAdminuser: this.managerAdminuser,
        role: this.userInfo.type,
        userId: this.userInfo.id
      };
      this.listLoading = true;
      _index.API_Auth.getAutoList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].usingstatus == 1) {
              res.data.data.list[i].usingstatus1 = "正常使用";
            } else if (res.data.data.list[i].usingstatus == 3) {
              res.data.data.list[i].usingstatus1 = "禁用";
              res.data.data.list[i].usingstatus2 = true;
            } else if (res.data.data.list[i].usingstatus == 2) {
              res.data.data.list[i].usingstatus1 = "过期";
            }
          }
          _this2.dataList = res.data.data.list;
          _this2.total = res.data.data.totalRow;
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.listLoading = false;
      });
    },
    delTags: function delTags() {
      this.souchs = {}, this.souchs.souType = '';
      this.souchs.status = '';
      this.value = '';
      this.proName = '';
      this.typeValue = '';
      this.typeValue2 = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == "ID") {
        this.souchs.id = "";
        if (this.value == "ID") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs.name = "";
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "手机号") {
        this.souchs.phone = "";
        if (this.value == "手机号") {
          this.proName = '';
        }
      }
      if (tag == "名称") {
        this.souchs.productname = "";
        if (this.value == "名称") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.usercompany = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "类型") {
        this.souchs.souType = "";
        this.typeValue = '';
      }
      if (tag == "状态") {
        this.souchs.status = "";
        this.typeValue2 = '';
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    handleSizeChange2: function handleSizeChange2(val) {
      this.pageSize2 = val;
      this.handleEdit();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.handleEdit();
    },

    handleOpen: function handleOpen(index, row) {
      var _this3 = this;

      var _this = this;
      this.$confirm('确认启用吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var ids;
        if (row) {
          ids = row.id;
        } else {
          ids = _this.sels3.map(function (item) {
            return item.id;
          }).toString();
        }
        var param = {
          token: _this3.token,
          checkCode: _this3.checkCode,
          ids: ids,
          usingstatus: 1
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this3.$message({
              message: '启用成功',
              type: 'success'
            });
            _this3.getList();
          } else {
            _this3.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this3.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this3.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function () {});;
    },

    handleDel: function handleDel(index, row) {
      var _this4 = this;

      this.$confirm('确认禁用吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var ids;
        if (row) {
          ids = row.id;
        } else {
          ids = _this4.sels1.map(function (item) {
            return item.id;
          }).toString();
        }
        var param = {
          token: _this4.token,
          checkCode: _this4.checkCode,
          ids: ids,
          usingstatus: 3
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this4.$message({
              message: '禁用成功',
              type: 'success'
            });
            _this4.getList();
          } else {
            _this4.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this4.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this4.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function () {});;
    },
    handleEdit: function handleEdit(index, row) {
      this.allPrice = 0;
      this.ygPrice = 0;
      var ids2;

      if (!row) {
        for (var i = 0; i < this.sels.length; i++) {
          if (this.sels[0].phone != this.sels[i].phone) {
            this.$message.error('请选择同一用户下的订单！');
            return;
          }
        }
        this.userid = this.sels[0].userid;
        if (!this.sels[0].name || this.sels[0].name == null) {
          this.sels[0].name = "";
        }
        if (!this.sels[0].phone || this.sels[0].phone == null) {
          this.sels[0].phone = "";
        }
        this.orderUser = this.sels[0].name + "" + this.sels[0].phone;
        ids2 = this.sels.map(function (item) {
          return item.id;
        }).toString();
      } else {
        ids2 = row.id;
        this.userid = row.userid;
        this.orderUser = row.name + "" + row.phone;
      }


      this.getDetial(ids2);
      this.editFormVisible = true;
    },
    editSubmit: function editSubmit() {
      var _this5 = this;

      for (var i = 0; i < this.dataList2.length; i++) {
        if (!this.dataList2[i].purchaseMonth) {
          this.$message.error('列表中的续费时长(月)，不可为空！');
          return;
        }
      }

      if (!this.checked) {
        this.checkType = 2;
        if (!this.allPrice || this.allPrice == 0) {
          this.$message.error('总价不可为空或者0！');
          return;
        } else {
          if (isNaN(this.allPrice)) {
            this.allPrice = this.allPrice.replace(/[^\.\d]/g, '');
          }
        }
      } else {
        this.checkType = 1;
        this.allPrice = 0;
      }
      this.pruductJson = [];
      for (var i = 0; i < this.dataList2.length; i++) {
        var jsonid = [this.dataList2[i].id];
        var jsons = {
          "authorizedProductId": jsonid,
          "singlePrice": this.dataList2[i].price,
          "productId": this.dataList2[i].productid,
          "purchaseMonth": this.dataList2[i].purchaseMonth,
          "purchaseNum": "1",
          "productName": this.dataList2[i].name
        };
        this.pruductJson.push(jsons);
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: this.userid,
        price: this.allPrice,
        pruductJson: (0, _stringify2.default)(this.pruductJson),
        adminuserid: this.id,
        type: this.checkType
      };
      this.editLoading = true;
      _index.API_Auth.autoOrder(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.$message({
            message: '续费成功',
            type: 'success'
          });
          _this5.getList();
          _this5.editFormVisible = false;
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.editLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.editLoading = false;
      });
    },
    getDetial: function getDetial(ids) {
      var _this6 = this;

      this.detailIDS = ids;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        ids: ids
      };
      this.editlistLoading = true;
      _index.API_Auth.autoDetail(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].logo) {

              res.data.data[i].logo2 = res.data.data[i].logo;
            }
            if (res.data.data[i].price) {
              res.data.data[i].price = parseFloat(res.data.data[i].price);
              res.data.data[i].price2 = res.data.data[i].price.toLocaleString();
            }
          }

          _this6.dataList2 = res.data.data;
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
        _this6.editlistLoading = false;
      }).catch(function (err) {
        _this6.$message.error('数据丢失，试试重新登陆！');
        _this6.editlistLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    indexMethod2: function indexMethod2(index) {
      return index + 1 + (this.pageNumber2 - 1) * this.pageSize2;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(row) {
      this.sels1 = [];
      this.sels3 = [];
      for (var i = 0; i < row.length; i++) {
        if (row[i].usingstatus == "1") {
          var json1 = { "id": row[i].id };
          this.sels1.push(json1);
        }
        if (row[i].usingstatus == "3") {
          var json3 = { "id": row[i].id };
          this.sels3.push(json3);
        }
      }
      this.sels = row;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  created: function created() {
    this.getCookie();
  }
};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _detail = __webpack_require__(778);

var _detail2 = _interopRequireDefault(_detail);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _SelectCommon = __webpack_require__(76);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _ref;

    return _ref = {
      adminVisible: false,
      detailOrderId: false,
      checkType: '',
      disCheckBox: false,
      checked: false,
      detailIDS: '',
      pruductJson: [],
      companyid: '',
      allPrice: 0,
      orderUser: '',
      orderId: '',
      dataList2: [],
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      editlistLoading: false,
      editFormVisible: false,
      editLoading: false,
      editForm: {},
      ygPrice: 0
    }, (0, _defineProperty3.default)(_ref, 'allPrice', 0), (0, _defineProperty3.default)(_ref, 'disSouch', true), (0, _defineProperty3.default)(_ref, 'disType1', false), (0, _defineProperty3.default)(_ref, 'disType2', false), (0, _defineProperty3.default)(_ref, 'sels', []), (0, _defineProperty3.default)(_ref, 'sels1', []), (0, _defineProperty3.default)(_ref, 'sels3', []), (0, _defineProperty3.default)(_ref, 'token', ''), (0, _defineProperty3.default)(_ref, 'checkCode', ""), (0, _defineProperty3.default)(_ref, 'id', ""), (0, _defineProperty3.default)(_ref, 'listLoading', false), (0, _defineProperty3.default)(_ref, 'dataList', []), (0, _defineProperty3.default)(_ref, 'pageNumber', 1), (0, _defineProperty3.default)(_ref, 'pageSize', 20), (0, _defineProperty3.default)(_ref, 'total', 0), (0, _defineProperty3.default)(_ref, 'souchs', {
      id: '',
      phone: '',
      name: '',
      souType: '',
      status: ""
    }), (0, _defineProperty3.default)(_ref, 'proName', ''), (0, _defineProperty3.default)(_ref, 'options', [{ value: 'ID', label: 'ID' }, { value: '用户', label: '用户' }, { value: '手机号', label: '手机号' }, { value: '企业', label: '企业' }, { value: '名称', label: '名称' }, { value: '类型', label: '类型' }, { value: '状态', label: '状态' }]), (0, _defineProperty3.default)(_ref, 'value', ''), (0, _defineProperty3.default)(_ref, 'types', [{ value: '1', label: '试用' }, { value: '2', label: '正式' }]), (0, _defineProperty3.default)(_ref, 'types2', [{ value: '1', label: '正常使用' }, { value: '2', label: '到期' }, { value: '3', label: '禁用' }]), (0, _defineProperty3.default)(_ref, 'typeValue', ''), (0, _defineProperty3.default)(_ref, 'typeValue2', ''), (0, _defineProperty3.default)(_ref, 'dynamicTags', []), (0, _defineProperty3.default)(_ref, 'orderType', ""), (0, _defineProperty3.default)(_ref, 'orderStr', ''), (0, _defineProperty3.default)(_ref, 'searchText', ''), (0, _defineProperty3.default)(_ref, 'managerAdminuser', ''), _ref;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default,
    Detail: _detail2.default,
    SelectCommon: _SelectCommon2.default
  },

  methods: {
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.managerAdminuser = value[0];
    },
    adminVisibleClose: function adminVisibleClose(type) {
      this.adminVisible = false;
    },
    handleAbout: function handleAbout(index, item) {
      this.detailOrderId = item.id;
      this.adminVisible = true;
    },

    checkboxOnclick: function checkboxOnclick() {
      if (this.checked) {
        this.disCheckBox = true;
      } else {
        this.disCheckBox = false;
      }
    },
    priceloseF: function priceloseF() {
      if (this.allPrice) {
        if (isNaN(this.allPrice)) {
          this.allPrice = this.allPrice.replace(/[^\.\d]/g, '');
        }
        if (parseFloat(this.allPrice).toString() == "NaN") {
          this.$message.error("指标数为大于0的数, 请重新输入");
          return;
        } else if (this.allPrice < 0) {
          this.$message.error("指标数为大于0的数, 请重新输入");
          this.allPrice = 0;
          return;
        } else {
          this.allPrice = parseFloat(this.allPrice);
          this.allPrice = this.allPrice.toLocaleString();
        }
      } else {
        this.allPrice = 0;
        return;
      }
    },
    loseFcousMonth: function loseFcousMonth(index, row) {
      if (row.purchaseMonth) {
        var falg = this.isInteger(row.purchaseMonth);
        if (!falg) {
          this.$message.error('请输入月份为大于或等于0的整数!');
          return row.purchaseMonth = "";
        }
        if (row.purchaseMonth < 0) {
          this.$message.error('请输入月份为大于或等于0的整数!');
          return row.purchaseMonth = "";
        }
        this.ygPrice = 0;
        for (var i = 0; i < this.dataList2.length; i++) {
          if (this.dataList2[i].purchaseMonth && this.dataList2[i].price) {
            this.ygPrice = parseInt(this.ygPrice) + parseInt(this.dataList2[i].purchaseMonth) * parseInt(this.dataList2[i].price);
          }
        }
        if (this.ygPrice) {
          this.ygPrice = parseFloat(this.ygPrice);
          this.ygPrice = this.ygPrice.toLocaleString();
        }
      }
    },
    isInteger: function isInteger(obj) {
      obj = parseFloat(obj);
      return Math.floor(obj) === obj;
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "id") {
          this.orderStr = "idpx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "productname") {
          this.orderStr = "productnamepx";
        } else if (val.prop == "typename") {
          this.orderStr = "typepx";
        } else if (val.prop == "createtime") {
          this.orderStr = "createtimepx";
        } else if (val.prop == "duetime") {
          this.orderStr = "duetimepx";
        } else if (val.prop == "usingstatus1") {
          this.orderStr = "statuspx";
        } else if (val.prop == "userdeptname") {
          this.orderStr = "userdeptnamepx";
        }

        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch: function changeSouch(val) {
      if (val == "类型") {
        this.disSouch = false;
        this.disType1 = true;
        this.disType2 = false;
        this.proName = '';
        this.typeValue = this.souchs.souType;
      } else if (val == "状态") {
        this.disSouch = false;
        this.disType1 = false;
        this.disType2 = true;
        this.proName = '';
        this.typeValue2 = this.souchs.status;
      } else if (val == "ID") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.id;
      } else if (val == "手机号") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.phone;
      } else if (val == "用户") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.name;
      } else if (val == "名称") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.productname;
      } else if (val == '企业') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.companyname;
      } else if (val == '部门') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.userdeptname;
      }
    },
    getList: function getList(val) {
      var _this2 = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      if (this.value == "ID") {
        this.souchs.id = this.proName;
      }
      if (this.value == "手机号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "用户") {
        this.souchs.name = this.proName;
      }
      if (this.value == "名称") {
        this.souchs.productname = this.proName;
      }
      if (this.value == '企业') {
        this.souchs.companyname = this.proName;
      }
      if (this.value == '部门') {
        this.souchs.userdeptname = this.proName;
      }
      if (this.value == "类型") {
        this.souchs.souType = this.typeValue;
      }
      if (this.value == "状态") {
        this.souchs.status = this.typeValue2;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        id: this.souchs.id,
        name: this.souchs.name,
        phone: this.souchs.phone,
        productname: this.souchs.productname,
        companyname: this.souchs.companyname,
        userdeptname: this.souchs.userdeptname,
        type: this.souchs.souType,
        status: this.souchs.status,
        orderType: this.orderType,
        orderStr: this.orderStr,
        accountType: 1,
        searchText: this.searchText,
        managerAdminuser: this.managerAdminuser,
        role: this.userInfo.type,
        userId: this.userInfo.id
      };
      this.listLoading = true;
      _index.API_Auth.getAutoList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].usingstatus == 1) {
              res.data.data.list[i].usingstatus1 = "正常使用";
            } else if (res.data.data.list[i].usingstatus == 3) {
              res.data.data.list[i].usingstatus1 = "禁用";
              res.data.data.list[i].usingstatus2 = true;
            } else if (res.data.data.list[i].usingstatus == 2) {
              res.data.data.list[i].usingstatus1 = "过期";
            }
          }
          _this2.dataList = res.data.data.list;
          _this2.total = res.data.data.totalRow;
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.listLoading = false;
      });
    },
    delTags: function delTags() {
      this.souchs = {}, this.souchs.souType = '';
      this.souchs.status = '';
      this.value = '';
      this.proName = '';
      this.typeValue = '';
      this.typeValue2 = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == "ID") {
        this.souchs.id = "";
        if (this.value == "ID") {
          this.proName = '';
        }
      }
      if (tag == "用户") {
        this.souchs.name = "";
        if (this.value == "用户") {
          this.proName = '';
        }
      }
      if (tag == "手机号") {
        this.souchs.phone = "";
        if (this.value == "手机号") {
          this.proName = '';
        }
      }
      if (tag == "名称") {
        this.souchs.productname = "";
        if (this.value == "名称") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.companyname = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "部门") {
        this.souchs.userdeptname = "";
        if (this.value == "部门") {
          this.proName = '';
        }
      }
      if (tag == "类型") {
        this.souchs.souType = "";
        this.typeValue = '';
      }
      if (tag == "状态") {
        this.souchs.status = "";
        this.typeValue2 = '';
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    handleSizeChange2: function handleSizeChange2(val) {
      this.pageSize2 = val;
      this.handleEdit();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.handleEdit();
    },

    handleOpen: function handleOpen(index, row) {
      var _this3 = this;

      var _this = this;
      this.$confirm('确认启用吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var ids;
        if (row) {
          ids = row.id;
        } else {
          ids = _this.sels3.map(function (item) {
            return item.id;
          }).toString();
        }
        var param = {
          token: _this3.token,
          checkCode: _this3.checkCode,
          ids: ids,
          usingstatus: 1
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this3.$message({
              message: '启用成功',
              type: 'success'
            });
            _this3.getList();
          } else {
            _this3.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this3.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this3.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function () {});;
    },

    handleDel: function handleDel(index, row) {
      var _this4 = this;

      this.$confirm('确认禁用吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var ids;
        if (row) {
          ids = row.id;
        } else {
          ids = _this4.sels1.map(function (item) {
            return item.id;
          }).toString();
        }
        var param = {
          token: _this4.token,
          checkCode: _this4.checkCode,
          ids: ids,
          usingstatus: 3
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this4.$message({
              message: '禁用成功',
              type: 'success'
            });
            _this4.getList();
          } else {
            _this4.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this4.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this4.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function () {});;
    },
    handleEdit: function handleEdit(index, row) {
      this.allPrice = 0;
      this.ygPrice = 0;
      var ids2;
      var nameds = '';
      var phoneds = '';
      if (!row) {
        for (var i = 0; i < this.sels.length; i++) {
          if (this.sels[0].companyid != this.sels[i].companyid) {
            this.$message.error('请选择同一用企业的订单！');
            return;
          }
        }
        this.companyid = this.sels[0].companyid;
        if (!this.sels[0].name || this.sels[0].name == null) {
          this.sels[0].name = "";
        }
        if (!this.sels[0].phone || this.sels[0].phone == null) {
          this.sels[0].phone = "";
        }
        if (this.sels[0].name) {
          nameds = this.sels[0].name;
        }
        if (this.sels[0].phone) {
          phoneds = this.sels[0].phone;
        }
        this.orderUser = nameds + "" + phoneds;
        ids2 = this.sels.map(function (item) {
          return item.id;
        }).toString();
      } else {
        ids2 = row.id;
        this.companyid = row.companyid;
        if (row.name) {
          nameds = row.name;
        }
        if (row.phone) {
          phoneds = row.phone;
        }
        this.orderUser = nameds + "" + phoneds;
      }
      this.dataList2 = [];
      this.getDetial(ids2);
      this.editFormVisible = true;
    },
    editSubmit: function editSubmit() {
      var _this5 = this;

      for (var i = 0; i < this.dataList2.length; i++) {
        if (!this.dataList2[i].purchaseMonth) {
          this.$message.error('列表中的续费时长(月)，不可为空！');
          return;
        }
      }
      if (!this.checked) {
        this.checkType = 2;
        if (!this.allPrice || this.allPrice == 0) {
          this.$message.error('总价不可为空或者0！');
          return;
        } else {
          if (isNaN(this.allPrice)) {
            this.allPrice = this.allPrice.replace(/[^\.\d]/g, '');
          }
        }
      } else {
        this.checkType = 1;
        this.allPrice = 0;
      }
      this.pruductJson = [];
      for (var i = 0; i < this.dataList2.length; i++) {
        var jsonid = [this.dataList2[i].id];
        var jsons = {
          "authorizedProductId": jsonid,
          "singlePrice": this.dataList2[i].price,
          "productId": this.dataList2[i].productid,
          "purchaseMonth": this.dataList2[i].purchaseMonth,
          "purchaseNum": "1",
          "productName": this.dataList2[i].name
        };
        this.pruductJson.push(jsons);
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyid,
        price: this.allPrice,
        pruductJson: (0, _stringify2.default)(this.pruductJson),
        adminuserid: this.id,
        type: this.checkType
      };
      this.editLoading = true;
      _index.API_Auth.autoOrder(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.$message({
            message: '续费成功',
            type: 'success'
          });
          _this5.getList();
          _this5.editFormVisible = false;
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.editLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.editLoading = false;
      });
    },
    getDetial: function getDetial(ids) {
      var _this6 = this;

      this.detailIDS = ids;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        ids: ids
      };
      this.editlistLoading = true;
      _index.API_Auth.autoDetail(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].logo) {
              res.data.data[i].logo2 = res.data.data[i].logo;
            }
            if (res.data.data[i].price) {
              res.data.data[i].price = parseFloat(res.data.data[i].price);
              res.data.data[i].price2 = res.data.data[i].price.toLocaleString();
            }
          }

          _this6.dataList2 = res.data.data;
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
        _this6.editlistLoading = false;
      }).catch(function (err) {
        _this6.$message.error('数据丢失，试试重新登陆！');
        _this6.editlistLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    indexMethod2: function indexMethod2(index) {
      return index + 1 + (this.pageNumber2 - 1) * this.pageSize2;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(row) {
      this.sels1 = [];
      this.sels3 = [];
      for (var i = 0; i < row.length; i++) {
        if (row[i].usingstatus == "1") {
          var json1 = { "id": row[i].id };
          this.sels1.push(json1);
        }
        if (row[i].usingstatus == "3") {
          var json3 = { "id": row[i].id };
          this.sels3.push(json3);
        }
      }
      this.sels = row;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  created: function created() {
    this.getCookie();
  }
};

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  props: {
    adminVisible: {
      type: Boolean,
      default: false
    },
    authProductId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      userSelection: [],
      adminList: [],
      userLoading: false,
      orderLoading: false,
      token: '',
      checkCode: ''
    };
  },

  watch: {},
  mounted: function mounted() {
    this.getCookie();
    this.getCompanyManage();
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    adminVisibleClose: function adminVisibleClose() {
      this.$emit("adminVisibleClose");
    },
    getCompanyManage: function getCompanyManage(id) {
      var _this = this;

      var param = {
        authProductId: this.authProductId,
        token: this.token,
        checkCode: this.checkCode
      };
      this.userLoading = true;
      _index.API_Auth.getDetailByAuthProductId(param).then(function (res) {
        if (res.data.code == 200) {
          var list = JSON.parse(res.data.data.product);
          console.log(list);
          _this.adminList = list;
        }
        _this.userLoading = false;
      });
    }
  }
};

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _echarts = __webpack_require__(119);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['userGuishuPie'],
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      loading: true,
      chartPie: [],
      token: '',
      checkCode: '',
      otherList: [],
      numRecord: 0
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    'userGuishuPie': function userGuishuPie(val) {
      this.adminModulePointPie();
    }
  },
  methods: {
    adminModulePointPie: function adminModulePointPie(val) {

      var list = [];
      var data = this.userGuishuPie;
      var num = 0;
      for (var p in data) {
        num = num + data[p].value;
      }

      this.numRecord = num;


      this.chartPie = data;

      this.initCharts();
      this.loading = false;
    },
    initCharts: function initCharts() {
      var _this = this;
      var charts = null;

      var allcount = 0;
      var selected = {};
      for (var i = 0; i < this.chartPie.length; i++) {
        allcount += this.chartPie[i].value;
      }

      for (var _i = 0; _i < this.chartPie.length; _i++) {
        var name = this.chartPie[_i].name;
        selected[name] = this.chartPie[_i].value / allcount > 0.05;
      }
      charts = _echarts2.default.init(document.getElementById("charts-box-copy-lpie-census"));
      charts.showLoading();
      charts.setOption({
        title: {
          text: "用户手机号归属地统计",
          top: "top",
          left: "left",
          textStyle: {
            color: "#596471",
            fontSize: 17,
            fontWeight: 100
          }
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 0,
          top: 20,
          bottom: 0,
          selected: selected },
        series: [{
          name: "用户手机号归属地统计",
          type: "pie",
          radius: "20%",
          center: ["30%", "55%"],
          data: this.chartPie,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          },
          label: {
            show: true,
            color: 'black',
            fontSize: 10,
            formatter: function formatter(params) {
              return params.name + ": " + params.value;
            }
          },
          labelLine: {
            normal: (0, _defineProperty3.default)({
              length: 4
            }, "length", 12)
          }
        }],
        color: ['#FF6383', '#FFCB48', '#5C89FF', '#7C6AF2', '#C95FF2', '#52c41a', '#13c2c2', '#c41d7f', '#a0d911', '#f5222d', '#096dd9', '#a0d911', '#2f54eb', '#fa541c', '#fadb14', '#13c2c2', '#2f54eb']
      });
      charts.hideLoading();
    }
  }
};

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _echarts = __webpack_require__(119);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['userGuishuBar'],
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      chart: {
        x: ['2020-01', '2020-02', '2020-03', '2020-04', '2020-05', '2020-06', '2020-07'],
        y3: [150, 232, 201, 154, 190, 330, 410]
      },
      value: '1',
      loading: true,
      chartPie: [],
      token: '',
      checkCode: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    userGuishuBar: function userGuishuBar(val) {
      this.registerCount();
    }
  },
  methods: {
    registerCount: function registerCount(val) {
      this.chart.x = [];
      console.log(this.userGuishuBar);

      this.chart.x = this.userGuishuBar.x;
      this.chart.y3 = this.userGuishuBar.y;
      this.initBar();
      this.loading = false;
    },
    initBar: function initBar() {
      var echartsbar = _echarts2.default.init(document.getElementById('charts-box-copy-lbar-census'));
      echartsbar.clear();
      echartsbar.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' },
          formatter: '{b0}: {c0}人'
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '0',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: this.chart.x,
          axisLine: {
            lineStyle: {
              color: '#EBEBEB'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#6E6E6E'
            }
          }
        }],
        dataZoom: {
          type: 'inside',
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        yAxis: [(0, _defineProperty3.default)({
          type: 'value',
          splitLine: {
            show: false
          },
          axisTick: {
            show: false,
            alignWithLabel: false
          },
          axisLine: {
            lineStyle: {
              color: '#EBEBEB'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#596471'
            }
          }
        }, 'splitLine', {
          show: false
        })],
        series: [{
          name: '人数',
          type: 'bar',
          stack: '广告',
          data: this.chart.y3,
          barMaxWidth: 60
        }],
        color: ['#13c2c2']
      });
    }
  }
};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _echarts = __webpack_require__(119);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      chart: {
        x: []

      },
      value: "1",
      loading: false,
      options: [{
        value: "1",
        label: "最近一个月"
      }, {
        value: "3",
        label: "最近三个月"
      }, {
        value: "6",
        label: "最近半年"
      }, {
        value: "12",
        label: "最近一年"
      }],
      chartPie: [],
      firstLabelList: [],
      secondLabelList: [],
      pieList: [],
      token: "",
      checkCode: "",
      officalList: [],
      tryList: [] };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getCookie();
    this.getData();
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    getData: function getData() {
      this.registerCount();
    },
    registerCount: function registerCount(val) {
      var _this = this;

      var param = {
        count: this.value,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading = true;
      _index.API_control.registerCount(param).then(function (res) {
        if (res.data.code == 200) {
          _this.chart.x = res.data.data.x;
          var offical = [];
          var tryList = [];
          res.data.data.y.map(function (item) {
            var list = item.split(',');
            offical.push(list[0]);
            tryList.push(list[1]);
          });
          _this.officalList = offical;
          _this.tryList = tryList;
          _this.firstLabelList = [{ name: "正式授权(活跃)", value: res.data.proActiveCount }, { name: "正式授权(不活跃)", value: res.data.proInactiveCount }, { name: "总数", value: res.data.proCount }];
          _this.secondLabelList = [{ name: "试用授权(活跃)", value: res.data.testActiveCount }, { name: "试用授权(不活跃)", value: res.data.testInactiveCount }, { name: "总数", value: res.data.testCount }];
          _this.chartPie = [{ name: "正式授权(活跃)", value: res.data.proActiveCount }, { name: "正式授权(不活跃)", value: res.data.proInactiveCount }, { name: "试用授权(活跃)", value: res.data.testActiveCount }, { name: "试用授权(不活跃)", value: res.data.testInactiveCount }];
          _this.initCharts();
          _this.initBar();
          _this.loading = false;
        }
      });
    },
    initCharts: function initCharts() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-copy-l"));
      charts.showLoading();
      charts.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        title: {
          text: "注册用户情况统计",
          top: "top",
          left: "left",
          textStyle: {
            color: "#666666",
            fontSize: 16,
            fontWeight: 500
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "0%",
          containLabel: true
        },
        series: [{
          name: "注册用户情况统计",
          type: "pie",
          radius: ["40%", "58%"],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: "center"
            }
          },

          hoverAnimation: false,
          emphasis: {
            label: {
              show: true,
              formatter: function formatter(params) {
                return "{nm|" + params.data.name + "}" + "\n\n{p|" + params.data.value + "}";
              },
              rich: {
                p: {
                  fontSize: 20,
                  backgroundColor: "white",
                  color: "#666666",
                  fontWeight: "700"
                },
                nm: {
                  color: "#666666",
                  fontSize: 14,
                  backgroundColor: "white",
                  fontWeight: "400"
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          center: ["45%", "50%"],
          data: this.chartPie
        }],
        color: ["#669DF0", "#1D55AA", "#BE74D9", "#6D3780"]
      });
      charts.hideLoading();
      var index = 0;
      var myChart = charts;
      myChart.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: 0
      });
      myChart.on("mouseover", function (e) {
        if (e.dataIndex != index) {
          myChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: index
          });
        }
      });
      myChart.on("mouseout", function (e) {
        index = e.dataIndex;
        myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: e.dataIndex
        });
      });
    },
    initBar: function initBar() {
      var echartsbar = _echarts2.default.init(document.getElementById("charts-box-copy-lbar"));
      echartsbar.clear();
      echartsbar.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow" }
        },
        title: {
          text: "新注册用户统计",
          top: "top",
          left: "left",
          textStyle: {
            color: "#666666",
            fontSize: 16,
            fontWeight: 500
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "0",
          containLabel: true
        },
        xAxis: [{
          type: "category",
          data: this.chart.x,
          axisLine: {
            lineStyle: {
              color: "#EBEBEB"
            }
          },
          axisLabel: {
            show: true,


            textStyle: {
              color: "#6E6E6E"
            }
          }
        }],

        yAxis: [(0, _defineProperty3.default)({
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: false,
            alignWithLabel: false
          },
          axisLine: {
            lineStyle: {
              color: "#EBEBEB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        }, "splitLine", {
          show: false
        })],
        series: [{
          name: "正式用户",
          type: "bar",
          stack: "one",
          barMaxWidth: 24,
          data: this.officalList
        }, {
          name: "试用用户",
          type: "bar",
          stack: "one",
          barMaxWidth: 24,
          data: this.tryList
        }],

        dataZoom: {
          type: 'inside',
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        color: ["#669DF0", "#BE74D9"]
      });
    }
  }
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(119);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      value: "1",
      loading: false,
      options: [{
        value: "1",
        label: "最近一个月"
      }, {
        value: "3",
        label: "最近三个月"
      }, {
        value: "6",
        label: "最近半年"
      }, {
        value: "12",
        label: "最近一年"
      }],
      chartPie: [],
      legend: [],
      token: "",
      checkCode: "",
      colorList: ["#FF6383", "#FF9F40", "#FFCB48", "#5C89FF", "#7C6AF2", "#C95FF2", "#52c41a", "#13c2c2", "#c41d7f"]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getCookie();
    this.getData();
  },


  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    getData: function getData() {
      this.adminModulePointPie();
    },
    adminModulePointPie: function adminModulePointPie(val) {
      var _this = this;

      var param = {
        count: this.value,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading = true;
      _index.API_control.adminModulePointPie(param).then(function (res) {
        if (res.data.code == 200) {
          var list = [];
          var data = res.data.data;
          var legend = [];
          for (var p in data) {
            list.push({ name: data[p].modulename, value: data[p].sumpoint });
            legend.push(data[p].modulename);
          }

          list.map(function (item, index) {
            item.label = {
              formatter: function formatter(params) {
                return "{nm|" + params.data.name + "}" + "\n\n{zz|" + params.data.value + "}";
              },
              rich: {
                zz: {
                  align: "right",
                  fontSize: 16,
                  backgroundColor: "white",
                  color: _this.colorList[index],
                  fontWeight: "700"
                },
                nm: {
                  color: "#666666",
                  fontSize: 14,
                  backgroundColor: "white",
                  fontWeight: "400"
                }
              }

            };
            return item;
          });
          _this.chartPie = list;
          _this.legend = legend;
          _this.initCharts();
          _this.loading = false;
        }
      });
    },
    initCharts: function initCharts() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-copy-lpie"));
      charts.showLoading();
      charts.setOption({
        title: {
          text: "模块使用情况",
          top: "top",
          left: "left",
          textStyle: {
            color: "#666666",
            fontSize: 16,
            fontWeight: 500
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },

        series: [{
          name: "模块使用情况",
          type: "pie",
          avoidLabelOverlap: true,

          radius: "35%",
          center: ["50%", "70%"],
          data: this.chartPie,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          },
          label: {
            show: true,
            alignTo: "edge",
            margin: 5,
            lineHeight: 10 }
        }],
        color: ["#FF6383", "#FF9F40", "#FFCB48", "#5C89FF", "#7C6AF2", "#C95FF2", "#52c41a", "#13c2c2", "#c41d7f"]
      });
      charts.hideLoading();
    }
  }
};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var _jquery = __webpack_require__(269);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var date = new Date();
exports.default = {
  data: function data() {
    return {
      downHref: '',
      disSouch: true,
      disTime2: false,
      proName: "",
      dynamicTags: [],
      optionsSouch: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }],
      value: '账号',
      yhlx: [],
      zhlx: [],
      cities: [],
      citiesd: [],
      id: '',
      token: '',
      checkCode: '',
      listLoading: false,
      souchs: {
        phone: '',
        name: '',
        company: '',
        fromtime: ''
      },
      LogDate: [],
      orderStr: '',
      orderType: '',
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      users: [],

      companyList: []

    };
  },

  methods: {
    handleClose: function handleClose(tag) {
      if (tag == "账号") {
        this.souchs.phone = '';
        if (this.value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs.name = '';
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.company = '';
        if (this.value == "企业") {
          this.proName = '';
        }
      }

      if (tag == "开始日期") {
        this.souchs.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs.totime = "";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    delTags: function delTags() {
      this.souchs = {
        name: '',
        phone: '',
        company: ''
      };
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getUser();
    },
    changeSouch: function changeSouch(val) {
      this.souchs = {
        name: '',
        phone: '',
        company: ''
      };
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "phone") {
          this.orderStr = "phoneOrder";
        } else if (val.prop == "name") {
          this.orderStr = "nameOrder";
        } else if (val.prop == "point") {
          this.orderStr = "pointOrder";
        } else if (val.prop == "userName") {
          this.orderStr = "usertypeOrder";
        } else if (val.prop == "registertime") {
          this.orderStr = "registertimeOrder";
        } else if (val.prop == "company") {
          this.orderStr = "companyOrder";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getUser();
    },
    forType: function forType(row, column) {
      if (row.usertype == 1) {
        return row.userType = '企业账号';
      } else {
        return row.userType = '个人账号';
      }
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },
    downFile: function downFile() {
      if (this.value == "账号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.company = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }
      this.downHref = _index.API_User.userListByExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&dBegin=" + this.$moment(this.LogDate[0]).format('YYYY-MM-DD') + "&dEnd=" + this.$moment(this.LogDate[1]).format('YYYY-MM-DD') + "&phone=" + this.souchs.phone + "&company=" + this.souchs.company + "&username=" + this.souchs.name + "";

      var a = document.createElement('a');

      fetch(this.downHref).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        a.href = URL.createObjectURL(blob);
        a.download = '日活用户统计';
        document.body.appendChild(a);
        a.click();
      });
    },

    getUser: function getUser(val) {
      var _this2 = this;

      if (this.value == "账号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.company = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }

      this.downHref = _index.API_User.userListByExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&dBegin=" + this.$moment(this.LogDate[0]).format('YYYY-MM-DD') + "&dEnd=" + this.$moment(this.LogDate[1]).format('YYYY-MM-DD') + "&phone=" + this.souchs.phone + "&company=" + this.souchs.company + "&username=" + this.souchs.name + "";

      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        userType: '',

        username: this.souchs.name,
        phone: this.souchs.phone,
        company: this.souchs.company,
        dBegin: this.$moment(this.LogDate[0]).format('YYYY-MM-DD'),
        dEnd: this.$moment(this.LogDate[1]).format('YYYY-MM-DD'),


        orderType: this.orderType,
        orderStr: this.orderStr
      };
      this.listLoading = true;
      _index.API_User.userListByDay(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              res.data.data.list[i].registertimeyuan = res.data.data.list[i].registertime;
              if (res.data.data.list[i].registertime) {
                res.data.data.list[i].registertime = res.data.data.list[i].registertime.substring(0, 10);
              }
            }
            _this2.total = res.data.data.totalRow;
            _this2.users = res.data.data.list;
            _this2.listLoading = false;
          }
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
      });
    },
    getModels: function getModels() {
      var _this3 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Models.getAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.models = res.data.data;
          _this3.cities = [];
          _this3.citiesd = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this3.cities.push(res.data.data[i].modulename);
            var jsones = { "modulename": res.data.data[i].modulename, "id": res.data.data[i].id };
            _this3.citiesd.push(jsones);
          }
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },

    getCode1: function getCode1() {
      var _this4 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };

      _index.API_Admin.tbCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.companyList = res.data.data;
        }
      });
    },
    getCode2: function getCode2() {
      var _this5 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.AccList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.zhlx = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.zhlx.push(jsons);
          }
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    }

  },

  created: function created() {
    var d = new Date();
    var year1 = void 0,
        month1 = void 0,
        day1 = void 0;var _ref2 = [d.getFullYear(), d.getMonth(), d.getDate()];
    year1 = _ref2[0];
    month1 = _ref2[1];
    day1 = _ref2[2];

    var date1 = new Date(year1, month1, day1, 7);
    var year2 = void 0,
        month2 = void 0,
        day2 = void 0;
    d.setTime(d.getTime() - 30 * 24 * 60 * 60 * 1000);var _ref3 = [d.getFullYear(), d.getMonth(), d.getDate()];
    year2 = _ref3[0];
    month2 = _ref3[1];
    day2 = _ref3[2];

    var date2 = new Date(year2, month2, day2, 7);
    this.LogDate = [date2, date1];

    this.getCookie();
    this.getCode1();
    this.getCode2();

    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getUser();
    this.getModels();
  },
  mounted: function mounted() {}
};

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Account = __webpack_require__(1739);

var _Account2 = _interopRequireDefault(_Account);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['dialogVisible'],
  methods: {
    handleClose: function handleClose() {
      this.$emit('update:dialogVisible', false);
    }
  },
  components: {
    Account: _Account2.default
  }
};

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(107);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(106);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _index = __webpack_require__(6);

var _vuex = __webpack_require__(19);

var _GisCommon = __webpack_require__(167);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _SelectCommon = __webpack_require__(76);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    editLevel: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    var _this = this,
        _ref3;

    var validatorCompany = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.form.name) {
                  _context.next = 4;
                  break;
                }

                callback("请输入企业名称");
                _context.next = 9;
                break;

              case 4:
                if (!(_this.oldname != value)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.checkCompanyFun(_this.form.name);

              case 7:
                res = _context.sent;

                !res ? callback("企业名称已存在") : callback();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function validatorCompany(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    var validatorAddress = function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(rule, value, callback) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this.form.address) {
                  callback("请输入企业位置");
                } else {
                  if (!_this.position_) {
                    callback("请在GIS地图中确认位置");
                  } else {
                    callback();
                  }
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function validatorAddress(_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }();
    return _ref3 = {
      loginType: sessionStorage.getItem("type"),
      oldname: "",
      form: {
        name: "",
        showname: "",
        grade: "",
        userScale: "",
        natrue: "",
        regionCode: "",
        address: "",
        level: 0
      },
      beformAddImg: "",
      imageUrl: "",
      editImageUrl: "",
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: _index.API_Common.setCompanyPic(),
        dialogImageUrl: "",
        dialogVisible: false,
        data: {
          mode: "save",
          token: this.token,
          checkCode: this.checkCode,
          type: 1
        }
      },
      token: "",
      checkCode: "",
      id: "",
      adminuserlist: [],
      adminuser: "",
      companyManages: [],
      company: "",
      isbinding: 1,
      selected: {
        province: "320000",
        city: "320100",
        area: "320115",
        town: "320115010"
      },
      address: "",
      selected_: "",
      address_: ""
    }, (0, _defineProperty3.default)(_ref3, "token", ""), (0, _defineProperty3.default)(_ref3, "checkCode", ""), (0, _defineProperty3.default)(_ref3, "id", ""), (0, _defineProperty3.default)(_ref3, "position_", ""), (0, _defineProperty3.default)(_ref3, "comLists", []), (0, _defineProperty3.default)(_ref3, "oldCompanyName", ""), (0, _defineProperty3.default)(_ref3, "regionCode", "1"), (0, _defineProperty3.default)(_ref3, "regionCodeList", [{
      value: "1",
      label: "华东大区"
    }, {
      value: "2",
      label: "华北大区"
    }, {
      value: "3",
      label: "西北大区"
    }, {
      value: "4",
      label: "华南大区"
    }, {
      value: "5",
      label: "西南大区"
    }]), (0, _defineProperty3.default)(_ref3, "gradeList", [{
      value: "1",
      label: "综合甲"
    }, {
      value: "2",
      label: "公路甲"
    }, {
      value: "3",
      label: "市政甲"
    }, {
      value: "4",
      label: "公路市政甲"
    }, {
      value: "5",
      label: "公路乙"
    }, {
      value: "6",
      label: "市政乙"
    }, {
      value: "7",
      label: "公路市政乙"
    }, {
      value: "9",
      label: "高校"
    }, {
      value: "10",
      label: "施工单位"
    }, {
      value: "8",
      label: "其他"
    }]), (0, _defineProperty3.default)(_ref3, "natureList", [{
      value: "1",
      label: "央企"
    }, {
      value: "2",
      label: "国企"
    }, {
      value: "3",
      label: "民营上市"
    }, {
      value: "4",
      label: "民营"
    }, {
      value: "5",
      label: "高校"
    }]), (0, _defineProperty3.default)(_ref3, "linker", ""), (0, _defineProperty3.default)(_ref3, "linkerPhone", ""), (0, _defineProperty3.default)(_ref3, "managerAdminuser", ""), (0, _defineProperty3.default)(_ref3, "successfulManager", ""), (0, _defineProperty3.default)(_ref3, "agencyManager", ""), (0, _defineProperty3.default)(_ref3, "note", ""), (0, _defineProperty3.default)(_ref3, "formRules", {
      name: [{ required: true, validator: validatorCompany, trigger: "blur" }],

      grade: [{ required: true, message: "请选择资质等级", trigger: ["change"] }],
      natrue: [{ required: true, message: "请选择企业性质", trigger: ["change"] }],
      userScale: [{
        required: true,
        message: "请输入用户规模",
        trigger: ["blur", "change"]
      }],
      address: [{ validator: validatorAddress, trigger: ["blur", "change"] }],
      level: [{
        required: true,
        message: "请选择客户分级",
        trigger: ["blur", "change"]
      }],
      showname: [{
        required: true,
        message: "请输入地区",
        trigger: ["blur", "change"]
      }]
    }), _ref3;
  },


  components: {
    GisCommon: _GisCommon2.default,
    SelectCommon: _SelectCommon2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: "userInfo"
  })),

  mounted: function mounted() {
    var _this2 = this;

    try {
      this.comLists = JSON.parse(sessionStorage.getItem("comLists"));
    } catch (e) {
      _index.API_User.getCompanySearch().then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var data = res.data.data;
          _this2.comLists = data.map(function (item) {
            return { value: item };
          });
          sessionStorage.setItem("comLists", (0, _stringify2.default)(_this2.comLists));
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: "loginAdmin" });
          }
        }
      });
    }
    if (document.cookie.length > 0) {
      var arr = document.cookie.split("; ");
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("=");
        if (arr2[0] == "dnnyptadmin_token") {
          this.token = arr2[1];
        } else if (arr2[0] == "dnnyptadmin_checkCode") {
          this.checkCode = arr2[1];
        } else if (arr2[0] == "dnnyptadmin_id") {
          this.id = arr2[1];
        }
      }
    }
    var param = {
      token: this.token,
      checkCode: this.checkCode,
      id: this.id,
      companyId: this.$route.query.companyId
    };
    _index.API_User.getCompanyUser(param).then(function (res) {
      _this2.companyManages = res.data.data;
    });
    var paramx = {
      token: this.token,
      checkCode: this.checkCode
    };
    _index.API_User.allAdminuser(paramx).then(function (res) {
      _this2.adminuserlist = res.data.data;
    });
    _index.API_User.getComputeDetail(this.$route.query.companyId).then(function (res) {
      _this2.form.name = res.data.data.name;
      _this2.oldname = res.data.data.name;
      _this2.oldCompanyName = res.data.data.name;
      _this2.form.showname = res.data.data.showname;
      _this2.imageUrl = res.data.data.sltUrl;

      _this2.adminuser = _this2.userInfo.type == 1 ? res.data.data.managerAdminuser : _this2.userInfo.id;
      _this2.isbinding = res.data.data.isbinding;
      _this2.form.regionCode = res.data.data.regionCode;
      _this2.form.grade = res.data.data.grade;
      _this2.form.natrue = res.data.data.natrue;
      _this2.form.userScale = res.data.data.userScale;
      _this2.linker = res.data.data.linker;
      _this2.linkerPhone = res.data.data.linkerPhone;
      _this2.managerAdminuser = res.data.data.managerAdminuser;
      _this2.agencyManager = res.data.data.agencyManager;
      _this2.successfulManager = res.data.data.successfulManager;
      _this2.form.level = Number(res.data.data.level);
      _this2.note = res.data.data.note;
      if (res.data.data.managerid) {
        _this2.company = res.data.data.managerid.split(",");
      }
      _this2.selected = {
        province: res.data.data.province ? JSON.parse(res.data.data.province).key : "",
        city: res.data.data.city ? JSON.parse(res.data.data.city).key : "",
        area: res.data.data.district ? JSON.parse(res.data.data.district).key : "",
        town: ""
      };
      if (res.data.data.longitudeAndLatitude) {
        _this2.position_ = [Number(res.data.data.longitudeAndLatitude.split(",")[0]), Number(res.data.data.longitudeAndLatitude.split(",")[1])];
      }
      _this2.$refs.GisCommon.changItem(res.data.data.addressInfo);
      _this2.$refs.GisCommon.changePro(_this2.selected);
      _this2.$refs.GisCommon.changePos(_this2.position_);
      _this2.form.address = res.data.data.addressInfo, _this2.selected_ = {
        province: res.data.data.province ? JSON.parse(res.data.data.province) : "",
        city: res.data.data.city ? JSON.parse(res.data.data.city) : "",
        district: res.data.data.district ? JSON.parse(res.data.data.district) : "",
        town: null
      };
      _this2.$refs.form.clearValidate();
    });
  },


  methods: {
    checkCompanyFun: function checkCompanyFun(name) {
      return _index.API_User.checkCompanyUnique({ name: name }).then(function (res) {
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    querySearch: function querySearch(queryString, cb) {
      var comLists = this.comLists;
      var results = queryString ? comLists.filter(this.createFilter(queryString)) : comLists;

      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
        this.queryData();
      }
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;
        this.imageUrl = URL.createObjectURL(file.raw);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error("请选择图片文件");
      }
    },
    backPram: function backPram(param) {
      console.log(500, param);

      this.position_ = param.position, this.form.address = param.address, this.selected_ = param.selected;
    },
    saveData: function saveData() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var param;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                param = (0, _extends3.default)({
                  token: _this3.token,
                  checkCode: _this3.checkCode,
                  mode: "",
                  id: _this3.$route.query.companyId,
                  logoid: _this3.imageUrl,
                  managerid: _this3.company.toString(),
                  createUser: _this3.userInfo.id,
                  province: (0, _stringify2.default)(_this3.selected_.province),
                  city: (0, _stringify2.default)(_this3.selected_.city),
                  district: (0, _stringify2.default)(_this3.selected_.area),
                  longitudeAndLatitude: _this3.position_.toString(),
                  addressInfo: _this3.form.address,
                  managerAdminuser: _this3.managerAdminuser,
                  agencyManager: _this3.agencyManager,
                  successfulManager: _this3.successfulManager,
                  isbinding: _this3.isbinding
                }, _this3.form, {
                  linker: _this3.linker,
                  linkerPhone: _this3.linkerPhone,
                  note: _this3.note
                });

                _this3.$refs["form"].validate(function (valid) {
                  if (valid) {
                    if (_this3.beformAddImg) {
                      var formData = new FormData();
                      formData.append("pic", _this3.beformAddImg.raw);
                      formData.append("token", _this3.token);
                      formData.append("checkCode", _this3.checkCode);
                      formData.append("mode", "save");
                      var config = {
                        "Content-Type": "multipart/form-data"
                      };
                      _axios2.default.post(_this3.upload.postURL, formData, config).then(function (res) {
                        if (res.data.code == 200) {
                          var _res$data$data = res.data.data,
                              pic = _res$data$data.pic,
                              id = _res$data$data.id;

                          param.logoid = pic;
                          param.showpicid = id;
                          _this3.editSave(param);
                          _this3.$refs.upload.clearFiles();
                        } else {
                          _this3.$message.error(res.data.message);
                          if (res.data.code == 403) {
                            _this3.$router.push({ path: "loginAdmin" });
                          }
                          return;
                        }
                      }).catch(function (error) {
                        console.log(error);
                        return;
                      });
                    } else {
                      _this3.editSave(param);
                    }
                  }
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    editSave: function editSave(param) {
      var _this4 = this;

      var paramx = {
        companyid: this.$route.query.companyId,
        userid: this.company.toString(),
        toke: this.token,
        checkCode: this.checkCode
      };
      _index.API_User.setCompanyManager(paramx).then(function (res) {
        if (res.data.code != 200) {
          _this4.$message.error(res.data.message);
        } else {
          _index.API_User.addCompanyList(param).then(function (res) {
            if (res.data.code == 200) {
              _this4.$message({ message: "编辑成功", type: "success" });
              _this4.oldCompanyName == _this4.form.name;
            } else {
              _this4.$message.error(res.data.message);
            }
          }).catch(function (err) {
            _this4.$message.error("数据丢失，试试重新登陆！");
          });
        }
      });
    },
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    }
  }
};

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  inject: ['reload'],
  data: function data() {
    var checkPhone = function checkPhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        var reg = /^1[3-9]\d{9}$/;
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    return {
      searchText: '',
      deptId: '',
      detpList: [],

      inviValues: [],
      softtypes: [],
      checkUserId: '',
      checkUserIdOld: '',
      pageSize2: 10,
      pageNumber2: 1,
      total2: 1,
      companyList: [],
      disSofttype2: false,
      disSouch2: true,

      disTime1: false,
      disTime2: false,
      proName2: "",
      dynamicTags2: [],
      optionsSouch2: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '软件类型', label: '软件类型' }, { value: '开始日期', label: '开始日期' }, { value: '结束日期', label: '结束日期' }],
      value2: '',
      souchs2: {
        name: '',
        phone: '',
        company: '',
        invitestatus: '',
        softtype: '',
        fromtime: '',
        totime: ''
      },

      disSouch: true,
      disType: false,
      souchs: {
        phone: '',
        name: '',
        company: '',
        invitestatusname: ''
      },
      proName: '',
      typeValue: '',
      types: [{ value: '1', label: '邀请中' }, { value: '2', label: '邀请通过' }],
      options: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '状态', label: '状态' }],
      value: '',
      dynamicTags: [],

      addFormVisible: false,
      addLoading: false,
      addForm: {},
      addFormRules: {
        phone: [{ validator: checkPhone, trigger: 'blur' }]
      },
      userList: [],
      listLoading: false,
      pageSize: 20,
      pageNumber: 1,
      total: 0,

      token: '',
      checkCode: '',
      id: '',
      companymanageid: '',
      sels: [],
      sels2: [],
      orderType: '',
      orderStr: ""
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  methods: {
    handleSelectionChange: function handleSelectionChange(row) {
      this.flag = true;
      this.userList.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
        }
        if (item.id == row.id) {
          item.checked = true;
        }
      });
      if (row.name == null) {
        row.name = "";
      }
      if (row.phone == null) {
        row.phone = "";
      }
      this.checkUserId = row.id;
      this.checkUserIdOld = row.id;
    },
    changeSouch2: function changeSouch2(val) {
      this.disSouch2 = false;

      this.disSofttype2 = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName2 = this.souchs2.phone;
        this.disSouch2 = true;
      } else if (val == "姓名") {
        this.proName2 = this.souchs2.name;
        this.disSouch2 = true;
      } else if (val == "企业") {
        this.proName2 = this.souchs2.company;
        this.disSouch2 = true;
      } else if (val == "软件类型") {
        this.disSofttype2 = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },
    handleClose2: function handleClose2(tag) {
      if (tag == "账号") {
        this.souchs2.phone = '';
        if (this.value2 == "账号") {
          this.proName2 = '';
        }
      }
      if (tag == "姓名") {
        this.souchs2.name = '';
        if (this.value2 == "姓名") {
          this.proName2 = '';
        }
      }
      if (tag == "企业") {
        this.souchs2.company = '';
        if (this.value2 == "企业") {
          this.proName2 = '';
        }
      }
      if (tag == "软件类型") {
        this.souchs2.softtype = "";
      }

      if (tag == "开始日期") {
        this.souchs2.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs2.totime = "";
      }
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1);
    },

    delTags2: function delTags2() {
      this.souchs2 = {};
      this.proName2 = '';
      this.value2 = '';
      this.dynamicTags2 = [];
      this.getComUser();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getComUser();
    },
    handleSizeChange2: function handleSizeChange2(val) {
      if (!val) {
        this.getComUser(9);
      } else {
        this.pageSize2 = val;
        this.getComUser();
      }
    },

    getComUser: function getComUser(val) {
      var _this = this;
      if (this.value2 == "账号") {
        this.souchs2.phone = this.proName2;
      }
      if (this.value2 == "企业") {
        this.souchs2.company = this.proName2;
      }
      if (this.value2 == "姓名") {
        this.souchs2.name = this.proName2;
      }
      var flag2 = true;
      if (val == 1) {
        if (this.value2) {
          if (this.dynamicTags2.length > 0) {
            for (var i = 0; i < this.dynamicTags2.length; i++) {
              if (this.value2 == this.dynamicTags2[i]) {
                flag2 = false;
              }
            }
          }
          if (flag2) {
            this.dynamicTags2.push(this.value2);
          }
        }
      }
      var param = void 0;
      if (val == 9) {
        param = {
          token: this.token,
          checkCode: this.checkCode,

          username: this.souchs2.name,
          phone: this.souchs2.phone,
          company: this.souchs2.company,
          registertimefrom: this.souchs2.fromtime,
          registertimeto: this.souchs2.totime,
          softtype: this.souchs2.softtype,
          invitestatus: '0'

        };
      } else {
        param = {
          token: this.token,
          checkCode: this.checkCode,
          pageNumber: this.pageNumber2,
          pageSize: this.pageSize2,
          listType: 'page',
          userType: '',

          username: this.souchs2.name,
          phone: this.souchs2.phone,
          company: this.souchs2.company,
          registertimefrom: this.souchs2.fromtime,
          registertimeto: this.souchs2.totime,
          softtype: this.souchs2.softtype,
          invitestatus: '0'
        };
      }


      _index.API_User.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.list) {
            _this.total2 = res.data.data.totalRow;
            _this.companyList = res.data.data.list;
          } else {
            _this.companyList = res.data.data;
            _this.total2 = 1;
            _this.pageNumber2 = 1;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "invitestatusname") {
          this.orderStr = "invitestatusnamepx";
        } else if (val.prop == "point") {
          this.orderStr = "pointpx";
        } else if (val.prop == "company") {
          this.orderStr = "companypx";
        } else if (val.prop == "deptname") {
          this.orderStr = "deptpx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getUser();
    },

    batchRemove: function batchRemove(index, row) {
      var _this2 = this;

      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(function () {
        var ids;
        if (row) {
          ids = row.id;
        } else {
          ids = _this2.sels.map(function (item) {
            return item.id;
          }).toString();
        }
        _this2.listLoading = true;
        var para = {
          token: _this2.token,
          checkCode: _this2.checkCode,
          companyid: _this2.$route.query.companyId,
          userids: ids
        };
        _index.API_userCom.delComUserList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this2.listLoading = false;
            _this2.$message({
              message: '删除成功',
              type: 'success'
            });
            _this2.getUser();
          } else {
            _this2.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'login' });
            }
          }
        }).catch(function (err) {
          _this2.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    selsChange2: function selsChange2(sels) {
      this.sels2 = sels;
    },
    selectInit: function selectInit(row, index) {
      if (row.companymanageid || row.deptList && row.deptList.length > 0) {
        return 0;
      } else {
        return 1;
      }
    },
    delTags: function delTags() {
      this.souchs = {}, this.value = '';
      this.typeValue = '';
      this.proName = '';
      this.dynamicTags = [];
      this.getUser();
    },
    handleClose: function handleClose(tag) {
      if (tag == "账号") {
        this.souchs.phone = "";
        if (this.value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs.name = "";
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.company = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "状态") {
        this.souchs.invitestatusname = "";
        this.typeValue = '';
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    changeSouch: function changeSouch(val) {
      if (val == "账号") {
        this.proName = this.souchs.phone;
        this.disSouch = true;
        this.disType = false;
      } else if (val == "姓名") {
        this.proName = this.souchs.name;
        this.disSouch = true;
        this.disType = false;
      } else if (val == "企业") {
        this.proName = this.souchs.company;
        this.disSouch = true;
        this.disType = false;
      } else if (val == "状态") {
        this.typeValue = this.souchs.invitestatusname;
        this.disSouch = false;
        this.disType = true;
      }
    },
    addSubmit: function addSubmit(addForm) {
      var _this3 = this;

      var ids = this.sels2.map(function (item) {
        return item.id;
      }).toString();
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.$route.query.companyId,
        userids: ids
      };
      _index.API_userCom.addComUserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '添加成功',
            type: 'success'
          });
          _this3.addFormVisible = false;
          _this3.getUser();
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'login' });
          }
        }
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },
    addList: function addList() {
      this.getComUser();
      this.addFormVisible = true;
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },

    getUser: function getUser(val) {
      var _this4 = this;

      if (this.value == "账号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.company = this.proName;
      }
      if (this.value == "状态") {
        this.souchs.invitestatusname = this.typeValue;
      }
      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        companyid: _this.$route.query.companyId,

        company: this.souchs.company,
        phone: this.souchs.phone,
        username: this.souchs.name,

        orderType: this.orderType,
        orderStr: this.orderStr,
        invitestatus: this.typeValue,
        searchText: this.searchText,
        deptid: this.deptId
      };
      this.listLoading = true;
      _index.API_userCom.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i].companymanageid || res.data.data.list[i].deptList && res.data.data.list[i].deptList.length > 0) {
                res.data.data.list[i].delShow = true;
              } else {
                res.data.data.list[i].delShow = false;
              }
            }
            _this.userList = res.data.data.list;
            _this.total = res.data.data.totalRow;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'login' });
          }
        }
        _this4.listLoading = false;
      }).catch(function (err) {
        _this4.listLoading = false;
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getDeptList: function getDeptList() {
      var _this5 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.$route.query.companyId
      };
      _index.API_userCom.getDepartList(param).then(function (res) {
        if (res.data.code == 200) {
          _this5.detpList = res.data.data;
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },


    handledel: function handledel(index, row) {
      var param = {
        id: row.id
      };
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    getCode1: function getCode1() {
      var _this6 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.yhlx = [];
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.yhlx.push(jsons);
            var json = { 'value': res.data.data[i].code, 'label': res.data.data[i].name };
            _this.softtypes.push(json);
          }
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    getCode: function getCode() {
      var _this7 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "label": res.data.data[i].name };
            _this.inviValues.push(jsons);
          }
        } else {
          _this7.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this7.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    }

  },
  created: function created() {
    this.getCookie();
    this.getDeptList();
  },
  mounted: function mounted() {
    this.getUser();
    this.getCode();
    this.getCode1();
  }
};

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(294);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(107);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(106);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(93);

var _index3 = _interopRequireDefault(_index2);

var _SelectCommon = __webpack_require__(76);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    mode: {
      type: String,
      default: 'save'
    },

    visible: {
      type: Boolean,
      default: false
    },

    processDetail: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    var _this = this;

    var validatorDept = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.ruleForm.deptname) {
                  _context.next = 4;
                  break;
                }

                callback("请输入部门名称");
                _context.next = 9;
                break;

              case 4:
                if (!(_this.oldDepartName != _this.ruleForm.deptname)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.checkDepart(_this.ruleForm.deptname);

              case 7:
                res = _context.sent;

                !res ? callback('部门名称已存在') : callback();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function validatorDept(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      myVisible: false,
      searchText: '',
      listLoading: false,
      confirmLoading: false,
      pageSize: 10,
      pageNumber: 1,
      total: 0,

      token: '',
      checkCode: '',
      companyList: [],
      title: '',

      selectedUserIdBack: [],

      rules: {
        deptname: [{ required: true, validator: validatorDept, trigger: 'change' }],

        deptmanager: [{ required: false, message: '请选择部门管理员', trigger: 'change' }],

        useridList: [{ required: false, message: '请选择部门人员', trigger: 'change' }]
      },

      flag: '-1',
      allCompanyList: [],

      ruleForm: {
        deptname: '',
        deptmanager: '',
        useridList: [],
        companyid: this.$route.query.companyId
      },

      oldDepartName: '' };
  },


  components: {
    SelectCommon: _SelectCommon2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    this.myVisible = this.visible;
  },
  mounted: function mounted() {
    var _this2 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
      var _utils$getParamsByCoo, token, checkCode, res;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _utils$getParamsByCoo = _index3.default.getParamsByCookie(), token = _utils$getParamsByCoo.token, checkCode = _utils$getParamsByCoo.checkCode;

              _this2.token = token;
              _this2.checkCode = checkCode;

              if (!(_this2.mode == 'save')) {
                _context2.next = 8;
                break;
              }

              _this2.title = '新增部门';
              _this2.getComUser(0);
              _context2.next = 13;
              break;

            case 8:
              _this2.title = '编辑部门';
              _context2.next = 11;
              return _this2.getDetail();

            case 11:
              res = _context2.sent;

              if (res) {
                _this2.getComUser(0);
              }

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },


  methods: {
    checkDepart: function checkDepart(name) {
      return _index.API_userCom.checkDepartUnique({ deptname: name, companyid: this.ruleForm.companyid }).then(function (res) {
        console.log('ressss--', res);
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.$route.query.companyId,
        id: this.processDetail.id
      };
      this.listLoading = true;
      return _index.API_userCom.getDepartDetail(param).then(function (res) {
        if (res.data.code == 200) {
          var data = res.data.data;
          var deptname = data.deptname,
              deptmanager = data.deptmanager,
              _data$userList = data.userList,
              userList = _data$userList === undefined ? [] : _data$userList;

          _this3.ruleForm.useridList = userList.map(function (item) {
            return { id: item.id };
          });
          _this3.ruleForm.deptname = deptname;
          _this3.ruleForm.deptmanager = deptmanager;
          _this3.oldDepartName = deptname;

          return true;
        } else {
          _this3.listLoading = false;
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
          return false;
        }
      }).catch(function (err) {
        _this3.listLoading = false;
        _this3.$message.error('数据丢失，试试重新登录1！');
        return false;
      });
    },
    getComUser: function getComUser(flag) {
      var _this4 = this;

      this.flag = flag;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.$route.query.companyId,
        searchText: this.searchText
      };
      this.listLoading = true;
      return _index.API_userCom.getCompanyUser(param).then(function (res) {
        if (res.data.code == 200) {
          _this4.companyList = res.data.data;

          if (!_this4.searchText) {
            _this4.allCompanyList = JSON.parse((0, _stringify2.default)(_this4.companyList));
            _this4.ruleForm.useridList = [].concat((0, _toConsumableArray3.default)(_this4.ruleForm.useridList), (0, _toConsumableArray3.default)(JSON.parse((0, _stringify2.default)(_this4.selectedUserIdBack))));

            _this4.ruleForm.useridList = _this4.uniqObj(_this4.ruleForm.useridList, 'id');
          } else {
            _this4.selectedUserIdBack = [].concat((0, _toConsumableArray3.default)(JSON.parse((0, _stringify2.default)(_this4.ruleForm.useridList))), (0, _toConsumableArray3.default)(_this4.selectedUserIdBack));
            _this4.selectedUserIdBack = _this4.uniqObj(_this4.selectedUserIdBack, 'id');
          }
          _this4.listLoading = false;
          setTimeout(function () {
            _this4.initSelectedUser();
          }, 100);
          return true;
        } else {
          _this4.listLoading = false;
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
          return false;
        }
      }).catch(function (err) {
        _this4.listLoading = false;
        _this4.$message.error('数据丢失，试试重新登录1！');
        return false;
      });
    },
    uniqObj: function uniqObj(array, field) {
      var tempObj = {};
      array = array.reduce(function (cur, next) {
        tempObj[next[field]] ? "" : tempObj[next[field]] = true && cur.push(next);
        return cur;
      }, []);
      return array;
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.ruleForm[key] = value[0];
      this.$refs.ruleForm.validateField(key);
    },
    handerSectionChange: function handerSectionChange(data, column, event) {
      if (this.flag == 1 && this.ruleForm.useridList.length > 0) {
        this.flag = -1;
        return;
      }
      var selectedUserId = data.length > 0 ? data.map(function (item) {
        return { id: item.id };
      }) : [];

      this.ruleForm.useridList = selectedUserId;

      this.$refs.ruleForm.validateField('useridList');
    },
    handerRowClick: function handerRowClick(row, column, event) {
      this.$set(row, 'selected', !row.selected);
      this.$refs.companyRef.toggleRowSelection(row);
    },
    handerChkSelect: function handerChkSelect(selection, row) {
      this.handerRowClick(row);
    },
    initSelectedUser: function initSelectedUser() {
      var _this5 = this;

      var selectedList = this.ruleForm.useridList;
      this.companyList.forEach(function (list) {
        selectedList.forEach(function (item) {
          if (list.id == item.id) {
            _this5.handerRowClick(list);
          }
        });
      });
    },
    handerSubmit: function handerSubmit(formName) {
      var _this6 = this;

      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          if (_this6.confirmLoading) {
            return;
          }
          _this6.confirmLoading = true;

          _this6.ruleForm.useridList = [].concat((0, _toConsumableArray3.default)(_this6.ruleForm.useridList), (0, _toConsumableArray3.default)(JSON.parse((0, _stringify2.default)(_this6.selectedUserIdBack))));

          _this6.ruleForm.useridList = _this6.uniqObj(_this6.ruleForm.useridList, 'id');
          var useridList = _this6.ruleForm.useridList.map(function (item) {
            return item.id;
          });
          var data = (0, _extends3.default)({}, _this6.ruleForm);
          data.useridList = useridList.length > 0 ? useridList.join() : '';
          data.createUser = _this6.userId;
          _this6.mode == 'save' ? _this6.handerSave(data) : _this6.handerUpdate(data);
        }
      });
    },
    handerSave: function handerSave(data) {
      var _this7 = this;

      _index.API_userCom.addDept(data).then(function (res) {
        if (res.data.code == 200) {
          _this7.$message.success('新增成功');
          _this7.$emit('getList');
          _this7.handerClose();
        } else {
          if (res.data.code == 403) {
            _this7.$router.push({ path: 'loginAdmin' });
          }
        }
        _this7.confirmLoading = false;
      }).catch(function (err) {
        _this7.confirmLoading = false;
      });
    },
    handerUpdate: function handerUpdate(data) {
      var _this8 = this;

      data.id = this.processDetail.id;
      _index.API_userCom.editDept(data).then(function (res) {
        if (res.data.code == 200) {
          _this8.$message.success('编辑成功');
          _this8.$emit('getList');
          _this8.handerClose();
        } else {
          if (res.data.code == 403) {
            _this8.$router.push({ path: 'loginAdmin' });
          }
        }
        _this8.confirmLoading = false;
      }).catch(function (err) {
        _this8.confirmLoading = false;
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handerClose: function handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false);
    }
  }
};

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(93);

var _index3 = _interopRequireDefault(_index2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    mode: {
      type: String,
      default: 'save'
    },

    visible: {
      type: Boolean,
      default: false
    },

    processDetail: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {

    return {
      myVisible: false,
      listLoading: false,

      token: '',
      checkCode: '',

      departDetail: null
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    this.myVisible = this.visible;

    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.checkCode = checkCode;
    this.getDetail();
  },


  methods: {
    getDetail: function getDetail() {
      var _this = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.$route.query.companyId,
        id: this.processDetail.id
      };
      this.listLoading = true;
      _index.API_userCom.getDepartDetail(param).then(function (res) {
        if (res.data.code == 200) {
          var data = res.data.data;
          _this.departDetail = data;
        } else {
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
        _this.$message.error('数据丢失，试试重新登录1！');
      });
    },
    handerClose: function handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false);
    }
  }
};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _ModalForm = __webpack_require__(1741);

var _ModalForm2 = _interopRequireDefault(_ModalForm);

var _ModalFormView = __webpack_require__(1742);

var _ModalFormView2 = _interopRequireDefault(_ModalFormView);

var _index2 = __webpack_require__(93);

var _index3 = _interopRequireDefault(_index2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      listLoading: false,
      dataList: [],

      pageNumber: 1,
      pageSize: 20,
      total: 0,
      token: '',

      visible: false,
      visibleView: false,
      mode: 'save',

      searchText: '',
      selectedUserId: [],

      processDetail: null
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default,
    ModalForm: _ModalForm2.default,
    ModalFormView: _ModalFormView2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.getList();
  },


  methods: {
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      var data = {
        token: this.token,
        companyid: this.$route.query.companyId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        searchText: this.searchText
      };
      _index.API_userCom.getDepartList(data).then(function (res) {
        if (res.data.code == 200) {
          var _data = res.data.data;
          _this.dataList = _data.list;
          _this.total = _data.totalRow;
        } else {
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handerSectionChange: function handerSectionChange(data, column, event) {
      console.log("handerSectionChange==", data);
      this.selectedUserId = data.length > 0 ? data.map(function (item) {
        return item.id;
      }) : [];
    },
    handerRowClick: function handerRowClick(row, column, event) {
      if (event.target.className.indexOf('dnnfont') > -1) {
        return;
      }
      this.$refs.companyTabRef.toggleRowSelection(row);
    },
    addForm: function addForm() {
      this.visible = true;
      this.mode = 'save';
    },
    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this2.token,
          checkCode: _this2.checkCode,
          id: row.id
        };
        _index.API_userCom.delDepart(param).then(function (res) {
          if (res.data.code == 200) {
            _this2.$message({ message: '删除成功', type: 'success' });
            _this2.getList();
          } else {
            _this2.$message.error('删除失败');
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this2.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    handleEdit: function handleEdit(index, row) {
      this.processDetail = row;
      this.visible = true;
      this.mode = 'update';
    },
    handleDetail: function handleDetail(index, row) {
      this.processDetail = row;
      this.visibleView = true;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    }
  }
};

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _index = __webpack_require__(6);

var _jquery = __webpack_require__(269);

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = __webpack_require__(377);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  inject: ['reload'],
  data: function data() {
    return {
      searchText: '',
      companymanageid: '',
      souchs: {
        hardHash: '',
        comment: '',
        deptname: ''
      },
      dynamicTags: [],
      proName: '',
      options: [{ value: '硬件码', label: '硬件码' }, { value: '备注', label: '备注' }, { value: '部门', label: '部门' }],
      value: "",
      token: '',
      checkCode: '',
      id: '',
      total: 1,
      pageSize: 20,
      pageNumber: 1,
      proList: [],
      listLoading: false,
      sels: [],
      addFormVisible: false,
      addForm: {
        hardHash: '',
        comment: '',
        deptname: ''
      },
      addLoading: false,
      addFormRules: {
        hardHash: [{ required: true, message: '请输入硬件码', trigger: 'blur' }]
      },
      editFormVisible: false,
      editForm: {
        hardHash: '',
        comment: '',
        deptname: ''
      },
      editLoading: false,
      editFormRules: {
        hardHash: [{ required: true, message: '请输入硬件码', trigger: 'blur' }],
        deptname: [{ required: true, message: '请输入部门', trigger: 'blur' }]
      },
      orderType: '',
      orderStr: '',
      hrefUrl: ''
    };
  },

  methods: {
    importFile: function importFile(filex) {
      var file = filex.target.files[0];
      var formData = new FormData();
      formData.append('file', file);
      if (!file) {
        _this.$message.error('请选择文件！');
        return;
      }
      var _this = this;
      _this.listLoading = true;
      _jquery2.default.ajax({
        url: _index.API_userCom.companyBatchAdd() + "?companyid=" + this.$route.query.companyId + "" + '&checkCode=' + _jsCookie2.default.get("dnnyptadmin_checkCode") + '&token=' + _jsCookie2.default.get("dnnyptadmin_token"),
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        dataType: "json",
        timeout: 180000,
        success: function success(res) {
          if (res.code == 200) {
            _this.$message.success('导入成功！');
          } else {
            _this.$message.error(res.message);
          }
          _this.getList();
          _this.$refs.clearFileModal.value = "";
        },
        error: function error(err) {
          _this.$message.error(res.message);
          _this.listLoading = false;
        },
        complete: function complete() {}
      });
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "hardHash") {
          this.orderStr = "hardHashpx";
        } else if (val.prop == "comment") {
          this.orderStr = "commentpx";
        } else if (val.prop == "deptname") {
          this.orderStr = "deptnamepx";
        } else if (val.prop == "intime") {
          this.orderStr = "intimepx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch: function changeSouch(val) {
      if (val == "硬件码") {
        this.proName = this.souchs.hardHash;
      } else if (val == "备注") {
        this.proName = this.souchs.comment;
      } else if (val == "部门") {
        this.proName = this.souchs.deptname;
      }
    },
    delTags: function delTags() {
      this.souchs = {}, this.value = '';
      this.proName = '';
      this.dynamicTags = [];
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == "硬件码") {
        this.souchs.hardHash = "";
        if (this.value == "硬件码") {
          this.proName = '';
        }
      }
      if (tag == "部门") {
        this.souchs.deptname = "";
        if (this.value == "部门") {
          this.proName = '';
        }
      }
      if (tag == "备注") {
        this.souchs.comment = "";
        if (this.value == "备注") {
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    editSubmit: function editSubmit() {
      var _this2 = this;

      if (!this.editForm.hardHash) {
        this.$message.error('硬件码不可为空！');
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: '',
        id: this.editForm.id,
        comment: this.editForm.comment,
        hardHash: this.editForm.hardHash,
        deptname: this.editForm.deptname,

        companyid: this.$route.query.companyId
      };
      this.editLoading = true;
      _index.API_userCom.addSBList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: "保存成功",
            type: 'success'
          });
          _this2.getList();
          _this2.editFormVisible = false;
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'login' });
          }
        }
        _this2.editLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.editLoading = false;
      });
    },
    addSubmit: function addSubmit() {
      var _this3 = this;

      if (!this.addForm.hardHash) {
        this.$message.error('硬件码不可为空！');
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        comment: this.addForm.comment,
        hardHash: this.addForm.hardHash,
        deptname: this.addForm.deptname,

        companyid: this.$route.query.companyId
      };
      this.addLoading = true;
      _index.API_userCom.addSBList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: "保存成功",
            type: 'success'
          });
          _this3.getList();
          _this3.addFormVisible = false;
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'login' });
          }
        }
        _this3.addLoading = false;
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
        _this3.addLoading = false;
      });
    },
    handleDel: function handleDel(index, row) {
      var _this4 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this4.token,
          checkCode: _this4.checkCode,
          id: row.id
        };
        _index.API_userCom.delSBList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this4.$message({
              message: "删除成功",
              type: 'success'
            });
            _this4.getList();
          } else {
            _this4.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this4.$router.push({ path: 'login' });
            }
          }
        }).catch(function (err) {
          _this4.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    handleEdit: function handleEdit(index, row) {
      this.editForm = (0, _assign2.default)({}, row);
      this.editFormVisible = true;
    },
    handleAdd: function handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    getList: function getList(val) {
      var _this5 = this;

      if (this.value == "硬件码") {
        this.souchs.hardHash = this.proName;
      }
      if (this.value == "部门") {
        this.souchs.deptname = this.proName;
      }
      if (this.value == "备注") {
        this.souchs.comment = this.proName;
      }
      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,

        companyid: this.$route.query.companyId,
        comment: this.souchs.comment,
        hardHash: this.souchs.hardHash,
        deptname: this.souchs.deptname,
        orderType: this.orderType,
        orderStr: this.orderStr,
        searchText: this.searchText
      };
      this.listLoading = true;
      _index.API_userCom.getSBList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.list) {
            _this5.proList = res.data.data.list;
            if (res.data.data.totalRow) {
              _this5.total = res.data.data.totalRow;
            }
          }
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'login' });
          }
        }
        _this5.listLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.listLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  created: function created() {
    this.getCookie();
    this.hrefUrl = _index.API_userCom.companyTemplate();
  }
};

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(107);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(106);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(93);

var _index3 = _interopRequireDefault(_index2);

var _SelectCommon = __webpack_require__(76);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _GisCommon = __webpack_require__(167);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _proj = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    mode: {
      type: String,
      default: 'save'
    },

    visible: {
      type: Boolean,
      default: false
    },

    visitStatusList: {
      type: Array,
      default: function _default() {}
    },
    processDetail: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },

  data: function data() {
    var _this = this;

    var validateFile = function validateFile(rule, value, callback) {
      if (!_this.ruleForm.pic) {
        callback(new Error('请上传现场照片'));
      } else {
        callback();
      }
    };
    return {
      myVisible: false,
      searchText: '',
      listLoading: false,
      confirmLoading: false,
      pageSize: 10,
      pageNumber: 1,
      total: 0,

      token: '',
      checkCode: '',
      companyList: [],
      title: '',

      selectedUserId: [],

      rules: {
        departName: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],

        payVisitDate: [{ required: true, message: '请选择拜访日期', trigger: 'change' }],

        contactUser: [{ required: true, message: '请输入联系人', trigger: 'change' }],

        contactPhone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],

        position: [{ required: true, message: '请输入职位', trigger: 'blur' }],

        payVisitInfo: [{ required: true, message: '请输入拜访详情', trigger: 'blur' }],

        payVisitStatus: [{ required: true, message: '请选择拜访状态', trigger: 'blur' }]

      },

      ruleForm: {
        companyName: this.$route.query.companyName,
        companyId: this.$route.query.companyId,
        adminUser: '',
        payVisitDate: '',
        contactUser: '',
        contactPhone: '',
        position: '',
        payVisitInfo: '',
        payVisitStatus: '',
        successfulManager: "",
        agencyManager: "",
        pic: ''
      },

      companyId: this.$route.query.companyId,
      fileList: [],
      removeUploadFileIds: [],
      uploadURL: ''

    };
  },


  components: {
    SelectCommon: _SelectCommon2.default,
    GisCommon: _GisCommon2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    this.myVisible = this.visible;
  },
  mounted: function mounted() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.checkCode = checkCode;

    if (this.mode == 'save') {
      this.title = '新增';
    } else {
      this.title = '编辑';
      var myDetail = JSON.parse((0, _stringify2.default)(this.processDetail));
      myDetail.auditStatus = myDetail.auditStatus + '';
      myDetail.payVisitStatus = myDetail.payVisitStatus + '';

      var fileList = myDetail.picList;
      fileList.forEach(function (item) {
        item.uid = item.id;
        item.name = item.fileName;
        item.url = item.sltUrl;
      });
      myDetail.picList = fileList;
      this.fileList = fileList;
      this.ruleForm = (0, _extends3.default)({}, this.ruleForm, myDetail);
    }
  },


  methods: {
    handerUploadChange: function handerUploadChange(file, fileList) {
      this.fileList.push(file);
      this.ruleForm.pic = this.fileList.length > 0 ? this.fileList.map(function (item) {
        return item.uid;
      }).join() : '';
      this.$refs.ruleForm.validateField('pic');
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      console.log("remove==");
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = this.fileList.filter(function (item) {
        return item.uid != file.uid;
      });
      this.ruleForm.pic = this.fileList.length > 0 ? this.fileList.map(function (item) {
        return item.uid;
      }).join() : '';

      if (file.id) {
        this.removeUploadFileIds.push(file.id);
      }

      this.$refs.ruleForm.validateField('pic');
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.ruleForm[key] = value[0];
      this.$refs.ruleForm.validateField(key);
      if (key === 'contactUser') {
        this.ruleForm.contactPhone = datas[0].phone;
      }
    },
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this.ruleForm[key] = value[0];
    },
    submitUpload: function submitUpload() {
      this.$refs.upload.submit();
    },
    uploadPic: function uploadPic(formData) {
      var _this2 = this;

      return _index.API_userCom.uploadPic(formData).then(function (res) {
        if (res.data.code == 200) {
          var data = res.data.data;
          var picIds = data.length > 0 ? data.map(function (item) {
            return item.id;
          }).join() : '';
          return picIds;
        } else {
          _this2.$message.error('上传图片出错');
        }
        return false;
      }).catch(function (err) {
        _this2.confirmLoading = false;
        _this2.$message.error('上传图片出错');
        return false;
      });
    },
    delPic: function delPic() {
      var _this3 = this;

      var data = {
        picId: this.removeUploadFileIds.join(),
        id: this.ruleForm.id
      };
      return _index.API_userCom.delPic(data).then(function (res) {
        if (res.data.code == 200) {
          return true;
        } else {
          _this3.$message.error('删除图片出错');
        }
        return false;
      }).catch(function (err) {
        _this3.confirmLoading = false;
        _this3.$message.error('删除图片出错');
        return false;
      });
    },
    handerSubmit: function handerSubmit(formName) {
      var _this4 = this;

      this.$refs['ruleForm'].validate(function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(valid) {
          var data, fileRawList, res, formData, picIds;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 27;
                    break;
                  }

                  data = (0, _extends3.default)({}, _this4.ruleForm);

                  data.createUser = _this4.userInfo.id;
                  delete data.companyName;
                  _this4.confirmLoading = true;
                  fileRawList = _this4.fileList.filter(function (item) {
                    return item.raw;
                  });

                  if (!(data.payVisitStatus == 2 || data.payVisitStatus == 3)) {
                    _context.next = 25;
                    break;
                  }

                  if (!(_this4.removeUploadFileIds.length > 0)) {
                    _context.next = 13;
                    break;
                  }

                  _context.next = 10;
                  return _this4.delPic();

                case 10:
                  res = _context.sent;

                  if (res) {
                    _context.next = 13;
                    break;
                  }

                  return _context.abrupt('return');

                case 13:
                  if (!(fileRawList.length > 0)) {
                    _context.next = 22;
                    break;
                  }

                  formData = new FormData();

                  fileRawList.map(function (item) {
                    formData.append('pic', item.raw);
                  });
                  _context.next = 18;
                  return _this4.uploadPic(formData);

                case 18:
                  picIds = _context.sent;

                  if (picIds) {
                    data.pic = picIds;
                    _this4.mode == 'save' ? _this4.handerSave(data) : _this4.handerUpdate(data);
                  }
                  _context.next = 23;
                  break;

                case 22:
                  _this4.mode == 'save' ? _this4.handerSave(data) : _this4.handerUpdate(data);

                case 23:
                  _context.next = 27;
                  break;

                case 25:
                  _this4.confirmLoading = true;
                  _this4.mode == 'save' ? _this4.handerSave(data) : _this4.handerUpdate(data);

                case 27:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this4);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handerSave: function handerSave(data) {
      var _this5 = this;

      data.payVisitDate = data.payVisitDate + ' 00:00:00';
      _index.API_userCom.addTrack(data).then(function (res) {
        if (res.data.code == 200) {
          _this5.$message.success('新增成功');
          _this5.$emit('getList');
          _this5.handerClose();
        }
        _this5.confirmLoading = false;
      }).catch(function (err) {
        _this5.confirmLoading = false;
      });
    },
    handerUpdate: function handerUpdate(data) {
      var _this6 = this;

      var date = data.payVisitDate;
      data.payVisitDate = date.indexOf('00:00:00') > -1 ? date : date + ' 00:00:00';
      delete data.contactUserName;
      delete data.adminUserName;
      _index.API_userCom.updateTrack(data).then(function (res) {
        if (res.data.code == 200) {
          _this6.$message.success('编辑成功');
          _this6.$emit('getList');
          _this6.handerClose();
        }
        _this6.confirmLoading = false;
      }).catch(function (err) {
        _this6.confirmLoading = false;
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handerClose: function handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false);
    }
  }

};

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(93);

var _index3 = _interopRequireDefault(_index2);

var _PictureList = __webpack_require__(776);

var _PictureList2 = _interopRequireDefault(_PictureList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    processDetail: {
      type: Object,
      default: function _default() {
        return null;
      }
    }

  },

  data: function data() {
    return {

      listLoading: false,
      confirmLoading: false,

      token: '',
      checkCode: '',
      myDetail: null,
      myVisible: false,
      commentNote: undefined,
      postLoading: false,
      commentList: [],
      isReply: false,
      replyObj: '',
      replyNote: undefined
    };
  },


  components: {
    PictureList: _PictureList2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    this.myVisible = this.visible;
  },
  mounted: function mounted() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.checkCode = checkCode;
    this.myDetail = JSON.parse((0, _stringify2.default)(this.processDetail));
    this.getCommentList();
  },


  methods: {
    handerSubmit: function handerSubmit(processInfo) {
      var _this = this;

      var data = JSON.parse((0, _stringify2.default)(processInfo));

      var param = {
        id: data.id,
        auditStatus: '2',
        companyId: data.companyId
      };
      _index.API_userCom.updateTrack(param).then(function (res) {
        if (res.data.code == 200) {
          _this.$message.success('审核成功');
          _this.$emit('getList');
          _this.handerClose();
        }
        _this.confirmLoading = false;
      }).catch(function (err) {
        _this.confirmLoading = false;
      });
    },
    handerClose: function handerClose() {
      console.log('handerCLose=');
      this.myVisible = false;
      this.$emit('update:visible', false);
    },
    getCommentList: function getCommentList() {
      var _this2 = this;

      console.log('userInfo', this.userInfo);
      var marketid = this.myDetail.id;
      _index.API_userCom.getComment(marketid).then(function (res) {
        if (res.data.code == 200) {
          _this2.commentList = res.data.data;
          var listDom = document.getElementsByClassName('list');
          console.log(218, listDom);
          listDom[0].scrollTop = 0;
        }
      }).catch(function (err) {});
    },
    postComment: function postComment() {
      var _this3 = this;

      this.postLoading = true;
      var params = {
        marketid: this.myDetail.id,
        userid: this.userInfo.id,
        note: this.commentNote
      };
      _index.API_userCom.addComment(params).then(function (res) {
        if (res.data.code == 200) {
          _this3.$message.success('评论成功');
          _this3.commentNote = undefined;
          _this3.getCommentList();
        } else {
          _this3.$message.error(res.data.message);
        }
        _this3.postLoading = false;
      }).catch(function () {
        _this3.postLoading = false;
      });
    },
    deleteComment: function deleteComment(item) {
      var _this4 = this;

      console.log(item, this.userInfo.id);
      if (item.userid != this.userInfo.id) {
        this.$message.warning('不允许删除别人的评论');
        return false;
      }
      _index.API_userCom.delComment(item.id).then(function (res) {
        console.log('delComment', res);
        if (res.data.code == 200) {
          _this4.$message.success('删除成功');
          _this4.getCommentList();
        } else {
          _this4.$message.error(res.data.message);
        }
      }).catch(function () {});
    },
    reply: function reply(item) {
      if (item.userid != this.userInfo.id) {
        this.replyObj = item.username;
        this.isReply = true;
      }
    },
    closeReply: function closeReply() {
      this.isReply = false;
      this.replyObj = '';
    },
    replyComment: function replyComment() {
      var _this5 = this;

      this.postLoading = true;
      var params = {
        marketid: this.myDetail.id,
        userid: this.userInfo.id,
        note: this.replyNote
      };
      _index.API_userCom.addComment(params).then(function (res) {
        if (res.data.code == 200) {
          _this5.$message.success('回复成功');
          _this5.replyNote = undefined;
          _this5.isReply = false;
          _this5.replyObj = '';
          _this5.getCommentList();
        } else {
          _this5.$message.error(res.data.message);
        }
        _this5.postLoading = false;
      }).catch(function () {
        _this5.postLoading = false;
      });
    }
  }
};

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _SelectCommon = __webpack_require__(76);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _ModalForm = __webpack_require__(1743);

var _ModalForm2 = _interopRequireDefault(_ModalForm);

var _ModalFormView = __webpack_require__(825);

var _ModalFormView2 = _interopRequireDefault(_ModalFormView);

var _index2 = __webpack_require__(93);

var _index3 = _interopRequireDefault(_index2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      listLoading: false,
      dataList: [],

      pageNumber: 1,
      pageSize: 20,
      total: 0,

      visible: false,
      visibleView: false,
      mode: 'save',

      searchVal: {
        searchText: '',
        payVisitStatus: '',
        auditStatus: '',
        managerAdminuser: '',
        payVisitDate: ''
      },

      selectedUserId: [],
      visitStatusList: [{ label: '电话沟通', value: '1' }, { label: '客户现场', value: '2' }, { label: '视频会议', value: '3' }],

      checkStatusList: [{ label: '待审核', value: '1' }, { label: '已审核', value: '2' }],

      processDetail: null,
      token: ''
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default,
    SelectCommon: _SelectCommon2.default,
    ModalForm: _ModalForm2.default,
    ModalFormView: _ModalFormView2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.getList();
  },


  methods: {
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      var data = (0, _extends3.default)({
        token: this.token,
        compayId: this.$route.query.companyId,
        page: this.pageNumber,
        size: this.pageSize
      }, this.searchVal);
      _index.API_userCom.getTrackList(data).then(function (res) {
        if (res.data.code == 200) {
          var _data = res.data.data;
          _this.dataList = _data.list;
          _this.total = _data.totalRow;
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.searchVal.managerAdminuser = value[0];
    },
    handerSectionChange: function handerSectionChange(data, column, event) {
      this.selectedUserId = data.length > 0 ? data.map(function (item) {
        return item.id;
      }) : [];
    },
    handerRowClick: function handerRowClick(row, column, event) {
      if (event.target.className.indexOf('dnnfont') > -1) {
        return;
      }
      this.$refs.companyTabRef.toggleRowSelection(row);
    },
    addForm: function addForm() {
      this.processDetail = null;
      this.visible = true;
      this.mode = 'save';
    },
    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this2.token,
          checkCode: _this2.checkCode,
          id: row.id,
          del: 0
        };
        _index.API_userCom.updateTrack(param).then(function (res) {
          if (res.data.code == 200) {
            _this2.$message({ message: '删除成功', type: 'success' });
            _this2.getList();
          } else {
            _this2.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this2.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    handleEdit: function handleEdit(index, row) {
      this.processDetail = row;
      this.visible = true;
      this.mode = 'update';
      console.log("handleEdit==", this.visible);
    },
    handleDetail: function handleDetail(index, row) {
      this.processDetail = row;
      this.visibleView = true;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    }
  }
};

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  inject: ['reload'],
  data: function data() {
    return (0, _defineProperty3.default)({
      ProductSelection: [],
      userSelection: [],
      disSouch2: true,
      fpTypes2: false,
      showDepart: false,
      fpType: '',
      dynamicTags2: [],
      souchs2: {},
      proName2: '',
      value2: '',
      deptid: '',
      fpType2: '',
      optionsSouch2: [{ value: '姓名', label: '姓名' }, { value: '手机号', label: '手机号' }, { value: '状态', label: '状态' }, { value: '部门', label: '部门' }],
      fpTypes: [{ value: '1', label: '已有产品' }, { value: '0', label: '未有产品' }],

      disSouch: true,
      disType1: false,
      disType2: false,
      souchs: {
        id: '',
        phone: '',
        name: '',
        souType: '',
        status: ''
      },
      proName: '',
      options: [{ value: 'ID', label: 'ID' }, { value: '用户', label: '用户' }, { value: '手机号', label: '手机号' }, { value: '名称', label: '名称' }, { value: '类型', label: '类型' }, { value: '状态', label: '状态' }],
      value: '',
      types: [{ value: '1', label: '试用' }, { value: '2', label: '正式' }],
      types2: [{ value: '1', label: '正常使用' }, { value: '3', label: '禁用' }],
      typeValue: '',
      typeValue2: '',
      dynamicTags: [],

      token: '',
      checkCode: '',
      id: '',
      proList: [],
      listLoading: false,
      pageNumber: 1,
      pageSize: 20,
      total: 1,
      companymanageid: '',
      pageNumber2: 1,
      pageSize2: 10,
      total2: 1,
      userList: [],
      userLoading: false,
      editLoading: false,
      editFormVisible: false,
      rname: '',
      checkUserId: '',
      checkUserIdOld: '',
      flag: false,
      productid: '',
      orderType: '',
      orderStr: '',

      batchType: 0,
      searchText: '',

      visibleDispatch: false,
      dispatchForm: {
        deptid: ''
      },
      dispatchRules: {
        deptid: [{ required: true, message: '请选择部门', trigger: 'change' }]
      },
      confirmDispatchLoading: false,
      departList: [],

      deptpx: ''
    }, 'orderType', '');
  },

  methods: {
    getDepartList: function getDepartList() {
      var _this2 = this;

      var data = {
        token: this.token,
        companyid: this.$route.query.companyId
      };
      _index.API_userCom.getDepartList(data).then(function (res) {
        if (res.data.code == 200) {
          _this2.departList = res.data.data || [];
        } else {
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {});
    },
    handerSubmitDispatch: function handerSubmitDispatch() {
      var _this3 = this;

      this.$refs['dispatchForm'].validate(function (valid) {
        if (valid) {
          _this3.confirmDispatchLoading = true;
          var data = {
            auproductid: _this3.ProductSelection.join(),
            deptid: _this3.dispatchForm.deptid
          };
          _index.API_userCom.dispatchProductToDepart(data).then(function (res) {
            if (res.data.code == 200) {
              _this3.$message.success('产品分配成功');
              _this3.handerCloseDispatch();
              _this3.getProList(1);
            } else {
              _this3.$message.error(res.data.message);
              if (res.data.code == 403) {
                _this3.$router.push({ path: 'loginAdmin' });
              }
            }
            _this3.confirmDispatchLoading = false;
          }).catch(function (err) {
            _this3.confirmDispatchLoading = false;
          });
        }
      });
    },
    handerCloseDispatch: function handerCloseDispatch() {
      this.visibleDispatch = false;
      this.$refs['dispatchForm'].resetFields();
    },
    selectTable: function selectTable(selection, row) {
      if (selection.length > this.ProductSelection.length) {
        var del_row = selection.shift();

        this.$refs.userList.toggleRowSelection(del_row, false);
      }
    },


    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == 'id') {
          this.orderStr = 'idpx';
        } else if (val.prop == 'productname') {
          this.orderStr = 'productnamepx';
        } else if (val.prop == 'name') {
          this.orderStr = 'namepx';
        } else if (val.prop == 'phone') {
          this.orderStr = 'phonepx';
        } else if (val.prop == 'duetime1') {
          this.orderStr = 'duetimepx';
        } else if (val.prop == 'typename') {
          this.orderStr = 'typepx';
        } else if (val.prop == 'usingstatusname') {
          this.orderStr = 'statuspx';
        } else if (val.prop == 'deptname') {
          this.orderStr = 'deptidpx';
        } else if (val.prop == 'userdeptname') {
          this.orderStr = 'userdeptnamepx';
        }
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
      }
      this.getProList();
    },
    changeSouch2: function changeSouch2(val) {
      if (val == '姓名') {
        this.disSouch2 = true;
        this.fpTypes2 = false;
        this.showDepart = false;
        this.proName2 = this.souchs2.name;
      } else if (val == '手机号') {
        this.disSouch2 = true;
        this.fpTypes2 = false;
        this.showDepart = false;
        this.proName2 = this.souchs2.phone;
      } else if (val == '状态') {
        this.disSouch2 = false;
        this.showDepart = false;
        this.fpTypes2 = true;
      } else if (val == '部门') {
        this.disSouch2 = false;
        this.fpTypes2 = false;
        this.showDepart = true;
      }
    },
    delTags2: function delTags2() {
      ;this.souchs2 = {}, this.value2 = '';
      this.fpType = '';
      this.proName2 = '';
      this.dynamicTags2 = [];
      this.getUser();
    },
    handleClose2: function handleClose2(tag) {
      if (tag == '姓名') {
        this.souchs2.name = '';
        if (this.value2 == '姓名') {
          this.proName2 = '';
        }
      }
      if (tag == '手机号') {
        this.souchs2.phone = '';
        if (this.value2 == '手机号') {
          this.proName2 = '';
        }
      }
      if (tag == '状态') {
        this.souchs2.fpType = '';
        this.fpType = '';
      }
      if (tag == '部门') {
        this.deptid = '';
      }
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1);
    },


    delTags: function delTags() {
      ;this.souchs = {}, this.souchs.souType = '';
      this.souchs.status = '';
      this.value = '';
      this.proName = '';
      this.typeValue = '';
      this.typeValue2 = '';
      this.dynamicTags = [];
      this.getProList();
    },
    handleClose: function handleClose(tag) {
      if (tag == 'ID') {
        this.souchs.id = '';
        if (this.value == 'ID') {
          this.proName = '';
        }
      }
      if (tag == '用户') {
        this.souchs.name = '';
        if (this.value == '用户') {
          this.proName = '';
        }
      }
      if (tag == '手机号') {
        this.souchs.phone = '';
        if (this.value == '手机号') {
          this.proName = '';
        }
      }
      if (tag == '名称') {
        this.souchs.productname = '';
        if (this.value == '名称') {
          this.proName = '';
        }
      }
      if (tag == '类型') {
        this.souchs.souType = '';
        this.typeValue = '';
      }
      if (tag == '状态') {
        this.souchs.status = '';
        this.typeValue2 = '';
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    changeSouch: function changeSouch(val) {
      if (val == '类型') {
        this.disSouch = false;
        this.disType1 = true;
        this.disType2 = false;
        this.proName = '';
        this.typeValue = this.souchs.souType;
      } else if (val == '状态') {
        this.disSouch = false;
        this.disType1 = false;
        this.disType2 = true;
        this.proName = '';
        this.typeValue2 = this.souchs.status;
      } else if (val == 'ID') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.id;
      } else if (val == '手机号') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.phone;
      } else if (val == '用户') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.name;
      } else if (val == '名称') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.productname;
      }
    },
    editSubmit: function editSubmit(type) {
      var _this4 = this;

      if (!this.checkUserId && type == 0) {
        this.$message.error('用户不可为空，请选择！');
        return;
      }
      var methods = 'setProduct';
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        managerid: this.$route.query.managerId,
        productid: this.productid,
        userid: this.checkUserId };
      if (type == 1) {
        methods = 'companyProductBatchDistribute';
        param['userid'] = this.userSelection + '';
        param['productid'] = this.ProductSelection + '';
      }
      this.editLoading = true;
      _index.API_userCom[methods](param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: '分配完成',
            type: 'success',
            center: true
          });
          _this4.editFormVisible = false;
          _this4.getProList();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'login' });
          }
        }
        _this4.editLoading = false;
      }).catch(function (err) {
        _this4.editLoading = false;
        _this4.$message.error('数据丢失，试试重新登陆！');
      });
    },

    changeFun: function changeFun() {
      var falg = false;
      for (var i = 0; i < this.userList.length; i++) {
        if (this.userList[i].checked == true) {
          falg = true;
          this.checkUserId = this.userList[i].id;
        }
      }
      if (!falg) {
        this.checkUserId = '';
      }
    },

    handleProductSelectionChange: function handleProductSelectionChange(row) {
      var list = [];
      if (row.length != 0) {
        row.map(function (item) {
          list.push(item.id);
        });
      }
      this.ProductSelection = list;
    },
    handleUserSelectionChange: function handleUserSelectionChange(row) {
      var list = [];
      if (row.length != 0) {
        row.map(function (item) {
          list.push(item.id);
        });
      }
      this.userSelection = list;
    },
    handleSelectionChange: function handleSelectionChange(row) {
      if (this.batchType == 0) {
        this.flag = true;
        if (row) {
          this.userList.forEach(function (item) {
            if (item.id !== row.id) {
              item.checked = false;
            }
            if (item.id == row.id) {
              item.checked = true;
            }
          });
        } else {
          this.userList.forEach(function (item) {
            item.checked = false;
          });
        }

        if (row.name == null) {
          row.name = '';
        }
        if (row.phone == null) {
          row.phone = '';
        }
        this.checkUserId = row.id;
        this.checkUserIdOld = row.id;
      }
    },


    getUser: function getUser(val) {
      var _this5 = this;

      if (this.value2 == '手机号') {
        this.souchs2.phone = this.proName2;
      }
      if (this.value2 == '姓名') {
        this.souchs2.name = this.proName2;
      }
      if (this.value2 == '状态') {
        this.souchs2.fpType = this.fpType;
      }
      var flag = true;
      if (val == 1) {
        this.pageNumber2 = 1;

        if (this.value2) {
          if (this.dynamicTags2.length > 0) {
            for (var i = 0; i < this.dynamicTags2.length; i++) {
              if (this.value2 == this.dynamicTags2[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags2.push(this.value2);
          }
        }
      }

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        listType: 'page',
        companyid: this.$route.query.companyId,

        phone: this.souchs2.phone,
        username: this.souchs2.name,
        hasproduct: this.souchs2.fpType,
        orderStr: this.deptpx,
        orderType: this.orderType,
        deptid: this.value2 == '部门' ? this.deptid : '' };
      this.userLoading = true;
      _index.API_userCom.userList(param).then(function (res) {
        _this5.userLoading = false;
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.list) {
            _this.userList = res.data.data.list;
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i]) {
                if (_this.rname && res.data.data.list[i].id == _this.rname) {
                  res.data.data.list[i].checked = true;
                } else {
                  res.data.data.list[i].checked = false;
                }
              }
            }
            if (res.data.data.totalRow) {
              _this.total2 = res.data.data.totalRow;
            }
          }
        } else {
          _this5.userLoading = false;
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'login' });
          }
        }
      }).catch(function (err) {
        _this5.userLoading = false;
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    handleDel: function handleDel(index, row) {
      var _this6 = this;

      this.$confirm('确认撤销吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this6.token,
          checkCode: _this6.checkCode,

          productid: row.id };
        _index.API_userCom.delProduct(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this6.$message({
              message: '撤销成功',
              type: 'success',
              center: true
            });
            _this6.getProList();
          } else {
            _this6.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this6.$router.push({ path: 'login' });
            }
          }
        }).catch(function (err) {
          _this6.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },

    handleDelDepart: function handleDelDepart(index, row) {
      var _this7 = this;

      this.$confirm('确认撤销吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this7.token,
          checkCode: _this7.checkCode,
          id: row.id };
        _index.API_userCom.delProductDepart(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this7.$message({ message: '撤销成功', type: 'success', center: true });
            _this7.getProList();
          } else {
            _this7.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this7.$router.push({ path: 'login' });
            }
          }
        }).catch(function (err) {
          _this7.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },

    handleEdit: function handleEdit(index, row) {
      this.productid = row.id;
      this.rname = '';
      this.rname = row.userid;
      this.batchType = 0;
      this.getUser();
      this.editFormVisible = true;
    },
    batch: function batch() {
      this.productid = '';
      this.rname = '';
      this.getUser();
      this.batchType = 1;
      this.editFormVisible = true;
    },

    getProList: function getProList(val) {
      var _this8 = this;

      if (this.value == 'ID') {
        this.souchs.id = this.proName;
      }
      if (this.value == '手机号') {
        this.souchs.phone = this.proName;
      }
      if (this.value == '用户') {
        this.souchs.name = this.proName;
      }
      if (this.value == '名称') {
        this.souchs.productname = this.proName;
      }
      if (this.value == '类型') {
        this.souchs.souType = this.typeValue;
      }
      if (this.value == '状态') {
        this.souchs.status = this.typeValue2;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        companyid: this.$route.query.companyId,
        id: this.souchs.id,
        name: this.souchs.name,
        phone: this.souchs.phone,
        productname: this.souchs.productname,

        type: this.typeValue,

        status: this.typeValue2,
        orderType: this.orderType,
        orderStr: this.orderStr,
        searchText: this.searchText
      };
      this.listLoading = true;
      _index.API_userCom.getList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].userid) {
              res.data.data.list[i].delShow = false;
            } else {
              res.data.data.list[i].delShow = true;
            }
            if (res.data.data.list[i].duetime) {
              res.data.data.list[i].duetime1 = res.data.data.list[i].duetime.substring(0, 10);
            }
          }
          _this8.proList = res.data.data.list;
          _this8.total = res.data.data.totalRow;
        } else {
          _this8.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this8.$router.push({ path: 'login' });
          }
        }
        _this8.listLoading = false;
      }).catch(function (err) {
        _this8.listLoading = false;
        _this8.$message.error('数据丢失，试试重新登陆！');
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return 'background:#F5F7FA';
      } else {
        return '';
      }
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getUser();
    },
    handleSizeChange2: function handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getUser();
    },
    handleSortChange2: function handleSortChange2(val) {
      if (val.order == null) {
        this.deptpx = '';
        this.orderType = '';
        this.getUser();
      } else {
        var order;
        if (val.order == 'descending') {
          order = 'desc';
        } else {
          order = 'asc';
        }
        this.deptpx = 'deptpx';
        this.orderType = order;
        this.getUser();
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getProList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getProList();
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  created: function created() {
    this.getCookie();
    this.getDepartList();
  },
  mounted: function mounted() {
    this.getProList();
  }
};

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  props: {
    adminVisible: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: String,
      default: ''
    },
    UserSelection: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      userSelection: [],
      adminList: [],
      userLoading: false,
      orderLoading: false,
      checkCode: '',
      token: ''
    };
  },

  watch: {
    UserSelection: function UserSelection(val) {
      this.adminList = this.adminList.concat(val);
    }
  },
  mounted: function mounted() {
    this.getCookie();
    this.getCompanyManage();
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    addAdmin: function addAdmin() {
      this.$emit("addAdmin");
    },
    adminVisibleClose: function adminVisibleClose() {
      this.$emit("adminVisibleClose");
    },
    getCompanyManage: function getCompanyManage(id) {
      var _this = this;

      var param = {
        companyId: this.companyId,
        token: this.token,
        checkCode: this.checkCode
      };
      this.userLoading = true;
      _index.API_Admin.getCompanyManage(param).then(function (res) {
        if (res.data.code == 200) {
          _this.adminList = res.data.data;
        }
        _this.userLoading = false;
      });
    },
    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm("确认删除吗?", "提示", {
        type: "warning"
      }).then(function () {
        _this2.adminList.splice(index, 1);
      });
    },
    orderUserSubmit: function orderUserSubmit() {
      this.$emit("orderUserSubmit", this.adminList);
    }
  }
};

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(93);

var _index3 = _interopRequireDefault(_index2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var echarts = __webpack_require__(119);
exports.default = {
  props: ['defalutd', 'comId'],

  data: function data() {
    return {
      creditLoading: false,
      rankLoading: false,
      moduleLoading: false,
      productLoading: false,
      deviceLoading: false,

      modulePieArr: [],
      chartObjArr: [],

      staTime: '1',
      moduleTime: '1',
      pieColor: ['#5C89FF', '#7C6AF2', ' #C95FF2', '#FF6383', '#5C89FF', '#FF9F40', '#FFCB48'],

      lineVisible: false,
      pieVisible: false,

      pageNumber: 1,
      pageSize: 6,
      total: 1,
      proCPlist: false,
      checkPerson2: '',
      person2: '1',
      funCheck: 1,
      products: [],
      proNum: 0,
      proXZ: 0,
      proGQ: 0,
      proJGQ: 0,

      optionsSouch: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '积分', label: '积分' }],

      checkCode: '',
      token: '',
      id: '',
      companyuseid: '',
      checkUser: '',
      checkUser2: '',
      checkUserId: "",
      checkUserId2: "",
      personVisible: false,
      pageSize2: 10,
      pageNumber2: 1,
      total2: 1,
      users: [],
      times: [{ value: '1', text: '最近一个月' }, { value: '3', text: '最近三个月' }, { value: '6', text: '最近六个月' }, { value: '12', text: '最近一年' }],
      persons: [{ value: "1", text: "企业" }, { value: "2", text: "个人" }],
      checkPerson: '',
      person: '1',
      values: [],


      customColor: '#409eff',
      customColors: [{ color: '#f56c6c', percentage: 20 }, { color: '#e6a23c', percentage: 40 }, { color: '#5cb87a', percentage: 60 }, { color: '#1989fa', percentage: 80 }, { color: '#6f7ad3', percentage: 100 }],
      flag: false,
      dynamicTags: [],
      proName: '',
      souchs: {},
      souch_value: '',
      dateTime: [],
      dataNum: [],
      masg: false,
      masg2: false,
      pieName: '',
      lineName: '',
      ranked: false,
      deviceCount: '1',

      dateRange: [],
      startTime: '',
      endTime: '' };
  },

  methods: {
    handleLine: function handleLine(id, name) {
      this.lineName = name;
      this.lineVisible = true;
      this.getUserMonthPointBrokenLine2(id);
    },
    handlePie: function handlePie(id, name) {
      this.pieName = name;
      this.pieVisible = true;
      this.getCompanyUserMonthModulePointPie2(id);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      if (this.ranked) {
        this.getCompanyUserMonthPointList();
      } else {
        this.getCompanyUserPointList();
      }
    },

    changeTime: function changeTime(method) {
      this[method]();
    },


    userSubmit: function userSubmit() {
      if (this.funCheck == 1) {
        this.checkPerson2 = this.checkUser2;
        this.getCompanyUserMonthModulePointPie(this.checkUserId2);
      } else {
        this.checkPerson = this.checkUser;
        this.getUserMonthPointBrokenLine(this.checkUserId);
      }
      this.personVisible = false;
    },
    changeSouch: function changeSouch(val) {
      if (val == "姓名") {
        this.proName = this.souchs.name;
      } else if (val == "账号") {
        this.proName = this.souchs.phone;
      } else if (val == "积分") {
        this.proName = this.souchs.point;
      }
    },
    delTags2: function delTags2() {
      this.souchs = {};
      this.proName = '';
      this.dynamicTags = [];
      this.getUser();
    },
    handleClose: function handleClose(tag) {
      if (tag == "姓名") {
        this.souchs.name = "";
        if (this.souch_value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "账号") {
        this.souchs.phone = "";
        if (this.souch_value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "积分") {
        this.souchs.point = "";
        if (this.souch_value == "积分") {
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
    },

    changeFun: function changeFun() {
      var falg = false;
      if (this.funCheck == 1) {
        for (var i = 0; i < this.users.length; i++) {
          if (this.users[i].checked == true) {
            falg = true;
            this.checkUserId2 = this.users[i].id;
          }
        }
        if (!falg) {
          this.checkUserId2 = "";
        }
      } else {
        for (var i = 0; i < this.users.length; i++) {
          if (this.users[i].checked == true) {
            falg = true;
            this.checkUserId = this.users[i].id;
          }
        }
        if (!falg) {
          this.checkUserId = "";
        }
      }
    },
    handleSelectionChange: function handleSelectionChange(row) {
      this.flag = true;
      this.users.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
        }
        if (item.id == row.id) {
          item.checked = true;
        }
      });
      if (row.name == null) {
        row.name = "";
      }
      if (row.phone == null) {
        row.phone = "";
      }
      if (this.funCheck == 1) {
        this.checkUser2 = row.name;
        this.checkUserId2 = row.id;
      } else {
        this.checkUser = row.name;
        this.checkUserId = row.id;
      }
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    handleUser: function handleUser(val) {
      this.funCheck = val;
      this.personVisible = true;
      this.getUser();
    },
    getUser: function getUser() {
      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        listType: 'page',

        companyid: this.comId
      };
      _index.API_Company.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i]) {
                if (_this.funCheck == 1) {
                  if (_this.checkUserId2 && res.data.data.list[i].id == _this.checkUserId2) {
                    res.data.data.list[i].checked = true;
                  } else {
                    res.data.data.list[i].checked = false;
                  }
                } else {
                  if (_this.checkUserId && res.data.data.list[i].id == _this.checkUserId) {
                    res.data.data.list[i].checked = true;
                  } else {
                    res.data.data.list[i].checked = false;
                  }
                }
              }
            }
            _this.total2 = res.data.data.totalRow;
            _this.users = res.data.data.list;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'login' });
          }
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    creditDrawLine: function creditDrawLine(dataTime, dataNumber) {
      var myChart = echarts.init(document.getElementById('creditLine'));
      this.chartObjArr.push(myChart);

      myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '3.5%',
          left: '2%',
          right: '6%',
          bottom: '5%',
          containLabel: true
        },

        dataZoom: [{
          type: 'inside'
        }],

        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dataTime,
          axisLine: {
            lineStyle: {
              color: '#DBDBDB'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#666",
              margin: 15
            }
          }
        },

        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: "#DBDBDB"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#666",
              margin: 15
            }
          },
          splitLine: {
            show: false
          }
        },
        series: [{
          name: '积分',
          type: 'line',
          stack: '总量',
          data: dataNumber,
          showBackground: false,
          smooth: true,
          color: '#F66B3D',
          symbol: 'none',
          areaStyle: {
            normal: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(249, 91, 71, 0.35)' }, {
                  offset: 0.7,
                  color: 'rgba(249, 91, 71, 0.01)' }],
                globalCoord: false }
            }
          }
        }]
      });
    },


    echart4: function echart4(dataTime, dataNumber) {
      var myChart = echarts.init(document.getElementById('echartZXT2'));
      myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '8%',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        dataZoom: [{
          type: 'inside'
        }],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dataTime,
          axisLine: {
            lineStyle: {
              color: '#DBDBDB'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#666",
              margin: 15
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: "#DBDBDB"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#666",
              margin: 15
            }
          },
          splitLine: {
            show: false
          }
        },
        series: [{
          name: '积分',
          type: 'line',
          stack: '总量',
          data: dataNumber,
          showBackground: false,
          smooth: true,
          color: '#F66B3D',
          symbol: 'none',
          areaStyle: {
            normal: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(249, 91, 71, 0.35)' }, {
                  offset: 0.7,
                  color: 'rgba(249, 91, 71, 0.01)' }],
                globalCoord: false }
            }
          }
        }]
      });
    },

    echartModule: function echartModule(data1, data2) {
      var _self = this;
      var myChart = echarts.init(document.getElementById('echartModule'));

      myChart.setOption({

        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },

        legend: {
          bottom: 10,
          left: 'center',
          data: data1,
          show: false
        },
        color: _self.pieColor,
        series: [{
          name: '模块名称',
          type: 'pie',
          radius: '50%',
          center: ['50%', '50%'],
          data: data2,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      });
    },


    echart3: function echart3(data1, data2) {
      var myChart = echarts.init(document.getElementById('echartBT2'));

      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: data1
        },
        series: [{
          name: '模块名称',
          type: 'pie',
          radius: '55%',
          center: ['50%', '45%'],
          data: data2,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
            normal: {
              color: function color(params) {
                var colorList = ['#CDDC39', '#E6EE9C', '#AEEA00', '#FFEA00', '#FFA000', '#FFCC80', '#F48FB1', '#FF5722', '#D50000', '#7B1FA2', '#7C4DFF', '#B388FF', '#3949AB', '#536DFE', '#8C9EFF', '#64B5F6', '#2196F3', '#607D8B', '#4CAF50', '#00E5FF', '#64FFDA'];
                return colorList[params.dataIndex];
              }
            }
          }
        }]
      });
    },

    getCookie: function getCookie() {
      this.id = sessionStorage.getItem('dnnypt_id');
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnypt_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnypt_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    getProductSum: function getProductSum() {
      var _this2 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.comId
      };
      _index.API_Stat.getProductSum(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this2.proNum = res.data.data[0].num;
          }
        }
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getGroupProductSum: function getGroupProductSum() {
      var _this3 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.comId
      };
      this.productLoading = true;
      _index.API_Stat.getGroupProductSum(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this3.proCPlist = true;
            _this.products = res.data.data;
          } else {
            _this3.proCPlist = false;
          }
          _this3.productLoading = false;
        }
      }).catch(function (err) {
        _this3.productLoading = false;
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getDueProductSum: function getDueProductSum() {
      var _this4 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.comId
      };
      _index.API_Stat.getDueProductSum(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this4.proGQ = res.data.data[0].num;
          }
        }
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getUnusedProductSum: function getUnusedProductSum() {
      var _this5 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.comId
      };
      _index.API_Stat.getUnusedProductSum(param).then(function (res) {

        if (res.data.code == _index.API__code.SUCCESS) {

          if (res.data.data.length > 0) {
            _this5.proXZ = res.data.data[0].num;
          }
        }
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getDueInMonthProductSum: function getDueInMonthProductSum() {
      var _this6 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.comId
      };
      _index.API_Stat.getDueInMonthProductSum(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this6.proJGQ = res.data.data[0].num;
          }
        }
      }).catch(function (err) {
        _this6.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCompanyUserPointList: function getCompanyUserPointList() {
      var _this7 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyuseid,

        pageNumber: 1,
        pageSize: 1000,
        listType: 'page'
      };
      this.rankLoading = true;
      _index.API_Stat.getCompanyUserPointList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.list.length > 0) {
            _this7.masg2 = true;
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i].sumpoint) {
                res.data.data.list[i].num = parseInt(res.data.data.list[i].sumpoint / res.data.maxPoint * 100);
                if (res.data.data.list[i].num < 30) {
                  _this7.customColor = '#f56c6c';
                } else if (res.data.data.list[i].num < 70) {
                  _this7.customColor = '#5cb87a';
                } else {
                  _this7.customColor = '#67c23a';
                }
              }
            }
            _this7.values = res.data.data.list;
            _this7.total = res.data.data.totalRow;
          } else {
            _this7.masg2 = false;
            _this7.values = [];
            _this7.total = 0;
          }
          _this7.rankLoading = false;
        }
      }).catch(function (err) {
        _this7.rankLoading = false;
        _this7.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCompanyUserMonthPointList: function getCompanyUserMonthPointList() {
      var _this8 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyuseid,

        pageNumber: 1,
        pageSize: 1000,
        listType: 'page',
        startTime: this.startTime || undefined,
        endTime: this.endTime || undefined
      };
      this.rankLoading = true;
      _index.API_Stat.getCompanyUserMonthPointList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.list.length > 0) {
            _this8.masg2 = true;
            var allsumpoint = 0;
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i].sumpoint) {
                res.data.data.list[i].num = parseInt(res.data.data.list[i].sumpoint / res.data.maxPoint * 100);
                if (res.data.data.list[i].num < 30) {
                  _this8.customColor = '#f56c6c';
                } else if (res.data.data.list[i].num < 70) {
                  _this8.customColor = '#5cb87a';
                } else {
                  _this8.customColor = '#67c23a';
                }
              }
            }
            _this8.values = res.data.data.list;
            _this8.total = res.data.data.totalRow;
          } else {
            _this8.masg2 = false;
            _this8.values = [];
            _this8.total = 0;
          }
          _this8.rankLoading = false;
        }
      }).catch(function (err) {
        _this8.rankLoading = false;
        _this8.$message.error('数据丢失，试试重新登陆！');
      });
    },

    ranking: function ranking(val) {
      if (val == 1) {
        this.ranked = false;
        this.dateRange = [];
        this.startTime = '';
        this.endTime = '';
        this.getCompanyUserPointList();
      } else {
        this.ranked = true;
        var tempDate = _index3.default.getNear30DaysStartDateAndEndDate();
        this.dateRange = [tempDate.startDate, tempDate.endDate];
        this.startTime = tempDate.startDate;
        this.endTime = tempDate.endDate;
        console.log('tempDate', tempDate);
        console.log('this.dateRange', this.dateRange);
        console.log('this.startTime', this.startTime);
        console.log('this.endTime', this.endTime);

        this.getCompanyUserMonthPointList();
      }
    },
    changeDateRange: function changeDateRange(val) {
      if (val && val.length > 0) {
        this.startTime = val[0];
        this.endTime = val[1];
      } else {
        this.startTime = '';
        this.endTime = '';
      }
      console.log('this.startTime', this.startTime, 'this.endTime', this.endTime);

      this.getCompanyUserMonthPointList();
    },

    getCompanyMonthPointBrokenLine: function getCompanyMonthPointBrokenLine() {
      var _this9 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyuseid,
        count: this.staTime
      };
      this.creditLoading = true;
      _index.API_Stat.getCompanyMonthPointBrokenLine(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this9.dateTime = [];
          _this9.dataNum = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this9.dateTime.push(res.data.data[i].date);
            _this9.dataNum.push(res.data.data[i].sumpoint);
          }
          _this9.creditDrawLine(_this9.dateTime, _this9.dataNum);
          _this9.creditLoading = false;
        }
      });
    },

    getUserMonthPointBrokenLine: function getUserMonthPointBrokenLine(id) {
      var _this10 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: id
      };
      _index.API_Stat.getUserMonthPointBrokenLine(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this10.dateTime = [];
          _this10.dataNum = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this10.dateTime.push(res.data.data[i].date.substring(6));
            _this10.dataNum.push(res.data.data[i].sumpoint);
          }
          _this10.creditDrawLine(_this10.dateTime, _this10.dataNum);
        }
      });
    },

    getUserMonthPointBrokenLine2: function getUserMonthPointBrokenLine2(id) {
      var _this11 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: id
      };
      _index.API_Stat.getUserMonthPointBrokenLine(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this11.dateTime = [];
          _this11.dataNum = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this11.dateTime.push(res.data.data[i].date.substring(5).replace(/-/g, "月") + '日');
            _this11.dataNum.push(res.data.data[i].sumpoint);
          }
          _this11.echart4(_this11.dateTime, _this11.dataNum);
        }
      });
    },

    getCompanyMonthModulePointPie: function getCompanyMonthModulePointPie() {
      var _this12 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyuseid,
        count: this.moduleTime
      };
      this.moduleLoading = true;
      _index.API_Stat.getCompanyMonthModulePointPie(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this12.masg = false;
          } else {
            _this12.masg = true;
          }
          _this12.modulePieArr = res.data.data;
          var modulenames = [];
          var modul = [];
          for (var i = 0; i < res.data.data.length; i++) {
            modulenames.push(res.data.data[i].modulename);
            var json = { value: res.data.data[i].sumpoint, name: res.data.data[i].modulename };
            modul.push(json);
          }
          _this12.echartModule(modulenames, modul);
          _this12.moduleLoading = false;
        }
      });
    },

    getCompanyUserMonthModulePointPie: function getCompanyUserMonthModulePointPie(id) {
      var _this13 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: id
      };
      _index.API_Stat.getCompanyUserMonthModulePointPie(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this13.masg = false;
          } else {
            _this13.masg = true;
          }
          var modulenames = [];
          var modul = [];
          for (var i = 0; i < res.data.data.length; i++) {
            modulenames.push(res.data.data[i].modulename);
            var json = { value: res.data.data[i].sumpoint, name: res.data.data[i].modulename };
            modul.push(json);
          }

          _this13.echartModule(modulenames, modul);
        }
      });
    },

    getCompanyUserMonthModulePointPie2: function getCompanyUserMonthModulePointPie2(id) {
      var _this14 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: id
      };
      _index.API_Stat.getCompanyUserMonthModulePointPie(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this14.masg = false;
          } else {
            _this14.masg = true;
          }
          var modulenames = [];
          var modul = [];
          for (var i = 0; i < res.data.data.length; i++) {
            modulenames.push(res.data.data[i].modulename);
            var json = { value: res.data.data[i].sumpoint, name: res.data.data[i].modulename };
            modul.push(json);
          }
          _this14.echart3(modulenames, modul);
        }
      });
    },

    getOptionBar: function getOptionBar(data) {
      var option = {
        color: ['#F66B3D', '#3DBFF6'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          }
        },
        grid: {
          left: '95px',
          right: '6%',
          top: '1%',
          bottom: '0'
        },

        xAxis: {
          type: 'value',

          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          }

        },

        yAxis: {
          type: 'category',
          data: ['企业用户(人)', '登录设备(台)'],

          splitLine: {
            show: false
          },

          axisTick: { show: false },

          axisLine: {
            show: false
          },

          axisLabel: {
            show: true,
            margin: 12,
            fontSize: '14',
            color: '#666'
          }
        },

        series: [{
          type: 'bar',
          data: [data.userCount, data.hardHashCount],
          barGap: '50%',
          barWidth: 20,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'right',
                textStyle: {
                  fontSize: 14
                }
              },
              color: function color(params) {
                var colorList = ['#3DBFF6', '#F66B3D'];
                return colorList[params.dataIndex];
              }
            }
          }
        }]
      };
      return option;
    },
    initChartDevice: function initChartDevice(data) {
      var myChart = echarts.init(document.getElementById('device-chart'));

      var option = this.getOptionBar(data);
      option && myChart.setOption(option);
      this.chartObjArr.push(myChart);
    },
    getDeviceInfo: function getDeviceInfo() {
      var _this15 = this;

      console.log('getDeviceInfo');
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: this.id,
        count: this.deviceCount,
        companyid: this.$route.query.companyId
      };
      this.deviceLoading = true;
      _index.API_Stat.getLoginDevice(param).then(function (res) {
        if (res.data.code == 200) {
          var data = res.data.data;
          data.userCount = parseInt(data.userCount);
          _this15.initChartDevice(res.data.data);
          console.log('res.data==getDeviceInfo', res.data);
        }
        _this15.deviceLoading = false;
      }).then(function (err) {
        _this15.deviceLoading = false;
      });
    },
    chartResize: function chartResize() {
      if (this.chartObjArr.length > 0) {
        this.chartObjArr.forEach(function (item) {
          return item.resize();
        });
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.chartResize);
  },
  mounted: function mounted() {

    window.addEventListener("resize", this.chartResize);
    this.getProductSum();
    this.getGroupProductSum();
    this.getDueProductSum();
    this.getUnusedProductSum();
    this.getDueInMonthProductSum();

    this.ranking(2);
    this.getCompanyMonthPointBrokenLine();
    this.getCompanyMonthModulePointPie();

    this.getDeviceInfo();
  },

  watch: {},
  created: function created() {
    this.companyuseid = this.comId;
    this.getCookie();
  }
};

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  data: function data() {
    return {
      value1: true,
      checkCode: '',
      token: ''
    };
  },
  created: function created() {
    var _this = this;

    this.getCookie();
    var param = {
      id: this.$route.query.companyId,
      token: this.token,
      checkCode: this.checkCode
    };
    _index.API_Admin.getCompany(param).then(function (res) {
      _this.value1 = res.data.data.isbinding == 1 ? true : false;
    });
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    submit: function submit() {
      var _this2 = this;

      var param = {
        id: this.$route.query.companyId,
        isbinding: this.value1 ? 1 : 0,
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.hardwareBinding(param).then(function (res) {
        _this2.$message.success("修改成功");
      });
    }
  }
};

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DetailPage = __webpack_require__(232);

var _DetailPage2 = _interopRequireDefault(_DetailPage);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      modulename: this.$route.query.modulename,
      tiemSlot: [this.$route.query.startData, this.$route.query.endDate],
      order: '',
      orderType: 'desc',
      showzero: 1,
      mokuais: [{
        value: 1,
        label: '显示不为0的数据'
      }, {
        value: 2,
        label: '显示为0的数据'
      }],
      count: this.$route.query.count,
      jifen: this.$route.query.jifen,
      token: '',
      checkCode: '',
      id: '',
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      moduleid: this.$route.query.moduleid,
      list: [],
      params: {
        type: this.$route.query.type,
        pageNumber: this.$route.query.pageNumber,
        pageSize: this.$route.query.pageSize
      }
    };
  },

  components: {
    DetailPage: _DetailPage2.default
  },
  mounted: function mounted() {
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; ');
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=');
        if (arr2[0] == 'dnnyptadmin_token') {
          this.token = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_checkCode') {
          this.checkCode = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_id') {
          this.id = arr2[1];
        }
      }
    }
    this.getData();
  },

  methods: {
    downFile: function downFile() {
      var _this = this;

      var downHref = _index.API__DailyStatistic.exportmodellist() + '?token=' + this.token + '&checkCode=' + this.checkCode + '&orderType=' + this.orderType + '&moduleid=' + this.moduleid + '&dBegin=' + this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD') + '&dEnd=' + this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD') + '&order=' + this.order + '&listType=page' + '&pageSize=9999' + '&pageNumber=1' + '&showzero=1' + '&modulename=' + this.modulename;

      var a = document.createElement('a');

      fetch(downHref).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        a.href = URL.createObjectURL(blob);
        a.download = _this.modulename;
        document.body.appendChild(a);
        a.click();
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleSortChange: function handleSortChange(val) {
      if (val.order == null) {
        this.order = '';
        this.orderType = '';
        this.getData();
      } else {
        this.order = val.prop;
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
        this.getData();
      }
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    create: function create(item) {
      var idStr = Date.now().toString(36);
      idStr += Math.random().toString(36).substr(3);
      return idStr;
    },
    changeData: function changeData() {
      this.getData();
    },
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        order: this.order,
        orderType: this.orderType,
        moduleid: this.moduleid,
        dBegin: this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD'),
        dEnd: this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD'),
        showzero: this.showzero
      };
      _index.API__DailyStatistic.getTbModuleDetails(param).then(function (res) {
        _this2.loading = false;
        _this2.list = res.data.data.list;
        _this2.total = res.data.data.totalRow;
        _this2.count = res.data.data.totalRow;
      });
    },
    indexchange: function indexchange(index) {
      if (index == 0) {
        return 'contextEc1';
      } else if (index == 1) {
        return 'contextEc2';
      } else {
        if (index % 2 == 0) {
          return 'contextEc3';
        } else {
          return 'contextEc4';
        }
      }
    }
  }
};

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DetailPage = __webpack_require__(232);

var _DetailPage2 = _interopRequireDefault(_DetailPage);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      modulename: this.$route.query.modulename,
      tiemSlot: [this.$route.query.startData, this.$route.query.endDate],
      order: '',
      orderType: 'desc',
      mokuais: [{
        value: 1,
        label: '显示不为0的数据'
      }, {
        value: 2,
        label: '显示为0的数据'
      }],
      count: this.$route.query.count,
      jifen: this.$route.query.jifen,
      token: '',
      checkCode: '',
      id: '',
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      moduleid: this.$route.query.moduleid,
      list: [],
      params: {
        type: this.$route.query.type,
        moduleid: this.$route.query.moduleid,
        pageNumber: this.$route.query.pageNumber,
        pageSize: this.$route.query.pageSize
      },

      personalPointsDialogTitle: '积分详情',
      personalPointsVisible: false,
      personalPointsList: [],
      personalPointsListParams: {
        userid: '',
        moduleid: '',
        dBegin: '',
        dEnd: '',
        listType: 'page',
        pageNumber: 1,
        pageSize: 20
      },
      personalPointsTotal: 0
    };
  },

  components: {
    DetailPage: _DetailPage2.default
  },
  mounted: function mounted() {
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; ');
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=');
        if (arr2[0] == 'dnnyptadmin_token') {
          this.token = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_checkCode') {
          this.checkCode = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_id') {
          this.id = arr2[1];
        }
      }
    }
    this.getData();
  },

  methods: {
    detailUser: function detailUser(index, row) {
      console.log(index, row);
      this.personalPointsDialogTitle = row.username + '的积分详情';
      this.personalPointsListParams.userid = row.userid;
      this.personalPointsListParams.moduleid = this.moduleid;
      this.personalPointsListParams.dBegin = this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD');
      this.personalPointsListParams.dEnd = this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD');
      this.personalPointsListParams.listType = 'page';
      this.personalPointsListParams.pageNumber = 1;
      this.personalPointsListParams.pageSize = 20;
      this.personalPointsVisible = true;
      console.log(129, this.personalPointsListParams);
    },
    getPersonalPointsList: function getPersonalPointsList() {
      var _this = this;

      this.personalPointsListParams.token = this.token;
      this.personalPointsListParams.checkCode = this.checkCode;
      _index.API__DailyStatistic.getUserPointWithCmdByLog(this.personalPointsListParams).then(function (res) {
        console.log(139, res);
        if (res.data.code == 200) {
          _this.personalPointsList = res.data.data.list;
          _this.personalPointsTotal = res.data.data.totalRow;
        } else {
          _this.$message.error(res.data.message);
        }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleSizeChangePP: function handleSizeChangePP(val) {
      this.personalPointsListParams.pageSize = val;
      this.getPersonalPointsList();
    },
    handleSortChange: function handleSortChange(val) {
      if (val.order == null) {
        this.order = '';
        this.orderType = '';
        this.getData();
      } else {
        this.order = val.prop;
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
        this.getData();
      }
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    create: function create(item) {
      var idStr = Date.now().toString(36);
      idStr += Math.random().toString(36).substr(3);
      return idStr;
    },
    changeData: function changeData() {
      this.getData();
    },
    changeDataPP: function changeDataPP() {
      this.getPersonalPointsList();
    },
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        order: this.order,
        orderType: this.orderType,
        moduleid: this.moduleid,
        dBegin: this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD'),
        dEnd: this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD')
      };
      _index.API__DailyStatistic.getModuleUser(param).then(function (res) {
        _this2.loading = false;
        _this2.list = res.data.data.list;
        _this2.total = res.data.data.totalRow;
        _this2.count = res.data.data.totalRow;
      });
    },
    indexchange: function indexchange(index) {
      if (index == 0) {
        return 'contextEc1';
      } else if (index == 1) {
        return 'contextEc2';
      } else {
        if (index % 2 == 0) {
          return 'contextEc3';
        } else {
          return 'contextEc4';
        }
      }
    },
    downFile: function downFile() {
      var downHref = _index.API__DailyStatistic.getUserPointExcel() + '?token=' + this.token + '&checkCode=' + this.checkCode + '&orderType=' + this.orderType + '&moduleid=' + this.moduleid + '&dBegin=' + this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD') + '&dEnd=' + this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD') + '&order=' + this.order + '&listType=page' + '&pageSize=' + this.count;

      var a = document.createElement('a');

      fetch(downHref).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        a.href = URL.createObjectURL(blob);
        a.download = '模块用户积分列表';
        document.body.appendChild(a);
        a.click();
      });
    }
  },
  watch: {
    personalPointsVisible: function personalPointsVisible(newVal) {
      if (newVal) {
        this.getPersonalPointsList();
      }
    }
  }
};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      token: '',
      checkCode: '',
      id: '',
      souchs: {},
      typeList: [],
      listLoading: false,
      pageNumber: 1,
      total: 0,
      pageSize: 20,

      addForm: {},
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: '请输入类型名称', trigger: 'blur' }]

      },

      editFormVisible: false,
      editForm: {},
      editLoading: false,
      editFormRules: {
        name: [{ required: true, message: '请输入类型名称', trigger: 'blur' }]
      },
      orderType: '',
      orderStr: ''
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
    },
    editSubmit: function editSubmit() {
      var _this = this;

      if (!this.editForm.name) {
        this.$message.error('类型名称不可为空！');
        return;
      }
      if (!this.editForm.code && this.editForm.code != 0) {
        this.$message.error('类型ID不可为空！');
        return;
      }
      var param = {
        id: this.editForm.id,
        token: this.token,
        checkCode: this.checkCode,
        mode: '',
        code: this.editForm.code,
        name: this.editForm.name
      };
      this.editLoading = true;
      _index.API_Menu.upTypeList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.$message({
            message: '修改成功',
            type: 'success'
          });
          _this.getTypeList();
        } else {
          _this.$message.error(res.data.message);
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.editLoading = false;
        _this.editFormVisible = false;
      }).catch(function (err) {
        _this.editLoading = false;
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm('确认删除该类型吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var para = {
          id: row.id,
          token: _this2.token,
          checkCode: _this2.checkCode
        };
        _index.API_Menu.delTypeList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this2.$message({
              message: '删除成功',
              type: 'success'
            });
            _this2.getTypeList();
          } else {
            _this2.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function () {
          _this2.$message.error('服务器异常，请您稍后再试..');
        });
      });
    },

    addSubmit: function addSubmit() {
      var _this3 = this;

      if (!this.addForm.name) {
        this.$message.error('类型名称不可为空！');
        return;
      }
      if (!this.addForm.code && this.addForm.code != 0) {
        this.$message.error('类型ID不可为空！');
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        code: this.addForm.code,
        name: this.addForm.name
      };
      this.addLoading = true;
      _index.API_Menu.upTypeList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '添加成功',
            type: 'success'
          });
          _this3.getTypeList();
        } else {
          _this3.$message.error(res.data.message);
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
        _this3.addLoading = false;
        _this3.addFormVisible = false;
      }).catch(function (err) {
        _this3.addLoading = false;
        _this3.$message.error('服务器异常，请您稍后再试..');
      });
    },
    handleAdd: function handleAdd() {
      this.addFormVisible = true;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getTypeList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTypeList();
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "code") {
          this.orderStr = "codepx";
        } else if (val.prop == "intime") {
          this.orderStr = "intimepx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getTypeList();
    },
    getTypeList: function getTypeList(val) {
      var _this4 = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        searchStr: this.souchs.name,
        orderType: this.orderType,
        orderStr: this.orderStr
      };
      _index.API_Menu.getTypeList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.total = res.data.data.totalPage;
          _this4.typeList = res.data.data.list;
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this4.$message.error('服务器异常，请您稍后再试..');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }

  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getTypeList();
  }
};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

var _jquery = __webpack_require__(269);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      editFormList: {},
      editVisibleList: false,
      editLoadingList: false,
      editListSouch: {},

      addListVisible: false,
      addListForm: {},
      addListLoading: false,

      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,

      souchs: {
        modelName: ''
      },
      token: '',
      checkCode: '',
      id: '',
      listLoading: false,
      models: [],
      total: 0,
      pageNumber: 1,
      pageSize: 20,
      addForm: {
        moduleid: '',
        modulename: ''
      },
      addFormRules: {
        modulename: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        moduleid: [{ required: true, message: '请输入模块ID', trigger: 'blur' }]
      },
      addFormVisible: false,
      addLoading: false,

      editForm: {
        moduleid: '',
        modulename: ''
      },
      editLoading: false,
      editFormRules: {
        modulename: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        moduleid: [{ required: true, message: '请输入模块ID', trigger: 'blur' }]
      },
      editFormVisible: false,

      modulenames: '',
      moduleids: '',
      editList: [],
      editListVisible: false,
      editListLoading: false,
      orderType: '',
      orderStr: '',

      importLoading: false,
      exportModuleUrl: ''
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    handleExportModule: function handleExportModule() {
      var _this = this;

      if (!this.exportModuleUrl) {
        this.$message.error('导出地址无效！');
        return;
      }
      var now = new Date();
      var y = now.getFullYear();
      var m = String(now.getMonth() + 1).padStart(2, '0');
      var d = String(now.getDate()).padStart(2, '0');
      var fileName = (this.modulenames || '模块命令') + y + m + d + '.xlsx';

      var a = document.createElement("a");
      fetch(this.exportModuleUrl).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        a.href = URL.createObjectURL(blob);
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
      }).catch(function () {
        _this.$message.error('导出失败！');
      });
    },
    importModuleFile: function importModuleFile(filex) {
      var file = filex.target.files[0];
      console.log('file', file);
      var formData = new FormData();
      formData.append('file', file);

      var that = this;
      if (!file) {
        that.$message.error('请选择文件！');
        return;
      }
      that.importLoading = true;
      _jquery2.default.ajax({
        url: _index.API_Models.importAdminModule() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&parentid=" + this.moduleids,
        type: "post",
        data: formData,
        processData: false,
        contentType: false,
        dataType: "json",
        timeout: 180000,
        success: function success(res) {
          if (res.code == 200) {
            that.$message.success(res.message);
          } else {
            that.$message.error(res.message);
          }
          that.importLoading = false;
          that.$refs.clearFileModal.value = '';
          that.getZJ(1);
        },
        error: function error(err) {
          that.$message.error(res.message);
          that.importLoading = false;
          that.$refs.clearFileModal.value = '';
        }
      });
    },

    editSubmit: function editSubmit() {
      var _this2 = this;

      if (!this.editForm.modulename && this.editForm.modulename != 0) {
        this.$message.error('名称不可为空！');
        return;
      };
      if (!this.editForm.moduleid && this.editForm.moduleid != 0) {
        this.$message.error('模块ID不可为空！');
        return;
      };
      var param = {
        id: this.editForm.id,
        token: this.token,
        checkCode: this.checkCode,
        mode: 'update',
        moduleid: this.editForm.moduleid,
        modulename: this.editForm.modulename
      };
      this.editLoading = true;
      _index.API_Models.setAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: '新增成功',
            type: 'success',
            center: true
          });

          _this2.editFormVisible = false;
          _this2.getModels();
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.editLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.editLoading = false;
      });
    },
    addSubmit: function addSubmit() {
      var _this3 = this;

      if (!this.addForm.modulename && this.addForm.modulename != 0) {
        this.$message.error('名称不可为空！');
        return;
      };
      if (!this.addForm.moduleid && this.addForm.moduleid != 0) {
        this.$message.error('模块ID不可为空！');
        return;
      };
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        moduleid: this.addForm.moduleid,
        modulename: this.addForm.modulename
      };
      this.addLoading = true;
      _index.API_Models.setAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '新增成功',
            type: 'success',
            center: true
          });

          _this3.addFormVisible = false;
          _this3.getModels();
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
        _this3.addLoading = false;
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
        _this3.addLoading = false;
      });
    },

    handleAdd: function handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        name: '',
        modelID: ''
      };
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getModels();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getModels();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getZJ();
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "modulename") {
          this.orderStr = "modulenameOrder";
        } else if (val.prop == "moduleid") {
          this.orderStr = "moduleidOrder";
        } else if (val.prop == "intime") {
          this.orderStr = "intimeOrder";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getModels();
    },
    getModels: function getModels(val) {
      var _this4 = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        searchModuleName: this.souchs.modelName,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,

        orderStr: this.orderStr,
        orderType: this.orderType
      };
      this.listLoading = true;
      _index.API_Models.getAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            _this4.total = res.data.data.totalRow;
            _this4.models = res.data.data.list;
          }
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
        _this4.listLoading = false;
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
        _this4.listLoading = false;
      });
    },

    handleDel: function handleDel(index, row) {
      var _this5 = this;

      this.$confirm('确认删除该模块吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var para = {
          id: row.id,
          token: _this5.token,
          checkCode: _this5.checkCode
        };
        _index.API_Models.delAdminModule(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this5.$message({
              message: '删除成功',
              type: 'success'
            });
            _this5.getModels();
          } else {
            _this5.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this5.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this5.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },

    handleList: function handleList(index, row) {
      this.editListVisible = true;
      this.modulenames = row.modulename;
      this.moduleids = row.moduleid;

      this.exportModuleUrl = _index.API_Models.exportAdminModule() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&parentid=" + this.moduleids;

      this.getZJ();
    },
    getZJ: function getZJ(val) {
      var _this6 = this;

      if (val == 1) {
        this.pageNumber2 = 1;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        parentid: this.moduleids,
        searchStr: this.editListSouch.name,
        listType: 'page',
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2
      };
      _index.API_Models.getAdminModuleTwo(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this6.total2 = res.data.data.totalRow;
          _this6.editList = res.data.data.list;
        }
      }).catch(function (err) {
        _this6.$message.error('数据丢失，试试重新登陆！');
      });
    },
    editListDel: function editListDel(index, row) {
      var _this7 = this;

      this.$confirm('确认删除该模块吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this7.token,
          checkCode: _this7.checkCode,
          id: row.id,
          parentid: _this7.moduleids,
          moduleid: row.moduleid
        };
        _index.API_Models.delAdminModule(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this7.$message({
              message: '删除成功',
              type: 'success'
            });
            _this7.getZJ();
          }
        }).catch(function (err) {
          _this7.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },

    editSubmitList: function editSubmitList() {
      var _this8 = this;

      if (!this.editFormList.modulename && this.editFormList.modulename != 0) {
        this.$message.error('名称不可为空！');
        return;
      }
      if (!this.editFormList.moduleid && this.editFormList.moduleid != 0) {
        this.$message.error('模块ID不可为空！');
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,

        id: this.editFormList.id,
        moduleid: this.editFormList.moduleid,
        modulename: this.editFormList.modulename,
        mode: '',
        point: this.editFormList.point
      };
      this.editLoadingList = true;
      _index.API_Models.setAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this8.$message({
            message: '修改成功',
            type: 'success'
          });
          _this8.getZJ();
        } else {
          _this8.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this8.$router.push({ path: 'loginAdmin' });
          }
        }
        _this8.editLoadingList = false;
        _this8.editVisibleList = false;
      }).catch(function (err) {
        _this8.editLoadingList = false;
        _this8.$message.error('数据丢失，试试重新登陆！');
      });
    },

    editListEdit: function editListEdit(index, row) {
      this.editVisibleList = true;
      this.editFormList = (0, _assign2.default)({}, row);
    },
    editListAdd: function editListAdd() {
      this.addListVisible = true;
    },
    addListSubmit: function addListSubmit() {
      var _this9 = this;

      if (!this.addListForm.modulename) {
        this.$message.error('名称不可为空！');
        return;
      }
      if (!this.addListForm.moduleid) {
        this.$message.error('模块ID不可为空！');
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        parentid: this.moduleids,
        moduleid: this.addListForm.moduleid,
        modulename: this.addListForm.modulename,
        mode: 'save',
        point: this.addListForm.point
      };
      this.addListLoading = true;
      _index.API_Models.setAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this9.$message({
            message: '添加成功',
            type: 'success'
          });
          _this9.getZJ();
        } else {
          _this9.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this9.$router.push({ path: 'loginAdmin' });
          }
        }
        _this9.addListLoading = false;
        _this9.addListVisible = false;
      }).catch(function (err) {
        _this9.addListLoading = false;
        _this9.$message.error('数据丢失，试试重新登陆！');
      });
    },
    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }

  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getModels();
  }
};

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(139);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(93);

var _index3 = _interopRequireDefault(_index2);

var _PictureList = __webpack_require__(776);

var _PictureList2 = _interopRequireDefault(_PictureList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    productInfo: {
      type: Object,
      default: function _default() {
        return null;
      }
    }

  },

  data: function data() {
    return {

      confirmLoading: false,

      token: '',
      checkCode: '',
      myDetail: null,
      myVisible: false,
      totalPrice: 0
    };
  },


  components: {
    PictureList: _PictureList2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  }), {
    evaluatePrice: function evaluatePrice() {
      var _myDetail = this.myDetail,
          purchaseNum = _myDetail.purchaseNum,
          price = _myDetail.price,
          purchaseMonth = _myDetail.purchaseMonth;

      var money = 0;
      money = purchaseNum * purchaseMonth * price;
      this.totalPrice = money;
      return money;
    }
  }),

  created: function created() {
    this.myVisible = this.visible;
  },
  mounted: function mounted() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.checkCode = checkCode;
    this.myDetail = JSON.parse((0, _stringify2.default)(this.productInfo));

    this.myDetail.purchaseMonth = 1;
  },


  methods: {
    handleChangeNum: function handleChangeNum(val, data, key) {
      console.log("val==", val, typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val));
    },
    handerSubmit: function handerSubmit(processInfo) {
      var _this = this;

      console.log('processInfo==', processInfo);
      var orderId = processInfo.orderId,
          singlePrice = processInfo.singlePrice,
          productId = processInfo.productId,
          purchaseMonth = processInfo.purchaseMonth;

      var data = {
        id: orderId,
        productId: productId,
        purchaseMonth: purchaseMonth,
        price: this.totalPrice,
        singlePrice: singlePrice
      };
      this.confirmLoading = true;

      _index.API_Order.renewOrder(data).then(function (res) {
        if (res.data.code == 200) {
          _this.$message.success('续订成功');
          _this.$emit('getDetail');
          _this.handerClose();
        }
        _this.confirmLoading = false;
      }).catch(function (err) {
        _this.confirmLoading = false;
      });
    },
    handerClose: function handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false);
    }
  }
};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = __webpack_require__(294);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(93);

var _index3 = _interopRequireDefault(_index2);

var _DetailPage = __webpack_require__(232);

var _DetailPage2 = _interopRequireDefault(_DetailPage);

var _SelectedProduct = __webpack_require__(785);

var _SelectedProduct2 = _interopRequireDefault(_SelectedProduct);

var _vuex = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _ref;

    return _ref = {
      searchText: '',
      effectiveTime: new Date(),
      effectiveTimeSfm: '00:00:00',
      proName3: "",
      dynamicTags3: [],
      options3: [{ value: 'ID', label: 'ID' }, { value: '企业名称', label: '企业名称' }, { value: '管理员', label: '管理员' }],

      person: '1',
      persons: [{ value: "1", text: "个人用户" }, { value: "2", text: "企业用户" }],

      orderType: '1',
      orderTypes: [{ value: '1', label: '试用订单' }, { value: '2', label: '正式订单' }],

      mode: 'save',
      orderId: '',
      processDetail: null,

      proList: [],
      selectProList: [],
      listLoading: false,
      totalPrice: 0,

      value3: '',

      souchs2: {},
      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName: "",
      dynamicTags: [],
      optionsSouch: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '软件类型', label: '软件类型' }, { value: '邀请状态', label: '邀请状态' }, { value: '开始日期', label: '开始日期' }, { value: '结束日期', label: '结束日期' }],
      value: '',
      inviValues: [],
      softtypes: [],

      souchs3: {
        name: ''
      },
      personList: [],
      personVisible: false,
      personLoading: false,
      pageNumber3: 1,
      pageSize3: 10,
      total3: 0,
      orderLoading: false,
      checkPerson: '',
      checkPersonId: '',

      checkPerson2: '',
      checkPersonOld: '',
      checkPersonIdOld: '',
      flag2: false,

      orderSubLoading: false,

      token: '',
      checkCode: "",
      id: "",
      isDisabled: true,
      orderVisible: false
    }, (0, _defineProperty3.default)(_ref, 'orderLoading', false), (0, _defineProperty3.default)(_ref, 'userLoading', false), (0, _defineProperty3.default)(_ref, 'pageNumber2', 1), (0, _defineProperty3.default)(_ref, 'pageSize2', 10), (0, _defineProperty3.default)(_ref, 'total2', 0), (0, _defineProperty3.default)(_ref, 'users', []), (0, _defineProperty3.default)(_ref, 'flag', false), (0, _defineProperty3.default)(_ref, 'checkUser', ''), (0, _defineProperty3.default)(_ref, 'checkUser2', ''), (0, _defineProperty3.default)(_ref, 'checkUserOld', ''), (0, _defineProperty3.default)(_ref, 'checkUserId', ''), (0, _defineProperty3.default)(_ref, 'checkUserIdOld', ''), (0, _defineProperty3.default)(_ref, 'dialogLoading', false), _ref;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo']), {
    isOrderTest: function isOrderTest() {
      return this.orderType == 1;
    },
    evaluatePrice: function evaluatePrice() {
      var price = 0;
      price = this.selectProList.reduce(function (previousValue, curItem) {
        return previousValue + curItem.purchaseNum * curItem.purchaseMonth * curItem.price;
      }, 0);

      this.totalPrice = price;
      return price;
    }
  }),

  components: {
    DetailPage: _DetailPage2.default,
    SelectedProduct: _SelectedProduct2.default
  },

  created: function created() {
    var _$route$query = this.$route.query,
        mode = _$route$query.mode,
        orderId = _$route$query.orderId;

    this.orderId = orderId;

    this.getCookie();

    if (mode) {
      this.mode = mode;
      this.getDetail();
    } else {
      this.getProList();
    }
    console.log('this.mode==', this.mode);
  },
  mounted: function mounted() {

    this.getUser();
    this.getPerson();
    this.getCode1();
    this.getCode();
  },


  methods: {
    getDetail: function getDetail() {
      var _this2 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.$route.query.orderId
      };
      _index.API_Order.detailOrder(param).then(function (res) {
        if (res.data.code == 200) {
          _this2.processDetail = res.data.data;
          try {
            _this2.processDetail.product = JSON.parse(_this2.processDetail.product);
            _this2.processDetail.product.forEach(function (item) {
              item.price = item.singlePrice;
              item.name = item.productName;
              item.logo = '';
              item.id = item.productId;
            });

            var _res$data$data = res.data.data,
                type = _res$data$data.type,
                effectivetime = _res$data$data.effectivetime,
                userid = _res$data$data.userid,
                username = _res$data$data.username,
                companyid = _res$data$data.companyid,
                companyname = _res$data$data.companyname;

            _this2.person = userid ? '1' : '2';

            _this2.checkUserId = userid;
            _this2.checkUser = username;

            _this2.checkPersonId = companyid;
            _this2.checkPerson = companyname;

            _this2.effectiveTime = effectivetime;

            _this2.orderType = type;

            _this2.selectProList = [].concat((0, _toConsumableArray3.default)(_this2.processDetail.product));
            _this2.getProList();
          } catch (e) {
            _this2.processDetail.product = [];
          }
        }
      });
    },
    handerOrderType: function handerOrderType(type) {
      this.totalPrice = type == 1 ? 0 : this.evaluatePrice;
    },
    handerProduct: function handerProduct(data) {
      var index = this.selectProList.findIndex(function (item) {
        return item.id == data.id;
      });
      if (this.selectProList.length == 0 || index == -1) {
        this.selectProList.push(data);
      }

      if (index > -1) {
        this.selectProList = this.selectProList.filter(function (item) {
          return item.id !== data.id;
        });
      }
    },

    getProList: function getProList() {
      var _this3 = this;

      var param = (0, _defineProperty3.default)({
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: 9999,
        purchasable: 0,
        useful: '1'
      }, 'purchasable', '0');
      this.listLoading = true;
      _index.API_Product.productList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.total = res.data.data.totalRow;
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].purchasable) {
              if (res.data.data.list[i].purchasable == 0) {
                res.data.data.list[i].purchasabled = "是";
              } else {
                res.data.data.list[i].purchasabled = "否";
              }
            }
            if (res.data.data.list[i].logo) {
              res.data.data.list[i].logo2 = res.data.data.list[i].logo;
            }
            if (res.data.data.list[i].price) {
              res.data.data.list[i].price = parseFloat(res.data.data.list[i].price);
            }
          }

          res.data.data.list.forEach(function (item) {
            item.purchaseMonth = 1;
            item.purchaseNum = 1;
          });
          _this3.proList = res.data.data.list;
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
        _this3.listLoading = false;
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
        _this3.listLoading = false;
      });
    },

    changeSouch3: function changeSouch3(val) {
      if (val == "ID") {
        this.proName3 = this.souchs3.id;
      } else if (val == "企业名称") {
        this.proName3 = this.souchs3.company;
      } else if (val == "管理员") {
        this.proName3 = this.souchs3.managername;
      }
    },
    changeSouch: function changeSouch(val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName = this.souchs2.phone;
        this.disSouch = true;
      } else if (val == "姓名") {
        this.proName = this.souchs2.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs2.company;
        this.disSouch = true;
      } else if (val == "软件类型") {
        this.disSofttype = true;
      } else if (val == "邀请状态") {
        this.disinvit = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },

    orderSubmit: function orderSubmit() {
      var _this4 = this;

      if (this.selectProList.length == 0) {
        return;
      }
      this.checkPersonId;
      this.person;
      var userIde = '';

      if (this.person == '1') {
        if (!this.checkUserId) {
          this.$message.error('请选择用户！');
          return;
        } else {
          this.checkPersonId = '';
        }
      } else if (this.person == '2') {
        if (!this.checkPersonId) {
          this.$message.error('请选择用户！');
          return;
        } else {
          this.checkUserId = '';
        }
      }

      this.totalPrice = this.orderType == '1' ? 0 : this.totalPrice;

      if (this.orderType == 2 && this.totalPrice === '') {
        this.$message.error('请填写总价');
        return;
      }

      var pruductJson = [];
      pruductJson = this.selectProList.map(function (item) {
        return {
          "productId": item.id,
          "productName": item.name,
          "purchaseMonth": item.purchaseMonth,
          "purchaseNum": item.purchaseNum,
          "singlePrice": item.price,
          "logo": item.logo
        };
      });

      if (!this.effectiveTime) {
        this.$message.error('请选择生效时间');
        return;
      }
      var effectiveTime = _index3.default.formatDateGu(this.effectiveTime) + ' ' + this.effectiveTimeSfm;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: this.orderType,
        adminuserid: this.id,
        price: this.totalPrice,
        userid: this.checkUserId,
        companyid: this.checkPersonId,
        pruductJson: (0, _stringify2.default)(pruductJson),
        mode: this.mode,
        effectiveTime: effectiveTime
      };

      if (this.mode == 'update') {
        param.id = this.orderId;
      }
      console.log("param==", param);
      this.orderSubLoading = true;
      _index.API_Order.addOrder(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: '提交成功',
            type: 'success'
          });
          _this4.$router.push({ path: 'orderList' });
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
        _this4.orderSubLoading = false;
      }).catch(function (err) {
        _this4.orderSubLoading = false;
        _this4.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getPerson: function getPerson(val) {
      var _this5 = this;

      var _this = this;
      if (this.value3 == "ID") {
        this.souchs3.id = this.proName3;
      }
      if (this.value3 == "企业名称") {
        this.souchs3.company = this.proName3;
      }
      if (this.value3 == "管理员") {
        this.souchs3.managername = this.proName3;
      }
      var flags = true;
      if (val == 1) {
        if (this.value3) {
          if (this.dynamicTags3.length > 0) {
            for (var i = 0; i < this.dynamicTags3.length; i++) {
              if (this.value3 == this.dynamicTags3[i]) {
                flags = false;
              }
            }
          }
          if (flags) {
            this.dynamicTags3.push(this.value3);
          }
        }
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber3,
        pageSize: this.pageSize3,
        userType: '',
        listType: 'page',
        managename: this.souchs3.managename,
        id: this.souchs3.id,
        company: this.souchs3.company,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        isCompanyUser: this.person,
        searchText: this.searchText
      };
      this.dialogLoading = true;
      _index.API_User.companyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            _this.total3 = res.data.data.totalRow;
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i] && _this.checkPersonId && _this.checkPersonId == res.data.data.list[i].id) {
                res.data.data.list[i].checked = true;
              } else {
                res.data.data.list[i].checked = false;
              }
            }
            _this.personList = res.data.data.list;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }

        _this5.dialogLoading = false;
      }).catch(function (err) {
        _this5.dialogLoading = false;
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getUser: function getUser(val) {
      var _this6 = this;

      var _this = this;
      if (this.value == "账号") {
        this.souchs2.phone = this.proName;
      }
      if (this.value == "企业") {
        this.souchs2.company = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs2.name = this.proName;
      }
      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        username: this.souchs2.name,
        phone: this.souchs2.phone,
        company: this.souchs2.company,
        registertimefrom: this.souchs2.fromtime,
        registertimeto: this.souchs2.totime,
        softtype: this.souchs2.softtype,
        invitestatus: this.souchs2.invitValue,
        userType: '',
        listType: 'page',

        role: this.userInfo.type,
        userId: this.userInfo.id,
        isCompanyUser: this.person,
        searchText: this.searchText
      };
      this.dialogLoading = true;
      _index.API_User.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {

            _this6.total2 = res.data.data.totalRow;
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i] && _this6.checkUserId && res.data.data.list[i].id == _this6.checkUserId) {
                res.data.data.list[i].checked = true;
              } else {
                res.data.data.list[i].checked = false;
              }
            }
            _this6.users = res.data.data.list;
          }
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
        _this6.dialogLoading = false;
      }).catch(function (err) {
        _this6.dialogLoading = false;
        _this6.$message.error('数据丢失，试试重新登陆！');
      });
    },

    changeFun: function changeFun(e, val) {},
    changeFun3: function changeFun3(e, val) {},
    handleSelectionChange: function handleSelectionChange(row, column, event) {
      var _this7 = this;

      if (event.target.className.indexOf('el-checkbox__inner') > -1) {
        return;
      }
      this.flag = true;
      this.users.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
          _this7.$set(item, 'checked', false);
        }
        if (item.id == row.id) {
          item.checked = true;
          _this7.$set(item, 'checked', true);
        }
      });
      if (row.name == null) {
        row.name = "";
      }
      if (row.phone == null) {
        row.phone = "";
      }
      this.checkUser2 = row.name + ' ' + row.phone;
      this.checkUserOld = row.name + ' ' + row.phone;
      this.checkUserId = row.id;
      this.checkUserIdOld = row.id;
    },
    handleSelectionChange3: function handleSelectionChange3(row, column, event) {
      if (event.target.className.indexOf('el-checkbox__inner') > -1) {
        return;
      }
      this.flag2 = true;
      this.personList.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
        }
        if (item.id == row.id) {
          item.checked = true;
        }
      });
      this.checkPerson2 = row.name;
      this.checkPersonOld = row.name;
      this.checkPersonId = row.id;
      this.checkPersonIdOld = row.id;
    },
    handleCurrentChange3: function handleCurrentChange3(val) {
      this.pageNumber3 = val;
      this.getPerson();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getUser();
    },

    handleUser: function handleUser(val) {
      if (val == 1) {
        this.souchs2 = {};
        this.proName = '';
        this.value = '';
        this.dynamicTags = [];
        this.orderVisible = true;
        this.getUser();
      } else {
        this.souchs3 = {}, this.value3 = '';
        this.proName3 = '';
        this.dynamicTags3 = [];
        this.personVisible = true;
        this.getPerson();
      }
    },
    orderUserSubmit: function orderUserSubmit() {
      if (!this.checkUser2) {
        this.$message.error('请选择用户！');
        return;
      }
      this.checkUser = this.checkUser2;
      this.orderVisible = false;
      this.searchText = '';
    },
    orderPersonSubmit: function orderPersonSubmit() {
      if (!this.checkPerson2) {
        this.$message.error('请选择用户！');
        return;
      }
      this.checkPerson = this.checkPerson2;
      this.personVisible = false;
      this.searchText = '';
    },

    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    bak: function bak() {
      this.$router.push({ path: 'orderList' });
    },
    getCode1: function getCode1() {
      var _this8 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var json = { 'value': res.data.data[i].code, 'label': res.data.data[i].name };
            _this.softtypes.push(json);
          }
        } else {
          _this8.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this8.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    getCode: function getCode() {
      var _this9 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "label": res.data.data[i].name };
            _this.inviValues.push(jsons);
          }
        } else {
          _this9.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this9.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    delTags: function delTags() {
      this.souchs2 = {};
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.getUser();
    },
    handleClose: function handleClose(tag) {
      if (tag == "账号") {
        this.souchs2.phone = '';
        if (this.value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs2.name = '';
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs2.company = '';
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "软件类型") {
        this.souchs2.softtype = "";
      }
      if (tag == "邀请状态") {
        this.souchs2.invitValue = "";
      }
      if (tag == "开始日期") {
        this.souchs2.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs2.totime = "";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    delTags3: function delTags3() {
      this.souchs3 = {}, this.value3 = '';
      this.proName3 = '';
      this.dynamicTags3 = [];
      this.getPerson();
    },
    handleClose3: function handleClose3(tag) {
      if (tag == "ID") {
        this.souchs3.id = '';
        if (this.value3 == "ID") {
          this.proName3 = '';
        }
      }
      if (tag == "企业名称") {
        this.souchs3.company = '';
        if (this.value3 == "企业名称") {
          this.proName3 = '';
        }
      }
      if (tag == "管理员") {
        this.souchs3.managername = '';
        if (this.value3 == "管理员") {
          this.proName3 = '';
        }
      }
      this.dynamicTags3.splice(this.dynamicTags3.indexOf(tag), 1);
    }
  }

};

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _DetailPage = __webpack_require__(232);

var _DetailPage2 = _interopRequireDefault(_DetailPage);

var _SelectedProduct = __webpack_require__(785);

var _SelectedProduct2 = _interopRequireDefault(_SelectedProduct);

var _ModalFormOrder = __webpack_require__(1748);

var _ModalFormOrder2 = _interopRequireDefault(_ModalFormOrder);

var _index2 = __webpack_require__(93);

var _index3 = _interopRequireDefault(_index2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      pageLoading: true,
      dialogLoading: false,
      orderId: '',
      detailType: '1',

      token: '',
      checkCode: '',

      processDetail: null,
      comments: '',
      isShowComment: false,
      isShowError: false,

      visibleRenew: false,
      productInfo: null,
      productList: [],
      param: {
        searchText: this.$route.query.searchText,
        souType: this.$route.query.souType,
        souAccount: this.$route.query.souAccount,
        fromtime: this.$route.query.fromtime,
        totime: this.$route.query.totime,
        pageNumber: this.$route.query.pageNumber,
        pageSize: this.$route.query.pageSize
      }
    };
  },


  components: {
    DetailPage: _DetailPage2.default,
    SelectedProduct: _SelectedProduct2.default,
    ModalFormOrder: _ModalFormOrder2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    var _$route$query = this.$route.query,
        type = _$route$query.type,
        orderId = _$route$query.orderId;

    this.orderId = orderId;
    this.detailType = type;
    this.token = token;
    this.checkCode = checkCode;

    this.getDetail(token, checkCode);
  },


  methods: {
    getDetail: function getDetail(token, checkCode) {
      var _this = this;

      var param = {
        token: token,
        checkCode: checkCode,
        id: this.$route.query.orderId
      };
      this.pageLoading = true;
      _index.API_Order.detailOrder(param).then(function (res) {
        if (res.data.code == 200) {
          _this.processDetail = res.data.data;
          try {

            _this.processDetail.auProList.forEach(function (item) {
              item.price = item.singlePrice;
              item.name = item.productName;
            });
          } catch (e) {
            _this.processDetail.product = [];
          }
        }
        _this.pageLoading = false;
      });
    },
    handerChangeComments: function handerChangeComments(val) {
      this.isShowError = val ? false : true;
    },
    handerVerify: function handerVerify(status) {
      var _this2 = this;

      if (status == 1 && !this.comments) {
        this.isShowError = true;
        return;
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,

        id: this.$route.query.orderId,
        stateverify: status
      };

      status == 1 && (param.comments = this.comments);
      this.dialogLoading = true;
      _index.API_Order.verifyOrder(param).then(function (res) {
        if (res.data.code == 200) {
          _this2.$message.success('审核成功');
          _this2.$router.push({ path: 'orderList' });
        }
        _this2.dialogLoading = false;
      });
    },
    handleRenewOrder: function handleRenewOrder(product) {
      this.productInfo = product;

      this.productInfo.orderId = this.orderId;
      var _processDetail = this.processDetail,
          companyid = _processDetail.companyid,
          userid = _processDetail.userid,
          companyname = _processDetail.companyname,
          username = _processDetail.username;

      this.productInfo.typeId = companyid || userid;

      this.productInfo.ower = companyid ? companyname : username;
      this.visibleRenew = true;
    }
  }
};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  data: function data() {
    return {
      proList3: [],
      userType: '',
      checkPerson: '',

      person: '',

      proType: '',
      disCheckBox: false,
      ygPrice: 0,
      allPrice: 0,
      checkList: [],
      proList: [],
      proList2: [],
      listLoading: false,
      token: '',
      checkCode: "",
      id: "",
      isDisabled: true,

      orderVisible: false,
      orderLoading: false,

      userLoading: false,
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      souchs2: {
        modelName: ''
      },
      users: [],
      checkUser: '',
      checkUser2: '',
      checkUserId: '',
      pruductJson: []

    };
  },

  methods: {
    indexMethod: function indexMethod(index) {
      return index + 1;
    },

    getProList: function getProList() {
      var _this2 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: '1',
        pageSize: '9999',
        useful: '1',
        purchasable: '0'
      };
      this.listLoading = true;
      _index.API_Product.productList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.total = res.data.data.totalRow;
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].purchasable) {
              if (res.data.data.list[i].purchasable == 0) {
                res.data.data.list[i].purchasabled = "是";
              } else {
                res.data.data.list[i].purchasabled = "否";
              }
            }
            if (res.data.data.list[i].logo) {
              res.data.data.list[i].logo2 = res.data.data.list[i].logo;
            }
            if (res.data.data.list[i].price) {
              res.data.data.list[i].price = parseFloat(res.data.data.list[i].price);
              res.data.data.list[i].price2 = res.data.data.list[i].price.toLocaleString();
            }
          }
          _this.proList = res.data.data.list;
          if (_this.proList.length > 0 && _this.proList2.length > 0) {
            _this.logoNamePush(_this.proList, _this.proList2);
          }
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.listLoading = false;
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    getUser: function getUser(ide) {
      var _this3 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: ide
      };
      _index.API_User.getUserDetail(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.checkUser = '';
          if (res.data.data.name) {
            _this3.checkUser = res.data.data.name;
          }
          if (res.data.data.phone) {
            _this3.checkUser = _this3.checkUser + ' ' + res.data.data.phone;
          }
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },
    getDetail: function getDetail() {
      var _this4 = this;

      var _this = this;

      var myId = this.$route.query.id;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: myId
      };
      _index.API_Order.detailOrder(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.proList2 = JSON.parse(res.data.data.product);
          if (_this.proList2.length > 0 && _this.proList.length > 0) {
            _this.logoNamePush(_this.proList, _this.proList2);
          }
          _this.allPrice = res.data.data.price;
          if (_this.allPrice) {
            _this.allPrice = parseFloat(_this.allPrice);
            _this.allPrice = _this.allPrice.toLocaleString();
          }
          if (res.data.data.companyid) {
            _this.person = '2';
            _this.userType = '企业用户';
            _this.checkPerson = _this4.$route.query.name;
          } else {
            _this.person = '1';
            _this.userType = '个人用户';
            _this.checkUserId = res.data.data.userid;
            _this.getUser(res.data.data.userid);
          }
          _this.getProList();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
      });
    },
    logoNamePush: function logoNamePush(proList, proList2) {
      console.log(proList);
      console.log(proList2);
      this.ygPrice = 0;
      for (var i = 0; i < proList2.length; i++) {
        for (var k = 0; k < proList.length; k++) {
          if (proList2[i].productId == proList[k].id) {
            console.log(222);
            this.proList2[i].logo2 = proList[k].logo2;
            this.proList2[i].name = proList[k].name;
            this.proList2[i].price = proList[k].price;
            if (this.proList2[i].price) {
              this.proList2[i].price = parseFloat(this.proList2[i].price);
              this.proList2[i].price2 = this.proList2[i].price.toLocaleString();
            }
          }
        }

        this.ygPrice = this.ygPrice + this.proList2[i].purchaseNum * this.proList2[i].purchaseMonth * this.proList2[i].price;
      }
      if (this.ygPrice) {
        this.ygPrice = parseFloat(this.ygPrice);
        this.ygPrice = this.ygPrice.toLocaleString();
      }
      this.proList3 = this.proList2;
    },
    bak: function bak() {
      this.$router.push({
        path: '/orderList',
        query: {
          dynamicTags: this.$route.query.dynamicTags,
          souchs: this.$route.query.souchs,
          type: 1,
          pageNumber: this.$route.query.pageNumber
        }
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.getCookie();
    this.getDetail();
  },
  beforeMount: function beforeMount() {}
};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      disSouch: true,
      disType: false,
      disAccountType: false,
      disTime1: false,
      disTime2: false,
      token: '',
      checkCode: "",
      id: "",
      listLoading: false,
      dataList: [],
      souchs: {
        id: '',
        name: '',
        usercompany: '',
        souType: this.$route.query.souType ? this.$route.query.souType : '',
        adminusername: '',
        souAccount: this.$route.query.souAccount ? this.$route.query.souAccount : '',
        price: '',
        fromtime: this.$route.query.fromtime ? this.$route.query.fromtime : '',
        totime: this.$route.query.totime ? this.$route.query.totime : ''
      },

      proName: '',
      pageNumber: this.$route.query.pageNumber ? this.$route.query.pageNumber : 1,
      pageSize: this.$route.query.pageSize ? this.$route.query.pageSize : 20,
      total: 0,
      options: [{ value: 'ID', label: 'ID' }, { value: '用户', label: '用户' }, { value: '企业', label: '企业' }, { value: '类型', label: '类型' }, { value: '订单', label: '订单' }, { value: '操作人', label: '操作人' }, { value: '价格', label: '价格' }, { value: '开始日期', label: '开始日期' }, { value: '结束日期', label: '结束日期' }],
      value: '',
      types: [{ value: '1', label: '试用' }, { value: '2', label: '正式' }],
      accountType: '',
      accountTypes: [{ value: '0', label: '个人订单' }, { value: '1', label: '企业订单' }],
      typeValue: '',
      dynamicTags: [],

      orderStr: "intimepx",
      orderType: 'desc',
      searchText: this.$route.query.searchText
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "id") {
          this.orderStr = "idpx";
        } else if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "typename") {
          this.orderStr = "typepx";
        } else if (val.prop == "intime") {
          this.orderStr = "intimepx";
        } else if (val.prop == "adminusername") {
          this.orderStr = "adminuserpx";
        } else if (val.prop == "price2") {
          this.orderStr = "pricepx";
        } else if (val.prop == "usercompany") {
          this.orderStr = "usercompanypx";
        }

        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },

    changeSouch: function changeSouch(val) {
      this.disAccountType = false;
      this.disSouch = false;
      this.disType = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "类型") {
        this.typeValue = this.souchs.souType;
        this.disType = true;
      } else if (val == "ID") {
        this.proName = this.souchs.id;
        this.disSouch = true;
      } else if (val == "用户") {
        this.proName = this.souchs.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs.usercompany;
        this.disSouch = true;
      } else if (val == "操作人") {
        this.proName = this.souchs.adminusername;
        this.disSouch = true;
      } else if (val == "价格") {
        this.proName = this.souchs.price;
        this.disSouch = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      } else if (val == "订单") {
        this.accountType = this.souchs.souAccount;
        this.disAccountType = true;
      }
    },

    getList: function getList(val) {
      var _this = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      if (this.value == "ID") {
        this.souchs.id = this.proName;
      }
      if (this.value == "用户") {
        this.souchs.name = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.usercompany = this.proName;
      }
      if (this.value == "类型") {
        this.souchs.souType = this.typeValue;
      }
      if (this.value == "订单") {
        this.souchs.souAccount = this.accountType;
      }
      if (this.value == "操作人") {
        this.souchs.adminusername = this.proName;
      }
      if (this.value == "价格") {
        this.souchs.price = this.proName;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        id: this.souchs.id,
        name: this.souchs.name,
        usercompany: this.souchs.usercompany,
        type: this.souchs.souType,
        accountType: this.souchs.souAccount,
        adminusername: this.souchs.adminusername,
        price: this.souchs.price,
        fromtime: this.souchs.fromtime,
        totime: this.souchs.totime,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        searchText: this.searchText
      };
      this.listLoading = true;
      _index.API_Order.getOrderList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].price) {
              res.data.data.list[i].price = parseFloat(res.data.data.list[i].price);
              res.data.data.list[i].price2 = res.data.data.list[i].price.toLocaleString();
            } else {
              res.data.data.list[i].price2 = 0;
            }
          }
          _this.dataList = res.data.data.list;
          _this.total = res.data.data.totalRow;
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
        _this.listLoading = false;
      });
    },

    addList: function addList() {
      this.$router.push({ path: '/OrderAdd' });
    },

    handleEdit: function handleEdit(index, row) {

      this.$router.push({ path: 'OrderAdd', query: { orderId: row.id, mode: 'update' } });
    },

    handleDetail: function handleDetail(index, row, flag) {
      this.$router.push({
        path: 'orderDetail',
        query: {
          orderId: row.id,
          type: flag,
          searchText: this.searchText,
          souType: this.souchs.souType,
          souAccount: this.souchs.souAccount,
          fromtime: this.souchs.fromtime,
          totime: this.souchs.totime,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize
        }
      });
    },


    delTags: function delTags() {
      this.souchs = {}, this.souchs.souType = '';
      this.value = '';
      this.typeValue = '';
      this.accountType = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },

    handleClose: function handleClose(tag) {
      if (tag == "类型") {
        this.souchs.souType = "";
        this.typeValue = '';
      }
      if (tag == "订单") {
        this.souchs.souAccount = "";
        this.accountType = '';
      }
      if (tag == "用户") {
        this.souchs.name = "";
        if (this.value == "用户") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.usercompany = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "ID") {
        this.souchs.id = "";
        if (this.value == "ID") {
          this.proName = '';
        }
      }
      if (tag == "操作人") {
        this.souchs.adminusername = "";
        if (this.value == "操作人") {
          this.proName = '';
        }
      }
      if (tag == "价格") {
        this.souchs.price = "";
        if (this.value == "价格") {
          this.proName = '';
        }
      }
      if (tag == "开始日期") {
        this.souchs.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs.totime = "";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm('确认撤销吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this2.userInfo.phone,
          checkCode: _this2.userInfo.checkCode,
          id: row.id,
          role: _this2.userInfo.type,
          userId: _this2.userInfo.id
        };
        _index.API_Order.delOrder(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this2.$message({
              message: '撤销成功',
              type: 'success'
            });
            _this2.getList();
          } else {
            _this2.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this2.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },

  created: function created() {
    this.getCookie();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(139);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {

    productLists: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    isEdit: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {};
  },


  components: {},

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  mounted: function mounted() {
    console.log('this.productLists==', this.productLists);
  },


  methods: {
    handleChangeNum: function handleChangeNum(val, data, key) {
      console.log("val==", val, typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val));
    },
    handleDel: function handleDel(index, data) {
      console.log("index,data==", index, data);
      this.$emit("del", data);
    },
    handleRenewOrder: function handleRenewOrder(index, row) {
      this.$emit('renew', row);
    }
  }
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = __webpack_require__(19);

var _currency = __webpack_require__(957);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  filters: {
    currency: _currency.currency
  },
  inject: ['reload'],
  data: function data() {
    var _ref;

    return _ref = {
      orderType: '',
      orderStr: '',
      beformAddImg: '',
      editFormVisible: false,
      editForm: {
        useful: '1'
      },
      editLoading: false,
      editImageUrl: '',

      editFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        purchasable: [{ required: true, message: '请选择可购买', trigger: 'blur' }],
        useful: [{ required: true, message: '请选择', trigger: 'blur' }]
      },
      imgs: '',
      userModule: [],
      logo: '',
      cities: [],
      citiesd: [],
      checkedCities: [],
      editCheckedCities: [],
      souchs: {},
      checkCode: '',
      token: '',
      proList: [],
      listLoading: false,
      pageSize: 20,
      pageNumber: 1,
      total: 0,

      addFormVisible: false,
      addForm: {},
      purchasable: '0',
      useful: '1',
      addFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        purchasable: [{ required: true, message: '请选择', trigger: 'blur' }],
        useful: [{ required: true, message: '请选择', trigger: 'blur' }]
      },
      addLoading: false,
      gms: [{ value: '0', text: '是' }, { value: '1', text: '否' }],

      usefulLists: [{ value: '0', text: '废弃' }, { value: '1', text: '正常' }]

    }, (0, _defineProperty3.default)(_ref, 'editFormVisible', false), (0, _defineProperty3.default)(_ref, 'imageUrl', ''), (0, _defineProperty3.default)(_ref, 'upload', {
      fileList: this.fileList,
      picIds: [],
      postURL: _index.API_Common.setLoglist(),
      dialogImageUrl: '',
      dialogVisible: false,
      data: {
        mode: 'save',
        token: this.token,
        checkCode: this.checkCode,
        type: 1
      }
    }), (0, _defineProperty3.default)(_ref, 'changFalg', false), _ref;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    priceLose: function priceLose(val) {
      var newPrice;
      if (val == 1) {
        newPrice = this.addForm.price;
      } else {
        newPrice = this.editForm.price;
      }
      if (newPrice) {
        if (isNaN(newPrice)) {
          newPrice = newPrice.replace(/[^\.\d]/g, '');
        }
        if (parseFloat(newPrice).toString() == 'NaN') {
          this.$message.error('指标数为大于0的数, 请重新输入');
          return;
        } else if (newPrice < 0) {
          this.$message.error('指标数为大于0的数, 请重新输入');
          newPrice = 0;
          return;
        } else {
          newPrice = parseFloat(newPrice);
          newPrice = newPrice.toLocaleString();
        }
      } else {
        newPrice = 0;
      }
      if (val == 1) {
        this.addForm.price = newPrice;
      } else {
        this.editForm.price = newPrice;
      }
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;

        this.imageUrl = URL.createObjectURL(file.raw);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error('请选择图片文件');
      }
    },
    closeDialog: function closeDialog() {
      this.$refs['editForm'].clearValidate();
    },

    editSubmit: function editSubmit() {
      var _this2 = this;

      if (!this.editImageUrl && !this.beformAddImg) {
        this.$message.error('请上传图片!');
        return;
      }
      this.$refs['editForm'].validate(function (valid) {
        if (valid) {
          if (_this2.beformAddImg) {
            console.log('xxxxxx');
            var var_this = _this2;
            var formData = new FormData();
            formData.append('pic', _this2.beformAddImg.raw);
            formData.append('token', _this2.token);
            formData.append('checkCode', _this2.checkCode);
            formData.append('oldpicid', _this2.editForm.picid);
            formData.append('mode', 'save');
            var config = {
              'Content-Type': 'multipart/form-data'
            };
            _axios2.default.post(_this2.upload.postURL, formData, config).then(function (res) {
              if (res.data.code == _index.API__code.SUCCESS) {
                var_this.editSave(res.data.data);
                var_this.$refs.upload.clearFiles();
              } else {
                var_this.$message.error(res.data.message);
                if (res.data.code == 403) {
                  var_this.$router.push({ path: 'loginAdmin' });
                }
                return;
              }
            }).catch(function (error) {
              console.log(error);
              return;
            });
          } else {
            _this2.editSave();
          }
        }
      });
    },
    editSave: function editSave(val) {
      var _this3 = this;

      if (val) {
        this.editForm.logo = val.pic;
        this.editForm.picid = val.id;
      }
      if (isNaN(this.editForm.price)) {
        this.editForm.price = this.editForm.price.replace(/[^\.\d]/g, '');
      }
      var param = void 0;
      param = {
        id: this.editForm.id,
        token: this.token,
        checkCode: this.checkCode,
        mode: '',
        name: this.editForm.name,
        price: this.editForm.price,
        purchasable: this.editForm.purchasable,
        module: (0, _stringify2.default)(this.userModule),
        picid: this.editForm.picid,
        useful: this.editForm.useful
      };

      this.editLoading = true;
      _index.API_Product.setProductList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '修改成功',
            type: 'success'
          });
          _this3.getProList();
          _this3.editFormVisible = false;
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
        _this3.editLoading = false;
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
        _this3.editLoading = false;
      });
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      this.userModule = [];
      for (var i = 0; i < value.length; i++) {
        for (var k = 0; k < this.citiesd.length; k++) {
          if (value[i] == this.citiesd[k].modulename) {
            var jsoned = {
              id: this.citiesd[k].id,
              modulename: this.citiesd[k].modulename,
              moduleid: this.citiesd[k].moduleid
            };
            this.userModule.push(jsoned);
          }
        }
      }
    },
    handleCheckedCitiesChange2: function handleCheckedCitiesChange2(value) {
      console.log('value===', value);
      this.changFalg = true;
      this.userModule = [];
      for (var i = 0; i < value.length; i++) {
        for (var k = 0; k < this.citiesd.length; k++) {
          if (value[i] == this.citiesd[k].modulename) {
            var jsoned = {
              id: this.citiesd[k].id,
              modulename: this.citiesd[k].modulename,
              moduleid: this.citiesd[k].moduleid
            };
            console.log(jsoned);
            this.userModule.push(jsoned);
          }
        }
      }
    },

    addSubmit: function addSubmit() {
      var var_this = this;
      if (!this.addForm.name) {
        this.$message.error('请输入名称!');
        return;
      }
      if (!this.addForm.price) {
        this.$message.error('请输入单价!');
        return;
      }
      if (!this.beformAddImg) {
        this.$message.error('请上传图片!');
        return;
      }
      if (!this.purchasable) {
        this.$message.error('请选择可购买!');
        return;
      }
      if (this.userModule.length < 1) {
        this.$message.error('请选择产品模块!');
        return;
      }
      var formData = new FormData();
      formData.append('pic', this.beformAddImg.raw);
      formData.append('token', this.token);
      formData.append('checkCode', this.checkCode);
      formData.append('mode', 'save');
      var config = {
        'Content-Type': 'multipart/form-data'
      };
      _axios2.default.post(this.upload.postURL, formData, config).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var_this.addSave(res.data.data);
          var_this.$refs.upload.clearFiles();
        } else {
          var_this.$message.error(res.data.message);
          if (res.data.code == 403) {
            var_this.$router.push({ path: 'loginAdmin' });
          }
          return;
        }
      }).catch(function (error) {
        console.log(error);
        return;
      });
    },
    addSave: function addSave(val) {
      var _this4 = this;

      var newlbtPath = val.pic;

      var newId = val.id;
      if (isNaN(this.addForm.price)) {
        this.addForm.price = this.addForm.price.replace(/[^\.\d]/g, '');
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        name: this.addForm.name,
        price: this.addForm.price,
        purchasable: this.purchasable,
        module: (0, _stringify2.default)(this.userModule),
        logo: newlbtPath,
        picid: newId,
        useful: this.useful
      };
      this.addLoading = true;
      _index.API_Product.setProductList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: '添加成功',
            type: 'success'
          });
          _this4.purchasable = '0';
          _this4.addFormVisible = false;
          _this4.getProList();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
        _this4.addLoading = false;
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
        _this4.addLoading = false;
      });
    },
    handleAdd: function handleAdd() {
      this.addFormVisible = true;
      this.imageUrl = '';
      this.addForm = {};
      this.beformAddImg = '';
      this.userModule = [];
      this.logo = '';
      this.checkedCities = [];
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == 'name') {
          this.orderStr = 'namepx';
        } else if (val.prop == 'purchasabled') {
          this.orderStr = 'purchasabledpx';
        } else if (val.prop == 'price') {
          this.orderStr = 'pricepx';
        }
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
      }
      this.getProList();
    },
    getProList: function getProList(val) {
      var _this5 = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        nameStr: this.souchs.proName,

        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id
      };
      this.listLoading = true;
      _index.API_Product.productList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.total = res.data.data.totalRow;
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].purchasable) {
              if (res.data.data.list[i].purchasable == 0) {
                res.data.data.list[i].purchasabled = '是';
              } else {
                res.data.data.list[i].purchasabled = '否';
              }
            }
            if (res.data.data.list[i].logo) {
              res.data.data.list[i].logo2 = res.data.data.list[i].logo;
            }

            if (res.data.data.list[i].price) {
              res.data.data.list[i].price = parseFloat(res.data.data.list[i].price);
              res.data.data.list[i].price = res.data.data.list[i].price.toLocaleString();
            } else {
              res.data.data.list[i].price = 0;
            }
          }
          _this5.proList = res.data.data.list;
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.listLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.listLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return 'background:#F5F7FA';
      } else {
        return '';
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getProList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getProList();
    },

    handleEdit: function handleEdit(index, row) {
      this.userModule = [];
      this.beformAddImg = '';
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
      console.log('this.editForm==', this.editForm);

      var cc = JSON.parse(row.module);
      console.log('cc=', cc);
      this.userModule = cc;
      this.editCheckedCities = [];
      this.logo = '';
      for (var i = 0; i < cc.length; i++) {
        this.editCheckedCities.push(cc[i].modulename);
      }
      this.editImageUrl = row.logo2;
    },

    handleDel: function handleDel(index, row) {
      var _this6 = this;

      this.$confirm('确认删除该产品吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var para = {
          id: row.id,
          picid: row.picid,
          token: _this6.token,
          checkCode: _this6.checkCode
        };
        _index.API_Product.delProductList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this6.$message({
              message: '删除成功',
              type: 'success'
            });
            _this6.getProList();
          } else {
            _this6.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this6.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this6.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },
    getModuleList: function getModuleList() {
      var _this7 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Models.getAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this7.models = res.data.data;
          _this7.cities = [];
          _this7.citiesd = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this.cities.push(res.data.data[i].modulename);
            var jsones = {
              modulename: res.data.data[i].modulename,
              id: res.data.data[i].id,
              moduleid: res.data.data[i].moduleid
            };
            _this.citiesd.push(jsones);
          }
        } else {
          _this7.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this7.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this7.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getProList();
    this.getModuleList();
  }
};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UrlsNumber = __webpack_require__(1756);

var _UrlsNumber2 = _interopRequireDefault(_UrlsNumber);

var _UrlsLBT = __webpack_require__(1755);

var _UrlsLBT2 = _interopRequireDefault(_UrlsLBT);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      activeIndex: '',
      showLBT: true,
      showURL: false
    };
  },

  methods: {
    handleSelect: function handleSelect(key, keyPath) {
      this.showURL = false;
      this.showLBT = false;
      if (key == '1') {
        this.showLBT = true;
        sessionStorage.setItem('admin_menu', '1');
      } else if (key == '2') {
        this.showURL = true;
        sessionStorage.setItem('admin_menu', '2');
      }
    }
  },
  mounted: function mounted() {
    this.activeIndex = sessionStorage.getItem('admin_menu');
    if (this.activeIndex == '2') {
      this.showLBT = false;
      this.showURL = true;
      sessionStorage.setItem('admin_menu', 2);
    } else {
      this.showLBT = true;
      this.showURL = false;
      sessionStorage.setItem('admin_menu', 1);
    }
  },

  components: {
    UrlsLBT: _UrlsLBT2.default,
    UrlsNumber: _UrlsNumber2.default
  }
};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  inject: ['reload'],
  data: function data() {
    return {
      listLoading: false,
      id: '',
      checkCode: '',
      token: '',
      pageSize: 20,
      total: 1,
      pageNumber: 1,
      editImgLoading: false,
      editFormVisible: false,
      editForm: {},
      editImageUrl: '',
      editFormRules: {
        px: [{ required: true, message: '请输入排序', trigger: 'blur' }]
      },
      addFormVisible: false,
      addImgLoading: false,
      lbpic: '',
      lbsltUrl: '',
      imageUrl: '',
      addForm: {},
      addFormRules: {
        px: [{ required: true, message: '请输入排序', trigger: 'blur' }]
      },
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: _index.API_Common.upload(),
        dialogImageUrl: '',
        dialogVisible: false,
        data: {
          mode: 'save',
          token: this.token,
          checkCode: this.checkCode,
          type: 1
        }
      },
      rowPX: '',
      imgList: []
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    loseFcous: function loseFcous(index, row) {
      var _this = this;

      var para = {
        token: this.token,
        checkCode: this.checkCode,
        id: row.id
      };
      _index.API_Common.getLBTDetail(para).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.px) {
            _this.rowPX = res.data.data.px;
            if (!row.px || row.px == _this.rowPX) {
              return row.px = _this.rowPX;
            } else {
              _this.editPx(row.id, row.px);
            }
          }
        }
      });
    },

    editPx: function editPx(id, px) {
      var _this2 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: id,
        mode: '',
        px: px
      };
      _index.API_Common.setLBlist(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: '修改成功',
            type: 'success'
          });
          _this2.getlbtList();
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
      });
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;

        this.imageUrl = URL.createObjectURL(file.raw);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error('请选择图片文件');
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getlbtList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getlbtList();
    },

    handleAdd: function handleAdd() {
      this.addFormVisible = true;
      this.addForm = {};
      this.beformAddImg = '';
      this.lbpic = '';
      this.lbsltUrl = '';
      this.imageUrl = '';
    },

    handledel: function handledel(index, row) {
      var _this3 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this3.token,
          checkCode: _this3.checkCode,
          id: row.id,
          picid: row.picid
        };
        _index.API_Common.delLBlist(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this3.$message({
              message: '删除成功',
              type: 'success'
            });
            _this3.getlbtList();
          } else {
            _this3.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this3.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this3.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editImageUrl = row.lbtpic2;
      this.editImgId = row.picid;
      this.beformAddImg = '';
      this.editForm = (0, _assign2.default)({}, row);
    },

    addImgSubmit: function addImgSubmit() {
      var var_this = this;
      if (!this.beformAddImg) {
        this.$message.error("请上传图片!");
        return;
      }
      if (!this.addForm.px) {
        this.$message.error("请输入排序号!");
        return;
      }
      var formData = new FormData();
      formData.append('pic', this.beformAddImg.raw);
      formData.append('token', this.token);
      formData.append('checkCode', this.checkCode);
      formData.append('mode', 'save');
      var config = {
        'Content-Type': 'multipart/form-data'
      };
      this.addImgLoading = true;
      _axios2.default.post(this.upload.postURL, formData, config).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var_this.addSave(res.data.data);
          var_this.$refs.upload.clearFiles();
        } else {
          var_this.$message.error(res.data.message);
          if (res.data.code == 403) {
            var_this.$router.push({ path: 'loginAdmin' });
          }
          return;
        }
      }).catch(function (error) {
        console.log(error);
        return;
      });
    },
    addSave: function addSave(val) {
      var _this4 = this;

      var newId = val.id;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        lbtlink: this.addForm.lbtlink,
        px: this.addForm.px,
        mode: 'save',
        lbtpic: val.pic,
        lbtsltUrl: val.sltUrl,
        lbtfileName: this.addForm.lbtfileName,
        picid: newId,
        type: 1
      };
      _index.API_Common.setLBlist(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: '保存成功',
            type: 'success'
          });
          _this4.addFormVisible = false;
          _this4.getlbtList();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
        _this4.addImgLoading = false;
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
        _this4.addImgLoading = false;
      });
    },
    editImgSubmit: function editImgSubmit() {
      if (!this.editImageUrl && !this.beformAddImg) {
        this.$message.error("请上传图片!");
        return;
      }
      if (!this.editForm.px) {
        this.$message.error("请输入排序号!");
        return;
      }
      if (this.beformAddImg) {
        var var_this = this;
        var formData = new FormData();
        formData.append('pic', this.beformAddImg.raw);
        formData.append('token', this.token);
        formData.append('checkCode', this.checkCode);
        formData.append('oldpicid', this.editImgId);
        formData.append('mode', 'save');
        var config = {
          'Content-Type': 'multipart/form-data'
        };
        _axios2.default.post(this.upload.postURL, formData, config).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            var_this.editSave(res.data.data);
            var_this.$refs.upload.clearFiles();
          } else {
            var_this.$message.error(res.data.message);
            if (res.data.code == 403) {
              var_this.$router.push({ path: 'loginAdmin' });
            }
            return;
          }
        }).catch(function (error) {
          console.log(error);
          return;
        });
      } else {
        this.editSave();
      }
    },
    editSave: function editSave(val) {
      var _this5 = this;

      var param = void 0;
      if (val) {
        this.editForm.lbtpic = val.pic;
        this.editForm.lbtsltUrl = val.sltUrl;
        this.editForm.picid = val.id;
        param = {
          token: this.token,
          checkCode: this.checkCode,
          id: this.editForm.id,
          lbtlink: this.editForm.lbtlink,
          px: this.editForm.px,
          mode: '',
          lbtpic: this.editForm.lbtpic,
          lbtsltUrl: this.editForm.lbtsltUrl,
          lbtfileName: this.editForm.lbtfileName,
          picid: this.editForm.picid,
          type: 1
        };
      } else {
        param = {
          token: this.token,
          checkCode: this.checkCode,
          id: this.editForm.id,
          lbtlink: this.editForm.lbtlink,
          lbtfileName: this.editForm.lbtfileName,
          px: this.editForm.px,
          mode: '',
          type: 1
        };
      }
      this.editImgLoading = true;
      _index.API_Common.setLBlist(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.$message({
            message: '修改成功',
            type: 'success'
          });
          _this5.editFormVisible = false;
          _this5.getlbtList();
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.editImgLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.editImgLoading = false;
      });
    },
    getlbtList: function getlbtList() {
      var _this6 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        type: 0
      };
      _index.API_Common.getLBlist(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this6.total = res.data.data.totalRow;
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].lbtpic) {
              res.data.data.list[i].lbtpic2 = res.data.data.list[i].lbtpic;
            }
          }
          _this6.imgList = res.data.data.list;
        } else {
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
          _this6.$message.error(res.data.message);
        }
      }).catch(function (err) {
        _this6.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getlbtList();
  }
};

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  inject: ['reload'],
  data: function data() {
    return {
      id: '',
      checkCode: '',
      token: '',
      urlList: [],
      pageSize1: 20,
      total1: 1,
      pageNumber1: 1,
      listLoading: false,
      addUrl: {
        cloudserviceurl: '',
        version: '',
        comment: ''
      },
      addUrlRules: {
        cloudserviceurl: [{ required: true, message: '请输入路径', trigger: 'blur' }]
      },
      addUrlVisible: false,
      addUrlLoading: false,

      editUrlVisible: false,
      editUrlLoading: false,
      editUrl: {
        cloudserviceurl: '',
        version: '',
        comment: ''
      },
      editUrlRules: {
        cloudserviceurl: [{ required: true, message: '请输入路径', trigger: 'blur' }]
      }
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    editUrlSubmit: function editUrlSubmit() {
      var _this2 = this;

      if (!this.editUrl.cloudserviceurl) {
        this.$message.error("路径地址不可为空！");
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: '',
        cloudserviceurl: this.editUrl.cloudserviceurl,
        version: this.editUrl.version,
        comment: this.editUrl.comment,
        id: this.editUrl.id
      };
      this.editUrlLoading = true;
      _index.API_Urls.upUrls(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: '修改成功',
            type: 'success'
          });
          _this2.editUrlVisible = false;
          _this2.getUrls();
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.editUrlLoading = false;
      }).catch(function (err) {
        _this2.editUrlLoading = false;
        _this2.$message.error('数据丢失，试试重新登陆！');
      });
    },
    addUrlSubmit: function addUrlSubmit() {
      var _this3 = this;

      if (!this.addUrl.cloudserviceurl) {
        this.$message.error("路径地址不可为空！");
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        cloudserviceurl: this.addUrl.cloudserviceurl,
        version: this.addUrl.version,
        comment: this.addUrl.comment
      };
      this.addUrlLoading = true;
      _index.API_Urls.upUrls(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '添加成功',
            type: 'success'
          });
          _this3.addUrlVisible = false;
          _this3.getUrls();
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
        _this3.addUrlLoading = false;
      }).catch(function (err) {
        _this3.addUrlLoading = false;
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },
    handleURLAdd: function handleURLAdd() {
      this.addUrlVisible = true;
      this.addUrl = {};
    },
    handleURLEdit: function handleURLEdit(index, row) {
      this.editUrlVisible = true;
      this.editUrl = (0, _assign2.default)({}, row);
    },
    handleURLDel: function handleURLDel(index, row) {
      var _this4 = this;

      var _this = this;
      this.$confirm('确认删除该用户吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this4.token,
          checkCode: _this4.checkCode,
          id: row.id
        };
        _index.API_Urls.delUrls(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this4.$message({
              message: '删除成功',
              type: 'success'
            });
            _this4.getUrls();
          } else {
            _this4.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this4.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this4.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },
    handleCurrentChange1: function handleCurrentChange1(val) {
      this.pageNumber1 = val;
      this.getUrls();
    },
    handleSizeChange1: function handleSizeChange1(val) {
      this.pageSize1 = val;
      this.getUrls();
    },

    getUrls: function getUrls() {
      var _this5 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber1,
        pageSize: this.pageSize1
      };
      _index.API_Urls.getUrlsList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.urlList = res.data.data.list;
          _this5.total1 = res.data.data.totalRow;
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getUrls();
  }
};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var _jquery = __webpack_require__(269);

var _jquery2 = _interopRequireDefault(_jquery);

var _BaseContainer = __webpack_require__(38);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(46);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      downHrefExcel: '',
      downHref: '',
      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName: "",
      dynamicTags: [],
      optionsSouch: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '软件类型', label: '软件类型' }],
      value: '',
      inviValues: [],
      softtypes: [],
      yhlx: [],
      zhlx: [],
      cities: [],
      citiesd: [],
      userModule: [],
      editForm: {},
      editLoading: false,
      options: [{
        value: '1',
        label: '一个月'
      }, {
        value: '2',
        label: '二个月'
      }, {
        value: '3',
        label: '三个月'
      }, {
        value: '4',
        label: '四个月'
      }, {
        value: '5',
        label: '五个月'
      }, {
        value: '6',
        label: '六个月'
      }],
      id: '',
      token: '',
      checkCode: '',
      listLoading: false,
      souchs: {
        phone: '',
        name: '',
        company: '',

        fromtime: '',
        totime: ''
      },
      orderStr: '',
      orderType: '',
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      users: [],
      companyList: [],

      dateRange: '',
      searchText: ''
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    handerChangePicker: function handerChangePicker(dateArr) {
      console.log("dateArr==", dateArr);
      if (dateArr) {
        this.souchs.fromtime = dateArr[0];
        this.souchs.totime = dateArr[1];
        return;
      }

      this.souchs.fromtime = '';
      this.souchs.totime = '';
    },
    handleClose: function handleClose(tag) {
      if (tag == "账号") {
        this.souchs.phone = '';
        if (this.value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs.name = '';
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.company = '';
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "软件类型") {
        this.souchs.softtype = "";
      }
      if (tag == "邀请状态") {
        this.souchs.invitValue = "";
      }
      if (tag == "开始日期") {
        this.souchs.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs.totime = "";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },


    delTags: function delTags() {
      this.souchs = {};
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getUser();
    },

    changeSouch: function changeSouch(val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName = this.souchs.phone;
        this.disSouch = true;
      } else if (val == "姓名") {
        this.proName = this.souchs.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs.company;
        this.disSouch = true;
      } else if (val == "软件类型") {
        this.disSofttype = true;
      } else if (val == "邀请状态") {
        this.disinvit = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "phone") {
          this.orderStr = "phoneOrder";
        } else if (val.prop == "name") {
          this.orderStr = "nameOrder";
        } else if (val.prop == "point") {
          this.orderStr = "pointOrder";
        } else if (val.prop == "userName") {
          this.orderStr = "usertypeOrder";
        } else if (val.prop == "softtype") {
          this.orderStr = "codeOrder";
        } else if (val.prop == "registertime") {
          this.orderStr = "registertimeOrder";
        } else if (val.prop == "company") {
          this.orderStr = "companyOrder";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getUser();
    },

    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return rowIndex == 0 ? "background:#F5F7FA" : '';
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },


    getUser: function getUser(val) {
      var _this2 = this;

      if (this.value == "账号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.company = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }

      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        userType: '',

        username: this.souchs.name,
        phone: this.souchs.phone,
        company: this.souchs.company,
        registertimefrom: this.souchs.fromtime,
        registertimeto: this.souchs.totime,
        softtype: this.souchs.softtype,
        invitestatus: this.souchs.invitValue,

        orderType: this.orderType,
        orderStr: this.orderStr,
        searchText: this.searchText
      };

      this.downHrefExcel = _index.API_Integral.exportCreditsExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&registertimefrom=" + (this.souchs.fromtime || '') + "&registertimeto=" + (this.souchs.totime || '') + "&softtype=" + (this.souchs.softtype || '') + "&invitestatus=" + (this.souchs.invitestatus || '') + "&phone=" + (this.souchs.phone || '') + "&company=" + (this.souchs.company || '') + "&username=" + (this.souchs.name || '') + "";

      this.listLoading = true;
      _index.API_Integral.getcreditsPage(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              res.data.data.list[i].registertimeyuan = res.data.data.list[i].registertime;
              if (res.data.data.list[i].registertime) {
                res.data.data.list[i].registertime = res.data.data.list[i].registertime.substring(0, 10);
              }
            }
            _this2.total = res.data.data.totalRow;
            _this2.users = res.data.data.list;
            _this2.listLoading = false;
          }
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getModels: function getModels() {
      var _this3 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Models.getAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.models = res.data.data;
          _this3.cities = [];
          _this3.citiesd = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this3.cities.push(res.data.data[i].modulename);
            var jsones = { "modulename": res.data.data[i].modulename, "id": res.data.data[i].id };
            _this3.citiesd.push(jsones);
          }
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },

    getCode1: function getCode1() {
      var _this4 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.yhlx = [];
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.yhlx.push(jsons);
            var json = { 'value': res.data.data[i].code, 'label': res.data.data[i].name };
            _this.softtypes.push(json);
          }
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
      });

      _index.API_Admin.tbCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.companyList = res.data.data;
        }
      });
    },

    getCode2: function getCode2() {
      var _this5 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.AccList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.zhlx = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.zhlx.push(jsons);
          }
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },

    getCode: function getCode() {
      var _this6 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "label": res.data.data[i].name };
            _this.inviValues.push(jsons);
          }
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    }
  },

  created: function created() {

    this.getCookie();
    this.getCode1();
    this.getCode2();

    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getUser();
    this.getModels();
    this.getCode();

    this.downHref = _index.API_Admin.userExcelTemplate() + "?token=" + this.token + "&checkCode=" + this.checkCode;
  }
};

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  data: function data() {
    return {
      downHref: '',
      disSouch: true,
      disType: false,
      disAccountType: false,
      disTime1: false,
      disTime2: false,
      token: '',
      checkCode: "",
      id: "",
      listLoading: false,
      dataList: [],
      souchs: {
        application_time: ''
      },

      proName: '',
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      options: [{ value: '姓名', label: '姓名' }, { value: '手机号', label: '手机号' }, { value: '企业', label: '企业' }, { value: '状态', label: '状态' }, { value: '申请日期', label: '申请日期' }],
      value: '',
      types: [{ value: '0', label: '申请中' }, { value: '1', label: '通过' }, { value: '2', label: '驳回' }],
      accountType: '',
      accountTypes: [{ value: '0', label: '个人订单' }, { value: '1', label: '企业订单' }],
      typeValue: '',
      dynamicTags: [],
      orderStr: "application_time",
      orderType: 'desc'
    };
  },

  methods: {
    handleSortChange: function handleSortChange(val) {
      if (val) {
        this.orderStr = val.prop;
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch: function changeSouch(val) {
      this.disAccountType = false;
      this.disSouch = false;
      this.disType = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "状态") {
        this.typeValue = this.souchs.status;
        this.disType = true;
      } else if (val == "姓名") {
        this.proName = this.souchs.user_name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs.org_name;
        this.disSouch = true;
      } else if (val == "手机号") {
        this.proName = this.souchs.account;
        this.disSouch = true;
      } else if (val == "申请日期") {
        this.disTime1 = true;
      }
    },
    getList: function getList(val) {
      var _this = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      if (this.value == "手机号") {
        this.souchs.account = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.user_name = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.org_name = this.proName;
      }
      if (this.value == "状态") {
        this.souchs.status = this.typeValue;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,

        status: this.souchs.status,
        user_name: this.souchs.user_name,
        org_name: this.souchs.org_name,
        account: this.souchs.account,
        application_time: this.souchs.application_time,

        orderType: this.orderType,
        orderStr: this.orderStr

      };
      this.listLoading = true;
      _index.API_Integral.getListPage(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.dataList = res.data.data.list;
          _this.total = res.data.data.totalRow;
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
        _this.listLoading = false;
      });
    },
    delTags: function delTags() {
      this.souchs = {}, this.souchs.souType = '';
      this.value = '';
      this.typeValue = '';
      this.accountType = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == "状态") {
        this.souchs.status = "";
        this.typeValue = '';
      }
      if (tag == "姓名") {
        this.souchs.user_name = "";
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.org_name = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "手机号") {
        this.souchs.account = "";
        if (this.value == "手机号") {
          this.proName = '';
        }
      }

      if (tag == "开始日期") {
        this.souchs.application_time = "";
      }

      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    handleDel: function handleDel(index, row, type) {
      var _this2 = this;

      var title = type == 1 ? '确认通过吗?' : '确认驳回吗?';

      this.$confirm(title, '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this2.token,
          checkCode: _this2.checkCode,
          id: row.id,
          status: type
        };
        _index.API_Integral.updateStatus(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this2.$message({
              message: '操作成功',
              type: 'success'
            });
            _this2.getList();
          } else {
            _this2.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this2.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    exportExlsx: function exportExlsx() {
      var link = document.createElement('a');
      var body = document.querySelector('body');

      var href = _index.API_Integral.exportWbs() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&status=" + (this.souchs.status || '') + "&user_name=" + (this.souchs.user_name || '') + "&org_name=" + (this.souchs.org_name || '') + "&account=" + (this.souchs.account || '') + "&application_time=" + (this.souchs.application_time || '') + "&orderStr=" + (this.orderStr || '') + "&orderType=" + (this.orderType || '');

      link.href = href;

      link.download = '积分兑换导出';

      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.getCookie();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  data: function data() {
    return {
      downHref: '',
      disSouch: true,
      disType: false,
      disAccountType: false,
      token: '',
      checkCode: "",
      id: "",
      listLoading: false,
      dataList: [],
      souchs: {},

      proName: '',
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      options: [{ value: '姓名', label: '姓名' }, { value: '手机号', label: '手机号' }, { value: '企业', label: '企业' }],
      value: '',
      accountType: '2021',
      accountTypes: [{ value: '2021', label: '2021' }, { value: '2020', label: '2020' }, { value: '2019', label: '2019' }],
      typeValue: '',
      dynamicTags: [],
      orderStr: "",
      orderType: ''
    };
  },

  methods: {
    accountTypeChange: function accountTypeChange() {
      this.getList();
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        this.orderStr = val.prop;
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch: function changeSouch(val) {
      this.disAccountType = false;
      this.disSouch = false;
      this.disType = false;
      if (val == "姓名") {
        this.proName = this.souchs.user_name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs.org_name;
        this.disSouch = true;
      } else if (val == "手机号") {
        this.proName = this.souchs.account;
        this.disSouch = true;
      }
    },
    getList: function getList(val) {
      var _this = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      if (this.value == "手机号") {
        this.souchs.account = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.user_name = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.org_name = this.proName;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,

        status: this.souchs.status,
        user_name: this.souchs.user_name,
        org_name: this.souchs.org_name,
        account: this.souchs.account,
        year: this.accountType,
        orderType: this.orderType,
        orderStr: this.orderStr

      };
      this.listLoading = true;
      _index.API_Integral.getListPage(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.dataList = res.data.data.list;
          _this.total = res.data.data.totalRow;
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
        _this.listLoading = false;
      });
    },
    delTags: function delTags() {
      this.souchs = {}, this.souchs.souType = '';
      this.value = '';
      this.typeValue = '';

      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {

      if (tag == "姓名") {
        this.souchs.user_name = "";
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.org_name = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "手机号") {
        this.souchs.account = "";
        if (this.value == "手机号") {
          this.proName = '';
        }
      }

      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    exportExlsx: function exportExlsx() {
      var link = document.createElement('a');
      var body = document.querySelector('body');

      var href = _index.API_Integral.exportWbs() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&status=" + (this.souchs.status || '') + "&user_name=" + (this.souchs.user_name || '') + "&org_name=" + (this.souchs.org_name || '') + "&account=" + (this.souchs.account || '') + "&orderStr=" + (this.orderStr || '') + "&orderType=" + (this.orderType || '') + "&year=" + this.accountType;

      link.href = href;

      link.download = '积分兑换导出';

      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.getCookie();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    getAIPdfList: function getAIPdfList(params) {
        var url = _config.baseURL + '/tbPdfTransformationRecord/list';
        return _axios2.default.post(url, _qs2.default.stringify(params));
    }
};

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    getAIRilabList: function getAIRilabList(params) {
        var url = _config.baseURL + '/tbAiriImageOptimize/getAllList';
        return _axios2.default.post(url, _qs2.default.stringify(params));
    },
    getAIRilabStatistics: function getAIRilabStatistics() {
        var url = _config.baseURL + '/tbAiriImageOptimize/getStats';
        return _axios2.default.post(url);
    }
};

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getData: function getData(params) {
    var url = _config.baseURL + '/tbUser/infoCount';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  pointByHour: function pointByHour(params) {
    var url = _config.baseURL + '/tbUser/pointByHour';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  dayVisit: function dayVisit(params) {
    var url = _config.baseURL + '/tbUser/dayVisit';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  yaerVisit: function yaerVisit(params) {
    var url = _config.baseURL + '/tbUser/activeUserByYear';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  registerCount: function registerCount(params) {
    var url = _config.baseURL + '/tbUser/registerCount';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  adminModulePointPie: function adminModulePointPie(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/adminModulePointPie';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getPeiAddress: function getPeiAddress(params) {
    var url = _config.baseURL + '/statistical/getPeiAddressCa';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  accountDetail: function accountDetail(params) {
    var url = _config.baseURL + '/tbUser/getDetail';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  accountUpdate: function accountUpdate(params) {
    var url = _config.baseURL + '/tbUser/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getDaylive: function getDaylive(params) {
    var url = _config.baseURL + '/tbUser/DayLive';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getAdminList: function getAdminList(params) {
    var url = _config.baseURL + '/tbAdminuser/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setAdmin: function setAdmin(params) {
    var url = _config.baseURL + '/tbAdminuser/addAdminUser';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delAdmin: function delAdmin(params) {
    var url = _config.baseURL + '/tbAdminuser/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  editAdmin: function editAdmin(params) {
    var url = _config.baseURL + '/tbAdminuser/adminUserModify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  loginAdmin: function loginAdmin(params) {
    var url = _config.baseURL + '/tbAdminuser/adminUserlogin';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setUserModule: function setUserModule(params) {
    var url = _config.baseURL + '/tbUser/setUserModule';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delUser: function delUser(params) {
    var url = _config.baseURL + '/tbUser/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  modifyUser: function modifyUser(params) {
    var url = _config.baseURL + '/tbUser/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addUserSingle: function addUserSingle(params) {
    var url = _config.baseURL + '/tbUser/addUserSingle';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  checkPhoneUnique: function checkPhoneUnique(param) {
    var url = _config.baseURL + '/tbUser/userPhoneCheck?phone=' + param.phone;
    return _axios2.default.post(url);
  },
  UserList: function UserList(params) {
    var url = _config.baseURL + '/tbType/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  AccList: function AccList(params) {
    var url = _config.baseURL + '/tbCode/getAcountList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getList: function getList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserModulePointPie: function getUserModulePointPie(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserModulePointPie';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  loginRecord: function loginRecord(params) {
    var url = _config.baseURL + '/tbUser/loginRecord';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  pointByPerson: function pointByPerson(params) {
    var url = _config.baseURL + '/tbUser/pointByPerson';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  importUserExcelfile: function importUserExcelfile(param, data) {
    var url = _config.baseURL + '/tbUser/importUserExcel?' + param;
    return _axios2.default.post(url, data);
  },
  tbCompanyList: function tbCompanyList(params) {
    var url = _config.baseURL + '/tbCompany/companyList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyManage: function getCompanyManage(params) {
    var url = _config.baseURL + '/tbCompany/getCompanyManage';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  exportPointExcel: function exportPointExcel(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/exportPointExcel';
    return url;
  },
  setCompanyManager: function setCompanyManager(params) {
    var url = _config.baseURL + '/tbUser/setCompanyManager';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  hardwareBinding: function hardwareBinding(params) {
    var url = _config.baseURL + '/tbCompany/hardwareBinding';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  userExcelTemplate: function userExcelTemplate(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/userExcelTemplate';
    return url;
  },
  getCompany: function getCompany(params) {
    var url = _config.baseURL + '/tbCompany/getCompany';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getAutoList: function getAutoList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delAutoList: function delAutoList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/productOperate';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  autoDetail: function autoDetail(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/productRenew';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  autoOrder: function autoOrder(params) {
    var url = _config.baseURL + '/tbOrder/renewOrder';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDetailByAuthProductId: function getDetailByAuthProductId(params) {
    var url = _config.baseURL + '/tbOrder/getDetailByAuthProductId';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addUserNote: function addUserNote(params) {
    var url = _config.baseURL + '/tbUserNote/add';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserNote: function getUserNote(params) {
    var url = _config.baseURL + '/tbUserNote/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getSelectCommonList: function getSelectCommonList(path, params) {
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "post";

    var url = _config.baseURL + path;
    return _axios2.default[method](url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  upload: function upload(params) {
    var url = _config.baseURL + '/tbPic/modify';
    return url;
  },
  getLBlist: function getLBlist(params) {
    var url = _config.baseURL + '/tbLunbotu/list';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delLBlist: function delLBlist(params) {
    var url = _config.baseURL + '/tbLunbotu/delete';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setLBlist: function setLBlist(params) {
    var url = _config.baseURL + '/tbLunbotu/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setLoglist: function setLoglist() {
    var url = _config.baseURL + '/tbPic/setProductLogo';
    return url;
  },
  setCompanyPic: function setCompanyPic() {
    var url = _config.baseURL + '/tbPic/modify';
    return url;
  },
  getLBTDetail: function getLBTDetail(params) {
    var url = _config.baseURL + '/tbLunbotu/getDetail';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(48);

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getrihuo: function getrihuo(params) {
    var url = _config.baseURL + "/tbClientLogCensus/userCountByDay";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getPageLoad: function getPageLoad(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/pageLoad";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getPageLoad2: function getPageLoad2(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/pageLoadPage";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getmoduleintegral: function getmoduleintegral(params) {
    var url = _config.baseURL + "/tbClientLogModule/listBYmoduleAndLog";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getTbModule: function getTbModule(params) {
    var url = _config.baseURL + "/tbModule/list";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getTbModuleDetails: function getTbModuleDetails(params) {
    var url = _config.baseURL + "/tbClientLogCmd/listBYmoduleCmdAndLog";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getModuleUser: function getModuleUser(params) {
    var url = _config.baseURL + "/tbClientLog/getUserPointWithModByLog";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getMarketPictureCount: function getMarketPictureCount(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/marketPictureCount";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getMarketPictureMap: function getMarketPictureMap(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/marketPictureMap";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getIntegralStatis: function getIntegralStatis(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/IntegralStatistics";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getintegraDetail: function getintegraDetail(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/histogramStatistics";
    params.city = encodeURI((0, _stringify2.default)(params.city));

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserPointExcel: function getUserPointExcel() {
    var url = _config.baseURL + "/tbClientLog/getUserPointWithModByLogExcel";
    return url;
  },
  exportListdata: function exportListdata() {
    var url = _config.baseURL + "/enterprise/loadRatio/exportDoc";
    return url;
  },
  exportmokuaiwai: function exportmokuaiwai() {
    var url = _config.baseURL + "/tbClientLogModule/listBYmoduleAndLogExcel";
    return url;
  },
  exportmodellist: function exportmodellist() {
    var url = _config.baseURL + "/tbClientLogCmd/listBYmoduleCmdAndLogExcel";
    return url;
  },
  exportMarke: function exportMarke() {
    var url = _config.baseURL + "/enterprise/loadRatio/exportMarket";
    return url;
  },
  loadRateSum: function loadRateSum(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/loadRateSum";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  loadRatio: function loadRatio(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/rankingOrg";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  rankingUser: function rankingUser(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/rankingUser";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  zombieUser: function zombieUser(params) {
    var url = _config.baseURL + "/tbUser/MonthLive";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  marketStatisticsCustomer: function marketStatisticsCustomer(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/marketStatisticsCustomer?dateType=" + params.dateType + '&date=' + params.date + '&year=' + params.year;
    return _axios2.default.get(url);
  },
  marketStatisticsCount: function marketStatisticsCount(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/marketStatisticsCount?dateType=" + params.dateType + '&date=' + params.date + '&year=' + params.year;
    return _axios2.default.get(url);
  },
  userStatisticsPie: function userStatisticsPie(params) {
    var url = _config.baseURL + "/tbUser/userStatisticsPie?managerAdminuser=" + params.managerAdminuser + '&status=' + params.status + '&type=' + params.type;
    return _axios2.default.get(url);
  },
  userStatisticsLine: function userStatisticsLine(params) {
    var url = _config.baseURL + "/tbUser/userStatisticsLine?managerAdminuser=" + params.managerAdminuser + '&type=' + params.type;
    return _axios2.default.get(url);
  },
  userStatisticsLineSum: function userStatisticsLineSum(params) {
    var url = _config.baseURL + "/tbUser/userStatisticsLineSum?managerAdminuser=" + params.managerAdminuser + '&type=' + params.type;
    return _axios2.default.get(url);
  },
  getUserPointWithCmdByLog: function getUserPointWithCmdByLog(params) {
    var url = _config.baseURL + "/tbClientLog/getUserPointWithCmdByLog?userid=" + params.userid + '&moduleid=' + params.moduleid + '&dBegin=' + params.dBegin + '&dEnd=' + params.dEnd + '&listType=' + params.listType + '&pageNumber=' + params.pageNumber + '&pageSize=' + params.pageSize;
    return _axios2.default.get(url);
  }
};

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getListPage: function getListPage(params) {
    var url = _config.baseURL + '/tbCreditsExchange/getListPage';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  updateStatus: function updateStatus(params) {
    var url = _config.baseURL + '/tbCreditsExchange/updateStatus';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  exportWbs: function exportWbs(params) {
    var url = _config.baseURL + '/tbCreditsExchange/exportWbs';
    return url;
  },
  getcreditsPage: function getcreditsPage(params) {
    var url = _config.baseURL + '/tbUser/userPointList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  exportCreditsExcel: function exportCreditsExcel(params) {
    var url = _config.baseURL + '/tbUser/userPointExcel';
    return url;
  }
};

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  login: function login(params) {
    var url = _config.baseURL + '/tbUser/login';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  register: function register(params) {
    var url = _config.baseURL + '/tbUser/userRegister';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  forget: function forget(params) {
    var url = _config.baseURL + '/tbUser/userPasswordReset';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  sendSmsCode: function sendSmsCode(params) {
    var url = _config.baseURL + '/tbUser/sendSmsCode';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  loginAdmin: function loginAdmin(params) {
    var url = _config.baseURL + '/tbAdminuser/adminUserlogin';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  CheckTencentCaptcha: function CheckTencentCaptcha(params) {
    var url = _config.baseURL + '/tbUser/CheckTencentCaptcha';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getUserProductSum: function getUserProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getcompanySetUserProductSum: function getcompanySetUserProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getcompanySetUserProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserDueProductSum: function getUserDueProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserDueProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserDueInMonthProductSum: function getUserDueInMonthProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserDueInMonthProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserGroupProductSum: function getUserGroupProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserGroupProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getLoginInfor: function getLoginInfor(params) {
    var url = _config.baseURL + '/tbClientLog/getLoginInfor';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getTypeList: function getTypeList(params) {
    var url = _config.baseURL + '/tbType/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  upTypeList: function upTypeList(params) {
    var url = _config.baseURL + '/tbType/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delTypeList: function delTypeList(params) {
    var url = _config.baseURL + '/tbType/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getAdminModule: function getAdminModule(params) {
    var url = _config.baseURL + "/tbModule/list";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setAdminModule: function setAdminModule(params) {
    var url = _config.baseURL + "/tbModule/modify";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delAdminModule: function delAdminModule(params) {
    var url = _config.baseURL + "/tbModule/delete";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getAdminModuleTwo: function getAdminModuleTwo(params) {
    var url = _config.baseURL + "/tbModule/getCmdlist";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  importAdminModule: function importAdminModule() {
    var url = _config.baseURL + "/tbModule/importModuleExcel";
    return url;
  },
  exportAdminModule: function exportAdminModule() {
    var url = _config.baseURL + "/tbModule/exportModuleExcel";
    return url;
  }
};

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getOrderList: function getOrderList(params) {
    var url = _config.baseURL + '/tbOrder/getList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addOrder: function addOrder(params) {
    var url = _config.baseURL + '/tbOrder/addOrder';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  detailOrder: function detailOrder(params) {
    var url = _config.baseURL + '/tbOrder/getDetail';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delOrder: function delOrder(params) {
    var url = _config.baseURL + '/tbOrder/deleteBeginAuth';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  verifyOrder: function verifyOrder(params) {
    var url = _config.baseURL + '/tbOrder/examineOrder';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  renewOrder: function renewOrder(params) {
    var url = _config.baseURL + '/tbOrder/renewOrderAuPro';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getPosition: function getPosition(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/requestMap?cityName=' + params.city + '&districtName=' + params.area + '&token=' + params.token + '&checkCode=' + params.checkCode;
    return _axios2.default.get(url);
  },
  getaddressfromposition: function getaddressfromposition(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/requestGetMapByLongitude?location=' + params.pos.toString() + '&token=' + params.token + '&checkCode=' + params.checkCode;
    return _axios2.default.get(url);
  }
};

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  productList: function productList(params) {
    var url = _config.baseURL + '/tbProduct/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setProductList: function setProductList(params) {
    var url = _config.baseURL + '/tbProduct/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delProductList: function delProductList(params) {
    var url = _config.baseURL + '/tbProduct/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  listDel: function listDel(params) {
    var url = _config.baseURL + '/tbProduct/listDel';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getGroupProductSum: function getGroupProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getGroupProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getProductSum: function getProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDueProductSum: function getDueProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getDueProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUnusedProductSum: function getUnusedProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUnusedProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDueInMonthProductSum: function getDueInMonthProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getDueInMonthProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyUserPointList: function getCompanyUserPointList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getCompanyUserPointList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyUserMonthPointList: function getCompanyUserMonthPointList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getCompanyUserMonthPointList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyMonthPointBrokenLine: function getCompanyMonthPointBrokenLine(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getCompanyMonthPointBrokenLine';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserMonthPointBrokenLine: function getUserMonthPointBrokenLine(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserMonthPointBrokenLine';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyMonthModulePointPie: function getCompanyMonthModulePointPie(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getCompanyMonthModulePointPie';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyUserMonthModulePointPie: function getCompanyUserMonthModulePointPie(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getCompanyUserMonthModulePointPie';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getLoginDevice: function getLoginDevice(params) {
    var url = _config.baseURL + '/tbClientLog/hardHashAnalyse';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getUserModule: function getUserModule(params) {
    var url = _config.baseURL + '/tbUser/getUserModule';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setUserModule: function setUserModule(params) {
    var url = _config.baseURL + '/tbUser/setUserModule';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getList: function getList(params) {
    var url = _config.baseURL + '/tbUsingapplication/getList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setList: function setList(params) {
    var url = _config.baseURL + '/tbUsingapplication/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  uploadFiles: function uploadFiles(params) {
    var url = _config.baseURL + '/tbPic/modify';
    return _axios2.default.post(url, params);
  }
};

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getUrlsList: function getUrlsList(params) {
    var url = _config.baseURL + '/tbSysmanage/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  upUrls: function upUrls(params) {
    var url = _config.baseURL + '/tbSysmanage/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delUrls: function delUrls(params) {
    var url = _config.baseURL + '/tbSysmanage/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(52);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _userList$getUserDeta;

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_userList$getUserDeta = {
  userList: function userList(params) {
    var url = _config.baseURL + "/tbUser/userList";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserDetail: function getUserDetail(params) {
    var url = _config.baseURL + "/tbUser/getDetail";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  companyList: function companyList(params) {
    var url = _config.baseURL + "/tbCompany/list";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addCompanyList: function addCompanyList(params) {
    var url = _config.baseURL + "/tbCompany/modify";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delCompanyList: function delCompanyList(params) {
    var url = _config.baseURL + "/tbCompany/delete";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  exportCompanyExcel: function exportCompanyExcel(params) {
    var url = _config.baseURL + "/tbCompany/exportExcel";
    return _axios2.default.post(url, params, {
      responseType: "blob",
      headers: { "Content-Type": "application/json" }
    });
  },
  importCompanyExcel: function importCompanyExcel(formData) {
    var url = _config.baseURL + "/tbCompany/importExcel";
    return _axios2.default.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  },
  setCompanyManager: function setCompanyManager(params) {
    var url = _config.baseURL + "/tbUser/setCompanyManager";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCode: function getCode(params) {
    var url = _config.baseURL + "/tbCode/list";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  userListByDay: function userListByDay(params) {
    var url = _config.baseURL + "/tbUser/userListByDay";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  userListByExcel: function userListByExcel(params) {
    var url = _config.baseURL + "/tbUser/userListByExcel";
    return url;
  },
  allUserByExcel: function allUserByExcel(params) {
    var url = _config.baseURL + "/tbUser/allUserByExcel";
    return url;
  },
  allAdminuser: function allAdminuser(param) {
    var url = _config.baseURL + "/tbAdminuser/list?type=2&token=" + param.token + "&checkCode=" + param.checkCode;
    return _axios2.default.get(url);
  },
  getComputeDetail: function getComputeDetail(id) {
    var url = _config.baseURL + "/tbCompany/getDetail?id=" + id;
    return _axios2.default.get(url);
  },
  getCompanyManage: function getCompanyManage(param) {
    var url = _config.baseURL + "/tbCompany/getCompanyManage?companyId=" + param.companyId + "&token=" + param.token + "&checkCode=" + param.checkCode;
    return _axios2.default.get(url);
  },
  getCompanyUser: function getCompanyUser(param) {
    var url = _config.baseURL + "/tbCompany/getCompanyUser?companyId=" + param.companyId + "&token=" + param.token + "&checkCode=" + param.checkCode;
    return _axios2.default.get(url);
  }
}, (0, _defineProperty3.default)(_userList$getUserDeta, "setCompanyManager", function setCompanyManager(params) {
  var url = _config.baseURL + "/tbUser/setCompanyManager?companyid=" + params.companyid + "&userid=" + params.userid + "&toke=" + params.toke + "&checkCode=" + params.checkCode;
  return _axios2.default.get(url);
}), (0, _defineProperty3.default)(_userList$getUserDeta, "getCompanySearch", function getCompanySearch(param) {
  var url = _config.baseURL + "/tbCompany/companySearch";
  return _axios2.default.post(url, param);
}), (0, _defineProperty3.default)(_userList$getUserDeta, "checkCompanyUnique", function checkCompanyUnique(param) {
  var url = _config.baseURL + "/tbCompany/companyCheck?name=" + param.name;
  return _axios2.default.post(url);
}), _userList$getUserDeta);

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

var _jsCookie = __webpack_require__(377);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  setProduct: function setProduct(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/companyProductDistribute';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  userList: function userList(params) {
    var url = _config.baseURL + '/tbUser/userListFront';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delComUserList: function delComUserList(params) {
    var url = _config.baseURL + '/tbUser/companyManagerRemoveUser';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delProduct: function delProduct(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/companyProductDistributeCancel';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delProductDepart: function delProductDepart(params) {
    var url = _config.baseURL + '/tbDept/deptProductCancle';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getList: function getList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  accountDetail: function accountDetail(params) {
    var url = _config.baseURL + '/tbUser/getDetail';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addComList: function addComList(params) {
    var url = _config.baseURL + '/tbUser/companyManagerAddUser';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getSBList: function getSBList(params) {
    var url = _config.baseURL + '/tbComputermanage/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addSBList: function addSBList(params) {
    var url = _config.baseURL + '/tbComputermanage/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delSBList: function delSBList(params) {
    var url = _config.baseURL + '/tbComputermanage/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addComUserList: function addComUserList(params) {
    var url = _config.baseURL + '/tbUser/adminUserAddUsers';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  companyProductBatchDistribute: function companyProductBatchDistribute(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/companyProductBatchDistribute';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  companyBatchAdd: function companyBatchAdd(params) {
    var url = _config.baseURL + '/tbComputermanage/batchAdd';
    return url;
  },
  companyTemplate: function companyTemplate(params) {
    var url = _config.baseURL + '/tbComputermanage/template' + '?checkCode=' + _jsCookie2.default.get("dnnyptadmin_checkCode") + '&token=' + _jsCookie2.default.get("dnnyptadmin_token");
    return url;
  },
  getCompanyUser: function getCompanyUser(params) {
    var url = _config.baseURL + '/tbUser/getCompanyUser';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDepartList: function getDepartList(params) {
    var url = _config.baseURL + '/tbDept/deptList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDepartDetail: function getDepartDetail(params) {
    var url = _config.baseURL + '/tbDept/deptDetail';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addDept: function addDept(params) {
    var url = _config.baseURL + '/tbDept/addDept';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  editDept: function editDept(params) {
    var url = _config.baseURL + '/tbDept/modifyDept';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delDepart: function delDepart(params) {
    var url = _config.baseURL + '/tbDept/deptDelete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDeptListByUserId: function getDeptListByUserId(params) {
    var url = _config.baseURL + '/tbDept/getDeptIdByUserId';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  dispatchProductToDepart: function dispatchProductToDepart(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/auProToDeptManager';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  checkDepartUnique: function checkDepartUnique(param) {
    var url = _config.baseURL + '/tbDept/deptNameCheck?deptname=' + param.deptname + '&companyid=' + param.companyid;
    return _axios2.default.post(url);
  },
  getTrackList: function getTrackList(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/marketPicturePage';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addTrack: function addTrack(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/marketPicture';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  updateTrack: function updateTrack(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/marketPictureUpdate';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  uploadPic: function uploadPic(params) {
    var url = _config.baseURL + '/tbPic/setPic';
    return (0, _axios2.default)({
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      url: url,
      method: 'post',
      data: params
    });
  },
  delPic: function delPic(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/delPic';
    return _axios2.default.post(url, params);
  },
  getComment: function getComment(marketid) {
    var url = _config.baseURL + "/tbMarketComment/list?marketid=" + marketid;
    return _axios2.default.get(url);
  },
  addComment: function addComment(param) {
    var url = _config.baseURL + "/tbMarketComment/modify?mode=save&marketid=" + param.marketid + '&userid=' + param.userid + '&note=' + param.note;
    return _axios2.default.post(url);
  },
  delComment: function delComment(id) {
    var url = _config.baseURL + "/tbMarketComment/delete?id=" + id;
    return _axios2.default.post(url);
  }
};

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currency = currency;
exports.formatMoney = formatMoney;
var digitsRE = /(\d{3})(?=\d)/g;

function currency(value, currency, decimals) {
  value = parseFloat(value);
  if (!isFinite(value) || !value && value !== 0) return '';
  currency = currency != null ? currency : '$';
  decimals = decimals != null ? decimals : 2;
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
}

function formatMoney(value, type) {
  if (/[^0-9\.]/.test(value)) return "0";
  if (value == null || value == "") return "0";
  value = value.toString().replace(/^(\d*)$/, "$1.");
  value = (value + "00").replace(/(\d*\.\d\d)\d*/, "$1");
  value = value.replace(".", ",");
  var re = /(\d)(\d{3},)/;
  while (re.test(value)) {
    value = value.replace(re, "$1,$2");
  }value = value.replace(/,(\d\d)$/, ".$1");
  if (type == 0) {
    var a = value.split(".");
    if (a[1] == "00") {
      value = a[0];
    }
  }
  return value;
}

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(815);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(50);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(822);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(422);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(816);

__webpack_require__(820);

var _vueRouter = __webpack_require__(823);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(814);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(19);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(813);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(817);

__webpack_require__(819);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(812);

var _index2 = _interopRequireDefault(_index);

var _vRegion = __webpack_require__(821);

var _vRegion2 = _interopRequireDefault(_vRegion);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _vViewer = __webpack_require__(811);

var _vViewer2 = _interopRequireDefault(_vViewer);

__webpack_require__(818);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.prototype.$moment = _moment2.default;

_vue2.default.use(_vRegion2.default, {});

_vue2.default.config.productionTip = false;
_vue2.default.use(_index2.default);

_vue2.default.prototype.$ajax = _axios2.default;

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

_vue2.default.use(_vViewer2.default);
_vViewer2.default.setDefaults({
  Options: { zIndex: 9999, "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

console.log('process.env==', "production");
var env = "production";

var base = function () {
  var path = location.pathname;

  if (/^\/authorizion/.test(path)) {
    return '/authorizion/';
  }

  if (env === 'test' && /^\/dnnCloud\/exchange/.test(path)) {
    console.log("dnnCloud/exchange/");
    return '/dnnCloud/exchange';
  }
  return '/';
}();

if (sessionStorage.getItem('token')) {
  _store2.default.commit('set__token', sessionStorage.getItem('token'));
}
var router = new _vueRouter2.default({
  mode: 'history',
  base: base,
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
  if (to.meta.requireAuth) {
    if (_store2.default.state.token) {
      next();
    } else {
      next({
        path: '/loginAdmin',
        query: { redirect: to.fullPath } });
    }
  } else {
    next();
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 564,
	"./af.js": 564,
	"./ar": 572,
	"./ar-dz": 565,
	"./ar-dz.js": 565,
	"./ar-kw": 566,
	"./ar-kw.js": 566,
	"./ar-ly": 567,
	"./ar-ly.js": 567,
	"./ar-ma": 568,
	"./ar-ma.js": 568,
	"./ar-ps": 569,
	"./ar-ps.js": 569,
	"./ar-sa": 570,
	"./ar-sa.js": 570,
	"./ar-tn": 571,
	"./ar-tn.js": 571,
	"./ar.js": 572,
	"./az": 573,
	"./az.js": 573,
	"./be": 574,
	"./be.js": 574,
	"./bg": 575,
	"./bg.js": 575,
	"./bm": 576,
	"./bm.js": 576,
	"./bn": 578,
	"./bn-bd": 577,
	"./bn-bd.js": 577,
	"./bn.js": 578,
	"./bo": 579,
	"./bo.js": 579,
	"./br": 580,
	"./br.js": 580,
	"./bs": 581,
	"./bs.js": 581,
	"./ca": 582,
	"./ca.js": 582,
	"./cs": 583,
	"./cs.js": 583,
	"./cv": 584,
	"./cv.js": 584,
	"./cy": 585,
	"./cy.js": 585,
	"./da": 586,
	"./da.js": 586,
	"./de": 589,
	"./de-at": 587,
	"./de-at.js": 587,
	"./de-ch": 588,
	"./de-ch.js": 588,
	"./de.js": 589,
	"./dv": 590,
	"./dv.js": 590,
	"./el": 591,
	"./el.js": 591,
	"./en-au": 592,
	"./en-au.js": 592,
	"./en-ca": 593,
	"./en-ca.js": 593,
	"./en-gb": 594,
	"./en-gb.js": 594,
	"./en-ie": 595,
	"./en-ie.js": 595,
	"./en-il": 596,
	"./en-il.js": 596,
	"./en-in": 597,
	"./en-in.js": 597,
	"./en-nz": 598,
	"./en-nz.js": 598,
	"./en-sg": 599,
	"./en-sg.js": 599,
	"./eo": 600,
	"./eo.js": 600,
	"./es": 604,
	"./es-do": 601,
	"./es-do.js": 601,
	"./es-mx": 602,
	"./es-mx.js": 602,
	"./es-us": 603,
	"./es-us.js": 603,
	"./es.js": 604,
	"./et": 605,
	"./et.js": 605,
	"./eu": 606,
	"./eu.js": 606,
	"./fa": 607,
	"./fa.js": 607,
	"./fi": 608,
	"./fi.js": 608,
	"./fil": 609,
	"./fil.js": 609,
	"./fo": 610,
	"./fo.js": 610,
	"./fr": 613,
	"./fr-ca": 611,
	"./fr-ca.js": 611,
	"./fr-ch": 612,
	"./fr-ch.js": 612,
	"./fr.js": 613,
	"./fy": 614,
	"./fy.js": 614,
	"./ga": 615,
	"./ga.js": 615,
	"./gd": 616,
	"./gd.js": 616,
	"./gl": 617,
	"./gl.js": 617,
	"./gom-deva": 618,
	"./gom-deva.js": 618,
	"./gom-latn": 619,
	"./gom-latn.js": 619,
	"./gu": 620,
	"./gu.js": 620,
	"./he": 621,
	"./he.js": 621,
	"./hi": 622,
	"./hi.js": 622,
	"./hr": 623,
	"./hr.js": 623,
	"./hu": 624,
	"./hu.js": 624,
	"./hy-am": 625,
	"./hy-am.js": 625,
	"./id": 626,
	"./id.js": 626,
	"./is": 627,
	"./is.js": 627,
	"./it": 629,
	"./it-ch": 628,
	"./it-ch.js": 628,
	"./it.js": 629,
	"./ja": 630,
	"./ja.js": 630,
	"./jv": 631,
	"./jv.js": 631,
	"./ka": 632,
	"./ka.js": 632,
	"./kk": 633,
	"./kk.js": 633,
	"./km": 634,
	"./km.js": 634,
	"./kn": 635,
	"./kn.js": 635,
	"./ko": 636,
	"./ko.js": 636,
	"./ku": 638,
	"./ku-kmr": 637,
	"./ku-kmr.js": 637,
	"./ku.js": 638,
	"./ky": 639,
	"./ky.js": 639,
	"./lb": 640,
	"./lb.js": 640,
	"./lo": 641,
	"./lo.js": 641,
	"./lt": 642,
	"./lt.js": 642,
	"./lv": 643,
	"./lv.js": 643,
	"./me": 644,
	"./me.js": 644,
	"./mi": 645,
	"./mi.js": 645,
	"./mk": 646,
	"./mk.js": 646,
	"./ml": 647,
	"./ml.js": 647,
	"./mn": 648,
	"./mn.js": 648,
	"./mr": 649,
	"./mr.js": 649,
	"./ms": 651,
	"./ms-my": 650,
	"./ms-my.js": 650,
	"./ms.js": 651,
	"./mt": 652,
	"./mt.js": 652,
	"./my": 653,
	"./my.js": 653,
	"./nb": 654,
	"./nb.js": 654,
	"./ne": 655,
	"./ne.js": 655,
	"./nl": 657,
	"./nl-be": 656,
	"./nl-be.js": 656,
	"./nl.js": 657,
	"./nn": 658,
	"./nn.js": 658,
	"./oc-lnc": 659,
	"./oc-lnc.js": 659,
	"./pa-in": 660,
	"./pa-in.js": 660,
	"./pl": 661,
	"./pl.js": 661,
	"./pt": 663,
	"./pt-br": 662,
	"./pt-br.js": 662,
	"./pt.js": 663,
	"./ro": 664,
	"./ro.js": 664,
	"./ru": 665,
	"./ru.js": 665,
	"./sd": 666,
	"./sd.js": 666,
	"./se": 667,
	"./se.js": 667,
	"./si": 668,
	"./si.js": 668,
	"./sk": 669,
	"./sk.js": 669,
	"./sl": 670,
	"./sl.js": 670,
	"./sq": 671,
	"./sq.js": 671,
	"./sr": 673,
	"./sr-cyrl": 672,
	"./sr-cyrl.js": 672,
	"./sr.js": 673,
	"./ss": 674,
	"./ss.js": 674,
	"./sv": 675,
	"./sv.js": 675,
	"./sw": 676,
	"./sw.js": 676,
	"./ta": 677,
	"./ta.js": 677,
	"./te": 678,
	"./te.js": 678,
	"./tet": 679,
	"./tet.js": 679,
	"./tg": 680,
	"./tg.js": 680,
	"./th": 681,
	"./th.js": 681,
	"./tk": 682,
	"./tk.js": 682,
	"./tl-ph": 683,
	"./tl-ph.js": 683,
	"./tlh": 684,
	"./tlh.js": 684,
	"./tr": 685,
	"./tr.js": 685,
	"./tzl": 686,
	"./tzl.js": 686,
	"./tzm": 688,
	"./tzm-latn": 687,
	"./tzm-latn.js": 687,
	"./tzm.js": 688,
	"./ug-cn": 689,
	"./ug-cn.js": 689,
	"./uk": 690,
	"./uk.js": 690,
	"./ur": 691,
	"./ur.js": 691,
	"./uz": 693,
	"./uz-latn": 692,
	"./uz-latn.js": 692,
	"./uz.js": 693,
	"./vi": 694,
	"./vi.js": 694,
	"./x-pseudo": 695,
	"./x-pseudo.js": 695,
	"./yo": 696,
	"./yo.js": 696,
	"./zh-cn": 697,
	"./zh-cn.js": 697,
	"./zh-hk": 698,
	"./zh-hk.js": 698,
	"./zh-mo": 699,
	"./zh-mo.js": 699,
	"./zh-tw": 700,
	"./zh-tw.js": 700
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1614;

/***/ }),
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.470127c.jpg";

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAYAAAC4wJK5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAaySURBVHgB7VpdiFVVFF5r73vPveP80t9T0rwFCmVYWJfIEyH4kinhQEqoQc9qUz06I72FpkFvCqPVKI7g30PlkyfBEQPRh5R8amIMKTPGaZy5c87Ze7f2mTk/+8z9/xkK/EDu/j/722vttddaI8Bj/DeA0EKoEbvPs6CfMViDCL2goG/xK1NKwm+KfjNFuIm7nCloIZom4Y7aa2iRzchgPShl1zQJ0aE5jgtwvOM9ZwKaRMMkvJO2TZOHat542R2gQxI7ltnmHIcGUTcJffKkLofKbZ4WnFAKHESc0moUNJJaKVD91NevANaUmXfTRdzSiGTqIuGesPcwUIdKdDmc4WGYgx+T+q7GtlpQvJOFJ3oscGUWfI8BdPV6vixQYSMNGUgvpBTuz253hqHVJPSFFXk4mz59VGqYuexLY+O0Czj/ehe4bifwfOX1i7BSIBuEpWTO8XncVasBqEpCnbT7pVKXSA36E82ORx/p2BWLPtj86Zd7gK9YAfVCk2GMVBQKidYJD/HNWtSrIgktAZlTN5IE9Onz7Zf3G+O+fqET8rnuqidfBdLHj5TAjxNNExyKr+K2a39UmscqdYqcGklJACQwY6NqbG0vdPb2NEsg2ExGfcER9iWa+gXkz6jv1vVUnFeuwxu1h+lnc7odUQ3pPq0+6sxbTzakPpVgyaPI1J5ES0E+tHarC/ZTZPVKHlTJRn0PhFK/RoNIhYJ2xOFoDMLnGUsehjYhrVqciw1QdG/gjp8epMeWlIRUZIliOPoO6H8hGQ1U8Kmc54PQJmjVoiMeD+tC8P3QlbNKqdYSEv6ovZMepuhB0lYoLAdEED4L6zRusJ1EuJR7E9UCePgazFmd6sJaQ4WXSoLBDoh3ecwwo2NbOct5XyFXB+IhbSSSh0nF1MGwKiQufEdlupP3wyCh70LyQfNcNEwpZO93g+Jci3q5iGQYP5KoFsBXq8G3GHy/rjtsNEhIqCwFkKIjmrhcRLg/nbwbvmAbg4JWq0VpmJIAsKO5HM8Zi2kppLBsRBQcDYsIdC9CnF7VGewjGkevs+EbkTNnLuRaUALLQYRn2HiiWgCRWbBQuW6ThJ+PXWTtFi/xRukulPtI24lolVJwN9qr8lYuFCymxlZZEQkMQ8lgEzBhrnLfgipoOxFUkTSYz1ZH7fmOTEyCwXNRGXDCXCFXlUSweDuJID6MP6TiB090x5KAhCSiiCzCbFlVSqNdRMhXmw7LUmFv3OFarLYlijWT0FjOdwQ4hVVRJXn6SakEA+t3s1tNhGL2SIUYqli16HLHJlZA1EFOdh+0AC0msjIskId91/hOWKDX+ibEX7ON6aKooEG0igiFLxEJxlgsiYwrIxJZ1zCr/cHjFw3MSmgCTROhxw1BRWaVM34r6kNyRKLywuPmRJ0dlNEL4Xf70CSaISIoxRPX6L3Qj1/U2e0b1gl1Ni7sk4kQsXhvHlqAJohsjOfAVaPHA5OEkHA+UbUjlco/70GLUDcREVzoKC+VYXjKHPCna5Cwtjv6cjthXeZht/7FgdNuM5c7jXqICJ8l2kmVsjK2TCgEDtx2lzx2FJxHgRC9ksNzOlDSeLpzBlqImoikpED+3ZjR788Har6ERPZ9x4GENLJKjQQFx5mFFqMaEd9nUTaFYvufWV6ZJOB6cLBlsh2YDNBtnWci+UiYcx9Bi1GOiPT4ILkJUQBEKbsPjIlidhYHSFZQIY3pfksZcJbMgKud/M7lb2D1K8+0ItuXRokUZgRK2B1gFqVwogYhwB9/UJWEhn9i/SVIhKxS4t6stI5A51zFtGKjKEPkB56TKSn4UzhwdS6sVvRiKb2+BRMBkpaMz91P2qFWARRLH+okhaZ7zE3JmSQBjeqp/RFK7eeWpvY5k4OQhXvQCpAV0pc4eQdAE2DwrmFSs9zDTc5f6elV4wlyRybYPL5ExWT2wxaSXRcu0p1hz0Kj4JkefYHpLbhmElDjJIENBgHhz8PbzoOSe4Q6IEbfGEomleNV1Cny3y/yFZSVEAm/pszGxawskGQ/TJ38wlIo9zErTtEszCEV2nzln3JL1m1lFtXrbLk/IFI+6xZ5nJO08mQYUuqAhv7a1MsUFqi9jOTo9JUcgjzGHqr2EvJyGjddr/hGNWwqdeKZJKAzhjY0BXIlGBzkWWU6dnT68M6VGXrkqro7Tdv7QDJ52KEWEm92jbPGaXPjksmLmUzq5OHRDGy9/aiWzYdo+X+LgBy+SCmVPqmt2WKsTqo0RxZkhl7nX+iIfw/iAb3hrrygTh/+nnYh73vamYPH+B/jXz5NZQdHcfw8AAAAAElFTkSuQmCC"

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAYAAAC4wJK5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARxSURBVHgB7VjPbxtVEJ55tus6YDdRhITUAzkheq7UFslWbFpuHNKKFARKml44UcGx4pL2xhGp5UwCNyhN4dJLJTs0RW3Ehb+AXCxVSCWoIVId775hxt5dv7W9PxxvHB/8KdHueN+v7803M/sWYIIJJphgHIEwIBaq5ekM2Auk6C1IEAS0Y2t780Hl6Q4MiIFILFaL3/DlCzhC8IJu/1jZujVgn3gYBYEOaO2nypPrcVvHIrFYLa3wwN95UwDUQPF/ktBQ5sWUjTkq9ypbtThd45GoFas8atkZvmeXPnlcnIFXMGOfhDQMAbLoKwK81jZgO0Mnru6+tr/78MKzl2H9VMS48HG1PNchANAE+7b5fPnZxVkb4I1hCTiLuesZCOcs1SwVmpk3lx9dnI3oFw4b7dWORWtm9vjsj7OZxkFjFhICpfElIN33bKArcm1kG7Orq6uBaw0l0fYCrbh2txd29/KJEXCBSm0Y5mUNkJebP0sPZ4L6hJIwvSDB3O2Fk1M6BwkDkbZZStue3aRWjGRz6ekgb4SSQCMWuLitmc/2rXTu4EBn4AiACu948yJea3lDq1SQNwJJSFplTc45Q+38PP9k3dcRs4lLyUXLG0R1xyxw+r0sN+KNfu0DSXDu9aSkFdwyn3369HzhqLzgza+gs2kaVpyFpBZ/f7dHwn1JRHnBbmRPwRFDEUiA7znmabLwnNycaPQqoL8nsB1MDmrmow9+PTtFKvmA7oakW5bVmmcT3ZCrlbamur3RQyKquOXy+QKMCOyN7z2Di1+QN3pIRBU3lbZGRiKo+Ik3zHTrI3EcxS0KcYqfj8RxFLcoxCl+vpc2KW7k3vP/h5tFj9TuPmSQ7EKfWeqcDjfgECDJ/0SnIxtq3HPft6X48RrXlVZ7jjdeeCT8abWFMupOgLcG6PfmTq2/vFJGEMaAtpCzDX0e6zTgb9IufjyfU/xeeHIa6sys4QbZqegddedqtRUChwMStRXhFL+gM0CNjJObIpLi1tOW5fA+y+kdvi2Qtr/GFCxBDBDZPxiGyPF+ZB+N5yXNdv8u6bYvCSFwb37Ly0wfPS6+Df2H3iCCX0AyBk+gNSxHycqRkec1JrCEKaxDJFjshD0kJN1GHorCIJOza+90Vhguq24ZSd94BMIx9JESM7hONlzijZJdKrBUvgWbHvVry8+uGEad+96FBDA0CQEC3eTM1ZYVwBl2+5nIPipe/MTBUHJy0SOrqPYJychFIp4QiKzAAnnXCU+1hCKjQxXHICRGQoBpqdwDf94dGonI6bgRQAKnYdxAEHgE6JDQsOneoqaVheqFORgTSH3h7Hep8wNtm899Ar5aLf1lnq1JqQd8/ZdfO0Z+jnChSRWwfRjKt5dFdZXB98w2vsDWQNeZVbVt4Rx75MtWv2MIVhcI5LeRbpp7j7j/ny8m5FO6fFJHwB0YN0iFB72EaeVJSVu2ft489XfgFi/+VprnLwxl8zeFlGV3vQ6jBsdA9+Jt0K/+gdzzWqVmwQQTTDDBWOJ/3/ziLJ2CvzIAAAAASUVORK5CYII="

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAYAAAC4wJK5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPeSURBVHgB7Zq/TxRBFMffm9tDD4VALLXAVhuNiYlR9NR/QFoLfzQW/AhHZ2IBFhgbw5kTY6zA0gJiZ4g/LhBjLEzoKKGhMipw5Phxt/N8wzF3u8fu3e7tQE7CNzl2d2Z35vuZzNvdeQvAIRCCYVEq2ZEvypQgukEAyd1u5hHsdGL82yTsg4xBaPNANMiNdnifBEuIcsQ0TGSIQOb3XGQWpmGIWuZ5Gq1weXq7xXqpjuPb9h2BOMw1Xe5GzMCEhghqvjOdXdHly48utXbGTpwCIe/ySQOAeNrdaDSYwBBRzAshE87zJUCPSZi6EI0ErJ/5apmCwUbMq5FHwBWvOQ5IYwLgI4RQVBhPiPW+7hRXDNebNuu93Q88AxZwmf9kBMhpOAAYF4Qa/c2CPV15SIGneV1eN2BNwwBkt+KxHqeHPRDr/dfT/KQdDGo+cMCahUm3js8NeUJspJJdVLAXXa2YDtgQMCIWbyvK4gMiuM8m25x1toDza1v5pdNvf+ZdEPnea4PcadqzRRWwAC8E0gyEUCMwtcyXryYc5cF9d0zgX8zM/RLlCncQZ7lkqXIVdPEvI0F84V8PBBQ3Pi0QbvEoPOZpuVypIYai5872lHmJOFCwi18ZvN8JQEQ5JFgoHyO1q+2WpE5KXegQ3qSUbR2fPSsJHrpgPDo3BeNnnjeZOMFNQvjk1fZmsb1T1Or85Ou5CQUTZCSjwviZF0CvpICcX5tIMl4TIkjnYWHUtOEYOUOI7dV1YcxX+QuuKDD15nwj5h2+wstkwEYxr2VBBCkYvmtNS6CqW6mCAQUzYNvFdmXc+VTdudsgTrD5SYmUkw0NZUWRILRqweyneS0jEFp+MPtl3tGveZVgcEofK4Aocz5Af/+/jiCaRUcQzaIjiGbREUSz6HBB7KRn9D5iEppM7O+c3udEwZqzrpIokNYHR3ky1399BJpAaj1iIzzht+HblVL7s+scvZN4k13iTTllEyMazvd2L270Xb1PEopwwHIupnjk75UriKb4hbK8ECMUBVdMcIrwqfq+Vi7gVA2BmCAhZsMkBKKo1kqQ9cMieOY8/3i8sOqCUKlKzm5cNJWqMWW+lHfCUX6dv+d8nT9mtazi2Pc/Nb9PRMl6S8B+3gzsHmbUegJ8zPtl/PRiypI06TQvRSGfsMRvBtjYcQMB1AhMPQgT5ssuIITCwPhBmDTfEEQYmGoIK2ZNmjYfCSIYzE4+6nKpE1zg5MEZ0+aNQGj5w3jLlHktIxBa9WBMm9cy/g8qSiUY9dkML5RKaJ7v/TP8oHpv0rzWvkD4iYauJHLbdqvab2uJ5aOa1/oHCNFPNQxQe7EAAAAASUVORK5CYII="

/***/ }),
/* 1708 */,
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1537)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(1781),
  /* scopeId */
  "data-v-31d56c14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1515)

var Component = __webpack_require__(5)(
  /* script */
  null,
  /* template */
  __webpack_require__(1765),
  /* scopeId */
  "data-v-0f02ba32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1549)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(871),
  /* template */
  __webpack_require__(1793),
  /* scopeId */
  "data-v-4b076483",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1580)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(872),
  /* template */
  __webpack_require__(1816),
  /* scopeId */
  "data-v-83e7217a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1524)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(873),
  /* template */
  __webpack_require__(1773),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1572)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(1810),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1536)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(875),
  /* template */
  __webpack_require__(1780),
  /* scopeId */
  "data-v-314e828e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1593)
__webpack_require__(1594)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(1827),
  /* scopeId */
  "data-v-f1fd6286",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1555)
__webpack_require__(1556)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(877),
  /* template */
  __webpack_require__(1798),
  /* scopeId */
  "data-v-57c21605",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1595)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(1828),
  /* scopeId */
  "data-v-f753404a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1521)
__webpack_require__(1522)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(879),
  /* template */
  __webpack_require__(1771),
  /* scopeId */
  "data-v-194f4ae3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1570)
__webpack_require__(1571)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(1809),
  /* scopeId */
  "data-v-713d559a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1510)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(881),
  /* template */
  __webpack_require__(1762),
  /* scopeId */
  "data-v-0c4b59ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1582)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(1818),
  /* scopeId */
  "data-v-8ba0d758",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1548)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(883),
  /* template */
  __webpack_require__(1792),
  /* scopeId */
  "data-v-4a0e6022",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1550)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(1794),
  /* scopeId */
  "data-v-50d0d14f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1551)
__webpack_require__(1552)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(1795),
  /* scopeId */
  "data-v-53c8b456",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1577)
__webpack_require__(1578)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(1814),
  /* scopeId */
  "data-v-7cc21527",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1559)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(887),
  /* template */
  __webpack_require__(1801),
  /* scopeId */
  "data-v-590559db",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1547)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(888),
  /* template */
  __webpack_require__(1791),
  /* scopeId */
  "data-v-48760567",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1540)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(889),
  /* template */
  __webpack_require__(1784),
  /* scopeId */
  "data-v-38156bfc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1567)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(891),
  /* template */
  __webpack_require__(1806),
  /* scopeId */
  "data-v-644c9b16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1564)
__webpack_require__(1565)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(892),
  /* template */
  __webpack_require__(1804),
  /* scopeId */
  "data-v-6315d127",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1527)
__webpack_require__(1528)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(1775),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1574)
__webpack_require__(1575)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(894),
  /* template */
  __webpack_require__(1812),
  /* scopeId */
  "data-v-78a4d8d7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1562)
__webpack_require__(1563)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(895),
  /* template */
  __webpack_require__(1803),
  /* scopeId */
  "data-v-5cee676e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1519)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(1769),
  /* scopeId */
  "data-v-18f02b92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1520)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(898),
  /* template */
  __webpack_require__(1770),
  /* scopeId */
  "data-v-191395e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1568)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(899),
  /* template */
  __webpack_require__(1807),
  /* scopeId */
  "data-v-66624324",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1516)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(1766),
  /* scopeId */
  "data-v-13006f62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1579)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(901),
  /* template */
  __webpack_require__(1815),
  /* scopeId */
  "data-v-80e5d33e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1576)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(1813),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1545)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(905),
  /* template */
  __webpack_require__(1789),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1531)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(1777),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1585)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(909),
  /* template */
  __webpack_require__(1820),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1569)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(916),
  /* template */
  __webpack_require__(1808),
  /* scopeId */
  "data-v-695c6de6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1596)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(917),
  /* template */
  __webpack_require__(1829),
  /* scopeId */
  "data-v-fa35a4de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1546)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(918),
  /* template */
  __webpack_require__(1790),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1534)
__webpack_require__(1535)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(919),
  /* template */
  __webpack_require__(1779),
  /* scopeId */
  "data-v-2fc07047",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1538)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(920),
  /* template */
  __webpack_require__(1782),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1586)
__webpack_require__(1587)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(921),
  /* template */
  __webpack_require__(1821),
  /* scopeId */
  "data-v-9bf113a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1554)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(922),
  /* template */
  __webpack_require__(1797),
  /* scopeId */
  "data-v-56c3f258",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1542)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(923),
  /* template */
  __webpack_require__(1786),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1529)
__webpack_require__(1530)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(924),
  /* template */
  __webpack_require__(1776),
  /* scopeId */
  "data-v-2b65cf61",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1511)
__webpack_require__(1512)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(926),
  /* template */
  __webpack_require__(1763),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1517)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(927),
  /* template */
  __webpack_require__(1767),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1583)
__webpack_require__(1584)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(1819),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1513)
__webpack_require__(1514)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(929),
  /* template */
  __webpack_require__(1764),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1532)
__webpack_require__(1533)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(930),
  /* template */
  __webpack_require__(1778),
  /* scopeId */
  "data-v-2f80b00d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1589)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(931),
  /* template */
  __webpack_require__(1823),
  /* scopeId */
  "data-v-cde99cc0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1523)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(932),
  /* template */
  __webpack_require__(1772),
  /* scopeId */
  "data-v-1e7db994",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "硬件码 / 备注"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList(1)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getList(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "adds",
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "adds",
    attrs: {
      "type": "text"
    }
  }, [_c('label', {
    attrs: {
      "for": "uploadwxsModal"
    }
  }, [_vm._v("导入")])])], 1), _vm._v(" "), _c('input', {
    ref: "clearFileModal",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "uploadwxsModal",
      "name": "file"
    },
    on: {
      "change": function($event) {
        return _vm.importFile($event)
      }
    }
  }), _vm._v(" "), _c('el-form-item', [_c('a', {
    attrs: {
      "href": _vm.hrefUrl
    }
  }, [_c('el-button', {
    staticClass: "adds",
    attrs: {
      "type": "text"
    }
  }, [_vm._v("下载模板")])], 1)])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "tooltip-effect": "dark",
      "data": _vm.proList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hardHash",
      "label": "设备硬件码",
      "min-width": "240",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "comment",
      "label": "备注",
      "min-width": "300",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.comment || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "300",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "intime",
      "label": "添加时间",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "operate"
        }, [_c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "编辑",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconEdit",
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "删除",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont icondelete",
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "新增设备",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "硬件码",
      "prop": "hardHash"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.hardHash),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "hardHash", $$v)
      },
      expression: "addForm.hardHash"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.deptname),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "deptname", $$v)
      },
      expression: "addForm.deptname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "comment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.comment),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "comment", $$v)
      },
      expression: "addForm.comment"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "编辑设备",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "硬件码",
      "prop": "hardHash"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.hardHash),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hardHash", $$v)
      },
      expression: "editForm.hardHash"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.deptname),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deptname", $$v)
      },
      expression: "editForm.deptname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "comment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.comment),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "comment", $$v)
      },
      expression: "editForm.comment"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-visit-form-view",
    attrs: {
      "width": "850px",
      "title": "拜访详情",
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.myVisible = $event
      },
      "close": _vm.handerClose
    }
  }, [(_vm.myDetail) ? _c('el-row', {
    staticClass: "toolbar",
    attrs: {
      "gutter": 24
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "110px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访客户："
    }
  }, [_vm._v(" " + _vm._s(_vm.$route.query.companyName || _vm.myDetail.companyName) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.adminUserName) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.successfulManagerName || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.agencyManagerName || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访日期："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.payVisitDate ? _vm.myDetail.payVisitDate.split(" ")[0] : '-'))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.contactUser) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式："
    }
  }, [_vm._v(" " + _vm._s(_vm.myDetail.contactPhone) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.position || '-'))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访方式："
    }
  }, [_c('span', {
    staticClass: "myTag-fill",
    class: _vm.myDetail.payVisitStatus == 1 ? 'pruple' : (_vm.myDetail.payVisitStatus == 2 ? 'primary' : 'warning')
  }, [_vm._v("\n                " + _vm._s(_vm.myDetail.payVisitStatus == 1 ? "电话沟通" : (_vm.myDetail.payVisitStatus == 2 ? '客户现场' : '视频会议')) + "\n              ")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户地址："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.addressInfo))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访详情："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.payVisitInfo || '-'))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现场照片："
    }
  }, [(_vm.myDetail.picList.length > 0) ? _c('PictureList', {
    attrs: {
      "pictureList": _vm.myDetail.picList
    }
  }) : _c('span', [_vm._v("-")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核状态："
    }
  }, [_c('span', {
    staticClass: "myTag",
    class: [_vm.myDetail.auditStatus == 1 ? 'warning' : 'primary']
  }, [_vm._v("\n                " + _vm._s(_vm.myDetail.auditStatus == 1 ? "待审核" : '已审核') + "\n              ")])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_c('span', {
    staticClass: "dividerSpan"
  }, [_vm._v("评论（" + _vm._s(_vm.commentList.length) + "）")])]), _vm._v(" "), _c('div', {
    staticClass: "commentBox"
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.commentList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "avatar"
    }), _vm._v(" "), _c('div', {
      staticClass: "itemInfo"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.username || '-'))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.intime || '-'))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.note || '-'))]), _vm._v(" "), _c('div', {
      staticClass: "actionBox"
    }, [(item.userid != _vm.userInfo.id) ? _c('span', {
      staticClass: "dnnfont iconcomment-dots",
      on: {
        "click": function($event) {
          return _vm.reply(item)
        }
      }
    }, [_vm._v(" 回复")]) : _vm._e(), _vm._v(" "), (item.userid === _vm.userInfo.id) ? _c('span', {
      staticClass: "dnnfont icondelete",
      on: {
        "click": function($event) {
          return _vm.deleteComment(item)
        }
      }
    }, [_vm._v(" 删除")]) : _vm._e()])])])
  }), 0), _vm._v(" "), (_vm.userInfo.type == 1 && !_vm.isReply) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "3",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.commentNote),
      callback: function($$v) {
        _vm.commentNote = $$v
      },
      expression: "commentNote"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isReply) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "3",
      "placeholder": '回复 ' + _vm.replyObj
    },
    model: {
      value: (_vm.replyNote),
      callback: function($$v) {
        _vm.replyNote = $$v
      },
      expression: "replyNote"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btnBox"
  }, [(_vm.userInfo.type == 1 && !_vm.isReply) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.postLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.postComment.apply(null, arguments)
      }
    }
  }, [_vm._v("发表评论")]) : _vm._e(), _vm._v(" "), (_vm.isReply) ? _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeReply.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isReply) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.postLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.replyComment.apply(null, arguments)
      }
    }
  }, [_vm._v("回复")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.myDetail && _vm.userInfo.type == 1 && _vm.myDetail.auditStatus == 1) ? _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit(_vm.myDetail)
      }
    }
  }, [_vm._v("审核通过")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-detail-box"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "font",
    on: {
      "click": _vm.bak
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left icon"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "shu"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "font-text"
  }, [_vm._v(_vm._s(_vm.$route.query.companyName))])]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("用户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }, [_vm._v("跟踪记录")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [_vm._v("企业设置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-content"
  }, [(_vm.activeIndex == 1) ? _c('company') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 7) ? _c('TrackManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 8) ? _c('CompamySetting') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-account-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "产品名称"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getProList(1)
            }
          },
          model: {
            value: (_vm.souchs.proName),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "proName", $$v)
            },
            expression: "souchs.proName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getProList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.proList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "logo2",
            "header-align": "center",
            "align": "center",
            "width": "200px",
            "label": "图片",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('img', {
                staticClass: "tpimg",
                attrs: {
                  "slot": "reference",
                  "src": scope.row.logo2,
                  "alt": scope.row.logo2
                },
                slot: "reference"
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "产品名称",
            "min-width": "240",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price",
            "label": "单价(元/月)",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "purchasabled",
            "label": "是否可购买",
            "width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag primary"
              }, [_vm._v(_vm._s(scope.row.purchasable == 1 ? "否" : '是'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "useful",
            "label": "是否作废",
            "width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag primary"
              }, [_vm._v(_vm._s(scope.row.useful == 1 ? "否" : '是'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })])], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增产品",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片",
            "required": ""
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.imageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.imageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入",
            "auto-complete": "off"
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "单价",
            "prop": "price"
          }
        }, [_c('el-input', {
          staticStyle: {
            "width": "217px"
          },
          attrs: {
            "placeholder": "请输入"
          },
          on: {
            "blur": function($event) {
              return _vm.priceLose(1)
            }
          },
          model: {
            value: (_vm.addForm.price),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "price", $$v)
            },
            expression: "addForm.price"
          }
        }), _vm._v(" 元/月\n            ")], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "可购买",
            "prop": "purchasable"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.purchasable),
            callback: function($$v) {
              _vm.purchasable = $$v
            },
            expression: "purchasable"
          }
        }, _vm._l((_vm.gms), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "是否废弃",
            "prop": "useful"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.useful),
            callback: function($$v) {
              _vm.useful = $$v
            },
            expression: "useful"
          }
        }, _vm._l((_vm.usefulLists), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "产品模块"
          }
        }, [_c('div', {
          staticClass: "mk_div",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange
          },
          model: {
            value: (_vm.checkedCities),
            callback: function($$v) {
              _vm.checkedCities = $$v
            },
            expression: "checkedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticClass: "mk_elbox",
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑产品",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            },
            "closed": _vm.closeDialog
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片",
            "required": ""
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.editImageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.editImageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "单价",
            "prop": "price"
          }
        }, [_c('el-input', {
          staticStyle: {
            "width": "217px"
          },
          attrs: {
            "placeholder": "请输入"
          },
          on: {
            "blur": function($event) {
              return _vm.priceLose(2)
            }
          },
          model: {
            value: (_vm.editForm.price),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "price", $$v)
            },
            expression: "editForm.price"
          }
        }), _vm._v(" 元/月\n            ")], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "可购买",
            "prop": "purchasable"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.editForm.purchasable),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "purchasable", $$v)
            },
            expression: "editForm.purchasable"
          }
        }, _vm._l((_vm.gms), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "是否废弃",
            "prop": "useful"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.editForm.useful),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "useful", $$v)
            },
            expression: "editForm.useful"
          }
        }, _vm._l((_vm.usefulLists), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "产品模块"
          }
        }, [_c('div', {
          staticClass: "mk_div",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange2
          },
          model: {
            value: (_vm.editCheckedCities),
            callback: function($$v) {
              _vm.editCheckedCities = $$v
            },
            expression: "editCheckedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticClass: "mk_elbox",
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-UrlsNumber-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', [_c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleURLAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.urlList,
            "highlight-current-row": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber1 - 1) * _vm.pageSize1 + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "cloudserviceurl",
            "label": "路径",
            "min-width": "200"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "version",
            "label": "版本",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "comment",
            "label": "备注",
            "min-width": "240",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleURLEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleURLDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "visible": _vm.addUrlVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addUrlVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addUrl,
            "label-width": "80px",
            "rules": _vm.addUrlRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "路径",
            "prop": "cloudserviceurl"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addUrl.cloudserviceurl),
            callback: function($$v) {
              _vm.$set(_vm.addUrl, "cloudserviceurl", $$v)
            },
            expression: "addUrl.cloudserviceurl"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "版本",
            "prop": "version"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addUrl.version),
            callback: function($$v) {
              _vm.$set(_vm.addUrl, "version", $$v)
            },
            expression: "addUrl.version"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "备注",
            "prop": "comment"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "textarea",
            "rows": 3,
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addUrl.comment),
            callback: function($$v) {
              _vm.$set(_vm.addUrl, "comment", $$v)
            },
            expression: "addUrl.comment"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addUrlVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addUrlLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addUrlSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editUrlVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editUrlVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.editUrl,
            "label-width": "80px",
            "rules": _vm.editUrlRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "路径",
            "prop": "cloudserviceurl"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editUrl.cloudserviceurl),
            callback: function($$v) {
              _vm.$set(_vm.editUrl, "cloudserviceurl", $$v)
            },
            expression: "editUrl.cloudserviceurl"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "版本",
            "prop": "version"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editUrl.version),
            callback: function($$v) {
              _vm.$set(_vm.editUrl, "version", $$v)
            },
            expression: "editUrl.version"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "备注",
            "prop": "comment"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "textarea",
            "rows": 3,
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editUrl.comment),
            callback: function($$v) {
              _vm.$set(_vm.editUrl, "comment", $$v)
            },
            expression: "editUrl.comment"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editUrlVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editUrlLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editUrlSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber1,
            "page-size": _vm.pageSize1,
            "total": _vm.total1
          },
          on: {
            "current-change": _vm.handleCurrentChange1,
            "size-change": _vm.handleSizeChange1
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.adminModulePointPie
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "charts-box-copy-lpie"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dnnCloud-sys-box"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("轮播图")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("系统参数")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLBT),
      expression: "showLBT"
    }],
    staticClass: "sys-tab-item"
  }, [_c('UrlsLBT')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showURL),
      expression: "showURL"
    }],
    staticClass: "sys-tab-item"
  }, [_c('UrlsNumber')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    staticClass: "selected-product-tab",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "tooltip-effect": "dark",
      "data": _vm.productLists,
      "empty-text": "还没有选择产品"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "logo",
      "header-align": "center",
      "align": "center",
      "width": "100px",
      "label": "产品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "tpimg",
          attrs: {
            "src": scope.row.logo,
            "alt": scope.row.logo
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseNum",
      "label": "购买数量",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [(!_vm.isEdit) ? _c('span', [_vm._v(_vm._s(row.purchaseNum))]) : _c('el-input-number', {
          attrs: {
            "min": 1,
            "size": "small",
            "step-strictly": true,
            "controls-position": "right"
          },
          on: {
            "change": function (val) { return _vm.handleChangeNum(val, row, 'purchaseNum'); }
          },
          model: {
            value: (row.purchaseNum),
            callback: function($$v) {
              _vm.$set(row, "purchaseNum", $$v)
            },
            expression: "row.purchaseNum"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseMonth",
      "label": "购买时长(月)",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [(!_vm.isEdit) ? _c('span', [_vm._v(_vm._s(row.purchaseMonth))]) : _c('el-input-number', {
          attrs: {
            "min": 1,
            "size": "small",
            "step-strictly": true,
            "controls-position": "right"
          },
          on: {
            "change": _vm.handleChangeNum
          },
          model: {
            value: (row.purchaseMonth),
            callback: function($$v) {
              _vm.$set(row, "purchaseMonth", $$v)
            },
            expression: "row.purchaseMonth"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "单价(元)",
      "min-width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "price"
        }, [_vm._v(_vm._s(scope.row.price.toLocaleString()))])]
      }
    }])
  }), _vm._v(" "), (!_vm.isEdit) ? _c('el-table-column', {
    attrs: {
      "prop": "effectivetime",
      "label": "启用时间",
      "min-width": "130",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.effectivetime || '-'))])]
      }
    }], null, false, 1536076627)
  }) : _vm._e(), _vm._v(" "), (!_vm.isEdit) ? _c('el-table-column', {
    attrs: {
      "prop": "duetime",
      "label": "到期时间",
      "min-width": "130",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.duetime || '-'))])]
      }
    }], null, false, 270402858)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isEdit) ? _c('span', {
          staticClass: "dnnfont icondelete",
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.renewFlg == 1) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "续费",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconclock",
          on: {
            "click": function($event) {
              return _vm.handleRenewOrder(scope.$index, scope.row)
            }
          }
        })]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-copy-lpie-census"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-copy-lbar-census"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-account-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "155px"
          },
          attrs: {
            "placeholder": "账号 / 姓名 / 企业",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.searchName),
            callback: function($$v) {
              _vm.searchName = $$v
            },
            expression: "searchName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "placeholder": "用户类型",
            "clearable": ""
          },
          model: {
            value: (_vm.isCompanyUser),
            callback: function($$v) {
              _vm.isCompanyUser = $$v
            },
            expression: "isCompanyUser"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "个人用户",
            "value": "1"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "企业用户",
            "value": "2"
          }
        })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "开始日期"
          },
          model: {
            value: (_vm.souchs.fromtime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "fromtime", $$v)
            },
            expression: "souchs.fromtime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "结束日期"
          },
          model: {
            value: (_vm.souchs.totime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "totime", $$v)
            },
            expression: "souchs.totime"
          }
        })], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', {
          staticStyle: {
            "width": "130px"
          }
        }, [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.managerAdminuser
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "130px"
          },
          attrs: {
            "placeholder": "客户成功经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.successfulManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "130px"
          },
          attrs: {
            "placeholder": "经销商",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.agencyManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "placeholder": "是否分配",
            "clearable": ""
          },
          model: {
            value: (_vm.distributionStatus),
            callback: function($$v) {
              _vm.distributionStatus = $$v
            },
            expression: "distributionStatus"
          }
        }, _vm._l((_vm.distribution), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.addUser(1)
            }
          }
        }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.addUser(2)
            }
          }
        }, [_vm._v("批量导入")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('a', {
          attrs: {
            "href": _vm.downHref
          }
        }, [_vm._v("下载模板")])]), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('a', {
          attrs: {
            "href": _vm.downHrefExcel
          }
        }, [_vm._v("导出")])]) : _vm._e(), _vm._v(" "), _c('input', {
          ref: "clearFileModal",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "id": "uploadwxsModal",
            "name": "file",
            "accept": "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          },
          on: {
            "change": function($event) {
              return _vm.fileInputChange($event)
            }
          }
        })], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
          return _c('el-tag', {
            key: tag,
            attrs: {
              "closable": "",
              "disable-transitions": false
            },
            on: {
              "close": function($event) {
                return _vm.handleClose(tag)
              }
            }
          }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")])
        }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          on: {
            "click": _vm.delTags
          }
        }, [_vm._v("清除标签")]) : _vm._e()], 2)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          attrs: {
            "data": _vm.users,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "point",
            "label": "积分",
            "width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" " + _vm._s(scope.row.point || "-") + " ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "registertime",
            "label": "注册日期",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productTypeName",
            "label": "类型"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.productType === '1') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("\n            " + _vm._s(scope.row.productTypeName) + "\n          ")]) : (scope.row.productType === '2') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("\n            " + _vm._s(scope.row.productTypeName) + "\n          ")]) : _c('div', {
                staticClass: "gray"
              }, [_vm._v(_vm._s(scope.row.productTypeName))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "客户经理",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.adminName || "-") + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "客户成功经理",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.successfulManagerName || "-") + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "经销商",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.agencyManagerName || "-") + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "是否联系过",
            "min-width": "100",
            "sortable": "hasNote",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.hasNote == 0 ? "否" : "是") + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.readUser(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit0(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.canYouDel == 1) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handledel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), (_vm.editFormVisible0) ? _c('el-dialog', {
          staticClass: "model-edit model-user-box",
          attrs: {
            "width": "850px",
            "title": _vm.asTitle,
            "visible": _vm.editFormVisible0,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible0 = $event
            },
            "close": _vm.dialogClose
          }
        }, [_c('el-row', {
          attrs: {
            "gutter": 24
          }
        }, [_c('el-form', {
          ref: "editForm0",
          attrs: {
            "model": _vm.editForm0,
            "label-width": "100px",
            "rules": _vm.rules
          }
        }, [(_vm.modalType != 2) ? _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "账号",
            "prop": "phone"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm0.phone),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "phone", $$v)
            },
            expression: "editForm0.phone"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.modalType != 2) ? _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm0.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "name", $$v)
            },
            expression: "editForm0.name"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "软件类型",
            "prop": "code"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          model: {
            value: (_vm.editForm0.code),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "code", $$v)
            },
            expression: "editForm0.code"
          }
        }, _vm._l((_vm.yhlx), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户类型",
            "prop": "userType"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          on: {
            "change": function (val) { return _vm.handerChange(val, 'addCode'); }
          },
          model: {
            value: (_vm.editForm0.userType),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "userType", $$v)
            },
            expression: "editForm0.userType"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "个人用户",
            "value": "0"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "企业用户",
            "value": "1"
          }
        })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户经理"
          }
        }, [_c('SelectCommon', {
          key: _vm.curCompanyId || _vm.addCode == 0,
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "disabled": _vm.addCode == 1 || (_vm.addCode == 0 && _vm.userInfo.type != 1),
            "selectFirst": _vm.addCode == 1 && _vm.editForm0.companyuseid != '',
            "defaultVal": _vm.addCode == 0 && _vm.editForm0.managerAdminuser ?
              _vm.editForm0.managerAdminuser :
              '',
            "params": {
              ComId: _vm.addCode == 1 ? _vm.editForm0.companyuseid : '',
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户成功经理"
          }
        }, [_c('SelectCommon', {
          key: _vm.curCompanyId || _vm.addCode == 0,
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": true,
            "apiPath": _vm.addCode == 1 ?
              '/tbAdminuser/getAdminUserByComId' :
              '/tbAdminuser/list',
            "params": _vm.addCode == 1 ?
              {
                userType: 3,
                ComId: _vm.addCode == 1 ? _vm.editForm0.companyuseid : '',
              } :
              {
                type: 3
              },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "disabled": _vm.addCode == 1 || (_vm.addCode == 0 && _vm.userInfo.type != 1),
            "selectFirst": _vm.addCode == 1 && _vm.editForm0.companyuseid != '',
            "defaultVal": _vm.addCode == 0 && _vm.editForm0.successfulManager ?
              _vm.editForm0.successfulManager :
              ''
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'successfulManager'); }
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "经销商"
          }
        }, [_c('SelectCommon', {
          key: _vm.curCompanyId || _vm.addCode == 0,
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": true,
            "apiPath": _vm.addCode == 1 ?
              '/tbAdminuser/getAdminUserByComId' :
              '/tbAdminuser/list',
            "params": _vm.addCode == 1 ?
              {
                userType: 4,
                ComId: _vm.addCode == 1 ? _vm.editForm0.companyuseid : '',
              } :
              {
                type: 4
              },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "disabled": _vm.addCode == 1 || (_vm.addCode == 0 && _vm.userInfo.type != 1),
            "selectFirst": _vm.addCode == 1 && _vm.editForm0.companyuseid != '',
            "defaultVal": _vm.addCode == 0 && _vm.editForm0.agencyManager ?
              _vm.editForm0.agencyManager :
              ''
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'agencyManager'); }
          }
        })], 1)], 1), _vm._v(" "), (_vm.addCode == 0) ? _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "所属企业",
            "prop": "company"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm0.company),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "company", $$v)
            },
            expression: "editForm0.company"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addCode == 1) ? _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "所属企业",
            "prop": "companyuseid"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": ""
          },
          on: {
            "change": function (val) { return _vm.handerChange(val, 'curCompanyId'); }
          },
          model: {
            value: (_vm.editForm0.companyuseid),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "companyuseid", $$v)
            },
            expression: "editForm0.companyuseid"
          }
        }, _vm._l((_vm.companyList), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (
              _vm.editForm0.userType &&
              _vm.editForm0.userType == '1' &&
              _vm.modalType == '2'
            ),
            expression: "\n              editForm0.userType &&\n              editForm0.userType == '1' &&\n              modalType == '2'\n            "
          }],
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "部门"
          }
        }, [_c('el-select', {
          staticClass: "souch_change souch_input",
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "placeholder": "部门",
            "clearable": ""
          },
          model: {
            value: (_vm.deptId),
            callback: function($$v) {
              _vm.deptId = $$v
            },
            expression: "deptId"
          }
        }, _vm._l((_vm.detpList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.deptname,
              "value": item.id
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户地址",
            "prop": "longitudeAndLatitude"
          }
        }, [_c('GisCommon', {
          ref: "GisCommon",
          attrs: {
            "selected": _vm.editForm0.selected,
            "address": _vm.editForm0.address,
            "lonLat": _vm.editForm0.longitudeAndLatitude
          },
          on: {
            "backPram": _vm.backPram
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户密码",
            "prop": "passwordMo"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm0.passwordMo),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "passwordMo", $$v)
            },
            expression: "editForm0.passwordMo"
          }
        })], 1)], 1), _vm._v(" "), (_vm.modalType == 2) ? _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "文件",
            "prop": "fileUploadName"
          }
        }, [_c('el-button', {
          staticStyle: {
            "padding-left": "0",
            "padding-right": "0"
          },
          attrs: {
            "type": "primary"
          }
        }, [_c('label', {
          staticStyle: {
            "padding": "12px 20px",
            "cursor": "pointer"
          },
          attrs: {
            "for": "uploadwxsModal"
          }
        }, [_vm._v("选择文件")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.fileUploadName))])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              return _vm.cancelHandler.apply(null, arguments)
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), (_vm.modalType != 2) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading0
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit0('editForm0')
            }
          }
        }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (_vm.modalType == 2) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading0
          },
          nativeOn: {
            "click": function($event) {
              return _vm.importFile('editForm0')
            }
          }
        }, [_vm._v("提交")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "试用模块",
            "prop": "title"
          }
        }, [_c('div', {
          staticStyle: {
            "background": "rgb(244, 255, 243)",
            "width": "90%",
            "height": "300px",
            "overflow": "auto",
            "border": "1px solid #dfe6ec"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange
          },
          model: {
            value: (_vm.editForm.checkedCities),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "checkedCities", $$v)
            },
            expression: "editForm.checkedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticStyle: {
              "float": "left",
              "clear": "left",
              "margin-left": "20px",
              "position": "relative",
              "top": "0px"
            },
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "试用期限",
            "prop": "origin"
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.editForm.value),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "value", $$v)
            },
            expression: "editForm.value"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "审批",
            "visible": _vm.appFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.appFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "appForm",
          attrs: {
            "model": _vm.appForm,
            "label-width": "80px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "试用模块",
            "prop": "title"
          }
        }, [_c('div', {
          staticStyle: {
            "background": "rgb(244, 255, 243)",
            "width": "90%",
            "height": "300px",
            "overflow": "auto"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange
          },
          model: {
            value: (_vm.appForm.checkedCities),
            callback: function($$v) {
              _vm.$set(_vm.appForm, "checkedCities", $$v)
            },
            expression: "appForm.checkedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticStyle: {
              "float": "left",
              "clear": "left",
              "margin-left": "20px",
              "position": "relative",
              "top": "0px"
            },
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "试用期限",
            "prop": "origin"
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.appForm.value),
            callback: function($$v) {
              _vm.$set(_vm.appForm, "value", $$v)
            },
            expression: "appForm.value"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.appLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.appSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("通过")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "loading": _vm.falseLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.falseSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("驳回")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticStyle: {
      "min-width": "1023px"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch),
      expression: "disSouch"
    }],
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList(1)
      }
    },
    model: {
      value: (_vm.proName),
      callback: function($$v) {
        _vm.proName = $$v
      },
      expression: "proName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.getList(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "统计年份"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "change": _vm.accountTypeChange
    },
    model: {
      value: (_vm.accountType),
      callback: function($$v) {
        _vm.accountType = $$v
      },
      expression: "accountType"
    }
  }, _vm._l((_vm.accountTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.exportExlsx()
      }
    }
  }, [_vm._v("批量导出")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v(" \n          " + _vm._s(tag) + " \n      ")])
  }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "账号",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "姓名",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "org_name",
      "label": "企业",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accumulative_integral",
      "label": "累计积分",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "available_integral",
      "label": "可使用积分",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "credits_exchange",
      "label": "已兑换积分",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "border": "1px solid #dfe6ec",
      "margin-top": "0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('div', {
    staticClass: "ft"
  }, [_c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])])
}]}

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dnnCloud-login-box"
  }, [_c('img', {
    staticClass: "icon-dm animate__animated",
    attrs: {
      "src": "static/img/icon_login_csdm.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-jyjj animate__animated",
    attrs: {
      "src": "static/img/icon_login_zyjj.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-erzy animate__animated",
    attrs: {
      "src": "static/img/icon_login_erzy.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-erbz animate__animated",
    attrs: {
      "src": "static/img/icon_login_erbz.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-erdl animate__animated",
    attrs: {
      "src": "static/img/icon_login_erdl.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-erlj animate__animated",
    attrs: {
      "src": "static/img/icon_login_erlj.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    staticClass: "login-container",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("账号登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-dianhua"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone no-autofill",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号码"
    },
    model: {
      value: (_vm.loginForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "phone", $$v)
      },
      expression: "loginForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-mima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone no-autofill",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-button', {
    staticClass: "gradual large",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loginLoading,
      "data-appid": "2014410046",
      "data-cbfn": "callback"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("登 录")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "http://www.jsdnn.com/",
      "target": "_blank"
    }
  }, [_vm._v("狄诺尼官网")])], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "ftBoxs ft-copyright"
  }, [_c('p', [_vm._v("江苏狄诺尼信息技术有限责任公司")]), _vm._v(" "), _c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])
}]}

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "addBusinessClass",
      "title": "新增企业",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "close-on-click-modal": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "100px",
      "rules": _vm.addFormRules,
      "label-position": "right"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "地区",
      "prop": "showname"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addForm.showname),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "showname", $$v)
      },
      expression: "addForm.showname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "大区代号",
      "prop": "regionCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.regionCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "regionCode", $$v)
      },
      expression: "addForm.regionCode"
    }
  }, _vm._l((_vm.regionCodeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资质等级",
      "prop": "grade"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.grade),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "grade", $$v)
      },
      expression: "addForm.grade"
    }
  }, _vm._l((_vm.gradeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业性质",
      "prop": "natrue"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.natrue),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "natrue", $$v)
      },
      expression: "addForm.natrue"
    }
  }, _vm._l((_vm.natureList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户规模",
      "prop": "userScale"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.userScale),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "userScale", $$v)
      },
      expression: "addForm.userScale"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户地址",
      "prop": "addressInfo"
    }
  }, [_c('GisCommon', {
    attrs: {
      "selected": _vm.selected,
      "address": _vm.addForm.addressInfo,
      "lonLat": _vm.addForm.longitudeAndLatitude
    },
    on: {
      "update:address": function($event) {
        return _vm.$set(_vm.addForm, "addressInfo", $event)
      },
      "backPram": _vm.backPram
    },
    model: {
      value: (_vm.addForm.addressInfo),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "addressInfo", $$v)
      },
      expression: "addForm.addressInfo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "客户经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/manageList",
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.managerAdminuser
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "客户成功经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 3
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.successfulManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "经销商",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 4
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.agencyManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticClass: "ratingClass",
    attrs: {
      "label": "客户分级",
      "prop": "level"
    }
  }, [_c('el-rate', {
    attrs: {
      "max": 3
    },
    model: {
      value: (_vm.addForm.level),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "level", $$v)
      },
      expression: "addForm.level"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业联系人",
      "prop": "linker"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.linker),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "linker", $$v)
      },
      expression: "addForm.linker"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式",
      "prop": "linkerPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.linkerPhone),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "linkerPhone", $$v)
      },
      expression: "addForm.linkerPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业图标"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    attrs: {
      "auto-upload": false,
      "on-change": _vm.imgPreview,
      "action": _vm.upload.postURL,
      "show-file-list": false
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-applyTrial-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "姓名 / 电话 / 公司"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getProList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getProList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.proList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usename",
            "label": "姓名",
            "width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "电话",
            "width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "qq",
            "label": "QQ",
            "width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "公司",
            "min-width": "300",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "bumenzhiwei",
            "label": "部门职位",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adress",
            "label": "地址",
            "min-width": "300",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "statusname",
            "label": "处理状态",
            "width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.status == '1' ? 'success' : 'warning'
              }, [_vm._v(" " + _vm._s(scope.row.statusname) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "fixed": "right",
            "min-width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleView(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "处理",
                  "placement": "top"
                }
              }, [(scope.row.status != '0') ? _c('span', {
                staticClass: "dnnfont iconfile-done icon-disabled"
              }) : _c('span', {
                staticClass: "dnnfont iconfile-done",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })])], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "详情",
            "visible": _vm.viewVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.viewVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "viewForm",
          attrs: {
            "model": _vm.viewForm,
            "label-width": "80px"
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名:",
            "prop": "usename"
          }
        }, [_vm._v("\n             " + _vm._s(_vm.viewForm.usename) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "QQ:",
            "prop": "qq"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.viewForm.qq) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "电话:",
            "prop": "phone"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.viewForm.phone) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "部门职位:",
            "prop": "bumenzhiwei"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.viewForm.bumenzhiwei) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "公司:",
            "prop": "company"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.viewForm.company) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地址:",
            "prop": "adress"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.viewForm.adress) + "\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.viewVisible = false
            }
          }
        }, [_vm._v("确定")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-order-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "用户 / 企业 / 价格",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "类型",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.souType),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "souType", $$v)
            },
            expression: "souchs.souType"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "订单",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.souAccount),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "souAccount", $$v)
            },
            expression: "souchs.souAccount"
          }
        }, _vm._l((_vm.accountTypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "开始日期时间"
          },
          model: {
            value: (_vm.souchs.fromtime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "fromtime", $$v)
            },
            expression: "souchs.fromtime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "结束日期时间"
          },
          model: {
            value: (_vm.souchs.totime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "totime", $$v)
            },
            expression: "souchs.totime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.addList
          }
        }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
          return _c('el-tag', {
            key: tag,
            attrs: {
              "closable": "",
              "disable-transitions": false
            },
            on: {
              "close": function($event) {
                return _vm.handleClose(tag)
              }
            }
          }, [_vm._v(" \n              " + _vm._s(tag) + " \n          ")])
        }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          on: {
            "click": _vm.delTags
          }
        }, [_vm._v("清除标签")]) : _vm._e()], 2)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "200",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "用户",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userid ? scope.row.name : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usercompany",
            "label": "企业",
            "min-width": "260",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userid ? scope.row.usercompany : scope.row.name))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "时间",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminusername",
            "label": "操作人",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price2",
            "label": "价格(元)",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "typename",
            "label": "类型",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.type == 1 ? 'primary' : 'success'
              }, [_vm._v(_vm._s(scope.row.typename))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "stateverify",
            "label": "订单状态",
            "width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.stateverify == 1 ? 'warning' : 'primary'
              }, [_vm._v(_vm._s(scope.row.stateverify == 1 ? "申请中" : '审核通过'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "isrenew",
            "label": "续订订单",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag-fill",
                class: scope.row.isrenew == 2 ? 'pruple' : 'primary'
              }, [_vm._v(_vm._s(scope.row.isrenew == 2 ? "是" : '否'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "fixed": "right",
            "min-width": "140"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.$index, scope.row, 1)
                  }
                }
              })]), _vm._v(" "), (scope.row.adminuserid == _vm.userInfo.id && scope.row.stateverify == 1) ? [(scope.row.isrenew != 2) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "撤销",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconundo",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })])] : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 && scope.row.stateverify == 1) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "审核",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconapprove",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.$index, scope.row, 2)
                  }
                }
              })]) : _vm._e()], 2)]
            }
          }])
        })], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-depart-form-view",
    attrs: {
      "width": "850px",
      "title": "部门详情",
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handerClose
    }
  }, [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "toolbar",
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [(_vm.departDetail) ? _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门名称："
    }
  }, [_vm._v(" " + _vm._s(_vm.departDetail.deptname || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门管理员："
    }
  }, [_vm._v(_vm._s(_vm.departDetail.deptManagerName || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("部门人员(" + _vm._s(_vm.departDetail.userList.length) + ")")]), _vm._v(" "), _c('el-table', {
    ref: "companyRef",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.departDetail.userList,
      "highlight-current-row": "",
      "height": 500
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "软件类型",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-credits-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "账号 / 姓名 /企业"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "软件类型",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.softtype),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "softtype", $$v)
            },
            expression: "souchs.softtype"
          }
        }, _vm._l((_vm.softtypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "position": "relative",
            "top": "2px",
            "width": "260px"
          },
          attrs: {
            "type": "daterange",
            "value-format": "yyyy-MM-dd",
            "range-separator": "~",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期"
          },
          on: {
            "change": _vm.handerChangePicker
          },
          model: {
            value: (_vm.dateRange),
            callback: function($$v) {
              _vm.dateRange = $$v
            },
            expression: "dateRange"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          }
        }, [_c('a', {
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": _vm.downHrefExcel
          }
        }, [_vm._v("导出数据")])])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.users,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "140",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "sumpoint",
            "label": "可用积分",
            "min-width": "140",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "registertime",
            "label": "注册日期",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        })], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-module-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "模块名称"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getModels(1)
            }
          },
          model: {
            value: (_vm.souchs.modelName),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "modelName", $$v)
            },
            expression: "souchs.modelName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getModels(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.models,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "modulename",
            "label": "名称",
            "min-width": "220",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "moduleid",
            "label": "模块ID",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "创建时间",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e(), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "命令模块",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconstatistics-all",
                on: {
                  "click": function($event) {
                    return _vm.handleList(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "modulename"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.addForm.modulename),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "modulename", $$v)
            },
            expression: "addForm.modulename"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "模块ID",
            "prop": "moduleid"
          }
        }, [_c('el-input', {
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.addSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.addForm.moduleid),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "moduleid", $$v)
            },
            expression: "addForm.moduleid"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "modulename"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.modulename),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "modulename", $$v)
            },
            expression: "editForm.modulename"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "模块ID",
            "prop": "moduleid"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.editSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.editForm.moduleid),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "moduleid", $$v)
            },
            expression: "editForm.moduleid"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": _vm.modulenames,
            "visible": _vm.editListVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editListVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "名称"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getZJ(1)
            }
          },
          model: {
            value: (_vm.editListSouch.name),
            callback: function($$v) {
              _vm.$set(_vm.editListSouch, "name", $$v)
            },
            expression: "editListSouch.name"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.getZJ(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.editListAdd
          }
        }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.importLoading
          },
          on: {
            "click": function($event) {
              return _vm.$refs.clearFileModal.click()
            }
          }
        }, [_vm._v("导入")])], 1), _vm._v(" "), _c('input', {
          ref: "clearFileModal",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "id": "importModule",
            "name": "file"
          },
          on: {
            "change": function($event) {
              return _vm.importModuleFile($event)
            }
          }
        }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.handleExportModule
          }
        }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.editList,
            "highlight-current-row": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "label": "序号",
            "width": "80"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "modulename",
            "label": "名称",
            "min-width": "200",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "moduleid",
            "label": "模块ID",
            "min-width": "120"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "point",
            "label": "分数",
            "min-width": "120"
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "160"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-button', {
                attrs: {
                  "type": "primary",
                  "plain": "",
                  "size": "small"
                },
                on: {
                  "click": function($event) {
                    return _vm.editListEdit(scope.$index, scope.row)
                  }
                }
              }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
                attrs: {
                  "type": "danger",
                  "plain": "",
                  "size": "small"
                },
                on: {
                  "click": function($event) {
                    return _vm.editListDel(scope.$index, scope.row)
                  }
                }
              }, [_vm._v("删除")])]
            }
          }])
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "margin-top": "0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "prev, pager, next",
            "current-page": _vm.pageNumber2,
            "page-size": 10,
            "total": _vm.total2
          },
          on: {
            "current-change": _vm.handleCurrentChange2
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editListVisible = false
            }
          }
        }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "命令新增",
            "visible": _vm.addListVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addListVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addListForm",
          attrs: {
            "model": _vm.addListForm,
            "label-width": "80px"
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "modulename"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.addListForm.modulename),
            callback: function($$v) {
              _vm.$set(_vm.addListForm, "modulename", $$v)
            },
            expression: "addListForm.modulename"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "模块ID",
            "prop": "moduleid"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.addListForm.moduleid),
            callback: function($$v) {
              _vm.$set(_vm.addListForm, "moduleid", $$v)
            },
            expression: "addListForm.moduleid"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "分数",
            "prop": "point"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.addListForm.point),
            callback: function($$v) {
              _vm.$set(_vm.addListForm, "point", $$v)
            },
            expression: "addListForm.point"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addListVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addListLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addListSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "命令修改",
            "visible": _vm.editVisibleList,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editVisibleList = $event
            }
          }
        }, [_c('el-form', {
          ref: "editFormList",
          attrs: {
            "model": _vm.editFormList,
            "label-width": "80px"
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "modulename"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editFormList.modulename),
            callback: function($$v) {
              _vm.$set(_vm.editFormList, "modulename", $$v)
            },
            expression: "editFormList.modulename"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "模块ID",
            "prop": "moduleid"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editFormList.moduleid),
            callback: function($$v) {
              _vm.$set(_vm.editFormList, "moduleid", $$v)
            },
            expression: "editFormList.moduleid"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "分数",
            "prop": "point"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editFormList.point),
            callback: function($$v) {
              _vm.$set(_vm.editFormList, "point", $$v)
            },
            expression: "editFormList.point"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editVisibleList = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoadingList
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmitList.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "imger"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "registerForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.registerForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("注册帐号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-dianhua"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.registerForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "phone", $$v)
      },
      expression: "registerForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "smsCode"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-securityCode-b"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone form-control",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.registerForm.smsCode),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "smsCode", $$v)
      },
      expression: "registerForm.smsCode"
    }
  }), _vm._v(" "), (_vm.disabled == false) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v("发送验证码\r\n          ")]) : _vm._e(), _vm._v(" "), (_vm.disabled == true) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v(_vm._s(_vm.btntxt) + "\r\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-mima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.registerForm.password),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "password", $$v)
      },
      expression: "registerForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "conpassword"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-querenmima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "确认密码"
    },
    model: {
      value: (_vm.registerForm.conpassword),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "conpassword", $$v)
      },
      expression: "registerForm.conpassword"
    }
  })], 1), _vm._v(" "), _c('slide-verify', {
    attrs: {
      "slider-text": _vm.texts
    },
    on: {
      "success": _vm.onSuccess,
      "fail": _vm.onFail,
      "refresh": _vm.onRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("注册")])], 1)], 1)], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBar"
  }, [_c('h1'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.jsdnn.com/",
      "target": "_blank"
    }
  }, [_vm._v("狄诺尼官网")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('p', [_vm._v("江苏狄诺尼信息技术有限责任公司")]), _vm._v(" "), _c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])
}]}

/***/ }),
/* 1781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-verify",
    attrs: {
      "id": "slideVerify",
      "onselectstart": "return false;"
    }
  }, [_c('canvas', {
    ref: "canvas",
    attrs: {
      "width": _vm.w,
      "height": _vm.h
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-verify-refresh-icon",
    on: {
      "click": _vm.refresh
    }
  }), _vm._v(" "), _c('canvas', {
    ref: "block",
    staticClass: "slide-verify-block",
    attrs: {
      "width": _vm.w,
      "height": _vm.h
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-verify-slider",
    class: {
      'container-active': _vm.containerActive,
      'container-success': _vm.containerSuccess,
      'container-fail': _vm.containerFail
    }
  }, [_c('div', {
    staticClass: "slide-verify-slider-mask",
    style: ({
      width: _vm.sliderMaskWidth
    })
  }, [_c('div', {
    staticClass: "slide-verify-slider-mask-item",
    style: ({
      left: _vm.sliderLeft
    }),
    on: {
      "mousedown": _vm.sliderDown,
      "touchstart": _vm.touchStartEvent,
      "touchmove": _vm.touchMoveEvent,
      "touchend": _vm.touchEndEvent
    }
  }, [_c('div', {
    staticClass: "slide-verify-slider-mask-item-icon"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "slide-verify-slider-text"
  }, [_vm._v(_vm._s(_vm.sliderText))])])])
},staticRenderFns: []}

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-renew-form",
    attrs: {
      "width": "850px",
      "title": "续费",
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.myVisible = $event
      },
      "close": _vm.handerClose
    }
  }, [(_vm.myDetail) ? _c('div', {
    staticClass: "renew-content"
  }, [_c('section', {
    staticClass: "renew-bd"
  }, [_c('el-table', {
    staticClass: "selected-product-tab",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "tooltip-effect": "dark",
      "data": [_vm.myDetail],
      "empty-text": "还没有选择产品"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "logo",
      "header-align": "center",
      "align": "center",
      "width": "100px",
      "label": "产品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "tpimg",
          attrs: {
            "src": scope.row.logo,
            "alt": scope.row.logo
          }
        })]
      }
    }], null, false, 2004791488)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseNum",
      "label": "购买数量",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [_c('span', [_vm._v(_vm._s(row.purchaseNum))])]
      }
    }], null, false, 1458136111)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "单价(元)",
      "min-width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "price"
        }, [_vm._v(_vm._s(scope.row.price.toLocaleString()))])]
      }
    }], null, false, 1758458025)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseMonth",
      "label": "续费时长(月)",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [_c('el-input-number', {
          attrs: {
            "min": 1,
            "size": "small",
            "step-strictly": true,
            "controls-position": "right"
          },
          on: {
            "change": _vm.handleChangeNum
          },
          model: {
            value: (row.purchaseMonth),
            callback: function($$v) {
              _vm.$set(row, "purchaseMonth", $$v)
            },
            expression: "row.purchaseMonth"
          }
        })]
      }
    }], null, false, 1583599189)
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "order-add-ft",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "order-evaluate",
    staticStyle: {
      "color": "#EB6264"
    },
    attrs: {
      "label": "预估价格:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.evaluatePrice) + " 元\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "order-total",
    attrs: {
      "label": "订单总价:"
    }
  }, [_c('el-input', {
    staticClass: "price",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "oninput": "this.value=this.value.replace(/[^\\d]/g,'');"
    },
    model: {
      value: (_vm.totalPrice),
      callback: function($$v) {
        _vm.totalPrice = $$v
      },
      expression: "totalPrice"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.myDetail) ? _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit(_vm.myDetail)
      }
    }
  }, [_vm._v("提交")])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "tab-detart-manage",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-form', {
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "联系人电话 / 客户地址"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchVal.searchText),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "searchText", $$v)
            },
            expression: "searchVal.searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "拜访日期"
          },
          model: {
            value: (_vm.searchVal.payVisitDate),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "payVisitDate", $$v)
            },
            expression: "searchVal.payVisitDate"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "110px"
          },
          attrs: {
            "placeholder": "拜访方式",
            "clearable": ""
          },
          model: {
            value: (_vm.searchVal.payVisitStatus),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "payVisitStatus", $$v)
            },
            expression: "searchVal.payVisitStatus"
          }
        }, _vm._l((_vm.visitStatusList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "110px"
          },
          attrs: {
            "placeholder": "审核状态",
            "clearable": ""
          },
          model: {
            value: (_vm.searchVal.auditStatus),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "auditStatus", $$v)
            },
            expression: "searchVal.auditStatus"
          }
        }, _vm._l((_vm.checkStatusList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), (_vm.userInfo.type != 1) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "plain": "",
            "icon": "el-icon-plus"
          },
          on: {
            "click": _vm.addForm
          }
        }, [_vm._v("新\n          增")]) : _vm._e()], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          ref: "companyTabRef",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "row-style": {
              height: '50px'
            }
          },
          on: {
            "selection-change": _vm.handerSectionChange,
            "row-click": _vm.handerRowClick
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "50"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "70"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "payVisitDate",
            "width": "120",
            "label": "拜访日期",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.payVisitDate ? scope.row.payVisitDate.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminUserName",
            "width": "100",
            "label": "客户经理",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.adminUserName ? scope.row.adminUserName.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "successfulManagerName",
            "width": "110",
            "label": "客户成功经理",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.successfulManagerName ? scope.row.successfulManagerName.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "agencyManagerName",
            "width": "100",
            "label": "经销商",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.agencyManagerName ? scope.row.agencyManagerName.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "contactUser",
            "width": "120",
            "label": "联系人",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "contactPhone",
            "width": "120",
            "label": "联系人电话",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.contactPhone ? scope.row.contactPhone : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "payVisitStatus",
            "width": "120",
            "label": "拜访方式",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag-fill",
                class: scope.row.payVisitStatus == 1 ? 'pruple' : (scope.row.payVisitStatus == 2 ? 'primary' : 'warning')
              }, [_vm._v("\n            " + _vm._s(scope.row.payVisitStatus == 1 ? "电话沟通" : (scope.row.payVisitStatus == 2 ? '客户现场' : '视频会议')) + "\n          ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "auditStatus",
            "width": "120",
            "label": "审核状态",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.auditStatus == 1 ? 'warning' : 'primary'
              }, [_vm._v("\n            " + _vm._s(scope.row.auditStatus == 1 ? "待审核" : '已审核') + "\n          ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "position",
            "label": "职位",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.position ? scope.row.position : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "addressInfo",
            "label": "客户地址",
            "min-width": "150",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.addressInfo || '') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.$index, scope.row, 1)
                  }
                }
              })]), _vm._v(" "), (scope.row.auditStatus == 1 && _vm.userInfo.id == scope.row.createUser) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e(), _vm._v(" "), (scope.row.auditStatus == 1 && _vm.userInfo.id == scope.row.createUser) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), (_vm.visible) ? _c('ModalForm', {
          attrs: {
            "visible": _vm.visible,
            "mode": _vm.mode,
            "visitStatusList": _vm.visitStatusList,
            "processDetail": _vm.processDetail
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            "getList": _vm.getList
          }
        }) : _vm._e(), _vm._v(" "), (_vm.visibleView) ? _c('ModalFormView', {
          attrs: {
            "visible": _vm.visibleView,
            "visitStatusList": _vm.visitStatusList,
            "processDetail": _vm.processDetail
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleView = $event
            },
            "getList": _vm.getList
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "position": "relative"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-account-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.souchs.value1),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "value1", $$v)
            },
            expression: "souchs.value1"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.souchs.value2),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "value2", $$v)
            },
            expression: "souchs.value2"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.souchs.value3),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "value3", $$v)
            },
            expression: "souchs.value3"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "请输入内容"
          },
          model: {
            value: (_vm.souchs.input),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "input", $$v)
            },
            expression: "souchs.input"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.check()
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.add()
            }
          }
        }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('target-custom-dialog', {
          ref: "targetcustomdialogRef"
        })]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('div', {
          staticClass: "tips"
        }, [_c('span', [_vm._v("目标客户总数量：")]), _c('span', {
          staticClass: "blueNumber"
        }, [_vm._v("600")]), _vm._v(" "), _c('span', [_vm._v("甲级目标客户总数量：")]), _c('span', {
          staticClass: "redNumber"
        }, [_vm._v("600")])]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.tableData,
            "height": _vm.maxTbHeight - 36,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "date",
            "label": "日期",
            "sortable": "",
            "width": "180",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "sortable": "",
            "width": "180",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "address",
            "label": "地址",
            "show-overflow-tooltip": ""
          }
        })], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "base-container",
    class: {
      noPageHd: !_vm.isPageHd,
      noMainHd: !_vm.isMainHd,
      noPageFt: !_vm.isHasPageFt,
    }
  }, [(_vm.isPageHd) ? _c('header', {
    staticClass: "base-container-hd"
  }, [_c('span', {
    staticClass: "arrow"
  }), _vm._v(" " + _vm._s(_vm.getCurMenu))]) : _vm._e(), _vm._v(" "), [_c('main', {
    staticClass: "base-container-bd"
  }, [_c('header', {
    staticClass: "content-hd"
  }, [_vm._t("hd")], 2), _vm._v(" "), _c('section', {
    staticClass: "content-bd"
  }, [_vm._t("main")], 2)]), _vm._v(" "), (_vm.isHasPageFt) ? _c('footer', {
    staticClass: "base-container-ft"
  }, [_vm._t("ft")], 2) : _vm._e()]], 2)
},staticRenderFns: []}

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    staticStyle: {
      "position": "absolute",
      "float": "right",
      "right": "35px",
      "top": "6px"
    },
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.bak
    }
  }, [_vm._v("\n        返回\n      ")]), _vm._v(" "), _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "readonly": "readonly"
    },
    model: {
      value: (_vm.userType),
      callback: function($$v) {
        _vm.userType = $$v
      },
      expression: "userType"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [(_vm.person == '2') ? _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "readonly": "readonly",
      "placeholder": "企业用户"
    },
    model: {
      value: (_vm.checkPerson),
      callback: function($$v) {
        _vm.checkPerson = $$v
      },
      expression: "checkPerson"
    }
  }) : _c('el-input', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "readonly": "readonly",
      "placeholder": "个人用户"
    },
    model: {
      value: (_vm.checkUser),
      callback: function($$v) {
        _vm.checkUser = $$v
      },
      expression: "checkUser"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "aaaaa",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "tooltip-effect": "dark",
      "data": _vm.proList3,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "logo2",
      "header-align": "center",
      "align": "center",
      "min-width": "220px",
      "label": "图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "tpimg",
          attrs: {
            "slot": "reference",
            "src": scope.row.logo2,
            "alt": scope.row.logo2
          },
          slot: "reference"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "min-width": "220",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseMonth",
      "label": "购买时长(月)",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [_c('el-input', {
          staticClass: "input_Border",
          attrs: {
            "type": "number",
            "min": "1",
            "disabled": ""
          },
          model: {
            value: (row.purchaseMonth),
            callback: function($$v) {
              _vm.$set(row, "purchaseMonth", $$v)
            },
            expression: "row.purchaseMonth"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseNum",
      "label": "购买数量",
      "width": "210"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [_c('el-input', {
          staticClass: "input_Border",
          attrs: {
            "type": "number",
            "min": "1",
            "disabled": ""
          },
          model: {
            value: (row.purchaseNum),
            callback: function($$v) {
              _vm.$set(row, "purchaseNum", $$v)
            },
            expression: "row.purchaseNum"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price2",
      "label": "单价(元)",
      "min-width": "200",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-checkbox-group', {
    staticClass: "order-checkbox",
    model: {
      value: (_vm.checkList),
      callback: function($$v) {
        _vm.checkList = $$v
      },
      expression: "checkList"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "试用订单",
      "disabled": ""
    }
  })], 1), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticClass: "allPrice",
    attrs: {
      "label": "总价:"
    }
  }, [_c('el-input', {
    staticClass: "price",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "readonly": "readonly",
      "disabled": _vm.disCheckBox
    },
    model: {
      value: (_vm.allPrice),
      callback: function($$v) {
        _vm.allPrice = $$v
      },
      expression: "allPrice"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('div', {
    staticClass: "ft"
  }, [_c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])])
}]}

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "账号 / 姓名 / 企业",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "souch_change souch_input",
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "状态",
      "clearable": ""
    },
    model: {
      value: (_vm.typeValue),
      callback: function($$v) {
        _vm.typeValue = $$v
      },
      expression: "typeValue"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "souch_change souch_input",
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "部门",
      "clearable": ""
    },
    model: {
      value: (_vm.deptId),
      callback: function($$v) {
        _vm.deptId = $$v
      },
      expression: "deptId"
    }
  }, _vm._l((_vm.detpList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.deptname,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.addList
    }
  }, [_vm._v("添加用户")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.userList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55",
      "selectable": _vm.selectInit
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "point",
      "label": "积分",
      "min-width": "100",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "企业",
      "min-width": "200",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.deptname || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invitestatusname",
      "label": "状态",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "operate"
        }, [(!scope.row.delShow) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "删除",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont icondelete",
          on: {
            "click": function($event) {
              return _vm.batchRemove(scope.$index, scope.row)
            }
          }
        })]) : _c('span', {
          staticClass: "dnnfont icondelete icon-disabled"
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "添加",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs2
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch2
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.optionsSouch2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch2),
      expression: "disSouch2"
    }],
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getComUser(1)
      }
    },
    model: {
      value: (_vm.proName2),
      callback: function($$v) {
        _vm.proName2 = $$v
      },
      expression: "proName2"
    }
  }), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSofttype2),
      expression: "disSofttype2"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.souchs2.softtype),
      callback: function($$v) {
        _vm.$set(_vm.souchs2, "softtype", $$v)
      },
      expression: "souchs2.softtype"
    }
  }, _vm._l((_vm.softtypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disTime1),
      expression: "disTime1"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "开始日期时间"
    },
    model: {
      value: (_vm.souchs2.fromtime),
      callback: function($$v) {
        _vm.$set(_vm.souchs2, "fromtime", $$v)
      },
      expression: "souchs2.fromtime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disTime2),
      expression: "disTime2"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "结束日期时间"
    },
    model: {
      value: (_vm.souchs2.totime),
      callback: function($$v) {
        _vm.$set(_vm.souchs2, "totime", $$v)
      },
      expression: "souchs2.totime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getComUser(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags2), function(tag2) {
    return _c('el-tag', {
      key: tag2,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose2(tag2)
        }
      }
    }, [_vm._v(" \n              " + _vm._s(tag2) + " \n          ")])
  }), _vm._v(" "), (_vm.dynamicTags2 != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags2
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    ref: "companyList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companyList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange2,
      "current-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "softtype",
      "label": "软件类型",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "企业",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100, '全部'],
      "page-size": _vm.pageSize2,
      "total": _vm.total2,
      "current-page": _vm.pageNumber2
    },
    on: {
      "current-change": _vm.handleCurrentChange2,
      "size-change": _vm.handleSizeChange2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.adminVisible) ? _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "企业管理员",
      "width": "950px",
      "visible": _vm.adminVisible,
      "close-on-click-modal": false,
      "before-close": _vm.adminVisibleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.adminVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userLoading),
      expression: "userLoading"
    }],
    ref: "userList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row-key": function (row) { return row.id; },
      "data": _vm.adminList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "xshow-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "softtype",
      "label": "软件类型",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "企业",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "intime",
      "label": "注册时间",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "160",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "plain": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 88714150)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.adminVisibleClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addAdmin.apply(null, arguments)
      }
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.orderUserSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-depart-form",
    attrs: {
      "width": "850px",
      "title": _vm.title,
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handerClose
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "-10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门名称",
      "prop": "deptname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.deptname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "deptname", $$v)
      },
      expression: "ruleForm.deptname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门管理员",
      "prop": "deptmanager"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.deptmanager),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "deptmanager", $$v)
      },
      expression: "ruleForm.deptmanager"
    }
  }, _vm._l((_vm.allCompanyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门人员",
      "prop": "useridList"
    }
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "姓名 / 账号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getComUser(1)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getComUser(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "companyRef",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companyList,
      "highlight-current-row": "",
      "height": 500
    },
    on: {
      "selection-change": _vm.handerSectionChange,
      "row-click": _vm.handerRowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "软件类型",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "160",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.deptname || '-'))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-menu-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "企业名称"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getTypeList(1)
            }
          },
          model: {
            value: (_vm.souchs.name),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "name", $$v)
            },
            expression: "souchs.name"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getTypeList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.typeList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "min-width": "240",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "code",
            "label": "企业ID",
            "min-width": "220",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "创建时间",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业ID",
            "prop": "code"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.addSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.addForm.code),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "code", $$v)
            },
            expression: "addForm.code"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业ID",
            "prop": "code"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.editSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.editForm.code),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "code", $$v)
            },
            expression: "editForm.code"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.adminModulePointPieCopy
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "charts-box-copy-lpie"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.adminModulePointPie
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "charts-box"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "imger"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "forgetForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.forgetForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("密码重置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-dianhua"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.forgetForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "phone", $$v)
      },
      expression: "forgetForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "smsCode"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-securityCode-b"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone form-control",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.forgetForm.smsCode),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "smsCode", $$v)
      },
      expression: "forgetForm.smsCode"
    }
  }), _vm._v(" "), (_vm.disabled == false) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v("发送验证码\r\n          ")]) : _vm._e(), _vm._v(" "), (_vm.disabled == true) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v(_vm._s(_vm.btntxt) + "\r\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-mima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.forgetForm.password),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "password", $$v)
      },
      expression: "forgetForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "conpassword"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-querenmima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "确认密码"
    },
    model: {
      value: (_vm.forgetForm.conpassword),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "conpassword", $$v)
      },
      expression: "forgetForm.conpassword"
    }
  })], 1), _vm._v(" "), _c('slide-verify', {
    attrs: {
      "slider-text": _vm.texts
    },
    on: {
      "success": _vm.onSuccess,
      "fail": _vm.onFail,
      "refresh": _vm.onRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBar"
  }, [_c('h1'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.jsdnn.com/",
      "target": "_blank"
    }
  }, [_vm._v("狄诺尼官网")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('p', [_vm._v("江苏狄诺尼信息技术有限责任公司")]), _vm._v(" "), _c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])
}]}

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-detail-box"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "font",
    on: {
      "click": _vm.bak
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left icon"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "shu"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "font-text"
  }, [_vm._v(_vm._s(_vm.$route.query.companyName))]), _vm._v(" "), _c('span', {
    staticClass: "export"
  }, [_c('a', {
    attrs: {
      "href": _vm.href
    }
  }, [_c('span', {
    staticClass: "el-icon-download"
  }), _vm._v("导出统计数据")])]), _vm._v(" "), _c('span', {
    staticClass: "export"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.pointByHour
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("用户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6"
    }
  }, [_vm._v("部门管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("产品管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("设备管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }, [_vm._v("跟踪记录")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("分析统计")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [_vm._v("企业设置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-content"
  }, [(_vm.showCom) ? _c('div', [_c('company')], 1) : _vm._e(), _vm._v(" "), (_vm.showWeP) ? _c('div', [_c('weProduct')], 1) : _vm._e(), _vm._v(" "), (_vm.showDev) ? _c('div', [_c('device')], 1) : _vm._e(), _vm._v(" "), (_vm.showFx) ? _c('Static', {
    attrs: {
      "comId": _vm.$route.query.companyId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 6) ? _c('DepartManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 7) ? _c('TrackManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 8) ? _c('CompamySetting', {
    attrs: {
      "editLevel": false
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-company-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "大区",
            "clearable": true
          },
          model: {
            value: (_vm.regionCode),
            callback: function($$v) {
              _vm.regionCode = $$v
            },
            expression: "regionCode"
          }
        }, _vm._l((_vm.regionCodeList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "企业名称",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.managerAdminuser
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "客户成功经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.successfulManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "经销商",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.agencyManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "default-value": _vm.deadTime,
            "type": "date",
            "placeholder": "过期截止日期",
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd"
          },
          model: {
            value: (_vm.deadTime),
            callback: function($$v) {
              _vm.deadTime = $$v
            },
            expression: "deadTime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "loading": _vm.exportLoading
          },
          on: {
            "click": function($event) {
              return _vm.batchExport()
            }
          }
        }, [_vm._v("\n            批量导出"), (_vm.exportList.length) ? _c('span', [_vm._v(" (" + _vm._s(_vm.exportList.length) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "loading": _vm.importLoading
          },
          on: {
            "click": function($event) {
              return _vm.batchImport()
            }
          }
        }, [_vm._v("批量导入")]), _vm._v(" "), _c('input', {
          ref: "clearFileModal",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "id": "importOfficial",
            "name": "file",
            "accept": ".xls,.xlsx"
          },
          on: {
            "change": function($event) {
              return _vm.importCompanyFile($event)
            }
          }
        })], 1) : _vm._e()], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('div', {
          staticClass: "tips"
        }, [_c('span', [_vm._v("正式客户总数量：")]), _c('span', {
          staticClass: "blueNumber"
        }, [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('span', [_vm._v("甲级正式客户数量：")]), _c('span', {
          staticClass: "redNumber"
        }, [_vm._v(_vm._s(_vm.levelTotal))]), _vm._v(" "), _c('span', [_vm._v("正式用户数：")]), _c('span', {
          staticClass: "purpleNumber"
        }, [_vm._v(_vm._s(_vm.tryTotal))]), _vm._v(" "), _c('span', [_vm._v("高校正式用户数：")]), _c('span', {
          staticClass: "colleges"
        }, [_vm._v(_vm._s(_vm.collegesTotal))]), _vm._v(" "), _c('span', [_vm._v("设计院正式用户数：")]), _c('span', {
          staticClass: "institute"
        }, [_vm._v(_vm._s(_vm.instituteTotal))])]), _vm._v(" "), _c('el-table', {
          ref: "companyTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.proList,
            "row-key": "id",
            "highlight-current-row": "",
            "height": _vm.maxTbHeight - 36,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "reserve-selection": true,
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "regionCode",
            "label": "大区代号",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.regionCode === '1') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华东大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '2') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '3') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '4') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华南大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '5') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西南大区")]) : _vm._e(), _vm._v(" "), (!scope.row.regionCode) ? _c('span', [_vm._v("-")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "sortable": "custom",
            "min-width": "250",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "grade",
            "label": "资质等级",
            "sortable": "custom",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.grade === '1') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("综合甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '2') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '3') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '4') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '5') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '6') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '7') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '9') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("高校")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '10') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("施工单位")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '8') ? _c('div', {
                staticClass: "other"
              }, [_vm._v("其他")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "natrue",
            "label": "企业性质",
            "sortable": "custom",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.natrue === '1' ? '央企' : scope.row.natrue === '2' ? '国企' : scope.row.natrue === '3' ? '民营上市' :
                scope.row.natrue === '4' ? '民营' : scope.row.natrue === '5' ? '高校' : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "zsuc",
            "label": "正式用户数",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "showname",
            "label": "地区",
            "sortable": "custom",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "公司管理员",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managername ? scope.row.managername : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户经理",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managerAdminuserName ? scope.row.managerAdminuserName : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户成功经理",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.successfulManagerName ?
                scope.row.successfulManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "经销商",
            "min-width": "70",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.agencyManagerName ?
                scope.row.agencyManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "正式产品总数",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "blue_num"
              }, [_vm._v(_vm._s(scope.row.ac ? scope.row.ac : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "即将过期产品数量",
            "min-width": "140",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "orange"
              }, [_vm._v(_vm._s(scope.row.dc ? scope.row.dc : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "fixed": "right",
            "label": "操作",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleCom(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (_vm.id == scope.row.createUser && scope.row.delFlg !== '0') ? _c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "width": "850px",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            },
            "close": _vm.closedialog
          }
        }, [(_vm.addFormVisible) ? _c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-autocomplete', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请输入",
            "clearable": "",
            "fetch-suggestions": _vm.querySearch,
            "trigger-on-focus": false
          },
          on: {
            "select": _vm.handleSelect
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地区",
            "prop": "showname"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.showname),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "showname", $$v)
            },
            expression: "addForm.showname"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户地址",
            "required": ""
          }
        }, [_c('GisCommon', {
          attrs: {
            "selected": _vm.selected,
            "address": _vm.address,
            "lonLat": _vm.addForm.longitudeAndLatitude
          },
          on: {
            "backPram": _vm.backPram
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户经理",
            "required": ""
          }
        }, [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业图标",
            "required": ""
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.imageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.imageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              return _vm.handerClose('addFormVisible', 'addForm')
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片"
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.editImageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.editImageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地区",
            "prop": "showname"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.showname),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "showname", $$v)
            },
            expression: "editForm.showname"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.orderVisible) ? _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "选择人员",
            "visible": _vm.orderVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.orderVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px",
            "border": "1px solid #dfe6ec"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs2
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": _vm.changeSouch2
          },
          model: {
            value: (_vm.value2),
            callback: function($$v) {
              _vm.value2 = $$v
            },
            expression: "value2"
          }
        }, _vm._l((_vm.optionsSouch2), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disSouch),
            expression: "disSouch"
          }],
          staticStyle: {
            "width": "200px"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.proName2),
            callback: function($$v) {
              _vm.proName2 = $$v
            },
            expression: "proName2"
          }
        }), _vm._v(" "), _c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disinvit),
            expression: "disinvit"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs2.invitValue),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "invitValue", $$v)
            },
            expression: "souchs2.invitValue"
          }
        }, _vm._l((_vm.inviValues), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disSofttype),
            expression: "disSofttype"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs2.softtype),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "softtype", $$v)
            },
            expression: "souchs2.softtype"
          }
        }, _vm._l((_vm.softtypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-date-picker', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disTime1),
            expression: "disTime1"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "注册开始时间"
          },
          model: {
            value: (_vm.souchs2.fromtime),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "fromtime", $$v)
            },
            expression: "souchs2.fromtime"
          }
        }), _vm._v(" "), _c('el-date-picker', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disTime2),
            expression: "disTime2"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "注册结束时间"
          },
          model: {
            value: (_vm.souchs2.totime),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "totime", $$v)
            },
            expression: "souchs2.totime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags2), function(tag2) {
          return _c('el-tag', {
            key: tag2,
            attrs: {
              "closable": "",
              "disable-transitions": false
            },
            on: {
              "close": function($event) {
                return _vm.handleClose2(tag2)
              }
            }
          }, [_vm._v("\n          " + _vm._s(tag2) + "\n        ")])
        }), _vm._v(" "), (_vm.dynamicTags2 != '') ? _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          on: {
            "click": _vm.delTags2
          }
        }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.userLoading),
            expression: "userLoading"
          }],
          ref: "userList",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "row-key": function (row) { return row.id; },
            "data": _vm.userList,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "current-change": _vm.handleSelectionChange,
            "selection-change": _vm.handleUserSelectionChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "reserve-selection": true,
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "130"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "xshow-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "注册时间",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "border": "1px solid #dfe6ec",
            "margin-top": "0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": " prev, pager, next",
            "current-page": _vm.pageNumber2,
            "page-size": _vm.pageSize2,
            "total": _vm.total2
          },
          on: {
            "current-change": _vm.handleCurrentChange2
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.orderVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.orderLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.clickUserSelection.apply(null, arguments)
            }
          }
        }, [_vm._v("确定")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adminVisible) ? _c('Admin', {
          attrs: {
            "adminVisible": _vm.adminVisible,
            "companyId": _vm.companyId,
            "UserSelection": _vm.UserSelection
          },
          on: {
            "adminVisibleClose": _vm.adminVisibleClose,
            "addAdmin": _vm.addAdmin,
            "orderUserSubmit": _vm.orderUserSubmit
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "update:currentPage": function($event) {
              _vm.pageNumber = $event
            },
            "update:current-page": function($event) {
              _vm.pageNumber = $event
            },
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingx),
      expression: "loadingx"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.title
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    },
    attrs: {
      "placeholder": "请输入位置后点击右侧图标确定坐标"
    },
    on: {
      "change": _vm.changeAddres
    },
    model: {
      value: (_vm.address_),
      callback: function($$v) {
        _vm.address_ = $$v
      },
      expression: "address_"
    }
  }, [_c('i', {
    staticClass: "dnnfont iconrenyuandingwei",
    staticStyle: {
      "cursor": "pointer",
      "color": "#666666"
    },
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.openMap
    },
    slot: "suffix"
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.innerVisible,
      "append-to-body": "",
      "fullscreen": true
    },
    on: {
      "update:visible": function($event) {
        _vm.innerVisible = $event
      },
      "opened": _vm.initMap
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('el-select', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading,
      "placeholder": "请输入区域关键词（如：南京、安徽、北京）"
    },
    on: {
      "change": _vm.posChange
    },
    model: {
      value: (_vm.posValue),
      callback: function($$v) {
        _vm.posValue = $$v
      },
      expression: "posValue"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name + '（' + item.address + '）',
        "value": index + '_' + item.lonlat.toString()
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadings),
      expression: "loadings"
    }],
    staticClass: "map",
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.innerVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.confirmLoading,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.positions(_vm.position)
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DetailPage', {
    staticClass: "order-detail-box",
    attrs: {
      "name": ("订单编号：" + _vm.orderId),
      "backRoute": 'orderList',
      "param": _vm.param
    },
    scopedSlots: _vm._u([{
      key: "detailMain",
      fn: function() {
        return [_c('div', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.pageLoading),
            expression: "pageLoading"
          }],
          staticClass: "detail-content",
          class: {
            'detail-content-verify': _vm.detailType == 2
          }
        }, [(_vm.processDetail) ? [_c('div', {
          staticClass: "detail-content-wrapper"
        }, [_c('el-row', {
          staticClass: "content-item",
          attrs: {
            "gutter": 20
          }
        }, [_c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 8
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("用户类型：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.userid ? '个人用户' : '企业用户'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("企业名称：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.companyname || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("公司管理员：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.companymanagername || '-'))])])]), _vm._v(" "), _c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 8
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("订单类型：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.type == 1 ? '试用订单' : '正式订单'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("生效日期：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.effectivetime || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("订单金额：")]), _vm._v(" "), _c('span', {
          staticClass: "value color-red"
        }, [_vm._v(_vm._s(_vm.processDetail.price ? _vm.processDetail.price.toLocaleString() : 0) + " 元")])])]), _vm._v(" "), _c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 8
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("操作人：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.adminusername || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("操作时间：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.intime || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("订单状态：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_c('span', {
          staticClass: "myTag",
          class: _vm.processDetail.stateverify == 1 ? 'warning' : 'primary'
        }, [_vm._v(_vm._s(_vm.processDetail.stateverify == 1 ? "申请中" : '审核通过'))])])])]), _vm._v(" "), _c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 24
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("审核意见：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.comments || '-'))])])])], 1), _vm._v(" "), _c('section', {
          staticClass: "detail-bd"
        }, [_c('header', {
          staticClass: "title"
        }, [_vm._v("产品清单（" + _vm._s(_vm.processDetail.auProList.length) + "）")]), _vm._v(" "), _c('SelectedProduct', {
          attrs: {
            "productLists": _vm.processDetail.auProList
          },
          on: {
            "renew": _vm.handleRenewOrder
          }
        })], 1), _vm._v(" "), (_vm.isShowComment) ? _c('footer', {
          staticClass: "comments-box"
        }, [_c('h4', {
          staticClass: "title"
        }, [_vm._v("请输入审核意见：")]), _vm._v(" "), _c('el-input', {
          attrs: {
            "type": "textarea",
            "rows": 3,
            "placeholder": "请输入"
          },
          on: {
            "change": _vm.handerChangeComments
          },
          model: {
            value: (_vm.comments),
            callback: function($$v) {
              _vm.comments = $$v
            },
            expression: "comments"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowError),
            expression: "isShowError"
          }],
          staticClass: "status-text color-red"
        }, [_vm._v("审核意见不能为空")])], 1) : _vm._e()], 1), _vm._v(" "), _c('footer', {
          staticClass: "detail-ft"
        }, [(_vm.isShowComment) ? [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading,
            "plain": ""
          },
          on: {
            "click": function($event) {
              _vm.isShowComment = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading
          },
          on: {
            "click": function($event) {
              return _vm.handerVerify(1)
            }
          }
        }, [_vm._v("提 交")])] : [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading,
            "plain": ""
          },
          on: {
            "click": function($event) {
              _vm.isShowComment = true
            }
          }
        }, [_vm._v("审核不通过")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading
          },
          on: {
            "click": function($event) {
              return _vm.handerVerify(2)
            }
          }
        }, [_vm._v("审核通过")])]], 2)] : _vm._e()], 2), _vm._v(" "), (_vm.visibleRenew) ? _c('ModalFormOrder', {
          attrs: {
            "visible": _vm.visibleRenew,
            "productInfo": _vm.productInfo
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleRenew = $event
            },
            "getDetail": function($event) {
              return _vm.getDetail(_vm.token, _vm.checkCode)
            }
          }
        }) : _vm._e()]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-order-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 18
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "用户名",
            "clearable": ""
          },
          on: {
            "change": function($event) {
              return _vm.getList(1)
            }
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.userName),
            callback: function($$v) {
              _vm.userName = $$v
            },
            expression: "userName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 3
          }
        }, [_c('div', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("提交任务数：" + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 3
          }
        }, [_c('div', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("生图成功数：" + _vm._s(_vm.successCount))])])]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "row-dblclick": _vm.handleRowClick
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "userName",
            "label": "用户名",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userId ? scope.row.userName : "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "companyname",
            "label": "企业",
            "min-width": "240",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.companyname || "-"))])]
            }
          }])
        }), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "prop": "resolution",
            "label": "图片大小",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.resolution || "-"))])]
            }
          }], null, false, 3404415237)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "label": "通道图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.modelImgThumbnail || scope.row.modelImg) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.modelImgThumbnail || scope.row.modelImg,
                  "preview-src-list": [scope.row.modelImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }], null, false, 2834397069)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "label": "原图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.originalImgThumbnail || scope.row.originalImg) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.originalImgThumbnail || scope.row.originalImg,
                  "preview-src-list": [scope.row.originalImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }], null, false, 551977147)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "label": "叠加优化图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(
                scope.row.optimizationImgThumbnail || scope.row.optimizationImg
              ) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.optimizationImgThumbnail || scope.row.optimizationImg,
                  "preview-src-list": [scope.row.optimizationImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }], null, false, 209977539)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "label": "原图优化图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.satelliteImgThumbnail || scope.row.satelliteImg) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.satelliteImgThumbnail || scope.row.satelliteImg,
                  "preview-src-list": [scope.row.satelliteImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }], null, false, 2443157081)
        }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "createTime",
            "label": "创建时间",
            "width": "160",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" " + _vm._s(_vm.dateTran(scope.row.createTime)) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "生成耗时",
            "width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(
                scope.row.generationEndTime && scope.row.generationStartTime
              ) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.formatDuration(
                scope.row.generationEndTime - scope.row.generationStartTime
              )) + "\n          ")]) : _c('span', [_vm._v(" - ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "generationState",
            "label": "状态",
            "width": "80",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.generationState === -1) ? _c('span', [_vm._v("待提交")]) : (scope.row.generationState === 0) ? _c('span', [_vm._v("生成中")]) : (scope.row.generationState === 1) ? _c('span', [_vm._v("完成")]) : (scope.row.generationState === 3) ? _c('span', [_vm._v("错误")]) : (scope.row.generationState === 4) ? _c('span', [_vm._v("取消")]) : _c('span', [_vm._v("-")])]
            }
          }])
        }), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "prop": "prompt",
            "label": "提示词",
            "min-width": "180",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.prompt || "-"))])]
            }
          }], null, false, 1415799279)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.row)
                  }
                }
              })])], 1)]
            }
          }], null, false, 187938449)
        }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
          attrs: {
            "title": "生图详情",
            "visible": _vm.dialogVisible,
            "width": "50%",
            "top": "5vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        }, [_c('el-row', {
          attrs: {
            "gutter": 20
          }
        }, [_c('el-form', {
          staticClass: "demo-ruleForm login-container",
          attrs: {
            "label-width": "100px"
          }
        }, [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.companyname || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户名:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.userName || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "角色:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.membershipName || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "创建时间:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.dateTran(_vm.detail.createTime)) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片大小:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.resolution || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "提示词:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.prompt || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "生图记录id:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.generationId || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "通道图:"
          }
        }, [(_vm.detail.modelImgThumbnail || _vm.detail.modelImg) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.modelImgThumbnail || _vm.detail.modelImg,
            "preview-src-list": [_vm.detail.modelImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "原图:"
          }
        }, [(_vm.detail.originalImgThumbnail || _vm.detail.originalImg) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.originalImgThumbnail || _vm.detail.originalImg,
            "preview-src-list": [_vm.detail.originalImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "叠加优化图:"
          }
        }, [(
          _vm.detail.optimizationImgThumbnail || _vm.detail.optimizationImg
        ) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.optimizationImgThumbnail || _vm.detail.optimizationImg,
            "preview-src-list": [_vm.detail.optimizationImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "原图优化图:"
          }
        }, [(_vm.detail.satelliteImgThumbnail || _vm.detail.satelliteImg) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.satelliteImgThumbnail || _vm.detail.satelliteImg,
            "preview-src-list": [_vm.detail.satelliteImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1)], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "total, sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pictureList.length > 0) ? _c('viewer', {
    ref: "viewer",
    staticClass: "picture-view-box",
    attrs: {
      "images": _vm.pictureList,
      "rebuild": "",
      "options": {
        initialViewIndex: 0,
        navbar: false,
        title: function () { return _vm.item.fileTitle; }
      }
    }
  }, _vm._l((_vm.pictureList), function(pic) {
    return _c('div', {
      key: pic.id,
      staticClass: "pic-list"
    }, [_c('img', {
      staticClass: "item-pic",
      attrs: {
        "src": pic.pic,
        "alt": ""
      }
    }), _vm._v(" "), (_vm.isShowFt) ? _c('h4', {
      staticClass: "pic-label"
    }, [_vm._t("default", function() {
      return [_vm._v(_vm._s(pic.fileName))]
    })], 2) : _vm._e()])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-company-manage"
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "780px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "100px",
      "label-position": "left",
      "rules": _vm.formRules,
      "validate-on-rule-change": false
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "企业名称:",
      "prop": "name"
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入",
      "clearable": "",
      "fetch-suggestions": _vm.querySearch,
      "trigger-on-focus": false
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地区:",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.showname),
      callback: function($$v) {
        _vm.$set(_vm.form, "showname", $$v)
      },
      expression: "form.showname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业图标:"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "size": "small",
      "auto-upload": false,
      "on-change": _vm.imgPreview,
      "action": _vm.upload.postURL,
      "show-file-list": false
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon",
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "line-height": "100px"
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业管理员:"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择企业管理员"
    },
    model: {
      value: (_vm.company),
      callback: function($$v) {
        _vm.company = $$v
      },
      expression: "company"
    }
  }, _vm._l((_vm.companyManages), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "硬件绑定:",
      "required": ""
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#F66B3D",
      "active-value": 1,
      "inactive-value": 0,
      "inactive-color": "#F6F6F6"
    },
    model: {
      value: (_vm.isbinding),
      callback: function($$v) {
        _vm.isbinding = $$v
      },
      expression: "isbinding"
    }
  }), _c('span', {
    staticStyle: {
      "padding-left": "10px",
      "color": "#666666"
    }
  }, [_vm._v("是否启用硬件绑定")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户地址:",
      "required": "",
      "prop": "address"
    }
  }, [_c('GisCommon', {
    ref: "GisCommon",
    attrs: {
      "selected": _vm.selected,
      "address": _vm.form.address,
      "lonLat": this.position_.toString() || ''
    },
    on: {
      "update:address": function($event) {
        return _vm.$set(_vm.form, "address", $event)
      },
      "backPram": _vm.backPram
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "大区代号:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.loginType != '1'
    },
    model: {
      value: (_vm.form.regionCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "regionCode", $$v)
      },
      expression: "form.regionCode"
    }
  }, _vm._l((_vm.regionCodeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资质等级:",
      "prop": "grade"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }, _vm._l((_vm.gradeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业性质:",
      "prop": "natrue"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.natrue),
      callback: function($$v) {
        _vm.$set(_vm.form, "natrue", $$v)
      },
      expression: "form.natrue"
    }
  }, _vm._l((_vm.natureList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户规模:",
      "prop": "userScale"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.userScale),
      callback: function($$v) {
        _vm.$set(_vm.form, "userScale", $$v)
      },
      expression: "form.userScale"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业联系人:",
      "prop": "linker"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.linker),
      callback: function($$v) {
        _vm.linker = $$v
      },
      expression: "linker"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式:",
      "prop": "linkerPhone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.linkerPhone),
      callback: function($$v) {
        _vm.linkerPhone = $$v
      },
      expression: "linkerPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理:"
    }
  }, [_c('SelectCommon', {
    attrs: {
      "placeholder": "客户经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/manageList",
      "disabled": _vm.loginType !== '1',
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.managerAdminuser
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理:"
    }
  }, [_c('SelectCommon', {
    staticClass: "kuang",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择客户成功经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 3
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "disabled": _vm.loginType !== '1',
      "defaultVal": _vm.successfulManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商:"
    }
  }, [_c('SelectCommon', {
    staticClass: "kuang",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择经销商",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 4
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "disabled": _vm.loginType !== '1',
      "defaultVal": _vm.agencyManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
    }
  })], 1)], 1), _vm._v(" "), (_vm.editLevel) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "ratingClass",
    attrs: {
      "label": "客户分级:",
      "prop": "level"
    }
  }, [_c('el-rate', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "max": 3
    },
    model: {
      value: (_vm.form.level),
      callback: function($$v) {
        _vm.$set(_vm.form, "level", $$v)
      },
      expression: "form.level"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.note),
      callback: function($$v) {
        _vm.note = $$v
      },
      expression: "note"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "background": "#f66b3d",
      "color": "#fff",
      "width": "140px"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存设置")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-detail-box"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "font",
    on: {
      "click": _vm.bak
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left icon"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "shu"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "font-text"
  }, [_vm._v(_vm._s(_vm.$route.query.companyName))]), _vm._v(" "), _c('span', {
    staticClass: "export"
  }, [_c('a', {
    attrs: {
      "href": _vm.href
    }
  }, [_c('span', {
    staticClass: "el-icon-download"
  }), _vm._v("导出统计数据")])]), _vm._v(" "), _c('span', {
    staticClass: "export"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.pointByHour
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("用户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6"
    }
  }, [_vm._v("部门管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("产品管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("设备管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }, [_vm._v("跟踪记录")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("分析统计")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [_vm._v("企业设置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-content"
  }, [(_vm.showCom) ? _c('div', [_c('company')], 1) : _vm._e(), _vm._v(" "), (_vm.showWeP) ? _c('div', [_c('weProduct')], 1) : _vm._e(), _vm._v(" "), (_vm.showDev) ? _c('div', [_c('device')], 1) : _vm._e(), _vm._v(" "), (_vm.showFx) ? _c('Static', {
    attrs: {
      "comId": _vm.$route.query.companyId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 6) ? _c('DepartManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 7) ? _c('TrackManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 8) ? _c('CompamySetting', {
    attrs: {
      "editLevel": false
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-stastics-box fitSize"
  }, [_c('el-row', {
    staticClass: "company-stastics-wrapper fitSize"
  }, [_c('el-col', {
    staticClass: "company-stastics-item left",
    attrs: {
      "span": 13
    }
  }, [_c('header', {
    staticClass: "left-hd"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": __webpack_require__(1707)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("有效产品")]), _vm._v(" "), _c('span', {
    staticClass: "label_count zs"
  }, [_vm._v(_vm._s(_vm.proNum))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": __webpack_require__(1706)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("闲置产品")]), _vm._v(" "), _c('span', {
    staticClass: "label_count xz"
  }, [_vm._v(_vm._s(_vm.proXZ))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": __webpack_require__(1704)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("已过期产品")]), _vm._v(" "), _c('span', {
    staticClass: "label_count ygq"
  }, [_vm._v(_vm._s(_vm.proGQ))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": __webpack_require__(1705)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("即将过期")]), _vm._v(" "), _c('span', {
    staticClass: "label_count jgq"
  }, [_vm._v(_vm._s(_vm.proJGQ))])])], 1)], 1), _vm._v(" "), _c('article', {
    staticClass: "left-bd",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("产品统计")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.productLoading),
      expression: "productLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.products
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "logo",
      "header-align": "center",
      "align": "center",
      "width": "100px",
      "label": "产品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "tpimg",
          attrs: {
            "slot": "reference",
            "src": scope.row.logo,
            "alt": "logo"
          },
          slot: "reference"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "产品数量",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unUsedSum",
      "label": "闲置产品",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dueSum",
      "label": "过期产品",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dueMonthSum",
      "label": "即将过期",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "left-ft"
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("模块使用情况")]), _vm._v(" "), _c('el-select', {
    staticClass: "checkName",
    staticStyle: {
      "float": "right"
    },
    on: {
      "change": function($event) {
        return _vm.changeTime('getCompanyMonthModulePointPie')
      }
    },
    model: {
      value: (_vm.moduleTime),
      callback: function($$v) {
        _vm.moduleTime = $$v
      },
      expression: "moduleTime"
    }
  }, _vm._l((_vm.times), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.masg),
      expression: "!masg"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.moduleLoading),
      expression: "moduleLoading"
    }],
    staticClass: "pie-content"
  }, [_c('el-col', {
    staticClass: "pie-chart",
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "echartModule"
    }
  })]), _vm._v(" "), (_vm.modulePieArr.length > 0) ? _c('el-col', {
    staticClass: "pie-legend",
    attrs: {
      "span": 10
    }
  }, _vm._l((_vm.modulePieArr), function(leg, index) {
    return _c('div', {
      key: leg.moduleid,
      staticClass: "legend-list"
    }, [_c('span', {
      staticClass: "circle",
      style: ({
        'background': index < _vm.pieColor.length ? _vm.pieColor[index] : (_vm.pieColor[index - _vm.pieColor.length])
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(leg.modulename))])])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.masg),
      expression: "masg"
    }],
    staticStyle: {
      "height": "50px",
      "text-align": "center",
      "color": "#666",
      "line-height": "20"
    }
  }, [_vm._v(" 暂无数据")])], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "company-stastics-item right",
    attrs: {
      "span": 11
    }
  }, [_c('header', {
    staticClass: "right-hd",
    staticStyle: {
      "position": "relative",
      "margin-bottom": "15px"
    }
  }, [_c('header', {
    staticClass: "module-title",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("登录设备统计")]), _vm._v(" "), _c('el-select', {
    staticClass: "checkName",
    staticStyle: {
      "top": "-8px"
    },
    on: {
      "change": function($event) {
        return _vm.changeTime('getDeviceInfo')
      }
    },
    model: {
      value: (_vm.deviceCount),
      callback: function($$v) {
        _vm.deviceCount = $$v
      },
      expression: "deviceCount"
    }
  }, _vm._l((_vm.times), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.deviceLoading),
      expression: "deviceLoading"
    }],
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "id": "device-chart"
    }
  })], 1), _vm._v(" "), _c('article', {
    staticClass: "right-bd"
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("积分统计")]), _vm._v(" "), _c('el-select', {
    staticClass: "checkName",
    on: {
      "change": function($event) {
        return _vm.changeTime('getCompanyMonthPointBrokenLine')
      }
    },
    model: {
      value: (_vm.staTime),
      callback: function($$v) {
        _vm.staTime = $$v
      },
      expression: "staTime"
    }
  }, _vm._l((_vm.times), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.creditLoading),
      expression: "creditLoading"
    }],
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "id": "creditLine"
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "right-ft",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("积分排行榜")]), _vm._v(" "), _c('div', {
    staticClass: "operate-btn"
  }, [_c('el-button', {
    staticClass: "jf_button",
    on: {
      "click": function($event) {
        return _vm.ranking(1)
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-button', {
    staticClass: "jf_button",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.ranking(2)
      }
    }
  }, [_vm._v("近30天")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "size": "small",
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changeDateRange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.rankLoading),
      expression: "rankLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.values,
      "height": "200"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "排名",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sumpoint",
      "label": "产生积分",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "label-credit-queue",
          on: {
            "click": function($event) {
              return _vm.handlePie(scope.row.userid, scope.row.name)
            }
          }
        }, [_vm._v("模块使用情况")]), _vm._v(" "), _c('span', {
          staticClass: "label-credit-queue tj",
          on: {
            "click": function($event) {
              return _vm.handleLine(scope.row.userid, scope.row.name)
            }
          }
        }, [_vm._v("积分统计")])]
      }
    }])
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "选择人员",
      "visible": _vm.personVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.personVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch
    },
    model: {
      value: (_vm.souch_value),
      callback: function($$v) {
        _vm.souch_value = $$v
      },
      expression: "souch_value"
    }
  }, _vm._l((_vm.optionsSouch), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.proName),
      callback: function($$v) {
        _vm.proName = $$v
      },
      expression: "proName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v(" \n          " + _vm._s(tag) + " \n      ")])
  }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    ref: "users",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "current-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.checked),
            expression: "scope.row.checked"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(scope.row.checked) ? _vm._i(scope.row.checked, null) > -1 : (scope.row.checked)
          },
          on: {
            "change": [function($event) {
              var $$a = scope.row.checked,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(scope.row, "checked", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(scope.row, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(scope.row, "checked", $$c)
              }
            }, _vm.changeFun]
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "point",
      "label": "积分",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "border": "1px solid #dfe6ec",
      "margin-top": "0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": " prev, pager, next",
      "current-page": _vm.pageNumber2,
      "page-size": _vm.pageSize2,
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.personVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.userSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "近30天模块使用",
      "visible": _vm.pieVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.pieVisible = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "top": "60px"
    }
  }, [_vm._v("当前人员 : " + _vm._s(_vm.pieName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "360px"
    },
    attrs: {
      "id": "echartBT2"
    }
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "近30天积分统计",
      "visible": _vm.lineVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.lineVisible = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "top": "60px"
    }
  }, [_vm._v("当前人员 : " + _vm._s(_vm.lineName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "360px"
    },
    attrs: {
      "id": "echartZXT2"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-comorizeList-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "用户 / 手机号 / 名称 / 企业"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "类型",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.souType),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "souType", $$v)
            },
            expression: "souchs.souType"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "状态",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.status),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "status", $$v)
            },
            expression: "souchs.status"
          }
        }, _vm._l((_vm.types2), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "200",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productname",
            "label": "名称",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "companyname",
            "label": "企业",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "userdeptname",
            "label": "部门",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userdeptname || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "用户",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.name || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "手机号",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.phone || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "typename",
            "label": "类型",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.typename == '试用' ? 'success' : 'primary'
              }, [_vm._v(" " + _vm._s(scope.row.typename) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usingstatus",
            "label": "状态",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: ['2', '3'].includes(scope.row.usingstatus) ? '' : 'primary'
              }, [_vm._v(" " + _vm._s(scope.row.usingstatusname) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "effectivetime",
            "label": "生效时间",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "duetime",
            "label": "到期时间",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "fixed": "right",
            "min-width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "相关订单",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-Business",
                on: {
                  "click": function($event) {
                    return _vm.handleAbout(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.usingstatus != 2) ? [(!scope.row.usingstatus2) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "禁用",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondisabled",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "启用",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconaccomplish",
                on: {
                  "click": function($event) {
                    return _vm.handleOpen(scope.$index, scope.row)
                  }
                }
              })])] : _vm._e()], 2)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit model-xf-box",
          attrs: {
            "width": "800px",
            "title": "续费",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "订单账户:"
          }
        }, [_vm._v(_vm._s(_vm.orderUser) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.editlistLoading),
            expression: "editlistLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList2,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod2,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber2 - 1) * _vm.pageSize2 + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "logo2",
            "header-align": "center",
            "align": "center",
            "width": "100px",
            "label": "图片"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('img', {
                staticClass: "tpimg",
                attrs: {
                  "slot": "reference",
                  "src": scope.row.logo2,
                  "alt": scope.row.logo2
                },
                slot: "reference"
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "名称",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productid",
            "label": "订单ID",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price2",
            "label": "单价(元)",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "purchaseMonth",
            "label": "续费时长(月)",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var row = ref.row;
              var $index = ref.$index;

              return [_c('el-input', {
                attrs: {
                  "type": "number",
                  "min": "1"
                },
                on: {
                  "blur": function($event) {
                    return _vm.loseFcousMonth(1, row)
                  }
                },
                model: {
                  value: (row.purchaseMonth),
                  callback: function($$v) {
                    _vm.$set(row, "purchaseMonth", $$v)
                  },
                  expression: "row.purchaseMonth"
                }
              })]
            }
          }])
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "position": "relative",
            "padding-bottom": "0px",
            "margin-top": "0px",
            "height": "80px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-checkbox', {
          staticClass: "el-checkbox1",
          on: {
            "change": _vm.checkboxOnclick
          },
          model: {
            value: (_vm.checked),
            callback: function($$v) {
              _vm.checked = $$v
            },
            expression: "checked"
          }
        }, [_vm._v(" 试用订单")]), _vm._v(" "), _c('el-form-item', {
          staticClass: "Auto_allPrice",
          attrs: {
            "label": "总价:"
          }
        }, [_c('el-input', {
          staticClass: "price",
          staticStyle: {
            "width": "120px",
            "z-index": "9999"
          },
          attrs: {
            "disabled": _vm.disCheckBox
          },
          on: {
            "blur": function($event) {
              return _vm.priceloseF()
            }
          },
          model: {
            value: (_vm.allPrice),
            callback: function($$v) {
              _vm.allPrice = $$v
            },
            expression: "allPrice"
          }
        })], 1), _vm._v(" "), _c('el-form-item', {
          staticClass: "Auto_ygPrice",
          attrs: {
            "label": "预估价格:"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.ygPrice) + " 元\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.adminVisible) ? _c('Detail', {
          attrs: {
            "adminVisible": _vm.adminVisible,
            "authProductId": _vm.detailOrderId
          },
          on: {
            "adminVisibleClose": _vm.adminVisibleClose
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "float_left",
          attrs: {
            "type": "danger",
            "size": "medium",
            "disabled": _vm.sels1.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.handleDel()
            }
          }
        }, [_vm._v("\n          禁用\n        ")]), _vm._v(" "), _c('el-button', {
          staticClass: "float_left",
          attrs: {
            "type": "primary",
            "size": "medium",
            "disabled": _vm.sels3.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.handleOpen()
            }
          }
        }, [_vm._v("\n          启用\n        ")])], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-admin-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "姓名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.souchs.name),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "name", $$v)
            },
            expression: "souchs.name"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.users,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "220",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "类型",
            "min-width": "220",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.type == "0" ?
                "超级管理员" :
                scope.row.type == "1" ?
                "系统管理员" :
                scope.row.type == "2" ?
                "客户经理" :
                scope.row.type == "3" ?
                "客户成功经理" :
                scope.row.type == "4" ?
                "经销商" :
                ""))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "添加日期",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return (scope.row.type != '0') ? [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)] : undefined
            }
          }], null, true)
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            },
            "closed": _vm.closeAddform
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "账号",
            "prop": "user"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.user),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "user", $$v)
            },
            expression: "addForm.user"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "类型",
            "prop": "type"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.addForm.type),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "type", $$v)
            },
            expression: "addForm.type"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "密码",
            "prop": "password"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "password",
            "placeholder": "请输入"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.addSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.addForm.password),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "password", $$v)
            },
            expression: "addForm.password"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            },
            "closed": _vm.closeeditForm
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "账号",
            "prop": "phone"
          }
        }, [_c('el-input', {
          attrs: {
            "disabled": "",
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.phone),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "phone", $$v)
            },
            expression: "editForm.phone"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "类型",
            "prop": "type"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.editForm.type),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "type", $$v)
            },
            expression: "editForm.type"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "密码",
            "prop": "password"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "password",
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.password),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "password", $$v)
            },
            expression: "editForm.password"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "确认密码",
            "prop": "conpassword"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "password",
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.editSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.editForm.conpassword),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "conpassword", $$v)
            },
            expression: "editForm.conpassword"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "tab-detart-manage",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-form', {
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "部门 / 管理员",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "plain": "",
            "icon": "el-icon-plus"
          },
          on: {
            "click": _vm.addForm
          }
        }, [_vm._v("新 增")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          ref: "companyTabRef",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": ""
          },
          on: {
            "selection-change": _vm.handerSectionChange,
            "row-click": _vm.handerRowClick
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "deptname",
            "min-width": "180",
            "label": "部门名称",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n            " + _vm._s(scope.row.deptname || '-') + "\n          ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "deptManagerName",
            "min-width": "180",
            "label": "部门管理员",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n            " + _vm._s(scope.row.deptManagerName || '-') + "\n          ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.hasUser != 1) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), (_vm.visible) ? _c('ModalForm', {
          attrs: {
            "visible": _vm.visible,
            "mode": _vm.mode,
            "processDetail": _vm.processDetail
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            "getList": _vm.getList
          }
        }) : _vm._e(), _vm._v(" "), (_vm.visibleView) ? _c('ModalFormView', {
          attrs: {
            "visible": _vm.visibleView,
            "processDetail": _vm.processDetail
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleView = $event
            }
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "position": "relative"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-detail-box"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "font",
    on: {
      "click": _vm.back
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left icon"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "shu"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "font-text"
  }, [_vm._v(_vm._s(_vm.$route.query.name))])]), _vm._v(" "), _c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "content-copy"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "content-box-copy",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品管理")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("\n              共" + _vm._s(_vm.sum) + "个产品  "), _c('span', {
    staticClass: "higlight"
  }, [_vm._v("企业产品:" + _vm._s(_vm.company) + ",已过期产品:" + _vm._s(_vm.expired))])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%",
      "margin-top": "10px",
      "height": "auto"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "名称",
      "min-width": "220",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typename",
      "label": "类型",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "usingstatusname",
      "label": "状态",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.usingstatus == 1) ? _c('span', {
          staticStyle: {
            "color": "#2196f3"
          }
        }, [_vm._v(_vm._s(scope.row.usingstatusname))]) : _c('span', [_vm._v(_vm._s(scope.row.usingstatusname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "duetime",
      "label": "到期时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.duetime.split(" ")[0]) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "operate"
        }, [(scope.row.usingstatus == 1) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "禁用",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont icondisabled",
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.usingstatus == 3) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "启用",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconaccomplish",
          on: {
            "click": function($event) {
              return _vm.handleOpen(scope.$index, scope.row)
            }
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "content-box-two-copy",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("登录日历")]), _vm._v(" "), _c('Calendar')], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-copy"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "content-box-copy"
  }, [_c('LeftCharts', {
    attrs: {
      "userid": _vm.$route.query.userId
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "content-box-two-copy"
  }, [_c('RightCharts', {
    attrs: {
      "userid": _vm.$route.query.userId
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    class: _vm.showRecords ? 'content-copy' : 'newstyle'
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": _vm.showRecords ? 16 : 24
    }
  }, [_c('div', {
    class: _vm.showRecords ? 'newstyle' : ''
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("客户备注")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "rows": 3,
      "type": "textarea",
      "placeholder": "填写留言"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.addUserNote
    }
  }, [_vm._v("提交")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#616161",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n              所有备注(" + _vm._s(_vm.allcount) + ")\n            ")]), _vm._v(" "), _vm._l((_vm.notes), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "contextx"
    }, [_c('div', {
      staticClass: "contexss",
      staticStyle: {
        "height": "30px"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block",
        "width": "80px",
        "float": "left",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block",
        "margin-left": "20px",
        "float": "left",
        "color": "#acabab"
      }
    }, [_vm._v(_vm._s(item.intime))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "contexss",
      staticStyle: {
        "color": "#707070"
      }
    }, [_vm._v("\n                " + _vm._s(item.note) + "\n              ")])])
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "0.5px solid #d4d3d3"
    }
  })], 2)]), _vm._v(" "), (_vm.showRecords) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loginInfoLoading),
      expression: "loginInfoLoading"
    }],
    staticClass: "content-box-two-copy"
  }, [_c('div', {
    staticClass: "record_title"
  }, [_vm._v("登录记录统计")]), _vm._v(" "), _c('div', {
    staticClass: "login_info"
  }, [_c('span', {
    staticClass: "login_title"
  }, [_vm._v("总计登录："), _c('span', {
    staticClass: "login_num"
  }, [_vm._v(_vm._s(_vm.countNum) + "次")])])]), _vm._v(" "), _c('div', {
    staticClass: "last_time"
  }, [_vm._v("\n              您上次登陆时间和位置：" + _vm._s(_vm.lastLogin_time) + "，" + _vm._s(_vm.lastLogin_location) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "history"
  }, [_vm._v("历史记录（最近10次）")]), _vm._v(" "), _vm._l((_vm.infos), function(item) {
    return _c('div', {
      staticClass: "history_item"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('span', {
      staticClass: "times"
    }, [_vm._v(_vm._s(item.times))]), _vm._v(" "), _c('span', {
      staticClass: "ip"
    }, [_vm._v(_vm._s(item.ip))]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(item.location))])])
  })], 2)]) : _vm._e()], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-copy-l"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "legend"
    }
  }, [_vm._l((_vm.firstLabelList), function(p, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('div', {
      class: 'value' + index
    }, [_vm._v(_vm._s(p.value))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._l((_vm.secondLabelList), function(p, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('div', {
      class: 'second' + index
    }, [_vm._v(_vm._s(p.value))])])
  })], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.registerCount
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "charts-box-copy-lbar"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DetailPage', {
    attrs: {
      "name": _vm.modulename,
      "loading": _vm.loading,
      "backRoute": "moduleIntegral",
      "param": _vm.params
    }
  }, [_c('template', {
    slot: "detailMain"
  }, [_c('span', {
    staticClass: "searchName"
  }, [_vm._v("自定义时间段:")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "kuang",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "daterange",
      "clearable": false,
      "size": "large",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changeData
    },
    model: {
      value: (_vm.tiemSlot),
      callback: function($$v) {
        _vm.tiemSlot = $$v
      },
      expression: "tiemSlot"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#2196F3"
    },
    attrs: {
      "type": "text"
    }
  }, [_c('a', {
    on: {
      "click": _vm.downFile
    }
  }, [_vm._v("导出")])]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("共" + _vm._s(_vm.count) + "个命令模块        命令模块分数(总):" + _vm._s(_vm.jifen) + "        已过滤0积分模块")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": "545px",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "moduleid",
      "label": "命令id",
      "width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modulename",
      "label": "命令模块名称",
      "min-width": "230",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cmdpoint",
      "label": "命令模块分数",
      "width": "130",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cmdtotalpoint",
      "label": "总积分",
      "width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "allpoint",
      "label": "累计分数",
      "width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#669DF0"
          }
        }, [_vm._v(_vm._s(scope.row.allpoint))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clicksNum",
      "label": "点击次数",
      "width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes,prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "page-size": _vm.pageSize,
      "current-page": _vm.pageNumber,
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.pageNumber = $event
      },
      "update:current-page": function($event) {
        _vm.pageNumber = $event
      },
      "current-change": _vm.changeData
    }
  })], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-company-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "大区",
            "clearable": true
          },
          model: {
            value: (_vm.regionCode),
            callback: function($$v) {
              _vm.regionCode = $$v
            },
            expression: "regionCode"
          }
        }, _vm._l((_vm.regionCodeList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "企业名称",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.managerAdminuser
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "客户成功经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.successfulManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "经销商",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.agencyManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "placeholder": "是否分配",
            "clearable": ""
          },
          model: {
            value: (_vm.distributionStatus),
            callback: function($$v) {
              _vm.distributionStatus = $$v
            },
            expression: "distributionStatus"
          }
        }, _vm._l((_vm.distribution), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "资质等级",
            "multiple": "",
            "collapse-tags": "",
            "clearable": ""
          },
          model: {
            value: (_vm.gradeValue),
            callback: function($$v) {
              _vm.gradeValue = $$v
            },
            expression: "gradeValue"
          }
        }, _vm._l((_vm.gradeArr), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [(_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")]) : _vm._e()], 1), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "loading": _vm.exportLoading
          },
          on: {
            "click": function($event) {
              return _vm.batchExport()
            }
          }
        }, [_vm._v("\n            批量导出"), (_vm.exportList.length) ? _c('span', [_vm._v(" (" + _vm._s(_vm.exportList.length) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "loading": _vm.importLoading
          },
          on: {
            "click": function($event) {
              return _vm.batchImport()
            }
          }
        }, [_vm._v("批量导入")]), _vm._v(" "), _c('input', {
          ref: "clearFileModal",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "id": "importCompany",
            "name": "file",
            "accept": ".xls,.xlsx"
          },
          on: {
            "change": function($event) {
              return _vm.importCompanyFile($event)
            }
          }
        })], 1) : _vm._e()], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('div', {
          staticClass: "tips"
        }, [_c('span', [_vm._v("覆盖率：")]), _c('span', {
          staticClass: "blueNumber"
        }, [_vm._v(_vm._s(_vm.targetTotal))]), _vm._v(" "), _c('span', [_vm._v("甲级目标客户总数量：")]), _c('span', {
          staticClass: "redNumber"
        }, [_vm._v(_vm._s(_vm.qualityTotal))]), _vm._v(" "), _c('span', [_vm._v("高校目标客户总数量："), _c('span', {
          staticClass: "colleges"
        }, [_vm._v(_vm._s(_vm.collegesTotal))])])]), _vm._v(" "), _c('el-table', {
          ref: "companyTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.proList,
            "row-key": "id",
            "highlight-current-row": "",
            "height": _vm.maxTbHeight - 36,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "reserve-selection": true,
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "企业编号（ID）",
            "sortable": "custom",
            "min-width": "150",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "regionCode",
            "label": "大区代号",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.regionCode === '1') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华东大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '2') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '3') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '4') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华南大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '5') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西南大区")]) : _vm._e(), _vm._v(" "), (!scope.row.regionCode) ? _c('span', [_vm._v("-")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "sortable": "custom",
            "min-width": "240",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "grade",
            "label": "资质等级",
            "sortable": "custom",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.grade == '1') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("综合甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '2') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '3') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '4') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '5') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '6') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '7') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '9') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("高校")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '10') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("施工单位")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '8') ? _c('div', {
                staticClass: "other"
              }, [_vm._v("其他")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "natrue",
            "label": "企业性质",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.natrue === "1" ?
                "央企" :
                scope.row.natrue === "2" ?
                "国企" :
                scope.row.natrue === "3" ?
                "民营上市" :
                scope.row.natrue === "4" ?
                "民营" :
                scope.row.natrue === "5" ?
                "高校" :
                "-") + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "userScale",
            "label": "用户规模",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userScale || "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "showname",
            "label": "地区",
            "sortable": "custom",
            "min-width": "140",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.showname || "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户分级",
            "prop": "level",
            "sortable": "custom",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-rate', {
                attrs: {
                  "value": Number(scope.row.level),
                  "max": Number(scope.row.level)
                }
              }), _vm._v(" "), (!scope.row.level) ? _c('span', [_vm._v("-")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户经理",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managerAdminuserName ?
                scope.row.managerAdminuserName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户成功经理",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.successfulManagerName ?
                scope.row.successfulManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "经销商",
            "min-width": "70",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.agencyManagerName ?
                scope.row.agencyManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "status",
            "width": "100",
            "label": "企业状态",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.status == 0) ? _c('div', {
                staticClass: "visit_gray"
              }, [_vm._v("初始")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('div', {
                staticClass: "orange"
              }, [_vm._v("拜访")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('div', {
                staticClass: "purple_line"
              }, [_vm._v("试用")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('div', {
                staticClass: "blue_line"
              }, [_vm._v("正式")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleCom(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.delFlg !== '0') ? _c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()]
            }
          }])
        })], 1), _vm._v(" "), _c('target-custom-dialog', {
          ref: "targetcustomdialogRef",
          on: {
            "getList": _vm.getList
          }
        }), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "width": "850px",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            },
            "close": _vm.closedialog
          }
        }, [(_vm.addFormVisible) ? _c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-autocomplete', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请输入",
            "clearable": "",
            "fetch-suggestions": _vm.querySearch,
            "trigger-on-focus": false
          },
          on: {
            "select": _vm.handleSelect
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地区",
            "prop": "showname"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.showname),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "showname", $$v)
            },
            expression: "addForm.showname"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户地址",
            "required": ""
          }
        }, [_c('GisCommon', {
          attrs: {
            "selected": _vm.selected,
            "address": _vm.address,
            "lonLat": _vm.addForm.longitudeAndLatitude
          },
          on: {
            "backPram": _vm.backPram
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户经理",
            "required": ""
          }
        }, [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业图标",
            "required": ""
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.imageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.imageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              return _vm.handerClose('addFormVisible', 'addForm')
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片"
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.editImageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.editImageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地区",
            "prop": "showname"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.showname),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "showname", $$v)
            },
            expression: "editForm.showname"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.orderVisible) ? _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "选择人员",
            "visible": _vm.orderVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.orderVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px",
            "border": "1px solid #dfe6ec"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs2
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": _vm.changeSouch2
          },
          model: {
            value: (_vm.value2),
            callback: function($$v) {
              _vm.value2 = $$v
            },
            expression: "value2"
          }
        }, _vm._l((_vm.optionsSouch2), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disSouch),
            expression: "disSouch"
          }],
          staticStyle: {
            "width": "200px"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.proName2),
            callback: function($$v) {
              _vm.proName2 = $$v
            },
            expression: "proName2"
          }
        }), _vm._v(" "), _c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disinvit),
            expression: "disinvit"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs2.invitValue),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "invitValue", $$v)
            },
            expression: "souchs2.invitValue"
          }
        }, _vm._l((_vm.inviValues), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disSofttype),
            expression: "disSofttype"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs2.softtype),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "softtype", $$v)
            },
            expression: "souchs2.softtype"
          }
        }, _vm._l((_vm.softtypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-date-picker', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disTime1),
            expression: "disTime1"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "注册开始时间"
          },
          model: {
            value: (_vm.souchs2.fromtime),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "fromtime", $$v)
            },
            expression: "souchs2.fromtime"
          }
        }), _vm._v(" "), _c('el-date-picker', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disTime2),
            expression: "disTime2"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "注册结束时间"
          },
          model: {
            value: (_vm.souchs2.totime),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "totime", $$v)
            },
            expression: "souchs2.totime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags2), function(tag2) {
          return _c('el-tag', {
            key: tag2,
            attrs: {
              "closable": "",
              "disable-transitions": false
            },
            on: {
              "close": function($event) {
                return _vm.handleClose2(tag2)
              }
            }
          }, [_vm._v("\n          " + _vm._s(tag2) + "\n        ")])
        }), _vm._v(" "), (_vm.dynamicTags2 != '') ? _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          on: {
            "click": _vm.delTags2
          }
        }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.userLoading),
            expression: "userLoading"
          }],
          ref: "userList",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "row-key": function (row) { return row.id; },
            "data": _vm.userList,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "current-change": _vm.handleSelectionChange,
            "selection-change": _vm.handleUserSelectionChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "reserve-selection": true,
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "130"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "xshow-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "注册时间",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "border": "1px solid #dfe6ec",
            "margin-top": "0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": " prev, pager, next",
            "current-page": _vm.pageNumber2,
            "page-size": _vm.pageSize2,
            "total": _vm.total2
          },
          on: {
            "current-change": _vm.handleCurrentChange2
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.orderVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.orderLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.clickUserSelection.apply(null, arguments)
            }
          }
        }, [_vm._v("确定")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adminVisible) ? _c('Admin', {
          attrs: {
            "adminVisible": _vm.adminVisible,
            "companyId": _vm.companyId,
            "UserSelection": _vm.UserSelection
          },
          on: {
            "adminVisibleClose": _vm.adminVisibleClose,
            "addAdmin": _vm.addAdmin,
            "orderUserSubmit": _vm.orderUserSubmit
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "update:currentPage": function($event) {
              _vm.pageNumber = $event
            },
            "update:current-page": function($event) {
              _vm.pageNumber = $event
            },
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tmain\n")])
},staticRenderFns: []}

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "10px",
      "margin-bottom": "-12px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "用户 / 手机号 / 名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList(1)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "类型",
      "clearable": ""
    },
    model: {
      value: (_vm.typeValue),
      callback: function($$v) {
        _vm.typeValue = $$v
      },
      expression: "typeValue"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "状态",
      "clearable": ""
    },
    model: {
      value: (_vm.typeValue2),
      callback: function($$v) {
        _vm.typeValue2 = $$v
      },
      expression: "typeValue2"
    }
  }, _vm._l((_vm.types2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getProList(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "medium",
      "disabled": _vm.ProductSelection.length == 0 ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.batch(1)
      }
    }
  }, [_vm._v("批量分配")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "medium",
      "disabled": _vm.ProductSelection.length == 0
    },
    on: {
      "click": function($event) {
        _vm.visibleDispatch = true
      }
    }
  }, [_vm._v("分配部门")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.proList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass,
      "row-key": function (row) { return row.id; }
    },
    on: {
      "sort-change": _vm.handleSortChange,
      "selection-change": _vm.handleProductSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "reserve-selection": true,
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "min-width": "200",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "名称",
      "min-width": "220",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "用户",
      "min-width": "110",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.phone || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "产品所属部门",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.deptname || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userdeptname",
      "label": "用户所属部门",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.userdeptname || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typename",
      "label": "类型",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "usingstatusname",
      "label": "状态",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "duetime1",
      "label": "到期时间",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "operate"
        }, [_c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "分配用户授权",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconclone-more",
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "撤销用户授权",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconundo",
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.deptid) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "撤销部门授权",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconundo2",
          staticStyle: {
            "font-size": "17px"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelDepart(scope.$index, scope.row)
            }
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [3, 10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), (_vm.editFormVisible) ? _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "分配用户",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs2
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch2
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.optionsSouch2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch2),
      expression: "disSouch2"
    }],
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.proName2),
      callback: function($$v) {
        _vm.proName2 = $$v
      },
      expression: "proName2"
    }
  }), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fpTypes2),
      expression: "fpTypes2"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.fpType),
      callback: function($$v) {
        _vm.fpType = $$v
      },
      expression: "fpType"
    }
  }, _vm._l((_vm.fpTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.showDepart) ? _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "部门"
    },
    model: {
      value: (_vm.deptid),
      callback: function($$v) {
        _vm.deptid = $$v
      },
      expression: "deptid"
    }
  }, _vm._l((_vm.departList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.deptname,
        "value": item.id
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags2), function(tag2) {
    return _c('el-tag', {
      key: tag2,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose2(tag2)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tag2) + "\n        ")])
  }), _vm._v(" "), (_vm.dynamicTags2 != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags2
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userLoading),
      expression: "userLoading"
    }],
    ref: "userList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.userList,
      "highlight-current-row": "",
      "height": "400",
      "row-key": function (row) { return row.id; },
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "select": _vm.selectTable,
      "sort-change": _vm.handleSortChange2,
      "current-change": _vm.handleSelectionChange,
      "selection-change": _vm.handleUserSelectionChange
    }
  }, [(_vm.batchType == 0) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.checked),
            expression: "scope.row.checked"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(scope.row.checked) ? _vm._i(scope.row.checked, null) > -1 : (scope.row.checked)
          },
          on: {
            "change": [function($event) {
              var $$a = scope.row.checked,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(scope.row, "checked", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(scope.row, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(scope.row, "checked", $$c)
              }
            }, _vm.changeFun]
          }
        })]
      }
    }], null, false, 19795969)
  }) : _c('el-table-column', {
    attrs: {
      "reserve-selection": true,
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "200",
      "sortable": "deptname",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.deptname ? scope.row.deptname : '-') + "\n          ")]
      }
    }], null, false, 2631811957)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invitestatusname",
      "label": "状态",
      "min-width": "180",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,sizes, prev, pager, next",
      "current-page": _vm.pageNumber2,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize2,
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2,
      "size-change": _vm.handleSizeChange2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.batchType == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit(0)
      }
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (_vm.batchType == 1) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit(1)
      }
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.visibleDispatch) ? _c('el-dialog', {
    staticClass: "model-dispatch",
    attrs: {
      "title": "分配部门",
      "visible": _vm.visibleDispatch,
      "close-on-click-modal": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.visibleDispatch = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "-10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-form', {
    ref: "dispatchForm",
    attrs: {
      "model": _vm.dispatchForm,
      "rules": _vm.dispatchRules,
      "hide-required-asterisk": "",
      "label-position": "left"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px",
      "color": "#666",
      "font-size": "14px"
    },
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n            已选择" + _vm._s(_vm.ProductSelection.length) + "个产品授权，请选择所属部门\n          ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "deptid"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.dispatchForm.deptid),
      callback: function($$v) {
        _vm.$set(_vm.dispatchForm, "deptid", $$v)
      },
      expression: "dispatchForm.deptid"
    }
  }, _vm._l((_vm.departList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.deptname,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerCloseDispatch.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmDispatchLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmitDispatch.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-authorizeList-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "姓名 / 手机号 / 名称 / 企业"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "类型",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.souType),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "souType", $$v)
            },
            expression: "souchs.souType"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "状态",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.status),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "status", $$v)
            },
            expression: "souchs.status"
          }
        }, _vm._l((_vm.types2), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "200",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "手机号",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productname",
            "label": "名称",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usercompany",
            "label": "企业",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "typename",
            "label": "类型",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.typename == '试用' ? 'success' : 'primary'
              }, [_vm._v(" " + _vm._s(scope.row.typename) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usingstatus",
            "label": "状态",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: ['2', '3'].includes(scope.row.usingstatus) ? '' : 'primary'
              }, [_vm._v(" " + _vm._s(scope.row.usingstatusname) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "effectivetime",
            "label": "生效时间",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "duetime",
            "label": "到期时间",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "fixed": "right",
            "min-width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "相关订单",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-Business",
                on: {
                  "click": function($event) {
                    return _vm.handleAbout(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.usingstatus != 2) ? [(!scope.row.usingstatus2) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "禁用",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondisabled",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "启用",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconaccomplish",
                on: {
                  "click": function($event) {
                    return _vm.handleOpen(scope.$index, scope.row)
                  }
                }
              })])] : _vm._e()], 2)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit model-xf-box",
          attrs: {
            "width": "800px",
            "title": "续费",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "订单账户:"
          }
        }, [_vm._v(_vm._s(_vm.orderUser) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.editlistLoading),
            expression: "editlistLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList2,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod2,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber2 - 1) * _vm.pageSize2 + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "logo2",
            "header-align": "center",
            "align": "center",
            "width": "100px",
            "label": "图片"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('img', {
                staticClass: "tpimg",
                attrs: {
                  "slot": "reference",
                  "src": scope.row.logo2,
                  "alt": scope.row.logo2
                },
                slot: "reference"
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "名称",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productid",
            "label": "订单ID",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price2",
            "label": "单价(元)",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "purchaseMonth",
            "label": "续费时长(月)",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var row = ref.row;
              var $index = ref.$index;

              return [_c('el-input', {
                attrs: {
                  "type": "number",
                  "min": "1"
                },
                on: {
                  "blur": function($event) {
                    return _vm.loseFcousMonth(1, row)
                  }
                },
                model: {
                  value: (row.purchaseMonth),
                  callback: function($$v) {
                    _vm.$set(row, "purchaseMonth", $$v)
                  },
                  expression: "row.purchaseMonth"
                }
              })]
            }
          }])
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "position": "relative",
            "padding-bottom": "0px",
            "margin-top": "0px",
            "height": "80px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-checkbox', {
          staticClass: "el-checkbox1",
          on: {
            "change": _vm.checkboxOnclick
          },
          model: {
            value: (_vm.checked),
            callback: function($$v) {
              _vm.checked = $$v
            },
            expression: "checked"
          }
        }, [_vm._v(" 试用订单")]), _vm._v(" "), _c('el-form-item', {
          staticClass: "Auto_allPrice",
          attrs: {
            "label": "总价:"
          }
        }, [_c('el-input', {
          staticClass: "price",
          staticStyle: {
            "width": "120px",
            "z-index": "9999"
          },
          attrs: {
            "disabled": _vm.disCheckBox
          },
          on: {
            "blur": function($event) {
              return _vm.priceloseF()
            }
          },
          model: {
            value: (_vm.allPrice),
            callback: function($$v) {
              _vm.allPrice = $$v
            },
            expression: "allPrice"
          }
        })], 1), _vm._v(" "), _c('el-form-item', {
          staticClass: "Auto_ygPrice",
          attrs: {
            "label": "预估价格:"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.ygPrice) + " 元\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.adminVisible) ? _c('Detail', {
          attrs: {
            "adminVisible": _vm.adminVisible,
            "authProductId": _vm.detailOrderId
          },
          on: {
            "adminVisibleClose": _vm.adminVisibleClose
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "float_left",
          attrs: {
            "type": "danger",
            "size": "medium",
            "disabled": _vm.sels1.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.handleDel()
            }
          }
        }, [_vm._v(" 禁用 ")]), _vm._v(" "), _c('el-button', {
          staticClass: "float_left",
          attrs: {
            "type": "primary",
            "size": "medium",
            "disabled": _vm.sels3.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.handleOpen()
            }
          }
        }, [_vm._v(" 启用  ")])], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "日活用户",
      "visible": _vm.dialogVisible,
      "width": "80%",
      "custom-class": "dialog",
      "footer": false
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('Account')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-company-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "大区",
            "clearable": true
          },
          model: {
            value: (_vm.regionCode),
            callback: function($$v) {
              _vm.regionCode = $$v
            },
            expression: "regionCode"
          }
        }, _vm._l((_vm.regionCodeList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "企业名称",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.managerAdminuser
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "客户成功经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.successfulManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "经销商",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.agencyManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "default-value": _vm.deadTime,
            "type": "date",
            "placeholder": "过期截止日期",
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd"
          },
          model: {
            value: (_vm.deadTime),
            callback: function($$v) {
              _vm.deadTime = $$v
            },
            expression: "deadTime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "loading": _vm.exportLoading
          },
          on: {
            "click": function($event) {
              return _vm.batchExport()
            }
          }
        }, [_vm._v("\n            批量导出"), (_vm.exportList.length) ? _c('span', [_vm._v(" (" + _vm._s(_vm.exportList.length) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "loading": _vm.importLoading
          },
          on: {
            "click": function($event) {
              return _vm.batchImport()
            }
          }
        }, [_vm._v("批量导入")]), _vm._v(" "), _c('input', {
          ref: "clearFileModal",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "id": "importProbation",
            "name": "file",
            "accept": ".xls,.xlsx"
          },
          on: {
            "change": function($event) {
              return _vm.importCompanyFile($event)
            }
          }
        })], 1) : _vm._e()], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('div', {
          staticClass: "tips"
        }, [_c('span', [_vm._v("试用客户总数量：")]), _c('span', {
          staticClass: "blueNumber"
        }, [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('span', [_vm._v("甲级试用客户数量：")]), _c('span', {
          staticClass: "redNumber"
        }, [_vm._v(_vm._s(_vm.levelTotal))]), _vm._v(" "), _c('span', [_vm._v("试用用户数：")]), _c('span', {
          staticClass: "purpleNumber"
        }, [_vm._v(_vm._s(_vm.tryTotal))]), _vm._v(" "), _c('span', [_vm._v("高校试用用户数：")]), _c('span', {
          staticClass: "colleges"
        }, [_vm._v(_vm._s(_vm.collegesTotal))]), _vm._v(" "), _c('span', [_vm._v("设计院试用用户数：")]), _c('span', {
          staticClass: "institute"
        }, [_vm._v(_vm._s(_vm.instituteTotal))])]), _vm._v(" "), _c('el-table', {
          ref: "companyTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.proList,
            "row-key": "id",
            "highlight-current-row": "",
            "height": _vm.maxTbHeight - 36,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "reserve-selection": true,
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "regionCode",
            "label": "大区代号",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.regionCode === '1') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华东大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '2') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '3') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '4') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华南大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '5') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西南大区")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "sortable": "custom",
            "min-width": "250",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "grade",
            "label": "资质等级",
            "sortable": "custom",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.grade === '1') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("综合甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '2') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '3') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '4') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '5') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '6') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '7') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '9') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("高校")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '10') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("施工单位")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '8') ? _c('div', {
                staticClass: "other"
              }, [_vm._v("其他")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "natrue",
            "label": "企业性质",
            "sortable": "custom",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.natrue === '1' ? '央企' : scope.row.natrue === '2' ? '国企' : scope.row.natrue === '3' ? '民营上市' :
                scope.row.natrue === '4' ? '民营' : scope.row.natrue === '5' ? '高校' : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "syuc",
            "label": "试用用户数",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "purpleNumber"
              }, [_vm._v(_vm._s(scope.row.syuc ? scope.row.syuc : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "showname",
            "label": "地区",
            "sortable": "custom",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "公司管理员",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managername ? scope.row.managername : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户经理",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managerAdminuserName ? scope.row.managerAdminuserName : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户成功经理",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.successfulManagerName ?
                scope.row.successfulManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "经销商",
            "min-width": "70",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.agencyManagerName ?
                scope.row.agencyManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "正式产品总数",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "blue_num"
              }, [_vm._v(_vm._s(scope.row.ac ? scope.row.ac : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "即将过期产品数量",
            "min-width": "140",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "orange"
              }, [_vm._v(_vm._s(scope.row.dc ? scope.row.dc : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "fixed": "right",
            "label": "操作",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleCom(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (_vm.id == scope.row.createUser && scope.row.delFlg !== '0') ? _c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()]
            }
          }])
        })], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "update:currentPage": function($event) {
              _vm.pageNumber = $event
            },
            "update:current-page": function($event) {
              _vm.pageNumber = $event
            },
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px",
      "margin-top": "2px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.optionsSouch), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch),
      expression: "disSouch"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.proName),
      callback: function($$v) {
        _vm.proName = $$v
      },
      expression: "proName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    staticStyle: {
      "position": "relative",
      "top": "2px",
      "width": "300px"
    },
    attrs: {
      "type": "daterange",
      "size": "large",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.LogDate),
      callback: function($$v) {
        _vm.LogDate = $$v
      },
      expression: "LogDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_c('a', {
    on: {
      "click": _vm.downFile
    }
  }, [_vm._v("导出")])])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": "",
      "height": "420px",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "point",
      "label": "积分",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registertime",
      "label": "注册日期",
      "min-width": "180",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "企业",
      "min-width": "180",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('br'), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "imger"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "loginForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("用户登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-dianhua"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号码"
    },
    model: {
      value: (_vm.loginForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "phone", $$v)
      },
      expression: "loginForm.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-mima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("免费注册")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/forget'
      }
    }
  }, [_vm._v("忘记密码")])], 1)], 1)], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBar"
  }, [_c('h1'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.jsdnn.com/",
      "target": "_blank"
    }
  }, [_vm._v("狄诺尼官网")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('p', [_vm._v("江苏狄诺尼信息技术有限责任公司")]), _vm._v(" "), _c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])
}]}

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', _vm._b({
    staticClass: "select_common",
    attrs: {
      "maxTagCount": 1,
      "maxTagTextLength": 10
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.myDefaultVal),
      callback: function($$v) {
        _vm.myDefaultVal = $$v
      },
      expression: "myDefaultVal"
    }
  }, 'el-select', _vm.$attrs, false), [(_vm.list) ? _vm._l((_vm.list), function(item) {
    return _c('el-option', {
      key: item[_vm.keys.value],
      attrs: {
        "value": item[_vm.keys.value],
        "label": item[_vm.keys.label]
      }
    })
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calendar"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("统计年月")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "postion": "relative",
      "top": "-10px"
    },
    attrs: {
      "options": _vm.options
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.valueYearMonth),
      callback: function($$v) {
        _vm.valueYearMonth = $$v
      },
      expression: "valueYearMonth"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_vm._v("登录天数")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', {
    staticClass: "loginRecord"
  }, [_vm._v(_vm._s(_vm.loginRecord) + "天")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "days"
  }, _vm._l((_vm.days), function(dayobject, index) {
    return _c('li', {
      key: index
    }, [(dayobject.day.getMonth() + 1 != _vm.currentMonth) ? _c('span', {
      staticClass: "other-month"
    }, [_vm._v(_vm._s(dayobject.day.getDate()))]) : _c('span', {
      ref: "dayLi",
      refInFor: true,
      staticClass: "curMonthDay",
      on: {
        "click": function($event) {
          return _vm.selectDay($event)
        }
      }
    }, [_vm._v(_vm._s(dayobject.day.getDate()) + "\n      ")])])
  }), 0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "weekdays"
  }, [_c('li', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("周日")]), _vm._v(" "), _c('li', [_vm._v("周一")]), _vm._v(" "), _c('li', [_vm._v("周二")]), _vm._v(" "), _c('li', [_vm._v("周三")]), _vm._v(" "), _c('li', [_vm._v("周四")]), _vm._v(" "), _c('li', [_vm._v("周五")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("周六")])])
}]}

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-UrlsLBT-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', [_c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.imgList,
            "highlight-current-row": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "prop": "index",
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "lbtfileName",
            "label": "名称",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "lbtpic2",
            "header-align": "center",
            "align": "center",
            "min-width": "200",
            "label": "图片"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('img', {
                staticClass: "tpimg",
                attrs: {
                  "slot": "reference",
                  "src": scope.row.lbtpic2,
                  "alt": scope.row.lbtpic2
                },
                slot: "reference"
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "px",
            "label": "排序",
            "min-width": "140"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var row = ref.row;
              var $index = ref.$index;

              return [(_vm.imgList[$index]) ? _c('el-input', {
                staticStyle: {
                  "width": "100px"
                },
                attrs: {
                  "type": "tel",
                  "onkeypress": "return( /[\\d]/.test(String.fromCharCode(event.keyCode) ) )"
                },
                on: {
                  "blur": function($event) {
                    return _vm.loseFcous($index, row)
                  }
                },
                nativeOn: {
                  "keyup": function($event) {
                    if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
                    return _vm.loseFcous($index, row)
                  }
                },
                model: {
                  value: (row.px),
                  callback: function($$v) {
                    _vm.$set(row, "px", $$v)
                  },
                  expression: "row.px"
                }
              }) : _vm._e(), _vm._v(" "), (!_vm.imgList[$index]) ? _c('span', [_vm._v(_vm._s(row.px))]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "lbtlink",
            "label": "超链接",
            "min-width": "250",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n               " + _vm._s(scope.row.lbtlink || '-') + "\n             ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handledel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片"
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.imageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.imageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "lbtfileName"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.lbtfileName),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "lbtfileName", $$v)
            },
            expression: "addForm.lbtfileName"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "超链接",
            "prop": "lbtlink"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.lbtlink),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "lbtlink", $$v)
            },
            expression: "addForm.lbtlink"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "排序",
            "prop": "px"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.px),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "px", $$v)
            },
            expression: "addForm.px"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addImgLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addImgSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片"
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.editImageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.editImageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "lbtfileName"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.lbtfileName),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "lbtfileName", $$v)
            },
            expression: "editForm.lbtfileName"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "超链接",
            "prop": "lbtlink"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.lbtlink),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "lbtlink", $$v)
            },
            expression: "editForm.lbtlink"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "排序",
            "prop": "px"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.px),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "px", $$v)
            },
            expression: "editForm.px"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editImgLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editImgSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-visit-form",
    attrs: {
      "width": "850px",
      "title": _vm.title,
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handerClose
    }
  }, [_c('el-row', {
    staticClass: "toolbar",
    attrs: {
      "gutter": 24
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访客户",
      "prop": "companyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": ""
    },
    model: {
      value: (_vm.ruleForm.companyName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "companyName", $$v)
      },
      expression: "ruleForm.companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理",
      "prop": "adminUser"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": "",
      "defaultVal": _vm.ruleForm.adminUser ? _vm.ruleForm.adminUser : undefined,
      "apiPath": "/tbAdminuser/manageList",
      "keys": {
        label: 'name',
        value: 'id'
      },
      "selectFirst": _vm.userInfo.type == '2',
      "params": {
        ComId: _vm.companyId
      }
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'adminUser'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": true,
      "disabled": "",
      "apiPath": "/tbCompany/getInfoById",
      "params": {
        type: 3,
        id: _vm.companyId
      },
      "keys": {
        label: 'successfulManagerName',
        value: 'successfulManager'
      },
      "defaultVal": _vm.ruleForm.successfulManager,
      "selectFirst": _vm.userInfo.type == '3'
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": true,
      "disabled": "",
      "apiPath": "/tbCompany/getInfoById",
      "params": {
        type: 4,
        id: _vm.companyId
      },
      "keys": {
        label: 'agencyManagerName',
        value: 'agencyManager'
      },
      "defaultVal": _vm.ruleForm.agencyManager,
      "selectFirst": _vm.userInfo.type == '4'
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访日期",
      "prop": "payVisitDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ruleForm.payVisitDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "payVisitDate", $$v)
      },
      expression: "ruleForm.payVisitDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "contactUser"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.contactUser),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contactUser", $$v)
      },
      expression: "ruleForm.contactUser"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式",
      "prop": "contactPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "oninput": "this.value=this.value.replace(/[^\\d]/g,'');"
    },
    model: {
      value: (_vm.ruleForm.contactPhone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contactPhone", $$v)
      },
      expression: "ruleForm.contactPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位",
      "prop": "position"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.position),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "position", $$v)
      },
      expression: "ruleForm.position"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访详情",
      "prop": "payVisitInfo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "3",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.payVisitInfo),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "payVisitInfo", $$v)
      },
      expression: "ruleForm.payVisitInfo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访方式：",
      "prop": "payVisitStatus"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "拜访状态"
    },
    model: {
      value: (_vm.ruleForm.payVisitStatus),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "payVisitStatus", $$v)
      },
      expression: "ruleForm.payVisitStatus"
    }
  }, _vm._l((_vm.visitStatusList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.ruleForm.payVisitStatus == 2 || _vm.ruleForm.payVisitStatus == 3) ? _c('el-form-item', {
    attrs: {
      "label": "现场照片",
      "prop": "pic"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    attrs: {
      "size": "small",
      "multiple": "",
      "accept": "image/png,image/jpg,image/jpeg,image/gif",
      "auto-upload": false,
      "action": "",
      "on-remove": _vm.handleRemove,
      "on-change": _vm.handerUploadChange,
      "file-list": _vm.fileList,
      "list-type": "picture-card"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DetailPage', {
    staticClass: "order-add-box",
    attrs: {
      "name": _vm.mode == 'save' ? '新增订单' : '编辑订单'
    },
    scopedSlots: _vm._u([{
      key: "detailMain",
      fn: function() {
        return [_c('div', {
          staticClass: "wrapper"
        }, [_c('header', {
          staticClass: "order-add-hd"
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户类型",
            "required": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          model: {
            value: (_vm.person),
            callback: function($$v) {
              _vm.person = $$v
            },
            expression: "person"
          }
        }, _vm._l((_vm.persons), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "选择用户",
            "required": ""
          }
        }, [(_vm.person == '2') ? _c('el-input', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "readonly": "readonly",
            "placeholder": "请选择",
            "clearable": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.handleUser(2)
            }
          },
          model: {
            value: (_vm.checkPerson),
            callback: function($$v) {
              _vm.checkPerson = $$v
            },
            expression: "checkPerson"
          }
        }) : _c('el-input', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "readonly": "readonly",
            "placeholder": "请选择",
            "clearable": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.handleUser(1)
            }
          },
          model: {
            value: (_vm.checkUser),
            callback: function($$v) {
              _vm.checkUser = $$v
            },
            expression: "checkUser"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "生效时间",
            "required": ""
          }
        }, [_c('el-date-picker', {
          staticStyle: {
            "width": "210px"
          },
          attrs: {
            "type": "date",
            "placeholder": "生效时间",
            "clearable": false
          },
          model: {
            value: (_vm.effectiveTime),
            callback: function($$v) {
              _vm.effectiveTime = $$v
            },
            expression: "effectiveTime"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "订单类型",
            "required": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "订单类型"
          },
          on: {
            "change": _vm.handerOrderType
          },
          model: {
            value: (_vm.orderType),
            callback: function($$v) {
              _vm.orderType = $$v
            },
            expression: "orderType"
          }
        }, _vm._l((_vm.orderTypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('section', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticClass: "order-add-bd"
        }, [_c('div', {
          staticClass: "product-list"
        }, [_c('h4', {
          staticClass: "list-hd title"
        }, [_vm._v("选择产品")]), _vm._v(" "), _c('ul', {
          staticClass: "list-bd fit-w"
        }, _vm._l((_vm.proList), function(item) {
          return _c('li', {
            key: item.id,
            staticClass: "list-item",
            class: {
              active: _vm.selectProList.findIndex(function (data) { return data.id == item.id; }) > -1
            },
            on: {
              "click": function($event) {
                return _vm.handerProduct(item)
              }
            }
          }, [_c('span', {
            staticClass: "dnnfont iconaccomplish-filled"
          }), _vm._v(" "), _c('img', {
            staticClass: "proLogo",
            attrs: {
              "src": item.logo,
              "alt": ""
            }
          }), _vm._v(" "), _c('h4', {
            staticClass: "proName"
          }, [_vm._v(_vm._s(item.name))])])
        }), 0)]), _vm._v(" "), _c('div', {
          staticClass: "product-list-selected"
        }, [_c('h4', {
          staticClass: "title"
        }, [_vm._v("订单清单")]), _vm._v(" "), _c('article', {
          staticClass: "fit-w list-selected-info"
        }, [_c('header', {
          staticClass: "tab-hd"
        }, [_vm._v("已选择" + _vm._s(_vm.selectProList.length) + "个产品")]), _vm._v(" "), _c('SelectedProduct', {
          attrs: {
            "productLists": _vm.selectProList,
            "isEdit": true
          },
          on: {
            "del": function (data) { return _vm.handerProduct(data); }
          }
        })], 1)])])]), _vm._v(" "), _c('footer', {
          staticClass: "order-add-ft",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          staticClass: "order-evaluate",
          staticStyle: {
            "color": "#EB6264"
          },
          attrs: {
            "label": "预估价格:"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.evaluatePrice) + " 元\n          ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          staticClass: "order-total",
          attrs: {
            "label": "订单总价:"
          }
        }, [_c('el-input', {
          staticClass: "price",
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "disabled": _vm.isOrderTest,
            "oninput": "this.value=this.value.replace(/[^\\d]/g,'');"
          },
          model: {
            value: (_vm.totalPrice),
            callback: function($$v) {
              _vm.totalPrice = $$v
            },
            expression: "totalPrice"
          }
        }, [_c('template', {
          slot: "append"
        }, [_vm._v("元")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
          staticClass: "ft-submit",
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', [_c('el-button', {
          staticClass: "gradual",
          attrs: {
            "type": "primary",
            "loading": _vm.orderSubLoading,
            "disabled": _vm.selectProList.length == 0
          },
          on: {
            "click": _vm.orderSubmit
          }
        }, [_vm._v("提交订单")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "订单账户",
            "visible": _vm.orderVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.orderVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs2
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "账号 / 姓名",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.dialogLoading),
            expression: "dialogLoading"
          }],
          ref: "users",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.users,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "row-click": _vm.handleSelectionChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-checkbox', {
                model: {
                  value: (scope.row.checked),
                  callback: function($$v) {
                    _vm.$set(scope.row, "checked", $$v)
                  },
                  expression: "scope.row.checked"
                }
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "130",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding": "10px 0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": " prev, pager, next",
            "current-page": _vm.pageNumber2,
            "page-size": _vm.pageSize2,
            "total": _vm.total2
          },
          on: {
            "current-change": _vm.handleCurrentChange2
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.orderVisible = false, _vm.searchText = ''
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.orderLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.orderUserSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "订单账户",
            "visible": _vm.personVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.personVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs3
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "企业名称",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getPerson(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getPerson(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.dialogLoading),
            expression: "dialogLoading"
          }],
          ref: "personList",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.personList,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "row-click": _vm.handleSelectionChange3
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-checkbox', {
                on: {
                  "change": _vm.changeFun3
                },
                model: {
                  value: (scope.row.checked),
                  callback: function($$v) {
                    _vm.$set(scope.row, "checked", $$v)
                  },
                  expression: "scope.row.checked"
                }
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "managername",
            "label": "公司管理员",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "min-width": "180",
            "show-overflow-tooltip": ""
          }
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding": "10px 0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": " prev, pager, next",
            "current-page": _vm.pageNumber3,
            "page-size": _vm.pageSize3,
            "total": _vm.total3
          },
          on: {
            "current-change": _vm.handleCurrentChange3
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.personVisible = false, _vm.searchText = ''
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.orderLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.orderPersonSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("确定")])], 1)], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.adminVisible) ? _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "相关订单",
      "width": "950px",
      "visible": _vm.adminVisible,
      "close-on-click-modal": false,
      "before-close": _vm.adminVisibleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.adminVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userLoading),
      expression: "userLoading"
    }],
    ref: "userList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row-key": function (row) { return row.id; },
      "data": _vm.adminList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseMonth",
      "label": "购买时长(月)",
      "min-width": "100",
      "xshow-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseNum",
      "label": "购买数量",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "singlePrice",
      "label": "单价(元)",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticStyle: {
      "min-width": "1023px"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch),
      expression: "disSouch"
    }],
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList(1)
      }
    },
    model: {
      value: (_vm.proName),
      callback: function($$v) {
        _vm.proName = $$v
      },
      expression: "proName"
    }
  }), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disType),
      expression: "disType"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.typeValue),
      callback: function($$v) {
        _vm.typeValue = $$v
      },
      expression: "typeValue"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disAccountType),
      expression: "disAccountType"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.accountType),
      callback: function($$v) {
        _vm.accountType = $$v
      },
      expression: "accountType"
    }
  }, _vm._l((_vm.accountTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disTime1),
      expression: "disTime1"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "申请日期"
    },
    model: {
      value: (_vm.souchs.application_time),
      callback: function($$v) {
        _vm.$set(_vm.souchs, "application_time", $$v)
      },
      expression: "souchs.application_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.getList(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.exportExlsx()
      }
    }
  }, [_vm._v("批量导出")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v(" \n          " + _vm._s(tag) + " \n      ")])
  }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "手机号",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "姓名",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "org_name",
      "label": "企业",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activity_name",
      "label": "兑换礼品",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "exchange_count",
      "label": "兑换数量",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "application_time",
      "min-width": "120",
      "label": "申请日期",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row, 1)
            }
          }
        }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "plain": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row, 2)
            }
          }
        }, [_vm._v("驳回申请")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', [_vm._v("已通过")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticStyle: {
            "color": "#F66B3D"
          }
        }, [_vm._v("已驳回申请")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "border": "1px solid #dfe6ec",
      "margin-top": "0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('div', {
    staticClass: "ft"
  }, [_c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])])
}]}

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "detailPage"
  }, [_c('header', {
    staticClass: "detaiHead"
  }, [_c('span', {
    staticClass: "back",
    on: {
      "click": _vm.backRoute_
    }
  }, [_c('i', {
    staticClass: "dnnfont iconangleleft",
    staticStyle: {
      "position": "relative",
      "margin-right": "8px"
    }
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.getName))]), _vm._v(" "), _c('span', {
    staticClass: "type"
  }, [_vm._t("type")], 2), _vm._v(" "), _c('span', {
    staticClass: "rightQuery"
  }, [_vm._t("right")], 2)]), _vm._v(" "), _c('main', {
    staticClass: "detailMain"
  }, [_vm._t("detailMain")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isRouterAlive) ? _c('router-view') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("系统设置")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v("硬件绑定")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle-switch"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-switch', {
    on: {
      "change": _vm.submit
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("是否启用硬件绑定")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-order-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "用户名",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList()
            }
          },
          model: {
            value: (_vm.userName),
            callback: function($$v) {
              _vm.userName = $$v
            },
            expression: "userName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "userName",
            "label": "用户名",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userId ? scope.row.userName : "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "150",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.company || "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "membershipName",
            "label": "角色",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.membershipName ? scope.row.membershipName : "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "straightCurveFiles",
            "label": "直曲线PDF",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(
                scope.row.straightCurveFiles &&
                scope.row.straightCurveFiles.length > 0
              ) ? _c('div', {
                staticClass: "table-column-box"
              }, [_c('span', {
                staticClass: "table-column-text"
              }, [_vm._v(_vm._s(scope.row.straightCurveFiles[0].fileTitle))]), _vm._v(" "), (scope.row.straightCurveFiles.length > 1) ? [_c('el-popover', {
                attrs: {
                  "placement": "top-start",
                  "width": "200",
                  "trigger": "click"
                }
              }, [_vm._l((scope.row.straightCurveFiles), function(item) {
                return _c('div', {
                  key: item.id,
                  staticClass: "popover-item"
                }, [_c('i', {
                  staticClass: "dnnfont iconnormal"
                }), _vm._v(" "), _c('span', {
                  staticClass: "popover-item-text"
                }, [_vm._v(_vm._s(item.fileTitle))])])
              }), _vm._v(" "), _c('i', {
                staticClass: "dnnfont iconfolder-filled table-column-popover-icon",
                attrs: {
                  "slot": "reference"
                },
                slot: "reference"
              })], 2)] : _vm._e()], 2) : _c('span', [_vm._v("-")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "verticalCurveFiles",
            "label": "竖曲线PDF",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(
                scope.row.verticalCurveFiles &&
                scope.row.verticalCurveFiles.length > 0
              ) ? _c('div', {
                staticClass: "table-column-box"
              }, [_c('span', {
                staticClass: "table-column-text"
              }, [_vm._v("\n              " + _vm._s(scope.row.verticalCurveFiles[0].fileTitle) + "\n            ")]), _vm._v(" "), (scope.row.verticalCurveFiles.length > 1) ? [_c('el-popover', {
                attrs: {
                  "placement": "top-start",
                  "width": "200",
                  "trigger": "click"
                }
              }, [_vm._l((scope.row.verticalCurveFiles), function(item) {
                return _c('div', {
                  key: item.id,
                  staticClass: "popover-item"
                }, [_c('i', {
                  staticClass: "dnnfont iconnormal"
                }), _vm._v(" "), _c('span', {
                  staticClass: "popover-item-text"
                }, [_vm._v(_vm._s(item.fileTitle))])])
              }), _vm._v(" "), _c('i', {
                staticClass: "dnnfont iconfolder-filled table-column-popover-icon",
                attrs: {
                  "slot": "reference"
                },
                slot: "reference"
              })], 2)] : _vm._e()], 2) : _c('span', [_vm._v("-")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "alignmentDiagramFiles",
            "label": "线位图",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(
                scope.row.alignmentDiagramFiles &&
                scope.row.alignmentDiagramFiles.length > 0
              ) ? _c('div', {
                staticClass: "table-column-box"
              }, [_c('span', {
                staticClass: "table-column-text"
              }, [_vm._v("\n              " + _vm._s(scope.row.alignmentDiagramFiles[0].fileTitle) + "\n            ")]), _vm._v(" "), (scope.row.alignmentDiagramFiles.length > 1) ? [_c('el-popover', {
                attrs: {
                  "placement": "top-start",
                  "width": "200",
                  "trigger": "click"
                }
              }, [_vm._l((scope.row.alignmentDiagramFiles), function(item) {
                return _c('div', {
                  key: item.id,
                  staticClass: "popover-item"
                }, [_c('i', {
                  staticClass: "dnnfont iconnormal"
                }), _vm._v(" "), _c('span', {
                  staticClass: "popover-item-text"
                }, [_vm._v(_vm._s(item.fileTitle))])])
              }), _vm._v(" "), _c('i', {
                staticClass: "dnnfont iconfolder-filled table-column-popover-icon",
                attrs: {
                  "slot": "reference"
                },
                slot: "reference"
              })], 2)] : _vm._e()], 2) : _c('span', [_vm._v("-")])]
            }
          }])
        }), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "prop": "jdFiles",
            "label": "转换JD文件",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.jdFiles && scope.row.jdFiles.length > 0) ? _c('div', {
                staticClass: "table-column-box"
              }, [_c('span', {
                staticClass: "table-column-text"
              }, [_vm._v("\n              " + _vm._s(scope.row.jdFiles[0].fileTitle) + "\n            ")]), _vm._v(" "), (scope.row.jdFiles.length > 1) ? [_c('el-popover', {
                attrs: {
                  "placement": "top-start",
                  "width": "200",
                  "trigger": "click"
                }
              }, [_vm._l((scope.row.jdFiles), function(item) {
                return _c('div', {
                  key: item.id,
                  staticClass: "popover-item"
                }, [_c('i', {
                  staticClass: "dnnfont iconnormal"
                }), _vm._v(" "), _c('span', {
                  staticClass: "popover-item-text"
                }, [_vm._v(_vm._s(item.fileTitle))])])
              }), _vm._v(" "), _c('i', {
                staticClass: "dnnfont iconfolder-filled table-column-popover-icon",
                attrs: {
                  "slot": "reference"
                },
                slot: "reference"
              })], 2)] : _vm._e()], 2) : _c('span', [_vm._v("-")])]
            }
          }], null, false, 4161050950)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "prop": "sqxFiles",
            "label": "转换SQX文件",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.sqxFiles && scope.row.sqxFiles.length > 0) ? _c('div', {
                staticClass: "table-column-box"
              }, [_c('span', {
                staticClass: "table-column-text"
              }, [_vm._v("\n              " + _vm._s(scope.row.sqxFiles[0].fileTitle) + "\n            ")]), _vm._v(" "), (scope.row.sqxFiles.length > 1) ? [_c('el-popover', {
                attrs: {
                  "placement": "top-start",
                  "width": "200",
                  "trigger": "click"
                }
              }, [_vm._l((scope.row.sqxFiles), function(item) {
                return _c('div', {
                  key: item.id,
                  staticClass: "popover-item"
                }, [_c('i', {
                  staticClass: "dnnfont iconnormal"
                }), _vm._v(" "), _c('span', {
                  staticClass: "popover-item-text"
                }, [_vm._v(_vm._s(item.fileTitle))])])
              }), _vm._v(" "), _c('i', {
                staticClass: "dnnfont iconfolder-filled table-column-popover-icon",
                attrs: {
                  "slot": "reference"
                },
                slot: "reference"
              })], 2)] : _vm._e()], 2) : _c('span', [_vm._v("-")])]
            }
          }], null, false, 6181746)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "prop": "icdFiles",
            "label": "转换ICD文件",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.icdFiles && scope.row.icdFiles.length > 0) ? _c('div', {
                staticClass: "table-column-box"
              }, [_c('span', {
                staticClass: "table-column-text"
              }, [_vm._v("\n              " + _vm._s(scope.row.icdFiles[0].fileTitle) + "\n            ")]), _vm._v(" "), (scope.row.icdFiles.length > 1) ? [_c('el-popover', {
                attrs: {
                  "placement": "top-start",
                  "width": "200",
                  "trigger": "click"
                }
              }, [_vm._l((scope.row.icdFiles), function(item) {
                return _c('div', {
                  key: item.id,
                  staticClass: "popover-item"
                }, [_c('i', {
                  staticClass: "dnnfont iconnormal"
                }), _vm._v(" "), _c('span', {
                  staticClass: "popover-item-text"
                }, [_vm._v(_vm._s(item.fileTitle))])])
              }), _vm._v(" "), _c('i', {
                staticClass: "dnnfont iconfolder-filled table-column-popover-icon",
                attrs: {
                  "slot": "reference"
                },
                slot: "reference"
              })], 2)] : _vm._e()], 2) : _c('span', [_vm._v("-")])]
            }
          }], null, false, 1383041574)
        }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "createTime",
            "label": "创建时间",
            "min-width": "170",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" " + _vm._s(_vm.dateTran(scope.row.createTime)) + " ")])]
            }
          }])
        }), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "label": "操作",
            "min-width": "50",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('a', {
                attrs: {
                  "href": "#"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.download(scope.row)
                  }
                }
              }, [_vm._v("下载")])]
            }
          }], null, false, 627196038)
        }) : _vm._e()], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "stand"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("注册用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm._f("numberSlice")(_vm.requestData.userCount)) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("企业数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.companyCount) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("企业用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.companyNumByUser) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("上线软件个数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.productCount) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("日活用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number active",
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.userCountByDay) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("月活用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.userCountByMonth) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("季活用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.userCountByQuarter) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("用户总积分数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm._f("numberSlice")(_vm.requestData.userPointCount)) + "\n          ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "charts"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.pointByHour
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading4),
      expression: "loading4"
    }],
    attrs: {
      "id": "charts-box",
      "element-loading-text": "加载中"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.dayVisit
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading5),
      expression: "loading5"
    }],
    attrs: {
      "id": "charts-box-two",
      "element-loading-text": "加载中"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "year",
      "value-format": "yyyy",
      "placeholder": "请选择",
      "picker-options": _vm.yearPickerOptions
    },
    on: {
      "change": _vm.MonthVisit
    },
    model: {
      value: (_vm.visitByMonth_Year),
      callback: function($$v) {
        _vm.visitByMonth_Year = $$v
      },
      expression: "visitByMonth_Year"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading6),
      expression: "loading6"
    }],
    attrs: {
      "id": "charts-box-Three",
      "element-loading-text": "加载中"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "year",
      "value-format": "yyyy",
      "placeholder": "请选择",
      "picker-options": _vm.yearPickerOptions
    },
    on: {
      "change": _vm.QuarterVisit
    },
    model: {
      value: (_vm.visitByQuarter_Year),
      callback: function($$v) {
        _vm.visitByQuarter_Year = $$v
      },
      expression: "visitByQuarter_Year"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading7),
      expression: "loading7"
    }],
    attrs: {
      "id": "charts-box-Four",
      "element-loading-text": "加载中"
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "charts-copy",
    staticStyle: {
      "height": "510px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-copy"
    }
  }, [_c('LeftCharts')], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-two-copy"
    }
  }, [_c('RightCharts')], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "charts",
    staticStyle: {
      "height": "400px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Census', {
    attrs: {
      "userGuishuPie": _vm.userGuishuPie
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('CensusBar', {
    attrs: {
      "userGuishuBar": _vm.userGuishuBar
    }
  })], 1)], 1)], 1)]), _vm._v(" "), (_vm.dialogVisible) ? _c('ActiveModal', {
    attrs: {
      "dialogVisible": _vm.dialogVisible
    },
    on: {
      "update:dialogVisible": function($event) {
        _vm.dialogVisible = $event
      },
      "update:dialog-visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DetailPage', {
    attrs: {
      "name": _vm.modulename,
      "loading": _vm.loading,
      "backRoute": "moduleIntegral",
      "param": _vm.params
    }
  }, [_c('template', {
    slot: "detailMain"
  }, [_c('span', {
    staticClass: "searchName"
  }, [_vm._v("自定义时间段:")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "kuang",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "daterange",
      "clearable": false,
      "size": "large",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changeData
    },
    model: {
      value: (_vm.tiemSlot),
      callback: function($$v) {
        _vm.tiemSlot = $$v
      },
      expression: "tiemSlot"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#2196F3"
    },
    attrs: {
      "type": "text"
    }
  }, [_c('a', {
    on: {
      "click": _vm.downFile
    }
  }, [_vm._v("导出")])]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("共" + _vm._s(_vm.count) + "人使用")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": "545px",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "用户名",
      "width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "companyname",
      "label": "企业",
      "min-width": "230",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "allpoint",
      "label": "产生积分",
      "width": "130",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#669DF0"
          }
        }, [_vm._v(_vm._s(scope.row.allpoint))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "操作",
      "width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "dnnfont iconfile-search",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.detailUser(scope.$index, scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes,prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "page-size": _vm.pageSize,
      "current-page": _vm.pageNumber,
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.pageNumber = $event
      },
      "update:current-page": function($event) {
        _vm.pageNumber = $event
      },
      "current-change": _vm.changeData
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.personalPointsVisible,
      "width": "800px",
      "title": _vm.personalPointsDialogTitle
    },
    on: {
      "update:visible": function($event) {
        _vm.personalPointsVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "personalPointsBox"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.personalPointsList,
      "height": "500px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "cmdName",
      "label": "命令名称",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cmdId",
      "label": "命令ID",
      "width": "200",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "allpoint",
      "label": "积分",
      "width": "200",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialogFooter"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "sizes,prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "page-size": _vm.personalPointsListParams.pageSize,
      "current-page": _vm.personalPointsListParams.pageNumber,
      "total": _vm.personalPointsTotal
    },
    on: {
      "size-change": _vm.handleSizeChangePP,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.personalPointsListParams, "pageNumber", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.personalPointsListParams, "pageNumber", $event)
      },
      "current-change": _vm.changeDataPP
    }
  })], 1)], 1)])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */
/***/ (function(module, exports) {

module.exports = [{"code":"110101","name":"东城区","cityCode":"1101","provinceCode":"11"},{"code":"110102","name":"西城区","cityCode":"1101","provinceCode":"11"},{"code":"110105","name":"朝阳区","cityCode":"1101","provinceCode":"11"},{"code":"110106","name":"丰台区","cityCode":"1101","provinceCode":"11"},{"code":"110107","name":"石景山区","cityCode":"1101","provinceCode":"11"},{"code":"110108","name":"海淀区","cityCode":"1101","provinceCode":"11"},{"code":"110109","name":"门头沟区","cityCode":"1101","provinceCode":"11"},{"code":"110111","name":"房山区","cityCode":"1101","provinceCode":"11"},{"code":"110112","name":"通州区","cityCode":"1101","provinceCode":"11"},{"code":"110113","name":"顺义区","cityCode":"1101","provinceCode":"11"},{"code":"110114","name":"昌平区","cityCode":"1101","provinceCode":"11"},{"code":"110115","name":"大兴区","cityCode":"1101","provinceCode":"11"},{"code":"110116","name":"怀柔区","cityCode":"1101","provinceCode":"11"},{"code":"110117","name":"平谷区","cityCode":"1101","provinceCode":"11"},{"code":"110118","name":"密云区","cityCode":"1101","provinceCode":"11"},{"code":"110119","name":"延庆区","cityCode":"1101","provinceCode":"11"},{"code":"120101","name":"和平区","cityCode":"1201","provinceCode":"12"},{"code":"120102","name":"河东区","cityCode":"1201","provinceCode":"12"},{"code":"120103","name":"河西区","cityCode":"1201","provinceCode":"12"},{"code":"120104","name":"南开区","cityCode":"1201","provinceCode":"12"},{"code":"120105","name":"河北区","cityCode":"1201","provinceCode":"12"},{"code":"120106","name":"红桥区","cityCode":"1201","provinceCode":"12"},{"code":"120110","name":"东丽区","cityCode":"1201","provinceCode":"12"},{"code":"120111","name":"西青区","cityCode":"1201","provinceCode":"12"},{"code":"120112","name":"津南区","cityCode":"1201","provinceCode":"12"},{"code":"120113","name":"北辰区","cityCode":"1201","provinceCode":"12"},{"code":"120114","name":"武清区","cityCode":"1201","provinceCode":"12"},{"code":"120115","name":"宝坻区","cityCode":"1201","provinceCode":"12"},{"code":"120116","name":"滨海新区","cityCode":"1201","provinceCode":"12"},{"code":"120117","name":"宁河区","cityCode":"1201","provinceCode":"12"},{"code":"120118","name":"静海区","cityCode":"1201","provinceCode":"12"},{"code":"120119","name":"蓟州区","cityCode":"1201","provinceCode":"12"},{"code":"130102","name":"长安区","cityCode":"1301","provinceCode":"13"},{"code":"130104","name":"桥西区","cityCode":"1301","provinceCode":"13"},{"code":"130105","name":"新华区","cityCode":"1301","provinceCode":"13"},{"code":"130107","name":"井陉矿区","cityCode":"1301","provinceCode":"13"},{"code":"130108","name":"裕华区","cityCode":"1301","provinceCode":"13"},{"code":"130109","name":"藁城区","cityCode":"1301","provinceCode":"13"},{"code":"130110","name":"鹿泉区","cityCode":"1301","provinceCode":"13"},{"code":"130111","name":"栾城区","cityCode":"1301","provinceCode":"13"},{"code":"130121","name":"井陉县","cityCode":"1301","provinceCode":"13"},{"code":"130123","name":"正定县","cityCode":"1301","provinceCode":"13"},{"code":"130125","name":"行唐县","cityCode":"1301","provinceCode":"13"},{"code":"130126","name":"灵寿县","cityCode":"1301","provinceCode":"13"},{"code":"130127","name":"高邑县","cityCode":"1301","provinceCode":"13"},{"code":"130128","name":"深泽县","cityCode":"1301","provinceCode":"13"},{"code":"130129","name":"赞皇县","cityCode":"1301","provinceCode":"13"},{"code":"130130","name":"无极县","cityCode":"1301","provinceCode":"13"},{"code":"130131","name":"平山县","cityCode":"1301","provinceCode":"13"},{"code":"130132","name":"元氏县","cityCode":"1301","provinceCode":"13"},{"code":"130133","name":"赵县","cityCode":"1301","provinceCode":"13"},{"code":"130171","name":"石家庄高新技术产业开发区","cityCode":"1301","provinceCode":"13"},{"code":"130172","name":"石家庄循环化工园区","cityCode":"1301","provinceCode":"13"},{"code":"130181","name":"辛集市","cityCode":"1301","provinceCode":"13"},{"code":"130183","name":"晋州市","cityCode":"1301","provinceCode":"13"},{"code":"130184","name":"新乐市","cityCode":"1301","provinceCode":"13"},{"code":"130202","name":"路南区","cityCode":"1302","provinceCode":"13"},{"code":"130203","name":"路北区","cityCode":"1302","provinceCode":"13"},{"code":"130204","name":"古冶区","cityCode":"1302","provinceCode":"13"},{"code":"130205","name":"开平区","cityCode":"1302","provinceCode":"13"},{"code":"130207","name":"丰南区","cityCode":"1302","provinceCode":"13"},{"code":"130208","name":"丰润区","cityCode":"1302","provinceCode":"13"},{"code":"130209","name":"曹妃甸区","cityCode":"1302","provinceCode":"13"},{"code":"130224","name":"滦南县","cityCode":"1302","provinceCode":"13"},{"code":"130225","name":"乐亭县","cityCode":"1302","provinceCode":"13"},{"code":"130227","name":"迁西县","cityCode":"1302","provinceCode":"13"},{"code":"130229","name":"玉田县","cityCode":"1302","provinceCode":"13"},{"code":"130271","name":"河北唐山芦台经济开发区","cityCode":"1302","provinceCode":"13"},{"code":"130272","name":"唐山市汉沽管理区","cityCode":"1302","provinceCode":"13"},{"code":"130273","name":"唐山高新技术产业开发区","cityCode":"1302","provinceCode":"13"},{"code":"130274","name":"河北唐山海港经济开发区","cityCode":"1302","provinceCode":"13"},{"code":"130281","name":"遵化市","cityCode":"1302","provinceCode":"13"},{"code":"130283","name":"迁安市","cityCode":"1302","provinceCode":"13"},{"code":"130284","name":"滦州市","cityCode":"1302","provinceCode":"13"},{"code":"130302","name":"海港区","cityCode":"1303","provinceCode":"13"},{"code":"130303","name":"山海关区","cityCode":"1303","provinceCode":"13"},{"code":"130304","name":"北戴河区","cityCode":"1303","provinceCode":"13"},{"code":"130306","name":"抚宁区","cityCode":"1303","provinceCode":"13"},{"code":"130321","name":"青龙满族自治县","cityCode":"1303","provinceCode":"13"},{"code":"130322","name":"昌黎县","cityCode":"1303","provinceCode":"13"},{"code":"130324","name":"卢龙县","cityCode":"1303","provinceCode":"13"},{"code":"130371","name":"秦皇岛市经济技术开发区","cityCode":"1303","provinceCode":"13"},{"code":"130372","name":"北戴河新区","cityCode":"1303","provinceCode":"13"},{"code":"130402","name":"邯山区","cityCode":"1304","provinceCode":"13"},{"code":"130403","name":"丛台区","cityCode":"1304","provinceCode":"13"},{"code":"130404","name":"复兴区","cityCode":"1304","provinceCode":"13"},{"code":"130406","name":"峰峰矿区","cityCode":"1304","provinceCode":"13"},{"code":"130407","name":"肥乡区","cityCode":"1304","provinceCode":"13"},{"code":"130408","name":"永年区","cityCode":"1304","provinceCode":"13"},{"code":"130423","name":"临漳县","cityCode":"1304","provinceCode":"13"},{"code":"130424","name":"成安县","cityCode":"1304","provinceCode":"13"},{"code":"130425","name":"大名县","cityCode":"1304","provinceCode":"13"},{"code":"130426","name":"涉县","cityCode":"1304","provinceCode":"13"},{"code":"130427","name":"磁县","cityCode":"1304","provinceCode":"13"},{"code":"130430","name":"邱县","cityCode":"1304","provinceCode":"13"},{"code":"130431","name":"鸡泽县","cityCode":"1304","provinceCode":"13"},{"code":"130432","name":"广平县","cityCode":"1304","provinceCode":"13"},{"code":"130433","name":"馆陶县","cityCode":"1304","provinceCode":"13"},{"code":"130434","name":"魏县","cityCode":"1304","provinceCode":"13"},{"code":"130435","name":"曲周县","cityCode":"1304","provinceCode":"13"},{"code":"130471","name":"邯郸经济技术开发区","cityCode":"1304","provinceCode":"13"},{"code":"130473","name":"邯郸冀南新区","cityCode":"1304","provinceCode":"13"},{"code":"130481","name":"武安市","cityCode":"1304","provinceCode":"13"},{"code":"130502","name":"襄都区","cityCode":"1305","provinceCode":"13"},{"code":"130503","name":"信都区","cityCode":"1305","provinceCode":"13"},{"code":"130505","name":"任泽区","cityCode":"1305","provinceCode":"13"},{"code":"130506","name":"南和区","cityCode":"1305","provinceCode":"13"},{"code":"130522","name":"临城县","cityCode":"1305","provinceCode":"13"},{"code":"130523","name":"内丘县","cityCode":"1305","provinceCode":"13"},{"code":"130524","name":"柏乡县","cityCode":"1305","provinceCode":"13"},{"code":"130525","name":"隆尧县","cityCode":"1305","provinceCode":"13"},{"code":"130528","name":"宁晋县","cityCode":"1305","provinceCode":"13"},{"code":"130529","name":"巨鹿县","cityCode":"1305","provinceCode":"13"},{"code":"130530","name":"新河县","cityCode":"1305","provinceCode":"13"},{"code":"130531","name":"广宗县","cityCode":"1305","provinceCode":"13"},{"code":"130532","name":"平乡县","cityCode":"1305","provinceCode":"13"},{"code":"130533","name":"威县","cityCode":"1305","provinceCode":"13"},{"code":"130534","name":"清河县","cityCode":"1305","provinceCode":"13"},{"code":"130535","name":"临西县","cityCode":"1305","provinceCode":"13"},{"code":"130571","name":"河北邢台经济开发区","cityCode":"1305","provinceCode":"13"},{"code":"130581","name":"南宫市","cityCode":"1305","provinceCode":"13"},{"code":"130582","name":"沙河市","cityCode":"1305","provinceCode":"13"},{"code":"130602","name":"竞秀区","cityCode":"1306","provinceCode":"13"},{"code":"130606","name":"莲池区","cityCode":"1306","provinceCode":"13"},{"code":"130607","name":"满城区","cityCode":"1306","provinceCode":"13"},{"code":"130608","name":"清苑区","cityCode":"1306","provinceCode":"13"},{"code":"130609","name":"徐水区","cityCode":"1306","provinceCode":"13"},{"code":"130623","name":"涞水县","cityCode":"1306","provinceCode":"13"},{"code":"130624","name":"阜平县","cityCode":"1306","provinceCode":"13"},{"code":"130626","name":"定兴县","cityCode":"1306","provinceCode":"13"},{"code":"130627","name":"唐县","cityCode":"1306","provinceCode":"13"},{"code":"130628","name":"高阳县","cityCode":"1306","provinceCode":"13"},{"code":"130629","name":"容城县","cityCode":"1306","provinceCode":"13"},{"code":"130630","name":"涞源县","cityCode":"1306","provinceCode":"13"},{"code":"130631","name":"望都县","cityCode":"1306","provinceCode":"13"},{"code":"130632","name":"安新县","cityCode":"1306","provinceCode":"13"},{"code":"130633","name":"易县","cityCode":"1306","provinceCode":"13"},{"code":"130634","name":"曲阳县","cityCode":"1306","provinceCode":"13"},{"code":"130635","name":"蠡县","cityCode":"1306","provinceCode":"13"},{"code":"130636","name":"顺平县","cityCode":"1306","provinceCode":"13"},{"code":"130637","name":"博野县","cityCode":"1306","provinceCode":"13"},{"code":"130638","name":"雄县","cityCode":"1306","provinceCode":"13"},{"code":"130671","name":"保定高新技术产业开发区","cityCode":"1306","provinceCode":"13"},{"code":"130672","name":"保定白沟新城","cityCode":"1306","provinceCode":"13"},{"code":"130681","name":"涿州市","cityCode":"1306","provinceCode":"13"},{"code":"130682","name":"定州市","cityCode":"1306","provinceCode":"13"},{"code":"130683","name":"安国市","cityCode":"1306","provinceCode":"13"},{"code":"130684","name":"高碑店市","cityCode":"1306","provinceCode":"13"},{"code":"130702","name":"桥东区","cityCode":"1307","provinceCode":"13"},{"code":"130703","name":"桥西区","cityCode":"1307","provinceCode":"13"},{"code":"130705","name":"宣化区","cityCode":"1307","provinceCode":"13"},{"code":"130706","name":"下花园区","cityCode":"1307","provinceCode":"13"},{"code":"130708","name":"万全区","cityCode":"1307","provinceCode":"13"},{"code":"130709","name":"崇礼区","cityCode":"1307","provinceCode":"13"},{"code":"130722","name":"张北县","cityCode":"1307","provinceCode":"13"},{"code":"130723","name":"康保县","cityCode":"1307","provinceCode":"13"},{"code":"130724","name":"沽源县","cityCode":"1307","provinceCode":"13"},{"code":"130725","name":"尚义县","cityCode":"1307","provinceCode":"13"},{"code":"130726","name":"蔚县","cityCode":"1307","provinceCode":"13"},{"code":"130727","name":"阳原县","cityCode":"1307","provinceCode":"13"},{"code":"130728","name":"怀安县","cityCode":"1307","provinceCode":"13"},{"code":"130730","name":"怀来县","cityCode":"1307","provinceCode":"13"},{"code":"130731","name":"涿鹿县","cityCode":"1307","provinceCode":"13"},{"code":"130732","name":"赤城县","cityCode":"1307","provinceCode":"13"},{"code":"130771","name":"张家口经济开发区","cityCode":"1307","provinceCode":"13"},{"code":"130772","name":"张家口市察北管理区","cityCode":"1307","provinceCode":"13"},{"code":"130773","name":"张家口市塞北管理区","cityCode":"1307","provinceCode":"13"},{"code":"130802","name":"双桥区","cityCode":"1308","provinceCode":"13"},{"code":"130803","name":"双滦区","cityCode":"1308","provinceCode":"13"},{"code":"130804","name":"鹰手营子矿区","cityCode":"1308","provinceCode":"13"},{"code":"130821","name":"承德县","cityCode":"1308","provinceCode":"13"},{"code":"130822","name":"兴隆县","cityCode":"1308","provinceCode":"13"},{"code":"130824","name":"滦平县","cityCode":"1308","provinceCode":"13"},{"code":"130825","name":"隆化县","cityCode":"1308","provinceCode":"13"},{"code":"130826","name":"丰宁满族自治县","cityCode":"1308","provinceCode":"13"},{"code":"130827","name":"宽城满族自治县","cityCode":"1308","provinceCode":"13"},{"code":"130828","name":"围场满族蒙古族自治县","cityCode":"1308","provinceCode":"13"},{"code":"130871","name":"承德高新技术产业开发区","cityCode":"1308","provinceCode":"13"},{"code":"130881","name":"平泉市","cityCode":"1308","provinceCode":"13"},{"code":"130902","name":"新华区","cityCode":"1309","provinceCode":"13"},{"code":"130903","name":"运河区","cityCode":"1309","provinceCode":"13"},{"code":"130921","name":"沧县","cityCode":"1309","provinceCode":"13"},{"code":"130922","name":"青县","cityCode":"1309","provinceCode":"13"},{"code":"130923","name":"东光县","cityCode":"1309","provinceCode":"13"},{"code":"130924","name":"海兴县","cityCode":"1309","provinceCode":"13"},{"code":"130925","name":"盐山县","cityCode":"1309","provinceCode":"13"},{"code":"130926","name":"肃宁县","cityCode":"1309","provinceCode":"13"},{"code":"130927","name":"南皮县","cityCode":"1309","provinceCode":"13"},{"code":"130928","name":"吴桥县","cityCode":"1309","provinceCode":"13"},{"code":"130929","name":"献县","cityCode":"1309","provinceCode":"13"},{"code":"130930","name":"孟村回族自治县","cityCode":"1309","provinceCode":"13"},{"code":"130971","name":"河北沧州经济开发区","cityCode":"1309","provinceCode":"13"},{"code":"130972","name":"沧州高新技术产业开发区","cityCode":"1309","provinceCode":"13"},{"code":"130973","name":"沧州渤海新区","cityCode":"1309","provinceCode":"13"},{"code":"130981","name":"泊头市","cityCode":"1309","provinceCode":"13"},{"code":"130982","name":"任丘市","cityCode":"1309","provinceCode":"13"},{"code":"130983","name":"黄骅市","cityCode":"1309","provinceCode":"13"},{"code":"130984","name":"河间市","cityCode":"1309","provinceCode":"13"},{"code":"131002","name":"安次区","cityCode":"1310","provinceCode":"13"},{"code":"131003","name":"广阳区","cityCode":"1310","provinceCode":"13"},{"code":"131022","name":"固安县","cityCode":"1310","provinceCode":"13"},{"code":"131023","name":"永清县","cityCode":"1310","provinceCode":"13"},{"code":"131024","name":"香河县","cityCode":"1310","provinceCode":"13"},{"code":"131025","name":"大城县","cityCode":"1310","provinceCode":"13"},{"code":"131026","name":"文安县","cityCode":"1310","provinceCode":"13"},{"code":"131028","name":"大厂回族自治县","cityCode":"1310","provinceCode":"13"},{"code":"131071","name":"廊坊经济技术开发区","cityCode":"1310","provinceCode":"13"},{"code":"131081","name":"霸州市","cityCode":"1310","provinceCode":"13"},{"code":"131082","name":"三河市","cityCode":"1310","provinceCode":"13"},{"code":"131102","name":"桃城区","cityCode":"1311","provinceCode":"13"},{"code":"131103","name":"冀州区","cityCode":"1311","provinceCode":"13"},{"code":"131121","name":"枣强县","cityCode":"1311","provinceCode":"13"},{"code":"131122","name":"武邑县","cityCode":"1311","provinceCode":"13"},{"code":"131123","name":"武强县","cityCode":"1311","provinceCode":"13"},{"code":"131124","name":"饶阳县","cityCode":"1311","provinceCode":"13"},{"code":"131125","name":"安平县","cityCode":"1311","provinceCode":"13"},{"code":"131126","name":"故城县","cityCode":"1311","provinceCode":"13"},{"code":"131127","name":"景县","cityCode":"1311","provinceCode":"13"},{"code":"131128","name":"阜城县","cityCode":"1311","provinceCode":"13"},{"code":"131171","name":"河北衡水高新技术产业开发区","cityCode":"1311","provinceCode":"13"},{"code":"131172","name":"衡水滨湖新区","cityCode":"1311","provinceCode":"13"},{"code":"131182","name":"深州市","cityCode":"1311","provinceCode":"13"},{"code":"140105","name":"小店区","cityCode":"1401","provinceCode":"14"},{"code":"140106","name":"迎泽区","cityCode":"1401","provinceCode":"14"},{"code":"140107","name":"杏花岭区","cityCode":"1401","provinceCode":"14"},{"code":"140108","name":"尖草坪区","cityCode":"1401","provinceCode":"14"},{"code":"140109","name":"万柏林区","cityCode":"1401","provinceCode":"14"},{"code":"140110","name":"晋源区","cityCode":"1401","provinceCode":"14"},{"code":"140121","name":"清徐县","cityCode":"1401","provinceCode":"14"},{"code":"140122","name":"阳曲县","cityCode":"1401","provinceCode":"14"},{"code":"140123","name":"娄烦县","cityCode":"1401","provinceCode":"14"},{"code":"140171","name":"山西转型综合改革示范区","cityCode":"1401","provinceCode":"14"},{"code":"140181","name":"古交市","cityCode":"1401","provinceCode":"14"},{"code":"140212","name":"新荣区","cityCode":"1402","provinceCode":"14"},{"code":"140213","name":"平城区","cityCode":"1402","provinceCode":"14"},{"code":"140214","name":"云冈区","cityCode":"1402","provinceCode":"14"},{"code":"140215","name":"云州区","cityCode":"1402","provinceCode":"14"},{"code":"140221","name":"阳高县","cityCode":"1402","provinceCode":"14"},{"code":"140222","name":"天镇县","cityCode":"1402","provinceCode":"14"},{"code":"140223","name":"广灵县","cityCode":"1402","provinceCode":"14"},{"code":"140224","name":"灵丘县","cityCode":"1402","provinceCode":"14"},{"code":"140225","name":"浑源县","cityCode":"1402","provinceCode":"14"},{"code":"140226","name":"左云县","cityCode":"1402","provinceCode":"14"},{"code":"140271","name":"山西大同经济开发区","cityCode":"1402","provinceCode":"14"},{"code":"140302","name":"城区","cityCode":"1403","provinceCode":"14"},{"code":"140303","name":"矿区","cityCode":"1403","provinceCode":"14"},{"code":"140311","name":"郊区","cityCode":"1403","provinceCode":"14"},{"code":"140321","name":"平定县","cityCode":"1403","provinceCode":"14"},{"code":"140322","name":"盂县","cityCode":"1403","provinceCode":"14"},{"code":"140403","name":"潞州区","cityCode":"1404","provinceCode":"14"},{"code":"140404","name":"上党区","cityCode":"1404","provinceCode":"14"},{"code":"140405","name":"屯留区","cityCode":"1404","provinceCode":"14"},{"code":"140406","name":"潞城区","cityCode":"1404","provinceCode":"14"},{"code":"140423","name":"襄垣县","cityCode":"1404","provinceCode":"14"},{"code":"140425","name":"平顺县","cityCode":"1404","provinceCode":"14"},{"code":"140426","name":"黎城县","cityCode":"1404","provinceCode":"14"},{"code":"140427","name":"壶关县","cityCode":"1404","provinceCode":"14"},{"code":"140428","name":"长子县","cityCode":"1404","provinceCode":"14"},{"code":"140429","name":"武乡县","cityCode":"1404","provinceCode":"14"},{"code":"140430","name":"沁县","cityCode":"1404","provinceCode":"14"},{"code":"140431","name":"沁源县","cityCode":"1404","provinceCode":"14"},{"code":"140502","name":"城区","cityCode":"1405","provinceCode":"14"},{"code":"140521","name":"沁水县","cityCode":"1405","provinceCode":"14"},{"code":"140522","name":"阳城县","cityCode":"1405","provinceCode":"14"},{"code":"140524","name":"陵川县","cityCode":"1405","provinceCode":"14"},{"code":"140525","name":"泽州县","cityCode":"1405","provinceCode":"14"},{"code":"140581","name":"高平市","cityCode":"1405","provinceCode":"14"},{"code":"140602","name":"朔城区","cityCode":"1406","provinceCode":"14"},{"code":"140603","name":"平鲁区","cityCode":"1406","provinceCode":"14"},{"code":"140621","name":"山阴县","cityCode":"1406","provinceCode":"14"},{"code":"140622","name":"应县","cityCode":"1406","provinceCode":"14"},{"code":"140623","name":"右玉县","cityCode":"1406","provinceCode":"14"},{"code":"140671","name":"山西朔州经济开发区","cityCode":"1406","provinceCode":"14"},{"code":"140681","name":"怀仁市","cityCode":"1406","provinceCode":"14"},{"code":"140702","name":"榆次区","cityCode":"1407","provinceCode":"14"},{"code":"140703","name":"太谷区","cityCode":"1407","provinceCode":"14"},{"code":"140721","name":"榆社县","cityCode":"1407","provinceCode":"14"},{"code":"140722","name":"左权县","cityCode":"1407","provinceCode":"14"},{"code":"140723","name":"和顺县","cityCode":"1407","provinceCode":"14"},{"code":"140724","name":"昔阳县","cityCode":"1407","provinceCode":"14"},{"code":"140725","name":"寿阳县","cityCode":"1407","provinceCode":"14"},{"code":"140727","name":"祁县","cityCode":"1407","provinceCode":"14"},{"code":"140728","name":"平遥县","cityCode":"1407","provinceCode":"14"},{"code":"140729","name":"灵石县","cityCode":"1407","provinceCode":"14"},{"code":"140781","name":"介休市","cityCode":"1407","provinceCode":"14"},{"code":"140802","name":"盐湖区","cityCode":"1408","provinceCode":"14"},{"code":"140821","name":"临猗县","cityCode":"1408","provinceCode":"14"},{"code":"140822","name":"万荣县","cityCode":"1408","provinceCode":"14"},{"code":"140823","name":"闻喜县","cityCode":"1408","provinceCode":"14"},{"code":"140824","name":"稷山县","cityCode":"1408","provinceCode":"14"},{"code":"140825","name":"新绛县","cityCode":"1408","provinceCode":"14"},{"code":"140826","name":"绛县","cityCode":"1408","provinceCode":"14"},{"code":"140827","name":"垣曲县","cityCode":"1408","provinceCode":"14"},{"code":"140828","name":"夏县","cityCode":"1408","provinceCode":"14"},{"code":"140829","name":"平陆县","cityCode":"1408","provinceCode":"14"},{"code":"140830","name":"芮城县","cityCode":"1408","provinceCode":"14"},{"code":"140881","name":"永济市","cityCode":"1408","provinceCode":"14"},{"code":"140882","name":"河津市","cityCode":"1408","provinceCode":"14"},{"code":"140902","name":"忻府区","cityCode":"1409","provinceCode":"14"},{"code":"140921","name":"定襄县","cityCode":"1409","provinceCode":"14"},{"code":"140922","name":"五台县","cityCode":"1409","provinceCode":"14"},{"code":"140923","name":"代县","cityCode":"1409","provinceCode":"14"},{"code":"140924","name":"繁峙县","cityCode":"1409","provinceCode":"14"},{"code":"140925","name":"宁武县","cityCode":"1409","provinceCode":"14"},{"code":"140926","name":"静乐县","cityCode":"1409","provinceCode":"14"},{"code":"140927","name":"神池县","cityCode":"1409","provinceCode":"14"},{"code":"140928","name":"五寨县","cityCode":"1409","provinceCode":"14"},{"code":"140929","name":"岢岚县","cityCode":"1409","provinceCode":"14"},{"code":"140930","name":"河曲县","cityCode":"1409","provinceCode":"14"},{"code":"140931","name":"保德县","cityCode":"1409","provinceCode":"14"},{"code":"140932","name":"偏关县","cityCode":"1409","provinceCode":"14"},{"code":"140971","name":"五台山风景名胜区","cityCode":"1409","provinceCode":"14"},{"code":"140981","name":"原平市","cityCode":"1409","provinceCode":"14"},{"code":"141002","name":"尧都区","cityCode":"1410","provinceCode":"14"},{"code":"141021","name":"曲沃县","cityCode":"1410","provinceCode":"14"},{"code":"141022","name":"翼城县","cityCode":"1410","provinceCode":"14"},{"code":"141023","name":"襄汾县","cityCode":"1410","provinceCode":"14"},{"code":"141024","name":"洪洞县","cityCode":"1410","provinceCode":"14"},{"code":"141025","name":"古县","cityCode":"1410","provinceCode":"14"},{"code":"141026","name":"安泽县","cityCode":"1410","provinceCode":"14"},{"code":"141027","name":"浮山县","cityCode":"1410","provinceCode":"14"},{"code":"141028","name":"吉县","cityCode":"1410","provinceCode":"14"},{"code":"141029","name":"乡宁县","cityCode":"1410","provinceCode":"14"},{"code":"141030","name":"大宁县","cityCode":"1410","provinceCode":"14"},{"code":"141031","name":"隰县","cityCode":"1410","provinceCode":"14"},{"code":"141032","name":"永和县","cityCode":"1410","provinceCode":"14"},{"code":"141033","name":"蒲县","cityCode":"1410","provinceCode":"14"},{"code":"141034","name":"汾西县","cityCode":"1410","provinceCode":"14"},{"code":"141081","name":"侯马市","cityCode":"1410","provinceCode":"14"},{"code":"141082","name":"霍州市","cityCode":"1410","provinceCode":"14"},{"code":"141102","name":"离石区","cityCode":"1411","provinceCode":"14"},{"code":"141121","name":"文水县","cityCode":"1411","provinceCode":"14"},{"code":"141122","name":"交城县","cityCode":"1411","provinceCode":"14"},{"code":"141123","name":"兴县","cityCode":"1411","provinceCode":"14"},{"code":"141124","name":"临县","cityCode":"1411","provinceCode":"14"},{"code":"141125","name":"柳林县","cityCode":"1411","provinceCode":"14"},{"code":"141126","name":"石楼县","cityCode":"1411","provinceCode":"14"},{"code":"141127","name":"岚县","cityCode":"1411","provinceCode":"14"},{"code":"141128","name":"方山县","cityCode":"1411","provinceCode":"14"},{"code":"141129","name":"中阳县","cityCode":"1411","provinceCode":"14"},{"code":"141130","name":"交口县","cityCode":"1411","provinceCode":"14"},{"code":"141181","name":"孝义市","cityCode":"1411","provinceCode":"14"},{"code":"141182","name":"汾阳市","cityCode":"1411","provinceCode":"14"},{"code":"150102","name":"新城区","cityCode":"1501","provinceCode":"15"},{"code":"150103","name":"回民区","cityCode":"1501","provinceCode":"15"},{"code":"150104","name":"玉泉区","cityCode":"1501","provinceCode":"15"},{"code":"150105","name":"赛罕区","cityCode":"1501","provinceCode":"15"},{"code":"150121","name":"土默特左旗","cityCode":"1501","provinceCode":"15"},{"code":"150122","name":"托克托县","cityCode":"1501","provinceCode":"15"},{"code":"150123","name":"和林格尔县","cityCode":"1501","provinceCode":"15"},{"code":"150124","name":"清水河县","cityCode":"1501","provinceCode":"15"},{"code":"150125","name":"武川县","cityCode":"1501","provinceCode":"15"},{"code":"150172","name":"呼和浩特经济技术开发区","cityCode":"1501","provinceCode":"15"},{"code":"150202","name":"东河区","cityCode":"1502","provinceCode":"15"},{"code":"150203","name":"昆都仑区","cityCode":"1502","provinceCode":"15"},{"code":"150204","name":"青山区","cityCode":"1502","provinceCode":"15"},{"code":"150205","name":"石拐区","cityCode":"1502","provinceCode":"15"},{"code":"150206","name":"白云鄂博矿区","cityCode":"1502","provinceCode":"15"},{"code":"150207","name":"九原区","cityCode":"1502","provinceCode":"15"},{"code":"150221","name":"土默特右旗","cityCode":"1502","provinceCode":"15"},{"code":"150222","name":"固阳县","cityCode":"1502","provinceCode":"15"},{"code":"150223","name":"达尔罕茂明安联合旗","cityCode":"1502","provinceCode":"15"},{"code":"150271","name":"包头稀土高新技术产业开发区","cityCode":"1502","provinceCode":"15"},{"code":"150302","name":"海勃湾区","cityCode":"1503","provinceCode":"15"},{"code":"150303","name":"海南区","cityCode":"1503","provinceCode":"15"},{"code":"150304","name":"乌达区","cityCode":"1503","provinceCode":"15"},{"code":"150402","name":"红山区","cityCode":"1504","provinceCode":"15"},{"code":"150403","name":"元宝山区","cityCode":"1504","provinceCode":"15"},{"code":"150404","name":"松山区","cityCode":"1504","provinceCode":"15"},{"code":"150421","name":"阿鲁科尔沁旗","cityCode":"1504","provinceCode":"15"},{"code":"150422","name":"巴林左旗","cityCode":"1504","provinceCode":"15"},{"code":"150423","name":"巴林右旗","cityCode":"1504","provinceCode":"15"},{"code":"150424","name":"林西县","cityCode":"1504","provinceCode":"15"},{"code":"150425","name":"克什克腾旗","cityCode":"1504","provinceCode":"15"},{"code":"150426","name":"翁牛特旗","cityCode":"1504","provinceCode":"15"},{"code":"150428","name":"喀喇沁旗","cityCode":"1504","provinceCode":"15"},{"code":"150429","name":"宁城县","cityCode":"1504","provinceCode":"15"},{"code":"150430","name":"敖汉旗","cityCode":"1504","provinceCode":"15"},{"code":"150502","name":"科尔沁区","cityCode":"1505","provinceCode":"15"},{"code":"150521","name":"科尔沁左翼中旗","cityCode":"1505","provinceCode":"15"},{"code":"150522","name":"科尔沁左翼后旗","cityCode":"1505","provinceCode":"15"},{"code":"150523","name":"开鲁县","cityCode":"1505","provinceCode":"15"},{"code":"150524","name":"库伦旗","cityCode":"1505","provinceCode":"15"},{"code":"150525","name":"奈曼旗","cityCode":"1505","provinceCode":"15"},{"code":"150526","name":"扎鲁特旗","cityCode":"1505","provinceCode":"15"},{"code":"150571","name":"通辽经济技术开发区","cityCode":"1505","provinceCode":"15"},{"code":"150581","name":"霍林郭勒市","cityCode":"1505","provinceCode":"15"},{"code":"150602","name":"东胜区","cityCode":"1506","provinceCode":"15"},{"code":"150603","name":"康巴什区","cityCode":"1506","provinceCode":"15"},{"code":"150621","name":"达拉特旗","cityCode":"1506","provinceCode":"15"},{"code":"150622","name":"准格尔旗","cityCode":"1506","provinceCode":"15"},{"code":"150623","name":"鄂托克前旗","cityCode":"1506","provinceCode":"15"},{"code":"150624","name":"鄂托克旗","cityCode":"1506","provinceCode":"15"},{"code":"150625","name":"杭锦旗","cityCode":"1506","provinceCode":"15"},{"code":"150626","name":"乌审旗","cityCode":"1506","provinceCode":"15"},{"code":"150627","name":"伊金霍洛旗","cityCode":"1506","provinceCode":"15"},{"code":"150702","name":"海拉尔区","cityCode":"1507","provinceCode":"15"},{"code":"150703","name":"扎赉诺尔区","cityCode":"1507","provinceCode":"15"},{"code":"150721","name":"阿荣旗","cityCode":"1507","provinceCode":"15"},{"code":"150722","name":"莫力达瓦达斡尔族自治旗","cityCode":"1507","provinceCode":"15"},{"code":"150723","name":"鄂伦春自治旗","cityCode":"1507","provinceCode":"15"},{"code":"150724","name":"鄂温克族自治旗","cityCode":"1507","provinceCode":"15"},{"code":"150725","name":"陈巴尔虎旗","cityCode":"1507","provinceCode":"15"},{"code":"150726","name":"新巴尔虎左旗","cityCode":"1507","provinceCode":"15"},{"code":"150727","name":"新巴尔虎右旗","cityCode":"1507","provinceCode":"15"},{"code":"150781","name":"满洲里市","cityCode":"1507","provinceCode":"15"},{"code":"150782","name":"牙克石市","cityCode":"1507","provinceCode":"15"},{"code":"150783","name":"扎兰屯市","cityCode":"1507","provinceCode":"15"},{"code":"150784","name":"额尔古纳市","cityCode":"1507","provinceCode":"15"},{"code":"150785","name":"根河市","cityCode":"1507","provinceCode":"15"},{"code":"150802","name":"临河区","cityCode":"1508","provinceCode":"15"},{"code":"150821","name":"五原县","cityCode":"1508","provinceCode":"15"},{"code":"150822","name":"磴口县","cityCode":"1508","provinceCode":"15"},{"code":"150823","name":"乌拉特前旗","cityCode":"1508","provinceCode":"15"},{"code":"150824","name":"乌拉特中旗","cityCode":"1508","provinceCode":"15"},{"code":"150825","name":"乌拉特后旗","cityCode":"1508","provinceCode":"15"},{"code":"150826","name":"杭锦后旗","cityCode":"1508","provinceCode":"15"},{"code":"150902","name":"集宁区","cityCode":"1509","provinceCode":"15"},{"code":"150921","name":"卓资县","cityCode":"1509","provinceCode":"15"},{"code":"150922","name":"化德县","cityCode":"1509","provinceCode":"15"},{"code":"150923","name":"商都县","cityCode":"1509","provinceCode":"15"},{"code":"150924","name":"兴和县","cityCode":"1509","provinceCode":"15"},{"code":"150925","name":"凉城县","cityCode":"1509","provinceCode":"15"},{"code":"150926","name":"察哈尔右翼前旗","cityCode":"1509","provinceCode":"15"},{"code":"150927","name":"察哈尔右翼中旗","cityCode":"1509","provinceCode":"15"},{"code":"150928","name":"察哈尔右翼后旗","cityCode":"1509","provinceCode":"15"},{"code":"150929","name":"四子王旗","cityCode":"1509","provinceCode":"15"},{"code":"150981","name":"丰镇市","cityCode":"1509","provinceCode":"15"},{"code":"152201","name":"乌兰浩特市","cityCode":"1522","provinceCode":"15"},{"code":"152202","name":"阿尔山市","cityCode":"1522","provinceCode":"15"},{"code":"152221","name":"科尔沁右翼前旗","cityCode":"1522","provinceCode":"15"},{"code":"152222","name":"科尔沁右翼中旗","cityCode":"1522","provinceCode":"15"},{"code":"152223","name":"扎赉特旗","cityCode":"1522","provinceCode":"15"},{"code":"152224","name":"突泉县","cityCode":"1522","provinceCode":"15"},{"code":"152501","name":"二连浩特市","cityCode":"1525","provinceCode":"15"},{"code":"152502","name":"锡林浩特市","cityCode":"1525","provinceCode":"15"},{"code":"152522","name":"阿巴嘎旗","cityCode":"1525","provinceCode":"15"},{"code":"152523","name":"苏尼特左旗","cityCode":"1525","provinceCode":"15"},{"code":"152524","name":"苏尼特右旗","cityCode":"1525","provinceCode":"15"},{"code":"152525","name":"东乌珠穆沁旗","cityCode":"1525","provinceCode":"15"},{"code":"152526","name":"西乌珠穆沁旗","cityCode":"1525","provinceCode":"15"},{"code":"152527","name":"太仆寺旗","cityCode":"1525","provinceCode":"15"},{"code":"152528","name":"镶黄旗","cityCode":"1525","provinceCode":"15"},{"code":"152529","name":"正镶白旗","cityCode":"1525","provinceCode":"15"},{"code":"152530","name":"正蓝旗","cityCode":"1525","provinceCode":"15"},{"code":"152531","name":"多伦县","cityCode":"1525","provinceCode":"15"},{"code":"152571","name":"乌拉盖管理区管委会","cityCode":"1525","provinceCode":"15"},{"code":"152921","name":"阿拉善左旗","cityCode":"1529","provinceCode":"15"},{"code":"152922","name":"阿拉善右旗","cityCode":"1529","provinceCode":"15"},{"code":"152923","name":"额济纳旗","cityCode":"1529","provinceCode":"15"},{"code":"152971","name":"内蒙古阿拉善高新技术产业开发区","cityCode":"1529","provinceCode":"15"},{"code":"210102","name":"和平区","cityCode":"2101","provinceCode":"21"},{"code":"210103","name":"沈河区","cityCode":"2101","provinceCode":"21"},{"code":"210104","name":"大东区","cityCode":"2101","provinceCode":"21"},{"code":"210105","name":"皇姑区","cityCode":"2101","provinceCode":"21"},{"code":"210106","name":"铁西区","cityCode":"2101","provinceCode":"21"},{"code":"210111","name":"苏家屯区","cityCode":"2101","provinceCode":"21"},{"code":"210112","name":"浑南区","cityCode":"2101","provinceCode":"21"},{"code":"210113","name":"沈北新区","cityCode":"2101","provinceCode":"21"},{"code":"210114","name":"于洪区","cityCode":"2101","provinceCode":"21"},{"code":"210115","name":"辽中区","cityCode":"2101","provinceCode":"21"},{"code":"210123","name":"康平县","cityCode":"2101","provinceCode":"21"},{"code":"210124","name":"法库县","cityCode":"2101","provinceCode":"21"},{"code":"210181","name":"新民市","cityCode":"2101","provinceCode":"21"},{"code":"210202","name":"中山区","cityCode":"2102","provinceCode":"21"},{"code":"210203","name":"西岗区","cityCode":"2102","provinceCode":"21"},{"code":"210204","name":"沙河口区","cityCode":"2102","provinceCode":"21"},{"code":"210211","name":"甘井子区","cityCode":"2102","provinceCode":"21"},{"code":"210212","name":"旅顺口区","cityCode":"2102","provinceCode":"21"},{"code":"210213","name":"金州区","cityCode":"2102","provinceCode":"21"},{"code":"210214","name":"普兰店区","cityCode":"2102","provinceCode":"21"},{"code":"210224","name":"长海县","cityCode":"2102","provinceCode":"21"},{"code":"210281","name":"瓦房店市","cityCode":"2102","provinceCode":"21"},{"code":"210283","name":"庄河市","cityCode":"2102","provinceCode":"21"},{"code":"210302","name":"铁东区","cityCode":"2103","provinceCode":"21"},{"code":"210303","name":"铁西区","cityCode":"2103","provinceCode":"21"},{"code":"210304","name":"立山区","cityCode":"2103","provinceCode":"21"},{"code":"210311","name":"千山区","cityCode":"2103","provinceCode":"21"},{"code":"210321","name":"台安县","cityCode":"2103","provinceCode":"21"},{"code":"210323","name":"岫岩满族自治县","cityCode":"2103","provinceCode":"21"},{"code":"210381","name":"海城市","cityCode":"2103","provinceCode":"21"},{"code":"210402","name":"新抚区","cityCode":"2104","provinceCode":"21"},{"code":"210403","name":"东洲区","cityCode":"2104","provinceCode":"21"},{"code":"210404","name":"望花区","cityCode":"2104","provinceCode":"21"},{"code":"210411","name":"顺城区","cityCode":"2104","provinceCode":"21"},{"code":"210421","name":"抚顺县","cityCode":"2104","provinceCode":"21"},{"code":"210422","name":"新宾满族自治县","cityCode":"2104","provinceCode":"21"},{"code":"210423","name":"清原满族自治县","cityCode":"2104","provinceCode":"21"},{"code":"210502","name":"平山区","cityCode":"2105","provinceCode":"21"},{"code":"210503","name":"溪湖区","cityCode":"2105","provinceCode":"21"},{"code":"210504","name":"明山区","cityCode":"2105","provinceCode":"21"},{"code":"210505","name":"南芬区","cityCode":"2105","provinceCode":"21"},{"code":"210521","name":"本溪满族自治县","cityCode":"2105","provinceCode":"21"},{"code":"210522","name":"桓仁满族自治县","cityCode":"2105","provinceCode":"21"},{"code":"210602","name":"元宝区","cityCode":"2106","provinceCode":"21"},{"code":"210603","name":"振兴区","cityCode":"2106","provinceCode":"21"},{"code":"210604","name":"振安区","cityCode":"2106","provinceCode":"21"},{"code":"210624","name":"宽甸满族自治县","cityCode":"2106","provinceCode":"21"},{"code":"210681","name":"东港市","cityCode":"2106","provinceCode":"21"},{"code":"210682","name":"凤城市","cityCode":"2106","provinceCode":"21"},{"code":"210702","name":"古塔区","cityCode":"2107","provinceCode":"21"},{"code":"210703","name":"凌河区","cityCode":"2107","provinceCode":"21"},{"code":"210711","name":"太和区","cityCode":"2107","provinceCode":"21"},{"code":"210726","name":"黑山县","cityCode":"2107","provinceCode":"21"},{"code":"210727","name":"义县","cityCode":"2107","provinceCode":"21"},{"code":"210781","name":"凌海市","cityCode":"2107","provinceCode":"21"},{"code":"210782","name":"北镇市","cityCode":"2107","provinceCode":"21"},{"code":"210802","name":"站前区","cityCode":"2108","provinceCode":"21"},{"code":"210803","name":"西市区","cityCode":"2108","provinceCode":"21"},{"code":"210804","name":"鲅鱼圈区","cityCode":"2108","provinceCode":"21"},{"code":"210811","name":"老边区","cityCode":"2108","provinceCode":"21"},{"code":"210881","name":"盖州市","cityCode":"2108","provinceCode":"21"},{"code":"210882","name":"大石桥市","cityCode":"2108","provinceCode":"21"},{"code":"210902","name":"海州区","cityCode":"2109","provinceCode":"21"},{"code":"210903","name":"新邱区","cityCode":"2109","provinceCode":"21"},{"code":"210904","name":"太平区","cityCode":"2109","provinceCode":"21"},{"code":"210905","name":"清河门区","cityCode":"2109","provinceCode":"21"},{"code":"210911","name":"细河区","cityCode":"2109","provinceCode":"21"},{"code":"210921","name":"阜新蒙古族自治县","cityCode":"2109","provinceCode":"21"},{"code":"210922","name":"彰武县","cityCode":"2109","provinceCode":"21"},{"code":"211002","name":"白塔区","cityCode":"2110","provinceCode":"21"},{"code":"211003","name":"文圣区","cityCode":"2110","provinceCode":"21"},{"code":"211004","name":"宏伟区","cityCode":"2110","provinceCode":"21"},{"code":"211005","name":"弓长岭区","cityCode":"2110","provinceCode":"21"},{"code":"211011","name":"太子河区","cityCode":"2110","provinceCode":"21"},{"code":"211021","name":"辽阳县","cityCode":"2110","provinceCode":"21"},{"code":"211081","name":"灯塔市","cityCode":"2110","provinceCode":"21"},{"code":"211102","name":"双台子区","cityCode":"2111","provinceCode":"21"},{"code":"211103","name":"兴隆台区","cityCode":"2111","provinceCode":"21"},{"code":"211104","name":"大洼区","cityCode":"2111","provinceCode":"21"},{"code":"211122","name":"盘山县","cityCode":"2111","provinceCode":"21"},{"code":"211202","name":"银州区","cityCode":"2112","provinceCode":"21"},{"code":"211204","name":"清河区","cityCode":"2112","provinceCode":"21"},{"code":"211221","name":"铁岭县","cityCode":"2112","provinceCode":"21"},{"code":"211223","name":"西丰县","cityCode":"2112","provinceCode":"21"},{"code":"211224","name":"昌图县","cityCode":"2112","provinceCode":"21"},{"code":"211281","name":"调兵山市","cityCode":"2112","provinceCode":"21"},{"code":"211282","name":"开原市","cityCode":"2112","provinceCode":"21"},{"code":"211302","name":"双塔区","cityCode":"2113","provinceCode":"21"},{"code":"211303","name":"龙城区","cityCode":"2113","provinceCode":"21"},{"code":"211321","name":"朝阳县","cityCode":"2113","provinceCode":"21"},{"code":"211322","name":"建平县","cityCode":"2113","provinceCode":"21"},{"code":"211324","name":"喀喇沁左翼蒙古族自治县","cityCode":"2113","provinceCode":"21"},{"code":"211381","name":"北票市","cityCode":"2113","provinceCode":"21"},{"code":"211382","name":"凌源市","cityCode":"2113","provinceCode":"21"},{"code":"211402","name":"连山区","cityCode":"2114","provinceCode":"21"},{"code":"211403","name":"龙港区","cityCode":"2114","provinceCode":"21"},{"code":"211404","name":"南票区","cityCode":"2114","provinceCode":"21"},{"code":"211421","name":"绥中县","cityCode":"2114","provinceCode":"21"},{"code":"211422","name":"建昌县","cityCode":"2114","provinceCode":"21"},{"code":"211481","name":"兴城市","cityCode":"2114","provinceCode":"21"},{"code":"220102","name":"南关区","cityCode":"2201","provinceCode":"22"},{"code":"220103","name":"宽城区","cityCode":"2201","provinceCode":"22"},{"code":"220104","name":"朝阳区","cityCode":"2201","provinceCode":"22"},{"code":"220105","name":"二道区","cityCode":"2201","provinceCode":"22"},{"code":"220106","name":"绿园区","cityCode":"2201","provinceCode":"22"},{"code":"220112","name":"双阳区","cityCode":"2201","provinceCode":"22"},{"code":"220113","name":"九台区","cityCode":"2201","provinceCode":"22"},{"code":"220122","name":"农安县","cityCode":"2201","provinceCode":"22"},{"code":"220171","name":"长春经济技术开发区","cityCode":"2201","provinceCode":"22"},{"code":"220172","name":"长春净月高新技术产业开发区","cityCode":"2201","provinceCode":"22"},{"code":"220173","name":"长春高新技术产业开发区","cityCode":"2201","provinceCode":"22"},{"code":"220174","name":"长春汽车经济技术开发区","cityCode":"2201","provinceCode":"22"},{"code":"220182","name":"榆树市","cityCode":"2201","provinceCode":"22"},{"code":"220183","name":"德惠市","cityCode":"2201","provinceCode":"22"},{"code":"220184","name":"公主岭市","cityCode":"2201","provinceCode":"22"},{"code":"220202","name":"昌邑区","cityCode":"2202","provinceCode":"22"},{"code":"220203","name":"龙潭区","cityCode":"2202","provinceCode":"22"},{"code":"220204","name":"船营区","cityCode":"2202","provinceCode":"22"},{"code":"220211","name":"丰满区","cityCode":"2202","provinceCode":"22"},{"code":"220221","name":"永吉县","cityCode":"2202","provinceCode":"22"},{"code":"220271","name":"吉林经济开发区","cityCode":"2202","provinceCode":"22"},{"code":"220272","name":"吉林高新技术产业开发区","cityCode":"2202","provinceCode":"22"},{"code":"220273","name":"吉林中国新加坡食品区","cityCode":"2202","provinceCode":"22"},{"code":"220281","name":"蛟河市","cityCode":"2202","provinceCode":"22"},{"code":"220282","name":"桦甸市","cityCode":"2202","provinceCode":"22"},{"code":"220283","name":"舒兰市","cityCode":"2202","provinceCode":"22"},{"code":"220284","name":"磐石市","cityCode":"2202","provinceCode":"22"},{"code":"220302","name":"铁西区","cityCode":"2203","provinceCode":"22"},{"code":"220303","name":"铁东区","cityCode":"2203","provinceCode":"22"},{"code":"220322","name":"梨树县","cityCode":"2203","provinceCode":"22"},{"code":"220323","name":"伊通满族自治县","cityCode":"2203","provinceCode":"22"},{"code":"220382","name":"双辽市","cityCode":"2203","provinceCode":"22"},{"code":"220402","name":"龙山区","cityCode":"2204","provinceCode":"22"},{"code":"220403","name":"西安区","cityCode":"2204","provinceCode":"22"},{"code":"220421","name":"东丰县","cityCode":"2204","provinceCode":"22"},{"code":"220422","name":"东辽县","cityCode":"2204","provinceCode":"22"},{"code":"220502","name":"东昌区","cityCode":"2205","provinceCode":"22"},{"code":"220503","name":"二道江区","cityCode":"2205","provinceCode":"22"},{"code":"220521","name":"通化县","cityCode":"2205","provinceCode":"22"},{"code":"220523","name":"辉南县","cityCode":"2205","provinceCode":"22"},{"code":"220524","name":"柳河县","cityCode":"2205","provinceCode":"22"},{"code":"220581","name":"梅河口市","cityCode":"2205","provinceCode":"22"},{"code":"220582","name":"集安市","cityCode":"2205","provinceCode":"22"},{"code":"220602","name":"浑江区","cityCode":"2206","provinceCode":"22"},{"code":"220605","name":"江源区","cityCode":"2206","provinceCode":"22"},{"code":"220621","name":"抚松县","cityCode":"2206","provinceCode":"22"},{"code":"220622","name":"靖宇县","cityCode":"2206","provinceCode":"22"},{"code":"220623","name":"长白朝鲜族自治县","cityCode":"2206","provinceCode":"22"},{"code":"220681","name":"临江市","cityCode":"2206","provinceCode":"22"},{"code":"220702","name":"宁江区","cityCode":"2207","provinceCode":"22"},{"code":"220721","name":"前郭尔罗斯蒙古族自治县","cityCode":"2207","provinceCode":"22"},{"code":"220722","name":"长岭县","cityCode":"2207","provinceCode":"22"},{"code":"220723","name":"乾安县","cityCode":"2207","provinceCode":"22"},{"code":"220771","name":"吉林松原经济开发区","cityCode":"2207","provinceCode":"22"},{"code":"220781","name":"扶余市","cityCode":"2207","provinceCode":"22"},{"code":"220802","name":"洮北区","cityCode":"2208","provinceCode":"22"},{"code":"220821","name":"镇赉县","cityCode":"2208","provinceCode":"22"},{"code":"220822","name":"通榆县","cityCode":"2208","provinceCode":"22"},{"code":"220871","name":"吉林白城经济开发区","cityCode":"2208","provinceCode":"22"},{"code":"220881","name":"洮南市","cityCode":"2208","provinceCode":"22"},{"code":"220882","name":"大安市","cityCode":"2208","provinceCode":"22"},{"code":"222401","name":"延吉市","cityCode":"2224","provinceCode":"22"},{"code":"222402","name":"图们市","cityCode":"2224","provinceCode":"22"},{"code":"222403","name":"敦化市","cityCode":"2224","provinceCode":"22"},{"code":"222404","name":"珲春市","cityCode":"2224","provinceCode":"22"},{"code":"222405","name":"龙井市","cityCode":"2224","provinceCode":"22"},{"code":"222406","name":"和龙市","cityCode":"2224","provinceCode":"22"},{"code":"222424","name":"汪清县","cityCode":"2224","provinceCode":"22"},{"code":"222426","name":"安图县","cityCode":"2224","provinceCode":"22"},{"code":"230102","name":"道里区","cityCode":"2301","provinceCode":"23"},{"code":"230103","name":"南岗区","cityCode":"2301","provinceCode":"23"},{"code":"230104","name":"道外区","cityCode":"2301","provinceCode":"23"},{"code":"230108","name":"平房区","cityCode":"2301","provinceCode":"23"},{"code":"230109","name":"松北区","cityCode":"2301","provinceCode":"23"},{"code":"230110","name":"香坊区","cityCode":"2301","provinceCode":"23"},{"code":"230111","name":"呼兰区","cityCode":"2301","provinceCode":"23"},{"code":"230112","name":"阿城区","cityCode":"2301","provinceCode":"23"},{"code":"230113","name":"双城区","cityCode":"2301","provinceCode":"23"},{"code":"230123","name":"依兰县","cityCode":"2301","provinceCode":"23"},{"code":"230124","name":"方正县","cityCode":"2301","provinceCode":"23"},{"code":"230125","name":"宾县","cityCode":"2301","provinceCode":"23"},{"code":"230126","name":"巴彦县","cityCode":"2301","provinceCode":"23"},{"code":"230127","name":"木兰县","cityCode":"2301","provinceCode":"23"},{"code":"230128","name":"通河县","cityCode":"2301","provinceCode":"23"},{"code":"230129","name":"延寿县","cityCode":"2301","provinceCode":"23"},{"code":"230183","name":"尚志市","cityCode":"2301","provinceCode":"23"},{"code":"230184","name":"五常市","cityCode":"2301","provinceCode":"23"},{"code":"230202","name":"龙沙区","cityCode":"2302","provinceCode":"23"},{"code":"230203","name":"建华区","cityCode":"2302","provinceCode":"23"},{"code":"230204","name":"铁锋区","cityCode":"2302","provinceCode":"23"},{"code":"230205","name":"昂昂溪区","cityCode":"2302","provinceCode":"23"},{"code":"230206","name":"富拉尔基区","cityCode":"2302","provinceCode":"23"},{"code":"230207","name":"碾子山区","cityCode":"2302","provinceCode":"23"},{"code":"230208","name":"梅里斯达斡尔族区","cityCode":"2302","provinceCode":"23"},{"code":"230221","name":"龙江县","cityCode":"2302","provinceCode":"23"},{"code":"230223","name":"依安县","cityCode":"2302","provinceCode":"23"},{"code":"230224","name":"泰来县","cityCode":"2302","provinceCode":"23"},{"code":"230225","name":"甘南县","cityCode":"2302","provinceCode":"23"},{"code":"230227","name":"富裕县","cityCode":"2302","provinceCode":"23"},{"code":"230229","name":"克山县","cityCode":"2302","provinceCode":"23"},{"code":"230230","name":"克东县","cityCode":"2302","provinceCode":"23"},{"code":"230231","name":"拜泉县","cityCode":"2302","provinceCode":"23"},{"code":"230281","name":"讷河市","cityCode":"2302","provinceCode":"23"},{"code":"230302","name":"鸡冠区","cityCode":"2303","provinceCode":"23"},{"code":"230303","name":"恒山区","cityCode":"2303","provinceCode":"23"},{"code":"230304","name":"滴道区","cityCode":"2303","provinceCode":"23"},{"code":"230305","name":"梨树区","cityCode":"2303","provinceCode":"23"},{"code":"230306","name":"城子河区","cityCode":"2303","provinceCode":"23"},{"code":"230307","name":"麻山区","cityCode":"2303","provinceCode":"23"},{"code":"230321","name":"鸡东县","cityCode":"2303","provinceCode":"23"},{"code":"230381","name":"虎林市","cityCode":"2303","provinceCode":"23"},{"code":"230382","name":"密山市","cityCode":"2303","provinceCode":"23"},{"code":"230402","name":"向阳区","cityCode":"2304","provinceCode":"23"},{"code":"230403","name":"工农区","cityCode":"2304","provinceCode":"23"},{"code":"230404","name":"南山区","cityCode":"2304","provinceCode":"23"},{"code":"230405","name":"兴安区","cityCode":"2304","provinceCode":"23"},{"code":"230406","name":"东山区","cityCode":"2304","provinceCode":"23"},{"code":"230407","name":"兴山区","cityCode":"2304","provinceCode":"23"},{"code":"230421","name":"萝北县","cityCode":"2304","provinceCode":"23"},{"code":"230422","name":"绥滨县","cityCode":"2304","provinceCode":"23"},{"code":"230502","name":"尖山区","cityCode":"2305","provinceCode":"23"},{"code":"230503","name":"岭东区","cityCode":"2305","provinceCode":"23"},{"code":"230505","name":"四方台区","cityCode":"2305","provinceCode":"23"},{"code":"230506","name":"宝山区","cityCode":"2305","provinceCode":"23"},{"code":"230521","name":"集贤县","cityCode":"2305","provinceCode":"23"},{"code":"230522","name":"友谊县","cityCode":"2305","provinceCode":"23"},{"code":"230523","name":"宝清县","cityCode":"2305","provinceCode":"23"},{"code":"230524","name":"饶河县","cityCode":"2305","provinceCode":"23"},{"code":"230602","name":"萨尔图区","cityCode":"2306","provinceCode":"23"},{"code":"230603","name":"龙凤区","cityCode":"2306","provinceCode":"23"},{"code":"230604","name":"让胡路区","cityCode":"2306","provinceCode":"23"},{"code":"230605","name":"红岗区","cityCode":"2306","provinceCode":"23"},{"code":"230606","name":"大同区","cityCode":"2306","provinceCode":"23"},{"code":"230621","name":"肇州县","cityCode":"2306","provinceCode":"23"},{"code":"230622","name":"肇源县","cityCode":"2306","provinceCode":"23"},{"code":"230623","name":"林甸县","cityCode":"2306","provinceCode":"23"},{"code":"230624","name":"杜尔伯特蒙古族自治县","cityCode":"2306","provinceCode":"23"},{"code":"230671","name":"大庆高新技术产业开发区","cityCode":"2306","provinceCode":"23"},{"code":"230717","name":"伊美区","cityCode":"2307","provinceCode":"23"},{"code":"230718","name":"乌翠区","cityCode":"2307","provinceCode":"23"},{"code":"230719","name":"友好区","cityCode":"2307","provinceCode":"23"},{"code":"230722","name":"嘉荫县","cityCode":"2307","provinceCode":"23"},{"code":"230723","name":"汤旺县","cityCode":"2307","provinceCode":"23"},{"code":"230724","name":"丰林县","cityCode":"2307","provinceCode":"23"},{"code":"230725","name":"大箐山县","cityCode":"2307","provinceCode":"23"},{"code":"230726","name":"南岔县","cityCode":"2307","provinceCode":"23"},{"code":"230751","name":"金林区","cityCode":"2307","provinceCode":"23"},{"code":"230781","name":"铁力市","cityCode":"2307","provinceCode":"23"},{"code":"230803","name":"向阳区","cityCode":"2308","provinceCode":"23"},{"code":"230804","name":"前进区","cityCode":"2308","provinceCode":"23"},{"code":"230805","name":"东风区","cityCode":"2308","provinceCode":"23"},{"code":"230811","name":"郊区","cityCode":"2308","provinceCode":"23"},{"code":"230822","name":"桦南县","cityCode":"2308","provinceCode":"23"},{"code":"230826","name":"桦川县","cityCode":"2308","provinceCode":"23"},{"code":"230828","name":"汤原县","cityCode":"2308","provinceCode":"23"},{"code":"230881","name":"同江市","cityCode":"2308","provinceCode":"23"},{"code":"230882","name":"富锦市","cityCode":"2308","provinceCode":"23"},{"code":"230883","name":"抚远市","cityCode":"2308","provinceCode":"23"},{"code":"230902","name":"新兴区","cityCode":"2309","provinceCode":"23"},{"code":"230903","name":"桃山区","cityCode":"2309","provinceCode":"23"},{"code":"230904","name":"茄子河区","cityCode":"2309","provinceCode":"23"},{"code":"230921","name":"勃利县","cityCode":"2309","provinceCode":"23"},{"code":"231002","name":"东安区","cityCode":"2310","provinceCode":"23"},{"code":"231003","name":"阳明区","cityCode":"2310","provinceCode":"23"},{"code":"231004","name":"爱民区","cityCode":"2310","provinceCode":"23"},{"code":"231005","name":"西安区","cityCode":"2310","provinceCode":"23"},{"code":"231025","name":"林口县","cityCode":"2310","provinceCode":"23"},{"code":"231081","name":"绥芬河市","cityCode":"2310","provinceCode":"23"},{"code":"231083","name":"海林市","cityCode":"2310","provinceCode":"23"},{"code":"231084","name":"宁安市","cityCode":"2310","provinceCode":"23"},{"code":"231085","name":"穆棱市","cityCode":"2310","provinceCode":"23"},{"code":"231086","name":"东宁市","cityCode":"2310","provinceCode":"23"},{"code":"231102","name":"爱辉区","cityCode":"2311","provinceCode":"23"},{"code":"231123","name":"逊克县","cityCode":"2311","provinceCode":"23"},{"code":"231124","name":"孙吴县","cityCode":"2311","provinceCode":"23"},{"code":"231181","name":"北安市","cityCode":"2311","provinceCode":"23"},{"code":"231182","name":"五大连池市","cityCode":"2311","provinceCode":"23"},{"code":"231183","name":"嫩江市","cityCode":"2311","provinceCode":"23"},{"code":"231202","name":"北林区","cityCode":"2312","provinceCode":"23"},{"code":"231221","name":"望奎县","cityCode":"2312","provinceCode":"23"},{"code":"231222","name":"兰西县","cityCode":"2312","provinceCode":"23"},{"code":"231223","name":"青冈县","cityCode":"2312","provinceCode":"23"},{"code":"231224","name":"庆安县","cityCode":"2312","provinceCode":"23"},{"code":"231225","name":"明水县","cityCode":"2312","provinceCode":"23"},{"code":"231226","name":"绥棱县","cityCode":"2312","provinceCode":"23"},{"code":"231281","name":"安达市","cityCode":"2312","provinceCode":"23"},{"code":"231282","name":"肇东市","cityCode":"2312","provinceCode":"23"},{"code":"231283","name":"海伦市","cityCode":"2312","provinceCode":"23"},{"code":"232701","name":"漠河市","cityCode":"2327","provinceCode":"23"},{"code":"232721","name":"呼玛县","cityCode":"2327","provinceCode":"23"},{"code":"232722","name":"塔河县","cityCode":"2327","provinceCode":"23"},{"code":"232761","name":"加格达奇区","cityCode":"2327","provinceCode":"23"},{"code":"232762","name":"松岭区","cityCode":"2327","provinceCode":"23"},{"code":"232763","name":"新林区","cityCode":"2327","provinceCode":"23"},{"code":"232764","name":"呼中区","cityCode":"2327","provinceCode":"23"},{"code":"310101","name":"黄浦区","cityCode":"3101","provinceCode":"31"},{"code":"310104","name":"徐汇区","cityCode":"3101","provinceCode":"31"},{"code":"310105","name":"长宁区","cityCode":"3101","provinceCode":"31"},{"code":"310106","name":"静安区","cityCode":"3101","provinceCode":"31"},{"code":"310107","name":"普陀区","cityCode":"3101","provinceCode":"31"},{"code":"310109","name":"虹口区","cityCode":"3101","provinceCode":"31"},{"code":"310110","name":"杨浦区","cityCode":"3101","provinceCode":"31"},{"code":"310112","name":"闵行区","cityCode":"3101","provinceCode":"31"},{"code":"310113","name":"宝山区","cityCode":"3101","provinceCode":"31"},{"code":"310114","name":"嘉定区","cityCode":"3101","provinceCode":"31"},{"code":"310115","name":"浦东新区","cityCode":"3101","provinceCode":"31"},{"code":"310116","name":"金山区","cityCode":"3101","provinceCode":"31"},{"code":"310117","name":"松江区","cityCode":"3101","provinceCode":"31"},{"code":"310118","name":"青浦区","cityCode":"3101","provinceCode":"31"},{"code":"310120","name":"奉贤区","cityCode":"3101","provinceCode":"31"},{"code":"310151","name":"崇明区","cityCode":"3101","provinceCode":"31"},{"code":"320102","name":"玄武区","cityCode":"3201","provinceCode":"32"},{"code":"320104","name":"秦淮区","cityCode":"3201","provinceCode":"32"},{"code":"320105","name":"建邺区","cityCode":"3201","provinceCode":"32"},{"code":"320106","name":"鼓楼区","cityCode":"3201","provinceCode":"32"},{"code":"320111","name":"浦口区","cityCode":"3201","provinceCode":"32"},{"code":"320113","name":"栖霞区","cityCode":"3201","provinceCode":"32"},{"code":"320114","name":"雨花台区","cityCode":"3201","provinceCode":"32"},{"code":"320115","name":"江宁区","cityCode":"3201","provinceCode":"32"},{"code":"320116","name":"六合区","cityCode":"3201","provinceCode":"32"},{"code":"320117","name":"溧水区","cityCode":"3201","provinceCode":"32"},{"code":"320118","name":"高淳区","cityCode":"3201","provinceCode":"32"},{"code":"320205","name":"锡山区","cityCode":"3202","provinceCode":"32"},{"code":"320206","name":"惠山区","cityCode":"3202","provinceCode":"32"},{"code":"320211","name":"滨湖区","cityCode":"3202","provinceCode":"32"},{"code":"320213","name":"梁溪区","cityCode":"3202","provinceCode":"32"},{"code":"320214","name":"新吴区","cityCode":"3202","provinceCode":"32"},{"code":"320281","name":"江阴市","cityCode":"3202","provinceCode":"32"},{"code":"320282","name":"宜兴市","cityCode":"3202","provinceCode":"32"},{"code":"320302","name":"鼓楼区","cityCode":"3203","provinceCode":"32"},{"code":"320303","name":"云龙区","cityCode":"3203","provinceCode":"32"},{"code":"320305","name":"贾汪区","cityCode":"3203","provinceCode":"32"},{"code":"320311","name":"泉山区","cityCode":"3203","provinceCode":"32"},{"code":"320312","name":"铜山区","cityCode":"3203","provinceCode":"32"},{"code":"320321","name":"丰县","cityCode":"3203","provinceCode":"32"},{"code":"320322","name":"沛县","cityCode":"3203","provinceCode":"32"},{"code":"320324","name":"睢宁县","cityCode":"3203","provinceCode":"32"},{"code":"320371","name":"徐州经济技术开发区","cityCode":"3203","provinceCode":"32"},{"code":"320381","name":"新沂市","cityCode":"3203","provinceCode":"32"},{"code":"320382","name":"邳州市","cityCode":"3203","provinceCode":"32"},{"code":"320402","name":"天宁区","cityCode":"3204","provinceCode":"32"},{"code":"320404","name":"钟楼区","cityCode":"3204","provinceCode":"32"},{"code":"320411","name":"新北区","cityCode":"3204","provinceCode":"32"},{"code":"320412","name":"武进区","cityCode":"3204","provinceCode":"32"},{"code":"320413","name":"金坛区","cityCode":"3204","provinceCode":"32"},{"code":"320481","name":"溧阳市","cityCode":"3204","provinceCode":"32"},{"code":"320505","name":"虎丘区","cityCode":"3205","provinceCode":"32"},{"code":"320506","name":"吴中区","cityCode":"3205","provinceCode":"32"},{"code":"320507","name":"相城区","cityCode":"3205","provinceCode":"32"},{"code":"320508","name":"姑苏区","cityCode":"3205","provinceCode":"32"},{"code":"320509","name":"吴江区","cityCode":"3205","provinceCode":"32"},{"code":"320576","name":"苏州工业园区","cityCode":"3205","provinceCode":"32"},{"code":"320581","name":"常熟市","cityCode":"3205","provinceCode":"32"},{"code":"320582","name":"张家港市","cityCode":"3205","provinceCode":"32"},{"code":"320583","name":"昆山市","cityCode":"3205","provinceCode":"32"},{"code":"320585","name":"太仓市","cityCode":"3205","provinceCode":"32"},{"code":"320612","name":"通州区","cityCode":"3206","provinceCode":"32"},{"code":"320613","name":"崇川区","cityCode":"3206","provinceCode":"32"},{"code":"320614","name":"海门区","cityCode":"3206","provinceCode":"32"},{"code":"320623","name":"如东县","cityCode":"3206","provinceCode":"32"},{"code":"320671","name":"南通经济技术开发区","cityCode":"3206","provinceCode":"32"},{"code":"320681","name":"启东市","cityCode":"3206","provinceCode":"32"},{"code":"320682","name":"如皋市","cityCode":"3206","provinceCode":"32"},{"code":"320685","name":"海安市","cityCode":"3206","provinceCode":"32"},{"code":"320703","name":"连云区","cityCode":"3207","provinceCode":"32"},{"code":"320706","name":"海州区","cityCode":"3207","provinceCode":"32"},{"code":"320707","name":"赣榆区","cityCode":"3207","provinceCode":"32"},{"code":"320722","name":"东海县","cityCode":"3207","provinceCode":"32"},{"code":"320723","name":"灌云县","cityCode":"3207","provinceCode":"32"},{"code":"320724","name":"灌南县","cityCode":"3207","provinceCode":"32"},{"code":"320771","name":"连云港经济技术开发区","cityCode":"3207","provinceCode":"32"},{"code":"320803","name":"淮安区","cityCode":"3208","provinceCode":"32"},{"code":"320804","name":"淮阴区","cityCode":"3208","provinceCode":"32"},{"code":"320812","name":"清江浦区","cityCode":"3208","provinceCode":"32"},{"code":"320813","name":"洪泽区","cityCode":"3208","provinceCode":"32"},{"code":"320826","name":"涟水县","cityCode":"3208","provinceCode":"32"},{"code":"320830","name":"盱眙县","cityCode":"3208","provinceCode":"32"},{"code":"320831","name":"金湖县","cityCode":"3208","provinceCode":"32"},{"code":"320871","name":"淮安经济技术开发区","cityCode":"3208","provinceCode":"32"},{"code":"320902","name":"亭湖区","cityCode":"3209","provinceCode":"32"},{"code":"320903","name":"盐都区","cityCode":"3209","provinceCode":"32"},{"code":"320904","name":"大丰区","cityCode":"3209","provinceCode":"32"},{"code":"320921","name":"响水县","cityCode":"3209","provinceCode":"32"},{"code":"320922","name":"滨海县","cityCode":"3209","provinceCode":"32"},{"code":"320923","name":"阜宁县","cityCode":"3209","provinceCode":"32"},{"code":"320924","name":"射阳县","cityCode":"3209","provinceCode":"32"},{"code":"320925","name":"建湖县","cityCode":"3209","provinceCode":"32"},{"code":"320971","name":"盐城经济技术开发区","cityCode":"3209","provinceCode":"32"},{"code":"320981","name":"东台市","cityCode":"3209","provinceCode":"32"},{"code":"321002","name":"广陵区","cityCode":"3210","provinceCode":"32"},{"code":"321003","name":"邗江区","cityCode":"3210","provinceCode":"32"},{"code":"321012","name":"江都区","cityCode":"3210","provinceCode":"32"},{"code":"321023","name":"宝应县","cityCode":"3210","provinceCode":"32"},{"code":"321071","name":"扬州经济技术开发区","cityCode":"3210","provinceCode":"32"},{"code":"321081","name":"仪征市","cityCode":"3210","provinceCode":"32"},{"code":"321084","name":"高邮市","cityCode":"3210","provinceCode":"32"},{"code":"321102","name":"京口区","cityCode":"3211","provinceCode":"32"},{"code":"321111","name":"润州区","cityCode":"3211","provinceCode":"32"},{"code":"321112","name":"丹徒区","cityCode":"3211","provinceCode":"32"},{"code":"321171","name":"镇江新区","cityCode":"3211","provinceCode":"32"},{"code":"321181","name":"丹阳市","cityCode":"3211","provinceCode":"32"},{"code":"321182","name":"扬中市","cityCode":"3211","provinceCode":"32"},{"code":"321183","name":"句容市","cityCode":"3211","provinceCode":"32"},{"code":"321202","name":"海陵区","cityCode":"3212","provinceCode":"32"},{"code":"321203","name":"高港区","cityCode":"3212","provinceCode":"32"},{"code":"321204","name":"姜堰区","cityCode":"3212","provinceCode":"32"},{"code":"321281","name":"兴化市","cityCode":"3212","provinceCode":"32"},{"code":"321282","name":"靖江市","cityCode":"3212","provinceCode":"32"},{"code":"321283","name":"泰兴市","cityCode":"3212","provinceCode":"32"},{"code":"321302","name":"宿城区","cityCode":"3213","provinceCode":"32"},{"code":"321311","name":"宿豫区","cityCode":"3213","provinceCode":"32"},{"code":"321322","name":"沭阳县","cityCode":"3213","provinceCode":"32"},{"code":"321323","name":"泗阳县","cityCode":"3213","provinceCode":"32"},{"code":"321324","name":"泗洪县","cityCode":"3213","provinceCode":"32"},{"code":"321371","name":"宿迁经济技术开发区","cityCode":"3213","provinceCode":"32"},{"code":"330102","name":"上城区","cityCode":"3301","provinceCode":"33"},{"code":"330105","name":"拱墅区","cityCode":"3301","provinceCode":"33"},{"code":"330106","name":"西湖区","cityCode":"3301","provinceCode":"33"},{"code":"330108","name":"滨江区","cityCode":"3301","provinceCode":"33"},{"code":"330109","name":"萧山区","cityCode":"3301","provinceCode":"33"},{"code":"330110","name":"余杭区","cityCode":"3301","provinceCode":"33"},{"code":"330111","name":"富阳区","cityCode":"3301","provinceCode":"33"},{"code":"330112","name":"临安区","cityCode":"3301","provinceCode":"33"},{"code":"330113","name":"临平区","cityCode":"3301","provinceCode":"33"},{"code":"330114","name":"钱塘区","cityCode":"3301","provinceCode":"33"},{"code":"330122","name":"桐庐县","cityCode":"3301","provinceCode":"33"},{"code":"330127","name":"淳安县","cityCode":"3301","provinceCode":"33"},{"code":"330182","name":"建德市","cityCode":"3301","provinceCode":"33"},{"code":"330203","name":"海曙区","cityCode":"3302","provinceCode":"33"},{"code":"330205","name":"江北区","cityCode":"3302","provinceCode":"33"},{"code":"330206","name":"北仑区","cityCode":"3302","provinceCode":"33"},{"code":"330211","name":"镇海区","cityCode":"3302","provinceCode":"33"},{"code":"330212","name":"鄞州区","cityCode":"3302","provinceCode":"33"},{"code":"330213","name":"奉化区","cityCode":"3302","provinceCode":"33"},{"code":"330225","name":"象山县","cityCode":"3302","provinceCode":"33"},{"code":"330226","name":"宁海县","cityCode":"3302","provinceCode":"33"},{"code":"330281","name":"余姚市","cityCode":"3302","provinceCode":"33"},{"code":"330282","name":"慈溪市","cityCode":"3302","provinceCode":"33"},{"code":"330302","name":"鹿城区","cityCode":"3303","provinceCode":"33"},{"code":"330303","name":"龙湾区","cityCode":"3303","provinceCode":"33"},{"code":"330304","name":"瓯海区","cityCode":"3303","provinceCode":"33"},{"code":"330305","name":"洞头区","cityCode":"3303","provinceCode":"33"},{"code":"330324","name":"永嘉县","cityCode":"3303","provinceCode":"33"},{"code":"330326","name":"平阳县","cityCode":"3303","provinceCode":"33"},{"code":"330327","name":"苍南县","cityCode":"3303","provinceCode":"33"},{"code":"330328","name":"文成县","cityCode":"3303","provinceCode":"33"},{"code":"330329","name":"泰顺县","cityCode":"3303","provinceCode":"33"},{"code":"330381","name":"瑞安市","cityCode":"3303","provinceCode":"33"},{"code":"330382","name":"乐清市","cityCode":"3303","provinceCode":"33"},{"code":"330383","name":"龙港市","cityCode":"3303","provinceCode":"33"},{"code":"330402","name":"南湖区","cityCode":"3304","provinceCode":"33"},{"code":"330411","name":"秀洲区","cityCode":"3304","provinceCode":"33"},{"code":"330421","name":"嘉善县","cityCode":"3304","provinceCode":"33"},{"code":"330424","name":"海盐县","cityCode":"3304","provinceCode":"33"},{"code":"330481","name":"海宁市","cityCode":"3304","provinceCode":"33"},{"code":"330482","name":"平湖市","cityCode":"3304","provinceCode":"33"},{"code":"330483","name":"桐乡市","cityCode":"3304","provinceCode":"33"},{"code":"330502","name":"吴兴区","cityCode":"3305","provinceCode":"33"},{"code":"330503","name":"南浔区","cityCode":"3305","provinceCode":"33"},{"code":"330521","name":"德清县","cityCode":"3305","provinceCode":"33"},{"code":"330522","name":"长兴县","cityCode":"3305","provinceCode":"33"},{"code":"330523","name":"安吉县","cityCode":"3305","provinceCode":"33"},{"code":"330602","name":"越城区","cityCode":"3306","provinceCode":"33"},{"code":"330603","name":"柯桥区","cityCode":"3306","provinceCode":"33"},{"code":"330604","name":"上虞区","cityCode":"3306","provinceCode":"33"},{"code":"330624","name":"新昌县","cityCode":"3306","provinceCode":"33"},{"code":"330681","name":"诸暨市","cityCode":"3306","provinceCode":"33"},{"code":"330683","name":"嵊州市","cityCode":"3306","provinceCode":"33"},{"code":"330702","name":"婺城区","cityCode":"3307","provinceCode":"33"},{"code":"330703","name":"金东区","cityCode":"3307","provinceCode":"33"},{"code":"330723","name":"武义县","cityCode":"3307","provinceCode":"33"},{"code":"330726","name":"浦江县","cityCode":"3307","provinceCode":"33"},{"code":"330727","name":"磐安县","cityCode":"3307","provinceCode":"33"},{"code":"330781","name":"兰溪市","cityCode":"3307","provinceCode":"33"},{"code":"330782","name":"义乌市","cityCode":"3307","provinceCode":"33"},{"code":"330783","name":"东阳市","cityCode":"3307","provinceCode":"33"},{"code":"330784","name":"永康市","cityCode":"3307","provinceCode":"33"},{"code":"330802","name":"柯城区","cityCode":"3308","provinceCode":"33"},{"code":"330803","name":"衢江区","cityCode":"3308","provinceCode":"33"},{"code":"330822","name":"常山县","cityCode":"3308","provinceCode":"33"},{"code":"330824","name":"开化县","cityCode":"3308","provinceCode":"33"},{"code":"330825","name":"龙游县","cityCode":"3308","provinceCode":"33"},{"code":"330881","name":"江山市","cityCode":"3308","provinceCode":"33"},{"code":"330902","name":"定海区","cityCode":"3309","provinceCode":"33"},{"code":"330903","name":"普陀区","cityCode":"3309","provinceCode":"33"},{"code":"330921","name":"岱山县","cityCode":"3309","provinceCode":"33"},{"code":"330922","name":"嵊泗县","cityCode":"3309","provinceCode":"33"},{"code":"331002","name":"椒江区","cityCode":"3310","provinceCode":"33"},{"code":"331003","name":"黄岩区","cityCode":"3310","provinceCode":"33"},{"code":"331004","name":"路桥区","cityCode":"3310","provinceCode":"33"},{"code":"331022","name":"三门县","cityCode":"3310","provinceCode":"33"},{"code":"331023","name":"天台县","cityCode":"3310","provinceCode":"33"},{"code":"331024","name":"仙居县","cityCode":"3310","provinceCode":"33"},{"code":"331081","name":"温岭市","cityCode":"3310","provinceCode":"33"},{"code":"331082","name":"临海市","cityCode":"3310","provinceCode":"33"},{"code":"331083","name":"玉环市","cityCode":"3310","provinceCode":"33"},{"code":"331102","name":"莲都区","cityCode":"3311","provinceCode":"33"},{"code":"331121","name":"青田县","cityCode":"3311","provinceCode":"33"},{"code":"331122","name":"缙云县","cityCode":"3311","provinceCode":"33"},{"code":"331123","name":"遂昌县","cityCode":"3311","provinceCode":"33"},{"code":"331124","name":"松阳县","cityCode":"3311","provinceCode":"33"},{"code":"331125","name":"云和县","cityCode":"3311","provinceCode":"33"},{"code":"331126","name":"庆元县","cityCode":"3311","provinceCode":"33"},{"code":"331127","name":"景宁畲族自治县","cityCode":"3311","provinceCode":"33"},{"code":"331181","name":"龙泉市","cityCode":"3311","provinceCode":"33"},{"code":"340102","name":"瑶海区","cityCode":"3401","provinceCode":"34"},{"code":"340103","name":"庐阳区","cityCode":"3401","provinceCode":"34"},{"code":"340104","name":"蜀山区","cityCode":"3401","provinceCode":"34"},{"code":"340111","name":"包河区","cityCode":"3401","provinceCode":"34"},{"code":"340121","name":"长丰县","cityCode":"3401","provinceCode":"34"},{"code":"340122","name":"肥东县","cityCode":"3401","provinceCode":"34"},{"code":"340123","name":"肥西县","cityCode":"3401","provinceCode":"34"},{"code":"340124","name":"庐江县","cityCode":"3401","provinceCode":"34"},{"code":"340176","name":"合肥高新技术产业开发区","cityCode":"3401","provinceCode":"34"},{"code":"340177","name":"合肥经济技术开发区","cityCode":"3401","provinceCode":"34"},{"code":"340178","name":"合肥新站高新技术产业开发区","cityCode":"3401","provinceCode":"34"},{"code":"340181","name":"巢湖市","cityCode":"3401","provinceCode":"34"},{"code":"340202","name":"镜湖区","cityCode":"3402","provinceCode":"34"},{"code":"340207","name":"鸠江区","cityCode":"3402","provinceCode":"34"},{"code":"340209","name":"弋江区","cityCode":"3402","provinceCode":"34"},{"code":"340210","name":"湾沚区","cityCode":"3402","provinceCode":"34"},{"code":"340212","name":"繁昌区","cityCode":"3402","provinceCode":"34"},{"code":"340223","name":"南陵县","cityCode":"3402","provinceCode":"34"},{"code":"340271","name":"芜湖经济技术开发区","cityCode":"3402","provinceCode":"34"},{"code":"340272","name":"安徽芜湖三山经济开发区","cityCode":"3402","provinceCode":"34"},{"code":"340281","name":"无为市","cityCode":"3402","provinceCode":"34"},{"code":"340302","name":"龙子湖区","cityCode":"3403","provinceCode":"34"},{"code":"340303","name":"蚌山区","cityCode":"3403","provinceCode":"34"},{"code":"340304","name":"禹会区","cityCode":"3403","provinceCode":"34"},{"code":"340311","name":"淮上区","cityCode":"3403","provinceCode":"34"},{"code":"340321","name":"怀远县","cityCode":"3403","provinceCode":"34"},{"code":"340322","name":"五河县","cityCode":"3403","provinceCode":"34"},{"code":"340323","name":"固镇县","cityCode":"3403","provinceCode":"34"},{"code":"340371","name":"蚌埠市高新技术开发区","cityCode":"3403","provinceCode":"34"},{"code":"340372","name":"蚌埠市经济开发区","cityCode":"3403","provinceCode":"34"},{"code":"340402","name":"大通区","cityCode":"3404","provinceCode":"34"},{"code":"340403","name":"田家庵区","cityCode":"3404","provinceCode":"34"},{"code":"340404","name":"谢家集区","cityCode":"3404","provinceCode":"34"},{"code":"340405","name":"八公山区","cityCode":"3404","provinceCode":"34"},{"code":"340406","name":"潘集区","cityCode":"3404","provinceCode":"34"},{"code":"340421","name":"凤台县","cityCode":"3404","provinceCode":"34"},{"code":"340422","name":"寿县","cityCode":"3404","provinceCode":"34"},{"code":"340503","name":"花山区","cityCode":"3405","provinceCode":"34"},{"code":"340504","name":"雨山区","cityCode":"3405","provinceCode":"34"},{"code":"340506","name":"博望区","cityCode":"3405","provinceCode":"34"},{"code":"340521","name":"当涂县","cityCode":"3405","provinceCode":"34"},{"code":"340522","name":"含山县","cityCode":"3405","provinceCode":"34"},{"code":"340523","name":"和县","cityCode":"3405","provinceCode":"34"},{"code":"340602","name":"杜集区","cityCode":"3406","provinceCode":"34"},{"code":"340603","name":"相山区","cityCode":"3406","provinceCode":"34"},{"code":"340604","name":"烈山区","cityCode":"3406","provinceCode":"34"},{"code":"340621","name":"濉溪县","cityCode":"3406","provinceCode":"34"},{"code":"340705","name":"铜官区","cityCode":"3407","provinceCode":"34"},{"code":"340706","name":"义安区","cityCode":"3407","provinceCode":"34"},{"code":"340711","name":"郊区","cityCode":"3407","provinceCode":"34"},{"code":"340722","name":"枞阳县","cityCode":"3407","provinceCode":"34"},{"code":"340802","name":"迎江区","cityCode":"3408","provinceCode":"34"},{"code":"340803","name":"大观区","cityCode":"3408","provinceCode":"34"},{"code":"340811","name":"宜秀区","cityCode":"3408","provinceCode":"34"},{"code":"340822","name":"怀宁县","cityCode":"3408","provinceCode":"34"},{"code":"340825","name":"太湖县","cityCode":"3408","provinceCode":"34"},{"code":"340826","name":"宿松县","cityCode":"3408","provinceCode":"34"},{"code":"340827","name":"望江县","cityCode":"3408","provinceCode":"34"},{"code":"340828","name":"岳西县","cityCode":"3408","provinceCode":"34"},{"code":"340871","name":"安徽安庆经济开发区","cityCode":"3408","provinceCode":"34"},{"code":"340881","name":"桐城市","cityCode":"3408","provinceCode":"34"},{"code":"340882","name":"潜山市","cityCode":"3408","provinceCode":"34"},{"code":"341002","name":"屯溪区","cityCode":"3410","provinceCode":"34"},{"code":"341003","name":"黄山区","cityCode":"3410","provinceCode":"34"},{"code":"341004","name":"徽州区","cityCode":"3410","provinceCode":"34"},{"code":"341021","name":"歙县","cityCode":"3410","provinceCode":"34"},{"code":"341022","name":"休宁县","cityCode":"3410","provinceCode":"34"},{"code":"341023","name":"黟县","cityCode":"3410","provinceCode":"34"},{"code":"341024","name":"祁门县","cityCode":"3410","provinceCode":"34"},{"code":"341102","name":"琅琊区","cityCode":"3411","provinceCode":"34"},{"code":"341103","name":"南谯区","cityCode":"3411","provinceCode":"34"},{"code":"341122","name":"来安县","cityCode":"3411","provinceCode":"34"},{"code":"341124","name":"全椒县","cityCode":"3411","provinceCode":"34"},{"code":"341125","name":"定远县","cityCode":"3411","provinceCode":"34"},{"code":"341126","name":"凤阳县","cityCode":"3411","provinceCode":"34"},{"code":"341171","name":"中新苏滁高新技术产业开发区","cityCode":"3411","provinceCode":"34"},{"code":"341172","name":"滁州经济技术开发区","cityCode":"3411","provinceCode":"34"},{"code":"341181","name":"天长市","cityCode":"3411","provinceCode":"34"},{"code":"341182","name":"明光市","cityCode":"3411","provinceCode":"34"},{"code":"341202","name":"颍州区","cityCode":"3412","provinceCode":"34"},{"code":"341203","name":"颍东区","cityCode":"3412","provinceCode":"34"},{"code":"341204","name":"颍泉区","cityCode":"3412","provinceCode":"34"},{"code":"341221","name":"临泉县","cityCode":"3412","provinceCode":"34"},{"code":"341222","name":"太和县","cityCode":"3412","provinceCode":"34"},{"code":"341225","name":"阜南县","cityCode":"3412","provinceCode":"34"},{"code":"341226","name":"颍上县","cityCode":"3412","provinceCode":"34"},{"code":"341271","name":"阜阳合肥现代产业园区","cityCode":"3412","provinceCode":"34"},{"code":"341272","name":"阜阳经济技术开发区","cityCode":"3412","provinceCode":"34"},{"code":"341282","name":"界首市","cityCode":"3412","provinceCode":"34"},{"code":"341302","name":"埇桥区","cityCode":"3413","provinceCode":"34"},{"code":"341321","name":"砀山县","cityCode":"3413","provinceCode":"34"},{"code":"341322","name":"萧县","cityCode":"3413","provinceCode":"34"},{"code":"341323","name":"灵璧县","cityCode":"3413","provinceCode":"34"},{"code":"341324","name":"泗县","cityCode":"3413","provinceCode":"34"},{"code":"341371","name":"宿州马鞍山现代产业园区","cityCode":"3413","provinceCode":"34"},{"code":"341372","name":"宿州经济技术开发区","cityCode":"3413","provinceCode":"34"},{"code":"341502","name":"金安区","cityCode":"3415","provinceCode":"34"},{"code":"341503","name":"裕安区","cityCode":"3415","provinceCode":"34"},{"code":"341504","name":"叶集区","cityCode":"3415","provinceCode":"34"},{"code":"341522","name":"霍邱县","cityCode":"3415","provinceCode":"34"},{"code":"341523","name":"舒城县","cityCode":"3415","provinceCode":"34"},{"code":"341524","name":"金寨县","cityCode":"3415","provinceCode":"34"},{"code":"341525","name":"霍山县","cityCode":"3415","provinceCode":"34"},{"code":"341602","name":"谯城区","cityCode":"3416","provinceCode":"34"},{"code":"341621","name":"涡阳县","cityCode":"3416","provinceCode":"34"},{"code":"341622","name":"蒙城县","cityCode":"3416","provinceCode":"34"},{"code":"341623","name":"利辛县","cityCode":"3416","provinceCode":"34"},{"code":"341702","name":"贵池区","cityCode":"3417","provinceCode":"34"},{"code":"341721","name":"东至县","cityCode":"3417","provinceCode":"34"},{"code":"341722","name":"石台县","cityCode":"3417","provinceCode":"34"},{"code":"341723","name":"青阳县","cityCode":"3417","provinceCode":"34"},{"code":"341802","name":"宣州区","cityCode":"3418","provinceCode":"34"},{"code":"341821","name":"郎溪县","cityCode":"3418","provinceCode":"34"},{"code":"341823","name":"泾县","cityCode":"3418","provinceCode":"34"},{"code":"341824","name":"绩溪县","cityCode":"3418","provinceCode":"34"},{"code":"341825","name":"旌德县","cityCode":"3418","provinceCode":"34"},{"code":"341871","name":"宣城市经济开发区","cityCode":"3418","provinceCode":"34"},{"code":"341881","name":"宁国市","cityCode":"3418","provinceCode":"34"},{"code":"341882","name":"广德市","cityCode":"3418","provinceCode":"34"},{"code":"350102","name":"鼓楼区","cityCode":"3501","provinceCode":"35"},{"code":"350103","name":"台江区","cityCode":"3501","provinceCode":"35"},{"code":"350104","name":"仓山区","cityCode":"3501","provinceCode":"35"},{"code":"350105","name":"马尾区","cityCode":"3501","provinceCode":"35"},{"code":"350111","name":"晋安区","cityCode":"3501","provinceCode":"35"},{"code":"350112","name":"长乐区","cityCode":"3501","provinceCode":"35"},{"code":"350121","name":"闽侯县","cityCode":"3501","provinceCode":"35"},{"code":"350122","name":"连江县","cityCode":"3501","provinceCode":"35"},{"code":"350123","name":"罗源县","cityCode":"3501","provinceCode":"35"},{"code":"350124","name":"闽清县","cityCode":"3501","provinceCode":"35"},{"code":"350125","name":"永泰县","cityCode":"3501","provinceCode":"35"},{"code":"350128","name":"平潭县","cityCode":"3501","provinceCode":"35"},{"code":"350181","name":"福清市","cityCode":"3501","provinceCode":"35"},{"code":"350203","name":"思明区","cityCode":"3502","provinceCode":"35"},{"code":"350205","name":"海沧区","cityCode":"3502","provinceCode":"35"},{"code":"350206","name":"湖里区","cityCode":"3502","provinceCode":"35"},{"code":"350211","name":"集美区","cityCode":"3502","provinceCode":"35"},{"code":"350212","name":"同安区","cityCode":"3502","provinceCode":"35"},{"code":"350213","name":"翔安区","cityCode":"3502","provinceCode":"35"},{"code":"350302","name":"城厢区","cityCode":"3503","provinceCode":"35"},{"code":"350303","name":"涵江区","cityCode":"3503","provinceCode":"35"},{"code":"350304","name":"荔城区","cityCode":"3503","provinceCode":"35"},{"code":"350305","name":"秀屿区","cityCode":"3503","provinceCode":"35"},{"code":"350322","name":"仙游县","cityCode":"3503","provinceCode":"35"},{"code":"350404","name":"三元区","cityCode":"3504","provinceCode":"35"},{"code":"350405","name":"沙县区","cityCode":"3504","provinceCode":"35"},{"code":"350421","name":"明溪县","cityCode":"3504","provinceCode":"35"},{"code":"350423","name":"清流县","cityCode":"3504","provinceCode":"35"},{"code":"350424","name":"宁化县","cityCode":"3504","provinceCode":"35"},{"code":"350425","name":"大田县","cityCode":"3504","provinceCode":"35"},{"code":"350426","name":"尤溪县","cityCode":"3504","provinceCode":"35"},{"code":"350428","name":"将乐县","cityCode":"3504","provinceCode":"35"},{"code":"350429","name":"泰宁县","cityCode":"3504","provinceCode":"35"},{"code":"350430","name":"建宁县","cityCode":"3504","provinceCode":"35"},{"code":"350481","name":"永安市","cityCode":"3504","provinceCode":"35"},{"code":"350502","name":"鲤城区","cityCode":"3505","provinceCode":"35"},{"code":"350503","name":"丰泽区","cityCode":"3505","provinceCode":"35"},{"code":"350504","name":"洛江区","cityCode":"3505","provinceCode":"35"},{"code":"350505","name":"泉港区","cityCode":"3505","provinceCode":"35"},{"code":"350521","name":"惠安县","cityCode":"3505","provinceCode":"35"},{"code":"350524","name":"安溪县","cityCode":"3505","provinceCode":"35"},{"code":"350525","name":"永春县","cityCode":"3505","provinceCode":"35"},{"code":"350526","name":"德化县","cityCode":"3505","provinceCode":"35"},{"code":"350527","name":"金门县","cityCode":"3505","provinceCode":"35"},{"code":"350581","name":"石狮市","cityCode":"3505","provinceCode":"35"},{"code":"350582","name":"晋江市","cityCode":"3505","provinceCode":"35"},{"code":"350583","name":"南安市","cityCode":"3505","provinceCode":"35"},{"code":"350602","name":"芗城区","cityCode":"3506","provinceCode":"35"},{"code":"350603","name":"龙文区","cityCode":"3506","provinceCode":"35"},{"code":"350604","name":"龙海区","cityCode":"3506","provinceCode":"35"},{"code":"350605","name":"长泰区","cityCode":"3506","provinceCode":"35"},{"code":"350622","name":"云霄县","cityCode":"3506","provinceCode":"35"},{"code":"350623","name":"漳浦县","cityCode":"3506","provinceCode":"35"},{"code":"350624","name":"诏安县","cityCode":"3506","provinceCode":"35"},{"code":"350626","name":"东山县","cityCode":"3506","provinceCode":"35"},{"code":"350627","name":"南靖县","cityCode":"3506","provinceCode":"35"},{"code":"350628","name":"平和县","cityCode":"3506","provinceCode":"35"},{"code":"350629","name":"华安县","cityCode":"3506","provinceCode":"35"},{"code":"350702","name":"延平区","cityCode":"3507","provinceCode":"35"},{"code":"350703","name":"建阳区","cityCode":"3507","provinceCode":"35"},{"code":"350721","name":"顺昌县","cityCode":"3507","provinceCode":"35"},{"code":"350722","name":"浦城县","cityCode":"3507","provinceCode":"35"},{"code":"350723","name":"光泽县","cityCode":"3507","provinceCode":"35"},{"code":"350724","name":"松溪县","cityCode":"3507","provinceCode":"35"},{"code":"350725","name":"政和县","cityCode":"3507","provinceCode":"35"},{"code":"350781","name":"邵武市","cityCode":"3507","provinceCode":"35"},{"code":"350782","name":"武夷山市","cityCode":"3507","provinceCode":"35"},{"code":"350783","name":"建瓯市","cityCode":"3507","provinceCode":"35"},{"code":"350802","name":"新罗区","cityCode":"3508","provinceCode":"35"},{"code":"350803","name":"永定区","cityCode":"3508","provinceCode":"35"},{"code":"350821","name":"长汀县","cityCode":"3508","provinceCode":"35"},{"code":"350823","name":"上杭县","cityCode":"3508","provinceCode":"35"},{"code":"350824","name":"武平县","cityCode":"3508","provinceCode":"35"},{"code":"350825","name":"连城县","cityCode":"3508","provinceCode":"35"},{"code":"350881","name":"漳平市","cityCode":"3508","provinceCode":"35"},{"code":"350902","name":"蕉城区","cityCode":"3509","provinceCode":"35"},{"code":"350921","name":"霞浦县","cityCode":"3509","provinceCode":"35"},{"code":"350922","name":"古田县","cityCode":"3509","provinceCode":"35"},{"code":"350923","name":"屏南县","cityCode":"3509","provinceCode":"35"},{"code":"350924","name":"寿宁县","cityCode":"3509","provinceCode":"35"},{"code":"350925","name":"周宁县","cityCode":"3509","provinceCode":"35"},{"code":"350926","name":"柘荣县","cityCode":"3509","provinceCode":"35"},{"code":"350981","name":"福安市","cityCode":"3509","provinceCode":"35"},{"code":"350982","name":"福鼎市","cityCode":"3509","provinceCode":"35"},{"code":"360102","name":"东湖区","cityCode":"3601","provinceCode":"36"},{"code":"360103","name":"西湖区","cityCode":"3601","provinceCode":"36"},{"code":"360104","name":"青云谱区","cityCode":"3601","provinceCode":"36"},{"code":"360111","name":"青山湖区","cityCode":"3601","provinceCode":"36"},{"code":"360112","name":"新建区","cityCode":"3601","provinceCode":"36"},{"code":"360113","name":"红谷滩区","cityCode":"3601","provinceCode":"36"},{"code":"360121","name":"南昌县","cityCode":"3601","provinceCode":"36"},{"code":"360123","name":"安义县","cityCode":"3601","provinceCode":"36"},{"code":"360124","name":"进贤县","cityCode":"3601","provinceCode":"36"},{"code":"360202","name":"昌江区","cityCode":"3602","provinceCode":"36"},{"code":"360203","name":"珠山区","cityCode":"3602","provinceCode":"36"},{"code":"360222","name":"浮梁县","cityCode":"3602","provinceCode":"36"},{"code":"360281","name":"乐平市","cityCode":"3602","provinceCode":"36"},{"code":"360302","name":"安源区","cityCode":"3603","provinceCode":"36"},{"code":"360313","name":"湘东区","cityCode":"3603","provinceCode":"36"},{"code":"360321","name":"莲花县","cityCode":"3603","provinceCode":"36"},{"code":"360322","name":"上栗县","cityCode":"3603","provinceCode":"36"},{"code":"360323","name":"芦溪县","cityCode":"3603","provinceCode":"36"},{"code":"360402","name":"濂溪区","cityCode":"3604","provinceCode":"36"},{"code":"360403","name":"浔阳区","cityCode":"3604","provinceCode":"36"},{"code":"360404","name":"柴桑区","cityCode":"3604","provinceCode":"36"},{"code":"360423","name":"武宁县","cityCode":"3604","provinceCode":"36"},{"code":"360424","name":"修水县","cityCode":"3604","provinceCode":"36"},{"code":"360425","name":"永修县","cityCode":"3604","provinceCode":"36"},{"code":"360426","name":"德安县","cityCode":"3604","provinceCode":"36"},{"code":"360428","name":"都昌县","cityCode":"3604","provinceCode":"36"},{"code":"360429","name":"湖口县","cityCode":"3604","provinceCode":"36"},{"code":"360430","name":"彭泽县","cityCode":"3604","provinceCode":"36"},{"code":"360481","name":"瑞昌市","cityCode":"3604","provinceCode":"36"},{"code":"360482","name":"共青城市","cityCode":"3604","provinceCode":"36"},{"code":"360483","name":"庐山市","cityCode":"3604","provinceCode":"36"},{"code":"360502","name":"渝水区","cityCode":"3605","provinceCode":"36"},{"code":"360521","name":"分宜县","cityCode":"3605","provinceCode":"36"},{"code":"360602","name":"月湖区","cityCode":"3606","provinceCode":"36"},{"code":"360603","name":"余江区","cityCode":"3606","provinceCode":"36"},{"code":"360681","name":"贵溪市","cityCode":"3606","provinceCode":"36"},{"code":"360702","name":"章贡区","cityCode":"3607","provinceCode":"36"},{"code":"360703","name":"南康区","cityCode":"3607","provinceCode":"36"},{"code":"360704","name":"赣县区","cityCode":"3607","provinceCode":"36"},{"code":"360722","name":"信丰县","cityCode":"3607","provinceCode":"36"},{"code":"360723","name":"大余县","cityCode":"3607","provinceCode":"36"},{"code":"360724","name":"上犹县","cityCode":"3607","provinceCode":"36"},{"code":"360725","name":"崇义县","cityCode":"3607","provinceCode":"36"},{"code":"360726","name":"安远县","cityCode":"3607","provinceCode":"36"},{"code":"360728","name":"定南县","cityCode":"3607","provinceCode":"36"},{"code":"360729","name":"全南县","cityCode":"3607","provinceCode":"36"},{"code":"360730","name":"宁都县","cityCode":"3607","provinceCode":"36"},{"code":"360731","name":"于都县","cityCode":"3607","provinceCode":"36"},{"code":"360732","name":"兴国县","cityCode":"3607","provinceCode":"36"},{"code":"360733","name":"会昌县","cityCode":"3607","provinceCode":"36"},{"code":"360734","name":"寻乌县","cityCode":"3607","provinceCode":"36"},{"code":"360735","name":"石城县","cityCode":"3607","provinceCode":"36"},{"code":"360781","name":"瑞金市","cityCode":"3607","provinceCode":"36"},{"code":"360783","name":"龙南市","cityCode":"3607","provinceCode":"36"},{"code":"360802","name":"吉州区","cityCode":"3608","provinceCode":"36"},{"code":"360803","name":"青原区","cityCode":"3608","provinceCode":"36"},{"code":"360821","name":"吉安县","cityCode":"3608","provinceCode":"36"},{"code":"360822","name":"吉水县","cityCode":"3608","provinceCode":"36"},{"code":"360823","name":"峡江县","cityCode":"3608","provinceCode":"36"},{"code":"360824","name":"新干县","cityCode":"3608","provinceCode":"36"},{"code":"360825","name":"永丰县","cityCode":"3608","provinceCode":"36"},{"code":"360826","name":"泰和县","cityCode":"3608","provinceCode":"36"},{"code":"360827","name":"遂川县","cityCode":"3608","provinceCode":"36"},{"code":"360828","name":"万安县","cityCode":"3608","provinceCode":"36"},{"code":"360829","name":"安福县","cityCode":"3608","provinceCode":"36"},{"code":"360830","name":"永新县","cityCode":"3608","provinceCode":"36"},{"code":"360881","name":"井冈山市","cityCode":"3608","provinceCode":"36"},{"code":"360902","name":"袁州区","cityCode":"3609","provinceCode":"36"},{"code":"360921","name":"奉新县","cityCode":"3609","provinceCode":"36"},{"code":"360922","name":"万载县","cityCode":"3609","provinceCode":"36"},{"code":"360923","name":"上高县","cityCode":"3609","provinceCode":"36"},{"code":"360924","name":"宜丰县","cityCode":"3609","provinceCode":"36"},{"code":"360925","name":"靖安县","cityCode":"3609","provinceCode":"36"},{"code":"360926","name":"铜鼓县","cityCode":"3609","provinceCode":"36"},{"code":"360981","name":"丰城市","cityCode":"3609","provinceCode":"36"},{"code":"360982","name":"樟树市","cityCode":"3609","provinceCode":"36"},{"code":"360983","name":"高安市","cityCode":"3609","provinceCode":"36"},{"code":"361002","name":"临川区","cityCode":"3610","provinceCode":"36"},{"code":"361003","name":"东乡区","cityCode":"3610","provinceCode":"36"},{"code":"361021","name":"南城县","cityCode":"3610","provinceCode":"36"},{"code":"361022","name":"黎川县","cityCode":"3610","provinceCode":"36"},{"code":"361023","name":"南丰县","cityCode":"3610","provinceCode":"36"},{"code":"361024","name":"崇仁县","cityCode":"3610","provinceCode":"36"},{"code":"361025","name":"乐安县","cityCode":"3610","provinceCode":"36"},{"code":"361026","name":"宜黄县","cityCode":"3610","provinceCode":"36"},{"code":"361027","name":"金溪县","cityCode":"3610","provinceCode":"36"},{"code":"361028","name":"资溪县","cityCode":"3610","provinceCode":"36"},{"code":"361030","name":"广昌县","cityCode":"3610","provinceCode":"36"},{"code":"361102","name":"信州区","cityCode":"3611","provinceCode":"36"},{"code":"361103","name":"广丰区","cityCode":"3611","provinceCode":"36"},{"code":"361104","name":"广信区","cityCode":"3611","provinceCode":"36"},{"code":"361123","name":"玉山县","cityCode":"3611","provinceCode":"36"},{"code":"361124","name":"铅山县","cityCode":"3611","provinceCode":"36"},{"code":"361125","name":"横峰县","cityCode":"3611","provinceCode":"36"},{"code":"361126","name":"弋阳县","cityCode":"3611","provinceCode":"36"},{"code":"361127","name":"余干县","cityCode":"3611","provinceCode":"36"},{"code":"361128","name":"鄱阳县","cityCode":"3611","provinceCode":"36"},{"code":"361129","name":"万年县","cityCode":"3611","provinceCode":"36"},{"code":"361130","name":"婺源县","cityCode":"3611","provinceCode":"36"},{"code":"361181","name":"德兴市","cityCode":"3611","provinceCode":"36"},{"code":"370102","name":"历下区","cityCode":"3701","provinceCode":"37"},{"code":"370103","name":"市中区","cityCode":"3701","provinceCode":"37"},{"code":"370104","name":"槐荫区","cityCode":"3701","provinceCode":"37"},{"code":"370105","name":"天桥区","cityCode":"3701","provinceCode":"37"},{"code":"370112","name":"历城区","cityCode":"3701","provinceCode":"37"},{"code":"370113","name":"长清区","cityCode":"3701","provinceCode":"37"},{"code":"370114","name":"章丘区","cityCode":"3701","provinceCode":"37"},{"code":"370115","name":"济阳区","cityCode":"3701","provinceCode":"37"},{"code":"370116","name":"莱芜区","cityCode":"3701","provinceCode":"37"},{"code":"370117","name":"钢城区","cityCode":"3701","provinceCode":"37"},{"code":"370124","name":"平阴县","cityCode":"3701","provinceCode":"37"},{"code":"370126","name":"商河县","cityCode":"3701","provinceCode":"37"},{"code":"370176","name":"济南高新技术产业开发区","cityCode":"3701","provinceCode":"37"},{"code":"370202","name":"市南区","cityCode":"3702","provinceCode":"37"},{"code":"370203","name":"市北区","cityCode":"3702","provinceCode":"37"},{"code":"370211","name":"黄岛区","cityCode":"3702","provinceCode":"37"},{"code":"370212","name":"崂山区","cityCode":"3702","provinceCode":"37"},{"code":"370213","name":"李沧区","cityCode":"3702","provinceCode":"37"},{"code":"370214","name":"城阳区","cityCode":"3702","provinceCode":"37"},{"code":"370215","name":"即墨区","cityCode":"3702","provinceCode":"37"},{"code":"370281","name":"胶州市","cityCode":"3702","provinceCode":"37"},{"code":"370283","name":"平度市","cityCode":"3702","provinceCode":"37"},{"code":"370285","name":"莱西市","cityCode":"3702","provinceCode":"37"},{"code":"370302","name":"淄川区","cityCode":"3703","provinceCode":"37"},{"code":"370303","name":"张店区","cityCode":"3703","provinceCode":"37"},{"code":"370304","name":"博山区","cityCode":"3703","provinceCode":"37"},{"code":"370305","name":"临淄区","cityCode":"3703","provinceCode":"37"},{"code":"370306","name":"周村区","cityCode":"3703","provinceCode":"37"},{"code":"370321","name":"桓台县","cityCode":"3703","provinceCode":"37"},{"code":"370322","name":"高青县","cityCode":"3703","provinceCode":"37"},{"code":"370323","name":"沂源县","cityCode":"3703","provinceCode":"37"},{"code":"370402","name":"市中区","cityCode":"3704","provinceCode":"37"},{"code":"370403","name":"薛城区","cityCode":"3704","provinceCode":"37"},{"code":"370404","name":"峄城区","cityCode":"3704","provinceCode":"37"},{"code":"370405","name":"台儿庄区","cityCode":"3704","provinceCode":"37"},{"code":"370406","name":"山亭区","cityCode":"3704","provinceCode":"37"},{"code":"370481","name":"滕州市","cityCode":"3704","provinceCode":"37"},{"code":"370502","name":"东营区","cityCode":"3705","provinceCode":"37"},{"code":"370503","name":"河口区","cityCode":"3705","provinceCode":"37"},{"code":"370505","name":"垦利区","cityCode":"3705","provinceCode":"37"},{"code":"370522","name":"利津县","cityCode":"3705","provinceCode":"37"},{"code":"370523","name":"广饶县","cityCode":"3705","provinceCode":"37"},{"code":"370571","name":"东营经济技术开发区","cityCode":"3705","provinceCode":"37"},{"code":"370572","name":"东营港经济开发区","cityCode":"3705","provinceCode":"37"},{"code":"370602","name":"芝罘区","cityCode":"3706","provinceCode":"37"},{"code":"370611","name":"福山区","cityCode":"3706","provinceCode":"37"},{"code":"370612","name":"牟平区","cityCode":"3706","provinceCode":"37"},{"code":"370613","name":"莱山区","cityCode":"3706","provinceCode":"37"},{"code":"370614","name":"蓬莱区","cityCode":"3706","provinceCode":"37"},{"code":"370671","name":"烟台高新技术产业开发区","cityCode":"3706","provinceCode":"37"},{"code":"370676","name":"烟台经济技术开发区","cityCode":"3706","provinceCode":"37"},{"code":"370681","name":"龙口市","cityCode":"3706","provinceCode":"37"},{"code":"370682","name":"莱阳市","cityCode":"3706","provinceCode":"37"},{"code":"370683","name":"莱州市","cityCode":"3706","provinceCode":"37"},{"code":"370685","name":"招远市","cityCode":"3706","provinceCode":"37"},{"code":"370686","name":"栖霞市","cityCode":"3706","provinceCode":"37"},{"code":"370687","name":"海阳市","cityCode":"3706","provinceCode":"37"},{"code":"370702","name":"潍城区","cityCode":"3707","provinceCode":"37"},{"code":"370703","name":"寒亭区","cityCode":"3707","provinceCode":"37"},{"code":"370704","name":"坊子区","cityCode":"3707","provinceCode":"37"},{"code":"370705","name":"奎文区","cityCode":"3707","provinceCode":"37"},{"code":"370724","name":"临朐县","cityCode":"3707","provinceCode":"37"},{"code":"370725","name":"昌乐县","cityCode":"3707","provinceCode":"37"},{"code":"370772","name":"潍坊滨海经济技术开发区","cityCode":"3707","provinceCode":"37"},{"code":"370781","name":"青州市","cityCode":"3707","provinceCode":"37"},{"code":"370782","name":"诸城市","cityCode":"3707","provinceCode":"37"},{"code":"370783","name":"寿光市","cityCode":"3707","provinceCode":"37"},{"code":"370784","name":"安丘市","cityCode":"3707","provinceCode":"37"},{"code":"370785","name":"高密市","cityCode":"3707","provinceCode":"37"},{"code":"370786","name":"昌邑市","cityCode":"3707","provinceCode":"37"},{"code":"370811","name":"任城区","cityCode":"3708","provinceCode":"37"},{"code":"370812","name":"兖州区","cityCode":"3708","provinceCode":"37"},{"code":"370826","name":"微山县","cityCode":"3708","provinceCode":"37"},{"code":"370827","name":"鱼台县","cityCode":"3708","provinceCode":"37"},{"code":"370828","name":"金乡县","cityCode":"3708","provinceCode":"37"},{"code":"370829","name":"嘉祥县","cityCode":"3708","provinceCode":"37"},{"code":"370830","name":"汶上县","cityCode":"3708","provinceCode":"37"},{"code":"370831","name":"泗水县","cityCode":"3708","provinceCode":"37"},{"code":"370832","name":"梁山县","cityCode":"3708","provinceCode":"37"},{"code":"370871","name":"济宁高新技术产业开发区","cityCode":"3708","provinceCode":"37"},{"code":"370881","name":"曲阜市","cityCode":"3708","provinceCode":"37"},{"code":"370883","name":"邹城市","cityCode":"3708","provinceCode":"37"},{"code":"370902","name":"泰山区","cityCode":"3709","provinceCode":"37"},{"code":"370911","name":"岱岳区","cityCode":"3709","provinceCode":"37"},{"code":"370921","name":"宁阳县","cityCode":"3709","provinceCode":"37"},{"code":"370923","name":"东平县","cityCode":"3709","provinceCode":"37"},{"code":"370982","name":"新泰市","cityCode":"3709","provinceCode":"37"},{"code":"370983","name":"肥城市","cityCode":"3709","provinceCode":"37"},{"code":"371002","name":"环翠区","cityCode":"3710","provinceCode":"37"},{"code":"371003","name":"文登区","cityCode":"3710","provinceCode":"37"},{"code":"371071","name":"威海火炬高技术产业开发区","cityCode":"3710","provinceCode":"37"},{"code":"371072","name":"威海经济技术开发区","cityCode":"3710","provinceCode":"37"},{"code":"371073","name":"威海临港经济技术开发区","cityCode":"3710","provinceCode":"37"},{"code":"371082","name":"荣成市","cityCode":"3710","provinceCode":"37"},{"code":"371083","name":"乳山市","cityCode":"3710","provinceCode":"37"},{"code":"371102","name":"东港区","cityCode":"3711","provinceCode":"37"},{"code":"371103","name":"岚山区","cityCode":"3711","provinceCode":"37"},{"code":"371121","name":"五莲县","cityCode":"3711","provinceCode":"37"},{"code":"371122","name":"莒县","cityCode":"3711","provinceCode":"37"},{"code":"371171","name":"日照经济技术开发区","cityCode":"3711","provinceCode":"37"},{"code":"371302","name":"兰山区","cityCode":"3713","provinceCode":"37"},{"code":"371311","name":"罗庄区","cityCode":"3713","provinceCode":"37"},{"code":"371312","name":"河东区","cityCode":"3713","provinceCode":"37"},{"code":"371321","name":"沂南县","cityCode":"3713","provinceCode":"37"},{"code":"371322","name":"郯城县","cityCode":"3713","provinceCode":"37"},{"code":"371323","name":"沂水县","cityCode":"3713","provinceCode":"37"},{"code":"371324","name":"兰陵县","cityCode":"3713","provinceCode":"37"},{"code":"371325","name":"费县","cityCode":"3713","provinceCode":"37"},{"code":"371326","name":"平邑县","cityCode":"3713","provinceCode":"37"},{"code":"371327","name":"莒南县","cityCode":"3713","provinceCode":"37"},{"code":"371328","name":"蒙阴县","cityCode":"3713","provinceCode":"37"},{"code":"371329","name":"临沭县","cityCode":"3713","provinceCode":"37"},{"code":"371371","name":"临沂高新技术产业开发区","cityCode":"3713","provinceCode":"37"},{"code":"371402","name":"德城区","cityCode":"3714","provinceCode":"37"},{"code":"371403","name":"陵城区","cityCode":"3714","provinceCode":"37"},{"code":"371422","name":"宁津县","cityCode":"3714","provinceCode":"37"},{"code":"371423","name":"庆云县","cityCode":"3714","provinceCode":"37"},{"code":"371424","name":"临邑县","cityCode":"3714","provinceCode":"37"},{"code":"371425","name":"齐河县","cityCode":"3714","provinceCode":"37"},{"code":"371426","name":"平原县","cityCode":"3714","provinceCode":"37"},{"code":"371427","name":"夏津县","cityCode":"3714","provinceCode":"37"},{"code":"371428","name":"武城县","cityCode":"3714","provinceCode":"37"},{"code":"371471","name":"德州天衢新区","cityCode":"3714","provinceCode":"37"},{"code":"371481","name":"乐陵市","cityCode":"3714","provinceCode":"37"},{"code":"371482","name":"禹城市","cityCode":"3714","provinceCode":"37"},{"code":"371502","name":"东昌府区","cityCode":"3715","provinceCode":"37"},{"code":"371503","name":"茌平区","cityCode":"3715","provinceCode":"37"},{"code":"371521","name":"阳谷县","cityCode":"3715","provinceCode":"37"},{"code":"371522","name":"莘县","cityCode":"3715","provinceCode":"37"},{"code":"371524","name":"东阿县","cityCode":"3715","provinceCode":"37"},{"code":"371525","name":"冠县","cityCode":"3715","provinceCode":"37"},{"code":"371526","name":"高唐县","cityCode":"3715","provinceCode":"37"},{"code":"371581","name":"临清市","cityCode":"3715","provinceCode":"37"},{"code":"371602","name":"滨城区","cityCode":"3716","provinceCode":"37"},{"code":"371603","name":"沾化区","cityCode":"3716","provinceCode":"37"},{"code":"371621","name":"惠民县","cityCode":"3716","provinceCode":"37"},{"code":"371622","name":"阳信县","cityCode":"3716","provinceCode":"37"},{"code":"371623","name":"无棣县","cityCode":"3716","provinceCode":"37"},{"code":"371625","name":"博兴县","cityCode":"3716","provinceCode":"37"},{"code":"371681","name":"邹平市","cityCode":"3716","provinceCode":"37"},{"code":"371702","name":"牡丹区","cityCode":"3717","provinceCode":"37"},{"code":"371703","name":"定陶区","cityCode":"3717","provinceCode":"37"},{"code":"371721","name":"曹县","cityCode":"3717","provinceCode":"37"},{"code":"371722","name":"单县","cityCode":"3717","provinceCode":"37"},{"code":"371723","name":"成武县","cityCode":"3717","provinceCode":"37"},{"code":"371724","name":"巨野县","cityCode":"3717","provinceCode":"37"},{"code":"371725","name":"郓城县","cityCode":"3717","provinceCode":"37"},{"code":"371726","name":"鄄城县","cityCode":"3717","provinceCode":"37"},{"code":"371728","name":"东明县","cityCode":"3717","provinceCode":"37"},{"code":"371771","name":"菏泽经济技术开发区","cityCode":"3717","provinceCode":"37"},{"code":"371772","name":"菏泽高新技术开发区","cityCode":"3717","provinceCode":"37"},{"code":"410102","name":"中原区","cityCode":"4101","provinceCode":"41"},{"code":"410103","name":"二七区","cityCode":"4101","provinceCode":"41"},{"code":"410104","name":"管城回族区","cityCode":"4101","provinceCode":"41"},{"code":"410105","name":"金水区","cityCode":"4101","provinceCode":"41"},{"code":"410106","name":"上街区","cityCode":"4101","provinceCode":"41"},{"code":"410108","name":"惠济区","cityCode":"4101","provinceCode":"41"},{"code":"410122","name":"中牟县","cityCode":"4101","provinceCode":"41"},{"code":"410171","name":"郑州经济技术开发区","cityCode":"4101","provinceCode":"41"},{"code":"410172","name":"郑州高新技术产业开发区","cityCode":"4101","provinceCode":"41"},{"code":"410173","name":"郑州航空港经济综合实验区","cityCode":"4101","provinceCode":"41"},{"code":"410181","name":"巩义市","cityCode":"4101","provinceCode":"41"},{"code":"410182","name":"荥阳市","cityCode":"4101","provinceCode":"41"},{"code":"410183","name":"新密市","cityCode":"4101","provinceCode":"41"},{"code":"410184","name":"新郑市","cityCode":"4101","provinceCode":"41"},{"code":"410185","name":"登封市","cityCode":"4101","provinceCode":"41"},{"code":"410202","name":"龙亭区","cityCode":"4102","provinceCode":"41"},{"code":"410203","name":"顺河回族区","cityCode":"4102","provinceCode":"41"},{"code":"410204","name":"鼓楼区","cityCode":"4102","provinceCode":"41"},{"code":"410205","name":"禹王台区","cityCode":"4102","provinceCode":"41"},{"code":"410212","name":"祥符区","cityCode":"4102","provinceCode":"41"},{"code":"410221","name":"杞县","cityCode":"4102","provinceCode":"41"},{"code":"410222","name":"通许县","cityCode":"4102","provinceCode":"41"},{"code":"410223","name":"尉氏县","cityCode":"4102","provinceCode":"41"},{"code":"410225","name":"兰考县","cityCode":"4102","provinceCode":"41"},{"code":"410302","name":"老城区","cityCode":"4103","provinceCode":"41"},{"code":"410303","name":"西工区","cityCode":"4103","provinceCode":"41"},{"code":"410304","name":"瀍河回族区","cityCode":"4103","provinceCode":"41"},{"code":"410305","name":"涧西区","cityCode":"4103","provinceCode":"41"},{"code":"410307","name":"偃师区","cityCode":"4103","provinceCode":"41"},{"code":"410308","name":"孟津区","cityCode":"4103","provinceCode":"41"},{"code":"410311","name":"洛龙区","cityCode":"4103","provinceCode":"41"},{"code":"410323","name":"新安县","cityCode":"4103","provinceCode":"41"},{"code":"410324","name":"栾川县","cityCode":"4103","provinceCode":"41"},{"code":"410325","name":"嵩县","cityCode":"4103","provinceCode":"41"},{"code":"410326","name":"汝阳县","cityCode":"4103","provinceCode":"41"},{"code":"410327","name":"宜阳县","cityCode":"4103","provinceCode":"41"},{"code":"410328","name":"洛宁县","cityCode":"4103","provinceCode":"41"},{"code":"410329","name":"伊川县","cityCode":"4103","provinceCode":"41"},{"code":"410371","name":"洛阳高新技术产业开发区","cityCode":"4103","provinceCode":"41"},{"code":"410402","name":"新华区","cityCode":"4104","provinceCode":"41"},{"code":"410403","name":"卫东区","cityCode":"4104","provinceCode":"41"},{"code":"410404","name":"石龙区","cityCode":"4104","provinceCode":"41"},{"code":"410411","name":"湛河区","cityCode":"4104","provinceCode":"41"},{"code":"410421","name":"宝丰县","cityCode":"4104","provinceCode":"41"},{"code":"410422","name":"叶县","cityCode":"4104","provinceCode":"41"},{"code":"410423","name":"鲁山县","cityCode":"4104","provinceCode":"41"},{"code":"410425","name":"郏县","cityCode":"4104","provinceCode":"41"},{"code":"410471","name":"平顶山高新技术产业开发区","cityCode":"4104","provinceCode":"41"},{"code":"410472","name":"平顶山市城乡一体化示范区","cityCode":"4104","provinceCode":"41"},{"code":"410481","name":"舞钢市","cityCode":"4104","provinceCode":"41"},{"code":"410482","name":"汝州市","cityCode":"4104","provinceCode":"41"},{"code":"410502","name":"文峰区","cityCode":"4105","provinceCode":"41"},{"code":"410503","name":"北关区","cityCode":"4105","provinceCode":"41"},{"code":"410505","name":"殷都区","cityCode":"4105","provinceCode":"41"},{"code":"410506","name":"龙安区","cityCode":"4105","provinceCode":"41"},{"code":"410522","name":"安阳县","cityCode":"4105","provinceCode":"41"},{"code":"410523","name":"汤阴县","cityCode":"4105","provinceCode":"41"},{"code":"410526","name":"滑县","cityCode":"4105","provinceCode":"41"},{"code":"410527","name":"内黄县","cityCode":"4105","provinceCode":"41"},{"code":"410571","name":"安阳高新技术产业开发区","cityCode":"4105","provinceCode":"41"},{"code":"410581","name":"林州市","cityCode":"4105","provinceCode":"41"},{"code":"410602","name":"鹤山区","cityCode":"4106","provinceCode":"41"},{"code":"410603","name":"山城区","cityCode":"4106","provinceCode":"41"},{"code":"410611","name":"淇滨区","cityCode":"4106","provinceCode":"41"},{"code":"410621","name":"浚县","cityCode":"4106","provinceCode":"41"},{"code":"410622","name":"淇县","cityCode":"4106","provinceCode":"41"},{"code":"410671","name":"鹤壁经济技术开发区","cityCode":"4106","provinceCode":"41"},{"code":"410702","name":"红旗区","cityCode":"4107","provinceCode":"41"},{"code":"410703","name":"卫滨区","cityCode":"4107","provinceCode":"41"},{"code":"410704","name":"凤泉区","cityCode":"4107","provinceCode":"41"},{"code":"410711","name":"牧野区","cityCode":"4107","provinceCode":"41"},{"code":"410721","name":"新乡县","cityCode":"4107","provinceCode":"41"},{"code":"410724","name":"获嘉县","cityCode":"4107","provinceCode":"41"},{"code":"410725","name":"原阳县","cityCode":"4107","provinceCode":"41"},{"code":"410726","name":"延津县","cityCode":"4107","provinceCode":"41"},{"code":"410727","name":"封丘县","cityCode":"4107","provinceCode":"41"},{"code":"410771","name":"新乡高新技术产业开发区","cityCode":"4107","provinceCode":"41"},{"code":"410772","name":"新乡经济技术开发区","cityCode":"4107","provinceCode":"41"},{"code":"410773","name":"新乡市平原城乡一体化示范区","cityCode":"4107","provinceCode":"41"},{"code":"410781","name":"卫辉市","cityCode":"4107","provinceCode":"41"},{"code":"410782","name":"辉县市","cityCode":"4107","provinceCode":"41"},{"code":"410783","name":"长垣市","cityCode":"4107","provinceCode":"41"},{"code":"410802","name":"解放区","cityCode":"4108","provinceCode":"41"},{"code":"410803","name":"中站区","cityCode":"4108","provinceCode":"41"},{"code":"410804","name":"马村区","cityCode":"4108","provinceCode":"41"},{"code":"410811","name":"山阳区","cityCode":"4108","provinceCode":"41"},{"code":"410821","name":"修武县","cityCode":"4108","provinceCode":"41"},{"code":"410822","name":"博爱县","cityCode":"4108","provinceCode":"41"},{"code":"410823","name":"武陟县","cityCode":"4108","provinceCode":"41"},{"code":"410825","name":"温县","cityCode":"4108","provinceCode":"41"},{"code":"410871","name":"焦作城乡一体化示范区","cityCode":"4108","provinceCode":"41"},{"code":"410882","name":"沁阳市","cityCode":"4108","provinceCode":"41"},{"code":"410883","name":"孟州市","cityCode":"4108","provinceCode":"41"},{"code":"410902","name":"华龙区","cityCode":"4109","provinceCode":"41"},{"code":"410922","name":"清丰县","cityCode":"4109","provinceCode":"41"},{"code":"410923","name":"南乐县","cityCode":"4109","provinceCode":"41"},{"code":"410926","name":"范县","cityCode":"4109","provinceCode":"41"},{"code":"410927","name":"台前县","cityCode":"4109","provinceCode":"41"},{"code":"410928","name":"濮阳县","cityCode":"4109","provinceCode":"41"},{"code":"410971","name":"河南濮阳工业园区","cityCode":"4109","provinceCode":"41"},{"code":"410972","name":"濮阳经济技术开发区","cityCode":"4109","provinceCode":"41"},{"code":"411002","name":"魏都区","cityCode":"4110","provinceCode":"41"},{"code":"411003","name":"建安区","cityCode":"4110","provinceCode":"41"},{"code":"411024","name":"鄢陵县","cityCode":"4110","provinceCode":"41"},{"code":"411025","name":"襄城县","cityCode":"4110","provinceCode":"41"},{"code":"411071","name":"许昌经济技术开发区","cityCode":"4110","provinceCode":"41"},{"code":"411081","name":"禹州市","cityCode":"4110","provinceCode":"41"},{"code":"411082","name":"长葛市","cityCode":"4110","provinceCode":"41"},{"code":"411102","name":"源汇区","cityCode":"4111","provinceCode":"41"},{"code":"411103","name":"郾城区","cityCode":"4111","provinceCode":"41"},{"code":"411104","name":"召陵区","cityCode":"4111","provinceCode":"41"},{"code":"411121","name":"舞阳县","cityCode":"4111","provinceCode":"41"},{"code":"411122","name":"临颍县","cityCode":"4111","provinceCode":"41"},{"code":"411171","name":"漯河经济技术开发区","cityCode":"4111","provinceCode":"41"},{"code":"411202","name":"湖滨区","cityCode":"4112","provinceCode":"41"},{"code":"411203","name":"陕州区","cityCode":"4112","provinceCode":"41"},{"code":"411221","name":"渑池县","cityCode":"4112","provinceCode":"41"},{"code":"411224","name":"卢氏县","cityCode":"4112","provinceCode":"41"},{"code":"411271","name":"河南三门峡经济开发区","cityCode":"4112","provinceCode":"41"},{"code":"411281","name":"义马市","cityCode":"4112","provinceCode":"41"},{"code":"411282","name":"灵宝市","cityCode":"4112","provinceCode":"41"},{"code":"411302","name":"宛城区","cityCode":"4113","provinceCode":"41"},{"code":"411303","name":"卧龙区","cityCode":"4113","provinceCode":"41"},{"code":"411321","name":"南召县","cityCode":"4113","provinceCode":"41"},{"code":"411322","name":"方城县","cityCode":"4113","provinceCode":"41"},{"code":"411323","name":"西峡县","cityCode":"4113","provinceCode":"41"},{"code":"411324","name":"镇平县","cityCode":"4113","provinceCode":"41"},{"code":"411325","name":"内乡县","cityCode":"4113","provinceCode":"41"},{"code":"411326","name":"淅川县","cityCode":"4113","provinceCode":"41"},{"code":"411327","name":"社旗县","cityCode":"4113","provinceCode":"41"},{"code":"411328","name":"唐河县","cityCode":"4113","provinceCode":"41"},{"code":"411329","name":"新野县","cityCode":"4113","provinceCode":"41"},{"code":"411330","name":"桐柏县","cityCode":"4113","provinceCode":"41"},{"code":"411371","name":"南阳高新技术产业开发区","cityCode":"4113","provinceCode":"41"},{"code":"411372","name":"南阳市城乡一体化示范区","cityCode":"4113","provinceCode":"41"},{"code":"411381","name":"邓州市","cityCode":"4113","provinceCode":"41"},{"code":"411402","name":"梁园区","cityCode":"4114","provinceCode":"41"},{"code":"411403","name":"睢阳区","cityCode":"4114","provinceCode":"41"},{"code":"411421","name":"民权县","cityCode":"4114","provinceCode":"41"},{"code":"411422","name":"睢县","cityCode":"4114","provinceCode":"41"},{"code":"411423","name":"宁陵县","cityCode":"4114","provinceCode":"41"},{"code":"411424","name":"柘城县","cityCode":"4114","provinceCode":"41"},{"code":"411425","name":"虞城县","cityCode":"4114","provinceCode":"41"},{"code":"411426","name":"夏邑县","cityCode":"4114","provinceCode":"41"},{"code":"411471","name":"豫东综合物流产业聚集区","cityCode":"4114","provinceCode":"41"},{"code":"411472","name":"河南商丘经济开发区","cityCode":"4114","provinceCode":"41"},{"code":"411481","name":"永城市","cityCode":"4114","provinceCode":"41"},{"code":"411502","name":"浉河区","cityCode":"4115","provinceCode":"41"},{"code":"411503","name":"平桥区","cityCode":"4115","provinceCode":"41"},{"code":"411521","name":"罗山县","cityCode":"4115","provinceCode":"41"},{"code":"411522","name":"光山县","cityCode":"4115","provinceCode":"41"},{"code":"411523","name":"新县","cityCode":"4115","provinceCode":"41"},{"code":"411524","name":"商城县","cityCode":"4115","provinceCode":"41"},{"code":"411525","name":"固始县","cityCode":"4115","provinceCode":"41"},{"code":"411526","name":"潢川县","cityCode":"4115","provinceCode":"41"},{"code":"411527","name":"淮滨县","cityCode":"4115","provinceCode":"41"},{"code":"411528","name":"息县","cityCode":"4115","provinceCode":"41"},{"code":"411571","name":"信阳高新技术产业开发区","cityCode":"4115","provinceCode":"41"},{"code":"411602","name":"川汇区","cityCode":"4116","provinceCode":"41"},{"code":"411603","name":"淮阳区","cityCode":"4116","provinceCode":"41"},{"code":"411621","name":"扶沟县","cityCode":"4116","provinceCode":"41"},{"code":"411622","name":"西华县","cityCode":"4116","provinceCode":"41"},{"code":"411623","name":"商水县","cityCode":"4116","provinceCode":"41"},{"code":"411624","name":"沈丘县","cityCode":"4116","provinceCode":"41"},{"code":"411625","name":"郸城县","cityCode":"4116","provinceCode":"41"},{"code":"411627","name":"太康县","cityCode":"4116","provinceCode":"41"},{"code":"411628","name":"鹿邑县","cityCode":"4116","provinceCode":"41"},{"code":"411671","name":"周口临港开发区","cityCode":"4116","provinceCode":"41"},{"code":"411681","name":"项城市","cityCode":"4116","provinceCode":"41"},{"code":"411702","name":"驿城区","cityCode":"4117","provinceCode":"41"},{"code":"411721","name":"西平县","cityCode":"4117","provinceCode":"41"},{"code":"411722","name":"上蔡县","cityCode":"4117","provinceCode":"41"},{"code":"411723","name":"平舆县","cityCode":"4117","provinceCode":"41"},{"code":"411724","name":"正阳县","cityCode":"4117","provinceCode":"41"},{"code":"411725","name":"确山县","cityCode":"4117","provinceCode":"41"},{"code":"411726","name":"泌阳县","cityCode":"4117","provinceCode":"41"},{"code":"411727","name":"汝南县","cityCode":"4117","provinceCode":"41"},{"code":"411728","name":"遂平县","cityCode":"4117","provinceCode":"41"},{"code":"411729","name":"新蔡县","cityCode":"4117","provinceCode":"41"},{"code":"411771","name":"河南驻马店经济开发区","cityCode":"4117","provinceCode":"41"},{"code":"419001","name":"济源市","cityCode":"4190","provinceCode":"41"},{"code":"420102","name":"江岸区","cityCode":"4201","provinceCode":"42"},{"code":"420103","name":"江汉区","cityCode":"4201","provinceCode":"42"},{"code":"420104","name":"硚口区","cityCode":"4201","provinceCode":"42"},{"code":"420105","name":"汉阳区","cityCode":"4201","provinceCode":"42"},{"code":"420106","name":"武昌区","cityCode":"4201","provinceCode":"42"},{"code":"420107","name":"青山区","cityCode":"4201","provinceCode":"42"},{"code":"420111","name":"洪山区","cityCode":"4201","provinceCode":"42"},{"code":"420112","name":"东西湖区","cityCode":"4201","provinceCode":"42"},{"code":"420113","name":"汉南区","cityCode":"4201","provinceCode":"42"},{"code":"420114","name":"蔡甸区","cityCode":"4201","provinceCode":"42"},{"code":"420115","name":"江夏区","cityCode":"4201","provinceCode":"42"},{"code":"420116","name":"黄陂区","cityCode":"4201","provinceCode":"42"},{"code":"420117","name":"新洲区","cityCode":"4201","provinceCode":"42"},{"code":"420202","name":"黄石港区","cityCode":"4202","provinceCode":"42"},{"code":"420203","name":"西塞山区","cityCode":"4202","provinceCode":"42"},{"code":"420204","name":"下陆区","cityCode":"4202","provinceCode":"42"},{"code":"420205","name":"铁山区","cityCode":"4202","provinceCode":"42"},{"code":"420222","name":"阳新县","cityCode":"4202","provinceCode":"42"},{"code":"420281","name":"大冶市","cityCode":"4202","provinceCode":"42"},{"code":"420302","name":"茅箭区","cityCode":"4203","provinceCode":"42"},{"code":"420303","name":"张湾区","cityCode":"4203","provinceCode":"42"},{"code":"420304","name":"郧阳区","cityCode":"4203","provinceCode":"42"},{"code":"420322","name":"郧西县","cityCode":"4203","provinceCode":"42"},{"code":"420323","name":"竹山县","cityCode":"4203","provinceCode":"42"},{"code":"420324","name":"竹溪县","cityCode":"4203","provinceCode":"42"},{"code":"420325","name":"房县","cityCode":"4203","provinceCode":"42"},{"code":"420381","name":"丹江口市","cityCode":"4203","provinceCode":"42"},{"code":"420502","name":"西陵区","cityCode":"4205","provinceCode":"42"},{"code":"420503","name":"伍家岗区","cityCode":"4205","provinceCode":"42"},{"code":"420504","name":"点军区","cityCode":"4205","provinceCode":"42"},{"code":"420505","name":"猇亭区","cityCode":"4205","provinceCode":"42"},{"code":"420506","name":"夷陵区","cityCode":"4205","provinceCode":"42"},{"code":"420525","name":"远安县","cityCode":"4205","provinceCode":"42"},{"code":"420526","name":"兴山县","cityCode":"4205","provinceCode":"42"},{"code":"420527","name":"秭归县","cityCode":"4205","provinceCode":"42"},{"code":"420528","name":"长阳土家族自治县","cityCode":"4205","provinceCode":"42"},{"code":"420529","name":"五峰土家族自治县","cityCode":"4205","provinceCode":"42"},{"code":"420581","name":"宜都市","cityCode":"4205","provinceCode":"42"},{"code":"420582","name":"当阳市","cityCode":"4205","provinceCode":"42"},{"code":"420583","name":"枝江市","cityCode":"4205","provinceCode":"42"},{"code":"420602","name":"襄城区","cityCode":"4206","provinceCode":"42"},{"code":"420606","name":"樊城区","cityCode":"4206","provinceCode":"42"},{"code":"420607","name":"襄州区","cityCode":"4206","provinceCode":"42"},{"code":"420624","name":"南漳县","cityCode":"4206","provinceCode":"42"},{"code":"420625","name":"谷城县","cityCode":"4206","provinceCode":"42"},{"code":"420626","name":"保康县","cityCode":"4206","provinceCode":"42"},{"code":"420682","name":"老河口市","cityCode":"4206","provinceCode":"42"},{"code":"420683","name":"枣阳市","cityCode":"4206","provinceCode":"42"},{"code":"420684","name":"宜城市","cityCode":"4206","provinceCode":"42"},{"code":"420702","name":"梁子湖区","cityCode":"4207","provinceCode":"42"},{"code":"420703","name":"华容区","cityCode":"4207","provinceCode":"42"},{"code":"420704","name":"鄂城区","cityCode":"4207","provinceCode":"42"},{"code":"420802","name":"东宝区","cityCode":"4208","provinceCode":"42"},{"code":"420804","name":"掇刀区","cityCode":"4208","provinceCode":"42"},{"code":"420822","name":"沙洋县","cityCode":"4208","provinceCode":"42"},{"code":"420881","name":"钟祥市","cityCode":"4208","provinceCode":"42"},{"code":"420882","name":"京山市","cityCode":"4208","provinceCode":"42"},{"code":"420902","name":"孝南区","cityCode":"4209","provinceCode":"42"},{"code":"420921","name":"孝昌县","cityCode":"4209","provinceCode":"42"},{"code":"420922","name":"大悟县","cityCode":"4209","provinceCode":"42"},{"code":"420923","name":"云梦县","cityCode":"4209","provinceCode":"42"},{"code":"420981","name":"应城市","cityCode":"4209","provinceCode":"42"},{"code":"420982","name":"安陆市","cityCode":"4209","provinceCode":"42"},{"code":"420984","name":"汉川市","cityCode":"4209","provinceCode":"42"},{"code":"421002","name":"沙市区","cityCode":"4210","provinceCode":"42"},{"code":"421003","name":"荆州区","cityCode":"4210","provinceCode":"42"},{"code":"421022","name":"公安县","cityCode":"4210","provinceCode":"42"},{"code":"421024","name":"江陵县","cityCode":"4210","provinceCode":"42"},{"code":"421071","name":"荆州经济技术开发区","cityCode":"4210","provinceCode":"42"},{"code":"421081","name":"石首市","cityCode":"4210","provinceCode":"42"},{"code":"421083","name":"洪湖市","cityCode":"4210","provinceCode":"42"},{"code":"421087","name":"松滋市","cityCode":"4210","provinceCode":"42"},{"code":"421088","name":"监利市","cityCode":"4210","provinceCode":"42"},{"code":"421102","name":"黄州区","cityCode":"4211","provinceCode":"42"},{"code":"421121","name":"团风县","cityCode":"4211","provinceCode":"42"},{"code":"421122","name":"红安县","cityCode":"4211","provinceCode":"42"},{"code":"421123","name":"罗田县","cityCode":"4211","provinceCode":"42"},{"code":"421124","name":"英山县","cityCode":"4211","provinceCode":"42"},{"code":"421125","name":"浠水县","cityCode":"4211","provinceCode":"42"},{"code":"421126","name":"蕲春县","cityCode":"4211","provinceCode":"42"},{"code":"421127","name":"黄梅县","cityCode":"4211","provinceCode":"42"},{"code":"421171","name":"龙感湖管理区","cityCode":"4211","provinceCode":"42"},{"code":"421181","name":"麻城市","cityCode":"4211","provinceCode":"42"},{"code":"421182","name":"武穴市","cityCode":"4211","provinceCode":"42"},{"code":"421202","name":"咸安区","cityCode":"4212","provinceCode":"42"},{"code":"421221","name":"嘉鱼县","cityCode":"4212","provinceCode":"42"},{"code":"421222","name":"通城县","cityCode":"4212","provinceCode":"42"},{"code":"421223","name":"崇阳县","cityCode":"4212","provinceCode":"42"},{"code":"421224","name":"通山县","cityCode":"4212","provinceCode":"42"},{"code":"421281","name":"赤壁市","cityCode":"4212","provinceCode":"42"},{"code":"421303","name":"曾都区","cityCode":"4213","provinceCode":"42"},{"code":"421321","name":"随县","cityCode":"4213","provinceCode":"42"},{"code":"421381","name":"广水市","cityCode":"4213","provinceCode":"42"},{"code":"422801","name":"恩施市","cityCode":"4228","provinceCode":"42"},{"code":"422802","name":"利川市","cityCode":"4228","provinceCode":"42"},{"code":"422822","name":"建始县","cityCode":"4228","provinceCode":"42"},{"code":"422823","name":"巴东县","cityCode":"4228","provinceCode":"42"},{"code":"422825","name":"宣恩县","cityCode":"4228","provinceCode":"42"},{"code":"422826","name":"咸丰县","cityCode":"4228","provinceCode":"42"},{"code":"422827","name":"来凤县","cityCode":"4228","provinceCode":"42"},{"code":"422828","name":"鹤峰县","cityCode":"4228","provinceCode":"42"},{"code":"429004","name":"仙桃市","cityCode":"4290","provinceCode":"42"},{"code":"429005","name":"潜江市","cityCode":"4290","provinceCode":"42"},{"code":"429006","name":"天门市","cityCode":"4290","provinceCode":"42"},{"code":"429021","name":"神农架林区","cityCode":"4290","provinceCode":"42"},{"code":"430102","name":"芙蓉区","cityCode":"4301","provinceCode":"43"},{"code":"430103","name":"天心区","cityCode":"4301","provinceCode":"43"},{"code":"430104","name":"岳麓区","cityCode":"4301","provinceCode":"43"},{"code":"430105","name":"开福区","cityCode":"4301","provinceCode":"43"},{"code":"430111","name":"雨花区","cityCode":"4301","provinceCode":"43"},{"code":"430112","name":"望城区","cityCode":"4301","provinceCode":"43"},{"code":"430121","name":"长沙县","cityCode":"4301","provinceCode":"43"},{"code":"430181","name":"浏阳市","cityCode":"4301","provinceCode":"43"},{"code":"430182","name":"宁乡市","cityCode":"4301","provinceCode":"43"},{"code":"430202","name":"荷塘区","cityCode":"4302","provinceCode":"43"},{"code":"430203","name":"芦淞区","cityCode":"4302","provinceCode":"43"},{"code":"430204","name":"石峰区","cityCode":"4302","provinceCode":"43"},{"code":"430211","name":"天元区","cityCode":"4302","provinceCode":"43"},{"code":"430212","name":"渌口区","cityCode":"4302","provinceCode":"43"},{"code":"430223","name":"攸县","cityCode":"4302","provinceCode":"43"},{"code":"430224","name":"茶陵县","cityCode":"4302","provinceCode":"43"},{"code":"430225","name":"炎陵县","cityCode":"4302","provinceCode":"43"},{"code":"430281","name":"醴陵市","cityCode":"4302","provinceCode":"43"},{"code":"430302","name":"雨湖区","cityCode":"4303","provinceCode":"43"},{"code":"430304","name":"岳塘区","cityCode":"4303","provinceCode":"43"},{"code":"430321","name":"湘潭县","cityCode":"4303","provinceCode":"43"},{"code":"430371","name":"湖南湘潭高新技术产业园区","cityCode":"4303","provinceCode":"43"},{"code":"430372","name":"湘潭昭山示范区","cityCode":"4303","provinceCode":"43"},{"code":"430373","name":"湘潭九华示范区","cityCode":"4303","provinceCode":"43"},{"code":"430381","name":"湘乡市","cityCode":"4303","provinceCode":"43"},{"code":"430382","name":"韶山市","cityCode":"4303","provinceCode":"43"},{"code":"430405","name":"珠晖区","cityCode":"4304","provinceCode":"43"},{"code":"430406","name":"雁峰区","cityCode":"4304","provinceCode":"43"},{"code":"430407","name":"石鼓区","cityCode":"4304","provinceCode":"43"},{"code":"430408","name":"蒸湘区","cityCode":"4304","provinceCode":"43"},{"code":"430412","name":"南岳区","cityCode":"4304","provinceCode":"43"},{"code":"430421","name":"衡阳县","cityCode":"4304","provinceCode":"43"},{"code":"430422","name":"衡南县","cityCode":"4304","provinceCode":"43"},{"code":"430423","name":"衡山县","cityCode":"4304","provinceCode":"43"},{"code":"430424","name":"衡东县","cityCode":"4304","provinceCode":"43"},{"code":"430426","name":"祁东县","cityCode":"4304","provinceCode":"43"},{"code":"430473","name":"湖南衡阳松木经济开发区","cityCode":"4304","provinceCode":"43"},{"code":"430476","name":"湖南衡阳高新技术产业园区","cityCode":"4304","provinceCode":"43"},{"code":"430481","name":"耒阳市","cityCode":"4304","provinceCode":"43"},{"code":"430482","name":"常宁市","cityCode":"4304","provinceCode":"43"},{"code":"430502","name":"双清区","cityCode":"4305","provinceCode":"43"},{"code":"430503","name":"大祥区","cityCode":"4305","provinceCode":"43"},{"code":"430511","name":"北塔区","cityCode":"4305","provinceCode":"43"},{"code":"430522","name":"新邵县","cityCode":"4305","provinceCode":"43"},{"code":"430523","name":"邵阳县","cityCode":"4305","provinceCode":"43"},{"code":"430524","name":"隆回县","cityCode":"4305","provinceCode":"43"},{"code":"430525","name":"洞口县","cityCode":"4305","provinceCode":"43"},{"code":"430527","name":"绥宁县","cityCode":"4305","provinceCode":"43"},{"code":"430528","name":"新宁县","cityCode":"4305","provinceCode":"43"},{"code":"430529","name":"城步苗族自治县","cityCode":"4305","provinceCode":"43"},{"code":"430581","name":"武冈市","cityCode":"4305","provinceCode":"43"},{"code":"430582","name":"邵东市","cityCode":"4305","provinceCode":"43"},{"code":"430602","name":"岳阳楼区","cityCode":"4306","provinceCode":"43"},{"code":"430603","name":"云溪区","cityCode":"4306","provinceCode":"43"},{"code":"430611","name":"君山区","cityCode":"4306","provinceCode":"43"},{"code":"430621","name":"岳阳县","cityCode":"4306","provinceCode":"43"},{"code":"430623","name":"华容县","cityCode":"4306","provinceCode":"43"},{"code":"430624","name":"湘阴县","cityCode":"4306","provinceCode":"43"},{"code":"430626","name":"平江县","cityCode":"4306","provinceCode":"43"},{"code":"430671","name":"岳阳市屈原管理区","cityCode":"4306","provinceCode":"43"},{"code":"430681","name":"汨罗市","cityCode":"4306","provinceCode":"43"},{"code":"430682","name":"临湘市","cityCode":"4306","provinceCode":"43"},{"code":"430702","name":"武陵区","cityCode":"4307","provinceCode":"43"},{"code":"430703","name":"鼎城区","cityCode":"4307","provinceCode":"43"},{"code":"430721","name":"安乡县","cityCode":"4307","provinceCode":"43"},{"code":"430722","name":"汉寿县","cityCode":"4307","provinceCode":"43"},{"code":"430723","name":"澧县","cityCode":"4307","provinceCode":"43"},{"code":"430724","name":"临澧县","cityCode":"4307","provinceCode":"43"},{"code":"430725","name":"桃源县","cityCode":"4307","provinceCode":"43"},{"code":"430726","name":"石门县","cityCode":"4307","provinceCode":"43"},{"code":"430771","name":"常德市西洞庭管理区","cityCode":"4307","provinceCode":"43"},{"code":"430781","name":"津市市","cityCode":"4307","provinceCode":"43"},{"code":"430802","name":"永定区","cityCode":"4308","provinceCode":"43"},{"code":"430811","name":"武陵源区","cityCode":"4308","provinceCode":"43"},{"code":"430821","name":"慈利县","cityCode":"4308","provinceCode":"43"},{"code":"430822","name":"桑植县","cityCode":"4308","provinceCode":"43"},{"code":"430902","name":"资阳区","cityCode":"4309","provinceCode":"43"},{"code":"430903","name":"赫山区","cityCode":"4309","provinceCode":"43"},{"code":"430921","name":"南县","cityCode":"4309","provinceCode":"43"},{"code":"430922","name":"桃江县","cityCode":"4309","provinceCode":"43"},{"code":"430923","name":"安化县","cityCode":"4309","provinceCode":"43"},{"code":"430971","name":"益阳市大通湖管理区","cityCode":"4309","provinceCode":"43"},{"code":"430972","name":"湖南益阳高新技术产业园区","cityCode":"4309","provinceCode":"43"},{"code":"430981","name":"沅江市","cityCode":"4309","provinceCode":"43"},{"code":"431002","name":"北湖区","cityCode":"4310","provinceCode":"43"},{"code":"431003","name":"苏仙区","cityCode":"4310","provinceCode":"43"},{"code":"431021","name":"桂阳县","cityCode":"4310","provinceCode":"43"},{"code":"431022","name":"宜章县","cityCode":"4310","provinceCode":"43"},{"code":"431023","name":"永兴县","cityCode":"4310","provinceCode":"43"},{"code":"431024","name":"嘉禾县","cityCode":"4310","provinceCode":"43"},{"code":"431025","name":"临武县","cityCode":"4310","provinceCode":"43"},{"code":"431026","name":"汝城县","cityCode":"4310","provinceCode":"43"},{"code":"431027","name":"桂东县","cityCode":"4310","provinceCode":"43"},{"code":"431028","name":"安仁县","cityCode":"4310","provinceCode":"43"},{"code":"431081","name":"资兴市","cityCode":"4310","provinceCode":"43"},{"code":"431102","name":"零陵区","cityCode":"4311","provinceCode":"43"},{"code":"431103","name":"冷水滩区","cityCode":"4311","provinceCode":"43"},{"code":"431122","name":"东安县","cityCode":"4311","provinceCode":"43"},{"code":"431123","name":"双牌县","cityCode":"4311","provinceCode":"43"},{"code":"431124","name":"道县","cityCode":"4311","provinceCode":"43"},{"code":"431125","name":"江永县","cityCode":"4311","provinceCode":"43"},{"code":"431126","name":"宁远县","cityCode":"4311","provinceCode":"43"},{"code":"431127","name":"蓝山县","cityCode":"4311","provinceCode":"43"},{"code":"431128","name":"新田县","cityCode":"4311","provinceCode":"43"},{"code":"431129","name":"江华瑶族自治县","cityCode":"4311","provinceCode":"43"},{"code":"431171","name":"永州经济技术开发区","cityCode":"4311","provinceCode":"43"},{"code":"431173","name":"永州市回龙圩管理区","cityCode":"4311","provinceCode":"43"},{"code":"431181","name":"祁阳市","cityCode":"4311","provinceCode":"43"},{"code":"431202","name":"鹤城区","cityCode":"4312","provinceCode":"43"},{"code":"431221","name":"中方县","cityCode":"4312","provinceCode":"43"},{"code":"431222","name":"沅陵县","cityCode":"4312","provinceCode":"43"},{"code":"431223","name":"辰溪县","cityCode":"4312","provinceCode":"43"},{"code":"431224","name":"溆浦县","cityCode":"4312","provinceCode":"43"},{"code":"431225","name":"会同县","cityCode":"4312","provinceCode":"43"},{"code":"431226","name":"麻阳苗族自治县","cityCode":"4312","provinceCode":"43"},{"code":"431227","name":"新晃侗族自治县","cityCode":"4312","provinceCode":"43"},{"code":"431228","name":"芷江侗族自治县","cityCode":"4312","provinceCode":"43"},{"code":"431229","name":"靖州苗族侗族自治县","cityCode":"4312","provinceCode":"43"},{"code":"431230","name":"通道侗族自治县","cityCode":"4312","provinceCode":"43"},{"code":"431271","name":"怀化市洪江管理区","cityCode":"4312","provinceCode":"43"},{"code":"431281","name":"洪江市","cityCode":"4312","provinceCode":"43"},{"code":"431302","name":"娄星区","cityCode":"4313","provinceCode":"43"},{"code":"431321","name":"双峰县","cityCode":"4313","provinceCode":"43"},{"code":"431322","name":"新化县","cityCode":"4313","provinceCode":"43"},{"code":"431381","name":"冷水江市","cityCode":"4313","provinceCode":"43"},{"code":"431382","name":"涟源市","cityCode":"4313","provinceCode":"43"},{"code":"433101","name":"吉首市","cityCode":"4331","provinceCode":"43"},{"code":"433122","name":"泸溪县","cityCode":"4331","provinceCode":"43"},{"code":"433123","name":"凤凰县","cityCode":"4331","provinceCode":"43"},{"code":"433124","name":"花垣县","cityCode":"4331","provinceCode":"43"},{"code":"433125","name":"保靖县","cityCode":"4331","provinceCode":"43"},{"code":"433126","name":"古丈县","cityCode":"4331","provinceCode":"43"},{"code":"433127","name":"永顺县","cityCode":"4331","provinceCode":"43"},{"code":"433130","name":"龙山县","cityCode":"4331","provinceCode":"43"},{"code":"440103","name":"荔湾区","cityCode":"4401","provinceCode":"44"},{"code":"440104","name":"越秀区","cityCode":"4401","provinceCode":"44"},{"code":"440105","name":"海珠区","cityCode":"4401","provinceCode":"44"},{"code":"440106","name":"天河区","cityCode":"4401","provinceCode":"44"},{"code":"440111","name":"白云区","cityCode":"4401","provinceCode":"44"},{"code":"440112","name":"黄埔区","cityCode":"4401","provinceCode":"44"},{"code":"440113","name":"番禺区","cityCode":"4401","provinceCode":"44"},{"code":"440114","name":"花都区","cityCode":"4401","provinceCode":"44"},{"code":"440115","name":"南沙区","cityCode":"4401","provinceCode":"44"},{"code":"440117","name":"从化区","cityCode":"4401","provinceCode":"44"},{"code":"440118","name":"增城区","cityCode":"4401","provinceCode":"44"},{"code":"440203","name":"武江区","cityCode":"4402","provinceCode":"44"},{"code":"440204","name":"浈江区","cityCode":"4402","provinceCode":"44"},{"code":"440205","name":"曲江区","cityCode":"4402","provinceCode":"44"},{"code":"440222","name":"始兴县","cityCode":"4402","provinceCode":"44"},{"code":"440224","name":"仁化县","cityCode":"4402","provinceCode":"44"},{"code":"440229","name":"翁源县","cityCode":"4402","provinceCode":"44"},{"code":"440232","name":"乳源瑶族自治县","cityCode":"4402","provinceCode":"44"},{"code":"440233","name":"新丰县","cityCode":"4402","provinceCode":"44"},{"code":"440281","name":"乐昌市","cityCode":"4402","provinceCode":"44"},{"code":"440282","name":"南雄市","cityCode":"4402","provinceCode":"44"},{"code":"440303","name":"罗湖区","cityCode":"4403","provinceCode":"44"},{"code":"440304","name":"福田区","cityCode":"4403","provinceCode":"44"},{"code":"440305","name":"南山区","cityCode":"4403","provinceCode":"44"},{"code":"440306","name":"宝安区","cityCode":"4403","provinceCode":"44"},{"code":"440307","name":"龙岗区","cityCode":"4403","provinceCode":"44"},{"code":"440308","name":"盐田区","cityCode":"4403","provinceCode":"44"},{"code":"440309","name":"龙华区","cityCode":"4403","provinceCode":"44"},{"code":"440310","name":"坪山区","cityCode":"4403","provinceCode":"44"},{"code":"440311","name":"光明区","cityCode":"4403","provinceCode":"44"},{"code":"440402","name":"香洲区","cityCode":"4404","provinceCode":"44"},{"code":"440403","name":"斗门区","cityCode":"4404","provinceCode":"44"},{"code":"440404","name":"金湾区","cityCode":"4404","provinceCode":"44"},{"code":"440507","name":"龙湖区","cityCode":"4405","provinceCode":"44"},{"code":"440511","name":"金平区","cityCode":"4405","provinceCode":"44"},{"code":"440512","name":"濠江区","cityCode":"4405","provinceCode":"44"},{"code":"440513","name":"潮阳区","cityCode":"4405","provinceCode":"44"},{"code":"440514","name":"潮南区","cityCode":"4405","provinceCode":"44"},{"code":"440515","name":"澄海区","cityCode":"4405","provinceCode":"44"},{"code":"440523","name":"南澳县","cityCode":"4405","provinceCode":"44"},{"code":"440604","name":"禅城区","cityCode":"4406","provinceCode":"44"},{"code":"440605","name":"南海区","cityCode":"4406","provinceCode":"44"},{"code":"440606","name":"顺德区","cityCode":"4406","provinceCode":"44"},{"code":"440607","name":"三水区","cityCode":"4406","provinceCode":"44"},{"code":"440608","name":"高明区","cityCode":"4406","provinceCode":"44"},{"code":"440703","name":"蓬江区","cityCode":"4407","provinceCode":"44"},{"code":"440704","name":"江海区","cityCode":"4407","provinceCode":"44"},{"code":"440705","name":"新会区","cityCode":"4407","provinceCode":"44"},{"code":"440781","name":"台山市","cityCode":"4407","provinceCode":"44"},{"code":"440783","name":"开平市","cityCode":"4407","provinceCode":"44"},{"code":"440784","name":"鹤山市","cityCode":"4407","provinceCode":"44"},{"code":"440785","name":"恩平市","cityCode":"4407","provinceCode":"44"},{"code":"440802","name":"赤坎区","cityCode":"4408","provinceCode":"44"},{"code":"440803","name":"霞山区","cityCode":"4408","provinceCode":"44"},{"code":"440804","name":"坡头区","cityCode":"4408","provinceCode":"44"},{"code":"440811","name":"麻章区","cityCode":"4408","provinceCode":"44"},{"code":"440823","name":"遂溪县","cityCode":"4408","provinceCode":"44"},{"code":"440825","name":"徐闻县","cityCode":"4408","provinceCode":"44"},{"code":"440881","name":"廉江市","cityCode":"4408","provinceCode":"44"},{"code":"440882","name":"雷州市","cityCode":"4408","provinceCode":"44"},{"code":"440883","name":"吴川市","cityCode":"4408","provinceCode":"44"},{"code":"440902","name":"茂南区","cityCode":"4409","provinceCode":"44"},{"code":"440904","name":"电白区","cityCode":"4409","provinceCode":"44"},{"code":"440981","name":"高州市","cityCode":"4409","provinceCode":"44"},{"code":"440982","name":"化州市","cityCode":"4409","provinceCode":"44"},{"code":"440983","name":"信宜市","cityCode":"4409","provinceCode":"44"},{"code":"441202","name":"端州区","cityCode":"4412","provinceCode":"44"},{"code":"441203","name":"鼎湖区","cityCode":"4412","provinceCode":"44"},{"code":"441204","name":"高要区","cityCode":"4412","provinceCode":"44"},{"code":"441223","name":"广宁县","cityCode":"4412","provinceCode":"44"},{"code":"441224","name":"怀集县","cityCode":"4412","provinceCode":"44"},{"code":"441225","name":"封开县","cityCode":"4412","provinceCode":"44"},{"code":"441226","name":"德庆县","cityCode":"4412","provinceCode":"44"},{"code":"441284","name":"四会市","cityCode":"4412","provinceCode":"44"},{"code":"441302","name":"惠城区","cityCode":"4413","provinceCode":"44"},{"code":"441303","name":"惠阳区","cityCode":"4413","provinceCode":"44"},{"code":"441322","name":"博罗县","cityCode":"4413","provinceCode":"44"},{"code":"441323","name":"惠东县","cityCode":"4413","provinceCode":"44"},{"code":"441324","name":"龙门县","cityCode":"4413","provinceCode":"44"},{"code":"441402","name":"梅江区","cityCode":"4414","provinceCode":"44"},{"code":"441403","name":"梅县区","cityCode":"4414","provinceCode":"44"},{"code":"441422","name":"大埔县","cityCode":"4414","provinceCode":"44"},{"code":"441423","name":"丰顺县","cityCode":"4414","provinceCode":"44"},{"code":"441424","name":"五华县","cityCode":"4414","provinceCode":"44"},{"code":"441426","name":"平远县","cityCode":"4414","provinceCode":"44"},{"code":"441427","name":"蕉岭县","cityCode":"4414","provinceCode":"44"},{"code":"441481","name":"兴宁市","cityCode":"4414","provinceCode":"44"},{"code":"441502","name":"城区","cityCode":"4415","provinceCode":"44"},{"code":"441521","name":"海丰县","cityCode":"4415","provinceCode":"44"},{"code":"441523","name":"陆河县","cityCode":"4415","provinceCode":"44"},{"code":"441581","name":"陆丰市","cityCode":"4415","provinceCode":"44"},{"code":"441602","name":"源城区","cityCode":"4416","provinceCode":"44"},{"code":"441621","name":"紫金县","cityCode":"4416","provinceCode":"44"},{"code":"441622","name":"龙川县","cityCode":"4416","provinceCode":"44"},{"code":"441623","name":"连平县","cityCode":"4416","provinceCode":"44"},{"code":"441624","name":"和平县","cityCode":"4416","provinceCode":"44"},{"code":"441625","name":"东源县","cityCode":"4416","provinceCode":"44"},{"code":"441702","name":"江城区","cityCode":"4417","provinceCode":"44"},{"code":"441704","name":"阳东区","cityCode":"4417","provinceCode":"44"},{"code":"441721","name":"阳西县","cityCode":"4417","provinceCode":"44"},{"code":"441781","name":"阳春市","cityCode":"4417","provinceCode":"44"},{"code":"441802","name":"清城区","cityCode":"4418","provinceCode":"44"},{"code":"441803","name":"清新区","cityCode":"4418","provinceCode":"44"},{"code":"441821","name":"佛冈县","cityCode":"4418","provinceCode":"44"},{"code":"441823","name":"阳山县","cityCode":"4418","provinceCode":"44"},{"code":"441825","name":"连山壮族瑶族自治县","cityCode":"4418","provinceCode":"44"},{"code":"441826","name":"连南瑶族自治县","cityCode":"4418","provinceCode":"44"},{"code":"441881","name":"英德市","cityCode":"4418","provinceCode":"44"},{"code":"441882","name":"连州市","cityCode":"4418","provinceCode":"44"},{"code":"441900","name":"东莞市","cityCode":"4419","provinceCode":"44"},{"code":"442000","name":"中山市","cityCode":"4420","provinceCode":"44"},{"code":"445102","name":"湘桥区","cityCode":"4451","provinceCode":"44"},{"code":"445103","name":"潮安区","cityCode":"4451","provinceCode":"44"},{"code":"445122","name":"饶平县","cityCode":"4451","provinceCode":"44"},{"code":"445202","name":"榕城区","cityCode":"4452","provinceCode":"44"},{"code":"445203","name":"揭东区","cityCode":"4452","provinceCode":"44"},{"code":"445222","name":"揭西县","cityCode":"4452","provinceCode":"44"},{"code":"445224","name":"惠来县","cityCode":"4452","provinceCode":"44"},{"code":"445281","name":"普宁市","cityCode":"4452","provinceCode":"44"},{"code":"445302","name":"云城区","cityCode":"4453","provinceCode":"44"},{"code":"445303","name":"云安区","cityCode":"4453","provinceCode":"44"},{"code":"445321","name":"新兴县","cityCode":"4453","provinceCode":"44"},{"code":"445322","name":"郁南县","cityCode":"4453","provinceCode":"44"},{"code":"445381","name":"罗定市","cityCode":"4453","provinceCode":"44"},{"code":"450102","name":"兴宁区","cityCode":"4501","provinceCode":"45"},{"code":"450103","name":"青秀区","cityCode":"4501","provinceCode":"45"},{"code":"450105","name":"江南区","cityCode":"4501","provinceCode":"45"},{"code":"450107","name":"西乡塘区","cityCode":"4501","provinceCode":"45"},{"code":"450108","name":"良庆区","cityCode":"4501","provinceCode":"45"},{"code":"450109","name":"邕宁区","cityCode":"4501","provinceCode":"45"},{"code":"450110","name":"武鸣区","cityCode":"4501","provinceCode":"45"},{"code":"450123","name":"隆安县","cityCode":"4501","provinceCode":"45"},{"code":"450124","name":"马山县","cityCode":"4501","provinceCode":"45"},{"code":"450125","name":"上林县","cityCode":"4501","provinceCode":"45"},{"code":"450126","name":"宾阳县","cityCode":"4501","provinceCode":"45"},{"code":"450181","name":"横州市","cityCode":"4501","provinceCode":"45"},{"code":"450202","name":"城中区","cityCode":"4502","provinceCode":"45"},{"code":"450203","name":"鱼峰区","cityCode":"4502","provinceCode":"45"},{"code":"450204","name":"柳南区","cityCode":"4502","provinceCode":"45"},{"code":"450205","name":"柳北区","cityCode":"4502","provinceCode":"45"},{"code":"450206","name":"柳江区","cityCode":"4502","provinceCode":"45"},{"code":"450222","name":"柳城县","cityCode":"4502","provinceCode":"45"},{"code":"450223","name":"鹿寨县","cityCode":"4502","provinceCode":"45"},{"code":"450224","name":"融安县","cityCode":"4502","provinceCode":"45"},{"code":"450225","name":"融水苗族自治县","cityCode":"4502","provinceCode":"45"},{"code":"450226","name":"三江侗族自治县","cityCode":"4502","provinceCode":"45"},{"code":"450302","name":"秀峰区","cityCode":"4503","provinceCode":"45"},{"code":"450303","name":"叠彩区","cityCode":"4503","provinceCode":"45"},{"code":"450304","name":"象山区","cityCode":"4503","provinceCode":"45"},{"code":"450305","name":"七星区","cityCode":"4503","provinceCode":"45"},{"code":"450311","name":"雁山区","cityCode":"4503","provinceCode":"45"},{"code":"450312","name":"临桂区","cityCode":"4503","provinceCode":"45"},{"code":"450321","name":"阳朔县","cityCode":"4503","provinceCode":"45"},{"code":"450323","name":"灵川县","cityCode":"4503","provinceCode":"45"},{"code":"450324","name":"全州县","cityCode":"4503","provinceCode":"45"},{"code":"450325","name":"兴安县","cityCode":"4503","provinceCode":"45"},{"code":"450326","name":"永福县","cityCode":"4503","provinceCode":"45"},{"code":"450327","name":"灌阳县","cityCode":"4503","provinceCode":"45"},{"code":"450328","name":"龙胜各族自治县","cityCode":"4503","provinceCode":"45"},{"code":"450329","name":"资源县","cityCode":"4503","provinceCode":"45"},{"code":"450330","name":"平乐县","cityCode":"4503","provinceCode":"45"},{"code":"450332","name":"恭城瑶族自治县","cityCode":"4503","provinceCode":"45"},{"code":"450381","name":"荔浦市","cityCode":"4503","provinceCode":"45"},{"code":"450403","name":"万秀区","cityCode":"4504","provinceCode":"45"},{"code":"450405","name":"长洲区","cityCode":"4504","provinceCode":"45"},{"code":"450406","name":"龙圩区","cityCode":"4504","provinceCode":"45"},{"code":"450421","name":"苍梧县","cityCode":"4504","provinceCode":"45"},{"code":"450422","name":"藤县","cityCode":"4504","provinceCode":"45"},{"code":"450423","name":"蒙山县","cityCode":"4504","provinceCode":"45"},{"code":"450481","name":"岑溪市","cityCode":"4504","provinceCode":"45"},{"code":"450502","name":"海城区","cityCode":"4505","provinceCode":"45"},{"code":"450503","name":"银海区","cityCode":"4505","provinceCode":"45"},{"code":"450512","name":"铁山港区","cityCode":"4505","provinceCode":"45"},{"code":"450521","name":"合浦县","cityCode":"4505","provinceCode":"45"},{"code":"450602","name":"港口区","cityCode":"4506","provinceCode":"45"},{"code":"450603","name":"防城区","cityCode":"4506","provinceCode":"45"},{"code":"450621","name":"上思县","cityCode":"4506","provinceCode":"45"},{"code":"450681","name":"东兴市","cityCode":"4506","provinceCode":"45"},{"code":"450702","name":"钦南区","cityCode":"4507","provinceCode":"45"},{"code":"450703","name":"钦北区","cityCode":"4507","provinceCode":"45"},{"code":"450721","name":"灵山县","cityCode":"4507","provinceCode":"45"},{"code":"450722","name":"浦北县","cityCode":"4507","provinceCode":"45"},{"code":"450802","name":"港北区","cityCode":"4508","provinceCode":"45"},{"code":"450803","name":"港南区","cityCode":"4508","provinceCode":"45"},{"code":"450804","name":"覃塘区","cityCode":"4508","provinceCode":"45"},{"code":"450821","name":"平南县","cityCode":"4508","provinceCode":"45"},{"code":"450881","name":"桂平市","cityCode":"4508","provinceCode":"45"},{"code":"450902","name":"玉州区","cityCode":"4509","provinceCode":"45"},{"code":"450903","name":"福绵区","cityCode":"4509","provinceCode":"45"},{"code":"450921","name":"容县","cityCode":"4509","provinceCode":"45"},{"code":"450922","name":"陆川县","cityCode":"4509","provinceCode":"45"},{"code":"450923","name":"博白县","cityCode":"4509","provinceCode":"45"},{"code":"450924","name":"兴业县","cityCode":"4509","provinceCode":"45"},{"code":"450981","name":"北流市","cityCode":"4509","provinceCode":"45"},{"code":"451002","name":"右江区","cityCode":"4510","provinceCode":"45"},{"code":"451003","name":"田阳区","cityCode":"4510","provinceCode":"45"},{"code":"451022","name":"田东县","cityCode":"4510","provinceCode":"45"},{"code":"451024","name":"德保县","cityCode":"4510","provinceCode":"45"},{"code":"451026","name":"那坡县","cityCode":"4510","provinceCode":"45"},{"code":"451027","name":"凌云县","cityCode":"4510","provinceCode":"45"},{"code":"451028","name":"乐业县","cityCode":"4510","provinceCode":"45"},{"code":"451029","name":"田林县","cityCode":"4510","provinceCode":"45"},{"code":"451030","name":"西林县","cityCode":"4510","provinceCode":"45"},{"code":"451031","name":"隆林各族自治县","cityCode":"4510","provinceCode":"45"},{"code":"451081","name":"靖西市","cityCode":"4510","provinceCode":"45"},{"code":"451082","name":"平果市","cityCode":"4510","provinceCode":"45"},{"code":"451102","name":"八步区","cityCode":"4511","provinceCode":"45"},{"code":"451103","name":"平桂区","cityCode":"4511","provinceCode":"45"},{"code":"451121","name":"昭平县","cityCode":"4511","provinceCode":"45"},{"code":"451122","name":"钟山县","cityCode":"4511","provinceCode":"45"},{"code":"451123","name":"富川瑶族自治县","cityCode":"4511","provinceCode":"45"},{"code":"451202","name":"金城江区","cityCode":"4512","provinceCode":"45"},{"code":"451203","name":"宜州区","cityCode":"4512","provinceCode":"45"},{"code":"451221","name":"南丹县","cityCode":"4512","provinceCode":"45"},{"code":"451222","name":"天峨县","cityCode":"4512","provinceCode":"45"},{"code":"451223","name":"凤山县","cityCode":"4512","provinceCode":"45"},{"code":"451224","name":"东兰县","cityCode":"4512","provinceCode":"45"},{"code":"451225","name":"罗城仫佬族自治县","cityCode":"4512","provinceCode":"45"},{"code":"451226","name":"环江毛南族自治县","cityCode":"4512","provinceCode":"45"},{"code":"451227","name":"巴马瑶族自治县","cityCode":"4512","provinceCode":"45"},{"code":"451228","name":"都安瑶族自治县","cityCode":"4512","provinceCode":"45"},{"code":"451229","name":"大化瑶族自治县","cityCode":"4512","provinceCode":"45"},{"code":"451302","name":"兴宾区","cityCode":"4513","provinceCode":"45"},{"code":"451321","name":"忻城县","cityCode":"4513","provinceCode":"45"},{"code":"451322","name":"象州县","cityCode":"4513","provinceCode":"45"},{"code":"451323","name":"武宣县","cityCode":"4513","provinceCode":"45"},{"code":"451324","name":"金秀瑶族自治县","cityCode":"4513","provinceCode":"45"},{"code":"451381","name":"合山市","cityCode":"4513","provinceCode":"45"},{"code":"451402","name":"江州区","cityCode":"4514","provinceCode":"45"},{"code":"451421","name":"扶绥县","cityCode":"4514","provinceCode":"45"},{"code":"451422","name":"宁明县","cityCode":"4514","provinceCode":"45"},{"code":"451423","name":"龙州县","cityCode":"4514","provinceCode":"45"},{"code":"451424","name":"大新县","cityCode":"4514","provinceCode":"45"},{"code":"451425","name":"天等县","cityCode":"4514","provinceCode":"45"},{"code":"451481","name":"凭祥市","cityCode":"4514","provinceCode":"45"},{"code":"460105","name":"秀英区","cityCode":"4601","provinceCode":"46"},{"code":"460106","name":"龙华区","cityCode":"4601","provinceCode":"46"},{"code":"460107","name":"琼山区","cityCode":"4601","provinceCode":"46"},{"code":"460108","name":"美兰区","cityCode":"4601","provinceCode":"46"},{"code":"460202","name":"海棠区","cityCode":"4602","provinceCode":"46"},{"code":"460203","name":"吉阳区","cityCode":"4602","provinceCode":"46"},{"code":"460204","name":"天涯区","cityCode":"4602","provinceCode":"46"},{"code":"460205","name":"崖州区","cityCode":"4602","provinceCode":"46"},{"code":"460321","name":"西沙群岛","cityCode":"4603","provinceCode":"46"},{"code":"460322","name":"南沙群岛","cityCode":"4603","provinceCode":"46"},{"code":"460323","name":"中沙群岛的岛礁及其海域","cityCode":"4603","provinceCode":"46"},{"code":"460400","name":"儋州市","cityCode":"4604","provinceCode":"46"},{"code":"469001","name":"五指山市","cityCode":"4690","provinceCode":"46"},{"code":"469002","name":"琼海市","cityCode":"4690","provinceCode":"46"},{"code":"469005","name":"文昌市","cityCode":"4690","provinceCode":"46"},{"code":"469006","name":"万宁市","cityCode":"4690","provinceCode":"46"},{"code":"469007","name":"东方市","cityCode":"4690","provinceCode":"46"},{"code":"469021","name":"定安县","cityCode":"4690","provinceCode":"46"},{"code":"469022","name":"屯昌县","cityCode":"4690","provinceCode":"46"},{"code":"469023","name":"澄迈县","cityCode":"4690","provinceCode":"46"},{"code":"469024","name":"临高县","cityCode":"4690","provinceCode":"46"},{"code":"469025","name":"白沙黎族自治县","cityCode":"4690","provinceCode":"46"},{"code":"469026","name":"昌江黎族自治县","cityCode":"4690","provinceCode":"46"},{"code":"469027","name":"乐东黎族自治县","cityCode":"4690","provinceCode":"46"},{"code":"469028","name":"陵水黎族自治县","cityCode":"4690","provinceCode":"46"},{"code":"469029","name":"保亭黎族苗族自治县","cityCode":"4690","provinceCode":"46"},{"code":"469030","name":"琼中黎族苗族自治县","cityCode":"4690","provinceCode":"46"},{"code":"500101","name":"万州区","cityCode":"5001","provinceCode":"50"},{"code":"500102","name":"涪陵区","cityCode":"5001","provinceCode":"50"},{"code":"500103","name":"渝中区","cityCode":"5001","provinceCode":"50"},{"code":"500104","name":"大渡口区","cityCode":"5001","provinceCode":"50"},{"code":"500105","name":"江北区","cityCode":"5001","provinceCode":"50"},{"code":"500106","name":"沙坪坝区","cityCode":"5001","provinceCode":"50"},{"code":"500107","name":"九龙坡区","cityCode":"5001","provinceCode":"50"},{"code":"500108","name":"南岸区","cityCode":"5001","provinceCode":"50"},{"code":"500109","name":"北碚区","cityCode":"5001","provinceCode":"50"},{"code":"500110","name":"綦江区","cityCode":"5001","provinceCode":"50"},{"code":"500111","name":"大足区","cityCode":"5001","provinceCode":"50"},{"code":"500112","name":"渝北区","cityCode":"5001","provinceCode":"50"},{"code":"500113","name":"巴南区","cityCode":"5001","provinceCode":"50"},{"code":"500114","name":"黔江区","cityCode":"5001","provinceCode":"50"},{"code":"500115","name":"长寿区","cityCode":"5001","provinceCode":"50"},{"code":"500116","name":"江津区","cityCode":"5001","provinceCode":"50"},{"code":"500117","name":"合川区","cityCode":"5001","provinceCode":"50"},{"code":"500118","name":"永川区","cityCode":"5001","provinceCode":"50"},{"code":"500119","name":"南川区","cityCode":"5001","provinceCode":"50"},{"code":"500120","name":"璧山区","cityCode":"5001","provinceCode":"50"},{"code":"500151","name":"铜梁区","cityCode":"5001","provinceCode":"50"},{"code":"500152","name":"潼南区","cityCode":"5001","provinceCode":"50"},{"code":"500153","name":"荣昌区","cityCode":"5001","provinceCode":"50"},{"code":"500154","name":"开州区","cityCode":"5001","provinceCode":"50"},{"code":"500155","name":"梁平区","cityCode":"5001","provinceCode":"50"},{"code":"500156","name":"武隆区","cityCode":"5001","provinceCode":"50"},{"code":"500229","name":"城口县","cityCode":"5002","provinceCode":"50"},{"code":"500230","name":"丰都县","cityCode":"5002","provinceCode":"50"},{"code":"500231","name":"垫江县","cityCode":"5002","provinceCode":"50"},{"code":"500233","name":"忠县","cityCode":"5002","provinceCode":"50"},{"code":"500235","name":"云阳县","cityCode":"5002","provinceCode":"50"},{"code":"500236","name":"奉节县","cityCode":"5002","provinceCode":"50"},{"code":"500237","name":"巫山县","cityCode":"5002","provinceCode":"50"},{"code":"500238","name":"巫溪县","cityCode":"5002","provinceCode":"50"},{"code":"500240","name":"石柱土家族自治县","cityCode":"5002","provinceCode":"50"},{"code":"500241","name":"秀山土家族苗族自治县","cityCode":"5002","provinceCode":"50"},{"code":"500242","name":"酉阳土家族苗族自治县","cityCode":"5002","provinceCode":"50"},{"code":"500243","name":"彭水苗族土家族自治县","cityCode":"5002","provinceCode":"50"},{"code":"510104","name":"锦江区","cityCode":"5101","provinceCode":"51"},{"code":"510105","name":"青羊区","cityCode":"5101","provinceCode":"51"},{"code":"510106","name":"金牛区","cityCode":"5101","provinceCode":"51"},{"code":"510107","name":"武侯区","cityCode":"5101","provinceCode":"51"},{"code":"510108","name":"成华区","cityCode":"5101","provinceCode":"51"},{"code":"510112","name":"龙泉驿区","cityCode":"5101","provinceCode":"51"},{"code":"510113","name":"青白江区","cityCode":"5101","provinceCode":"51"},{"code":"510114","name":"新都区","cityCode":"5101","provinceCode":"51"},{"code":"510115","name":"温江区","cityCode":"5101","provinceCode":"51"},{"code":"510116","name":"双流区","cityCode":"5101","provinceCode":"51"},{"code":"510117","name":"郫都区","cityCode":"5101","provinceCode":"51"},{"code":"510118","name":"新津区","cityCode":"5101","provinceCode":"51"},{"code":"510121","name":"金堂县","cityCode":"5101","provinceCode":"51"},{"code":"510129","name":"大邑县","cityCode":"5101","provinceCode":"51"},{"code":"510131","name":"蒲江县","cityCode":"5101","provinceCode":"51"},{"code":"510181","name":"都江堰市","cityCode":"5101","provinceCode":"51"},{"code":"510182","name":"彭州市","cityCode":"5101","provinceCode":"51"},{"code":"510183","name":"邛崃市","cityCode":"5101","provinceCode":"51"},{"code":"510184","name":"崇州市","cityCode":"5101","provinceCode":"51"},{"code":"510185","name":"简阳市","cityCode":"5101","provinceCode":"51"},{"code":"510302","name":"自流井区","cityCode":"5103","provinceCode":"51"},{"code":"510303","name":"贡井区","cityCode":"5103","provinceCode":"51"},{"code":"510304","name":"大安区","cityCode":"5103","provinceCode":"51"},{"code":"510311","name":"沿滩区","cityCode":"5103","provinceCode":"51"},{"code":"510321","name":"荣县","cityCode":"5103","provinceCode":"51"},{"code":"510322","name":"富顺县","cityCode":"5103","provinceCode":"51"},{"code":"510402","name":"东区","cityCode":"5104","provinceCode":"51"},{"code":"510403","name":"西区","cityCode":"5104","provinceCode":"51"},{"code":"510411","name":"仁和区","cityCode":"5104","provinceCode":"51"},{"code":"510421","name":"米易县","cityCode":"5104","provinceCode":"51"},{"code":"510422","name":"盐边县","cityCode":"5104","provinceCode":"51"},{"code":"510502","name":"江阳区","cityCode":"5105","provinceCode":"51"},{"code":"510503","name":"纳溪区","cityCode":"5105","provinceCode":"51"},{"code":"510504","name":"龙马潭区","cityCode":"5105","provinceCode":"51"},{"code":"510521","name":"泸县","cityCode":"5105","provinceCode":"51"},{"code":"510522","name":"合江县","cityCode":"5105","provinceCode":"51"},{"code":"510524","name":"叙永县","cityCode":"5105","provinceCode":"51"},{"code":"510525","name":"古蔺县","cityCode":"5105","provinceCode":"51"},{"code":"510603","name":"旌阳区","cityCode":"5106","provinceCode":"51"},{"code":"510604","name":"罗江区","cityCode":"5106","provinceCode":"51"},{"code":"510623","name":"中江县","cityCode":"5106","provinceCode":"51"},{"code":"510681","name":"广汉市","cityCode":"5106","provinceCode":"51"},{"code":"510682","name":"什邡市","cityCode":"5106","provinceCode":"51"},{"code":"510683","name":"绵竹市","cityCode":"5106","provinceCode":"51"},{"code":"510703","name":"涪城区","cityCode":"5107","provinceCode":"51"},{"code":"510704","name":"游仙区","cityCode":"5107","provinceCode":"51"},{"code":"510705","name":"安州区","cityCode":"5107","provinceCode":"51"},{"code":"510722","name":"三台县","cityCode":"5107","provinceCode":"51"},{"code":"510723","name":"盐亭县","cityCode":"5107","provinceCode":"51"},{"code":"510725","name":"梓潼县","cityCode":"5107","provinceCode":"51"},{"code":"510726","name":"北川羌族自治县","cityCode":"5107","provinceCode":"51"},{"code":"510727","name":"平武县","cityCode":"5107","provinceCode":"51"},{"code":"510781","name":"江油市","cityCode":"5107","provinceCode":"51"},{"code":"510802","name":"利州区","cityCode":"5108","provinceCode":"51"},{"code":"510811","name":"昭化区","cityCode":"5108","provinceCode":"51"},{"code":"510812","name":"朝天区","cityCode":"5108","provinceCode":"51"},{"code":"510821","name":"旺苍县","cityCode":"5108","provinceCode":"51"},{"code":"510822","name":"青川县","cityCode":"5108","provinceCode":"51"},{"code":"510823","name":"剑阁县","cityCode":"5108","provinceCode":"51"},{"code":"510824","name":"苍溪县","cityCode":"5108","provinceCode":"51"},{"code":"510903","name":"船山区","cityCode":"5109","provinceCode":"51"},{"code":"510904","name":"安居区","cityCode":"5109","provinceCode":"51"},{"code":"510921","name":"蓬溪县","cityCode":"5109","provinceCode":"51"},{"code":"510923","name":"大英县","cityCode":"5109","provinceCode":"51"},{"code":"510981","name":"射洪市","cityCode":"5109","provinceCode":"51"},{"code":"511002","name":"市中区","cityCode":"5110","provinceCode":"51"},{"code":"511011","name":"东兴区","cityCode":"5110","provinceCode":"51"},{"code":"511024","name":"威远县","cityCode":"5110","provinceCode":"51"},{"code":"511025","name":"资中县","cityCode":"5110","provinceCode":"51"},{"code":"511083","name":"隆昌市","cityCode":"5110","provinceCode":"51"},{"code":"511102","name":"市中区","cityCode":"5111","provinceCode":"51"},{"code":"511111","name":"沙湾区","cityCode":"5111","provinceCode":"51"},{"code":"511112","name":"五通桥区","cityCode":"5111","provinceCode":"51"},{"code":"511113","name":"金口河区","cityCode":"5111","provinceCode":"51"},{"code":"511123","name":"犍为县","cityCode":"5111","provinceCode":"51"},{"code":"511124","name":"井研县","cityCode":"5111","provinceCode":"51"},{"code":"511126","name":"夹江县","cityCode":"5111","provinceCode":"51"},{"code":"511129","name":"沐川县","cityCode":"5111","provinceCode":"51"},{"code":"511132","name":"峨边彝族自治县","cityCode":"5111","provinceCode":"51"},{"code":"511133","name":"马边彝族自治县","cityCode":"5111","provinceCode":"51"},{"code":"511181","name":"峨眉山市","cityCode":"5111","provinceCode":"51"},{"code":"511302","name":"顺庆区","cityCode":"5113","provinceCode":"51"},{"code":"511303","name":"高坪区","cityCode":"5113","provinceCode":"51"},{"code":"511304","name":"嘉陵区","cityCode":"5113","provinceCode":"51"},{"code":"511321","name":"南部县","cityCode":"5113","provinceCode":"51"},{"code":"511322","name":"营山县","cityCode":"5113","provinceCode":"51"},{"code":"511323","name":"蓬安县","cityCode":"5113","provinceCode":"51"},{"code":"511324","name":"仪陇县","cityCode":"5113","provinceCode":"51"},{"code":"511325","name":"西充县","cityCode":"5113","provinceCode":"51"},{"code":"511381","name":"阆中市","cityCode":"5113","provinceCode":"51"},{"code":"511402","name":"东坡区","cityCode":"5114","provinceCode":"51"},{"code":"511403","name":"彭山区","cityCode":"5114","provinceCode":"51"},{"code":"511421","name":"仁寿县","cityCode":"5114","provinceCode":"51"},{"code":"511423","name":"洪雅县","cityCode":"5114","provinceCode":"51"},{"code":"511424","name":"丹棱县","cityCode":"5114","provinceCode":"51"},{"code":"511425","name":"青神县","cityCode":"5114","provinceCode":"51"},{"code":"511502","name":"翠屏区","cityCode":"5115","provinceCode":"51"},{"code":"511503","name":"南溪区","cityCode":"5115","provinceCode":"51"},{"code":"511504","name":"叙州区","cityCode":"5115","provinceCode":"51"},{"code":"511523","name":"江安县","cityCode":"5115","provinceCode":"51"},{"code":"511524","name":"长宁县","cityCode":"5115","provinceCode":"51"},{"code":"511525","name":"高县","cityCode":"5115","provinceCode":"51"},{"code":"511526","name":"珙县","cityCode":"5115","provinceCode":"51"},{"code":"511527","name":"筠连县","cityCode":"5115","provinceCode":"51"},{"code":"511528","name":"兴文县","cityCode":"5115","provinceCode":"51"},{"code":"511529","name":"屏山县","cityCode":"5115","provinceCode":"51"},{"code":"511602","name":"广安区","cityCode":"5116","provinceCode":"51"},{"code":"511603","name":"前锋区","cityCode":"5116","provinceCode":"51"},{"code":"511621","name":"岳池县","cityCode":"5116","provinceCode":"51"},{"code":"511622","name":"武胜县","cityCode":"5116","provinceCode":"51"},{"code":"511623","name":"邻水县","cityCode":"5116","provinceCode":"51"},{"code":"511681","name":"华蓥市","cityCode":"5116","provinceCode":"51"},{"code":"511702","name":"通川区","cityCode":"5117","provinceCode":"51"},{"code":"511703","name":"达川区","cityCode":"5117","provinceCode":"51"},{"code":"511722","name":"宣汉县","cityCode":"5117","provinceCode":"51"},{"code":"511723","name":"开江县","cityCode":"5117","provinceCode":"51"},{"code":"511724","name":"大竹县","cityCode":"5117","provinceCode":"51"},{"code":"511725","name":"渠县","cityCode":"5117","provinceCode":"51"},{"code":"511781","name":"万源市","cityCode":"5117","provinceCode":"51"},{"code":"511802","name":"雨城区","cityCode":"5118","provinceCode":"51"},{"code":"511803","name":"名山区","cityCode":"5118","provinceCode":"51"},{"code":"511822","name":"荥经县","cityCode":"5118","provinceCode":"51"},{"code":"511823","name":"汉源县","cityCode":"5118","provinceCode":"51"},{"code":"511824","name":"石棉县","cityCode":"5118","provinceCode":"51"},{"code":"511825","name":"天全县","cityCode":"5118","provinceCode":"51"},{"code":"511826","name":"芦山县","cityCode":"5118","provinceCode":"51"},{"code":"511827","name":"宝兴县","cityCode":"5118","provinceCode":"51"},{"code":"511902","name":"巴州区","cityCode":"5119","provinceCode":"51"},{"code":"511903","name":"恩阳区","cityCode":"5119","provinceCode":"51"},{"code":"511921","name":"通江县","cityCode":"5119","provinceCode":"51"},{"code":"511922","name":"南江县","cityCode":"5119","provinceCode":"51"},{"code":"511923","name":"平昌县","cityCode":"5119","provinceCode":"51"},{"code":"512002","name":"雁江区","cityCode":"5120","provinceCode":"51"},{"code":"512021","name":"安岳县","cityCode":"5120","provinceCode":"51"},{"code":"512022","name":"乐至县","cityCode":"5120","provinceCode":"51"},{"code":"513201","name":"马尔康市","cityCode":"5132","provinceCode":"51"},{"code":"513221","name":"汶川县","cityCode":"5132","provinceCode":"51"},{"code":"513222","name":"理县","cityCode":"5132","provinceCode":"51"},{"code":"513223","name":"茂县","cityCode":"5132","provinceCode":"51"},{"code":"513224","name":"松潘县","cityCode":"5132","provinceCode":"51"},{"code":"513225","name":"九寨沟县","cityCode":"5132","provinceCode":"51"},{"code":"513226","name":"金川县","cityCode":"5132","provinceCode":"51"},{"code":"513227","name":"小金县","cityCode":"5132","provinceCode":"51"},{"code":"513228","name":"黑水县","cityCode":"5132","provinceCode":"51"},{"code":"513230","name":"壤塘县","cityCode":"5132","provinceCode":"51"},{"code":"513231","name":"阿坝县","cityCode":"5132","provinceCode":"51"},{"code":"513232","name":"若尔盖县","cityCode":"5132","provinceCode":"51"},{"code":"513233","name":"红原县","cityCode":"5132","provinceCode":"51"},{"code":"513301","name":"康定市","cityCode":"5133","provinceCode":"51"},{"code":"513322","name":"泸定县","cityCode":"5133","provinceCode":"51"},{"code":"513323","name":"丹巴县","cityCode":"5133","provinceCode":"51"},{"code":"513324","name":"九龙县","cityCode":"5133","provinceCode":"51"},{"code":"513325","name":"雅江县","cityCode":"5133","provinceCode":"51"},{"code":"513326","name":"道孚县","cityCode":"5133","provinceCode":"51"},{"code":"513327","name":"炉霍县","cityCode":"5133","provinceCode":"51"},{"code":"513328","name":"甘孜县","cityCode":"5133","provinceCode":"51"},{"code":"513329","name":"新龙县","cityCode":"5133","provinceCode":"51"},{"code":"513330","name":"德格县","cityCode":"5133","provinceCode":"51"},{"code":"513331","name":"白玉县","cityCode":"5133","provinceCode":"51"},{"code":"513332","name":"石渠县","cityCode":"5133","provinceCode":"51"},{"code":"513333","name":"色达县","cityCode":"5133","provinceCode":"51"},{"code":"513334","name":"理塘县","cityCode":"5133","provinceCode":"51"},{"code":"513335","name":"巴塘县","cityCode":"5133","provinceCode":"51"},{"code":"513336","name":"乡城县","cityCode":"5133","provinceCode":"51"},{"code":"513337","name":"稻城县","cityCode":"5133","provinceCode":"51"},{"code":"513338","name":"得荣县","cityCode":"5133","provinceCode":"51"},{"code":"513401","name":"西昌市","cityCode":"5134","provinceCode":"51"},{"code":"513402","name":"会理市","cityCode":"5134","provinceCode":"51"},{"code":"513422","name":"木里藏族自治县","cityCode":"5134","provinceCode":"51"},{"code":"513423","name":"盐源县","cityCode":"5134","provinceCode":"51"},{"code":"513424","name":"德昌县","cityCode":"5134","provinceCode":"51"},{"code":"513426","name":"会东县","cityCode":"5134","provinceCode":"51"},{"code":"513427","name":"宁南县","cityCode":"5134","provinceCode":"51"},{"code":"513428","name":"普格县","cityCode":"5134","provinceCode":"51"},{"code":"513429","name":"布拖县","cityCode":"5134","provinceCode":"51"},{"code":"513430","name":"金阳县","cityCode":"5134","provinceCode":"51"},{"code":"513431","name":"昭觉县","cityCode":"5134","provinceCode":"51"},{"code":"513432","name":"喜德县","cityCode":"5134","provinceCode":"51"},{"code":"513433","name":"冕宁县","cityCode":"5134","provinceCode":"51"},{"code":"513434","name":"越西县","cityCode":"5134","provinceCode":"51"},{"code":"513435","name":"甘洛县","cityCode":"5134","provinceCode":"51"},{"code":"513436","name":"美姑县","cityCode":"5134","provinceCode":"51"},{"code":"513437","name":"雷波县","cityCode":"5134","provinceCode":"51"},{"code":"520102","name":"南明区","cityCode":"5201","provinceCode":"52"},{"code":"520103","name":"云岩区","cityCode":"5201","provinceCode":"52"},{"code":"520111","name":"花溪区","cityCode":"5201","provinceCode":"52"},{"code":"520112","name":"乌当区","cityCode":"5201","provinceCode":"52"},{"code":"520113","name":"白云区","cityCode":"5201","provinceCode":"52"},{"code":"520115","name":"观山湖区","cityCode":"5201","provinceCode":"52"},{"code":"520121","name":"开阳县","cityCode":"5201","provinceCode":"52"},{"code":"520122","name":"息烽县","cityCode":"5201","provinceCode":"52"},{"code":"520123","name":"修文县","cityCode":"5201","provinceCode":"52"},{"code":"520181","name":"清镇市","cityCode":"5201","provinceCode":"52"},{"code":"520201","name":"钟山区","cityCode":"5202","provinceCode":"52"},{"code":"520203","name":"六枝特区","cityCode":"5202","provinceCode":"52"},{"code":"520204","name":"水城区","cityCode":"5202","provinceCode":"52"},{"code":"520281","name":"盘州市","cityCode":"5202","provinceCode":"52"},{"code":"520302","name":"红花岗区","cityCode":"5203","provinceCode":"52"},{"code":"520303","name":"汇川区","cityCode":"5203","provinceCode":"52"},{"code":"520304","name":"播州区","cityCode":"5203","provinceCode":"52"},{"code":"520322","name":"桐梓县","cityCode":"5203","provinceCode":"52"},{"code":"520323","name":"绥阳县","cityCode":"5203","provinceCode":"52"},{"code":"520324","name":"正安县","cityCode":"5203","provinceCode":"52"},{"code":"520325","name":"道真仡佬族苗族自治县","cityCode":"5203","provinceCode":"52"},{"code":"520326","name":"务川仡佬族苗族自治县","cityCode":"5203","provinceCode":"52"},{"code":"520327","name":"凤冈县","cityCode":"5203","provinceCode":"52"},{"code":"520328","name":"湄潭县","cityCode":"5203","provinceCode":"52"},{"code":"520329","name":"余庆县","cityCode":"5203","provinceCode":"52"},{"code":"520330","name":"习水县","cityCode":"5203","provinceCode":"52"},{"code":"520381","name":"赤水市","cityCode":"5203","provinceCode":"52"},{"code":"520382","name":"仁怀市","cityCode":"5203","provinceCode":"52"},{"code":"520402","name":"西秀区","cityCode":"5204","provinceCode":"52"},{"code":"520403","name":"平坝区","cityCode":"5204","provinceCode":"52"},{"code":"520422","name":"普定县","cityCode":"5204","provinceCode":"52"},{"code":"520423","name":"镇宁布依族苗族自治县","cityCode":"5204","provinceCode":"52"},{"code":"520424","name":"关岭布依族苗族自治县","cityCode":"5204","provinceCode":"52"},{"code":"520425","name":"紫云苗族布依族自治县","cityCode":"5204","provinceCode":"52"},{"code":"520502","name":"七星关区","cityCode":"5205","provinceCode":"52"},{"code":"520521","name":"大方县","cityCode":"5205","provinceCode":"52"},{"code":"520523","name":"金沙县","cityCode":"5205","provinceCode":"52"},{"code":"520524","name":"织金县","cityCode":"5205","provinceCode":"52"},{"code":"520525","name":"纳雍县","cityCode":"5205","provinceCode":"52"},{"code":"520526","name":"威宁彝族回族苗族自治县","cityCode":"5205","provinceCode":"52"},{"code":"520527","name":"赫章县","cityCode":"5205","provinceCode":"52"},{"code":"520581","name":"黔西市","cityCode":"5205","provinceCode":"52"},{"code":"520602","name":"碧江区","cityCode":"5206","provinceCode":"52"},{"code":"520603","name":"万山区","cityCode":"5206","provinceCode":"52"},{"code":"520621","name":"江口县","cityCode":"5206","provinceCode":"52"},{"code":"520622","name":"玉屏侗族自治县","cityCode":"5206","provinceCode":"52"},{"code":"520623","name":"石阡县","cityCode":"5206","provinceCode":"52"},{"code":"520624","name":"思南县","cityCode":"5206","provinceCode":"52"},{"code":"520625","name":"印江土家族苗族自治县","cityCode":"5206","provinceCode":"52"},{"code":"520626","name":"德江县","cityCode":"5206","provinceCode":"52"},{"code":"520627","name":"沿河土家族自治县","cityCode":"5206","provinceCode":"52"},{"code":"520628","name":"松桃苗族自治县","cityCode":"5206","provinceCode":"52"},{"code":"522301","name":"兴义市","cityCode":"5223","provinceCode":"52"},{"code":"522302","name":"兴仁市","cityCode":"5223","provinceCode":"52"},{"code":"522323","name":"普安县","cityCode":"5223","provinceCode":"52"},{"code":"522324","name":"晴隆县","cityCode":"5223","provinceCode":"52"},{"code":"522325","name":"贞丰县","cityCode":"5223","provinceCode":"52"},{"code":"522326","name":"望谟县","cityCode":"5223","provinceCode":"52"},{"code":"522327","name":"册亨县","cityCode":"5223","provinceCode":"52"},{"code":"522328","name":"安龙县","cityCode":"5223","provinceCode":"52"},{"code":"522601","name":"凯里市","cityCode":"5226","provinceCode":"52"},{"code":"522622","name":"黄平县","cityCode":"5226","provinceCode":"52"},{"code":"522623","name":"施秉县","cityCode":"5226","provinceCode":"52"},{"code":"522624","name":"三穗县","cityCode":"5226","provinceCode":"52"},{"code":"522625","name":"镇远县","cityCode":"5226","provinceCode":"52"},{"code":"522626","name":"岑巩县","cityCode":"5226","provinceCode":"52"},{"code":"522627","name":"天柱县","cityCode":"5226","provinceCode":"52"},{"code":"522628","name":"锦屏县","cityCode":"5226","provinceCode":"52"},{"code":"522629","name":"剑河县","cityCode":"5226","provinceCode":"52"},{"code":"522630","name":"台江县","cityCode":"5226","provinceCode":"52"},{"code":"522631","name":"黎平县","cityCode":"5226","provinceCode":"52"},{"code":"522632","name":"榕江县","cityCode":"5226","provinceCode":"52"},{"code":"522633","name":"从江县","cityCode":"5226","provinceCode":"52"},{"code":"522634","name":"雷山县","cityCode":"5226","provinceCode":"52"},{"code":"522635","name":"麻江县","cityCode":"5226","provinceCode":"52"},{"code":"522636","name":"丹寨县","cityCode":"5226","provinceCode":"52"},{"code":"522701","name":"都匀市","cityCode":"5227","provinceCode":"52"},{"code":"522702","name":"福泉市","cityCode":"5227","provinceCode":"52"},{"code":"522722","name":"荔波县","cityCode":"5227","provinceCode":"52"},{"code":"522723","name":"贵定县","cityCode":"5227","provinceCode":"52"},{"code":"522725","name":"瓮安县","cityCode":"5227","provinceCode":"52"},{"code":"522726","name":"独山县","cityCode":"5227","provinceCode":"52"},{"code":"522727","name":"平塘县","cityCode":"5227","provinceCode":"52"},{"code":"522728","name":"罗甸县","cityCode":"5227","provinceCode":"52"},{"code":"522729","name":"长顺县","cityCode":"5227","provinceCode":"52"},{"code":"522730","name":"龙里县","cityCode":"5227","provinceCode":"52"},{"code":"522731","name":"惠水县","cityCode":"5227","provinceCode":"52"},{"code":"522732","name":"三都水族自治县","cityCode":"5227","provinceCode":"52"},{"code":"530102","name":"五华区","cityCode":"5301","provinceCode":"53"},{"code":"530103","name":"盘龙区","cityCode":"5301","provinceCode":"53"},{"code":"530111","name":"官渡区","cityCode":"5301","provinceCode":"53"},{"code":"530112","name":"西山区","cityCode":"5301","provinceCode":"53"},{"code":"530113","name":"东川区","cityCode":"5301","provinceCode":"53"},{"code":"530114","name":"呈贡区","cityCode":"5301","provinceCode":"53"},{"code":"530115","name":"晋宁区","cityCode":"5301","provinceCode":"53"},{"code":"530124","name":"富民县","cityCode":"5301","provinceCode":"53"},{"code":"530125","name":"宜良县","cityCode":"5301","provinceCode":"53"},{"code":"530126","name":"石林彝族自治县","cityCode":"5301","provinceCode":"53"},{"code":"530127","name":"嵩明县","cityCode":"5301","provinceCode":"53"},{"code":"530128","name":"禄劝彝族苗族自治县","cityCode":"5301","provinceCode":"53"},{"code":"530129","name":"寻甸回族彝族自治县","cityCode":"5301","provinceCode":"53"},{"code":"530181","name":"安宁市","cityCode":"5301","provinceCode":"53"},{"code":"530302","name":"麒麟区","cityCode":"5303","provinceCode":"53"},{"code":"530303","name":"沾益区","cityCode":"5303","provinceCode":"53"},{"code":"530304","name":"马龙区","cityCode":"5303","provinceCode":"53"},{"code":"530322","name":"陆良县","cityCode":"5303","provinceCode":"53"},{"code":"530323","name":"师宗县","cityCode":"5303","provinceCode":"53"},{"code":"530324","name":"罗平县","cityCode":"5303","provinceCode":"53"},{"code":"530325","name":"富源县","cityCode":"5303","provinceCode":"53"},{"code":"530326","name":"会泽县","cityCode":"5303","provinceCode":"53"},{"code":"530381","name":"宣威市","cityCode":"5303","provinceCode":"53"},{"code":"530402","name":"红塔区","cityCode":"5304","provinceCode":"53"},{"code":"530403","name":"江川区","cityCode":"5304","provinceCode":"53"},{"code":"530423","name":"通海县","cityCode":"5304","provinceCode":"53"},{"code":"530424","name":"华宁县","cityCode":"5304","provinceCode":"53"},{"code":"530425","name":"易门县","cityCode":"5304","provinceCode":"53"},{"code":"530426","name":"峨山彝族自治县","cityCode":"5304","provinceCode":"53"},{"code":"530427","name":"新平彝族傣族自治县","cityCode":"5304","provinceCode":"53"},{"code":"530428","name":"元江哈尼族彝族傣族自治县","cityCode":"5304","provinceCode":"53"},{"code":"530481","name":"澄江市","cityCode":"5304","provinceCode":"53"},{"code":"530502","name":"隆阳区","cityCode":"5305","provinceCode":"53"},{"code":"530521","name":"施甸县","cityCode":"5305","provinceCode":"53"},{"code":"530523","name":"龙陵县","cityCode":"5305","provinceCode":"53"},{"code":"530524","name":"昌宁县","cityCode":"5305","provinceCode":"53"},{"code":"530581","name":"腾冲市","cityCode":"5305","provinceCode":"53"},{"code":"530602","name":"昭阳区","cityCode":"5306","provinceCode":"53"},{"code":"530621","name":"鲁甸县","cityCode":"5306","provinceCode":"53"},{"code":"530622","name":"巧家县","cityCode":"5306","provinceCode":"53"},{"code":"530623","name":"盐津县","cityCode":"5306","provinceCode":"53"},{"code":"530624","name":"大关县","cityCode":"5306","provinceCode":"53"},{"code":"530625","name":"永善县","cityCode":"5306","provinceCode":"53"},{"code":"530626","name":"绥江县","cityCode":"5306","provinceCode":"53"},{"code":"530627","name":"镇雄县","cityCode":"5306","provinceCode":"53"},{"code":"530628","name":"彝良县","cityCode":"5306","provinceCode":"53"},{"code":"530629","name":"威信县","cityCode":"5306","provinceCode":"53"},{"code":"530681","name":"水富市","cityCode":"5306","provinceCode":"53"},{"code":"530702","name":"古城区","cityCode":"5307","provinceCode":"53"},{"code":"530721","name":"玉龙纳西族自治县","cityCode":"5307","provinceCode":"53"},{"code":"530722","name":"永胜县","cityCode":"5307","provinceCode":"53"},{"code":"530723","name":"华坪县","cityCode":"5307","provinceCode":"53"},{"code":"530724","name":"宁蒗彝族自治县","cityCode":"5307","provinceCode":"53"},{"code":"530802","name":"思茅区","cityCode":"5308","provinceCode":"53"},{"code":"530821","name":"宁洱哈尼族彝族自治县","cityCode":"5308","provinceCode":"53"},{"code":"530822","name":"墨江哈尼族自治县","cityCode":"5308","provinceCode":"53"},{"code":"530823","name":"景东彝族自治县","cityCode":"5308","provinceCode":"53"},{"code":"530824","name":"景谷傣族彝族自治县","cityCode":"5308","provinceCode":"53"},{"code":"530825","name":"镇沅彝族哈尼族拉祜族自治县","cityCode":"5308","provinceCode":"53"},{"code":"530826","name":"江城哈尼族彝族自治县","cityCode":"5308","provinceCode":"53"},{"code":"530827","name":"孟连傣族拉祜族佤族自治县","cityCode":"5308","provinceCode":"53"},{"code":"530828","name":"澜沧拉祜族自治县","cityCode":"5308","provinceCode":"53"},{"code":"530829","name":"西盟佤族自治县","cityCode":"5308","provinceCode":"53"},{"code":"530902","name":"临翔区","cityCode":"5309","provinceCode":"53"},{"code":"530921","name":"凤庆县","cityCode":"5309","provinceCode":"53"},{"code":"530922","name":"云县","cityCode":"5309","provinceCode":"53"},{"code":"530923","name":"永德县","cityCode":"5309","provinceCode":"53"},{"code":"530924","name":"镇康县","cityCode":"5309","provinceCode":"53"},{"code":"530925","name":"双江拉祜族佤族布朗族傣族自治县","cityCode":"5309","provinceCode":"53"},{"code":"530926","name":"耿马傣族佤族自治县","cityCode":"5309","provinceCode":"53"},{"code":"530927","name":"沧源佤族自治县","cityCode":"5309","provinceCode":"53"},{"code":"532301","name":"楚雄市","cityCode":"5323","provinceCode":"53"},{"code":"532302","name":"禄丰市","cityCode":"5323","provinceCode":"53"},{"code":"532322","name":"双柏县","cityCode":"5323","provinceCode":"53"},{"code":"532323","name":"牟定县","cityCode":"5323","provinceCode":"53"},{"code":"532324","name":"南华县","cityCode":"5323","provinceCode":"53"},{"code":"532325","name":"姚安县","cityCode":"5323","provinceCode":"53"},{"code":"532326","name":"大姚县","cityCode":"5323","provinceCode":"53"},{"code":"532327","name":"永仁县","cityCode":"5323","provinceCode":"53"},{"code":"532328","name":"元谋县","cityCode":"5323","provinceCode":"53"},{"code":"532329","name":"武定县","cityCode":"5323","provinceCode":"53"},{"code":"532501","name":"个旧市","cityCode":"5325","provinceCode":"53"},{"code":"532502","name":"开远市","cityCode":"5325","provinceCode":"53"},{"code":"532503","name":"蒙自市","cityCode":"5325","provinceCode":"53"},{"code":"532504","name":"弥勒市","cityCode":"5325","provinceCode":"53"},{"code":"532523","name":"屏边苗族自治县","cityCode":"5325","provinceCode":"53"},{"code":"532524","name":"建水县","cityCode":"5325","provinceCode":"53"},{"code":"532525","name":"石屏县","cityCode":"5325","provinceCode":"53"},{"code":"532527","name":"泸西县","cityCode":"5325","provinceCode":"53"},{"code":"532528","name":"元阳县","cityCode":"5325","provinceCode":"53"},{"code":"532529","name":"红河县","cityCode":"5325","provinceCode":"53"},{"code":"532530","name":"金平苗族瑶族傣族自治县","cityCode":"5325","provinceCode":"53"},{"code":"532531","name":"绿春县","cityCode":"5325","provinceCode":"53"},{"code":"532532","name":"河口瑶族自治县","cityCode":"5325","provinceCode":"53"},{"code":"532601","name":"文山市","cityCode":"5326","provinceCode":"53"},{"code":"532622","name":"砚山县","cityCode":"5326","provinceCode":"53"},{"code":"532623","name":"西畴县","cityCode":"5326","provinceCode":"53"},{"code":"532624","name":"麻栗坡县","cityCode":"5326","provinceCode":"53"},{"code":"532625","name":"马关县","cityCode":"5326","provinceCode":"53"},{"code":"532626","name":"丘北县","cityCode":"5326","provinceCode":"53"},{"code":"532627","name":"广南县","cityCode":"5326","provinceCode":"53"},{"code":"532628","name":"富宁县","cityCode":"5326","provinceCode":"53"},{"code":"532801","name":"景洪市","cityCode":"5328","provinceCode":"53"},{"code":"532822","name":"勐海县","cityCode":"5328","provinceCode":"53"},{"code":"532823","name":"勐腊县","cityCode":"5328","provinceCode":"53"},{"code":"532901","name":"大理市","cityCode":"5329","provinceCode":"53"},{"code":"532922","name":"漾濞彝族自治县","cityCode":"5329","provinceCode":"53"},{"code":"532923","name":"祥云县","cityCode":"5329","provinceCode":"53"},{"code":"532924","name":"宾川县","cityCode":"5329","provinceCode":"53"},{"code":"532925","name":"弥渡县","cityCode":"5329","provinceCode":"53"},{"code":"532926","name":"南涧彝族自治县","cityCode":"5329","provinceCode":"53"},{"code":"532927","name":"巍山彝族回族自治县","cityCode":"5329","provinceCode":"53"},{"code":"532928","name":"永平县","cityCode":"5329","provinceCode":"53"},{"code":"532929","name":"云龙县","cityCode":"5329","provinceCode":"53"},{"code":"532930","name":"洱源县","cityCode":"5329","provinceCode":"53"},{"code":"532931","name":"剑川县","cityCode":"5329","provinceCode":"53"},{"code":"532932","name":"鹤庆县","cityCode":"5329","provinceCode":"53"},{"code":"533102","name":"瑞丽市","cityCode":"5331","provinceCode":"53"},{"code":"533103","name":"芒市","cityCode":"5331","provinceCode":"53"},{"code":"533122","name":"梁河县","cityCode":"5331","provinceCode":"53"},{"code":"533123","name":"盈江县","cityCode":"5331","provinceCode":"53"},{"code":"533124","name":"陇川县","cityCode":"5331","provinceCode":"53"},{"code":"533301","name":"泸水市","cityCode":"5333","provinceCode":"53"},{"code":"533323","name":"福贡县","cityCode":"5333","provinceCode":"53"},{"code":"533324","name":"贡山独龙族怒族自治县","cityCode":"5333","provinceCode":"53"},{"code":"533325","name":"兰坪白族普米族自治县","cityCode":"5333","provinceCode":"53"},{"code":"533401","name":"香格里拉市","cityCode":"5334","provinceCode":"53"},{"code":"533422","name":"德钦县","cityCode":"5334","provinceCode":"53"},{"code":"533423","name":"维西傈僳族自治县","cityCode":"5334","provinceCode":"53"},{"code":"540102","name":"城关区","cityCode":"5401","provinceCode":"54"},{"code":"540103","name":"堆龙德庆区","cityCode":"5401","provinceCode":"54"},{"code":"540104","name":"达孜区","cityCode":"5401","provinceCode":"54"},{"code":"540121","name":"林周县","cityCode":"5401","provinceCode":"54"},{"code":"540122","name":"当雄县","cityCode":"5401","provinceCode":"54"},{"code":"540123","name":"尼木县","cityCode":"5401","provinceCode":"54"},{"code":"540124","name":"曲水县","cityCode":"5401","provinceCode":"54"},{"code":"540127","name":"墨竹工卡县","cityCode":"5401","provinceCode":"54"},{"code":"540171","name":"格尔木藏青工业园区","cityCode":"5401","provinceCode":"54"},{"code":"540172","name":"拉萨经济技术开发区","cityCode":"5401","provinceCode":"54"},{"code":"540173","name":"西藏文化旅游创意园区","cityCode":"5401","provinceCode":"54"},{"code":"540174","name":"达孜工业园区","cityCode":"5401","provinceCode":"54"},{"code":"540202","name":"桑珠孜区","cityCode":"5402","provinceCode":"54"},{"code":"540221","name":"南木林县","cityCode":"5402","provinceCode":"54"},{"code":"540222","name":"江孜县","cityCode":"5402","provinceCode":"54"},{"code":"540223","name":"定日县","cityCode":"5402","provinceCode":"54"},{"code":"540224","name":"萨迦县","cityCode":"5402","provinceCode":"54"},{"code":"540225","name":"拉孜县","cityCode":"5402","provinceCode":"54"},{"code":"540226","name":"昂仁县","cityCode":"5402","provinceCode":"54"},{"code":"540227","name":"谢通门县","cityCode":"5402","provinceCode":"54"},{"code":"540228","name":"白朗县","cityCode":"5402","provinceCode":"54"},{"code":"540229","name":"仁布县","cityCode":"5402","provinceCode":"54"},{"code":"540230","name":"康马县","cityCode":"5402","provinceCode":"54"},{"code":"540231","name":"定结县","cityCode":"5402","provinceCode":"54"},{"code":"540232","name":"仲巴县","cityCode":"5402","provinceCode":"54"},{"code":"540233","name":"亚东县","cityCode":"5402","provinceCode":"54"},{"code":"540234","name":"吉隆县","cityCode":"5402","provinceCode":"54"},{"code":"540235","name":"聂拉木县","cityCode":"5402","provinceCode":"54"},{"code":"540236","name":"萨嘎县","cityCode":"5402","provinceCode":"54"},{"code":"540237","name":"岗巴县","cityCode":"5402","provinceCode":"54"},{"code":"540302","name":"卡若区","cityCode":"5403","provinceCode":"54"},{"code":"540321","name":"江达县","cityCode":"5403","provinceCode":"54"},{"code":"540322","name":"贡觉县","cityCode":"5403","provinceCode":"54"},{"code":"540323","name":"类乌齐县","cityCode":"5403","provinceCode":"54"},{"code":"540324","name":"丁青县","cityCode":"5403","provinceCode":"54"},{"code":"540325","name":"察雅县","cityCode":"5403","provinceCode":"54"},{"code":"540326","name":"八宿县","cityCode":"5403","provinceCode":"54"},{"code":"540327","name":"左贡县","cityCode":"5403","provinceCode":"54"},{"code":"540328","name":"芒康县","cityCode":"5403","provinceCode":"54"},{"code":"540329","name":"洛隆县","cityCode":"5403","provinceCode":"54"},{"code":"540330","name":"边坝县","cityCode":"5403","provinceCode":"54"},{"code":"540402","name":"巴宜区","cityCode":"5404","provinceCode":"54"},{"code":"540421","name":"工布江达县","cityCode":"5404","provinceCode":"54"},{"code":"540423","name":"墨脱县","cityCode":"5404","provinceCode":"54"},{"code":"540424","name":"波密县","cityCode":"5404","provinceCode":"54"},{"code":"540425","name":"察隅县","cityCode":"5404","provinceCode":"54"},{"code":"540426","name":"朗县","cityCode":"5404","provinceCode":"54"},{"code":"540481","name":"米林市","cityCode":"5404","provinceCode":"54"},{"code":"540502","name":"乃东区","cityCode":"5405","provinceCode":"54"},{"code":"540521","name":"扎囊县","cityCode":"5405","provinceCode":"54"},{"code":"540522","name":"贡嘎县","cityCode":"5405","provinceCode":"54"},{"code":"540523","name":"桑日县","cityCode":"5405","provinceCode":"54"},{"code":"540524","name":"琼结县","cityCode":"5405","provinceCode":"54"},{"code":"540525","name":"曲松县","cityCode":"5405","provinceCode":"54"},{"code":"540526","name":"措美县","cityCode":"5405","provinceCode":"54"},{"code":"540527","name":"洛扎县","cityCode":"5405","provinceCode":"54"},{"code":"540528","name":"加查县","cityCode":"5405","provinceCode":"54"},{"code":"540529","name":"隆子县","cityCode":"5405","provinceCode":"54"},{"code":"540531","name":"浪卡子县","cityCode":"5405","provinceCode":"54"},{"code":"540581","name":"错那市","cityCode":"5405","provinceCode":"54"},{"code":"540602","name":"色尼区","cityCode":"5406","provinceCode":"54"},{"code":"540621","name":"嘉黎县","cityCode":"5406","provinceCode":"54"},{"code":"540622","name":"比如县","cityCode":"5406","provinceCode":"54"},{"code":"540623","name":"聂荣县","cityCode":"5406","provinceCode":"54"},{"code":"540624","name":"安多县","cityCode":"5406","provinceCode":"54"},{"code":"540625","name":"申扎县","cityCode":"5406","provinceCode":"54"},{"code":"540626","name":"索县","cityCode":"5406","provinceCode":"54"},{"code":"540627","name":"班戈县","cityCode":"5406","provinceCode":"54"},{"code":"540628","name":"巴青县","cityCode":"5406","provinceCode":"54"},{"code":"540629","name":"尼玛县","cityCode":"5406","provinceCode":"54"},{"code":"540630","name":"双湖县","cityCode":"5406","provinceCode":"54"},{"code":"542521","name":"普兰县","cityCode":"5425","provinceCode":"54"},{"code":"542522","name":"札达县","cityCode":"5425","provinceCode":"54"},{"code":"542523","name":"噶尔县","cityCode":"5425","provinceCode":"54"},{"code":"542524","name":"日土县","cityCode":"5425","provinceCode":"54"},{"code":"542525","name":"革吉县","cityCode":"5425","provinceCode":"54"},{"code":"542526","name":"改则县","cityCode":"5425","provinceCode":"54"},{"code":"542527","name":"措勤县","cityCode":"5425","provinceCode":"54"},{"code":"610102","name":"新城区","cityCode":"6101","provinceCode":"61"},{"code":"610103","name":"碑林区","cityCode":"6101","provinceCode":"61"},{"code":"610104","name":"莲湖区","cityCode":"6101","provinceCode":"61"},{"code":"610111","name":"灞桥区","cityCode":"6101","provinceCode":"61"},{"code":"610112","name":"未央区","cityCode":"6101","provinceCode":"61"},{"code":"610113","name":"雁塔区","cityCode":"6101","provinceCode":"61"},{"code":"610114","name":"阎良区","cityCode":"6101","provinceCode":"61"},{"code":"610115","name":"临潼区","cityCode":"6101","provinceCode":"61"},{"code":"610116","name":"长安区","cityCode":"6101","provinceCode":"61"},{"code":"610117","name":"高陵区","cityCode":"6101","provinceCode":"61"},{"code":"610118","name":"鄠邑区","cityCode":"6101","provinceCode":"61"},{"code":"610122","name":"蓝田县","cityCode":"6101","provinceCode":"61"},{"code":"610124","name":"周至县","cityCode":"6101","provinceCode":"61"},{"code":"610202","name":"王益区","cityCode":"6102","provinceCode":"61"},{"code":"610203","name":"印台区","cityCode":"6102","provinceCode":"61"},{"code":"610204","name":"耀州区","cityCode":"6102","provinceCode":"61"},{"code":"610222","name":"宜君县","cityCode":"6102","provinceCode":"61"},{"code":"610302","name":"渭滨区","cityCode":"6103","provinceCode":"61"},{"code":"610303","name":"金台区","cityCode":"6103","provinceCode":"61"},{"code":"610304","name":"陈仓区","cityCode":"6103","provinceCode":"61"},{"code":"610305","name":"凤翔区","cityCode":"6103","provinceCode":"61"},{"code":"610323","name":"岐山县","cityCode":"6103","provinceCode":"61"},{"code":"610324","name":"扶风县","cityCode":"6103","provinceCode":"61"},{"code":"610326","name":"眉县","cityCode":"6103","provinceCode":"61"},{"code":"610327","name":"陇县","cityCode":"6103","provinceCode":"61"},{"code":"610328","name":"千阳县","cityCode":"6103","provinceCode":"61"},{"code":"610329","name":"麟游县","cityCode":"6103","provinceCode":"61"},{"code":"610330","name":"凤县","cityCode":"6103","provinceCode":"61"},{"code":"610331","name":"太白县","cityCode":"6103","provinceCode":"61"},{"code":"610402","name":"秦都区","cityCode":"6104","provinceCode":"61"},{"code":"610403","name":"杨陵区","cityCode":"6104","provinceCode":"61"},{"code":"610404","name":"渭城区","cityCode":"6104","provinceCode":"61"},{"code":"610422","name":"三原县","cityCode":"6104","provinceCode":"61"},{"code":"610423","name":"泾阳县","cityCode":"6104","provinceCode":"61"},{"code":"610424","name":"乾县","cityCode":"6104","provinceCode":"61"},{"code":"610425","name":"礼泉县","cityCode":"6104","provinceCode":"61"},{"code":"610426","name":"永寿县","cityCode":"6104","provinceCode":"61"},{"code":"610428","name":"长武县","cityCode":"6104","provinceCode":"61"},{"code":"610429","name":"旬邑县","cityCode":"6104","provinceCode":"61"},{"code":"610430","name":"淳化县","cityCode":"6104","provinceCode":"61"},{"code":"610431","name":"武功县","cityCode":"6104","provinceCode":"61"},{"code":"610481","name":"兴平市","cityCode":"6104","provinceCode":"61"},{"code":"610482","name":"彬州市","cityCode":"6104","provinceCode":"61"},{"code":"610502","name":"临渭区","cityCode":"6105","provinceCode":"61"},{"code":"610503","name":"华州区","cityCode":"6105","provinceCode":"61"},{"code":"610522","name":"潼关县","cityCode":"6105","provinceCode":"61"},{"code":"610523","name":"大荔县","cityCode":"6105","provinceCode":"61"},{"code":"610524","name":"合阳县","cityCode":"6105","provinceCode":"61"},{"code":"610525","name":"澄城县","cityCode":"6105","provinceCode":"61"},{"code":"610526","name":"蒲城县","cityCode":"6105","provinceCode":"61"},{"code":"610527","name":"白水县","cityCode":"6105","provinceCode":"61"},{"code":"610528","name":"富平县","cityCode":"6105","provinceCode":"61"},{"code":"610581","name":"韩城市","cityCode":"6105","provinceCode":"61"},{"code":"610582","name":"华阴市","cityCode":"6105","provinceCode":"61"},{"code":"610602","name":"宝塔区","cityCode":"6106","provinceCode":"61"},{"code":"610603","name":"安塞区","cityCode":"6106","provinceCode":"61"},{"code":"610621","name":"延长县","cityCode":"6106","provinceCode":"61"},{"code":"610622","name":"延川县","cityCode":"6106","provinceCode":"61"},{"code":"610625","name":"志丹县","cityCode":"6106","provinceCode":"61"},{"code":"610626","name":"吴起县","cityCode":"6106","provinceCode":"61"},{"code":"610627","name":"甘泉县","cityCode":"6106","provinceCode":"61"},{"code":"610628","name":"富县","cityCode":"6106","provinceCode":"61"},{"code":"610629","name":"洛川县","cityCode":"6106","provinceCode":"61"},{"code":"610630","name":"宜川县","cityCode":"6106","provinceCode":"61"},{"code":"610631","name":"黄龙县","cityCode":"6106","provinceCode":"61"},{"code":"610632","name":"黄陵县","cityCode":"6106","provinceCode":"61"},{"code":"610681","name":"子长市","cityCode":"6106","provinceCode":"61"},{"code":"610702","name":"汉台区","cityCode":"6107","provinceCode":"61"},{"code":"610703","name":"南郑区","cityCode":"6107","provinceCode":"61"},{"code":"610722","name":"城固县","cityCode":"6107","provinceCode":"61"},{"code":"610723","name":"洋县","cityCode":"6107","provinceCode":"61"},{"code":"610724","name":"西乡县","cityCode":"6107","provinceCode":"61"},{"code":"610725","name":"勉县","cityCode":"6107","provinceCode":"61"},{"code":"610726","name":"宁强县","cityCode":"6107","provinceCode":"61"},{"code":"610727","name":"略阳县","cityCode":"6107","provinceCode":"61"},{"code":"610728","name":"镇巴县","cityCode":"6107","provinceCode":"61"},{"code":"610729","name":"留坝县","cityCode":"6107","provinceCode":"61"},{"code":"610730","name":"佛坪县","cityCode":"6107","provinceCode":"61"},{"code":"610802","name":"榆阳区","cityCode":"6108","provinceCode":"61"},{"code":"610803","name":"横山区","cityCode":"6108","provinceCode":"61"},{"code":"610822","name":"府谷县","cityCode":"6108","provinceCode":"61"},{"code":"610824","name":"靖边县","cityCode":"6108","provinceCode":"61"},{"code":"610825","name":"定边县","cityCode":"6108","provinceCode":"61"},{"code":"610826","name":"绥德县","cityCode":"6108","provinceCode":"61"},{"code":"610827","name":"米脂县","cityCode":"6108","provinceCode":"61"},{"code":"610828","name":"佳县","cityCode":"6108","provinceCode":"61"},{"code":"610829","name":"吴堡县","cityCode":"6108","provinceCode":"61"},{"code":"610830","name":"清涧县","cityCode":"6108","provinceCode":"61"},{"code":"610831","name":"子洲县","cityCode":"6108","provinceCode":"61"},{"code":"610881","name":"神木市","cityCode":"6108","provinceCode":"61"},{"code":"610902","name":"汉滨区","cityCode":"6109","provinceCode":"61"},{"code":"610921","name":"汉阴县","cityCode":"6109","provinceCode":"61"},{"code":"610922","name":"石泉县","cityCode":"6109","provinceCode":"61"},{"code":"610923","name":"宁陕县","cityCode":"6109","provinceCode":"61"},{"code":"610924","name":"紫阳县","cityCode":"6109","provinceCode":"61"},{"code":"610925","name":"岚皋县","cityCode":"6109","provinceCode":"61"},{"code":"610926","name":"平利县","cityCode":"6109","provinceCode":"61"},{"code":"610927","name":"镇坪县","cityCode":"6109","provinceCode":"61"},{"code":"610929","name":"白河县","cityCode":"6109","provinceCode":"61"},{"code":"610981","name":"旬阳市","cityCode":"6109","provinceCode":"61"},{"code":"611002","name":"商州区","cityCode":"6110","provinceCode":"61"},{"code":"611021","name":"洛南县","cityCode":"6110","provinceCode":"61"},{"code":"611022","name":"丹凤县","cityCode":"6110","provinceCode":"61"},{"code":"611023","name":"商南县","cityCode":"6110","provinceCode":"61"},{"code":"611024","name":"山阳县","cityCode":"6110","provinceCode":"61"},{"code":"611025","name":"镇安县","cityCode":"6110","provinceCode":"61"},{"code":"611026","name":"柞水县","cityCode":"6110","provinceCode":"61"},{"code":"620102","name":"城关区","cityCode":"6201","provinceCode":"62"},{"code":"620103","name":"七里河区","cityCode":"6201","provinceCode":"62"},{"code":"620104","name":"西固区","cityCode":"6201","provinceCode":"62"},{"code":"620105","name":"安宁区","cityCode":"6201","provinceCode":"62"},{"code":"620111","name":"红古区","cityCode":"6201","provinceCode":"62"},{"code":"620121","name":"永登县","cityCode":"6201","provinceCode":"62"},{"code":"620122","name":"皋兰县","cityCode":"6201","provinceCode":"62"},{"code":"620123","name":"榆中县","cityCode":"6201","provinceCode":"62"},{"code":"620171","name":"兰州新区","cityCode":"6201","provinceCode":"62"},{"code":"620201","name":"嘉峪关市","cityCode":"6202","provinceCode":"62"},{"code":"620302","name":"金川区","cityCode":"6203","provinceCode":"62"},{"code":"620321","name":"永昌县","cityCode":"6203","provinceCode":"62"},{"code":"620402","name":"白银区","cityCode":"6204","provinceCode":"62"},{"code":"620403","name":"平川区","cityCode":"6204","provinceCode":"62"},{"code":"620421","name":"靖远县","cityCode":"6204","provinceCode":"62"},{"code":"620422","name":"会宁县","cityCode":"6204","provinceCode":"62"},{"code":"620423","name":"景泰县","cityCode":"6204","provinceCode":"62"},{"code":"620502","name":"秦州区","cityCode":"6205","provinceCode":"62"},{"code":"620503","name":"麦积区","cityCode":"6205","provinceCode":"62"},{"code":"620521","name":"清水县","cityCode":"6205","provinceCode":"62"},{"code":"620522","name":"秦安县","cityCode":"6205","provinceCode":"62"},{"code":"620523","name":"甘谷县","cityCode":"6205","provinceCode":"62"},{"code":"620524","name":"武山县","cityCode":"6205","provinceCode":"62"},{"code":"620525","name":"张家川回族自治县","cityCode":"6205","provinceCode":"62"},{"code":"620602","name":"凉州区","cityCode":"6206","provinceCode":"62"},{"code":"620621","name":"民勤县","cityCode":"6206","provinceCode":"62"},{"code":"620622","name":"古浪县","cityCode":"6206","provinceCode":"62"},{"code":"620623","name":"天祝藏族自治县","cityCode":"6206","provinceCode":"62"},{"code":"620702","name":"甘州区","cityCode":"6207","provinceCode":"62"},{"code":"620721","name":"肃南裕固族自治县","cityCode":"6207","provinceCode":"62"},{"code":"620722","name":"民乐县","cityCode":"6207","provinceCode":"62"},{"code":"620723","name":"临泽县","cityCode":"6207","provinceCode":"62"},{"code":"620724","name":"高台县","cityCode":"6207","provinceCode":"62"},{"code":"620725","name":"山丹县","cityCode":"6207","provinceCode":"62"},{"code":"620802","name":"崆峒区","cityCode":"6208","provinceCode":"62"},{"code":"620821","name":"泾川县","cityCode":"6208","provinceCode":"62"},{"code":"620822","name":"灵台县","cityCode":"6208","provinceCode":"62"},{"code":"620823","name":"崇信县","cityCode":"6208","provinceCode":"62"},{"code":"620825","name":"庄浪县","cityCode":"6208","provinceCode":"62"},{"code":"620826","name":"静宁县","cityCode":"6208","provinceCode":"62"},{"code":"620881","name":"华亭市","cityCode":"6208","provinceCode":"62"},{"code":"620902","name":"肃州区","cityCode":"6209","provinceCode":"62"},{"code":"620921","name":"金塔县","cityCode":"6209","provinceCode":"62"},{"code":"620922","name":"瓜州县","cityCode":"6209","provinceCode":"62"},{"code":"620923","name":"肃北蒙古族自治县","cityCode":"6209","provinceCode":"62"},{"code":"620924","name":"阿克塞哈萨克族自治县","cityCode":"6209","provinceCode":"62"},{"code":"620981","name":"玉门市","cityCode":"6209","provinceCode":"62"},{"code":"620982","name":"敦煌市","cityCode":"6209","provinceCode":"62"},{"code":"621002","name":"西峰区","cityCode":"6210","provinceCode":"62"},{"code":"621021","name":"庆城县","cityCode":"6210","provinceCode":"62"},{"code":"621022","name":"环县","cityCode":"6210","provinceCode":"62"},{"code":"621023","name":"华池县","cityCode":"6210","provinceCode":"62"},{"code":"621024","name":"合水县","cityCode":"6210","provinceCode":"62"},{"code":"621025","name":"正宁县","cityCode":"6210","provinceCode":"62"},{"code":"621026","name":"宁县","cityCode":"6210","provinceCode":"62"},{"code":"621027","name":"镇原县","cityCode":"6210","provinceCode":"62"},{"code":"621102","name":"安定区","cityCode":"6211","provinceCode":"62"},{"code":"621121","name":"通渭县","cityCode":"6211","provinceCode":"62"},{"code":"621122","name":"陇西县","cityCode":"6211","provinceCode":"62"},{"code":"621123","name":"渭源县","cityCode":"6211","provinceCode":"62"},{"code":"621124","name":"临洮县","cityCode":"6211","provinceCode":"62"},{"code":"621125","name":"漳县","cityCode":"6211","provinceCode":"62"},{"code":"621126","name":"岷县","cityCode":"6211","provinceCode":"62"},{"code":"621202","name":"武都区","cityCode":"6212","provinceCode":"62"},{"code":"621221","name":"成县","cityCode":"6212","provinceCode":"62"},{"code":"621222","name":"文县","cityCode":"6212","provinceCode":"62"},{"code":"621223","name":"宕昌县","cityCode":"6212","provinceCode":"62"},{"code":"621224","name":"康县","cityCode":"6212","provinceCode":"62"},{"code":"621225","name":"西和县","cityCode":"6212","provinceCode":"62"},{"code":"621226","name":"礼县","cityCode":"6212","provinceCode":"62"},{"code":"621227","name":"徽县","cityCode":"6212","provinceCode":"62"},{"code":"621228","name":"两当县","cityCode":"6212","provinceCode":"62"},{"code":"622901","name":"临夏市","cityCode":"6229","provinceCode":"62"},{"code":"622921","name":"临夏县","cityCode":"6229","provinceCode":"62"},{"code":"622922","name":"康乐县","cityCode":"6229","provinceCode":"62"},{"code":"622923","name":"永靖县","cityCode":"6229","provinceCode":"62"},{"code":"622924","name":"广河县","cityCode":"6229","provinceCode":"62"},{"code":"622925","name":"和政县","cityCode":"6229","provinceCode":"62"},{"code":"622926","name":"东乡族自治县","cityCode":"6229","provinceCode":"62"},{"code":"622927","name":"积石山保安族东乡族撒拉族自治县","cityCode":"6229","provinceCode":"62"},{"code":"623001","name":"合作市","cityCode":"6230","provinceCode":"62"},{"code":"623021","name":"临潭县","cityCode":"6230","provinceCode":"62"},{"code":"623022","name":"卓尼县","cityCode":"6230","provinceCode":"62"},{"code":"623023","name":"舟曲县","cityCode":"6230","provinceCode":"62"},{"code":"623024","name":"迭部县","cityCode":"6230","provinceCode":"62"},{"code":"623025","name":"玛曲县","cityCode":"6230","provinceCode":"62"},{"code":"623026","name":"碌曲县","cityCode":"6230","provinceCode":"62"},{"code":"623027","name":"夏河县","cityCode":"6230","provinceCode":"62"},{"code":"630102","name":"城东区","cityCode":"6301","provinceCode":"63"},{"code":"630103","name":"城中区","cityCode":"6301","provinceCode":"63"},{"code":"630104","name":"城西区","cityCode":"6301","provinceCode":"63"},{"code":"630105","name":"城北区","cityCode":"6301","provinceCode":"63"},{"code":"630106","name":"湟中区","cityCode":"6301","provinceCode":"63"},{"code":"630121","name":"大通回族土族自治县","cityCode":"6301","provinceCode":"63"},{"code":"630123","name":"湟源县","cityCode":"6301","provinceCode":"63"},{"code":"630202","name":"乐都区","cityCode":"6302","provinceCode":"63"},{"code":"630203","name":"平安区","cityCode":"6302","provinceCode":"63"},{"code":"630222","name":"民和回族土族自治县","cityCode":"6302","provinceCode":"63"},{"code":"630223","name":"互助土族自治县","cityCode":"6302","provinceCode":"63"},{"code":"630224","name":"化隆回族自治县","cityCode":"6302","provinceCode":"63"},{"code":"630225","name":"循化撒拉族自治县","cityCode":"6302","provinceCode":"63"},{"code":"632221","name":"门源回族自治县","cityCode":"6322","provinceCode":"63"},{"code":"632222","name":"祁连县","cityCode":"6322","provinceCode":"63"},{"code":"632223","name":"海晏县","cityCode":"6322","provinceCode":"63"},{"code":"632224","name":"刚察县","cityCode":"6322","provinceCode":"63"},{"code":"632301","name":"同仁市","cityCode":"6323","provinceCode":"63"},{"code":"632322","name":"尖扎县","cityCode":"6323","provinceCode":"63"},{"code":"632323","name":"泽库县","cityCode":"6323","provinceCode":"63"},{"code":"632324","name":"河南蒙古族自治县","cityCode":"6323","provinceCode":"63"},{"code":"632521","name":"共和县","cityCode":"6325","provinceCode":"63"},{"code":"632522","name":"同德县","cityCode":"6325","provinceCode":"63"},{"code":"632523","name":"贵德县","cityCode":"6325","provinceCode":"63"},{"code":"632524","name":"兴海县","cityCode":"6325","provinceCode":"63"},{"code":"632525","name":"贵南县","cityCode":"6325","provinceCode":"63"},{"code":"632621","name":"玛沁县","cityCode":"6326","provinceCode":"63"},{"code":"632622","name":"班玛县","cityCode":"6326","provinceCode":"63"},{"code":"632623","name":"甘德县","cityCode":"6326","provinceCode":"63"},{"code":"632624","name":"达日县","cityCode":"6326","provinceCode":"63"},{"code":"632625","name":"久治县","cityCode":"6326","provinceCode":"63"},{"code":"632626","name":"玛多县","cityCode":"6326","provinceCode":"63"},{"code":"632701","name":"玉树市","cityCode":"6327","provinceCode":"63"},{"code":"632722","name":"杂多县","cityCode":"6327","provinceCode":"63"},{"code":"632723","name":"称多县","cityCode":"6327","provinceCode":"63"},{"code":"632724","name":"治多县","cityCode":"6327","provinceCode":"63"},{"code":"632725","name":"囊谦县","cityCode":"6327","provinceCode":"63"},{"code":"632726","name":"曲麻莱县","cityCode":"6327","provinceCode":"63"},{"code":"632801","name":"格尔木市","cityCode":"6328","provinceCode":"63"},{"code":"632802","name":"德令哈市","cityCode":"6328","provinceCode":"63"},{"code":"632803","name":"茫崖市","cityCode":"6328","provinceCode":"63"},{"code":"632821","name":"乌兰县","cityCode":"6328","provinceCode":"63"},{"code":"632822","name":"都兰县","cityCode":"6328","provinceCode":"63"},{"code":"632823","name":"天峻县","cityCode":"6328","provinceCode":"63"},{"code":"632857","name":"大柴旦行政委员会","cityCode":"6328","provinceCode":"63"},{"code":"640104","name":"兴庆区","cityCode":"6401","provinceCode":"64"},{"code":"640105","name":"西夏区","cityCode":"6401","provinceCode":"64"},{"code":"640106","name":"金凤区","cityCode":"6401","provinceCode":"64"},{"code":"640121","name":"永宁县","cityCode":"6401","provinceCode":"64"},{"code":"640122","name":"贺兰县","cityCode":"6401","provinceCode":"64"},{"code":"640181","name":"灵武市","cityCode":"6401","provinceCode":"64"},{"code":"640202","name":"大武口区","cityCode":"6402","provinceCode":"64"},{"code":"640205","name":"惠农区","cityCode":"6402","provinceCode":"64"},{"code":"640221","name":"平罗县","cityCode":"6402","provinceCode":"64"},{"code":"640302","name":"利通区","cityCode":"6403","provinceCode":"64"},{"code":"640303","name":"红寺堡区","cityCode":"6403","provinceCode":"64"},{"code":"640323","name":"盐池县","cityCode":"6403","provinceCode":"64"},{"code":"640324","name":"同心县","cityCode":"6403","provinceCode":"64"},{"code":"640381","name":"青铜峡市","cityCode":"6403","provinceCode":"64"},{"code":"640402","name":"原州区","cityCode":"6404","provinceCode":"64"},{"code":"640422","name":"西吉县","cityCode":"6404","provinceCode":"64"},{"code":"640423","name":"隆德县","cityCode":"6404","provinceCode":"64"},{"code":"640424","name":"泾源县","cityCode":"6404","provinceCode":"64"},{"code":"640425","name":"彭阳县","cityCode":"6404","provinceCode":"64"},{"code":"640502","name":"沙坡头区","cityCode":"6405","provinceCode":"64"},{"code":"640521","name":"中宁县","cityCode":"6405","provinceCode":"64"},{"code":"640522","name":"海原县","cityCode":"6405","provinceCode":"64"},{"code":"650102","name":"天山区","cityCode":"6501","provinceCode":"65"},{"code":"650103","name":"沙依巴克区","cityCode":"6501","provinceCode":"65"},{"code":"650104","name":"新市区","cityCode":"6501","provinceCode":"65"},{"code":"650105","name":"水磨沟区","cityCode":"6501","provinceCode":"65"},{"code":"650106","name":"头屯河区","cityCode":"6501","provinceCode":"65"},{"code":"650107","name":"达坂城区","cityCode":"6501","provinceCode":"65"},{"code":"650109","name":"米东区","cityCode":"6501","provinceCode":"65"},{"code":"650121","name":"乌鲁木齐县","cityCode":"6501","provinceCode":"65"},{"code":"650202","name":"独山子区","cityCode":"6502","provinceCode":"65"},{"code":"650203","name":"克拉玛依区","cityCode":"6502","provinceCode":"65"},{"code":"650204","name":"白碱滩区","cityCode":"6502","provinceCode":"65"},{"code":"650205","name":"乌尔禾区","cityCode":"6502","provinceCode":"65"},{"code":"650402","name":"高昌区","cityCode":"6504","provinceCode":"65"},{"code":"650421","name":"鄯善县","cityCode":"6504","provinceCode":"65"},{"code":"650422","name":"托克逊县","cityCode":"6504","provinceCode":"65"},{"code":"650502","name":"伊州区","cityCode":"6505","provinceCode":"65"},{"code":"650521","name":"巴里坤哈萨克自治县","cityCode":"6505","provinceCode":"65"},{"code":"650522","name":"伊吾县","cityCode":"6505","provinceCode":"65"},{"code":"652301","name":"昌吉市","cityCode":"6523","provinceCode":"65"},{"code":"652302","name":"阜康市","cityCode":"6523","provinceCode":"65"},{"code":"652323","name":"呼图壁县","cityCode":"6523","provinceCode":"65"},{"code":"652324","name":"玛纳斯县","cityCode":"6523","provinceCode":"65"},{"code":"652325","name":"奇台县","cityCode":"6523","provinceCode":"65"},{"code":"652327","name":"吉木萨尔县","cityCode":"6523","provinceCode":"65"},{"code":"652328","name":"木垒哈萨克自治县","cityCode":"6523","provinceCode":"65"},{"code":"652701","name":"博乐市","cityCode":"6527","provinceCode":"65"},{"code":"652702","name":"阿拉山口市","cityCode":"6527","provinceCode":"65"},{"code":"652722","name":"精河县","cityCode":"6527","provinceCode":"65"},{"code":"652723","name":"温泉县","cityCode":"6527","provinceCode":"65"},{"code":"652801","name":"库尔勒市","cityCode":"6528","provinceCode":"65"},{"code":"652822","name":"轮台县","cityCode":"6528","provinceCode":"65"},{"code":"652823","name":"尉犁县","cityCode":"6528","provinceCode":"65"},{"code":"652824","name":"若羌县","cityCode":"6528","provinceCode":"65"},{"code":"652825","name":"且末县","cityCode":"6528","provinceCode":"65"},{"code":"652826","name":"焉耆回族自治县","cityCode":"6528","provinceCode":"65"},{"code":"652827","name":"和静县","cityCode":"6528","provinceCode":"65"},{"code":"652828","name":"和硕县","cityCode":"6528","provinceCode":"65"},{"code":"652829","name":"博湖县","cityCode":"6528","provinceCode":"65"},{"code":"652901","name":"阿克苏市","cityCode":"6529","provinceCode":"65"},{"code":"652902","name":"库车市","cityCode":"6529","provinceCode":"65"},{"code":"652922","name":"温宿县","cityCode":"6529","provinceCode":"65"},{"code":"652924","name":"沙雅县","cityCode":"6529","provinceCode":"65"},{"code":"652925","name":"新和县","cityCode":"6529","provinceCode":"65"},{"code":"652926","name":"拜城县","cityCode":"6529","provinceCode":"65"},{"code":"652927","name":"乌什县","cityCode":"6529","provinceCode":"65"},{"code":"652928","name":"阿瓦提县","cityCode":"6529","provinceCode":"65"},{"code":"652929","name":"柯坪县","cityCode":"6529","provinceCode":"65"},{"code":"653001","name":"阿图什市","cityCode":"6530","provinceCode":"65"},{"code":"653022","name":"阿克陶县","cityCode":"6530","provinceCode":"65"},{"code":"653023","name":"阿合奇县","cityCode":"6530","provinceCode":"65"},{"code":"653024","name":"乌恰县","cityCode":"6530","provinceCode":"65"},{"code":"653101","name":"喀什市","cityCode":"6531","provinceCode":"65"},{"code":"653121","name":"疏附县","cityCode":"6531","provinceCode":"65"},{"code":"653122","name":"疏勒县","cityCode":"6531","provinceCode":"65"},{"code":"653123","name":"英吉沙县","cityCode":"6531","provinceCode":"65"},{"code":"653124","name":"泽普县","cityCode":"6531","provinceCode":"65"},{"code":"653125","name":"莎车县","cityCode":"6531","provinceCode":"65"},{"code":"653126","name":"叶城县","cityCode":"6531","provinceCode":"65"},{"code":"653127","name":"麦盖提县","cityCode":"6531","provinceCode":"65"},{"code":"653128","name":"岳普湖县","cityCode":"6531","provinceCode":"65"},{"code":"653129","name":"伽师县","cityCode":"6531","provinceCode":"65"},{"code":"653130","name":"巴楚县","cityCode":"6531","provinceCode":"65"},{"code":"653131","name":"塔什库尔干塔吉克自治县","cityCode":"6531","provinceCode":"65"},{"code":"653201","name":"和田市","cityCode":"6532","provinceCode":"65"},{"code":"653221","name":"和田县","cityCode":"6532","provinceCode":"65"},{"code":"653222","name":"墨玉县","cityCode":"6532","provinceCode":"65"},{"code":"653223","name":"皮山县","cityCode":"6532","provinceCode":"65"},{"code":"653224","name":"洛浦县","cityCode":"6532","provinceCode":"65"},{"code":"653225","name":"策勒县","cityCode":"6532","provinceCode":"65"},{"code":"653226","name":"于田县","cityCode":"6532","provinceCode":"65"},{"code":"653227","name":"民丰县","cityCode":"6532","provinceCode":"65"},{"code":"654002","name":"伊宁市","cityCode":"6540","provinceCode":"65"},{"code":"654003","name":"奎屯市","cityCode":"6540","provinceCode":"65"},{"code":"654004","name":"霍尔果斯市","cityCode":"6540","provinceCode":"65"},{"code":"654021","name":"伊宁县","cityCode":"6540","provinceCode":"65"},{"code":"654022","name":"察布查尔锡伯自治县","cityCode":"6540","provinceCode":"65"},{"code":"654023","name":"霍城县","cityCode":"6540","provinceCode":"65"},{"code":"654024","name":"巩留县","cityCode":"6540","provinceCode":"65"},{"code":"654025","name":"新源县","cityCode":"6540","provinceCode":"65"},{"code":"654026","name":"昭苏县","cityCode":"6540","provinceCode":"65"},{"code":"654027","name":"特克斯县","cityCode":"6540","provinceCode":"65"},{"code":"654028","name":"尼勒克县","cityCode":"6540","provinceCode":"65"},{"code":"654201","name":"塔城市","cityCode":"6542","provinceCode":"65"},{"code":"654202","name":"乌苏市","cityCode":"6542","provinceCode":"65"},{"code":"654203","name":"沙湾市","cityCode":"6542","provinceCode":"65"},{"code":"654221","name":"额敏县","cityCode":"6542","provinceCode":"65"},{"code":"654224","name":"托里县","cityCode":"6542","provinceCode":"65"},{"code":"654225","name":"裕民县","cityCode":"6542","provinceCode":"65"},{"code":"654226","name":"和布克赛尔蒙古自治县","cityCode":"6542","provinceCode":"65"},{"code":"654301","name":"阿勒泰市","cityCode":"6543","provinceCode":"65"},{"code":"654321","name":"布尔津县","cityCode":"6543","provinceCode":"65"},{"code":"654322","name":"富蕴县","cityCode":"6543","provinceCode":"65"},{"code":"654323","name":"福海县","cityCode":"6543","provinceCode":"65"},{"code":"654324","name":"哈巴河县","cityCode":"6543","provinceCode":"65"},{"code":"654325","name":"青河县","cityCode":"6543","provinceCode":"65"},{"code":"654326","name":"吉木乃县","cityCode":"6543","provinceCode":"65"},{"code":"659001","name":"石河子市","cityCode":"6590","provinceCode":"65"},{"code":"659002","name":"阿拉尔市","cityCode":"6590","provinceCode":"65"},{"code":"659003","name":"图木舒克市","cityCode":"6590","provinceCode":"65"},{"code":"659004","name":"五家渠市","cityCode":"6590","provinceCode":"65"},{"code":"659005","name":"北屯市","cityCode":"6590","provinceCode":"65"},{"code":"659006","name":"铁门关市","cityCode":"6590","provinceCode":"65"},{"code":"659007","name":"双河市","cityCode":"6590","provinceCode":"65"},{"code":"659008","name":"可克达拉市","cityCode":"6590","provinceCode":"65"},{"code":"659009","name":"昆玉市","cityCode":"6590","provinceCode":"65"},{"code":"659010","name":"胡杨河市","cityCode":"6590","provinceCode":"65"},{"code":"659011","name":"新星市","cityCode":"6590","provinceCode":"65"},{"code":"659012","name":"白杨市","cityCode":"6590","provinceCode":"65"}]

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

module.exports = [{"code":"110100","name":"北京市"},{"code":"120100","name":"天津市"},{"code":"130100","name":"石家庄市"},{"code":"130200","name":"唐山市"},{"code":"130300","name":"秦皇岛市"},{"code":"130400","name":"邯郸市"},{"code":"130500","name":"邢台市"},{"code":"130600","name":"保定市"},{"code":"130700","name":"张家口市"},{"code":"130800","name":"承德市"},{"code":"130900","name":"沧州市"},{"code":"131000","name":"廊坊市"},{"code":"131100","name":"衡水市"},{"code":"140100","name":"太原市"},{"code":"140200","name":"大同市"},{"code":"140300","name":"阳泉市"},{"code":"140400","name":"长治市"},{"code":"140500","name":"晋城市"},{"code":"140600","name":"朔州市"},{"code":"140700","name":"晋中市"},{"code":"140800","name":"运城市"},{"code":"140900","name":"忻州市"},{"code":"141000","name":"临汾市"},{"code":"141100","name":"吕梁市"},{"code":"150100","name":"呼和浩特市"},{"code":"150200","name":"包头市"},{"code":"150300","name":"乌海市"},{"code":"150400","name":"赤峰市"},{"code":"150500","name":"通辽市"},{"code":"150600","name":"鄂尔多斯市"},{"code":"150700","name":"呼伦贝尔市"},{"code":"150800","name":"巴彦淖尔市"},{"code":"150900","name":"乌兰察布市"},{"code":"152200","name":"兴安盟"},{"code":"152500","name":"锡林郭勒盟"},{"code":"152900","name":"阿拉善盟"},{"code":"210100","name":"沈阳市"},{"code":"210200","name":"大连市"},{"code":"210300","name":"鞍山市"},{"code":"210400","name":"抚顺市"},{"code":"210500","name":"本溪市"},{"code":"210600","name":"丹东市"},{"code":"210700","name":"锦州市"},{"code":"210800","name":"营口市"},{"code":"210900","name":"阜新市"},{"code":"211000","name":"辽阳市"},{"code":"211100","name":"盘锦市"},{"code":"211200","name":"铁岭市"},{"code":"211300","name":"朝阳市"},{"code":"211400","name":"葫芦岛市"},{"code":"220100","name":"长春市"},{"code":"220200","name":"吉林市"},{"code":"220300","name":"四平市"},{"code":"220400","name":"辽源市"},{"code":"220500","name":"通化市"},{"code":"220600","name":"白山市"},{"code":"220700","name":"松原市"},{"code":"220800","name":"白城市"},{"code":"222400","name":"延边朝鲜族自治州"},{"code":"230100","name":"哈尔滨市"},{"code":"230200","name":"齐齐哈尔市"},{"code":"230300","name":"鸡西市"},{"code":"230400","name":"鹤岗市"},{"code":"230500","name":"双鸭山市"},{"code":"230600","name":"大庆市"},{"code":"230700","name":"伊春市"},{"code":"230800","name":"佳木斯市"},{"code":"230900","name":"七台河市"},{"code":"231000","name":"牡丹江市"},{"code":"231100","name":"黑河市"},{"code":"231200","name":"绥化市"},{"code":"232700","name":"大兴安岭地区"},{"code":"310100","name":"上海市"},{"code":"320100","name":"南京市"},{"code":"320200","name":"无锡市"},{"code":"320300","name":"徐州市"},{"code":"320400","name":"常州市"},{"code":"320500","name":"苏州市"},{"code":"320600","name":"南通市"},{"code":"320700","name":"连云港市"},{"code":"320800","name":"淮安市"},{"code":"320900","name":"盐城市"},{"code":"321000","name":"扬州市"},{"code":"321100","name":"镇江市"},{"code":"321200","name":"泰州市"},{"code":"321300","name":"宿迁市"},{"code":"330100","name":"杭州市"},{"code":"330200","name":"宁波市"},{"code":"330300","name":"温州市"},{"code":"330400","name":"嘉兴市"},{"code":"330500","name":"湖州市"},{"code":"330600","name":"绍兴市"},{"code":"330700","name":"金华市"},{"code":"330800","name":"衢州市"},{"code":"330900","name":"舟山市"},{"code":"331000","name":"台州市"},{"code":"331100","name":"丽水市"},{"code":"340100","name":"合肥市"},{"code":"340200","name":"芜湖市"},{"code":"340300","name":"蚌埠市"},{"code":"340400","name":"淮南市"},{"code":"340500","name":"马鞍山市"},{"code":"340600","name":"淮北市"},{"code":"340700","name":"铜陵市"},{"code":"340800","name":"安庆市"},{"code":"340900","name":"黄山市"},{"code":"341000","name":"滁州市"},{"code":"341100","name":"阜阳市"},{"code":"341200","name":"宿州市"},{"code":"341300","name":"六安市"},{"code":"341400","name":"亳州市"},{"code":"341500","name":"池州市"},{"code":"341600","name":"宣城市"},{"code":"350100","name":"福州市"},{"code":"350200","name":"厦门市"},{"code":"350300","name":"莆田市"},{"code":"350400","name":"三明市"},{"code":"350500","name":"泉州市"},{"code":"350600","name":"漳州市"},{"code":"350700","name":"南平市"},{"code":"350800","name":"龙岩市"},{"code":"350900","name":"宁德市"},{"code":"360100","name":"南昌市"},{"code":"360200","name":"景德镇市"},{"code":"360300","name":"萍乡市"},{"code":"360400","name":"九江市"},{"code":"360500","name":"新余市"},{"code":"360600","name":"鹰潭市"},{"code":"360700","name":"赣州市"},{"code":"360800","name":"吉安市"},{"code":"360900","name":"宜春市"},{"code":"361000","name":"抚州市"},{"code":"361100","name":"上饶市"},{"code":"370100","name":"济南市"},{"code":"370200","name":"青岛市"},{"code":"370300","name":"淄博市"},{"code":"370400","name":"枣庄市"},{"code":"370500","name":"东营市"},{"code":"370600","name":"烟台市"},{"code":"370700","name":"潍坊市"},{"code":"370800","name":"济宁市"},{"code":"370900","name":"泰安市"},{"code":"371000","name":"威海市"},{"code":"371100","name":"日照市"},{"code":"371300","name":"临沂市"},{"code":"371400","name":"德州市"},{"code":"371500","name":"聊城市"},{"code":"371600","name":"滨州市"},{"code":"371700","name":"菏泽市"},{"code":"410100","name":"郑州市"},{"code":"410200","name":"开封市"},{"code":"410300","name":"洛阳市"},{"code":"410400","name":"平顶山市"},{"code":"410500","name":"安阳市"},{"code":"410600","name":"鹤壁市"},{"code":"410700","name":"新乡市"},{"code":"410800","name":"焦作市"},{"code":"410900","name":"濮阳市"},{"code":"411000","name":"许昌市"},{"code":"411100","name":"漯河市"},{"code":"411200","name":"三门峡市"},{"code":"411300","name":"南阳市"},{"code":"411400","name":"商丘市"},{"code":"411500","name":"信阳市"},{"code":"411600","name":"周口市"},{"code":"411700","name":"驻马店市"},{"code":"419000","name":"省直辖县级行政区划"},{"code":"420100","name":"武汉市"},{"code":"420200","name":"黄石市"},{"code":"420300","name":"十堰市"},{"code":"420400","name":"宜昌市"},{"code":"420500","name":"襄阳市"},{"code":"420600","name":"鄂州市"},{"code":"420700","name":"荆门市"},{"code":"420800","name":"孝感市"},{"code":"420900","name":"荆州市"},{"code":"421000","name":"黄冈市"},{"code":"421100","name":"咸宁市"},{"code":"421200","name":"随州市"},{"code":"422800","name":"恩施土家族苗族自治州"},{"code":"429000","name":"省直辖县级行政区划"},{"code":"430100","name":"长沙市"},{"code":"430200","name":"株洲市"},{"code":"430300","name":"湘潭市"},{"code":"430400","name":"衡阳市"},{"code":"430500","name":"邵阳市"},{"code":"430600","name":"岳阳市"},{"code":"430700","name":"常德市"},{"code":"430800","name":"张家界市"},{"code":"430900","name":"益阳市"},{"code":"431000","name":"郴州市"},{"code":"431100","name":"永州市"},{"code":"431200","name":"怀化市"},{"code":"431300","name":"娄底市"},{"code":"433100","name":"湘西土家族苗族自治州"},{"code":"440100","name":"广州市"},{"code":"440200","name":"韶关市"},{"code":"440300","name":"深圳市"},{"code":"440400","name":"珠海市"},{"code":"440500","name":"汕头市"},{"code":"440600","name":"佛山市"},{"code":"440700","name":"江门市"},{"code":"440800","name":"湛江市"},{"code":"440900","name":"茂名市"},{"code":"441000","name":"肇庆市"},{"code":"441100","name":"惠州市"},{"code":"441200","name":"梅州市"},{"code":"441300","name":"汕尾市"},{"code":"441400","name":"河源市"},{"code":"441500","name":"阳江市"},{"code":"441600","name":"清远市"},{"code":"441700","name":"东莞市"},{"code":"441800","name":"中山市"},{"code":"441900","name":"潮州市"},{"code":"442000","name":"揭阳市"},{"code":"442100","name":"云浮市"},{"code":"450100","name":"南宁市"},{"code":"450200","name":"柳州市"},{"code":"450300","name":"桂林市"},{"code":"450400","name":"梧州市"},{"code":"450500","name":"北海市"},{"code":"450600","name":"防城港市"},{"code":"450700","name":"钦州市"},{"code":"450800","name":"贵港市"},{"code":"450900","name":"玉林市"},{"code":"451000","name":"百色市"},{"code":"451100","name":"贺州市"},{"code":"451200","name":"河池市"},{"code":"451300","name":"来宾市"},{"code":"451400","name":"崇左市"},{"code":"460100","name":"海口市"},{"code":"460200","name":"三亚市"},{"code":"460300","name":"三沙市"},{"code":"460400","name":"儋州市"},{"code":"469000","name":"省直辖县级行政区划"},{"code":"500100","name":"重庆市"},{"code":"510100","name":"成都市"},{"code":"510200","name":"自贡市"},{"code":"510300","name":"攀枝花市"},{"code":"510400","name":"泸州市"},{"code":"510500","name":"德阳市"},{"code":"510600","name":"绵阳市"},{"code":"510700","name":"广元市"},{"code":"510800","name":"遂宁市"},{"code":"510900","name":"内江市"},{"code":"511000","name":"乐山市"},{"code":"511100","name":"南充市"},{"code":"511200","name":"眉山市"},{"code":"511300","name":"宜宾市"},{"code":"511400","name":"广安市"},{"code":"511500","name":"达州市"},{"code":"511600","name":"雅安市"},{"code":"511700","name":"巴中市"},{"code":"511800","name":"资阳市"},{"code":"511900","name":"阿坝藏族羌族自治州"},{"code":"512000","name":"甘孜藏族自治州"},{"code":"512100","name":"凉山彝族自治州"},{"code":"520100","name":"贵阳市"},{"code":"520200","name":"六盘水市"},{"code":"520300","name":"遵义市"},{"code":"520400","name":"安顺市"},{"code":"520500","name":"毕节市"},{"code":"520600","name":"铜仁市"},{"code":"522300","name":"黔西南布依族苗族自治州"},{"code":"522600","name":"黔东南苗族侗族自治州"},{"code":"522700","name":"黔南布依族苗族自治州"},{"code":"530100","name":"昆明市"},{"code":"530200","name":"曲靖市"},{"code":"530300","name":"玉溪市"},{"code":"530400","name":"保山市"},{"code":"530500","name":"昭通市"},{"code":"530600","name":"丽江市"},{"code":"530700","name":"普洱市"},{"code":"530800","name":"临沧市"},{"code":"532300","name":"楚雄彝族自治州"},{"code":"532500","name":"红河哈尼族彝族自治州"},{"code":"532600","name":"文山壮族苗族自治州"},{"code":"532800","name":"西双版纳傣族自治州"},{"code":"532900","name":"大理白族自治州"},{"code":"533100","name":"德宏傣族景颇族自治州"},{"code":"533300","name":"怒江傈僳族自治州"},{"code":"533400","name":"迪庆藏族自治州"},{"code":"540100","name":"拉萨市"},{"code":"540200","name":"日喀则市"},{"code":"540300","name":"昌都市"},{"code":"540400","name":"林芝市"},{"code":"540500","name":"山南市"},{"code":"540600","name":"那曲市"},{"code":"542500","name":"阿里地区"},{"code":"610100","name":"西安市"},{"code":"610200","name":"铜川市"},{"code":"610300","name":"宝鸡市"},{"code":"610400","name":"咸阳市"},{"code":"610500","name":"渭南市"},{"code":"610600","name":"延安市"},{"code":"610700","name":"汉中市"},{"code":"610800","name":"榆林市"},{"code":"610900","name":"安康市"},{"code":"611000","name":"商洛市"},{"code":"620100","name":"兰州市"},{"code":"620200","name":"嘉峪关市"},{"code":"620300","name":"金昌市"},{"code":"620400","name":"白银市"},{"code":"620500","name":"天水市"},{"code":"620600","name":"武威市"},{"code":"620700","name":"张掖市"},{"code":"620800","name":"平凉市"},{"code":"620900","name":"酒泉市"},{"code":"621000","name":"庆阳市"},{"code":"621100","name":"定西市"},{"code":"621200","name":"陇南市"},{"code":"622900","name":"临夏回族自治州"},{"code":"623000","name":"甘南藏族自治州"},{"code":"630100","name":"西宁市"},{"code":"630200","name":"海东市"},{"code":"632200","name":"海北藏族自治州"},{"code":"632300","name":"黄南藏族自治州"},{"code":"632500","name":"海南藏族自治州"},{"code":"632600","name":"果洛藏族自治州"},{"code":"632700","name":"玉树藏族自治州"},{"code":"632800","name":"海西蒙古族藏族自治州"},{"code":"640100","name":"银川市"},{"code":"640200","name":"石嘴山市"},{"code":"640300","name":"吴忠市"},{"code":"640400","name":"固原市"},{"code":"640500","name":"中卫市"},{"code":"650100","name":"乌鲁木齐市"},{"code":"650200","name":"克拉玛依市"},{"code":"650400","name":"吐鲁番市"},{"code":"650500","name":"哈密市"},{"code":"652300","name":"昌吉回族自治州"},{"code":"652700","name":"博尔塔拉蒙古自治州"},{"code":"652800","name":"巴音郭楞蒙古自治州"},{"code":"652900","name":"阿克苏地区"},{"code":"653000","name":"克孜勒苏柯尔克孜自治州"},{"code":"653100","name":"喀什地区"},{"code":"653200","name":"和田地区"},{"code":"654000","name":"伊犁哈萨克自治州"},{"code":"654200","name":"塔城地区"},{"code":"654300","name":"阿勒泰地区"},{"code":"659000","name":"自治区直辖县级行政区划"}]

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

module.exports = [{"code":"110000","name":"北京市"},{"code":"120000","name":"天津市"},{"code":"130000","name":"河北省"},{"code":"140000","name":"山西省"},{"code":"150000","name":"内蒙古自治区"},{"code":"210000","name":"辽宁省"},{"code":"220000","name":"吉林省"},{"code":"230000","name":"黑龙江省"},{"code":"310000","name":"上海市"},{"code":"320000","name":"江苏省"},{"code":"330000","name":"浙江省"},{"code":"340000","name":"安徽省"},{"code":"350000","name":"福建省"},{"code":"360000","name":"江西省"},{"code":"370000","name":"山东省"},{"code":"410000","name":"河南省"},{"code":"420000","name":"湖北省"},{"code":"430000","name":"湖南省"},{"code":"440000","name":"广东省"},{"code":"450000","name":"广西壮族自治区"},{"code":"460000","name":"海南省"},{"code":"500000","name":"重庆市"},{"code":"510000","name":"四川省"},{"code":"520000","name":"贵州省"},{"code":"530000","name":"云南省"},{"code":"540000","name":"西藏自治区"},{"code":"610000","name":"陕西省"},{"code":"620000","name":"甘肃省"},{"code":"630000","name":"青海省"},{"code":"640000","name":"宁夏回族自治区"},{"code":"650000","name":"新疆维吾尔自治区"},{"code":"710000","name":"台湾省"},{"code":"810000","name":"香港特别行政区"},{"code":"820000","name":"澳门特别行政区"}]

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[958]);


// WEBPACK FOOTER //
// static/js/app.65f428bac124718272d9.js